export const clipPositions = [
  [
    [118.532776901352, 24.8246289321137, 0.000928545370697975],
    [118.532334811002, 24.8252279336024, 0.000928619876503944],
  ],
  [
    [118.532760495736, 24.824618841184, 0.000928543508052826],
    [118.532318405355, 24.8252178516529, 0.00092861894518137],
  ],
  [
    [118.532744080244, 24.8246087592922, 0.000928541645407677],
    [118.532301999698, 24.8252077606739, 0.000928617082536221],
  ],
  [
    [118.532727674634, 24.8245986683588, 0.000928539782762527],
    [118.532285584165, 24.8251976787328, 0.000928616151213646],
  ],
  [
    [118.532711269039, 24.8245885864513, 0.000928538851439953],
    [118.532269178513, 24.8251875877501, 0.000928615219891071],
  ],
  [
    [118.532694853542, 24.8245784955263, 0.000928537920117378],
    [118.532252772877, 24.8251775057933, 0.000928615219891071],
  ],
  [
    [118.532678447952, 24.8245684136151, 0.000928536988794804],
    [118.532236357339, 24.825167414819, 0.000928612425923347],
  ],
  [
    [118.532662042352, 24.8245583226744, 0.000928536057472229],
    [118.532219951709, 24.8251573328585, 0.000928612425923347],
  ],
  [
    [118.532645636768, 24.8245482407596, 0.00092853419482708],
    [118.532203546067, 24.8251472418686, 0.000928609631955624],
  ],
  [
    [118.532629221281, 24.8245381498273, 0.000928532332181931],
    [118.532187130537, 24.8251371508888, 0.000928607769310474],
  ],
  [
    [118.532612815703, 24.8245280679088, 0.000928532332181931],
    [118.532170724914, 24.8251270689229, 0.000928607769310474],
  ],
  [
    [118.532596410113, 24.8245179769608, 0.000928529538214207],
    [118.532154319281, 24.8251169779274, 0.000928605906665325],
  ],
  [
    [118.532579994648, 24.8245078950507, 0.000928530469536781],
    [118.532137913664, 24.8251068959578, 0.000928604975342751],
  ],
  [
    [118.532563589064, 24.824497804099, 0.000928528606891632],
    [118.532121498144, 24.8250968049707, 0.000928604044020176],
  ],
  [
    [118.532547183495, 24.8244877221732, 0.000928526744246483],
    [118.532105092532, 24.8250867229974, 0.000928602181375027],
  ],
  [
    [118.532530768025, 24.8244776312299, 0.000928525812923908],
    [118.532088686909, 24.8250766319947, 0.000928601250052452],
  ],
  [
    [118.532514362448, 24.8244675402728, 0.000928523950278759],
    [118.532072271411, 24.8250665500298, 0.000928597524762154],
  ],
  [
    [118.532497956888, 24.8244574583414, 0.000928523950278759],
    [118.532055865793, 24.8250564590233, 0.000928597524762154],
  ],
  [
    [118.532481541425, 24.8244473673927, 0.00092852208763361],
    [118.532039460192, 24.8250463770427, 0.000928596593439579],
  ],
  [
    [118.53246513587, 24.8244372854577, 0.000928521156311035],
    [118.532023044688, 24.8250362860447, 0.000928596593439579],
  ],
  [
    [118.532448730305, 24.8244271944932, 0.000928519293665886],
    [118.532006639092, 24.8250262040604, 0.000928592868149281],
  ],
  [
    [118.532432324755, 24.8244171125546, 0.000928517431020737],
    [118.531990233485, 24.8250161130467, 0.000928593799471855],
  ],
  [
    [118.532415909303, 24.8244070215986, 0.000928516499698162],
    [118.531973818003, 24.8250060310708, 0.000928592868149281],
  ],
  [
    [118.532399503759, 24.8243969396562, 0.000928515568375587],
    [118.531957412401, 24.8249959400534, 0.000928590074181557],
  ],
  [
    [118.532383098204, 24.8243868486845, 0.000928512774407864],
    [118.531941006816, 24.8249858580618, 0.000928590074181557],
  ],
  [
    [118.532366682773, 24.8243767667506, 0.000928512774407864],
    [118.531924591328, 24.8249757670528, 0.000928589142858982],
  ],
  [
    [118.532350277223, 24.8243666757751, 0.000928511843085289],
    [118.531908185747, 24.8249656850576, 0.000928587280213833],
  ],
  [
    [118.532333871689, 24.8243565938255, 0.000928509049117565],
    [118.531891780157, 24.8249555940328, 0.000928587280213833],
  ],
  [
    [118.532317456253, 24.8243465028585, 0.000928509049117565],
    [118.531875374582, 24.8249455120339, 0.000928584486246109],
  ],
  [
    [118.532301050724, 24.8243364209052, 0.000928508117794991],
    [118.531858959104, 24.8249354210176, 0.000928583554923534],
  ],
  [
    [118.532284645185, 24.8243263299224, 0.000928506255149841],
    [118.531842553535, 24.824925339015, 0.000928581692278385],
  ],
  [
    [118.53226822977, 24.8243162479776, 0.000928504392504692],
    [118.531826147955, 24.824915247983, 0.000928581692278385],
  ],
  [
    [118.532251824237, 24.8243061569911, 0.000928503461182117],
    [118.531809732498, 24.8249051659888, 0.000928579829633236],
  ],
  [
    [118.532235418719, 24.8242960750306, 0.000928502529859543],
    [118.531793326923, 24.8248950749531, 0.000928577966988087],
  ],
  [
    [118.532219003298, 24.8242859840525, 0.000928500667214394],
    [118.531776921351, 24.8248849839156, 0.000928577035665512],
  ],
  [
    [118.532202597786, 24.8242759020883, 0.000928498804569244],
    [118.531760505903, 24.8248749019159, 0.000928576104342937],
  ],
  [
    [118.532186192263, 24.8242658110946, 0.00092849787324667],
    [118.531744100336, 24.8248648108748, 0.000928574241697788],
  ],
  [
    [118.532169786755, 24.8242557291266, 0.000928496941924095],
    [118.531727694785, 24.8248547288594, 0.000928573310375214],
  ],
  [
    [118.532153371346, 24.8242456381413, 0.000928495079278946],
    [118.531711279332, 24.8248446378266, 0.000928572379052639],
  ],
  [
    [118.53213696583, 24.8242355471421, 0.000928495079278946],
    [118.531694873786, 24.8248345558076, 0.00092857051640749],
  ],
  [
    [118.532120560331, 24.8242254651687, 0.000928493216633797],
    [118.531678468229, 24.8248244647591, 0.00092857051640749],
  ],
  [
    [118.532104144929, 24.8242153741779, 0.000928492285311222],
    [118.531662062689, 24.8248143827364, 0.000928565859794617],
  ],
  [
    [118.532087739435, 24.8242052922008, 0.000928492285311222],
    [118.531645647246, 24.8248042916963, 0.000928566791117191],
  ],
  [
    [118.532071333931, 24.8241952011943, 0.000928490422666073],
    [118.531629241711, 24.8247942096699, 0.000928566791117191],
  ],
  [
    [118.53205491855, 24.8241851192256, 0.000928488560020924],
    [118.531612836165, 24.8247841186141, 0.000928564928472042],
  ],
  [
    [118.532038513051, 24.8241750282154, 0.000928487628698349],
    [118.531596420743, 24.8247740365961, 0.000928563997149467],
  ],
  [
    [118.532022107567, 24.8241649462311, 0.0009284857660532],
    [118.531580015203, 24.8247639455367, 0.000928562134504318],
  ],
  [
    [118.532005692182, 24.8241548552292, 0.000928484834730625],
    [118.531563609678, 24.824753863503, 0.000928560271859169],
  ],
  [
    [118.531989286703, 24.8241447732412, 0.000928483903408051],
    [118.531547194251, 24.8247437724519, 0.00092855840921402],
  ],
  [
    [118.531972881215, 24.8241346822237, 0.000928481109440327],
    [118.531530788732, 24.8247336904146, 0.000928557477891445],
  ],
  [
    [118.531956475742, 24.824124600232, 0.000928481109440327],
    [118.531514383202, 24.8247235993478, 0.000928557477891445],
  ],
  [
    [118.531940060367, 24.8241145092229, 0.000928479246795177],
    [118.531497967797, 24.8247135173189, 0.000928556546568871],
  ],
  [
    [118.531923654899, 24.8241044272276, 0.000928478315472603],
    [118.531481562272, 24.8247034262484, 0.000928554683923721],
  ],
  [
    [118.531907249421, 24.8240943362027, 0.000928475521504879],
    [118.531465156763, 24.8246933442038, 0.000928552821278572],
  ],
  [
    [118.531890834067, 24.8240842542158, 0.000928474590182304],
    [118.531448751244, 24.8246832531297, 0.000928551889955997],
  ],
  [
    [118.531874428594, 24.8240741631873, 0.000928474590182304],
    [118.531432335849, 24.8246731710934, 0.000928550027310848],
  ],
  [
    [118.531858023137, 24.8240640811846, 0.00092847365885973],
    [118.531415930335, 24.8246630800157, 0.000928548164665699],
  ],
  [
    [118.531841607778, 24.8240539901645, 0.000928470864892006],
    [118.531399524837, 24.8246529979637, 0.000928548164665699],
  ],
  [
    [118.531825202326, 24.8240439081582, 0.000928470864892006],
    [118.531383109437, 24.8246429068943, 0.000928545370697975],
  ],
  [
    [118.531808796864, 24.8240338171224, 0.000928469002246857],
    [118.531366703931, 24.8246328158111, 0.000928544439375401],
  ],
  [
    [118.531792381526, 24.8240237351244, 0.000928468070924282],
    [118.53135029844, 24.8246227337536, 0.000928543508052826],
  ],
  [
    [118.531775976069, 24.824013644085, 0.000928466208279133],
    [118.531333883048, 24.8246126426787, 0.000928542576730251],
  ],
  [
    [118.531759570628, 24.8240035620714, 0.000928465276956558],
    [118.531317477563, 24.8246025606176, 0.000928542576730251],
  ],
  [
    [118.531743165176, 24.8239934710282, 0.000928465276956558],
    [118.531301072068, 24.8245924695271, 0.000928540714085102],
  ],
  [
    [118.531726749836, 24.8239833799953, 0.000928462482988834],
    [118.531284656696, 24.8245823874743, 0.000928538851439953],
  ],
  [
    [118.531710344402, 24.8239732979762, 0.000928460620343685],
    [118.531268251206, 24.8245722963801, 0.000928536988794804],
  ],
  [
    [118.531693938959, 24.8239632069276, 0.000928460620343685],
    [118.531251845732, 24.8245622143117, 0.000928535126149654],
  ],
  [
    [118.531677523639, 24.8239531249168, 0.000928458757698536],
    [118.531235430356, 24.8245521232258, 0.000928535126149654],
  ],
  [
    [118.531661118201, 24.8239430338646, 0.000928458757698536],
    [118.531219024887, 24.8245420411538, 0.00092853419482708],
  ],
  [
    [118.531644712778, 24.8239329518381, 0.000928455963730812],
    [118.531202619407, 24.8245319500522, 0.000928531400859356],
  ],
  [
    [118.531628297454, 24.8239228607943, 0.000928455032408237],
    [118.531186213944, 24.8245218679765, 0.000928531400859356],
  ],
  [
    [118.531611892036, 24.8239127787642, 0.000928454101085663],
    [118.531169798578, 24.8245117768833, 0.000928530469536781],
  ],
  [
    [118.531595486609, 24.8239026877046, 0.000928452238440514],
    [118.531153393119, 24.824501694804, 0.000928528606891632],
  ],
  [
    [118.531579071305, 24.8238926056828, 0.000928451307117939],
    [118.53113698765, 24.8244916036951, 0.000928526744246483],
  ],
  [
    [118.531562665883, 24.8238825146196, 0.00092844944447279],
    [118.531120572306, 24.8244815216241, 0.000928524881601334],
  ],
  [
    [118.531546260476, 24.8238724325822, 0.00092844944447279],
    [118.531104166842, 24.8244714305115, 0.000928525812923908],
  ],
  [
    [118.531529855059, 24.8238623415153, 0.000928447581827641],
    [118.531087761394, 24.8244613484249, 0.000928523018956184],
  ],
  [
    [118.531513439766, 24.8238522594863, 0.000928446650505066],
    [118.531071346044, 24.8244512573207, 0.000928521156311035],
  ],
  [
    [118.531497034354, 24.8238421684157, 0.000928444787859917],
    [118.531054940602, 24.8244411752303, 0.000928520224988461],
  ],
  [
    [118.531480628958, 24.823832086371, 0.000928443856537342],
    [118.531038535149, 24.8244310841105, 0.000928519293665886],
  ],
  [
    [118.53146421366, 24.8238219953088, 0.000928442925214767],
    [118.53102211982, 24.8244210020285, 0.000928518362343311],
  ],
  [
    [118.531447808269, 24.8238119132604, 0.000928441993892193],
    [118.531005714372, 24.824410910905, 0.000928517431020737],
  ],
  [
    [118.531431402868, 24.8238018221825, 0.000928439199924469],
    [118.530989308941, 24.8244008288073, 0.000928515568375587],
  ],
  [
    [118.531414987591, 24.8237917401425, 0.000928439199924469],
    [118.530972903498, 24.8243907376802, 0.000928514637053013],
  ],
  [
    [118.531398582195, 24.823781649061, 0.00092843733727932],
    [118.530956488167, 24.8243806465632, 0.000928513705730438],
  ],
  [
    [118.531382176814, 24.8237715670053, 0.000928435474634171],
    [118.530940082743, 24.8243705644601, 0.000928510911762714],
  ],
  [
    [118.531365761532, 24.8237614759321, 0.000928433611989021],
    [118.530923677309, 24.8243604733274, 0.000928511843085289],
  ],
  [
    [118.531349356157, 24.8237513938727, 0.000928432680666447],
    [118.530907261998, 24.8243503912326, 0.000928509049117565],
  ],
  [
    [118.531332950772, 24.8237413027839, 0.000928431749343872],
    [118.530890856569, 24.8243403000963, 0.000928508117794991],
  ],
  [
    [118.531316535498, 24.8237312117052, 0.000928430818021297],
    [118.530874451156, 24.8243302179858, 0.000928506255149841],
  ],
  [
    [118.531300130131, 24.8237211296404, 0.000928428955376148],
    [118.53085803584, 24.8243201268579, 0.000928506255149841],
  ],
  [
    [118.531283724753, 24.8237110385461, 0.000928428955376148],
    [118.530841630432, 24.8243100447437, 0.000928504392504692],
  ],
  [
    [118.531267319392, 24.8237009564776, 0.000928427092730999],
    [118.530825225014, 24.8242999536001, 0.000928503461182117],
  ],
  [
    [118.531250904128, 24.8236908653916, 0.000928427092730999],
    [118.530808809719, 24.8242898714943, 0.000928501598536968],
  ],
  [
    [118.531234498772, 24.8236807833194, 0.00092842523008585],
    [118.530792404306, 24.8242797803471, 0.000928500667214394],
  ],
  [
    [118.531218093405, 24.8236706922178, 0.000928423367440701],
    [118.530775998909, 24.8242696982256, 0.000928499735891819],
  ],
  [
    [118.531201678162, 24.823660610154, 0.000928422436118126],
    [118.530759593501, 24.8242596070747, 0.000928499735891819],
  ],
  [
    [118.531185272801, 24.8236505190487, 0.000928421504795551],
    [118.530743178217, 24.8242495249616, 0.00092849787324667],
  ],
  [
    [118.531168867455, 24.8236404369692, 0.000928418710827827],
    [118.530726772815, 24.824239433807, 0.000928495079278946],
  ],
  [
    [118.531152452207, 24.8236303458722, 0.000928418710827827],
    [118.530710367428, 24.8242293516783, 0.000928494147956371],
  ],
  [
    [118.531136046867, 24.8236202637891, 0.000928417779505253],
    [118.530693952139, 24.824219260532, 0.000928493216633797],
  ],
  [
    [118.531119641516, 24.8236101726765, 0.000928415916860104],
    [118.530677546757, 24.8242091783996, 0.000928492285311222],
  ],
  [
    [118.531103226289, 24.8236000906017, 0.000928414054214954],
    [118.530661141365, 24.8241990872377, 0.000928488560020924],
  ],
  [
    [118.531086820944, 24.8235899994854, 0.00092841312289238],
    [118.530644726097, 24.8241890051136, 0.000928487628698349],
  ],
  [
    [118.531070415614, 24.823579917395, 0.000928411260247231],
    [118.530628320711, 24.824178913948, 0.0009284857660532],
  ],
  [
    [118.531054010274, 24.823569826275, 0.000928410328924656],
    [118.53061191534, 24.8241688318083, 0.0009284857660532],
  ],
  [
    [118.531037595058, 24.8235597441929, 0.000928409397602081],
    [118.530595500067, 24.824158740651, 0.0009284857660532],
  ],
  [
    [118.531021189723, 24.8235496530693, 0.000928409397602081],
    [118.530579094701, 24.8241486585076, 0.000928483903408051],
  ],
  [
    [118.531004784403, 24.8235395709716, 0.000928406603634357],
    [118.530562689325, 24.8241385673348, 0.000928482040762901],
  ],
  [
    [118.530988369182, 24.8235294798563, 0.000928405672311783],
    [118.53054627406, 24.824128476172, 0.000928481109440327],
  ],
  [
    [118.530971963868, 24.8235193977549, 0.000928404740989208],
    [118.530529868702, 24.8241183940232, 0.000928480178117752],
  ],
  [
    [118.530955558544, 24.823509306624, 0.000928402878344059],
    [118.530513463334, 24.8241083028448, 0.000928477384150028],
  ],
  [
    [118.530939143344, 24.8234992245309, 0.00092840101569891],
    [118.530497057982, 24.8240982206923, 0.000928478315472603],
  ],
  [
    [118.530922738025, 24.8234891333963, 0.00092840101569891],
    [118.530480642727, 24.8240881295222, 0.000928476452827454],
  ],
  [
    [118.530906332708, 24.8234790422599, 0.000928398221731186],
    [118.53046423738, 24.824078047366, 0.000928475521504879],
  ],
  [
    [118.530889917516, 24.8234689601613, 0.000928397290408611],
    [118.530447832023, 24.8240679561804, 0.000928474590182304],
  ],
  [
    [118.530873512205, 24.8234588690213, 0.000928397290408611],
    [118.530431416789, 24.8240578740325, 0.000928470864892006],
  ],
  [
    [118.530857106909, 24.8234487869071, 0.000928394496440887],
    [118.530415011437, 24.8240477828432, 0.000928470864892006],
  ],
  [
    [118.530840701604, 24.8234386957633, 0.000928394496440887],
    [118.530398606101, 24.8240377006797, 0.000928470864892006],
  ],
  [
    [118.530824286422, 24.8234286136574, 0.000928393565118313],
    [118.530382190862, 24.8240276094986, 0.000928468070924282],
  ],
  [
    [118.530807881121, 24.8234185225101, 0.000928391702473164],
    [118.530365785531, 24.8240175273315, 0.000928468070924282],
  ],
  [
    [118.530791475837, 24.8234084403885, 0.000928389839828014],
    [118.530349380189, 24.8240074361348, 0.000928466208279133],
  ],
  [
    [118.53077506065, 24.8233983492495, 0.000928387977182865],
    [118.530332964972, 24.8239973539759, 0.000928465276956558],
  ],
  [
    [118.53075865537, 24.8233882671243, 0.000928387977182865],
    [118.530316559636, 24.8239872627756, 0.000928463414311409],
  ],
  [
    [118.530742250081, 24.8233781759696, 0.000928387045860291],
    [118.530300154315, 24.8239771806012, 0.000928462482988834],
  ],
  [
    [118.530725834915, 24.8233680938527, 0.000928385183215141],
    [118.530283748984, 24.8239670893972, 0.000928460620343685],
  ],
  [
    [118.53070942963, 24.8233580026944, 0.000928384251892567],
    [118.530267333777, 24.823957007231, 0.000928457826375961],
  ],
  [
    [118.530693024361, 24.8233479205619, 0.000928382389247417],
    [118.530250928451, 24.8239469160234, 0.000928458757698536],
  ],
  [
    [118.53067660919, 24.8233378294118, 0.000928382389247417],
    [118.530234523142, 24.8239368338416, 0.000928456895053387],
  ],
  [
    [118.530660203927, 24.8233277472757, 0.000928379595279694],
    [118.530218107929, 24.8239267426423, 0.000928456895053387],
  ],
  [
    [118.530643798653, 24.82331765611, 0.000928378663957119],
    [118.530201702625, 24.8239166604568, 0.000928454101085663],
  ],
  [
    [118.530627383503, 24.8233075739822, 0.000928377732634544],
    [118.53018529731, 24.8239065692419, 0.000928453169763088],
  ],
  [
    [118.530610978234, 24.8232974828128, 0.00092837680131197],
    [118.530168882119, 24.8238964870647, 0.000928452238440514],
  ],
  [
    [118.530594572981, 24.8232874006694, 0.000928375869989395],
    [118.530152476809, 24.8238863958461, 0.000928451307117939],
  ],
  [
    [118.530578167718, 24.8232773094964, 0.000928374938666821],
    [118.530136071502, 24.8238763046257, 0.000928448513150215],
  ],
  [
    [118.530561752579, 24.8232672273612, 0.000928373076021671],
    [118.530119656319, 24.8238662224431, 0.000928448513150215],
  ],
  [
    [118.530545347321, 24.8232571361846, 0.000928371213376522],
    [118.530103251017, 24.823856131219, 0.000928446650505066],
  ],
  [
    [118.530528942078, 24.8232470540338, 0.000928369350731373],
    [118.530086845731, 24.8238460490207, 0.000928445719182491],
  ],
  [
    [118.530512526934, 24.8232369628655, 0.000928369350731373],
    [118.530070440434, 24.823835957793, 0.000928444787859917],
  ],
  [
    [118.530496121684, 24.8232268716833, 0.000928366556763649],
    [118.530054025262, 24.823825875603, 0.000928442925214767],
  ],
  [
    [118.53047971645, 24.8232167895271, 0.000928367488086224],
    [118.530037619971, 24.8238157843716, 0.000928441993892193],
  ],
  [
    [118.530463301313, 24.8232066983532, 0.0009283646941185],
    [118.530021214695, 24.8238057021661, 0.000928440131247044],
  ],
  [
    [118.530446896084, 24.8231966161933, 0.0009283646941185],
    [118.530004799517, 24.8237956109429, 0.000928439199924469],
  ],
  [
    [118.530430490844, 24.8231865250039, 0.000928363762795925],
    [118.529988394247, 24.8237855287337, 0.00092843733727932],
  ],
  [
    [118.530414075729, 24.8231764428522, 0.000928361900150776],
    [118.529971988967, 24.823775437495, 0.000928435474634171],
  ],
  [
    [118.530397670495, 24.8231663516591, 0.000928359106183052],
    [118.52995557381, 24.823765355294, 0.000928434543311596],
  ],
  [
    [118.530381265276, 24.8231562694919, 0.000928358174860477],
    [118.529939168535, 24.8237552640517, 0.000928434543311596],
  ],
  [
    [118.530364860047, 24.8231461782951, 0.000928357243537903],
    [118.529922763275, 24.8237451818352, 0.000928432680666447],
  ],
  [
    [118.530348444943, 24.8231360961362, 0.000928355380892754],
    [118.529906348113, 24.823735090601, 0.000928431749343872],
  ],
  [
    [118.530332039719, 24.8231260049358, 0.000928355380892754],
    [118.529889942859, 24.8237250083808, 0.000928429886698723],
  ],
  [
    [118.530315634511, 24.8231159227612, 0.00092835258692503],
    [118.529873537595, 24.8237149171312, 0.000928429886698723],
  ],
  [
    [118.530299219401, 24.8231058315691, 0.00092835258692503],
    [118.529857122454, 24.8237048349192, 0.000928428024053574],
  ],
  [
    [118.530282814199, 24.8230957493908, 0.000928351655602455],
    [118.529840717194, 24.8236947436659, 0.000928426161408424],
  ],
  [
    [118.530266408986, 24.8230856581831, 0.000928349792957306],
    [118.529824311951, 24.8236846614384, 0.00092842523008585],
  ],
  [
    [118.530249993897, 24.8230755760132, 0.000928349792957306],
    [118.529807906697, 24.8236745701814, 0.00092842523008585],
  ],
  [
    [118.530233588689, 24.8230654848018, 0.000928347930312157],
    [118.529791491567, 24.8236644879621, 0.000928424298763275],
  ],
  [
    [118.530217183497, 24.8230554026163, 0.000928345136344433],
    [118.529775086318, 24.8236543967015, 0.000928420573472977],
  ],
  [
    [118.530200768403, 24.8230453114132, 0.000928344205021858],
    [118.529758681072, 24.823644305439, 0.000928419642150402],
  ],
  [
    [118.530184363216, 24.823035229224, 0.000928343273699284],
    [118.52974226595, 24.8236342232143, 0.000928418710827827],
  ],
  [
    [118.530167958019, 24.8230251380053, 0.000928342342376709],
    [118.529725860709, 24.8236241319481, 0.000928416848182678],
  ],
  [
    [118.530151552838, 24.8230150558124, 0.000928341411054134],
    [118.529709455484, 24.8236140497078, 0.000928415916860104],
  ],
  [
    [118.530135137754, 24.823004964602, 0.000928339548408985],
    [118.529693040356, 24.8236039584499, 0.000928414985537529],
  ],
  [
    [118.530118732578, 24.8229948824055, 0.000928337685763836],
    [118.529676635137, 24.823593876206, 0.000928414054214954],
  ],
  [
    [118.530102327392, 24.8229847911795, 0.000928335823118687],
    [118.529660229906, 24.8235837849325, 0.000928412191569805],
  ],
  [
    [118.530085912316, 24.8229746999636, 0.000928335823118687],
    [118.5296438148, 24.8235737026968, 0.000928411260247231],
  ],
  [
    [118.530069507148, 24.8229646177616, 0.000928333960473537],
    [118.529627409575, 24.8235636114197, 0.000928411260247231],
  ],
  [
    [118.53005310197, 24.8229545265301, 0.000928333960473537],
    [118.529611004366, 24.8235535291684, 0.000928409397602081],
  ],
  [
    [118.530036686915, 24.8229444443364, 0.000928332097828388],
    [118.529594599146, 24.8235434378876, 0.000928407534956932],
  ],
  [
    [118.530020281742, 24.8229343531012, 0.000928330235183239],
    [118.529578184051, 24.8235333556446, 0.000928406603634357],
  ],
  [
    [118.530003876585, 24.8229242708919, 0.000928330235183239],
    [118.529561778836, 24.8235232643602, 0.000928404740989208],
  ],
  [
    [118.529987461525, 24.822914179665, 0.000928327441215515],
    [118.529545373638, 24.8235131821016, 0.000928404740989208],
  ],
  [
    [118.529971056373, 24.822904097452, 0.000928327441215515],
    [118.529528958537, 24.8235030908254, 0.000928402878344059],
  ],
  [
    [118.52995465121, 24.8228940062096, 0.000928324647247791],
    [118.529512553344, 24.8234930085631, 0.00092840101569891],
  ],
  [
    [118.529938236172, 24.8228839240048, 0.000928324647247791],
    [118.52949614814, 24.8234829172714, 0.000928399153053761],
  ],
  [
    [118.529921831014, 24.8228738327587, 0.000928322784602642],
    [118.52947973306, 24.8234728350174, 0.000928398221731186],
  ],
  [
    [118.529905425873, 24.8228637505385, 0.000928322784602642],
    [118.529463327862, 24.823462743722, 0.000928397290408611],
  ],
  [
    [118.529889020721, 24.8228536592887, 0.000928319059312344],
    [118.529446922679, 24.8234526614524, 0.000928395427763462],
  ],
  [
    [118.529872605693, 24.8228435770766, 0.000928318127989769],
    [118.529430507594, 24.8234425701652, 0.000928395427763462],
  ],
  [
    [118.529856200546, 24.8228334858232, 0.000928319059312344],
    [118.529414102417, 24.823432487892, 0.000928392633795738],
  ],
  [
    [118.529839795415, 24.8228234035956, 0.000928314402699471],
    [118.529397697229, 24.8234223965893, 0.000928392633795738],
  ],
  [
    [118.529823380382, 24.8228133123504, 0.000928315334022045],
    [118.529381292057, 24.8234123143124, 0.000928390771150589],
  ],
  [
    [118.529806975256, 24.8228032301192, 0.000928314402699471],
    [118.529364876983, 24.8234022230179, 0.00092838890850544],
  ],
  [
    [118.52979057012, 24.8227931388584, 0.000928312540054321],
    [118.529348471803, 24.8233921317097, 0.000928387045860291],
  ],
  [
    [118.529774155108, 24.8227830566354, 0.000928311608731747],
    [118.529332066639, 24.8233820494274, 0.000928386114537716],
  ],
  [
    [118.529757749977, 24.822772965371, 0.000928310677409172],
    [118.529315651573, 24.8233719581274, 0.000928386114537716],
  ],
  [
    [118.529741344862, 24.8227628831324, 0.000928308814764023],
    [118.529299246414, 24.8233618758414, 0.000928384251892567],
  ],
  [
    [118.529724929845, 24.8227527918763, 0.000928307883441448],
    [118.529282841244, 24.8233517845259, 0.000928384251892567],
  ],
  [
    [118.529708524735, 24.822742709634, 0.000928306952118874],
    [118.529266426199, 24.823341702248, 0.000928381457924843],
  ],
  [
    [118.529692119615, 24.8227326183623, 0.000928305089473724],
    [118.529250021035, 24.8233316109289, 0.000928381457924843],
  ],
  [
    [118.529675714497, 24.8227225270888, 0.000928303226828575],
    [118.529233615887, 24.8233215286355, 0.000928378663957119],
  ],
  [
    [118.529659299504, 24.8227124448529, 0.000928302295506001],
    [118.529217200837, 24.8233114373246, 0.000928377732634544],
  ],
  [
    [118.529642894392, 24.8227023535757, 0.000928300432860851],
    [118.529200795694, 24.8233013550276, 0.00092837680131197],
  ],
  [
    [118.529626489295, 24.8226922713244, 0.000928299501538277],
    [118.52918439054, 24.8232912637011, 0.000928375869989395],
  ],
  [
    [118.529610074296, 24.8226821800554, 0.000928298570215702],
    [118.529167975511, 24.8232811814123, 0.000928374007344246],
  ],
  [
    [118.529593669205, 24.8226720978004, 0.000928296707570553],
    [118.529151570363, 24.8232710900822, 0.000928373076021671],
  ],
  [
    [118.529577264104, 24.8226620065158, 0.000928294844925404],
    [118.529135165231, 24.8232610077778, 0.000928372144699097],
  ],
  [
    [118.529560849126, 24.822651924269, 0.000928293913602829],
    [118.529118760088, 24.8232509164441, 0.000928370282053947],
  ],
  [
    [118.52954444403, 24.8226418329809, 0.00092829205095768],
    [118.529102345069, 24.8232408341479, 0.000928369350731373],
  ],
  [
    [118.529528038949, 24.8226317507185, 0.000928292982280254],
    [118.529085939932, 24.8232307428105, 0.000928367488086224],
  ],
  [
    [118.529511623966, 24.8226216594386, 0.00092829205095768],
    [118.52906953481, 24.8232206604989, 0.000928366556763649],
  ],
  [
    [118.529495218891, 24.8226115771726, 0.000928289256989956],
    [118.529053119786, 24.8232105691696, 0.000928365625441074],
  ],
  [
    [118.529478813805, 24.8226014858771, 0.000928288325667381],
    [118.52903671467, 24.8232004868543, 0.0009283646941185],
  ],
  [
    [118.529462408735, 24.8225914036074, 0.000928286463022232],
    [118.529020309543, 24.8231903955096, 0.000928361900150776],
  ],
  [
    [118.529445993763, 24.8225813123202, 0.000928285531699657],
    [118.52900389454, 24.8231803132025, 0.000928360968828201],
  ],
  [
    [118.529429588698, 24.8225712300468, 0.000928284600377083],
    [118.528987489418, 24.823170221854, 0.000928360037505627],
  ],
  [
    [118.529413183623, 24.822561138744, 0.000928283669054508],
    [118.528971084313, 24.8231601395315, 0.000928358174860477],
  ],
  [
    [118.529396768672, 24.8225510564789, 0.000928280875086784],
    [118.528954669305, 24.8231500481912, 0.000928358174860477],
  ],
  [
    [118.529380363602, 24.8225409651725, 0.00092827994376421],
    [118.528938264191, 24.8231399568373, 0.000928356312215328],
  ],
  [
    [118.529363958548, 24.8225308828918, 0.00092827994376421],
    [118.528921859093, 24.8231298745092, 0.000928354449570179],
  ],
  [
    [118.529347543592, 24.8225207915936, 0.000928279012441635],
    [118.528905453985, 24.8231197831517, 0.000928354449570179],
  ],
  [
    [118.529331138543, 24.8225107093093, 0.000928277149796486],
    [118.528889039001, 24.8231097008318, 0.000928351655602455],
  ],
  [
    [118.529314733484, 24.8225006179955, 0.000928276218473911],
    [118.528872633898, 24.8230996094705, 0.000928350724279881],
  ],
  [
    [118.529298318549, 24.8224905357194, 0.000928274355828762],
    [118.52885622881, 24.8230895271351, 0.000928351655602455],
  ],
  [
    [118.529281913495, 24.822480444402, 0.000928273424506187],
    [118.528839813821, 24.8230794357821, 0.000928348861634731],
  ],
  [
    [118.529265508444, 24.8224703530828, 0.000928272493183613],
    [118.528823408739, 24.823069353443, 0.000928346998989582],
  ],
  [
    [118.529249093516, 24.8224602708012, 0.000928269699215889],
    [118.528807003647, 24.8230592620745, 0.000928345136344433],
  ],
  [
    [118.52923268847, 24.8224501794783, 0.000928268767893314],
    [118.528790588678, 24.8230491797436, 0.000928344205021858],
  ],
  [
    [118.52921628344, 24.8224400971812, 0.000928269699215889],
    [118.528774183591, 24.8230390883714, 0.000928342342376709],
  ],
  [
    [118.529199878399, 24.8224300058546, 0.00092826783657074],
    [118.52875777852, 24.8230290060251, 0.000928342342376709],
  ],
  [
    [118.529183463483, 24.8224199235657, 0.000928265042603016],
    [118.528741363546, 24.823018914661, 0.000928341411054134],
  ],
  [
    [118.529167058447, 24.8224098322355, 0.000928263179957867],
    [118.52872495848, 24.823008832311, 0.000928339548408985],
  ],
  [
    [118.529150653428, 24.8223997499311, 0.000928262248635292],
    [118.528708553404, 24.8229987409315, 0.000928337685763836],
  ],
  [
    [118.529134238506, 24.8223896586091, 0.000928260385990143],
    [118.528692148343, 24.8229886585778, 0.000928337685763836],
  ],
  [
    [118.529117833491, 24.822379576301, 0.000928261317312717],
    [118.52867573338, 24.8229785672065, 0.000928336754441261],
  ],
  [
    [118.529101428467, 24.8223694849634, 0.000928259454667568],
    [118.528659328325, 24.8229684848491, 0.000928334891796112],
  ],
  [
    [118.529085013566, 24.8223594026636, 0.000928256660699844],
    [118.528642923259, 24.8229583934623, 0.000928333029150963],
  ],
  [
    [118.529068608547, 24.8223493113224, 0.000928254798054695],
    [118.528626508317, 24.8229483111131, 0.000928332097828388],
  ],
  [
    [118.529052203543, 24.822339229007, 0.000928254798054695],
    [118.528610103257, 24.8229382197227, 0.000928330235183239],
  ],
  [
    [118.529035788637, 24.822329137674, 0.000928253866732121],
    [118.528593698212, 24.822928137358, 0.000928330235183239],
  ],
  [
    [118.529019383638, 24.822319055355, 0.000928251072764397],
    [118.528577283265, 24.8229180459757, 0.000928327441215515],
  ],
  [
    [118.52900297863, 24.8223089640064, 0.000928251072764397],
    [118.528560878225, 24.8229079636074, 0.000928326509892941],
  ],
  [
    [118.528986573636, 24.8222988816838, 0.000928249210119247],
    [118.528544473175, 24.8228978722096, 0.000928325578570366],
  ],
  [
    [118.528970158741, 24.8222887903434, 0.000928248278796673],
    [118.528528058236, 24.8228877808218, 0.000928324647247791],
  ],
  [
    [118.528953753753, 24.8222787080171, 0.000928248278796673],
    [118.528511653205, 24.822877698448, 0.000928323715925217],
  ],
  [
    [118.528937348755, 24.8222686166612, 0.000928246416151524],
    [118.528495248163, 24.8228676070447, 0.000928320921957493],
  ],
  [
    [118.528920933881, 24.8222585343431, 0.000928245484828949],
    [118.528478833245, 24.8228575246791, 0.000928319990634918],
  ],
  [
    [118.528904528888, 24.8222484429836, 0.000928242690861225],
    [118.528462428208, 24.8228474332721, 0.000928319990634918],
  ],
  [
    [118.528888123911, 24.8222383606499, 0.000928241759538651],
    [118.528446023187, 24.822837350891, 0.000928318127989769],
  ],
  [
    [118.528871709031, 24.8222282692986, 0.000928239896893501],
    [118.528429618155, 24.8228272594804, 0.00092831626534462],
  ],
  [
    [118.528855304046, 24.8222181779337, 0.000928238965570927],
    [118.528413203248, 24.8228171771075, 0.000928315334022045],
  ],
  [
    [118.528838899077, 24.8222080955945, 0.000928238965570927],
    [118.528396798222, 24.8228070856932, 0.000928313471376896],
  ],
  [
    [118.528822484206, 24.8221980042377, 0.000928237102925777],
    [118.528380393211, 24.8227970033048, 0.000928312540054321],
  ],
  [
    [118.528806079242, 24.8221879218949, 0.000928236171603203],
    [118.528363978299, 24.8227869118987, 0.000928312540054321],
  ],
  [
    [118.528789674267, 24.8221778305226, 0.000928234308958054],
    [118.528347573294, 24.8227768295066, 0.000928312540054321],
  ],
  [
    [118.528773269309, 24.8221677481762, 0.000928233377635479],
    [118.528331168278, 24.822766738085, 0.000928309746086597],
  ],
  [
    [118.528756854448, 24.8221576568121, 0.00092823151499033],
    [118.528314753387, 24.8227566557011, 0.000928307883441448],
  ],
  [
    [118.528740449494, 24.8221475744619, 0.000928229652345181],
    [118.528298348377, 24.8227465642759, 0.000928306952118874],
  ],
  [
    [118.528724044531, 24.8221374830823, 0.000928230583667755],
    [118.528281943382, 24.8227364818765, 0.000928306020796299],
  ],
  [
    [118.528707629691, 24.8221274007404, 0.000928227789700031],
    [118.528265528486, 24.8227263904594, 0.00092830415815115],
  ],
  [
    [118.528691224732, 24.8221173093571, 0.000928227789700031],
    [118.528249123496, 24.8227163080563, 0.000928302295506001],
  ],
  [
    [118.52867481979, 24.8221072269997, 0.000928225927054882],
    [118.528232718497, 24.8227062166238, 0.000928300432860851],
  ],
  [
    [118.528658404945, 24.8220971356246, 0.000928225927054882],
    [118.528216313513, 24.8226961342171, 0.000928300432860851],
  ],
  [
    [118.528642000007, 24.8220870532635, 0.000928223133087158],
    [118.528199898627, 24.8226860427927, 0.000928297638893127],
  ],
  [
    [118.528625595059, 24.8220769618729, 0.000928221270442009],
    [118.528183493648, 24.8226759603823, 0.000928297638893127],
  ],
  [
    [118.528609180235, 24.82206687952, 0.000928220339119434],
    [118.528167088659, 24.8226658689425, 0.000928296707570553],
  ],
  [
    [118.528592775293, 24.8220567881258, 0.00092821940779686],
    [118.528150673794, 24.8226557865403, 0.000928294844925404],
  ],
  [
    [118.528576370366, 24.8220467057574, 0.000928217545151711],
    [118.528134268811, 24.8226456950968, 0.000928293913602829],
  ],
  [
    [118.528559955537, 24.8220366143713, 0.000928216613829136],
    [118.52811786383, 24.8226356036514, 0.000928292982280254],
  ],
  [
    [118.528543550615, 24.8220265319993, 0.000928214751183987],
    [118.528101448973, 24.8226255212437, 0.000928291119635105],
  ],
  [
    [118.528527145683, 24.8220164405977, 0.000928214751183987],
    [118.528085043997, 24.8226154297947, 0.000928289256989956],
  ],
  [
    [118.528510740767, 24.822006358222, 0.000928213819861412],
    [118.528068639037, 24.8226053473715, 0.000928289256989956],
  ],
  [
    [118.528494325949, 24.8219962668286, 0.000928211025893688],
    [118.528052224175, 24.8225952559307, 0.000928288325667381],
  ],
  [
    [118.528477921038, 24.8219861844492, 0.000928210094571114],
    [118.52803581922, 24.8225851735039, 0.000928285531699657],
  ],
  [
    [118.528461516116, 24.8219760930404, 0.000928209163248539],
    [118.528019414255, 24.8225750820476, 0.000928284600377083],
  ],
  [
    [118.528445101306, 24.8219660016415, 0.000928208231925964],
    [118.528003009305, 24.8225649996171, 0.000928284600377083],
  ],
  [
    [118.528428696403, 24.8219559192567, 0.00092820730060339],
    [118.527986594454, 24.8225549081689, 0.000928281806409359],
  ],
  [
    [118.52841229149, 24.8219458278423, 0.000928205437958241],
    [118.52797018951, 24.8225448257348, 0.000928281806409359],
  ],
  [
    [118.5283958767, 24.8219357454656, 0.000928203575313091],
    [118.527953784555, 24.8225347342711, 0.00092827994376421],
  ],
  [
    [118.528379471792, 24.8219256540476, 0.000928202643990517],
    [118.527937369725, 24.8225246518451, 0.000928277149796486],
  ],
  [
    [118.5283630669, 24.8219155716554, 0.000928200781345367],
    [118.527920964776, 24.8225145603778, 0.000928277149796486],
  ],
  [
    [118.528346652105, 24.8219054802456, 0.000928199850022793],
    [118.527904559842, 24.8225044779364, 0.000928275287151337],
  ],
  [
    [118.528330247218, 24.8218953978498, 0.000928198918700218],
    [118.527888145006, 24.8224943864772, 0.000928273424506187],
  ],
  [
    [118.528313842321, 24.8218853064244, 0.000928197056055069],
    [118.527871740078, 24.8224843040321, 0.000928273424506187],
  ],
  [
    [118.528297437439, 24.821875224025, 0.000928197056055069],
    [118.52785533514, 24.8224742125575, 0.000928272493183613],
  ],
  [
    [118.528281022655, 24.8218651326078, 0.000928194262087345],
    [118.527838920325, 24.8224641301205, 0.000928270630538464],
  ],
  [
    [118.528264617778, 24.8218550502046, 0.000928194262087345],
    [118.527822515392, 24.8224540386423, 0.000928270630538464],
  ],
  [
    [118.528248212891, 24.821844958772, 0.000928191468119621],
    [118.527806110474, 24.8224439561899, 0.000928268767893314],
  ],
  [
    [118.528231798128, 24.821834876377, 0.000928189605474472],
    [118.527789695654, 24.8224338647197, 0.00092826783657074],
  ],
  [
    [118.528215393247, 24.8218247849407, 0.000928189605474472],
    [118.527773290742, 24.8224237822637, 0.000928266905248165],
  ],
  [
    [118.528198988381, 24.8218147025303, 0.000928188674151897],
    [118.527756885819, 24.8224136907781, 0.000928263179957867],
  ],
  [
    [118.528182573613, 24.8218046111021, 0.000928187742829323],
    [118.527740480912, 24.8224036083184, 0.000928263179957867],
  ],
  [
    [118.528166168752, 24.821794528688, 0.000928184948861599],
    [118.527724066103, 24.8223935168409, 0.000928261317312717],
  ],
  [
    [118.528149763881, 24.8217844372444, 0.000928184948861599],
    [118.527707661188, 24.8223834253499, 0.000928259454667568],
  ],
  [
    [118.528133349134, 24.8217743548384, 0.000928184017539024],
    [118.527691256289, 24.8223733428846, 0.000928258523344994],
  ],
  [
    [118.528116944269, 24.8217642633912, 0.00092818308621645],
    [118.527674841488, 24.8223632514017, 0.000928258523344994],
  ],
  [
    [118.528100539418, 24.8217541809698, 0.000928181223571301],
    [118.527658436594, 24.8223531689328, 0.000928257592022419],
  ],
  [
    [118.528084134558, 24.8217440895188, 0.000928179360926151],
    [118.52764203169, 24.8223430774345, 0.000928254798054695],
  ],
  [
    [118.528067719822, 24.8217340071055, 0.000928177498281002],
    [118.52762561691, 24.8223329949737, 0.000928254798054695],
  ],
  [
    [118.528051314967, 24.821723915651, 0.000928177498281002],
    [118.527609212011, 24.8223229034717, 0.000928253866732121],
  ],
  [
    [118.528034910114, 24.8217138241946, 0.000928176566958427],
    [118.527592807128, 24.8223128209955, 0.000928251072764397],
  ],
  [
    [118.528018495386, 24.8217037417758, 0.000928174704313278],
    [118.527576392343, 24.8223027295016, 0.000928249210119247],
  ],
  [
    [118.528002090539, 24.8216936503158, 0.000928171910345554],
    [118.527559987465, 24.8222926470217, 0.000928249210119247],
  ],
  [
    [118.527985685707, 24.8216835678815, 0.000928171910345554],
    [118.527543582577, 24.8222825555124, 0.000928247347474098],
  ],
  [
    [118.527969270974, 24.8216734764296, 0.00092817097902298],
    [118.527527177704, 24.8222724730289, 0.000928246416151524],
  ],
  [
    [118.527952866147, 24.8216633939917, 0.000928169116377831],
    [118.52751076293, 24.8222623815276, 0.000928245484828949],
  ],
  [
    [118.527936461311, 24.8216533025243, 0.000928169116377831],
    [118.527494358062, 24.8222522990405, 0.0009282436221838],
  ],
  [
    [118.527920046598, 24.8216432200946, 0.000928166322410107],
    [118.527477953185, 24.8222422075238, 0.0009282436221838],
  ],
  [
    [118.527903641767, 24.8216331286236, 0.000928164459764957],
    [118.527461538431, 24.8222321250448, 0.000928240828216076],
  ],
  [
    [118.527887236952, 24.8216230461784, 0.000928164459764957],
    [118.527445133559, 24.8222220335245, 0.000928240828216076],
  ],
  [
    [118.527870822234, 24.8216129547155, 0.000928162597119808],
    [118.527428728702, 24.82221195103, 0.000928239896893501],
  ],
  [
    [118.527854417424, 24.8216028722666, 0.000928161665797234],
    [118.527412313943, 24.8222018595178, 0.000928236171603203],
  ],
  [
    [118.527838012603, 24.8215927807883, 0.000928159803152084],
    [118.527395909092, 24.8221917770196, 0.000928236171603203],
  ],
  [
    [118.527821607798, 24.8215826983358, 0.000928159803152084],
    [118.52737950423, 24.822181685492, 0.000928234308958054],
  ],
  [
    [118.527805193091, 24.8215726068655, 0.000928157940506935],
    [118.527363089492, 24.822171603002, 0.000928236171603203],
  ],
  [
    [118.527788788291, 24.8215625244094, 0.000928157009184361],
    [118.527346684636, 24.8221615114707, 0.00092823151499033],
  ],
  [
    [118.527772383481, 24.8215524329237, 0.000928156077861786],
    [118.527330279795, 24.8221514289653, 0.000928230583667755],
  ],
  [
    [118.527755968795, 24.8215423504757, 0.000928155146539211],
    [118.527313874944, 24.8221413374303, 0.000928229652345181],
  ],
  [
    [118.527739563991, 24.8215322589864, 0.000928154215216637],
    [118.527297460204, 24.8221312459053, 0.000928229652345181],
  ],
  [
    [118.527723159201, 24.8215221765229, 0.000928153283894062],
    [118.527281055371, 24.8221211633944, 0.000928227789700031],
  ],
  [
    [118.52770674451, 24.8215120850417, 0.000928150489926338],
    [118.527264650528, 24.822111071854, 0.000928224995732307],
  ],
  [
    [118.527690339727, 24.8215020025745, 0.000928150489926338],
    [118.527248235809, 24.8221009893511, 0.000928224064409733],
  ],
  [
    [118.527673934933, 24.8214919110779, 0.000928147695958614],
    [118.527231830971, 24.822090897807, 0.000928224064409733],
  ],
  [
    [118.527657520262, 24.8214818286189, 0.00092814676463604],
    [118.527215426149, 24.8220808152888, 0.000928221270442009],
  ],
  [
    [118.527641115474, 24.8214717371186, 0.000928145833313465],
    [118.527199011425, 24.8220707237528, 0.000928220339119434],
  ],
  [
    [118.527624710687, 24.8214616456165, 0.000928143970668316],
    [118.527182606608, 24.8220606412309, 0.000928222201764584],
  ],
  [
    [118.527608305917, 24.8214515631402, 0.000928141176700592],
    [118.52716620178, 24.8220505496795, 0.000928217545151711],
  ],
  [
    [118.527591891244, 24.8214414716462, 0.000928141176700592],
    [118.527149787077, 24.8220404671657, 0.000928217545151711],
  ],
  [
    [118.527575486479, 24.8214313891663, 0.000928141176700592],
    [118.527133382255, 24.8220303756107, 0.000928215682506561],
  ],
  [
    [118.527559081704, 24.8214212976569, 0.000928138382732868],
    [118.527116977449, 24.8220202930814, 0.000928213819861412],
  ],
  [
    [118.527542667052, 24.821411215185, 0.000928137451410294],
    [118.52710056274, 24.8220102015345, 0.000928214751183987],
  ],
  [
    [118.527526262282, 24.821401123672, 0.000928136520087719],
    [118.527084157939, 24.8220001190016, 0.000928212888538837],
  ],
  [
    [118.527509857527, 24.8213910411847, 0.000928133726119995],
    [118.527067753128, 24.8219900274392, 0.000928212888538837],
  ],
  [
    [118.527493442871, 24.8213809496797, 0.000928133726119995],
    [118.527051348332, 24.8219799449027, 0.000928211025893688],
  ],
  [
    [118.527477038121, 24.8213708671888, 0.000928132794797421],
    [118.527034933635, 24.8219698533484, 0.00092820730060339],
  ],
  [
    [118.527460633362, 24.8213607756684, 0.000928130000829697],
    [118.527018528844, 24.8219597708082, 0.000928206369280815],
  ],
  [
    [118.527444218726, 24.8213506931856, 0.000928130000829697],
    [118.527002124043, 24.8219496792386, 0.000928204506635666],
  ],
  [
    [118.52742772487, 24.8213405476013, 0.000928128138184547],
    [118.52698580836, 24.8219396507553, 0.000928202643990517],
  ],
  [
    [118.527411201342, 24.8213304020503, 0.000928128138184547],
    [118.526969492692, 24.8219296312979, 0.000928203575313091],
  ],
  [
    [118.527394687722, 24.8213202655134, 0.000928125344216824],
    [118.526953186931, 24.8219196208546, 0.000928201712667942],
  ],
  [
    [118.527378164212, 24.8213101289863, 0.000928125344216824],
    [118.526936871293, 24.8219096194488, 0.000928201712667942],
  ],
  [
    [118.527361630827, 24.8213000014968, 0.000928123481571674],
    [118.526920545754, 24.8218996090253, 0.000928199850022793],
  ],
  [
    [118.527345107335, 24.8212898739937, 0.0009281225502491],
    [118.526904220244, 24.8218896166553, 0.000928197987377644],
  ],
  [
    [118.527328573968, 24.8212797555282, 0.000928121618926525],
    [118.526887894735, 24.8218796242834, 0.000928196124732494],
  ],
  [
    [118.527312030712, 24.8212696370725, 0.000928119756281376],
    [118.52687156923, 24.8218696319098, 0.000928196124732494],
  ],
  [
    [118.527295487471, 24.8212595276426, 0.000928118824958801],
    [118.526855233848, 24.8218596485737, 0.000928193330764771],
  ],
  [
    [118.527278944233, 24.8212494182108, 0.000928116962313652],
    [118.526838898469, 24.8218496652358, 0.000928192399442196],
  ],
  [
    [118.52726240101, 24.8212393178049, 0.000928116962313652],
    [118.526822563105, 24.8218396909237, 0.000928190536797047],
  ],
  [
    [118.527245847912, 24.8212292264364, 0.000928114168345928],
    [118.526806217865, 24.8218297256492, 0.000928191468119621],
  ],
  [
    [118.527229294816, 24.8212191350661, 0.000928113237023354],
    [118.526789872628, 24.8218197603729, 0.000928188674151897],
  ],
  [
    [118.527212731831, 24.8212090437057, 0.000928111374378204],
    [118.526773517501, 24.8218097951064, 0.000928189605474472],
  ],
  [
    [118.527196168862, 24.821198961371, 0.000928111374378204],
    [118.526757162403, 24.8217998478934, 0.000928185880184174],
  ],
  [
    [118.527179605908, 24.8211888880621, 0.000928109511733055],
    [118.526740807295, 24.821789891651, 0.000928185880184174],
  ],
  [
    [118.527163033065, 24.8211788147631, 0.000928108580410481],
    [118.52672444231, 24.821779944446, 0.000928184948861599],
  ],
  [
    [118.527146470117, 24.8211687414505, 0.000928106717765331],
    [118.526708077341, 24.8217700062669, 0.000928184017539024],
  ],
  [
    [118.527129887401, 24.8211586771872, 0.000928106717765331],
    [118.526691712375, 24.821760068086, 0.000928181223571301],
  ],
  [
    [118.527113314592, 24.8211486219379, 0.000928103923797607],
    [118.526675347424, 24.821750138931, 0.000928179360926151],
  ],
  [
    [118.527096731894, 24.8211385666984, 0.000928102061152458],
    [118.526658972584, 24.8217402097858, 0.000928181223571301],
  ],
  [
    [118.52708013932, 24.8211285204965, 0.000928101129829884],
    [118.526642587867, 24.8217302896781, 0.000928178429603577],
  ],
  [
    [118.527063546749, 24.8211184742926, 0.000928102061152458],
    [118.526626213045, 24.8217203695569, 0.000928175635635853],
  ],
  [
    [118.527046954193, 24.8211084371146, 0.000928099267184734],
    [118.526609828347, 24.8217104584732, 0.000928176566958427],
  ],
  [
    [118.52703036164, 24.8210983999347, 0.000928096473217011],
    [118.526593433759, 24.8217005473994, 0.000928173772990704],
  ],
  [
    [118.527013759211, 24.8210883717923, 0.000928096473217011],
    [118.526577049079, 24.8216906453397, 0.000928173772990704],
  ],
  [
    [118.526997156784, 24.821078343648, 0.000928094610571861],
    [118.526560644618, 24.8216807433015, 0.000928171910345554],
  ],
  [
    [118.526980554373, 24.8210683245295, 0.000928094610571861],
    [118.526544250064, 24.8216708502775, 0.000928170047700405],
  ],
  [
    [118.526963942086, 24.8210583144485, 0.000928093679249287],
    [118.526527845621, 24.8216609572634, 0.000928170047700405],
  ],
  [
    [118.526947329802, 24.8210483043656, 0.000928091816604137],
    [118.526511441194, 24.8216510732751, 0.000928168185055256],
  ],
  [
    [118.526930707628, 24.8210382942925, 0.000928090885281563],
    [118.526495036782, 24.8216411983126, 0.000928165391087532],
  ],
  [
    [118.52691408547, 24.8210282932452, 0.000928089022636414],
    [118.52647862248, 24.8216313233599, 0.000928165391087532],
  ],
  [
    [118.526897463328, 24.8210183012237, 0.000928087159991264],
    [118.526462208182, 24.8216214484054, 0.000928163528442383],
  ],
  [
    [118.526880831297, 24.821008309212, 0.00092808622866869],
    [118.526445784007, 24.8216115824885, 0.000928160734474659],
  ],
  [
    [118.526864199268, 24.8209983171985, 0.000928084366023541],
    [118.526429369739, 24.8216017255856, 0.000928161665797234],
  ],
  [
    [118.526847567255, 24.8209883342107, 0.000928085297346115],
    [118.526412935691, 24.8215918687043, 0.000928160734474659],
  ],
  [
    [118.526830925366, 24.8209783602604, 0.000928081572055817],
    [118.526396511537, 24.8215820118095, 0.000928159803152084],
  ],
  [
    [118.526814283479, 24.8209683863082, 0.000928082503378391],
    [118.526380077506, 24.8215721639522, 0.000928157009184361],
  ],
  [
    [118.526797641608, 24.8209584213817, 0.000928079709410667],
    [118.526363643491, 24.8215623251206, 0.000928157940506935],
  ],
  [
    [118.526780989848, 24.8209484564651, 0.000928079709410667],
    [118.526347199587, 24.821552486299, 0.000928156077861786],
  ],
  [
    [118.526764338104, 24.8209385005743, 0.000928078778088093],
    [118.526330755698, 24.8215426565031, 0.000928154215216637],
  ],
  [
    [118.526747686362, 24.8209285446816, 0.000928076915442944],
    [118.526314311812, 24.8215328267054, 0.000928153283894062],
  ],
  [
    [118.526731024744, 24.8209185978263, 0.000928075052797794],
    [118.52629785805, 24.8215230059452, 0.000928153283894062],
  ],
  [
    [118.526714363142, 24.8209086599968, 0.00092807412147522],
    [118.526281414182, 24.8215131851715, 0.000928149558603764],
  ],
  [
    [118.526697701542, 24.8208987221654, 0.000928072258830071],
    [118.526264950546, 24.8215033734469, 0.000928149558603764],
  ],
  [
    [118.526681030053, 24.8208887843439, 0.000928072258830071],
    [118.526248496804, 24.8214935617088, 0.000928147695958614],
  ],
  [
    [118.52666435858, 24.8208788555481, 0.000928070396184921],
    [118.526232033186, 24.8214837590082, 0.000928145833313465],
  ],
  [
    [118.526647677218, 24.8208689267621, 0.000928069464862347],
    [118.526215559679, 24.8214739563174, 0.000928143970668316],
  ],
  [
    [118.526630995884, 24.8208590160295, 0.000928067602217197],
    [118.526199096078, 24.8214641626407, 0.000928144901990891],
  ],
  [
    [118.52661431454, 24.8208490962673, 0.000928065739572048],
    [118.526182622602, 24.8214543780016, 0.000928143039345741],
  ],
  [
    [118.526597633211, 24.820839185531, 0.000928064808249474],
    [118.526166139237, 24.8214445933722, 0.000928141176700592],
  ],
  [
    [118.526580942007, 24.820829283832, 0.000928062945604324],
    [118.526149665766, 24.8214348087293, 0.000928141176700592],
  ],
  [
    [118.526564250805, 24.8208193821312, 0.00092806201428175],
    [118.526133182418, 24.8214250331239, 0.000928140245378017],
  ],
  [
    [118.526547549727, 24.8208094894679, 0.000928061082959175],
    [118.526116689194, 24.821415266556, 0.000928137451410294],
  ],
  [
    [118.526530848651, 24.8207995968026, 0.0009280601516366],
    [118.526100205865, 24.8214054999746, 0.000928136520087719],
  ],
  [
    [118.526514147591, 24.8207897131631, 0.000928059220314026],
    [118.526083712646, 24.8213957334029, 0.000928135588765144],
  ],
  [
    [118.526497436642, 24.8207798295334, 0.000928057357668877],
    [118.526067209552, 24.8213859758688, 0.000928133726119995],
  ],
  [
    [118.526480725709, 24.8207699549294, 0.000928056426346302],
    [118.526050706472, 24.8213762273604, 0.00092813465744257],
  ],
  [
    [118.526464014778, 24.8207600803235, 0.000928056426346302],
    [118.526034203395, 24.8213664788502, 0.000928131863474846],
  ],
  [
    [118.526447293971, 24.8207502147551, 0.000928054563701153],
    [118.526017700334, 24.8213567393658, 0.000928130932152271],
  ],
  [
    [118.526430573179, 24.8207403582124, 0.000928053632378578],
    [118.526001187383, 24.8213469998911, 0.000928130000829697],
  ],
  [
    [118.52641385239, 24.8207305016679, 0.000928050838410854],
    [118.525984674448, 24.8213372694423, 0.000928129069507122],
  ],
  [
    [118.526397121712, 24.8207206451331, 0.00092804990708828],
    [118.525968161515, 24.8213275389917, 0.000928127206861973],
  ],
  [
    [118.52638039105, 24.820710797624, 0.00092804990708828],
    [118.525951638706, 24.8213178175784, 0.000928126275539398],
  ],
  [
    [118.526363660403, 24.8207009591407, 0.000928047113120556],
    [118.5259351159, 24.8213080961634, 0.000928126275539398],
  ],
  [
    [118.526346919867, 24.8206911206672, 0.000928047113120556],
    [118.525918583217, 24.8212983837857, 0.000928124412894249],
  ],
  [
    [118.526330179347, 24.8206812912194, 0.000928044319152832],
    [118.525902050537, 24.8212886714062, 0.000928121618926525],
  ],
  [
    [118.526313438829, 24.8206714617697, 0.000928043387830257],
    [118.525885517873, 24.8212789680525, 0.000928121618926525],
  ],
  [
    [118.526296688435, 24.8206616413575, 0.000928043387830257],
    [118.525868985223, 24.8212692737246, 0.000928120687603951],
  ],
  [
    [118.526279938044, 24.8206518209433, 0.000928042456507683],
    [118.525852442685, 24.8212595794065, 0.000928118824958801],
  ],
  [
    [118.526263177776, 24.8206420095665, 0.000928039662539959],
    [118.525835900149, 24.8212498850865, 0.000928116030991077],
  ],
  [
    [118.526246427403, 24.8206321981762, 0.00092803779989481],
    [118.525819347737, 24.821240199804, 0.000928116030991077],
  ],
  [
    [118.526229657262, 24.820622395835, 0.00092803779989481],
    [118.52580279534, 24.8212305235472, 0.000928114168345928],
  ],
  [
    [118.526212897015, 24.8206125934801, 0.00092803593724966],
    [118.525786242946, 24.8212208472886, 0.000928113237023354],
  ],
  [
    [118.526196126893, 24.8206028001627, 0.00092803593724966],
    [118.525769690554, 24.8212111710281, 0.000928112305700779],
  ],
  [
    [118.526179356785, 24.820593015871, 0.00092803593724966],
    [118.525753128286, 24.8212015038051, 0.00092811044305563],
  ],
  [
    [118.526162576789, 24.8205832315891, 0.000928033143281937],
    [118.525736556142, 24.8211918456194, 0.00092811044305563],
  ],
  [
    [118.526145806686, 24.8205734472936, 0.000928031280636787],
    [118.525719993892, 24.8211821874203, 0.000928107649087906],
  ],
  [
    [118.526129016817, 24.8205636720472, 0.000928031280636787],
    [118.525703421766, 24.8211725382586, 0.000928107649087906],
  ],
  [
    [118.526112236854, 24.8205539058148, 0.000928029417991638],
    [118.525686849642, 24.821162889095, 0.000928105786442757],
  ],
  [
    [118.526095447002, 24.8205441395922, 0.000928027555346489],
    [118.525670267642, 24.8211532489689, 0.000928104855120182],
  ],
  [
    [118.526078657165, 24.8205343823953, 0.000928026624023914],
    [118.525653685645, 24.8211436088408, 0.000928102992475033],
  ],
  [
    [118.52606185744, 24.8205246252082, 0.000928026624023914],
    [118.525637103662, 24.8211339777386, 0.000928102061152458],
  ],
  [
    [118.52604505773, 24.8205148770468, 0.00092802383005619],
    [118.525620511804, 24.8211243556738, 0.000928101129829884],
  ],
  [
    [118.526028258023, 24.8205051288835, 0.000928022898733616],
    [118.525603919935, 24.8211147245794, 0.000928101129829884],
  ],
  [
    [118.526011448439, 24.8204953897575, 0.000928021036088467],
    [118.525587328095, 24.8211051115385, 0.000928099267184734],
  ],
  [
    [118.525994638858, 24.8204856506297, 0.000928021036088467],
    [118.525570736256, 24.8210954984957, 0.00092809833586216],
  ],
  [
    [118.525977829293, 24.8204759205276, 0.000928019173443317],
    [118.525554134529, 24.8210858854627, 0.000928097404539585],
  ],
  [
    [118.525961009851, 24.8204661994628, 0.000928019173443317],
    [118.525537522926, 24.821076281467, 0.000928096473217011],
  ],
  [
    [118.525944200304, 24.8204564783845, 0.000928018242120743],
    [118.525520921229, 24.8210666864856, 0.000928094610571861],
  ],
  [
    [118.525927370976, 24.8204467573276, 0.000928015448153019],
    [118.525504309644, 24.8210570915138, 0.000928092747926712],
  ],
  [
    [118.525910551555, 24.8204370452848, 0.000928014516830444],
    [118.525487698074, 24.8210475055679, 0.000928092747926712],
  ],
  [
    [118.525893722257, 24.8204273422793, 0.000928014516830444],
    [118.525471076614, 24.8210379196317, 0.000928091816604137],
  ],
  [
    [118.525876883071, 24.8204176392835, 0.000928012654185295],
    [118.525454455157, 24.8210283336936, 0.000928089022636414],
  ],
  [
    [118.525860053792, 24.8204079453019, 0.000928010791540146],
    [118.525437833729, 24.8210187658089, 0.000928089022636414],
  ],
  [
    [118.525843214624, 24.8203982513299, 0.000928007997572422],
    [118.525421202398, 24.8210091889063, 0.00092808622866869],
  ],
  [
    [118.52582636558, 24.8203885663954, 0.000928007066249847],
    [118.525404571096, 24.8209996300572, 0.000928087159991264],
  ],
  [
    [118.52580952643, 24.8203788814472, 0.000928007066249847],
    [118.525387939783, 24.8209900621785, 0.000928085297346115],
  ],
  [
    [118.525792677403, 24.8203692055364, 0.000928007066249847],
    [118.525371298607, 24.8209805123649, 0.000928083434700966],
  ],
  [
    [118.525775818488, 24.8203595296353, 0.000928004272282124],
    [118.525354657433, 24.8209709625493, 0.000928082503378391],
  ],
  [
    [118.525758959588, 24.82034986276, 0.000928003340959549],
    [118.525338016262, 24.8209614127319, 0.000928079709410667],
  ],
  [
    [118.525742100691, 24.8203401958827, 0.000928002409636974],
    [118.525321365214, 24.8209518719519, 0.000928079709410667],
  ],
  [
    [118.525725241809, 24.8203305380312, 0.000928000546991825],
    [118.525304714169, 24.82094233117, 0.000928079709410667],
  ],
  [
    [118.525708373051, 24.820320889217, 0.000927998684346676],
    [118.52528806314, 24.8209327994139, 0.000928076915442944],
  ],
  [
    [118.525691504296, 24.8203112404008, 0.00092799961566925],
    [118.525271402234, 24.8209232766951, 0.000928076915442944],
  ],
  [
    [118.525674635543, 24.8203015915828, 0.000927996821701527],
    [118.52525474133, 24.8209137539744, 0.000928075052797794],
  ],
  [
    [118.525657756926, 24.8202919608297, 0.000927995890378952],
    [118.525238080429, 24.8209042312519, 0.00092807412147522],
  ],
  [
    [118.5256408783, 24.820282321047, 0.000927994027733803],
    [118.525221409665, 24.8208947265944, 0.000928072258830071],
  ],
  [
    [118.525623999689, 24.8202726902901, 0.000927994027733803],
    [118.52520473889, 24.8208852129073, 0.000928071327507496],
  ],
  [
    [118.525607111202, 24.8202630685705, 0.000927992165088654],
    [118.525188068131, 24.820875708246, 0.000928070396184921],
  ],
  [
    [118.52559022273, 24.8202534558766, 0.000927991233766079],
    [118.525171387495, 24.8208662126221, 0.000928068533539772],
  ],
  [
    [118.525573324356, 24.8202438341648, 0.000927991233766079],
    [118.525154706862, 24.8208567169963, 0.000928067602217197],
  ],
  [
    [118.525556435902, 24.8202342304947, 0.00092798937112093],
    [118.525138026244, 24.8208472303962, 0.000928065739572048],
  ],
  [
    [118.525539527668, 24.8202246268459, 0.000927988439798355],
    [118.525121345628, 24.8208377437943, 0.000928063876926899],
  ],
  [
    [118.525522629328, 24.8202150231836, 0.000927988439798355],
    [118.525104655136, 24.8208282662297, 0.000928063876926899],
  ],
  [
    [118.525505721111, 24.8202054285585, 0.000927985645830631],
    [118.525087954768, 24.8208187977025, 0.000928062945604324],
  ],
  [
    [118.52548881291, 24.8201958429592, 0.000927984714508057],
    [118.525071264281, 24.8208093201341, 0.00092806201428175],
  ],
  [
    [118.525471904711, 24.820186257358, 0.000927983783185482],
    [118.525054563931, 24.8207998606308, 0.00092806201428175],
  ],
  [
    [118.525454986624, 24.8201766717664, 0.000927981920540333],
    [118.525037853692, 24.8207904011371, 0.000928059220314026],
  ],
  [
    [118.525438068552, 24.8201670952006, 0.000927979126572609],
    [118.525021153346, 24.8207809416299, 0.000928058288991451],
  ],
  [
    [118.525421140603, 24.820157527672, 0.000927979126572609],
    [118.525004443125, 24.8207714911601, 0.000928057357668877],
  ],
  [
    [118.525404222549, 24.8201479601299, 0.000927978195250034],
    [118.524987723027, 24.8207620497276, 0.000928056426346302],
  ],
  [
    [118.525387284727, 24.8201384016368, 0.00092797726392746],
    [118.524971012823, 24.8207526082817, 0.000928054563701153],
  ],
  [
    [118.525370356799, 24.8201288431301, 0.00092797540128231],
    [118.524954292743, 24.8207431758731, 0.000928054563701153],
  ],
  [
    [118.525353418995, 24.8201192936606, 0.000927974469959736],
    [118.524937562773, 24.8207337434741, 0.000928052701056004],
  ],
  [
    [118.525336481207, 24.8201097532169, 0.000927973538637161],
    [118.524920842711, 24.8207243200894, 0.000928050838410854],
  ],
  [
    [118.525319533529, 24.8201002127829, 0.000927972607314587],
    [118.524904112759, 24.8207148967143, 0.000928050838410854],
  ],
  [
    [118.525302595745, 24.8200906723353, 0.000927970744669437],
    [118.524887382823, 24.820705482365, 0.000928048975765705],
  ],
  [
    [118.525285648086, 24.820081140925, 0.000927968882024288],
    [118.524870642998, 24.8206960680254, 0.000928047113120556],
  ],
  [
    [118.52526869055, 24.820071618552, 0.000927967950701714],
    [118.524853903187, 24.8206866627115, 0.000928046181797981],
  ],
  [
    [118.525251733016, 24.8200620961771, 0.000927967019379139],
    [118.52483716338, 24.8206772573957, 0.000928045250475407],
  ],
  [
    [118.525234775486, 24.8200525738002, 0.000927966088056564],
    [118.524820413696, 24.8206678611172, 0.000928043387830257],
  ],
  [
    [118.525217817983, 24.8200430694767, 0.000927964225411415],
    [118.524803664027, 24.8206584738645, 0.000928041525185108],
  ],
  [
    [118.525200850578, 24.8200335561352, 0.00092796329408884],
    [118.524786914361, 24.8206490866099, 0.000928039662539959],
  ],
  [
    [118.525183883202, 24.820024060847, 0.000927962362766266],
    [118.524770154806, 24.8206396993649, 0.000928039662539959],
  ],
  [
    [118.525166905924, 24.8200145565408, 0.000927960500121117],
    [118.524753395266, 24.8206303211457, 0.00092803779989481],
  ],
  [
    [118.525149928674, 24.820005070288, 0.000927959568798542],
    [118.524736635741, 24.8206209519522, 0.000928036868572235],
  ],
  [
    [118.525132951426, 24.8199955840332, 0.000927959568798542],
    [118.524719876218, 24.8206115827569, 0.00092803779989481],
  ],
  [
    [118.525115974181, 24.8199860977764, 0.000927958637475967],
    [118.524703106819, 24.8206022225988, 0.000928035005927086],
  ],
  [
    [118.52509898706, 24.819976620557, 0.000927955843508244],
    [118.524686327532, 24.8205928624504, 0.000928034074604511],
  ],
  [
    [118.525081999955, 24.8199671523632, 0.000927955843508244],
    [118.524669558151, 24.8205835113162, 0.000928031280636787],
  ],
  [
    [118.52506500296, 24.8199576841791, 0.000927953980863094],
    [118.524652778881, 24.8205741601916, 0.000928031280636787],
  ],
  [
    [118.525048015859, 24.8199482159814, 0.00092795304954052],
    [118.524635999626, 24.8205648180928, 0.000928029417991638],
  ],
  [
    [118.525031008991, 24.8199387568326, 0.000927952118217945],
    [118.524619210482, 24.8205554760036, 0.000928030349314213],
  ],
  [
    [118.525014012029, 24.8199293066979, 0.000927950255572796],
    [118.524602421353, 24.8205461429402, 0.000928026624023914],
  ],
  [
    [118.524997005179, 24.8199198565728, 0.000927950255572796],
    [118.524585632227, 24.8205368098748, 0.000928027555346489],
  ],
  [
    [118.524979998343, 24.8199104154734, 0.000927947461605072],
    [118.524568833224, 24.8205274858467, 0.00092802569270134],
  ],
  [
    [118.524962991511, 24.819900974372, 0.000927946530282497],
    [118.524552044128, 24.8205181708329, 0.00092802383005619],
  ],
  [
    [118.524945974802, 24.8198915423079, 0.000927946530282497],
    [118.524535235252, 24.8205088558402, 0.00092802569270134],
  ],
  [
    [118.524928958108, 24.8198821192695, 0.000927945598959923],
    [118.524518436269, 24.8204995408341, 0.000928022898733616],
  ],
  [
    [118.524911931525, 24.8198726962408, 0.000927943736314774],
    [118.524501627411, 24.8204902348652, 0.000928021967411041],
  ],
  [
    [118.524894904945, 24.81986327321, 0.000927941873669624],
    [118.524484818567, 24.8204809379221, 0.000928020104765892],
  ],
  [
    [118.52487787838, 24.819853859205, 0.00092794094234705],
    [118.524467999834, 24.8204716409886, 0.000928018242120743],
  ],
  [
    [118.524860851831, 24.8198444542256, 0.0009279390797019],
    [118.524451191008, 24.8204623530693, 0.000928018242120743],
  ],
  [
    [118.524843815392, 24.8198350492558, 0.0009279390797019],
    [118.524434362402, 24.8204530651712, 0.000928015448153019],
  ],
  [
    [118.524826778969, 24.8198256533117, 0.000927937217056751],
    [118.524417543702, 24.8204437862872, 0.000928015448153019],
  ],
  [
    [118.524809732657, 24.8198162573773, 0.000927936285734177],
    [118.524400715113, 24.8204345074129, 0.00092801358550787],
  ],
  [
    [118.524792696252, 24.8198068704569, 0.000927935354411602],
    [118.524383886539, 24.8204252375644, 0.000928012654185295],
  ],
  [
    [118.524775649957, 24.8197974835461, 0.000927933491766453],
    [118.52436705798, 24.8204159767415, 0.000928012654185295],
  ],
  [
    [118.524758593787, 24.8197881056726, 0.000927932560443878],
    [118.52435021952, 24.8204067069006, 0.000928008928894997],
  ],
  [
    [118.524741537619, 24.8197787277971, 0.000927927903831005],
    [118.524333381088, 24.8203974551131, 0.000928008928894997],
  ],
  [
    [118.524724481466, 24.8197693589473, 0.00092792883515358],
    [118.524316532766, 24.8203882033353, 0.000928008928894997],
  ],
  [
    [118.524707425328, 24.8197599991232, 0.00092792883515358],
    [118.52429968446, 24.8203789605831, 0.000928005203604698],
  ],
  [
    [118.524690359302, 24.8197506393087, 0.00092792697250843],
    [118.524282836156, 24.820369717829, 0.000928006134927273],
  ],
  [
    [118.524673293278, 24.8197412794921, 0.00092792697250843],
    [118.524265987854, 24.820360475073, 0.000928005203604698],
  ],
  [
    [118.524656227269, 24.8197319287013, 0.000927925109863281],
    [118.524249129677, 24.8203512413543, 0.000928004272282124],
  ],
  [
    [118.524639151384, 24.8197225869477, 0.000927924178540707],
    [118.524232271514, 24.8203420166613, 0.000928003340959549],
  ],
  [
    [118.524622075502, 24.8197132451921, 0.000927922315895557],
    [118.524215413354, 24.8203327919663, 0.000928000546991825],
  ],
  [
    [118.524604989743, 24.8197039124738, 0.000927922315895557],
    [118.524198545317, 24.8203235763087, 0.000928000546991825],
  ],
  [
    [118.524587913879, 24.8196945797419, 0.000927922315895557],
    [118.524181677283, 24.820314360649, 0.000928000546991825],
  ],
  [
    [118.524570828138, 24.8196852560473, 0.000927919521927834],
    [118.524164809264, 24.8203051540152, 0.000927997753024101],
  ],
  [
    [118.524553732508, 24.8196759323622, 0.000927918590605259],
    [118.524147931369, 24.8202959564185, 0.000927996821701527],
  ],
  [
    [118.524536646785, 24.8196666176913, 0.00092791672796011],
    [118.524131053476, 24.82028675882, 0.000927994959056377],
  ],
  [
    [118.524519551185, 24.8196573120576, 0.000927915796637535],
    [118.524114175585, 24.8202775612195, 0.000927994027733803],
  ],
  [
    [118.524502445697, 24.8196480064334, 0.000927915796637535],
    [118.524097287819, 24.8202683726562, 0.000927992165088654],
  ],
  [
    [118.524485350115, 24.8196387098234, 0.000927913933992386],
    [118.524080400067, 24.8202591931187, 0.000927991233766079],
  ],
  [
    [118.524468244645, 24.8196294132229, 0.000927912071347237],
    [118.524063512318, 24.8202500135792, 0.000927990302443504],
  ],
  [
    [118.524451129285, 24.819620116632, 0.000927911140024662],
    [118.524046614679, 24.8202408340493, 0.00092798937112093],
  ],
  [
    [118.524434023845, 24.8196108380829, 0.000927908346056938],
    [118.524029717069, 24.8202316725728, 0.000927988439798355],
  ],
  [
    [118.524416908504, 24.8196015505157, 0.000927909277379513],
    [118.524012819448, 24.8202225020667, 0.000927988439798355],
  ],
  [
    [118.524399783298, 24.8195922810133, 0.000927907414734364],
    [118.523995921855, 24.820213349614, 0.000927985645830631],
  ],
  [
    [118.524382667974, 24.8195830024698, 0.000927906483411789],
    [118.523979014361, 24.8202041881432, 0.000927985645830631],
  ],
  [
    [118.524365542787, 24.8195737419911, 0.00092790462076664],
    [118.523962097002, 24.8201950447373, 0.000927984714508057],
  ],
  [
    [118.524348417601, 24.8195644815105, 0.000927903689444065],
    [118.523945189538, 24.8201859013179, 0.000927982851862907],
  ],
  [
    [118.524331282527, 24.8195552210393, 0.000927901826798916],
    [118.523928272184, 24.8201767579081, 0.000927981920540333],
  ],
  [
    [118.524314147469, 24.8195459695939, 0.000927900895476341],
    [118.523911354846, 24.820167623524, 0.000927980057895184],
  ],
  [
    [118.524297012425, 24.8195367271741, 0.000927900895476341],
    [118.523894427619, 24.8201584891495, 0.000927980057895184],
  ],
  [
    [118.524279867492, 24.8195274847639, 0.000927899964153767],
    [118.523877510298, 24.8201493637892, 0.00092797726392746],
  ],
  [
    [118.524262722575, 24.8195182513793, 0.000927897170186043],
    [118.523860573209, 24.8201402474776, 0.000927978195250034],
  ],
  [
    [118.52424557766, 24.8195090179927, 0.000927898101508617],
    [118.523843646014, 24.8201311311526, 0.00092797540128231],
  ],
  [
    [118.524228422869, 24.8194997936433, 0.000927896238863468],
    [118.523826708943, 24.8201220238648, 0.000927974469959736],
  ],
  [
    [118.524211277972, 24.8194905692805, 0.000927895307540894],
    [118.523809771874, 24.820112916575, 0.000927971675992012],
  ],
  [
    [118.524194113307, 24.8194813539663, 0.000927893444895744],
    [118.523792834821, 24.8201038183109, 0.000927971675992012],
  ],
  [
    [118.524176958536, 24.8194721386386, 0.00092789251357317],
    [118.523775887878, 24.8200947200565, 0.000927971675992012],
  ],
  [
    [118.524159793889, 24.819462932348, 0.00092789065092802],
    [118.52375894095, 24.8200856308277, 0.000927969813346863],
  ],
  [
    [118.524142629257, 24.8194537350832, 0.000927889719605446],
    [118.523741994025, 24.8200765415969, 0.000927969813346863],
  ],
  [
    [118.524125454736, 24.8194445378279, 0.000927889719605446],
    [118.523725037224, 24.8200674614034, 0.000927967950701714],
  ],
  [
    [118.524108290121, 24.8194353495867, 0.000927888788282871],
    [118.523708080437, 24.8200583902356, 0.000927967019379139],
  ],
  [
    [118.524091105726, 24.8194261613665, 0.000927886925637722],
    [118.523691113761, 24.8200493190773, 0.00092796515673399],
  ],
  [
    [118.524073931238, 24.8194169821605, 0.000927884131669998],
    [118.52367415698, 24.8200402479056, 0.000927964225411415],
  ],
  [
    [118.524056746861, 24.819407802964, 0.000927884131669998],
    [118.523657190322, 24.8200311857711, 0.000927962362766266],
  ],
  [
    [118.524039562499, 24.8193986327932, 0.000927883200347424],
    [118.523640223679, 24.8200221326623, 0.000927960500121117],
  ],
  [
    [118.52402237814, 24.8193894626203, 0.000927883200347424],
    [118.523623247147, 24.820013079563, 0.000927962362766266],
  ],
  [
    [118.524005183904, 24.8193803014846, 0.000927882269024849],
    [118.52360627063, 24.8200040354894, 0.000927960500121117],
  ],
  [
    [118.523987989671, 24.8193711403469, 0.0009278804063797],
    [118.523589294115, 24.8199949914139, 0.000927958637475967],
  ],
  [
    [118.523970785561, 24.8193619882464, 0.00092787854373455],
    [118.523572307724, 24.8199859563756, 0.000927957706153393],
  ],
  [
    [118.523953591358, 24.8193528451601, 0.00092787854373455],
    [118.523555321336, 24.8199769213353, 0.000927956774830818],
  ],
  [
    [118.523936387266, 24.8193437020832, 0.000927875749766827],
    [118.523538334962, 24.8199678953207, 0.000927954912185669],
  ],
  [
    [118.523919173298, 24.8193345680435, 0.000927874818444252],
    [118.523521348591, 24.8199588693041, 0.000927953980863094],
  ],
  [
    [118.523901969224, 24.8193254339903, 0.000927874818444252],
    [118.523504352344, 24.8199498523248, 0.00092795304954052],
  ],
  [
    [118.523884755274, 24.8193163089742, 0.000927873887121677],
    [118.523487356111, 24.8199408443711, 0.000927952118217945],
  ],
  [
    [118.523867531434, 24.8193071839676, 0.000927872024476528],
    [118.52347034999, 24.8199318364269, 0.00092795118689537],
  ],
  [
    [118.523850317501, 24.8192980679752, 0.000927870161831379],
    [118.523453353762, 24.8199228284694, 0.000927948392927647],
  ],
  [
    [118.523833093679, 24.8192889519923, 0.000927869230508804],
    [118.523436337767, 24.8199138295604, 0.000927948392927647],
  ],
  [
    [118.523815859981, 24.8192798450465, 0.00092786829918623],
    [118.523419331678, 24.8199048396657, 0.000927946530282497],
  ],
  [
    [118.52379863619, 24.8192707471148, 0.00092786829918623],
    [118.5234023157, 24.8198958497805, 0.000927945598959923],
  ],
  [
    [118.523781402509, 24.8192616491927, 0.000927864573895931],
    [118.523385299737, 24.819886868921, 0.000927944667637348],
  ],
  [
    [118.523764168831, 24.8192525512685, 0.000927864573895931],
    [118.523368283776, 24.8198778880595, 0.000927944667637348],
  ],
  [
    [118.523746925289, 24.8192434714091, 0.000927864573895931],
    [118.523351257939, 24.8198689162352, 0.000927941873669624],
  ],
  [
    [118.523729681738, 24.8192343825201, 0.000927862711250782],
    [118.523334232117, 24.8198599534366, 0.00092794094234705],
  ],
  [
    [118.523712438213, 24.8192253116844, 0.000927860848605633],
    [118.523317206298, 24.8198509906361, 0.000927940011024475],
  ],
  [
    [118.523695194679, 24.819216231819, 0.000927859917283058],
    [118.523300170589, 24.819842027845, 0.000927938148379326],
  ],
  [
    [118.523677941281, 24.8192071700183, 0.000927859917283058],
    [118.523283134896, 24.8198330740796, 0.000927937217056751],
  ],
  [
    [118.523660687886, 24.8191981082157, 0.00092785619199276],
    [118.523266099217, 24.8198241293399, 0.000927936285734177],
  ],
  [
    [118.523643424601, 24.8191890464225, 0.000927857123315334],
    [118.523249063541, 24.8198151845983, 0.000927935354411602],
  ],
  [
    [118.523626161332, 24.819179993655, 0.000927855260670185],
    [118.523232017976, 24.8198062398661, 0.000927936285734177],
  ],
  [
    [118.523608898078, 24.8191709499131, 0.00092785432934761],
    [118.523214972438, 24.8197973131873, 0.000927934423089027],
  ],
  [
    [118.523591634826, 24.8191619061692, 0.00092785432934761],
    [118.523197916999, 24.8197883774903, 0.000927931629121304],
  ],
  [
    [118.523574361698, 24.8191528714624, 0.000927851535379887],
    [118.523180861587, 24.8197794598467, 0.000927931629121304],
  ],
  [
    [118.523557088573, 24.8191438367536, 0.000927851535379887],
    [118.523163806165, 24.8197705331734, 0.000927929766476154],
  ],
  [
    [118.523539815462, 24.8191348110705, 0.000927849672734737],
    [118.523146750771, 24.8197616245535, 0.00092792883515358],
  ],
  [
    [118.523522532463, 24.8191257853968, 0.000927849672734737],
    [118.523129685488, 24.8197527159431, 0.000927927903831005],
  ],
  [
    [118.523505249478, 24.8191167687487, 0.000927846878767014],
    [118.523112620207, 24.8197438073307, 0.000927927903831005],
  ],
  [
    [118.523487966497, 24.8191077520986, 0.000927845947444439],
    [118.523095554941, 24.8197349077439, 0.000927925109863281],
  ],
  [
    [118.523470673638, 24.8190987444856, 0.000927845016121864],
    [118.523078479799, 24.8197260171943, 0.000927924178540707],
  ],
  [
    [118.523453380795, 24.8190897458982, 0.000927843153476715],
    [118.523061404659, 24.8197171266428, 0.000927924178540707],
  ],
  [
    [118.523436087955, 24.8190807473089, 0.000927843153476715],
    [118.523044329534, 24.8197082451169, 0.000927923247218132],
  ],
  [
    [118.523418785225, 24.8190717487289, 0.000927841290831566],
    [118.52302724452, 24.8196993636005, 0.000927922315895557],
  ],
  [
    [118.523401482523, 24.8190627682023, 0.000927839428186417],
    [118.523010159508, 24.8196904820821, 0.000927919521927834],
  ],
  [
    [118.523384179811, 24.819053778646, 0.000927840359508991],
    [118.522993074524, 24.8196816186171, 0.000927918590605259],
  ],
  [
    [118.523366877127, 24.8190448071429, 0.000927838496863842],
    [118.522975979651, 24.8196727551615, 0.000927918590605259],
  ],
  [
    [118.523349564554, 24.8190358356493, 0.000927836634218693],
    [118.52295888478, 24.8196638917039, 0.00092791672796011],
  ],
  [
    [118.523332251983, 24.8190268641537, 0.000927835702896118],
    [118.522941789925, 24.819655037272, 0.000927915796637535],
  ],
  [
    [118.523314929536, 24.8190179016952, 0.000927836634218693],
    [118.522924695071, 24.8196461828382, 0.00092791486531496],
  ],
  [
    [118.523297607091, 24.8190089392346, 0.000927832908928394],
    [118.522907590342, 24.8196373374414, 0.00092791486531496],
  ],
  [
    [118.523280284674, 24.8189999948273, 0.000927832908928394],
    [118.522890485627, 24.8196285010704, 0.000927912071347237],
  ],
  [
    [118.523262962247, 24.8189910413903, 0.000927832908928394],
    [118.522873380914, 24.8196196646973, 0.000927911140024662],
  ],
  [
    [118.523245629943, 24.8189820969904, 0.00092783011496067],
    [118.522856266325, 24.8196108373614, 0.000927909277379513],
  ],
  [
    [118.523228297655, 24.8189731616162, 0.000927829183638096],
    [118.522839151739, 24.8196020100235, 0.000927909277379513],
  ],
  [
    [118.523210965369, 24.8189642262399, 0.000927827320992947],
    [118.522822027276, 24.8195931917227, 0.000927907414734364],
  ],
  [
    [118.523193623206, 24.8189552999007, 0.000927826389670372],
    [118.522804912707, 24.8195843734084, 0.000927907414734364],
  ],
  [
    [118.523176281059, 24.8189463825871, 0.000927825458347797],
    [118.522787788261, 24.8195755641313, 0.00092790462076664],
  ],
  [
    [118.523158938914, 24.8189374652715, 0.000927824527025223],
    [118.522770663818, 24.8195667548522, 0.000927903689444065],
  ],
  [
    [118.52314158688, 24.8189285479652, 0.000927823595702648],
    [118.522753529498, 24.8195579546102, 0.00092790275812149],
  ],
  [
    [118.523124234861, 24.8189196396847, 0.000927822664380074],
    [118.522736395193, 24.8195491633938, 0.000927900895476341],
  ],
  [
    [118.523106882858, 24.8189107404297, 0.000927820801734924],
    [118.522719260891, 24.8195403721755, 0.000927901826798916],
  ],
  [
    [118.523089520965, 24.8189018411841, 0.000927820801734924],
    [118.522702116699, 24.8195315809666, 0.000927899964153767],
  ],
  [
    [118.523072168979, 24.8188929509527, 0.000927820801734924],
    [118.522684982414, 24.819522798772, 0.000927899032831192],
  ],
  [
    [118.523054797212, 24.8188840607422, 0.0009278180077672],
    [118.522667828361, 24.8195140256259, 0.000927897170186043],
  ],
  [
    [118.523037435352, 24.8188751795458, 0.000927817076444626],
    [118.522650684202, 24.8195052524663, 0.000927896238863468],
  ],
  [
    [118.523020063603, 24.8188662983589, 0.000927815213799477],
    [118.522633530166, 24.8194964883439, 0.000927895307540894],
  ],
  [
    [118.523002691869, 24.8188574261975, 0.000927814282476902],
    [118.522616376133, 24.8194877242194, 0.000927893444895744],
  ],
  [
    [118.52298532015, 24.8188485630618, 0.000927814282476902],
    [118.522599222115, 24.8194789691206, 0.000927893444895744],
  ],
  [
    [118.522967938542, 24.8188396999355, 0.000927812419831753],
    [118.52258205822, 24.8194702230589, 0.000927893444895744],
  ],
  [
    [118.522950556936, 24.8188308368071, 0.000927811488509178],
    [118.522564894327, 24.8194614769952, 0.00092789065092802],
  ],
  [
    [118.522933175346, 24.8188219827043, 0.000927811488509178],
    [118.522547730437, 24.8194527309296, 0.00092789251357317],
  ],
  [
    [118.522915783879, 24.8188131376386, 0.000927809625864029],
    [118.52253055667, 24.8194439939009, 0.000927888788282871],
  ],
  [
    [118.522898392414, 24.8188042925709, 0.000927808694541454],
    [118.522513382919, 24.819435265898, 0.000927887856960297],
  ],
  [
    [118.522881000965, 24.8187954565287, 0.000927806831896305],
    [118.522496209169, 24.8194265378931, 0.000927885994315147],
  ],
  [
    [118.522863599626, 24.818786620496, 0.000927804969251156],
    [118.522479035435, 24.8194178189138, 0.000927884131669998],
  ],
  [
    [118.522846198303, 24.8187777934888, 0.000927804037928581],
    [118.522461851811, 24.8194090999439, 0.000927884131669998],
  ],
  [
    [118.522828796994, 24.8187689755073, 0.000927802175283432],
    [118.522444668203, 24.8194003899997, 0.000927885062992573],
  ],
  [
    [118.522811385797, 24.8187601575351, 0.000927803106606007],
    [118.522427474705, 24.8193916800649, 0.000927881337702274],
  ],
  [
    [118.522793984506, 24.8187513485771, 0.000927802175283432],
    [118.522410291114, 24.8193829791443, 0.000927882269024849],
  ],
  [
    [118.522776563434, 24.81874253964, 0.000927800312638283],
    [118.522393097633, 24.8193742782332, 0.000927881337702274],
  ],
  [
    [118.522759152257, 24.8187337306893, 0.000927798449993134],
    [118.522375894277, 24.8193655863591, 0.000927879475057125],
  ],
  [
    [118.522741731215, 24.8187249398033, 0.000927798449993134],
    [118.522358700826, 24.8193569034993, 0.00092787854373455],
  ],
  [
    [118.522724310177, 24.8187161489153, 0.000927796587347984],
    [118.522341497486, 24.8193482206488, 0.00092787854373455],
  ],
  [
    [118.52270688914, 24.8187073580252, 0.00092779565602541],
    [118.52232428427, 24.8193395468355, 0.000927875749766827],
  ],
  [
    [118.522689458227, 24.8186985761722, 0.000927794724702835],
    [118.522307080948, 24.8193308730087, 0.000927874818444252],
  ],
  [
    [118.522672027317, 24.8186897943171, 0.000927792862057686],
    [118.522289867749, 24.8193222082189, 0.000927874818444252],
  ],
  [
    [118.522654596421, 24.8186810214876, 0.000927791930735111],
    [118.522272654552, 24.8193135434272, 0.000927872024476528],
  ],
  [
    [118.522637155649, 24.8186722576951, 0.000927790999412537],
    [118.522255431479, 24.8193048876725, 0.000927870161831379],
  ],
  [
    [118.52261971488, 24.8186634939006, 0.000927790999412537],
    [118.5222382183, 24.8192962319044, 0.000927870161831379],
  ],
  [
    [118.522602274125, 24.8186547391317, 0.000927789136767387],
    [118.522220995244, 24.8192875851734, 0.000927870161831379],
  ],
  [
    [118.522584823482, 24.8186459843721, 0.000927787274122238],
    [118.522203762312, 24.8192789474794, 0.000927867367863655],
  ],
  [
    [118.522567382745, 24.8186372386267, 0.000927787274122238],
    [118.522186529382, 24.8192703097834, 0.000927867367863655],
  ],
  [
    [118.522549922227, 24.8186284929021, 0.000927786342799664],
    [118.522169296454, 24.8192616720854, 0.000927865505218506],
  ],
  [
    [118.522532471616, 24.8186197561916, 0.000927784480154514],
    [118.522152063541, 24.819253043413, 0.00092786643654108],
  ],
  [
    [118.522515011129, 24.8186110285182, 0.000927784480154514],
    [118.522134830643, 24.8192444237663, 0.000927863642573357],
  ],
  [
    [118.522497550643, 24.8186023008427, 0.00092778168618679],
    [118.522117587856, 24.8192358041289, 0.000927861779928207],
  ],
  [
    [118.522480090173, 24.8185935821928, 0.000927782617509365],
    [118.522100345084, 24.8192271935172, 0.000927858985960484],
  ],
  [
    [118.522462619814, 24.8185848635523, 0.00092778168618679],
    [118.522083092423, 24.8192185829149, 0.000927861779928207],
  ],
  [
    [118.52244514947, 24.8185761539373, 0.000927777960896492],
    [118.522065839777, 24.8192099813382, 0.000927858985960484],
  ],
  [
    [118.522427679128, 24.8185674443203, 0.000927778892219067],
    [118.522048587145, 24.8192013887872, 0.000927858054637909],
  ],
  [
    [118.52241019891, 24.8185587437403, 0.000927776098251343],
    [118.522031334516, 24.8191927962341, 0.00092785619199276],
  ],
  [
    [118.522392718694, 24.8185500431582, 0.000927776098251343],
    [118.522014071998, 24.8191842036904, 0.00092785619199276],
  ],
  [
    [118.522375238493, 24.8185413516017, 0.000927773304283619],
    [118.521996809495, 24.8191756201724, 0.00092785432934761],
  ],
  [
    [118.522357758308, 24.8185326690708, 0.000927774235606194],
    [118.521979547006, 24.81916704568, 0.000927853398025036],
  ],
  [
    [118.522340268233, 24.8185239865492, 0.000927772372961044],
    [118.521962274629, 24.819158471197, 0.000927852466702461],
  ],
  [
    [118.52232277816, 24.8185153040256, 0.00092777144163847],
    [118.521945002266, 24.8191499057396, 0.000927850604057312],
  ],
  [
    [118.522305278224, 24.8185066395666, 0.00092776957899332],
    [118.521927729906, 24.8191413402801, 0.000927850604057312],
  ],
  [
    [118.522287788169, 24.8184979660665, 0.00092776957899332],
    [118.521910447669, 24.8191327838577, 0.000927850604057312],
  ],
  [
    [118.52227028825, 24.818489310631, 0.000927768647670746],
    [118.521893175338, 24.8191242364496, 0.000927849672734737],
  ],
  [
    [118.522252778442, 24.8184806552048, 0.000927766785025597],
    [118.521875893118, 24.8191156890508, 0.000927846878767014],
  ],
  [
    [118.522235278528, 24.8184719997652, 0.000927765853703022],
    [118.52185860101, 24.8191071416613, 0.000927845947444439],
  ],
  [
    [118.522217768737, 24.8184633533626, 0.000927764922380447],
    [118.521841308916, 24.8190986032975, 0.000927845016121864],
  ],
  [
    [118.52220024907, 24.8184547159969, 0.000927763059735298],
    [118.521824016836, 24.8190900739594, 0.00092784408479929],
  ],
  [
    [118.522182739297, 24.8184460786178, 0.000927762128412724],
    [118.52180672476, 24.8190815446192, 0.00092784222215414],
  ],
  [
    [118.522165219634, 24.8184374412479, 0.000927763059735298],
    [118.521789422806, 24.819073024316, 0.00092784222215414],
  ],
  [
    [118.522147699999, 24.8184288219314, 0.000927759334445],
    [118.521772130747, 24.8190645039994, 0.000927841290831566],
  ],
  [
    [118.522130170476, 24.8184202026241, 0.000927760265767574],
    [118.521754818919, 24.8190559927312, 0.000927839428186417],
  ],
  [
    [118.522112650846, 24.8184115833033, 0.00092775747179985],
    [118.521737516985, 24.8190474814496, 0.000927839428186417],
  ],
  [
    [118.522095111448, 24.818402973031, 0.000927758403122425],
    [118.521720205175, 24.8190389792049, 0.000927838496863842],
  ],
  [
    [118.522077581944, 24.8183943627451, 0.000927755609154701],
    [118.521702893379, 24.8190304859859, 0.000927836634218693],
  ],
  [
    [118.522060042563, 24.8183857614962, 0.000927753746509552],
    [118.521685581586, 24.8190219927649, 0.000927833840250969],
  ],
  [
    [118.522042503197, 24.8183771692729, 0.000927754677832127],
    [118.521668259903, 24.8190134995533, 0.000927832908928394],
  ],
  [
    [118.522024963834, 24.8183685770475, 0.000927751883864403],
    [118.521650938248, 24.8190050243949, 0.000927832908928394],
  ],
  [
    [118.522007424486, 24.8183599938477, 0.000927751883864403],
    [118.521633616583, 24.8189965402068, 0.000927833840250969],
  ],
  [
    [118.521989875248, 24.8183514106572, 0.000927751883864403],
    [118.521616285053, 24.8189880740833, 0.00092783197760582],
  ],
  [
    [118.521972326026, 24.8183428364923, 0.000927750021219254],
    [118.521598953514, 24.8189795989302, 0.000927829183638096],
  ],
  [
    [118.521954766914, 24.8183342623367, 0.000927748158574104],
    [118.521581622002, 24.8189711418303, 0.000927831046283245],
  ],
  [
    [118.521937207818, 24.8183256972066, 0.000927748158574104],
    [118.5215642806, 24.8189626847398, 0.000927827320992947],
  ],
  [
    [118.521919648736, 24.8183171411021, 0.000927746295928955],
    [118.521546949093, 24.8189542276359, 0.000927828252315521],
  ],
  [
    [118.521902089657, 24.8183085849955, 0.000927746295928955],
    [118.521529597817, 24.8189457795803, 0.000927826389670372],
  ],
  [
    [118.521884520701, 24.8183000379259, 0.000927744433283806],
    [118.521512256448, 24.818937340539, 0.000927825458347797],
  ],
  [
    [118.521866951748, 24.8182914908541, 0.000927743501961231],
    [118.521494905189, 24.818928901507, 0.000927824527025223],
  ],
  [
    [118.521849382809, 24.818282952808, 0.000927742570638657],
    [118.521477553945, 24.8189204715006, 0.000927822664380074],
  ],
  [
    [118.521831803981, 24.8182744147711, 0.000927739776670933],
    [118.521460202704, 24.8189120414922, 0.000927820801734924],
  ],
  [
    [118.521814225169, 24.8182658857598, 0.000927738845348358],
    [118.521442851477, 24.8189036205094, 0.000927820801734924],
  ],
  [
    [118.521796646359, 24.8182573567464, 0.000927737914025784],
    [118.521425490362, 24.8188951995359, 0.000927818939089775],
  ],
  [
    [118.521779067563, 24.8182488367586, 0.000927737914025784],
    [118.521408129261, 24.818886787588, 0.0009278180077672],
  ],
  [
    [118.521761478891, 24.8182403258077, 0.000927736982703209],
    [118.521390758271, 24.8188783756494, 0.000927817076444626],
  ],
  [
    [118.521743890222, 24.8182318148547, 0.000927736051380634],
    [118.521373387296, 24.8188699727365, 0.000927815213799477],
  ],
  [
    [118.521726301567, 24.8182233129273, 0.00092773512005806],
    [118.521356016335, 24.8188615788491, 0.000927816145122051],
  ],
  [
    [118.521708703024, 24.8182148110092, 0.00092773325741291],
    [118.521338645377, 24.8188531849598, 0.000927813351154327],
  ],
  [
    [118.521691104495, 24.8182063181166, 0.00092773325741291],
    [118.521321264542, 24.8188448001073, 0.000927812419831753],
  ],
  [
    [118.521673505969, 24.8181978252219, 0.000927731394767761],
    [118.521303893601, 24.8188364152415, 0.000927812419831753],
  ],
  [
    [118.521655897566, 24.8181893413641, 0.000927731394767761],
    [118.521286502892, 24.818828039424, 0.000927810557186604],
  ],
  [
    [118.521638289178, 24.8181808665319, 0.000927730463445187],
    [118.521269122077, 24.8188196635931, 0.000927809625864029],
  ],
  [
    [118.521620680792, 24.8181723916977, 0.000927729532122612],
    [118.521251731385, 24.8188112967992, 0.000927809625864029],
  ],
  [
    [118.521603072421, 24.8181639258889, 0.000927727669477463],
    [118.521234340707, 24.8188029390308, 0.000927808694541454],
  ],
  [
    [118.521585454161, 24.8181554600894, 0.000927726738154888],
    [118.521216950032, 24.8187945812605, 0.000927806831896305],
  ],
  [
    [118.521567835904, 24.8181469942879, 0.000927724875509739],
    [118.521199549468, 24.8187862234994, 0.00092780590057373],
  ],
  [
    [118.521550207782, 24.8181385465509, 0.000927724875509739],
    [118.521182148919, 24.8187778747639, 0.000927804969251156],
  ],
  [
    [118.521532589555, 24.8181300988004, 0.00092772301286459],
    [118.521164748384, 24.818769535054, 0.000927804037928581],
  ],
  [
    [118.521514961438, 24.8181216510592, 0.00092772301286459],
    [118.521147337961, 24.8187611953534, 0.000927803106606007],
  ],
  [
    [118.521497333336, 24.8181132123436, 0.00092772115021944],
    [118.521129927552, 24.8187528646784, 0.000927801243960857],
  ],
  [
    [118.521479695358, 24.8181047826648, 0.000927719287574291],
    [118.521112517145, 24.8187445340014, 0.000927800312638283],
  ],
  [
    [118.521462057381, 24.818096352984, 0.000927720218896866],
    [118.521095106753, 24.8187362123499, 0.000927798449993134],
  ],
  [
    [118.52144441942, 24.8180879323287, 0.000927717424929142],
    [118.521077686485, 24.8187278997354, 0.000927798449993134],
  ],
  [
    [118.521426781461, 24.8180795116713, 0.000927718356251717],
    [118.521060266219, 24.8187195871189, 0.000927797518670559],
  ],
  [
    [118.521409133626, 24.8180711000508, 0.000927715562283993],
    [118.521042845955, 24.8187112745003, 0.000927794724702835],
  ],
  [
    [118.521391485793, 24.8180626884282, 0.000927715562283993],
    [118.521025415827, 24.8187029799462, 0.000927794724702835],
  ],
  [
    [118.521373837975, 24.8180542858311, 0.000927713699638844],
    [118.521007985688, 24.8186946763625, 0.000927794724702835],
  ],
  [
    [118.52135618028, 24.818045892271, 0.000927711836993694],
    [118.520990555565, 24.8186863818043, 0.000927791930735111],
  ],
  [
    [118.521338522587, 24.8180374987087, 0.000927711836993694],
    [118.520973115565, 24.8186780962831, 0.000927792862057686],
  ],
  [
    [118.521320864897, 24.8180291051443, 0.00092770904302597],
    [118.52095568547, 24.8186698197762, 0.000927790999412537],
  ],
  [
    [118.521303197343, 24.8180207296445, 0.000927708111703396],
    [118.520938245487, 24.8186615432785, 0.000927789136767387],
  ],
  [
    [118.52128553967, 24.8180123451035, 0.000927708111703396],
    [118.520920795615, 24.8186532667901, 0.000927788205444813],
  ],
  [
    [118.521267862242, 24.8180039786385, 0.000927707180380821],
    [118.520903355649, 24.818644999316, 0.000927787274122238],
  ],
  [
    [118.521250194707, 24.81799561216, 0.000927706249058247],
    [118.520885905806, 24.8186367408787, 0.000927788205444813],
  ],
  [
    [118.521232517283, 24.8179872456907, 0.000927706249058247],
    [118.520868446074, 24.8186284824508, 0.000927784480154514],
  ],
  [
    [118.521214839875, 24.8179788882469, 0.000927702523767948],
    [118.520850996248, 24.8186202330371, 0.000927785411477089],
  ],
  [
    [118.521197162481, 24.8179705398287, 0.000927702523767948],
    [118.520833536533, 24.8186119836327, 0.00092778354883194],
  ],
  [
    [118.521179485089, 24.8179621914084, 0.000927702523767948],
    [118.520816076833, 24.8186037432538, 0.000927782617509365],
  ],
  [
    [118.521161797821, 24.817953852025, 0.000927700661122799],
    [118.520798617135, 24.8185955028729, 0.000927782617509365],
  ],
  [
    [118.521144110555, 24.8179455126394, 0.000927699729800224],
    [118.52078114756, 24.8185872715289, 0.000927778892219067],
  ],
  [
    [118.521126413412, 24.8179371822908, 0.000927699729800224],
    [118.520763677987, 24.8185790401828, 0.000927778892219067],
  ],
  [
    [118.521108726163, 24.8179288519286, 0.000927697867155075],
    [118.520746208442, 24.81857082689, 0.000927778892219067],
  ],
  [
    [118.521091029038, 24.8179205306034, 0.000927696004509926],
    [118.520728728995, 24.8185626045788, 0.000927777029573917],
  ],
  [
    [118.521073322036, 24.817912218315, 0.000927696004509926],
    [118.520711249563, 24.8185543912932, 0.000927775166928768],
  ],
  [
    [118.521055624928, 24.8179039060132, 0.000927693210542202],
    [118.520693770146, 24.8185461870331, 0.000927776098251343],
  ],
  [
    [118.521037917943, 24.8178956027482, 0.000927692279219627],
    [118.520676290731, 24.818537982771, 0.000927775166928768],
  ],
  [
    [118.52102021096, 24.8178872994811, 0.000927692279219627],
    [118.520658801439, 24.8185297875458, 0.000927774235606194],
  ],
  [
    [118.521002494101, 24.8178790052508, 0.000927691347897053],
    [118.520641312161, 24.8185216013461, 0.00092777144163847],
  ],
  [
    [118.520984777245, 24.8178707110185, 0.000927689485251904],
    [118.520623822886, 24.8185134151444, 0.00092776957899332],
  ],
  [
    [118.520967060403, 24.8178624258117, 0.00092768669128418],
    [118.520606323722, 24.8185052289519, 0.00092776957899332],
  ],
  [
    [118.520949343575, 24.8178541496304, 0.000927688553929329],
    [118.520588824573, 24.818497051785, 0.00092776957899332],
  ],
  [
    [118.520931616859, 24.8178458734583, 0.000927685759961605],
    [118.520571325438, 24.8184888836437, 0.000927768647670746],
  ],
  [
    [118.520913890158, 24.8178376063117, 0.000927685759961605],
    [118.520553826306, 24.8184807155003, 0.000927766785025597],
  ],
  [
    [118.520896163459, 24.817829339163, 0.00092768482863903],
    [118.520536317297, 24.8184725563938, 0.000927764922380447],
  ],
  [
    [118.520878436774, 24.8178210810399, 0.000927683897316456],
    [118.52051880829, 24.8184643972853, 0.000927764922380447],
  ],
  [
    [118.520860700201, 24.8178128229259, 0.000927682034671307],
    [118.520501299298, 24.8184562472023, 0.000927763059735298],
  ],
  [
    [118.520842963642, 24.8178045738375, 0.000927681103348732],
    [118.520483780417, 24.8184480971285, 0.000927762128412724],
  ],
  [
    [118.520825217194, 24.8177963247582, 0.000927681103348732],
    [118.520466271441, 24.818439956069, 0.000927762128412724],
  ],
  [
    [118.520807480653, 24.8177880846932, 0.000927680172026157],
    [118.520448742698, 24.8184318240577, 0.000927761197090149],
  ],
  [
    [118.520789734235, 24.817779853665, 0.000927679240703583],
    [118.520431223848, 24.818423692033, 0.000927759334445],
  ],
  [
    [118.520771987819, 24.8177716226346, 0.000927678309381008],
    [118.520413695122, 24.8184155690452, 0.000927758403122425],
  ],
  [
    [118.520754231526, 24.8177634006411, 0.000927677378058434],
    [118.520396166397, 24.8184074460553, 0.00092775747179985],
  ],
  [
    [118.520736475236, 24.8177551786455, 0.000927675515413284],
    [118.520378637688, 24.818399332091, 0.000927756540477276],
  ],
  [
    [118.520718718961, 24.8177469656754, 0.000927675515413284],
    [118.520361108981, 24.8183912181246, 0.000927755609154701],
  ],
  [
    [118.5207009627, 24.8177387617308, 0.000927673652768135],
    [118.520343570397, 24.818383113195, 0.000927755609154701],
  ],
  [
    [118.52068319655, 24.8177305577954, 0.00092767272144556],
    [118.520326031827, 24.818375017291, 0.000927751883864403],
  ],
  [
    [118.520665430403, 24.8177223538579, 0.00092767272144556],
    [118.520308483369, 24.8183669213963, 0.000927751883864403],
  ],
  [
    [118.52064766427, 24.8177141589459, 0.000927670858800411],
    [118.520290934912, 24.8183588254994, 0.000927752815186977],
  ],
  [
    [118.520629888261, 24.8177059730707, 0.000927668996155262],
    [118.520273386471, 24.8183507386281, 0.000927750021219254],
  ],
  [
    [118.520612112254, 24.8176977871933, 0.000927668064832687],
    [118.520255838044, 24.8183426607824, 0.000927749089896679],
  ],
  [
    [118.520594336262, 24.8176896103415, 0.000927667133510113],
    [118.520238289619, 24.8183345829347, 0.000927749089896679],
  ],
  [
    [118.520576560284, 24.8176814425153, 0.000927667133510113],
    [118.520220731318, 24.8183265141237, 0.000927746295928955],
  ],
  [
    [118.520558774418, 24.8176732746981, 0.000927664339542389],
    [118.520203173031, 24.8183184543384, 0.00092774536460638],
  ],
  [
    [118.520540988554, 24.8176651068788, 0.000927663408219814],
    [118.520185604855, 24.8183103945622, 0.000927746295928955],
  ],
  [
    [118.520523202704, 24.8176569480851, 0.000927663408219814],
    [118.520168046572, 24.8183023347726, 0.00092774536460638],
  ],
  [
    [118.520505476254, 24.8176488253322, 0.000927659682929516],
    [118.520150419028, 24.8182942570045, 0.000927743501961231],
  ],
  [
    [118.520487789409, 24.817640729615, 0.000927661545574665],
    [118.520132732101, 24.8182861522188, 0.000927742570638657],
  ],
  [
    [118.520470112444, 24.8176326248569, 0.00092766061425209],
    [118.52011505508, 24.8182780564473, 0.000927741639316082],
  ],
  [
    [118.520452435482, 24.8176245200966, 0.000927659682929516],
    [118.520097378049, 24.8182699516461, 0.000927740707993507],
  ],
  [
    [118.520434758535, 24.8176164243618, 0.000927656888961792],
    [118.520079701033, 24.8182618558705, 0.000927739776670933],
  ],
  [
    [118.520417071686, 24.8176083196086, 0.000927656888961792],
    [118.520062014115, 24.8182537510763, 0.000927737914025784],
  ],
  [
    [118.520399394731, 24.8176002148419, 0.000927655957639217],
    [118.520044337091, 24.8182456462688, 0.000927737914025784],
  ],
  [
    [118.520381717791, 24.8175921191009, 0.000927654094994068],
    [118.520026660081, 24.8182375504868, 0.000927734188735485],
  ],
  [
    [118.52036404084, 24.81758401433, 0.000927653163671494],
    [118.520008983062, 24.818229445675, 0.00092773512005806],
  ],
  [
    [118.520346354013, 24.817575918596, 0.000927653163671494],
    [118.519991296153, 24.8182213408724, 0.000927734188735485],
  ],
  [
    [118.520328677067, 24.8175678138209, 0.000927652232348919],
    [118.51997361915, 24.8182132450841, 0.000927734188735485],
  ],
  [
    [118.520311000123, 24.8175597090437, 0.000927651301026344],
    [118.519955942138, 24.818205140266, 0.00092773325741291],
  ],
  [
    [118.520293323194, 24.8175516132921, 0.000927649438381195],
    [118.51993826514, 24.8181970444735, 0.000927730463445187],
  ],
  [
    [118.520275636364, 24.8175435085219, 0.00092764850705862],
    [118.51992057824, 24.8181889396624, 0.000927731394767761],
  ],
  [
    [118.520257959427, 24.8175354037384, 0.000927647575736046],
    [118.519902901234, 24.818180834838, 0.000927729532122612],
  ],
  [
    [118.520240282505, 24.8175273079804, 0.00092764850705862],
    [118.519885224243, 24.8181727390391, 0.000927727669477463],
  ],
  [
    [118.520222605573, 24.8175192031927, 0.000927645713090897],
    [118.519867547242, 24.8181646342105, 0.000927727669477463],
  ],
  [
    [118.520204918764, 24.8175111074418, 0.000927643850445747],
    [118.519849860352, 24.818156529391, 0.000927725806832314],
  ],
  [
    [118.520187241836, 24.8175030026498, 0.000927644781768322],
    [118.519832183367, 24.8181484335858, 0.000927726738154888],
  ],
  [
    [118.520169564911, 24.8174948978557, 0.000927641987800598],
    [118.519814506373, 24.8181403287508, 0.000927724875509739],
  ],
  [
    [118.520151888, 24.8174868020872, 0.000927641987800598],
    [118.519796829393, 24.8181322329414, 0.000927722081542015],
  ],
  [
    [118.520134201188, 24.8174786973002, 0.000927639193832874],
    [118.519779142512, 24.8181241281134, 0.00092772301286459],
  ],
  [
    [118.520116524269, 24.8174705924998, 0.000927640125155449],
    [118.519761465524, 24.8181160232721, 0.000927720218896866],
  ],
  [
    [118.520098847365, 24.8174624967249, 0.0009276382625103],
    [118.519743788551, 24.8181079274564, 0.000927720218896866],
  ],
  [
    [118.520081170452, 24.8174543919203, 0.0009276382625103],
    [118.519726111569, 24.8180998226109, 0.000927719287574291],
  ],
  [
    [118.520063483661, 24.8174462961525, 0.000927637331187725],
    [118.519708424709, 24.8180917268021, 0.000927718356251717],
  ],
  [
    [118.520045806752, 24.8174381913436, 0.000927635468542576],
    [118.519690747731, 24.8180836219523, 0.000927716493606567],
  ],
  [
    [118.520028129845, 24.8174300865327, 0.000927632674574852],
    [118.519673070754, 24.8180755171005, 0.000927716493606567],
  ],
  [
    [118.520010452952, 24.8174219907473, 0.000927632674574852],
    [118.519655393793, 24.8180674212742, 0.000927714630961418],
  ],
  [
    [118.519992766158, 24.8174138859433, 0.000927632674574852],
    [118.51963770693, 24.8180593164293, 0.000927712768316269],
  ],
  [
    [118.519975089271, 24.8174057901537, 0.000927630811929703],
    [118.519620029961, 24.8180512115711, 0.000927712768316269],
  ],
  [
    [118.519957412373, 24.8173976853343, 0.000927630811929703],
    [118.519602353006, 24.8180431157385, 0.00092771090567112],
  ],
  [
    [118.519939735477, 24.8173895805128, 0.000927628949284554],
    [118.519584676042, 24.8180350108761, 0.000927709974348545],
  ],
  [
    [118.519922048705, 24.8173814847281, 0.000927628017961979],
    [118.5195669892, 24.8180269150505, 0.00092770904302597],
  ],
  [
    [118.519904371814, 24.8173733799024, 0.000927628017961979],
    [118.51954931224, 24.8180188101838, 0.000927708111703396],
  ],
  [
    [118.519886694925, 24.8173652750745, 0.00092762615531683],
    [118.519531635283, 24.8180107053151, 0.00092770904302597],
  ],
  [
    [118.519869018051, 24.8173571792722, 0.00092762429267168],
    [118.519513958339, 24.8180026094719, 0.000927707180380821],
  ],
  [
    [118.519851331275, 24.8173490744514, 0.000927622430026531],
    [118.519496281386, 24.8179945045989, 0.000927705317735672],
  ],
  [
    [118.519833654406, 24.8173409786449, 0.000927622430026531],
    [118.519478594544, 24.8179863997351, 0.000927705317735672],
  ],
  [
    [118.519815977526, 24.8173328738086, 0.000927621498703957],
    [118.519460917608, 24.8179783038856, 0.000927704386413097],
  ],
  [
    [118.519798300649, 24.8173247689702, 0.000927621498703957],
    [118.519443240661, 24.8179701990063, 0.000927703455090523],
  ],
  [
    [118.519780613895, 24.8173166731686, 0.000927621498703957],
    [118.51942556373, 24.8179621031525, 0.000927701592445374],
  ],
  [
    [118.519762937022, 24.817308568326, 0.000927619636058807],
    [118.519407876897, 24.8179539982802, 0.000927701592445374],
  ],
  [
    [118.519745260152, 24.8173004634813, 0.000927616842091084],
    [118.519390199957, 24.8179458933946, 0.00092769879847765],
  ],
  [
    [118.519727583296, 24.8172923676621, 0.000927615910768509],
    [118.519372523032, 24.8179377975345, 0.0009276969358325],
  ],
  [
    [118.519709896539, 24.8172842628244, 0.000927614979445934],
    [118.519354846097, 24.8179296926447, 0.000927697867155075],
  ],
  [
    [118.519692219688, 24.817276167001, 0.00092761404812336],
    [118.519337159274, 24.8179215877639, 0.000927696004509926],
  ],
  [
    [118.519674542827, 24.8172680621478, 0.00092761404812336],
    [118.519319482356, 24.8179134918975, 0.000927695073187351],
  ],
  [
    [118.519656865968, 24.8172599572925, 0.000927613116800785],
    [118.519301805428, 24.8179053870013, 0.000927693210542202],
  ],
  [
    [118.519639179232, 24.817251861474, 0.00092761218547821],
    [118.519284128514, 24.8178972911307, 0.000927693210542202],
  ],
  [
    [118.519621502378, 24.8172437566145, 0.000927611254155636],
    [118.519266441699, 24.8178891862415, 0.000927692279219627],
  ],
  [
    [118.519603825525, 24.8172356517529, 0.000927608460187912],
    [118.519248764778, 24.817881081339, 0.000927690416574478],
  ],
  [
    [118.519586148688, 24.8172275559169, 0.000927607528865337],
    [118.519231087872, 24.817872985462, 0.000927691347897053],
  ],
  [
    [118.519568461949, 24.8172194510622, 0.000927608460187912],
    [118.519213410955, 24.8178648805553, 0.000927689485251904],
  ],
  [
    [118.519550785116, 24.817211355222, 0.000927605666220188],
    [118.51919572415, 24.8178567756577, 0.000927687622606754],
  ],
  [
    [118.519533108273, 24.8172032503519, 0.000927604734897614],
    [118.51917804725, 24.8178486797744, 0.000927687622606754],
  ],
  [
    [118.519515431433, 24.8171951454798, 0.000927603803575039],
    [118.51916037034, 24.8178405748613, 0.000927685759961605],
  ],
  [
    [118.519497744715, 24.8171870496444, 0.000927602872252464],
    [118.519142693445, 24.8178324789738, 0.00092768482863903],
  ],
  [
    [118.519480067879, 24.817178944768, 0.00092760194092989],
    [118.519125006649, 24.8178243740677, 0.00092768482863903],
  ],
  [
    [118.519462391045, 24.8171708398895, 0.00092760194092989],
    [118.519107329746, 24.8178162691483, 0.000927682965993881],
  ],
  [
    [118.519444714226, 24.8171627440365, 0.00092760007828474],
    [118.519089652858, 24.8178081732545, 0.000927682034671307],
  ],
  [
    [118.519427027506, 24.817154639165, 0.00092760007828474],
    [118.51907197596, 24.8178000683309, 0.000927680172026157],
  ],
  [
    [118.519409350691, 24.8171465433079, 0.000927599146962166],
    [118.519054289185, 24.817791972444, 0.000927680172026157],
  ],
  [
    [118.519391673866, 24.8171384384209, 0.000927597284317017],
    [118.519036612291, 24.8177838675161, 0.000927678309381008],
  ],
  [
    [118.519373997044, 24.8171303335319, 0.000927596352994442],
    [118.5190189354, 24.8177757625862, 0.000927678309381008],
  ],
  [
    [118.519356310345, 24.8171222376796, 0.000927594490349293],
    [118.519001258523, 24.8177676666818, 0.000927676446735859],
  ],
  [
    [118.519338633527, 24.8171141327863, 0.000927593559026718],
    [118.518983571745, 24.8177595617588, 0.000927675515413284],
  ],
  [
    [118.519320956712, 24.817106027891, 0.000927592627704144],
    [118.51896589486, 24.8177514568225, 0.000927675515413284],
  ],
  [
    [118.519303279911, 24.8170979320211, 0.000927592627704144],
    [118.51894821799, 24.8177433609118, 0.000927673652768135],
  ],
  [
    [118.519285593209, 24.8170898271327, 0.000927590765058994],
    [118.51893054111, 24.8177352559713, 0.000927673652768135],
  ],
  [
    [118.519267916412, 24.8170817312587, 0.00092758983373642],
    [118.518912854354, 24.8177271600675, 0.000927670858800411],
  ],
  [
    [118.519250239606, 24.8170736263549, 0.000927590765058994],
    [118.518895177478, 24.8177190551228, 0.000927670858800411],
  ],
  [
    [118.519232562802, 24.8170655214489, 0.000927587039768696],
    [118.518877500605, 24.817710950176, 0.000927670858800411],
  ],
  [
    [118.519214876121, 24.8170574255798, 0.000927586108446121],
    [118.518859823747, 24.8177028542547, 0.000927668996155262],
  ],
  [
    [118.519197199322, 24.8170493206696, 0.000927587039768696],
    [118.518842136987, 24.8176947493148, 0.000927668064832687],
  ],
  [
    [118.519179522537, 24.817041224785, 0.000927586108446121],
    [118.518824460121, 24.8176866443617, 0.000927667133510113],
  ],
  [
    [118.519161845742, 24.8170331198706, 0.000927583314478397],
    [118.518806783269, 24.817678548434, 0.000927666202187538],
  ],
  [
    [118.519144159058, 24.8170250149653, 0.000927584245800972],
    [118.518789106408, 24.8176704434767, 0.000927664339542389],
  ],
  [
    [118.51912648228, 24.8170169190744, 0.000927582383155823],
    [118.518771419669, 24.817662347556, 0.000927663408219814],
  ],
  [
    [118.519108805492, 24.8170088141537, 0.000927580520510674],
    [118.518753742812, 24.8176542425944, 0.00092766247689724],
  ],
  [
    [118.519091128707, 24.8170007092309, 0.000927579589188099],
    [118.518736065958, 24.8176461376307, 0.000927661545574665],
  ],
  [
    [118.519073442044, 24.8169926133448, 0.000927578657865524],
    [118.518718389117, 24.8176380416925, 0.00092766061425209],
  ],
  [
    [118.519055765263, 24.8169845084178, 0.00092757772654295],
    [118.518700702376, 24.8176299367357, 0.000927659682929516],
  ],
  [
    [118.519038088497, 24.8169764125163, 0.000927576795220375],
    [118.518683025528, 24.8176218317657, 0.000927658751606941],
  ],
  [
    [118.51902041172, 24.816968307585, 0.000927576795220375],
    [118.518665348695, 24.8176137358212, 0.000927658751606941],
  ],
  [
    [118.519002734946, 24.8169602026517, 0.0009275758638978],
    [118.518647671852, 24.8176056308469, 0.000927655957639217],
  ],
  [
    [118.518985048295, 24.816952106755, 0.000927574001252651],
    [118.518629985131, 24.8175975349094, 0.000927655026316643],
  ],
  [
    [118.518967371525, 24.8169440018175, 0.000927573069930077],
    [118.518612308293, 24.8175894299309, 0.000927654094994068],
  ],
  [
    [118.518949694758, 24.8169358968778, 0.000927571207284927],
    [118.518594631456, 24.8175813249503, 0.000927654094994068],
  ],
  [
    [118.518932018005, 24.8169278009636, 0.000927570275962353],
    [118.518576954634, 24.8175732289952, 0.000927653163671494],
  ],
  [
    [118.518914331351, 24.8169196960309, 0.000927568413317204],
    [118.518559267911, 24.8175651240216, 0.000927651301026344],
  ],
  [
    [118.518896654603, 24.8169116001125, 0.000927568413317204],
    [118.518541591082, 24.8175570190346, 0.000927649438381195],
  ],
  [
    [118.518878977844, 24.8169034951644, 0.000927568413317204],
    [118.518523914267, 24.8175489230733, 0.000927651301026344],
  ],
  [
    [118.518861301088, 24.8168953902141, 0.000927566550672054],
    [118.518506237442, 24.8175408180821, 0.00092764850705862],
  ],
  [
    [118.518843614456, 24.8168872943006, 0.00092756561934948],
    [118.51848855074, 24.8175327221277, 0.000927645713090897],
  ],
  [
    [118.518825937704, 24.8168791893461, 0.00092756375670433],
    [118.51847087392, 24.8175246171323, 0.000927645713090897],
  ],
  [
    [118.518808260955, 24.8168710843895, 0.000927564688026905],
    [118.518453197102, 24.8175165121348, 0.000927644781768322],
  ],
  [
    [118.518790584221, 24.8168629884585, 0.000927561894059181],
    [118.518435520298, 24.8175084161629, 0.000927644781768322],
  ],
  [
    [118.518772897585, 24.8168548835089, 0.000927561894059181],
    [118.518417833593, 24.8175003111723, 0.000927642919123173],
  ],
  [
    [118.518755220855, 24.8168467875736, 0.000927561894059181],
    [118.518400156782, 24.8174922061685, 0.000927641056478024],
  ],
  [
    [118.518737544115, 24.8168386826086, 0.000927559100091457],
    [118.518382479985, 24.8174841101902, 0.000927641987800598],
  ],
  [
    [118.518719867378, 24.8168305776415, 0.000927559100091457],
    [118.518364803179, 24.8174760051822, 0.000927641056478024],
  ],
  [
    [118.518702180763, 24.8168224817111, 0.000927556306123734],
    [118.518347116495, 24.8174679092108, 0.000927639193832874],
  ],
  [
    [118.51868450403, 24.8168143767397, 0.000927558168768883],
    [118.518329439693, 24.8174598041986, 0.000927639193832874],
  ],
  [
    [118.518666827299, 24.8168062717662, 0.000927557237446308],
    [118.518311762894, 24.8174516991842, 0.000927637331187725],
  ],
  [
    [118.518649150583, 24.8167981758183, 0.000927554443478584],
    [118.518294086108, 24.8174436031954, 0.000927633605897427],
  ],
  [
    [118.518631463966, 24.8167900708518, 0.000927552580833435],
    [118.518276399422, 24.817435498188, 0.000927634537220001],
  ],
  [
    [118.518613787254, 24.8167819748997, 0.00092755351215601],
    [118.518258722641, 24.8174274021949, 0.000927634537220001],
  ],
  [
    [118.518596110532, 24.8167738699178, 0.00092755164951086],
    [118.51824104585, 24.8174192971721, 0.000927633605897427],
  ],
  [
    [118.518578433813, 24.8167657649337, 0.000927550718188286],
    [118.518223369062, 24.8174111921472, 0.000927632674574852],
  ],
  [
    [118.518560747217, 24.8167576689864, 0.000927548855543137],
    [118.518205682397, 24.817403096159, 0.000927630811929703],
  ],
  [
    [118.518543070502, 24.8167495639982, 0.000927548855543137],
    [118.518188005613, 24.8173949911298, 0.000927630811929703],
  ],
  [
    [118.518525393802, 24.8167414680355, 0.000927546992897987],
    [118.518170328832, 24.8173868860986, 0.000927629880607128],
  ],
  [
    [118.518507717092, 24.8167333630431, 0.000927546061575413],
    [118.518152652065, 24.8173787900929, 0.000927628949284554],
  ],
  [
    [118.518490030493, 24.8167252580596, 0.000927547924220562],
    [118.518134965397, 24.8173706850685, 0.000927628017961979],
  ],
  [
    [118.5184723538, 24.8167171620906, 0.000927544198930264],
    [118.518117288634, 24.8173625890586, 0.00092762429267168],
  ],
  [
    [118.518454677096, 24.8167090570918, 0.000927544198930264],
    [118.518099611862, 24.8173544840189, 0.000927625223994255],
  ],
  [
    [118.518437000395, 24.8167009520909, 0.00092754140496254],
    [118.518081935092, 24.8173463789771, 0.00092762429267168],
  ],
  [
    [118.518419313818, 24.8166928561267, 0.00092754140496254],
    [118.518064248445, 24.817338282972, 0.000927622430026531],
  ],
  [
    [118.518401637121, 24.8166847511216, 0.00092753954231739],
    [118.51804657168, 24.817330177926, 0.000927621498703957],
  ],
  [
    [118.518383960439, 24.8166766551421, 0.00092753954231739],
    [118.518028894917, 24.8173220728778, 0.000927619636058807],
  ],
  [
    [118.518366283747, 24.8166685501327, 0.000927538610994816],
    [118.518011218168, 24.8173139768553, 0.000927620567381382],
  ],
  [
    [118.518348597167, 24.8166604451324, 0.000927536748349667],
    [118.517993531518, 24.817305871814, 0.000927618704736233],
  ],
  [
    [118.518330920492, 24.8166523491465, 0.000927534885704517],
    [118.517975854774, 24.8172977757872, 0.000927616842091084],
  ],
  [
    [118.518313243807, 24.8166442441308, 0.000927534885704517],
    [118.51795817802, 24.8172896707306, 0.000927617773413658],
  ],
  [
    [118.518295567124, 24.816636139113, 0.000927533023059368],
    [118.517940501268, 24.817281565672, 0.000927615910768509],
  ],
  [
    [118.518277880565, 24.8166280431319, 0.000927533954381943],
    [118.51792281464, 24.8172734696499, 0.000927615910768509],
  ],
  [
    [118.518260203886, 24.81661993811, 0.000927532091736794],
    [118.517905137893, 24.817265364587, 0.00092761404812336],
  ],
  [
    [118.518242527223, 24.8166118421135, 0.000927531160414219],
    [118.517887461148, 24.817257259522, 0.000927611254155636],
  ],
  [
    [118.518224850549, 24.8166037370873, 0.000927531160414219],
    [118.517869784418, 24.8172491634826, 0.000927613116800785],
  ],
  [
    [118.518207163987, 24.8165956320701, 0.00092752929776907],
    [118.517852097786, 24.8172410584244, 0.000927610322833061],
  ],
  [
    [118.51818948733, 24.8165875360673, 0.000927526503801346],
    [118.51783442106, 24.8172329623807, 0.000927609391510487],
  ],
  [
    [118.518171810664, 24.8165794310347, 0.00092752743512392],
    [118.517816744325, 24.8172248573073, 0.000927608460187912],
  ],
  [
    [118.518154133999, 24.8165713260001, 0.000927526503801346],
    [118.517799067591, 24.8172167522317, 0.000927608460187912],
  ],
  [
    [118.518136447458, 24.8165632300021, 0.000927525572478771],
    [118.517781380981, 24.8172086561928, 0.000927605666220188],
  ],
  [
    [118.518118770798, 24.8165551249632, 0.000927523709833622],
    [118.517763704253, 24.817200551113, 0.000927605666220188],
  ],
  [
    [118.518101094153, 24.8165470289499, 0.000927524641156197],
    [118.517746027526, 24.8171924460311, 0.000927604734897614],
  ],
  [
    [118.518083417498, 24.8165389239068, 0.000927520915865898],
    [118.517728350814, 24.8171843499748, 0.000927603803575039],
  ],
  [
    [118.518065730954, 24.8165308188727, 0.000927519984543324],
    [118.517710674092, 24.8171762448887, 0.00092760194092989],
  ],
  [
    [118.518048054315, 24.816522722853, 0.000927518121898174],
    [118.517692987493, 24.8171681488392, 0.00092760194092989],
  ],
  [
    [118.518030377667, 24.8165146178036, 0.000927519984543324],
    [118.517675310776, 24.8171600437488, 0.000927598215639591],
  ],
  [
    [118.518012701021, 24.816506512752, 0.000927518121898174],
    [118.517657634061, 24.8171519386564, 0.000927599146962166],
  ],
  [
    [118.517995014498, 24.8164984167371, 0.000927516259253025],
    [118.51763995736, 24.8171438425895, 0.000927597284317017],
  ],
  [
    [118.517977337857, 24.8164903116814, 0.000927516259253025],
    [118.517622270759, 24.8171357375039, 0.000927598215639591],
  ],
  [
    [118.51795966123, 24.8164822156512, 0.00092751532793045],
    [118.517604594063, 24.8171276414328, 0.000927595421671867],
  ],
  [
    [118.517941984593, 24.8164741105912, 0.000927513465285301],
    [118.517586917357, 24.8171195363319, 0.000927594490349293],
  ],
  [
    [118.517924298067, 24.8164660055402, 0.000927514396607876],
    [118.517569240653, 24.8171114312289, 0.000927592627704144],
  ],
  [
    [118.517906621447, 24.8164579095036, 0.000927510671317577],
    [118.517551554073, 24.8171033351625, 0.000927592627704144],
  ],
  [
    [118.517888944817, 24.8164498044373, 0.000927509739995003],
    [118.517533877374, 24.8170952300553, 0.000927592627704144],
  ],
  [
    [118.517871268189, 24.8164416993689, 0.000927509739995003],
    [118.517516200677, 24.817087124946, 0.00092758983373642],
  ],
  [
    [118.517853581685, 24.8164336033371, 0.000927507877349854],
    [118.517498523995, 24.8170790288622, 0.00092758983373642],
  ],
  [
    [118.517835905061, 24.8164254982645, 0.000927506014704704],
    [118.517480837411, 24.8170709237597, 0.00092758983373642],
  ],
  [
    [118.517818228453, 24.8164174022174, 0.000927506946027279],
    [118.517463160733, 24.8170628276717, 0.000927587039768696],
  ],
  [
    [118.517800551834, 24.8164092971405, 0.000927504152059555],
    [118.517445484046, 24.817054722554, 0.00092758797109127],
  ],
  [
    [118.517782865327, 24.8164011920726, 0.00092750322073698],
    [118.517427807361, 24.8170466174341, 0.000927586108446121],
  ],
  [
    [118.517765188725, 24.8163930960192, 0.00092750508338213],
    [118.517410120799, 24.8170385213508, 0.000927585177123547],
  ],
  [
    [118.517747512113, 24.816384990936, 0.000927502289414406],
    [118.517392444118, 24.8170304162267, 0.000927583314478397],
  ],
  [
    [118.517729835516, 24.8163768948783, 0.000927501358091831],
    [118.517374767439, 24.8170223111005, 0.000927582383155823],
  ],
  [
    [118.517712149018, 24.816368789802, 0.000927501358091831],
    [118.517357090775, 24.8170142149998, 0.000927582383155823],
  ],
  [
    [118.517694472413, 24.8163606847125, 0.000927499495446682],
    [118.51733940421, 24.8170061098805, 0.000927581451833248],
  ],
  [
    [118.517676795822, 24.8163525886485, 0.000927496701478958],
    [118.517321727551, 24.8169980137756, 0.000927580520510674],
  ],
  [
    [118.517659119222, 24.8163444835548, 0.000927496701478958],
    [118.517304050882, 24.8169899086409, 0.00092757772654295],
  ],
  [
    [118.517641432733, 24.81633637847, 0.000927494838833809],
    [118.517286374215, 24.8169818035042, 0.00092757772654295],
  ],
  [
    [118.51762375615, 24.8163282823997, 0.000927496701478958],
    [118.517268687671, 24.816973707404, 0.0009275758638978],
  ],
  [
    [118.517606079556, 24.8163201772996, 0.00092749297618866],
    [118.517251011009, 24.816965602263, 0.0009275758638978],
  ],
  [
    [118.517588402977, 24.8163120812251, 0.000927492044866085],
    [118.517233334348, 24.8169574971199, 0.0009275758638978],
  ],
  [
    [118.517570716497, 24.8163039761318, 0.00092749297618866],
    [118.517215657703, 24.8169494010024, 0.000927574001252651],
  ],
  [
    [118.517553039911, 24.8162958710254, 0.00092749111354351],
    [118.517197971156, 24.8169412958661, 0.000927573069930077],
  ],
  [
    [118.517535363339, 24.8162877749446, 0.000927489250898361],
    [118.517180294515, 24.8169331997444, 0.000927572138607502],
  ],
  [
    [118.517517686757, 24.8162796698339, 0.000927488319575787],
    [118.517162617864, 24.8169250945928, 0.000927571207284927],
  ],
  [
    [118.517500000286, 24.8162715647323, 0.000927487388253212],
    [118.517144941215, 24.8169169894392, 0.000927570275962353],
  ],
  [
    [118.517482323721, 24.8162634686451, 0.000927486456930637],
    [118.51712725469, 24.8169088933221, 0.000927568413317204],
  ],
  [
    [118.517464647146, 24.8162553635281, 0.000927486456930637],
    [118.517109578046, 24.8169007881643, 0.000927568413317204],
  ],
  [
    [118.517446970585, 24.8162472674367, 0.000927483662962914],
    [118.517091901404, 24.8168926830043, 0.000927566550672054],
  ],
  [
    [118.517429284123, 24.8162391623266, 0.000927483662962914],
    [118.517074224777, 24.8168845868699, 0.000927567481994629],
  ],
  [
    [118.517411607555, 24.8162310572033, 0.000927483662962914],
    [118.517056538248, 24.8168764817167, 0.00092756561934948],
  ],
  [
    [118.517393931001, 24.8162229611056, 0.00092747900635004],
    [118.517038861625, 24.8168683855781, 0.000927560962736607],
  ],
  [
    [118.517376254438, 24.816214855978, 0.00092748086899519],
    [118.517021184993, 24.8168602804096, 0.000927562825381756],
  ],
  [
    [118.517358567985, 24.8162067508595, 0.000927479937672615],
    [118.517003508362, 24.8168521752391, 0.000927560962736607],
  ],
  [
    [118.517340891438, 24.8161986547554, 0.000927478075027466],
    [118.516985821855, 24.8168440791052, 0.000927560962736607],
  ],
  [
    [118.517323214882, 24.8161905496216, 0.000927477143704891],
    [118.51696814523, 24.8168359739304, 0.000927559100091457],
  ],
  [
    [118.517305538339, 24.8161824535133, 0.000927476212382317],
    [118.516950468606, 24.8168278687536, 0.000927558168768883],
  ],
  [
    [118.517287851896, 24.8161743483863, 0.000927475281059742],
    [118.516932791997, 24.8168197726023, 0.000927557237446308],
  ],
  [
    [118.517270175346, 24.8161662432461, 0.000927474349737167],
    [118.516915105487, 24.8168116674322, 0.000927554443478584],
  ],
  [
    [118.51725249881, 24.8161581471315, 0.000927475281059742],
    [118.516897428882, 24.8168035712767, 0.000927554443478584],
  ],
  [
    [118.517234822265, 24.8161500419871, 0.000927472487092018],
    [118.516879752268, 24.8167954660914, 0.000927555374801159],
  ],
  [
    [118.517217145722, 24.8161419368406, 0.000927471555769444],
    [118.516862075656, 24.816787360904, 0.000927552580833435],
  ],
  [
    [118.517199459302, 24.8161338407307, 0.000927471555769444],
    [118.516844389167, 24.8167792647532, 0.000927552580833435],
  ],
  [
    [118.517181782764, 24.8161257355799, 0.000927470624446869],
    [118.51682671256, 24.8167711595615, 0.000927549786865711],
  ],
  [
    [118.51716410624, 24.8161176394548, 0.00092746876180172],
    [118.516809035967, 24.8167630633954, 0.000927549786865711],
  ],
  [
    [118.517146429706, 24.8161095342998, 0.000927467830479145],
    [118.516791359364, 24.8167549581996, 0.000927548855543137],
  ],
  [
    [118.517128743283, 24.8161014291538, 0.000927465967833996],
    [118.516773672872, 24.8167468530127, 0.000927547924220562],
  ],
  [
    [118.517111066766, 24.8160933330223, 0.000927465967833996],
    [118.516755996286, 24.8167387568402, 0.000927546992897987],
  ],
  [
    [118.517093390239, 24.816085227861, 0.000927464105188847],
    [118.51673831969, 24.8167306516381, 0.000927545130252838],
  ],
  [
    [118.517075713727, 24.8160771317253, 0.000927462242543697],
    [118.516720643096, 24.8167225464338, 0.000927546061575413],
  ],
  [
    [118.517058027313, 24.8160690265708, 0.000927463173866272],
    [118.516702956626, 24.8167144502661, 0.000927544198930264],
  ],
  [
    [118.517040350793, 24.8160609214032, 0.000927461311221123],
    [118.516685280037, 24.8167063450575, 0.000927543267607689],
  ],
  [
    [118.517022674287, 24.8160528252612, 0.000927460379898548],
    [118.516667603462, 24.8166982488746, 0.000927543267607689],
  ],
  [
    [118.517004997772, 24.8160447200894, 0.000927458517253399],
    [118.516649926877, 24.8166901436618, 0.00092754140496254],
  ],
  [
    [118.516987311367, 24.8160366149265, 0.000927457585930824],
    [118.516632240404, 24.816682038458, 0.000927538610994816],
  ],
  [
    [118.516969634868, 24.8160285187781, 0.000927457585930824],
    [118.516614563836, 24.8166739422687, 0.000927537679672241],
  ],
  [
    [118.51695195836, 24.8160204135999, 0.00092745665460825],
    [118.516596887258, 24.8166658370497, 0.000927537679672241],
  ],
  [
    [118.516934281865, 24.8160123174473, 0.0009274547919631],
    [118.516579210683, 24.8166577318285, 0.000927536748349667],
  ],
  [
    [118.51691659547, 24.816004212276, 0.0009274547919631],
    [118.516561524231, 24.8166496356439, 0.000927535817027092],
  ],
  [
    [118.516898918968, 24.8159961070915, 0.000927452929317951],
    [118.51654384766, 24.8166415304185, 0.000927533954381943],
  ],
  [
    [118.516881242481, 24.8159880109325, 0.000927451066672802],
    [118.516526171104, 24.8166334342186, 0.000927534885704517],
  ],
  [
    [118.516863565984, 24.8159799057438, 0.000927450135350227],
    [118.516508494537, 24.816625328989, 0.000927533023059368],
  ],
  [
    [118.516845879598, 24.815971800564, 0.000927449204027653],
    [118.516490808082, 24.8166172237683, 0.000927532091736794],
  ],
  [
    [118.516828203117, 24.8159637043988, 0.000927448272705078],
    [118.516473131533, 24.8166091275621, 0.000927532091736794],
  ],
  [
    [118.516810526627, 24.8159555992037, 0.000927448272705078],
    [118.516455454973, 24.8166010223262, 0.000927528366446495],
  ],
  [
    [118.516792850151, 24.8159475030343, 0.000927447341382504],
    [118.516437778416, 24.8165929170881, 0.00092752929776907],
  ],
  [
    [118.516775163774, 24.815939397846, 0.000927446410059929],
    [118.516420091982, 24.8165848208866, 0.00092752743512392],
  ],
  [
    [118.51675748729, 24.8159312926446, 0.000927445478737354],
    [118.51640241543, 24.8165767156443, 0.000927526503801346],
  ],
  [
    [118.516739810821, 24.8159231964688, 0.00092744268476963],
    [118.516384738892, 24.8165686194276, 0.000927525572478771],
  ],
  [
    [118.516722134342, 24.8159150912632, 0.000927443616092205],
    [118.516367062344, 24.8165605141811, 0.000927526503801346],
  ],
  [
    [118.516704447975, 24.8159069860665, 0.000927441753447056],
    [118.516349375907, 24.8165524089435, 0.000927524641156197],
  ],
  [
    [118.516686771512, 24.8158988898844, 0.000927441753447056],
    [118.516331699376, 24.8165443127205, 0.000927522778511047],
  ],
  [
    [118.51666909504, 24.8158907846725, 0.000927439890801907],
    [118.516314022835, 24.8165362074676, 0.000927519984543324],
  ],
  [
    [118.516651418583, 24.8158826884861, 0.000927439890801907],
    [118.516296346296, 24.8165281022127, 0.000927520915865898],
  ],
  [
    [118.516633732224, 24.815874583281, 0.000927438028156757],
    [118.51627865988, 24.8165200059943, 0.000927519053220749],
  ],
  [
    [118.516616055759, 24.8158664780627, 0.000927436165511608],
    [118.516260983346, 24.8165119007351, 0.000927518121898174],
  ],
  [
    [118.516598379308, 24.8158583818701, 0.000927437096834183],
    [118.516243306826, 24.8165038045016, 0.0009275171905756],
  ],
  [
    [118.516580702848, 24.8158502766476, 0.000927435234189034],
    [118.516225630297, 24.8164956992382, 0.000927516259253025],
  ],
  [
    [118.516563016498, 24.815842171434, 0.000927434302866459],
    [118.516207943878, 24.8164875939837, 0.00092751532793045],
  ],
  [
    [118.516545340054, 24.815834075235, 0.000927433371543884],
    [118.516190267365, 24.8164794977437, 0.000927513465285301],
  ],
  [
    [118.516527663601, 24.8158259700062, 0.000927431508898735],
    [118.516172590843, 24.816471392474, 0.000927511602640152],
  ],
  [
    [118.516509987161, 24.8158178738029, 0.00092743057757616],
    [118.516154914322, 24.8164632872022, 0.000927511602640152],
  ],
  [
    [118.516492300821, 24.8158097685809, 0.000927428714931011],
    [118.516137227925, 24.8164551909669, 0.000927511602640152],
  ],
  [
    [118.516474624374, 24.8158016633458, 0.000927428714931011],
    [118.516119551409, 24.8164470856909, 0.000927508808672428],
  ],
  [
    [118.516456947942, 24.8157935671362, 0.000927427783608437],
    [118.516101874908, 24.8164389894404, 0.000927509739995003],
  ],
  [
    [118.516439271499, 24.8157854618968, 0.000927426852285862],
    [118.516084198396, 24.8164308841601, 0.000927507877349854],
  ],
  [
    [118.516421585168, 24.8157773566664, 0.000927424058318138],
    [118.516066511996, 24.8164227788887, 0.00092750508338213],
  ],
  [
    [118.516403908742, 24.8157692604505, 0.000927425920963287],
    [118.516048835501, 24.8164146826319, 0.000927507877349854],
  ],
  [
    [118.516386232307, 24.8157611552048, 0.000927424058318138],
    [118.516031158997, 24.8164065773453, 0.000927504152059555],
  ],
  [
    [118.516368555886, 24.8157530589847, 0.000927422195672989],
    [118.516013482507, 24.8163984810843, 0.00092750322073698],
  ],
  [
    [118.516350869564, 24.8157449537457, 0.000927421264350414],
    [118.515995796116, 24.8163903758045, 0.000927504152059555],
  ],
  [
    [118.516333193136, 24.8157368484937, 0.00092742033302784],
    [118.515978119619, 24.8163822705116, 0.000927501358091831],
  ],
  [
    [118.516315516721, 24.8157287522673, 0.00092742033302784],
    [118.515960443135, 24.8163741742442, 0.000927500426769257],
  ],
  [
    [118.516297840297, 24.815720647011, 0.00092741847038269],
    [118.515942766642, 24.816366068947, 0.000927499495446682],
  ],
  [
    [118.516280153997, 24.8157125507914, 0.000927416607737541],
    [118.515925090152, 24.8163579636478, 0.000927497632801533],
  ],
  [
    [118.516262477577, 24.8157044455309, 0.000927416607737541],
    [118.515907403784, 24.8163498673851, 0.000927497632801533],
  ],
  [
    [118.51624480116, 24.8156963402683, 0.000927414745092392],
    [118.515889727298, 24.8163417620816, 0.000927495770156384],
  ],
  [
    [118.516227124757, 24.8156882440313, 0.000927414745092392],
    [118.515872050826, 24.8163336658037, 0.000927494838833809],
  ],
  [
    [118.516209438454, 24.8156801387755, 0.000927413813769817],
    [118.515854374345, 24.816325560496, 0.000927494838833809],
  ],
  [
    [118.516191762044, 24.8156720335066, 0.000927412882447243],
    [118.515836687974, 24.8163174551972, 0.000927493907511234],
  ],
  [
    [118.516174085648, 24.8156639372633, 0.000927411019802094],
    [118.51581901151, 24.8163093589129, 0.000927492044866085],
  ],
  [
    [118.516156409242, 24.8156558319902, 0.000927410088479519],
    [118.515801335035, 24.8163012535989, 0.000927490182220936],
  ],
  [
    [118.51613872296, 24.8156477357536, 0.000927410088479519],
    [118.515783658563, 24.8162931482828, 0.000927490182220936],
  ],
  [
    [118.516121046559, 24.8156396304763, 0.00092740822583437],
    [118.515765972213, 24.8162850520031, 0.00092749111354351],
  ],
  [
    [118.51610337016, 24.8156315251968, 0.00092740636318922],
    [118.515748295746, 24.8162769466828, 0.000927487388253212],
  ],
  [
    [118.516085693775, 24.8156234289429, 0.00092740636318922],
    [118.515730619292, 24.816268850388, 0.000927489250898361],
  ],
  [
    [118.51606800749, 24.8156153236702, 0.000927405431866646],
    [118.515712942829, 24.8162607450634, 0.000927486456930637],
  ],
  [
    [118.516050331098, 24.8156072183845, 0.000927405431866646],
    [118.515695256477, 24.8162526397477, 0.000927484594285488],
  ],
  [
    [118.516032654721, 24.8155991221242, 0.000927402637898922],
    [118.51567758003, 24.8162445434466, 0.000927484594285488],
  ],
  [
    [118.516014978333, 24.8155910168343, 0.000927401706576347],
    [118.515659903574, 24.8162364381157, 0.000927482731640339],
  ],
  [
    [118.515997292069, 24.8155829205808, 0.000927399843931198],
    [118.51564222712, 24.8162283327826, 0.000927481800317764],
  ],
  [
    [118.515979615686, 24.8155748152866, 0.000927398912608624],
    [118.515624540789, 24.8162202364861, 0.000927479937672615],
  ],
  [
    [118.515961939306, 24.8155667099902, 0.000927397981286049],
    [118.51560686434, 24.8162121311489, 0.00092747900635004],
  ],
  [
    [118.51594426294, 24.8155586137195, 0.000927397049963474],
    [118.515589187904, 24.8162040348372, 0.000927477143704891],
  ],
  [
    [118.515926576673, 24.8155505084299, 0.0009273961186409],
    [118.51557151146, 24.8161959294958, 0.00092747900635004],
  ],
  [
    [118.515908900299, 24.8155424031272, 0.000927395187318325],
    [118.515553825126, 24.8161878241632, 0.000927478075027466],
  ],
  [
    [118.51589122394, 24.8155343068501, 0.000927395187318325],
    [118.515536148698, 24.8161797278452, 0.000927476212382317],
  ],
  [
    [118.515873547571, 24.8155262015433, 0.00092739425599575],
    [118.51551847226, 24.8161716224974, 0.000927474349737167],
  ],
  [
    [118.515855861325, 24.8155181052729, 0.000927392393350601],
    [118.515500795824, 24.8161635171475, 0.000927474349737167],
  ],
  [
    [118.515838184961, 24.8155099999618, 0.000927389599382877],
    [118.515483109511, 24.8161554208341, 0.000927473418414593],
  ],
  [
    [118.515820508599, 24.8155018946486, 0.000927390530705452],
    [118.51546543308, 24.81614731548, 0.000927472487092018],
  ],
  [
    [118.515802832251, 24.815493798361, 0.000927388668060303],
    [118.515447756663, 24.8161392191514, 0.000927471555769444],
  ],
  [
    [118.515785146002, 24.8154856930545, 0.000927386805415154],
    [118.515430080237, 24.8161311137931, 0.000927470624446869],
  ],
  [
    [118.515767469647, 24.815477587735, 0.000927386805415154],
    [118.515412393921, 24.8161230084436, 0.000927467830479145],
  ],
  [
    [118.515749793306, 24.815469491441, 0.000927387736737728],
    [118.515394717511, 24.8161149121087, 0.00092746876180172],
  ],
  [
    [118.515732116955, 24.8154613861172, 0.000927384942770004],
    [118.515377041092, 24.816106806744, 0.00092746689915657],
  ],
  [
    [118.515714430728, 24.81545328983, 0.000927383080124855],
    [118.515359364686, 24.8160987104049, 0.000927467830479145],
  ],
  [
    [118.515696754382, 24.815445184502, 0.000927383080124855],
    [118.51534167838, 24.816090605047, 0.000927465036511421],
  ],
  [
    [118.515679078038, 24.8154370791719, 0.000927383080124855],
    [118.515324001967, 24.816082499676, 0.000927464105188847],
  ],
  [
    [118.515661401708, 24.8154289828674, 0.000927381217479706],
    [118.515306325569, 24.8160744033305, 0.000927463173866272],
  ],
  [
    [118.515643715478, 24.815420877544, 0.000927380286157131],
    [118.51528864916, 24.8160662979553, 0.000927464105188847],
  ],
  [
    [118.515626039141, 24.8154127722076, 0.000927379354834557],
    [118.515270962863, 24.8160581925889, 0.000927461311221123],
  ],
  [
    [118.515608362818, 24.8154046758967, 0.000927379354834557],
    [118.515253286472, 24.8160500962371, 0.000927460379898548],
  ],
  [
    [118.515590686486, 24.8153965705561, 0.000927377492189407],
    [118.51523561007, 24.8160419908556, 0.000927459448575974],
  ],
  [
    [118.515573000277, 24.815388474252, 0.000927376560866833],
    [118.515217933683, 24.8160338944996, 0.000927458517253399],
  ],
  [
    [118.515555323949, 24.8153803689071, 0.000927375629544258],
    [118.515200247395, 24.8160257891248, 0.00092745665460825],
  ],
  [
    [118.515537647624, 24.8153722635602, 0.000927373766899109],
    [118.515182571001, 24.8160176837369, 0.00092745665460825],
  ],
  [
    [118.515519971312, 24.8153641672387, 0.000927372835576534],
    [118.515164894621, 24.8160095873746, 0.000927452929317951],
  ],
  [
    [118.5155022851, 24.8153560618985, 0.00092737190425396],
    [118.515147218231, 24.8160014819825, 0.000927455723285675],
  ],
  [
    [118.515484608794, 24.8153479655729, 0.000927370972931385],
    [118.515129531952, 24.8159933765992, 0.000927451997995377],
  ],
  [
    [118.515466932477, 24.8153398602175, 0.000927369110286236],
    [118.515111855579, 24.8159852802306, 0.000927451997995377],
  ],
  [
    [118.515449256163, 24.81533175486, 0.00092737004160881],
    [118.515094179196, 24.8159771748321, 0.000927450135350227],
  ],
  [
    [118.515431579864, 24.815323658528, 0.000927368178963661],
    [118.515076502827, 24.8159690784593, 0.000927451066672802],
  ],
  [
    [118.515413893663, 24.8153155531772, 0.000927368178963661],
    [118.515058816557, 24.8159609730675, 0.000927448272705078],
  ],
  [
    [118.515396217356, 24.8153074478134, 0.000927366316318512],
    [118.515041140181, 24.8159528676628, 0.000927448272705078],
  ],
  [
    [118.515378541063, 24.8152993514751, 0.000927365384995937],
    [118.515023463819, 24.8159447712836, 0.000927447341382504],
  ],
  [
    [118.51536086476, 24.815291246107, 0.000927363522350788],
    [118.515005787448, 24.8159366658746, 0.000927445478737354],
  ],
  [
    [118.515343178581, 24.8152831497754, 0.000927363522350788],
    [118.514988101187, 24.8159285604744, 0.00092744454741478],
  ],
  [
    [118.515325502283, 24.8152750444031, 0.000927361659705639],
    [118.514970424832, 24.8159204640889, 0.00092744268476963],
  ],
  [
    [118.515307825987, 24.8152669390287, 0.000927360728383064],
    [118.514952748467, 24.8159123586736, 0.00092744268476963],
  ],
  [
    [118.515290149706, 24.8152588426799, 0.00092735979706049],
    [118.514935072117, 24.8159042622838, 0.000927440822124481],
  ],
  [
    [118.515272463523, 24.8152507373122, 0.000927358865737915],
    [118.514917385865, 24.8158961568752, 0.000927440822124481],
  ],
  [
    [118.515254787235, 24.8152426319315, 0.00092735793441534],
    [118.514899709508, 24.8158880514536, 0.000927439890801907],
  ],
  [
    [118.51523711096, 24.8152345355763, 0.00092735793441534],
    [118.514882033164, 24.8158799550575, 0.000927439890801907],
  ],
  [
    [118.515219434676, 24.8152264301914, 0.000927355140447617],
    [118.514864356811, 24.8158718496317, 0.000927438028156757],
  ],
  [
    [118.515201748515, 24.8152183338429, 0.000927355140447617],
    [118.514846670569, 24.8158637442146, 0.000927437096834183],
  ],
  [
    [118.515184072235, 24.8152102284537, 0.000927355140447617],
    [118.514828994232, 24.8158556478122, 0.000927436165511608],
  ],
  [
    [118.515166395957, 24.8152021230624, 0.000927352346479893],
    [118.514811317886, 24.81584754238, 0.000927434302866459],
  ],
  [
    [118.515148719694, 24.8151940266967, 0.000927351415157318],
    [118.514793641553, 24.8158394459734, 0.000927433371543884],
  ],
  [
    [118.51513103353, 24.8151859213122, 0.000927350483834744],
    [118.51477595532, 24.8158313405479, 0.000927433371543884],
  ],
  [
    [118.51511335726, 24.8151778159146, 0.000927350483834744],
    [118.514758278981, 24.8158232351094, 0.00092743057757616],
  ],
  [
    [118.515095681004, 24.8151697195425, 0.000927349552512169],
    [118.514740602656, 24.8158151386964, 0.000927429646253586],
  ],
  [
    [118.515078004738, 24.8151616141407, 0.000927346758544445],
    [118.514722926321, 24.8158070332537, 0.000927429646253586],
  ],
  [
    [118.515060318595, 24.8151535177753, 0.000927346758544445],
    [118.514705240097, 24.8157989278197, 0.000927429646253586],
  ],
  [
    [118.515042642333, 24.8151454123693, 0.000927346758544445],
    [118.514687563778, 24.8157908314004, 0.000927428714931011],
  ],
  [
    [118.515024966074, 24.8151373069611, 0.000927343964576721],
    [118.51466988745, 24.8157827259514, 0.000927424989640713],
  ],
  [
    [118.515007289829, 24.8151292105785, 0.000927343964576721],
    [118.514652211136, 24.8157746295279, 0.000927424989640713],
  ],
  [
    [118.514989603684, 24.8151211051771, 0.000927342101931572],
    [118.514634524922, 24.8157665240854, 0.000927425920963287],
  ],
  [
    [118.514971927432, 24.8151129997626, 0.000927341170608997],
    [118.514616848601, 24.8157584186301, 0.000927423126995564],
  ],
  [
    [118.514954251194, 24.8151049033736, 0.000927339307963848],
    [118.514599172294, 24.8157503222002, 0.000927421264350414],
  ],
  [
    [118.514936574946, 24.8150967979549, 0.000927339307963848],
    [118.514581495977, 24.8157422167406, 0.00092742033302784],
  ],
  [
    [118.514918888821, 24.8150887015727, 0.000927338376641274],
    [118.514563809783, 24.8157341203174, 0.00092742033302784],
  ],
  [
    [118.514901212578, 24.8150805961498, 0.000927336513996124],
    [118.514546133471, 24.8157260148536, 0.000927419401705265],
  ],
  [
    [118.514883536338, 24.8150724907247, 0.000927337445318699],
    [118.514528457162, 24.8157179093877, 0.000927419401705265],
  ],
  [
    [118.514865860111, 24.8150643943253, 0.00092733558267355],
    [118.514510780866, 24.8157098129473, 0.000927417539060116],
  ],
  [
    [118.514848173984, 24.8150562889069, 0.0009273337200284],
    [118.51449309467, 24.815701707488, 0.000927414745092392],
  ],
  [
    [118.514830497762, 24.8150481925032, 0.0009273337200284],
    [118.514475418367, 24.8156936020157, 0.000927416607737541],
  ],
  [
    [118.51481282153, 24.8150400870697, 0.000927331857383251],
    [118.514457742078, 24.815685505569, 0.000927413813769817],
  ],
  [
    [118.514795145301, 24.8150319816341, 0.000927330926060677],
    [118.51444006578, 24.8156774000925, 0.000927412882447243],
  ],
  [
    [118.514777459195, 24.815023885235, 0.000927329063415527],
    [118.514422379605, 24.8156693036524, 0.000927411019802094],
  ],
  [
    [118.51475978297, 24.8150157797952, 0.000927329063415527],
    [118.514404703311, 24.8156611981717, 0.000927411951124668],
  ],
  [
    [118.514742106747, 24.8150076743533, 0.000927328132092953],
    [118.514387027019, 24.8156530926889, 0.000927409157156944],
  ],
  [
    [118.514724430539, 24.814999577937, 0.000927327200770378],
    [118.514369350742, 24.8156449962316, 0.000927409157156944],
  ],
  [
    [118.51470674443, 24.8149914725017, 0.000927326269447804],
    [118.514351664564, 24.8156368907555, 0.000927409157156944],
  ],
  [
    [118.514689068227, 24.8149833760811, 0.000927325338125229],
    [118.51433398828, 24.8156287852663, 0.00092740636318922],
  ],
  [
    [118.514671392013, 24.8149752706308, 0.000927324406802654],
    [118.514316312009, 24.8156206888027, 0.000927404500544071],
  ],
  [
    [118.514653715802, 24.8149671651783, 0.00092732347548008],
    [118.514298635729, 24.8156125833093, 0.000927403569221497],
  ],
  [
    [118.514636029714, 24.8149590687623, 0.000927322544157505],
    [118.514280949572, 24.8156044868524, 0.000927402637898922],
  ],
  [
    [118.514618353508, 24.8149509633056, 0.000927320681512356],
    [118.514263273297, 24.8155963813548, 0.000927403569221497],
  ],
  [
    [118.514600677304, 24.8149428578468, 0.000927320681512356],
    [118.514245597024, 24.8155882758551, 0.000927400775253773],
  ],
  [
    [118.514583001114, 24.8149347614136, 0.000927318818867207],
    [118.514227920765, 24.8155801793809, 0.000927400775253773],
  ],
  [
    [118.514565315023, 24.8149266559615, 0.000927317887544632],
    [118.514210234605, 24.8155720738879, 0.000927398912608624],
  ],
  [
    [118.514547638838, 24.814918559524, 0.000927316024899483],
    [118.514192558339, 24.8155639683818, 0.000927397981286049],
  ],
  [
    [118.514529962643, 24.8149104540568, 0.000927316956222057],
    [118.514174882087, 24.8155558719014, 0.000927397049963474],
  ],
  [
    [118.51451228645, 24.8149023485874, 0.000927314162254334],
    [118.514157205825, 24.8155477663911, 0.0009273961186409],
  ],
  [
    [118.514494600381, 24.8148942521545, 0.000927313230931759],
    [118.514139529578, 24.8155396699064, 0.000927397049963474],
  ],
  [
    [118.514476924193, 24.8148861466809, 0.000927312299609184],
    [118.514121843429, 24.8155315644028, 0.00092739425599575],
  ],
  [
    [118.514459248007, 24.8148780412053, 0.00092731136828661],
    [118.514104167175, 24.8155234588862, 0.000927393324673176],
  ],
  [
    [118.514441571835, 24.8148699447552, 0.000927310436964035],
    [118.514086490934, 24.8155153623952, 0.000927393324673176],
  ],
  [
    [118.514423885763, 24.8148618392861, 0.00092730950564146],
    [118.514068814684, 24.8155072568744, 0.000927390530705452],
  ],
  [
    [118.514406209596, 24.8148537428318, 0.000927307642996311],
    [118.514051128545, 24.8154991513623, 0.000927390530705452],
  ],
  [
    [118.514388533419, 24.8148456373477, 0.000927306711673737],
    [118.514033452311, 24.815491054865, 0.000927388668060303],
  ],
  [
    [118.514370857245, 24.8148375318615, 0.000927307642996311],
    [118.514015776067, 24.8154829493379, 0.000927388668060303],
  ],
  [
    [118.514353171193, 24.8148294354117, 0.000927306711673737],
    [118.513998099838, 24.8154748528363, 0.000927387736737728],
  ],
  [
    [118.514335495024, 24.8148213299212, 0.000927304849028587],
    [118.513980413708, 24.8154667473158, 0.000927384942770004],
  ],
  [
    [118.514317818856, 24.8148132244287, 0.000927304849028587],
    [118.513962737472, 24.8154586417823, 0.000927385874092579],
  ],
  [
    [118.514300142703, 24.8148051279617, 0.000927302055060863],
    [118.51394506125, 24.8154505452744, 0.000927384942770004],
  ],
  [
    [118.514282456649, 24.8147970224758, 0.000927300192415714],
    [118.513927385018, 24.8154424397367, 0.00092738401144743],
  ],
  [
    [118.5142647805, 24.8147889260046, 0.000927301123738289],
    [118.513909698897, 24.8154343342078, 0.000927383080124855],
  ],
  [
    [118.514247104342, 24.8147808205036, 0.000927300192415714],
    [118.513892022681, 24.8154262376936, 0.000927381217479706],
  ],
  [
    [118.514229428186, 24.8147727150005, 0.000927298329770565],
    [118.513874346456, 24.8154181321495, 0.000927380286157131],
  ],
  [
    [118.514211742153, 24.8147646185338, 0.00092729739844799],
    [118.513856670246, 24.8154100356311, 0.000927379354834557],
  ],
  [
    [118.514194066001, 24.8147565130265, 0.000927295535802841],
    [118.513838984134, 24.8154019300937, 0.000927377492189407],
  ],
  [
    [118.514176389852, 24.8147484075171, 0.000927296467125416],
    [118.513821307916, 24.8153938245434, 0.000927377492189407],
  ],
  [
    [118.514158713717, 24.8147403110332, 0.000927294604480267],
    [118.513803631712, 24.8153857280186, 0.000927375629544258],
  ],
  [
    [118.514141027681, 24.8147322055304, 0.000927294604480267],
    [118.513785955498, 24.815377622464, 0.000927375629544258],
  ],
  [
    [118.514123351551, 24.8147241090423, 0.000927291810512543],
    [118.513768269408, 24.8153695259458, 0.000927372835576534],
  ],
  [
    [118.514105675411, 24.8147160035244, 0.000927291810512543],
    [118.513750593199, 24.8153614203871, 0.000927372835576534],
  ],
  [
    [118.514087999273, 24.8147078980045, 0.000927289947867393],
    [118.513732916992, 24.8153533148262, 0.000927370972931385],
  ],
  [
    [118.514070313259, 24.8146998015209, 0.000927289016544819],
    [118.513715240799, 24.8153452182908, 0.00092737004160881],
  ],
  [
    [118.514052637125, 24.8146916959967, 0.000927289016544819],
    [118.513697554706, 24.8153371127366, 0.000927369110286236],
  ],
  [
    [118.514034961006, 24.8146835994981, 0.000927286222577095],
    [118.513679878506, 24.8153290071693, 0.000927368178963661],
  ],
  [
    [118.514017284878, 24.8146754939696, 0.000927286222577095],
    [118.513662202321, 24.8153209106277, 0.000927367247641087],
  ],
  [
    [118.513999598861, 24.81466738845, 0.00092728529125452],
    [118.513644526125, 24.8153128050562, 0.000927366316318512],
  ],
  [
    [118.513981922748, 24.814659291945, 0.000927283428609371],
    [118.513626840053, 24.8153047085212, 0.000927366316318512],
  ],
  [
    [118.513964246627, 24.8146511864102, 0.000927282497286797],
    [118.513609163862, 24.8152966029455, 0.000927365384995937],
  ],
  [
    [118.513946570507, 24.8146430808734, 0.000927281565964222],
    [118.513591487674, 24.8152884973678, 0.000927362591028214],
  ],
  [
    [118.513928884511, 24.8146349843729, 0.000927280634641647],
    [118.5135738115, 24.8152804008156, 0.000927363522350788],
  ],
  [
    [118.513911208396, 24.8146268788318, 0.000927280634641647],
    [118.513556125425, 24.8152722952444, 0.000927362591028214],
  ],
  [
    [118.513893532295, 24.8146187823163, 0.000927279703319073],
    [118.513538449243, 24.8152641896603, 0.000927360728383064],
  ],
  [
    [118.513875856185, 24.814610676771, 0.000927277840673923],
    [118.513520773076, 24.8152560931017, 0.000927358865737915],
  ],
  [
    [118.513858170186, 24.8146025712345, 0.000927275978028774],
    [118.513503096899, 24.8152479875134, 0.00092735793441534],
  ],
  [
    [118.513840494092, 24.8145944747126, 0.000927275978028774],
    [118.513485410845, 24.8152398909615, 0.000927358865737915],
  ],
  [
    [118.513822817989, 24.814586369161, 0.000927274115383625],
    [118.513467734673, 24.815231785369, 0.000927357003092766],
  ],
  [
    [118.513805141888, 24.8145782636073, 0.000927274115383625],
    [118.513450058502, 24.8152236797743, 0.000927356071770191],
  ],
  [
    [118.51378745591, 24.8145701670899, 0.00092727318406105],
    [118.513432382347, 24.8152155832052, 0.000927355140447617],
  ],
  [
    [118.513769779813, 24.814562061532, 0.00092727318406105],
    [118.51341469629, 24.8152074776172, 0.000927354209125042],
  ],
  [
    [118.513752103731, 24.8145539649996, 0.000927270390093327],
    [118.513397020127, 24.8151993720162, 0.000927353277802467],
  ],
  [
    [118.513734427639, 24.8145458594374, 0.000927269458770752],
    [118.513379343978, 24.8151912754408, 0.000927351415157318],
  ],
  [
    [118.513716741658, 24.8145377538839, 0.000927269458770752],
    [118.513361667819, 24.8151831698356, 0.000927351415157318],
  ],
  [
    [118.513699065583, 24.8145296573452, 0.000927266664803028],
    [118.513343981783, 24.8151750732667, 0.00092734768986702],
  ],
  [
    [118.513681389498, 24.8145215517767, 0.000927266664803028],
    [118.513326305629, 24.8151669676573, 0.000927348621189594],
  ],
  [
    [118.513663713415, 24.8145134462061, 0.000927264802157879],
    [118.513308629478, 24.8151588620458, 0.00092734768986702],
  ],
  [
    [118.513646037346, 24.814505349661, 0.000927265733480453],
    [118.51329095334, 24.8151507654598, 0.000927344895899296],
  ],
  [
    [118.513628351377, 24.814497244097, 0.000927263870835304],
    [118.513273267302, 24.8151426598549, 0.000927344895899296],
  ],
  [
    [118.513610675313, 24.8144891475478, 0.000927262008190155],
    [118.513255591157, 24.815134554237, 0.000927343964576721],
  ],
  [
    [118.513592999239, 24.8144810419687, 0.000927262008190155],
    [118.513237915026, 24.8151264576447, 0.000927342101931572],
  ],
  [
    [118.513575323168, 24.8144729363875, 0.000927260145545006],
    [118.513220238886, 24.8151183520227, 0.000927341170608997],
  ],
  [
    [118.51355763722, 24.8144648398427, 0.000927260145545006],
    [118.513202552868, 24.8151102554369, 0.000927342101931572],
  ],
  [
    [118.513539961153, 24.8144567342574, 0.000927260145545006],
    [118.513184876733, 24.8151021498107, 0.000927340239286423],
  ],
  [
    [118.513522285088, 24.8144486286699, 0.000927258282899857],
    [118.513167200599, 24.8150940441823, 0.000927339307963848],
  ],
  [
    [118.513504609038, 24.8144405321079, 0.000927256420254707],
    [118.51314952448, 24.8150859475794, 0.000927337445318699],
  ],
  [
    [118.513486923087, 24.814432426527, 0.000927255488932133],
    [118.51313183846, 24.8150778419576, 0.000927337445318699],
  ],
  [
    [118.513469247041, 24.8144243299609, 0.000927254557609558],
    [118.513114162345, 24.8150697453505, 0.000927336513996124],
  ],
  [
    [118.513451570986, 24.814416224365, 0.000927253626286983],
    [118.513096486221, 24.8150616397137, 0.000927334651350975],
  ],
  [
    [118.513433894933, 24.8144081187669, 0.00092725083231926],
    [118.513078810099, 24.8150535340747, 0.000927332788705826],
  ],
  [
    [118.513416209003, 24.8144000222052, 0.000927252694964409],
    [118.5130611241, 24.8150454374721, 0.000927332788705826],
  ],
  [
    [118.513398532955, 24.814391916603, 0.000927249900996685],
    [118.513043447982, 24.8150373318289, 0.000927331857383251],
  ],
  [
    [118.513380856909, 24.8143838109986, 0.000927249900996685],
    [118.513025771867, 24.8150292261837, 0.000927331857383251],
  ],
  [
    [118.513363180877, 24.8143757144198, 0.000927248038351536],
    [118.513008095766, 24.8150211295639, 0.000927329063415527],
  ],
  [
    [118.513345494944, 24.814367608822, 0.000927248038351536],
    [118.512990409765, 24.8150130239252, 0.000927330926060677],
  ],
  [
    [118.513327818917, 24.814359512239, 0.000927246175706387],
    [118.512972733668, 24.8150049273013, 0.000927328132092953],
  ],
  [
    [118.51331014288, 24.8143514066262, 0.000927246175706387],
    [118.512955057562, 24.8149968216476, 0.000927327200770378],
  ],
  [
    [118.513292466845, 24.8143433010113, 0.000927245244383812],
    [118.512937381458, 24.8149887159917, 0.000927326269447804],
  ],
  [
    [118.513274780933, 24.8143352044327, 0.000927241519093513],
    [118.512919695478, 24.8149806193722, 0.00092732347548008],
  ],
  [
    [118.513257104903, 24.8143270988136, 0.000927243381738663],
    [118.512902019379, 24.8149725137122, 0.000927324406802654],
  ],
  [
    [118.513239428887, 24.81431900222, 0.000927241519093513],
    [118.512884343282, 24.81496440805, 0.00092732347548008],
  ],
  [
    [118.513221752862, 24.8143108965966, 0.000927240587770939],
    [118.512866667199, 24.8149563114134, 0.00092732161283493],
  ],
  [
    [118.513204066947, 24.814302790982, 0.000927239656448364],
    [118.512848981216, 24.8149482057578, 0.00092732161283493],
  ],
  [
    [118.513186390938, 24.8142946943821, 0.000927237793803215],
    [118.512831305138, 24.814940109117, 0.000927320681512356],
  ],
  [
    [118.513168714919, 24.8142865887524, 0.00092723686248064],
    [118.51281362905, 24.8149320034464, 0.000927317887544632],
  ],
  [
    [118.513151038903, 24.8142784831206, 0.000927237793803215],
    [118.512795952965, 24.8149238977737, 0.000927316956222057],
  ],
  [
    [118.51313335301, 24.8142703865251, 0.000927234068512917],
    [118.512778267002, 24.8149158011373, 0.000927317887544632],
  ],
  [
    [118.513115676998, 24.8142622808891, 0.000927234999835491],
    [118.512760590922, 24.8149076954604, 0.000927315093576908],
  ],
  [
    [118.513098001, 24.8142541842787, 0.000927233137190342],
    [118.512742914843, 24.8148995897814, 0.000927314162254334],
  ],
  [
    [118.513080324993, 24.8142460786384, 0.000927231274545193],
    [118.512725228876, 24.814891484111, 0.000927314162254334],
  ],
  [
    [118.513062658891, 24.814237982013, 0.000927230343222618],
    [118.512707542911, 24.8148833784385, 0.00092731136828661],
  ],
  [
    [118.513044992791, 24.8142298853854, 0.000927228480577469],
    [118.512689856948, 24.8148752727639, 0.00092731136828661],
  ],
  [
    [118.513027326694, 24.8142217887557, 0.000927230343222618],
    [118.512672170988, 24.8148671670872, 0.00092730950564146],
  ],
  [
    [118.513009660586, 24.8142136830963, 0.00092722661793232],
    [118.512654475127, 24.8148590523914, 0.00092730950564146],
  ],
  [
    [118.512991994494, 24.8142055864624, 0.00092722661793232],
    [118.51263677928, 24.8148509467212, 0.000927307642996311],
  ],
  [
    [118.512974338294, 24.8141974898157, 0.000927225686609745],
    [118.512619083423, 24.8148428320213, 0.000927307642996311],
  ],
  [
    [118.512956682097, 24.8141893931668, 0.00092722475528717],
    [118.512601387569, 24.8148347173192, 0.000927305780351162],
  ],
  [
    [118.512939025901, 24.8141812965158, 0.000927223823964596],
    [118.512583691706, 24.8148265935873, 0.000927305780351162],
  ],
  [
    [118.5129213796, 24.8141731998519, 0.000927222892642021],
    [118.512565995856, 24.814818478881, 0.000927303917706013],
  ],
  [
    [118.5129037333, 24.814165103186, 0.000927221029996872],
    [118.512548290106, 24.8148103551556, 0.000927302986383438],
  ],
  [
    [118.512886087003, 24.8141570065179, 0.000927221961319447],
    [118.51253059425, 24.8148022314174, 0.000927302055060863],
  ],
  [
    [118.512868450599, 24.814148909837, 0.000927219167351723],
    [118.512512888492, 24.8147940986602, 0.000927301123738289],
  ],
  [
    [118.512850804295, 24.8141408041371, 0.000927219167351723],
    [118.512495182749, 24.8147859749285, 0.00092729926109314],
  ],
  [
    [118.512833167895, 24.8141327074519, 0.000927217304706573],
    [118.512477476997, 24.814777842167, 0.000927298329770565],
  ],
  [
    [118.512815541389, 24.8141246107539, 0.000927216373383999],
    [118.512459761355, 24.8147697094142, 0.000927298329770565],
  ],
  [
    [118.512797914874, 24.8141165050262, 0.000927215442061424],
    [118.512442055595, 24.8147615676208, 0.00092729739844799],
  ],
  [
    [118.512780288372, 24.814108408324, 0.00092721451073885],
    [118.512424349838, 24.8147534258253, 0.000927296467125416],
  ],
  [
    [118.512762661861, 24.814100302592, 0.000927213579416275],
    [118.512406634192, 24.8147452840384, 0.000927294604480267],
  ],
  [
    [118.512745045255, 24.8140922058749, 0.0009272126480937],
    [118.512388918548, 24.8147371422494, 0.000927294604480267],
  ],
  [
    [118.51272742864, 24.814084100128, 0.000927210785448551],
    [118.512371202894, 24.8147289914306, 0.000927291810512543],
  ],
  [
    [118.512709812027, 24.8140759943789, 0.000927210785448551],
    [118.512353497134, 24.814720840599, 0.000927291810512543],
  ],
  [
    [118.512692205307, 24.8140678886171, 0.000927209854125977],
    [118.512335781474, 24.8147126807483, 0.000927289947867393],
  ],
  [
    [118.512674598578, 24.8140597738254, 0.000927208922803402],
    [118.512318055924, 24.8147045209063, 0.000927289947867393],
  ],
  [
    [118.512657001753, 24.8140516680486, 0.000927207060158253],
    [118.512300340269, 24.8146963610513, 0.000927289947867393],
  ],
  [
    [118.51263940492, 24.8140435532421, 0.000927207060158253],
    [118.512282624603, 24.8146881921666, 0.000927288085222244],
  ],
  [
    [118.512621808088, 24.8140354384334, 0.000927204266190529],
    [118.51226490894, 24.8146800232798, 0.000927288085222244],
  ],
  [
    [118.512604211259, 24.8140273236227, 0.000927204266190529],
    [118.512247183377, 24.8146718453739, 0.000927284359931946],
  ],
  [
    [118.512586624323, 24.8140192087991, 0.000927203334867954],
    [118.512229467706, 24.8146636674552, 0.000927283428609371],
  ],
  [
    [118.512569047269, 24.814011084935, 0.00092720240354538],
    [118.512211752027, 24.8146554805067, 0.000927283428609371],
  ],
  [
    [118.512551470228, 24.8140029700965, 0.00092720240354538],
    [118.512194026458, 24.8146472935667, 0.000927282497286797],
  ],
  [
    [118.512533893179, 24.8139948462282, 0.00092720054090023],
    [118.512176310783, 24.814639106614, 0.000927280634641647],
  ],
  [
    [118.51251632601, 24.8139867133194, 0.000927198678255081],
    [118.512158585208, 24.8146309106422, 0.000927280634641647],
  ],
  [
    [118.512498758856, 24.8139785894363, 0.000927197746932507],
    [118.512140859623, 24.8146227056405, 0.000927279703319073],
  ],
  [
    [118.512481191692, 24.8139704565233, 0.000927196815609932],
    [118.512123143932, 24.8146145006261, 0.000927276909351349],
  ],
  [
    [118.512463634422, 24.8139623235976, 0.000927196815609932],
    [118.512105418351, 24.8146062956202, 0.000927276909351349],
  ],
  [
    [118.512446077154, 24.8139541906697, 0.000927193090319633],
    [118.512087702653, 24.8145980815739, 0.000927275978028774],
  ],
  [
    [118.512428529767, 24.8139460487014, 0.000927193090319633],
    [118.512069977054, 24.8145898585084, 0.0009272750467062],
  ],
  [
    [118.512410982383, 24.813937906731, 0.000927191227674484],
    [118.512052251457, 24.8145816354409, 0.0009272750467062],
  ],
  [
    [118.51239344488, 24.8139297557201, 0.000927193090319633],
    [118.512034535742, 24.8145734033328, 0.00092727318406105],
  ],
  [
    [118.512375907391, 24.8139216137348, 0.000927192158997059],
    [118.512016810138, 24.8145651712333, 0.00092727318406105],
  ],
  [
    [118.512358379784, 24.813913462709, 0.000927189365029335],
    [118.511999094416, 24.8145569300934, 0.000927270390093327],
  ],
  [
    [118.512340852167, 24.8139053026535, 0.000927189365029335],
    [118.511981368805, 24.814548688962, 0.000927270390093327],
  ],
  [
    [118.512323324552, 24.8138971425959, 0.000927187502384186],
    [118.511963643185, 24.8145404388008, 0.000927268527448177],
  ],
  [
    [118.512305806831, 24.8138889825254, 0.000927186571061611],
    [118.511945927446, 24.8145321795992, 0.000927267596125603],
  ],
  [
    [118.512288298992, 24.8138808134146, 0.000927187502384186],
    [118.511928211698, 24.8145239113677, 0.000927267596125603],
  ],
  [
    [118.512270791154, 24.8138726443016, 0.000927183777093887],
    [118.511910486061, 24.8145156431449, 0.000927267596125603],
  ],
  [
    [118.512253283319, 24.8138644751866, 0.000927182845771313],
    [118.511892770318, 24.8145073749092, 0.000927264802157879],
  ],
  [
    [118.512235785366, 24.8138562970311, 0.000927181914448738],
    [118.511875054553, 24.814499088616, 0.000927263870835304],
  ],
  [
    [118.512218297305, 24.8138481188628, 0.000927181914448738],
    [118.5118573289, 24.8144908023315, 0.000927262008190155],
  ],
  [
    [118.512200809236, 24.8138399316648, 0.000927181914448738],
    [118.51183961314, 24.8144825160341, 0.000927262008190155],
  ],
  [
    [118.512183331059, 24.813831744454, 0.000927180051803589],
    [118.51182189736, 24.8144742116792, 0.000927259214222431],
  ],
  [
    [118.512165852873, 24.8138235482134, 0.000927177257835865],
    [118.511804181581, 24.8144659073223, 0.000927260145545006],
  ],
  [
    [118.51214837469, 24.8138153519708, 0.00092717632651329],
    [118.511786465793, 24.8144575939355, 0.000927258282899857],
  ],
  [
    [118.512130906387, 24.8138071466878, 0.00092717632651329],
    [118.511768759899, 24.8144492805359, 0.000927257351577282],
  ],
  [
    [118.512113447979, 24.813798941392, 0.000927175395190716],
    [118.511751044092, 24.8144409490896, 0.000927256420254707],
  ],
  [
    [118.51209598956, 24.8137907270664, 0.000927172601222992],
    [118.511733328288, 24.8144326176412, 0.000927254557609558],
  ],
  [
    [118.512078541035, 24.8137825127281, 0.000927174463868141],
    [118.511715622377, 24.8144242861799, 0.000927254557609558],
  ],
  [
    [118.512061092501, 24.81377428936, 0.000927173532545567],
    [118.511697916445, 24.8144159366612, 0.000927252694964409],
  ],
  [
    [118.512043653848, 24.8137660569515, 0.000927171669900417],
    [118.511680210504, 24.8144075781127, 0.000927251763641834],
  ],
  [
    [118.512026225088, 24.8137578245302, 0.000927169807255268],
    [118.511662504565, 24.8143992195621, 0.00092725083231926],
  ],
  [
    [118.512008796331, 24.8137495921069, 0.000927170738577843],
    [118.511644798617, 24.8143908519817, 0.000927249900996685],
  ],
  [
    [118.511991377455, 24.8137413506431, 0.000927167013287544],
    [118.511627092659, 24.8143824753715, 0.000927249900996685],
  ],
  [
    [118.51197395857, 24.8137331001497, 0.00092716608196497],
    [118.511609386704, 24.8143740987592, 0.000927248038351536],
  ],
  [
    [118.511956549578, 24.8137248496434, 0.00092716421931982],
    [118.511591690618, 24.8143657040788, 0.00092724896967411],
  ],
  [
    [118.511939140577, 24.8137165901075, 0.00092716421931982],
    [118.511573994536, 24.8143573093962, 0.000927246175706387],
  ],
  [
    [118.511921741457, 24.8137083215311, 0.000927163287997246],
    [118.511556288541, 24.8143488966669, 0.000927246175706387],
  ],
  [
    [118.51190435223, 24.813700052942, 0.00092716421931982],
    [118.51153860233, 24.8143404839141, 0.000927243381738663],
  ],
  [
    [118.511886962994, 24.8136917753232, 0.000927162356674671],
    [118.511520906219, 24.8143320621422, 0.000927243381738663],
  ],
  [
    [118.511869583652, 24.8136834976916, 0.000927161425352097],
    [118.511503210099, 24.8143236313405, 0.000927241519093513],
  ],
  [
    [118.511852214191, 24.8136752110196, 0.000927160494029522],
    [118.511485523861, 24.8143151914983, 0.000927240587770939],
  ],
  [
    [118.51183484472, 24.8136669153179, 0.000927159562706947],
    [118.511467837613, 24.8143067426264, 0.000927239656448364],
  ],
  [
    [118.511817485131, 24.8136586105758, 0.000927157700061798],
    [118.511450151368, 24.8142982937523, 0.000927237793803215],
  ],
  [
    [118.511800125544, 24.8136503058316, 0.000927157700061798],
    [118.511432465101, 24.8142898268208, 0.000927237793803215],
  ],
  [
    [118.511782775839, 24.8136419920471, 0.0009271539747715],
    [118.511414788717, 24.8142813508489, 0.000927234999835491],
  ],
  [
    [118.511765436016, 24.8136336692221, 0.000927154906094074],
    [118.511397102443, 24.8142728748855, 0.000927235931158066],
  ],
  [
    [118.511748096195, 24.8136253463952, 0.0009271539747715],
    [118.51137942604, 24.814264380854, 0.000927234068512917],
  ],
  [
    [118.511730776146, 24.8136170145171, 0.00092715211212635],
    [118.51136175953, 24.8142558868097, 0.000927234068512917],
  ],
  [
    [118.511713446197, 24.81360867362, 0.000927150249481201],
    [118.511344083109, 24.8142473747186, 0.000927231274545193],
  ],
  [
    [118.51169613602, 24.8136003236719, 0.000927149318158627],
    [118.511326416569, 24.8142388535871, 0.000927231274545193],
  ],
  [
    [118.511678825846, 24.8135919737217, 0.000927149318158627],
    [118.511308750031, 24.8142303324535, 0.000927229411900043],
  ],
  [
    [118.511661525553, 24.8135836147312, 0.000927147455513477],
    [118.511291083472, 24.8142217932624, 0.000927228480577469],
  ],
  [
    [118.511644235142, 24.8135752467002, 0.000927146524190903],
    [118.511273416904, 24.8142132450415, 0.000927227549254894],
  ],
  [
    [118.511626944722, 24.8135668696396, 0.000927146524190903],
    [118.51125576023, 24.8142046968079, 0.000927225686609745],
  ],
  [
    [118.511609664183, 24.8135584835386, 0.000927145592868328],
    [118.511238103535, 24.8141961305168, 0.00092722661793232],
  ],
  [
    [118.511592393537, 24.8135500974249, 0.000927143730223179],
    [118.511220456721, 24.8141875551853, 0.00092722475528717],
  ],
  [
    [118.511575122882, 24.8135417022815, 0.00092714186757803],
    [118.511202800007, 24.8141789708347, 0.000927223823964596],
  ],
  [
    [118.511557862097, 24.8135332890701, 0.000927142798900604],
    [118.511185153175, 24.8141703774437, 0.000927221961319447],
  ],
  [
    [118.511540611205, 24.813524875846, 0.00092714186757803],
    [118.511167516213, 24.8141617659845, 0.000927221961319447],
  ],
  [
    [118.511523370207, 24.8135164626092, 0.00092714000493288],
    [118.511149869362, 24.8141531545339, 0.000927220098674297],
  ],
  [
    [118.511506139078, 24.8135080313043, 0.000927138142287731],
    [118.511132232393, 24.8141445340429, 0.000927220098674297],
  ],
  [
    [118.51148890794, 24.8134995909698, 0.000927138142287731],
    [118.511114605294, 24.8141358954838, 0.000927216373383999],
  ],
  [
    [118.511471686695, 24.8134911506226, 0.000927135348320007],
    [118.511096968295, 24.8141272479056, 0.000927218236029148],
  ],
  [
    [118.511454475321, 24.8134826922074, 0.000927136279642582],
    [118.511079341178, 24.8141185912869, 0.000927217304706573],
  ],
  [
    [118.511437263948, 24.8134742337902, 0.000927135348320007],
    [118.511061723943, 24.8141099256278, 0.00092721451073885],
  ],
  [
    [118.511420062457, 24.8134657663326, 0.000927134416997433],
    [118.511044096807, 24.8141012509496, 0.000927215442061424],
  ],
  [
    [118.511402880727, 24.8134572807964, 0.000927132554352283],
    [118.511026479542, 24.8140925582034, 0.000927213579416275],
  ],
  [
    [118.511385698999, 24.8134487952581, 0.00092712976038456],
    [118.511008872158, 24.8140838564167, 0.000927211716771126],
  ],
  [
    [118.511368517262, 24.8134403006902, 0.000927130691707134],
    [118.510991264765, 24.8140751456002, 0.000927209854125977],
  ],
  [
    [118.511351355298, 24.8134317970713, 0.000927128829061985],
    [118.510973657363, 24.814066425754, 0.000927207991480827],
  ],
  [
    [118.511334193324, 24.8134232844227, 0.000927128829061985],
    [118.51095604994, 24.8140576878503, 0.000927207991480827],
  ],
  [
    [118.511317041232, 24.8134147627338, 0.00092712976038456],
    [118.51093845241, 24.814048949934, 0.000927206128835678],
  ],
  [
    [118.511299899021, 24.8134062320046, 0.000927125103771687],
    [118.510920864751, 24.8140401939495, 0.000927207060158253],
  ],
  [
    [118.511282766692, 24.8133976922351, 0.000927123241126537],
    [118.51090327707, 24.8140314199076, 0.000927204266190529],
  ],
  [
    [118.511265644245, 24.8133891434252, 0.000927123241126537],
    [118.510885689392, 24.8140226458636, 0.00092720240354538],
  ],
  [
    [118.511248521776, 24.813380576558, 0.000927121378481388],
    [118.510868111585, 24.8140138537516, 0.000927203334867954],
  ],
  [
    [118.511231419092, 24.8133720096675, 0.000927122309803963],
    [118.510850533768, 24.8140050526098, 0.00092720054090023],
  ],
  [
    [118.511214316399, 24.8133634337474, 0.000927119515836239],
    [118.51083295593, 24.8139962334105, 0.00092720054090023],
  ],
  [
    [118.511197223587, 24.813354848787, 0.000927119515836239],
    [118.510815387974, 24.8139874051709, 0.000927199609577656],
  ],
  [
    [118.511180140645, 24.8133462457586, 0.000927119515836239],
    [118.5107978299, 24.8139785678909, 0.000927198678255081],
  ],
  [
    [118.511163067596, 24.8133376427175, 0.00092711765319109],
    [118.510780271817, 24.8139697215811, 0.000927195884287357],
  ],
  [
    [118.511146004418, 24.8133290216085, 0.00092711579054594],
    [118.510762713713, 24.8139608572139, 0.000927195884287357],
  ],
  [
    [118.511128951132, 24.8133204004869, 0.00092711579054594],
    [118.51074516548, 24.8139519747787, 0.000927194021642208],
  ],
  [
    [118.511111897826, 24.813311761308, 0.000927114859223366],
    [118.510727617248, 24.8139430923414, 0.000927194021642208],
  ],
  [
    [118.511094864292, 24.8133031130781, 0.000927113927900791],
    [118.510710078887, 24.813934191836, 0.000927192158997059],
  ],
  [
    [118.511077830749, 24.8132944558186, 0.000927111133933067],
    [118.510692550396, 24.8139252732626, 0.000927191227674484],
  ],
  [
    [118.511060807088, 24.8132857895188, 0.000927112065255642],
    [118.510675012005, 24.81391634567, 0.000927189365029335],
  ],
  [
    [118.511043803199, 24.8132771141681, 0.000927107408642769],
    [118.510657493387, 24.8139074090265, 0.000927189365029335],
  ],
  [
    [118.511026799289, 24.8132684207601, 0.000927109271287918],
    [118.510639974748, 24.8138984543256, 0.000927186571061611],
  ],
  [
    [118.511009805272, 24.8132597273394, 0.000927106477320194],
    [118.5106224561, 24.8138894905949, 0.000927187502384186],
  ],
  [
    [118.510992821126, 24.8132510158509, 0.000927106477320194],
    [118.510604947323, 24.8138805087961, 0.000927185639739037],
  ],
  [
    [118.510975846861, 24.8132422953221, 0.00092710554599762],
    [118.510587448427, 24.8138715179571, 0.000927184708416462],
  ],
  [
    [118.510958882478, 24.813233565753, 0.00092710368335247],
    [118.51056994951, 24.8138625090605, 0.000927183777093887],
  ],
  [
    [118.510941927965, 24.813224818116, 0.000927101820707321],
    [118.510552450584, 24.8138534911343, 0.000927180983126163],
  ],
  [
    [118.510924983345, 24.8132160704664, 0.000927100889384747],
    [118.51053497142, 24.8138444551294, 0.000927182845771313],
  ],
  [
    [118.510908048595, 24.8132073047489, 0.000927100889384747],
    [118.510517492246, 24.8138354100948, 0.000927179120481014],
  ],
  [
    [118.510891123727, 24.8131985299911, 0.000927099026739597],
    [118.510500013052, 24.8138263470028, 0.000927177257835865],
  ],
  [
    [118.510874208728, 24.8131897371655, 0.000927099026739597],
    [118.510482543739, 24.8138172748704, 0.000927177257835865],
  ],
  [
    [118.510857303623, 24.8131809443272, 0.000927096232771873],
    [118.510465074406, 24.8138081846807, 0.000927175395190716],
  ],
  [
    [118.510840408389, 24.8131721334211, 0.000927095301449299],
    [118.510447624846, 24.8137990854399, 0.00092717632651329],
  ],
  [
    [118.510823523035, 24.8131633134747, 0.000927095301449299],
    [118.510430165374, 24.8137899681524, 0.000927175395190716],
  ],
  [
    [118.510806647552, 24.8131544754604, 0.000927094370126724],
    [118.510412725663, 24.8137808327863, 0.000927173532545567],
  ],
  [
    [118.510789781962, 24.8131456374335, 0.00092709343880415],
    [118.510395285944, 24.8137716883904, 0.000927171669900417],
  ],
  [
    [118.510772926242, 24.8131367813388, 0.000927091576159],
    [118.510377856094, 24.8137625259266, 0.000927171669900417],
  ],
  [
    [118.510756080393, 24.8131279071761, 0.000927089713513851],
    [118.510360426236, 24.813753354433, 0.000927169807255268],
  ],
  [
    [118.510739244436, 24.8131190330009, 0.000927089713513851],
    [118.510343006248, 24.8137441648714, 0.000927167944610119],
  ],
  [
    [118.510722428241, 24.8131101407472, 0.000927088782191277],
    [118.51032558625, 24.8137349662801, 0.000927167013287544],
  ],
  [
    [118.510705612024, 24.8131012304363, 0.000927086919546127],
    [118.510308186003, 24.8137257405825, 0.00092716608196497],
  ],
  [
    [118.510688805701, 24.8130923201128, 0.000927086919546127],
    [118.510290785746, 24.8137165058552, 0.00092716421931982],
  ],
  [
    [118.510672019139, 24.8130833917108, 0.000927085056900978],
    [118.510273385481, 24.8137072620982, 0.000927163287997246],
  ],
  [
    [118.510655232556, 24.8130744452516, 0.000927084125578403],
    [118.510256004965, 24.813697991235, 0.000927163287997246],
  ],
  [
    [118.510638465746, 24.8130654897415, 0.000927084125578403],
    [118.510238624451, 24.8136887203697, 0.000927162356674671],
  ],
  [
    [118.510621708817, 24.8130565251913, 0.000927082262933254],
    [118.510221253797, 24.8136794224087, 0.000927161425352097],
  ],
  [
    [118.510604961759, 24.8130475425731, 0.00092707946896553],
    [118.510203883121, 24.8136701063904, 0.000927157700061798],
  ],
  [
    [118.510588224582, 24.8130385509148, 0.000927078537642956],
    [118.510186522328, 24.8136607813318, 0.000927158631384373],
  ],
  [
    [118.510571497287, 24.8130295502164, 0.000927078537642956],
    [118.510169171417, 24.8136514472328, 0.000927156768739223],
  ],
  [
    [118.510554779862, 24.81302053145, 0.000927076674997807],
    [118.510151830364, 24.8136420860383, 0.000927154906094074],
  ],
  [
    [118.510538082209, 24.8130115036329, 0.000927076674997807],
    [118.510134489303, 24.813632715814, 0.000927154906094074],
  ],
  [
    [118.510521384536, 24.8130024577585, 0.000927074812352657],
    [118.510117168003, 24.8136233275112, 0.00092715211212635],
  ],
  [
    [118.510504706635, 24.8129934028334, 0.000927073881030083],
    [118.510099836791, 24.8136139211616, 0.000927153043448925],
  ],
  [
    [118.510488038605, 24.8129843298404, 0.000927073881030083],
    [118.510082525341, 24.8136044967334, 0.000927151180803776],
  ],
  [
    [118.510471380456, 24.8129752478073, 0.000927071087062359],
    [118.510065223772, 24.813595063265, 0.000927150249481201],
  ],
  [
    [118.510454732177, 24.8129661477063, 0.000927070155739784],
    [118.510047922183, 24.8135856117392, 0.000927146524190903],
  ],
  [
    [118.510438103671, 24.8129570385546, 0.00092706922441721],
    [118.510030630453, 24.8135761331177, 0.000927148386836052],
  ],
  [
    [118.510421475156, 24.8129479203733, 0.00092706736177206],
    [118.510013348616, 24.8135666544837, 0.000927145592868328],
  ],
  [
    [118.510404866402, 24.8129387841136, 0.000927066430449486],
    [118.509996076639, 24.8135571487541, 0.000927145592868328],
  ],
  [
    [118.510388267518, 24.8129296297861, 0.000927064567804337],
    [118.50997880464, 24.8135476249671, 0.000927143730223179],
  ],
  [
    [118.510371678515, 24.8129204664184, 0.000927064567804337],
    [118.509961552415, 24.8135380921292, 0.00092714186757803],
  ],
  [
    [118.510355109274, 24.8129112849724, 0.000927061773836613],
    [118.509944300169, 24.813528541234, 0.000927140936255455],
  ],
  [
    [118.510338549914, 24.8129020944862, 0.000927061773836613],
    [118.509927057794, 24.8135189722709, 0.00092714000493288],
  ],
  [
    [118.510321990522, 24.8128928769151, 0.000927060842514038],
    [118.509909825289, 24.8135093852398, 0.000927138142287731],
  ],
  [
    [118.510305450915, 24.812883659321, 0.000927059911191463],
    [118.509892612545, 24.8134997801303, 0.000927139073610306],
  ],
  [
    [118.510288911274, 24.812874414642, 0.000927058979868889],
    [118.509875399793, 24.8134901659911, 0.000927135348320007],
  ],
  [
    [118.510272391407, 24.8128651609123, 0.000927056185901165],
    [118.509858206802, 24.8134805337733, 0.000927135348320007],
  ],
  [
    [118.510255881421, 24.8128558981424, 0.00092705711722374],
    [118.50984101379, 24.8134708834983, 0.000927134416997433],
  ],
  [
    [118.510239371403, 24.8128466082878, 0.000927053391933441],
    [118.509823840551, 24.8134612241724, 0.000927133485674858],
  ],
  [
    [118.510222881158, 24.8128373093824, 0.000927052460610867],
    [118.509806677183, 24.8134515467786, 0.000927131623029709],
  ],
  [
    [118.510206400783, 24.8128279924092, 0.000927052460610867],
    [118.509789523686, 24.8134418513169, 0.000927130691707134],
  ],
  [
    [118.510189930289, 24.8128186663959, 0.000927052460610867],
    [118.509772370168, 24.8134321377979, 0.00092712976038456],
  ],
  [
    [118.510173459775, 24.8128093223255, 0.000927051529288292],
    [118.509755236422, 24.8134224152281, 0.00092712789773941],
  ],
  [
    [118.510157009022, 24.8127999601767, 0.000927049666643143],
    [118.509738112548, 24.8134126745904, 0.000927126966416836],
  ],
  [
    [118.51014056815, 24.8127905889878, 0.000927048735320568],
    [118.509721008435, 24.8134029158743, 0.000927126035094261],
  ],
  [
    [118.510124137149, 24.8127811997311, 0.000927047803997993],
    [118.509703904301, 24.8133931391008, 0.000927124172449112],
  ],
  [
    [118.510107716018, 24.8127717924067, 0.000927045941352844],
    [118.509686810049, 24.8133833532872, 0.000927123241126537],
  ],
  [
    [118.510091304769, 24.8127623760422, 0.00092704501003027],
    [118.509669725668, 24.8133735494056, 0.000927119515836239],
  ],
  [
    [118.51007490339, 24.81275294161, 0.00092704314738512],
    [118.509652661049, 24.8133637274456, 0.000927121378481388],
  ],
  [
    [118.510058511881, 24.81274348911, 0.000927042216062546],
    [118.50963559642, 24.813353896456, 0.000927120447158813],
  ],
  [
    [118.510042140145, 24.8127340275593, 0.000927039422094822],
    [118.509618551541, 24.8133440383602, 0.000927116721868515],
  ],
  [
    [118.510025768388, 24.8127245479515, 0.000927038490772247],
    [118.509601516556, 24.813334180252, 0.000927116721868515],
  ],
  [
    [118.510009406501, 24.8127150502759, 0.000927038490772247],
    [118.509584491431, 24.8133242950482, 0.000927116721868515],
  ],
  [
    [118.509993064388, 24.8127055435497, 0.000927037559449673],
    [118.509567476187, 24.8133144008042, 0.000927114859223366],
  ],
  [
    [118.509976722253, 24.8126960187664, 0.000927036628127098],
    [118.509550470802, 24.8133044794648, 0.000927112996578217],
  ],
  [
    [118.509960389989, 24.8126864759153, 0.000927034765481949],
    [118.50953347531, 24.8132945581128, 0.000927113927900791],
  ],
  [
    [118.509944077497, 24.8126769240136, 0.0009270329028368],
    [118.509516489678, 24.8132846096652, 0.000927111133933067],
  ],
  [
    [118.509927774875, 24.8126673540442, 0.0009270329028368],
    [118.509499513928, 24.8132746521776, 0.000927110202610493],
  ],
  [
    [118.509911472233, 24.8126577660176, 0.00092703104019165],
    [118.509482557939, 24.8132646766115, 0.000927108339965343],
  ],
  [
    [118.509895189364, 24.8126481689404, 0.00092703104019165],
    [118.50946560193, 24.8132546829881, 0.000927104614675045],
  ],
  [
    [118.509878916365, 24.8126385537955, 0.000927028246223927],
    [118.509448665694, 24.813244680314, 0.00092710368335247],
  ],
  [
    [118.509862643356, 24.8126289296211, 0.000927027314901352],
    [118.509431739328, 24.8132346595721, 0.00092710368335247],
  ],
  [
    [118.509846390109, 24.8126192873685, 0.000927025452256203],
    [118.509414822834, 24.8132246207624, 0.000927102752029896],
  ],
  [
    [118.509830146732, 24.8126096270481, 0.000927025452256203],
    [118.509397916221, 24.8132145729125, 0.000927100889384747],
  ],
  [
    [118.509813913237, 24.8125999576877, 0.000927024520933628],
    [118.509381019467, 24.8132044979672, 0.000927100889384747],
  ],
  [
    [118.509797699504, 24.8125902702491, 0.00092702079564333],
    [118.509364132595, 24.8131944139817, 0.000927099958062172],
  ],
  [
    [118.509781485749, 24.8125805647533, 0.000927021726965904],
    [118.509347255606, 24.813184320956, 0.000927097164094448],
  ],
  [
    [118.509765281876, 24.8125708502175, 0.00092702079564333],
    [118.509330398366, 24.8131742008243, 0.000927097164094448],
  ],
  [
    [118.509749087874, 24.8125611176141, 0.00092701893299818],
    [118.509313551009, 24.8131640716525, 0.000927095301449299],
  ],
  [
    [118.509732913633, 24.8125513669324, 0.000927017070353031],
    [118.509296703643, 24.8131539334511, 0.00092709343880415],
  ],
  [
    [118.509716739382, 24.8125416072212, 0.000927017070353031],
    [118.509279876026, 24.8131437681437, 0.00092709343880415],
  ],
  [
    [118.509700584893, 24.8125318294318, 0.000927016139030457],
    [118.509263058292, 24.8131335937962, 0.000927091576159],
  ],
  [
    [118.509684440286, 24.8125220426024, 0.000927013345062733],
    [118.509246250429, 24.8131234013809, 0.000927089713513851],
  ],
  [
    [118.509668295658, 24.8125122377159, 0.000927013345062733],
    [118.509229452447, 24.8131131999255, 0.000927088782191277],
  ],
  [
    [118.509652170792, 24.8125024147512, 0.000927011482417583],
    [118.509212674228, 24.8131029803917, 0.000927087850868702],
  ],
  [
    [118.509636055795, 24.8124925737188, 0.000927010551095009],
    [118.509195895988, 24.8130927428008, 0.000927086919546127],
  ],
  [
    [118.509619950681, 24.8124827236464, 0.000927009619772434],
    [118.509179137509, 24.8130824871315, 0.000927084125578403],
  ],
  [
    [118.509603855448, 24.812472864534, 0.000927007757127285],
    [118.509162388913, 24.8130722224221, 0.000927082262933254],
  ],
  [
    [118.509587779977, 24.8124629873435, 0.00092700682580471],
    [118.509145650187, 24.8130619396449, 0.00092708133161068],
  ],
  [
    [118.509571704484, 24.8124530920958, 0.000927004963159561],
    [118.509128921332, 24.8130516388, 0.000927080400288105],
  ],
  [
    [118.509555638863, 24.8124431787805, 0.000927004031836987],
    [118.509112202359, 24.813041328915, 0.00092707946896553],
  ],
  [
    [118.509539593014, 24.8124332564146, 0.000927002169191837],
    [118.509095493256, 24.8130310009622, 0.000927078537642956],
  ],
  [
    [118.509523557035, 24.8124233159812, 0.000927001237869263],
    [118.509078803916, 24.8130206549311, 0.000927077606320381],
  ],
  [
    [118.509507521048, 24.8124133665183, 0.000927001237869263],
    [118.509062114566, 24.8130102998705, 0.000927074812352657],
  ],
  [
    [118.509491504821, 24.8124033989772, 0.000926998443901539],
    [118.509045444967, 24.812999917704, 0.000927075743675232],
  ],
  [
    [118.509475498465, 24.8123934133685, 0.000926998443901539],
    [118.509028785261, 24.812989535525, 0.000927072949707508],
  ],
  [
    [118.509459501991, 24.8123834187198, 0.00092699658125639],
    [118.509012135414, 24.8129791262507, 0.000927072018384933],
  ],
  [
    [118.509443515387, 24.8123734060035, 0.00092699658125639],
    [118.508995505341, 24.8129687079257, 0.000927070155739784],
  ],
  [
    [118.509427548556, 24.8123633842368, 0.00092699471861124],
    [118.508978875247, 24.8129582715436, 0.000927068293094635],
  ],
  [
    [118.509411581704, 24.8123533444129, 0.000926992855966091],
    [118.508962264927, 24.8129478261108, 0.000927066430449486],
  ],
  [
    [118.509395634614, 24.8123432865109, 0.000926990061998367],
    [118.508945654574, 24.8129373535932, 0.000927066430449486],
  ],
  [
    [118.509379687514, 24.8123332195795, 0.000926988199353218],
    [118.508929063995, 24.812926872025, 0.000927065499126911],
  ],
  [
    [118.509363760176, 24.81232313457, 0.000926989130675793],
    [118.508912483298, 24.8129163814168, 0.000927064567804337],
  ],
  [
    [118.509347842708, 24.8123130314929, 0.000926988199353218],
    [118.508895922362, 24.8129058727304, 0.000927061773836613],
  ],
  [
    [118.509331935122, 24.8123029193758, 0.000926987268030643],
    [118.508879361407, 24.8128953459867, 0.000927061773836613],
  ],
  [
    [118.509316037418, 24.8122927982188, 0.000926986336708069],
    [118.508862820212, 24.8128848011648, 0.000927059911191463],
  ],
  [
    [118.509300149573, 24.8122826499665, 0.00092698261141777],
    [118.50884627901, 24.8128742473134, 0.000927059911191463],
  ],
  [
    [118.509284281501, 24.8122724926638, 0.000926981680095196],
    [118.508829757568, 24.8128636753838, 0.000927058048546314],
  ],
  [
    [118.50926841342, 24.8122623263317, 0.000926981680095196],
    [118.508813245998, 24.8128530853865, 0.000927056185901165],
  ],
  [
    [118.5092525651, 24.8122521419215, 0.000926980748772621],
    [118.508796754201, 24.8128424863387, 0.000927053391933441],
  ],
  [
    [118.509236716759, 24.8122419394543, 0.000926979817450047],
    [118.508780262383, 24.8128318692337, 0.000927052460610867],
  ],
  [
    [118.509220888191, 24.8122317279366, 0.000926977954804897],
    [118.508763790339, 24.8128212430782, 0.000927051529288292],
  ],
  [
    [118.509205069494, 24.8122214983513, 0.000926977954804897],
    [118.508747318274, 24.8128105988654, 0.000927049666643143],
  ],
  [
    [118.509189260667, 24.8122112506985, 0.000926975160837173],
    [118.508730865971, 24.8127999365745, 0.000927049666643143],
  ],
  [
    [118.509173471613, 24.8122009939952, 0.000926974229514599],
    [118.508714423539, 24.812789256216, 0.000927048735320568],
  ],
  [
    [118.509157682538, 24.812190719235, 0.000926971435546875],
    [118.50869800088, 24.8127785668069, 0.000927046872675419],
  ],
  [
    [118.509141913236, 24.8121804354243, 0.000926971435546875],
    [118.5086815782, 24.8127678593407, 0.00092704501003027],
  ],
  [
    [118.509126143914, 24.8121701335565, 0.000926968641579151],
    [118.508665175283, 24.8127571337963, 0.00092704314738512],
  ],
  [
    [118.509110394364, 24.8121598226384, 0.000926968641579151],
    [118.508648782247, 24.8127463992119, 0.00092704314738512],
  ],
  [
    [118.509094654685, 24.8121494936527, 0.000926966778934002],
    [118.508632399082, 24.8127356465598, 0.000927040353417397],
  ],
  [
    [118.509078924877, 24.8121391465995, 0.000926964916288853],
    [118.5086160258, 24.8127248848678, 0.000927039422094822],
  ],
  [
    [118.509063214841, 24.8121287904958, 0.000926963984966278],
    [118.508599672279, 24.8127141050976, 0.000927037559449673],
  ],
  [
    [118.509047504784, 24.8121184163352, 0.000926963053643703],
    [118.508583328629, 24.8127033072598, 0.000927034765481949],
  ],
  [
    [118.509031814501, 24.8121080331242, 0.000926961190998554],
    [118.508566984959, 24.8126924913648, 0.000927035696804523],
  ],
  [
    [118.509016124185, 24.8120976228285, 0.000926962122321129],
    [118.508550670953, 24.8126816664089, 0.000927033834159374],
  ],
  [
    [118.509000453654, 24.8120872125101, 0.000926961190998554],
    [118.508534356927, 24.8126708233958, 0.0009270329028368],
  ],
  [
    [118.508984792993, 24.8120767841241, 0.000926957465708256],
    [118.508518052783, 24.8126599713428, 0.000927030108869076],
  ],
  [
    [118.508969152094, 24.8120663376601, 0.000926956534385681],
    [118.5085017684, 24.8126491012117, 0.000927029177546501],
  ],
  [
    [118.508953511186, 24.8120558821668, 0.000926955603063107],
    [118.508485493889, 24.8126382130129, 0.000927027314901352],
  ],
  [
    [118.508937890039, 24.8120454085955, 0.000926953740417957],
    [118.508469229259, 24.8126273157742, 0.000927029177546501],
  ],
  [
    [118.508922268871, 24.8120349169672, 0.000926951877772808],
    [118.508452974501, 24.8126164004678, 0.000927025452256203],
  ],
  [
    [118.508906667477, 24.8120244162885, 0.000926950946450233],
    [118.508436739504, 24.8126054670834, 0.000927026383578777],
  ],
  [
    [118.508891075953, 24.8120138975423, 0.000926949083805084],
    [118.508420514389, 24.812594524659, 0.000927023589611053],
  ],
  [
    [118.50887549431, 24.8120033697563, 0.00092694815248251],
    [118.508404299146, 24.8125835641671, 0.000927022658288479],
  ],
  [
    [118.50885993243, 24.8119928238922, 0.00092694815248251],
    [118.508388093784, 24.8125725946351, 0.00092702079564333],
  ],
  [
    [118.50884437054, 24.8119822689989, 0.000926945358514786],
    [118.508371898282, 24.812561598008, 0.00092701893299818],
  ],
  [
    [118.508828828411, 24.8119716960276, 0.000926945358514786],
    [118.508355722564, 24.812550601358, 0.000927017070353031],
  ],
  [
    [118.508813296165, 24.8119611140164, 0.000926943495869637],
    [118.508339556706, 24.8125395776129, 0.000927015207707882],
  ],
  [
    [118.508797773789, 24.8119505139378, 0.000926942564547062],
    [118.50832340073, 24.8125285448278, 0.000927016139030457],
  ],
  [
    [118.508782261284, 24.8119398957916, 0.000926939770579338],
    [118.508307254625, 24.8125174939751, 0.000927013345062733],
  ],
  [
    [118.508766768551, 24.8119292685952, 0.000926937907934189],
    [118.508291128293, 24.812506434072, 0.000927011482417583],
  ],
  [
    [118.508751275798, 24.8119186233418, 0.000926937907934189],
    [118.508275001941, 24.8124953561119, 0.000927010551095009],
  ],
  [
    [118.508735802818, 24.8119079690381, 0.000926936976611614],
    [118.508258895362, 24.8124842691013, 0.00092700868844986],
  ],
  [
    [118.508720339708, 24.8118972966669, 0.00092693418264389],
    [118.508242798643, 24.8124731549955, 0.000927009619772434],
  ],
  [
    [118.508704886469, 24.8118866062283, 0.000926933251321316],
    [118.508226721696, 24.8124620318394, 0.000927007757127285],
  ],
  [
    [118.508689443112, 24.8118759067499, 0.000926931388676167],
    [118.508210654632, 24.8124508996433, 0.000927005894482136],
  ],
  [
    [118.508674019527, 24.8118651982212, 0.000926931388676167],
    [118.508194587548, 24.8124397493902, 0.000927004031836987],
  ],
  [
    [118.508658605802, 24.8118544625973, 0.000926929526031017],
    [118.508178550117, 24.8124285810486, 0.000927002169191837],
  ],
  [
    [118.508643192079, 24.8118437269719, 0.000926927663385868],
    [118.508162512677, 24.8124174036775, 0.000927001237869263],
  ],
  [
    [118.508627807997, 24.8118329642303, 0.000926925800740719],
    [118.508146494998, 24.8124062082285, 0.000926999375224113],
  ],
  [
    [118.508612423918, 24.8118222014872, 0.000926925800740719],
    [118.5081304773, 24.8123949947223, 0.000926998443901539],
  ],
  [
    [118.508597049697, 24.8118114116489, 0.000926924869418144],
    [118.508114489266, 24.8123837721554, 0.00092699471861124],
  ],
  [
    [118.50858169525, 24.8118006127603, 0.000926923006772995],
    [118.508098501211, 24.8123725315314, 0.000926995649933815],
  ],
  [
    [118.508566350684, 24.811789804832, 0.000926921144127846],
    [118.50808253293, 24.8123612818571, 0.000926992855966091],
  ],
  [
    [118.508551015989, 24.8117789788363, 0.000926921144127846],
    [118.508066564629, 24.8123500141257, 0.000926992855966091],
  ],
  [
    [118.508535691165, 24.8117681347732, 0.000926918350160122],
    [118.50805062598, 24.8123387283058, 0.000926990993320942],
  ],
  [
    [118.508520386113, 24.8117572816598, 0.000926919281482697],
    [118.508034687323, 24.8123274334566, 0.000926990061998367],
  ],
  [
    [118.508505081052, 24.8117464195171, 0.000926914624869823],
    [118.508018758537, 24.8123161205398, 0.000926990993320942],
  ],
  [
    [118.508489795742, 24.8117355302689, 0.000926914624869823],
    [118.508002849524, 24.8123047985728, 0.000926988199353218],
  ],
  [
    [118.508474520325, 24.8117246410086, 0.000926912762224674],
    [118.507986950382, 24.8122934585382, 0.000926986336708069],
  ],
  [
    [118.508459264658, 24.8117137246427, 0.0009269118309021],
    [118.507971071001, 24.8122821004257, 0.000926985405385494],
  ],
  [
    [118.508444008993, 24.8117028082753, 0.000926910899579525],
    [118.507955201503, 24.8122707332733, 0.00092698261141777],
  ],
  [
    [118.508428773078, 24.8116918648023, 0.00092690996825695],
    [118.507939331985, 24.8122593480639, 0.000926980748772621],
  ],
  [
    [118.508413547046, 24.8116809122895, 0.000926907174289227],
    [118.507923492119, 24.8122479447661, 0.000926979817450047],
  ],
  [
    [118.508398330895, 24.8116699507371, 0.000926907174289227],
    [118.507907652245, 24.8122365324388, 0.000926978886127472],
  ],
  [
    [118.508383124615, 24.8116589711172, 0.000926904380321503],
    [118.507891832133, 24.8122251020337, 0.000926976092159748],
  ],
  [
    [118.508367938096, 24.8116479734195, 0.000926904380321503],
    [118.507876021903, 24.8122136625888, 0.000926975160837173],
  ],
  [
    [118.50835276146, 24.8116369666821, 0.000926902517676353],
    [118.507860221544, 24.8122022050763, 0.000926974229514599],
  ],
  [
    [118.508337594705, 24.811625950905, 0.000926901586353779],
    [118.507844431067, 24.8121907385241, 0.00092697236686945],
  ],
  [
    [118.508322437821, 24.8116149170604, 0.00092689972370863],
    [118.507828660352, 24.8121792538939, 0.0009269705042243],
  ],
  [
    [118.508307300698, 24.8116038651381, 0.000926898792386055],
    [118.507812899508, 24.8121677511963, 0.000926969572901726],
  ],
  [
    [118.508292163567, 24.8115928041865, 0.000926895067095757],
    [118.507797158437, 24.8121562394485, 0.000926968641579151],
  ],
  [
    [118.508277046197, 24.811581725157, 0.000926894135773182],
    [118.507781417347, 24.8121447096435, 0.000926966778934002],
  ],
  [
    [118.508261938709, 24.8115706370879, 0.000926893204450607],
    [118.507765696018, 24.8121331617608, 0.000926963053643703],
  ],
  [
    [118.508246850982, 24.8115595309409, 0.000926892273128033],
    [118.507749984571, 24.8121216048382, 0.000926963984966278],
  ],
  [
    [118.508231763247, 24.8115484157647, 0.000926890410482883],
    [118.507734292897, 24.8121100388654, 0.000926961190998554],
  ],
  [
    [118.508216695272, 24.8115372825107, 0.000926890410482883],
    [118.507718611095, 24.8120984548251, 0.00092696025967598],
  ],
  [
    [118.50820163718, 24.811526140217, 0.000926886685192585],
    [118.507702939163, 24.8120868527174, 0.000926959328353405],
  ],
  [
    [118.50818659885, 24.8115149798455, 0.00092688575387001],
    [118.507687277114, 24.8120752415699, 0.00092695839703083],
  ],
  [
    [118.50817156051, 24.8115038104448, 0.00092688575387001],
    [118.507671624935, 24.812063612355, 0.000926955603063107],
  ],
  [
    [118.508156541932, 24.8114926229663, 0.000926883891224861],
    [118.507655992519, 24.8120519650622, 0.000926953740417957],
  ],
  [
    [118.508141533225, 24.8114814174204, 0.000926882959902287],
    [118.507640379875, 24.8120403087193, 0.000926952809095383],
  ],
  [
    [118.508126544291, 24.8114702028244, 0.000926882028579712],
    [118.507624767212, 24.8120286343193, 0.000926951877772808],
  ],
  [
    [118.508111555347, 24.8114589791992, 0.000926878303289413],
    [118.507609174322, 24.8120169508691, 0.000926950946450233],
  ],
  [
    [118.508096586165, 24.8114477374963, 0.000926878303289413],
    [118.507593591303, 24.8120052493516, 0.000926949083805084],
  ],
  [
    [118.508081626866, 24.8114364867536, 0.000926876440644264],
    [118.507578018166, 24.8119935387942, 0.000926947221159935],
  ],
  [
    [118.508066677436, 24.8114252179437, 0.000926874577999115],
    [118.507562464791, 24.8119818101591, 0.000926944427192211],
  ],
  [
    [118.508051747768, 24.811413931056, 0.00092687364667654],
    [118.507546921287, 24.8119700634565, 0.000926945358514786],
  ],
  [
    [118.508036827983, 24.8114026351286, 0.000926872715353966],
    [118.507531387665, 24.8119583077142, 0.000926943495869637],
  ],
  [
    [118.508021918079, 24.8113913301616, 0.000926869921386242],
    [118.507515873816, 24.8119465429217, 0.000926940701901913],
  ],
  [
    [118.508007018046, 24.8113800071273, 0.000926871784031391],
    [118.507500369827, 24.8119347510342, 0.000926939770579338],
  ],
  [
    [118.507992127883, 24.8113686660256, 0.000926868990063667],
    [118.507484875721, 24.8119229501069, 0.000926938839256763],
  ],
  [
    [118.507977257494, 24.8113573158739, 0.000926868058741093],
    [118.507469391497, 24.8119111401399, 0.00092693604528904],
  ],
  [
    [118.507962396986, 24.8113459566826, 0.00092686340212822],
    [118.507453927034, 24.8118993120951, 0.00092693604528904],
  ],
  [
    [118.50794755624, 24.8113345794135, 0.000926864333450794],
    [118.507438472454, 24.8118874750106, 0.000926933251321316],
  ],
  [
    [118.507932715474, 24.8113231840876, 0.000926862470805645],
    [118.507423037636, 24.8118756198483, 0.000926933251321316],
  ],
  [
    [118.50791789448, 24.8113117797116, 0.000926860608160496],
    [118.507407612689, 24.8118637466186, 0.000926930457353592],
  ],
  [
    [118.507903083369, 24.811300366296, 0.000926859676837921],
    [118.507392197624, 24.8118518643493, 0.000926928594708443],
  ],
  [
    [118.507888292019, 24.8112889348027, 0.000926857814192772],
    [118.50737679243, 24.8118399640125, 0.000926927663385868],
  ],
  [
    [118.507873500649, 24.8112774852526, 0.000926856882870197],
    [118.507361407009, 24.8118280546256, 0.000926926732063293],
  ],
  [
    [118.507858729052, 24.8112660266524, 0.000926855951547623],
    [118.507346031459, 24.8118161271714, 0.00092692393809557],
  ],
  [
    [118.507843967336, 24.8112545590126, 0.000926853157579899],
    [118.507330665792, 24.8118041906775, 0.00092692393809557],
  ],
  [
    [118.507829225383, 24.811243073295, 0.000926852226257324],
    [118.507315319886, 24.8117922361058, 0.000926923006772995],
  ],
  [
    [118.507814493311, 24.8112315785379, 0.000926850363612175],
    [118.507299983852, 24.8117802634668, 0.000926920212805271],
  ],
  [
    [118.50779977111, 24.8112200657136, 0.0009268494322896],
    [118.5072846577, 24.811768281788, 0.000926918350160122],
  ],
  [
    [118.507785058779, 24.811208534822, 0.000926846638321877],
    [118.507269351321, 24.8117562910592, 0.000926917418837547],
  ],
  [
    [118.507770366222, 24.8111969948803, 0.000926844775676727],
    [118.507254054801, 24.8117442732354, 0.000926915556192398],
  ],
  [
    [118.507755673656, 24.8111854459095, 0.000926844775676727],
    [118.507238768176, 24.8117322553996, 0.000926913693547249],
  ],
  [
    [118.507741010742, 24.8111738788506, 0.000926843844354153],
    [118.5072235013, 24.8117202104584, 0.000926912762224674],
  ],
  [
    [118.507726347819, 24.8111623027626, 0.000926842913031578],
    [118.507208244319, 24.8117081655052, 0.000926910899579525],
  ],
  [
    [118.507711704658, 24.8111507085969, 0.000926841981709003],
    [118.507192997197, 24.811696093457, 0.000926910899579525],
  ],
  [
    [118.507697071378, 24.8111391053916, 0.00092683918774128],
    [118.50717776986, 24.8116840213865, 0.000926909036934376],
  ],
  [
    [118.50768244797, 24.8111274841191, 0.00092683918774128],
    [118.507162552383, 24.8116719222209, 0.000926907174289227],
  ],
  [
    [118.507667844334, 24.8111158537966, 0.000926835462450981],
    [118.507147344787, 24.8116598140157, 0.000926905311644077],
  ],
  [
    [118.507653250569, 24.8111042054068, 0.000926836393773556],
    [118.507132156965, 24.8116476967604, 0.000926902517676353],
  ],
  [
    [118.507638666686, 24.8110925479776, 0.000926831737160683],
    [118.507116979014, 24.8116355614379, 0.000926901586353779],
  ],
  [
    [118.507624092674, 24.8110808724811, 0.000926832668483257],
    [118.507101810935, 24.811623408048, 0.000926901586353779],
  ],
  [
    [118.507609538434, 24.8110691879346, 0.000926829874515533],
    [118.507086662628, 24.8116112456081, 0.000926898792386055],
  ],
  [
    [118.507594994066, 24.8110574853209, 0.000926828943192959],
    [118.507071524204, 24.8115990741286, 0.000926895998418331],
  ],
  [
    [118.507580459579, 24.8110457736677, 0.000926828011870384],
    [118.507056405541, 24.8115868845714, 0.00092689786106348],
  ],
  [
    [118.507565944865, 24.8110340529645, 0.00092682521790266],
    [118.50704129675, 24.8115746769469, 0.000926894135773182],
  ],
  [
    [118.507551440022, 24.8110223141941, 0.00092682521790266],
    [118.507026197841, 24.8115624602828, 0.000926892273128033],
  ],
  [
    [118.50753694505, 24.8110105573565, 0.000926822423934937],
    [118.507011108803, 24.8115502255514, 0.000926891341805458],
  ],
  [
    [118.50752246985, 24.810998791469, 0.000926822423934937],
    [118.506996039538, 24.81153798177, 0.000926889479160309],
  ],
  [
    [118.507508004533, 24.8109870165419, 0.000926818698644638],
    [118.506980980144, 24.8115257199213, 0.000926889479160309],
  ],
  [
    [118.507493549086, 24.8109752235477, 0.000926818698644638],
    [118.506965940523, 24.8115134490226, 0.000926886685192585],
  ],
  [
    [118.507479103521, 24.8109634215139, 0.000926816835999489],
    [118.506950910774, 24.8115011600567, 0.00092688575387001],
  ],
  [
    [118.507464677718, 24.8109516014026, 0.000926816835999489],
    [118.506935890907, 24.8114888620512, 0.000926882959902287],
  ],
  [
    [118.507450261797, 24.8109397722517, 0.00092681311070919],
    [118.506920890801, 24.811476545968, 0.000926882959902287],
  ],
  [
    [118.507435865637, 24.8109279250232, 0.000926812179386616],
    [118.506905900578, 24.8114642208453, 0.000926880165934563],
  ],
  [
    [118.507421469469, 24.8109160687657, 0.000926810316741467],
    [118.506890920227, 24.8114518776553, 0.000926878303289413],
  ],
  [
    [118.507407093062, 24.8109041944306, 0.000926809385418892],
    [118.506875959648, 24.8114395254153, 0.000926877371966839],
  ],
  [
    [118.507392736428, 24.8108923110455, 0.000926809385418892],
    [118.50686100894, 24.8114271551081, 0.00092687550932169],
  ],
  [
    [118.507378379785, 24.8108804186314, 0.000926807522773743],
    [118.506846077995, 24.8114147667233, 0.000926874577999115],
  ],
  [
    [118.507364042904, 24.8108685081397, 0.000926804728806019],
    [118.506831156943, 24.8114023783265, 0.000926872715353966],
  ],
  [
    [118.507349725784, 24.8108565795705, 0.000926805660128593],
    [118.50681624575, 24.8113899628349, 0.000926871784031391],
  ],
  [
    [118.507335408656, 24.8108446419722, 0.00092680100351572],
    [118.506801354331, 24.8113775382933, 0.000926868058741093],
  ],
  [
    [118.5073211113, 24.810832695324, 0.000926800072193146],
    [118.506786472795, 24.8113651047122, 0.000926868058741093],
  ],
  [
    [118.507306833706, 24.8108207305982, 0.000926798209547997],
    [118.506771601129, 24.8113526530638, 0.000926866196095943],
  ],
  [
    [118.507292556103, 24.8108087568434, 0.000926797278225422],
    [118.506756749237, 24.8113401923656, 0.000926864333450794],
  ],
  [
    [118.507278298273, 24.8107967740387, 0.000926796346902847],
    [118.506741907215, 24.8113277136001, 0.00092686340212822],
  ],
  [
    [118.507264050314, 24.8107847731669, 0.000926793552935123],
    [118.506727084956, 24.811315216757, 0.00092686153948307],
  ],
  [
    [118.507249822116, 24.8107727542175, 0.000926792621612549],
    [118.506712262699, 24.8113027199124, 0.000926859676837921],
  ],
  [
    [118.507235603801, 24.8107607262287, 0.0009267907589674],
    [118.506697470084, 24.8112901959522, 0.000926858745515347],
  ],
  [
    [118.507221395367, 24.8107486892004, 0.0009267907589674],
    [118.506682687351, 24.8112776629525, 0.000926857814192772],
  ],
  [
    [118.507207206695, 24.8107366340946, 0.00092678889632225],
    [118.506667914501, 24.8112651209132, 0.000926855020225048],
  ],
  [
    [118.507193027905, 24.8107245699494, 0.000926787033677101],
    [118.506653151522, 24.8112525608068, 0.000926853157579899],
  ],
  [
    [118.507178858986, 24.810712487737, 0.000926786102354527],
    [118.506638408316, 24.8112399916504, 0.00092685129493475],
  ],
  [
    [118.50716470984, 24.8107003964748, 0.000926783308386803],
    [118.506623674981, 24.8112274044269, 0.000926850363612175],
  ],
  [
    [118.507150570564, 24.8106882871455, 0.000926782377064228],
    [118.506608961419, 24.8112148081535, 0.000926848500967026],
  ],
  [
    [118.507136441182, 24.8106761778044, 0.000926779583096504],
    [118.506594257728, 24.8112021938129, 0.000926846638321877],
  ],
  [
    [118.50712233155, 24.8106640413582, 0.000926779583096504],
    [118.506579573811, 24.8111895704225, 0.000926845706999302],
  ],
  [
    [118.5071082318, 24.8106518958726, 0.00092677678912878],
    [118.506564899764, 24.8111769289648, 0.000926842913031578],
  ],
  [
    [118.507094141932, 24.8106397413475, 0.00092677678912878],
    [118.5065502356, 24.8111642784677, 0.000926842913031578],
  ],
  [
    [118.507080071826, 24.8106275687449, 0.000926775857806206],
    [118.506535591198, 24.8111516098931, 0.000926840119063854],
  ],
  [
    [118.507066011602, 24.8106153871029, 0.000926773063838482],
    [118.506520956678, 24.8111389322789, 0.00092683918774128],
  ],
  [
    [118.507051961259, 24.8106031964215, 0.000926772132515907],
    [118.506506332029, 24.8111262365976, 0.00092683918774128],
  ],
  [
    [118.507037930679, 24.8105909876627, 0.000926770269870758],
    [118.506491727154, 24.8111135318665, 0.000926835462450981],
  ],
  [
    [118.50702390998, 24.8105787698644, 0.000926769338548183],
    [118.50647713215, 24.8111008090682, 0.000926835462450981],
  ],
  [
    [118.507009909043, 24.8105665339887, 0.000926767475903034],
    [118.506462556918, 24.8110880772201, 0.000926834531128407],
  ],
  [
    [118.506995908097, 24.8105542890839, 0.00092676654458046],
    [118.50644799157, 24.8110753363325, 0.000926831737160683],
  ],
  [
    [118.506981936804, 24.8105420260913, 0.00092676468193531],
    [118.506433445983, 24.8110625773674, 0.000926829874515533],
  ],
  [
    [118.506967965502, 24.8105297540698, 0.000926763750612736],
    [118.506418910267, 24.8110498003351, 0.000926828943192959],
  ],
  [
    [118.506954013973, 24.8105174729984, 0.000926759093999863],
    [118.506404384434, 24.8110370142634, 0.000926826149225235],
  ],
  [
    [118.506940072314, 24.81050517386, 0.000926760025322437],
    [118.506389878373, 24.8110242191419, 0.00092682521790266],
  ],
  [
    [118.506926150428, 24.8104928656718, 0.000926760025322437],
    [118.506375382184, 24.8110114059533, 0.000926824286580086],
  ],
  [
    [118.506912238414, 24.8104805394165, 0.000926756300032139],
    [118.506360905757, 24.8109985746872, 0.000926821492612362],
  ],
  [
    [118.506898336281, 24.8104682041219, 0.000926753506064415],
    [118.506346439212, 24.8109857343817, 0.000926819629967213],
  ],
  [
    [118.506884453921, 24.8104558597776, 0.000926753506064415],
    [118.506331992441, 24.8109728850263, 0.000926818698644638],
  ],
  [
    [118.506870581432, 24.8104434973662, 0.000926750712096691],
    [118.50631754565, 24.8109600176142, 0.000926817767322063],
  ],
  [
    [118.506856728715, 24.810431125905, 0.000926750712096691],
    [118.506303128522, 24.810947141142, 0.000926814042031765],
  ],
  [
    [118.50684288587, 24.8104187363769, 0.000926747918128967],
    [118.506288721277, 24.8109342556303, 0.000926812179386616],
  ],
  [
    [118.506829052906, 24.8104063378093, 0.000926746055483818],
    [118.506274323892, 24.8109213430239, 0.000926812179386616],
  ],
  [
    [118.506815229825, 24.8103939302024, 0.000926746055483818],
    [118.506259936401, 24.8109084304057, 0.000926810316741467],
  ],
  [
    [118.506801426505, 24.8103815045181, 0.000926744192838669],
    [118.506245578562, 24.8108954996998, 0.000926809385418892],
  ],
  [
    [118.506787642958, 24.8103690697841, 0.00092674233019352],
    [118.506231220704, 24.810882550937, 0.000926806591451168],
  ],
  [
    [118.506773869281, 24.8103566169831, 0.00092674233019352],
    [118.506216882619, 24.8108695931246, 0.000926804728806019],
  ],
  [
    [118.506760105487, 24.8103441551427, 0.000926738604903221],
    [118.506202554416, 24.8108566262727, 0.00092680286616087],
  ],
  [
    [118.506746351575, 24.810331684263, 0.000926736742258072],
    [118.506188245975, 24.8108436413434, 0.00092680100351572],
  ],
  [
    [118.506732617425, 24.8103191953059, 0.000926735810935497],
    [118.506173957307, 24.8108306473644, 0.000926800072193146],
  ],
  [
    [118.506718893156, 24.8103066973095, 0.000926733016967773],
    [118.50615966862, 24.8108176353286, 0.000926800072193146],
  ],
  [
    [118.50670518866, 24.8102941902634, 0.000926733016967773],
    [118.506145399706, 24.8108046142431, 0.000926797278225422],
  ],
  [
    [118.506691494036, 24.8102816651503, 0.000926731154322624],
    [118.506131150554, 24.8107915750802, 0.000926794484257698],
  ],
  [
    [118.506677809281, 24.8102691219702, 0.00092673022300005],
    [118.506116911284, 24.8107785268779, 0.000926793552935123],
  ],
  [
    [118.506664144311, 24.8102565787681, 0.0009267283603549],
    [118.506102691787, 24.8107654696259, 0.000926792621612549],
  ],
  [
    [118.506650489212, 24.810244017499, 0.000926726497709751],
    [118.506088472271, 24.8107523943172, 0.0009267907589674],
  ],
  [
    [118.506636853875, 24.8102314381526, 0.000926723703742027],
    [118.506074282419, 24.8107393099484, 0.000926787964999676],
  ],
  [
    [118.50662322843, 24.8102188587945, 0.000926721841096878],
    [118.506060102437, 24.8107262075126, 0.000926787033677101],
  ],
  [
    [118.506609612846, 24.8102062523418, 0.000926719978451729],
    [118.506045932339, 24.8107130960374, 0.000926784239709377],
  ],
  [
    [118.506596017045, 24.810193645867, 0.00092671811580658],
    [118.506031782002, 24.8106999664849, 0.000926783308386803],
  ],
  [
    [118.506582431115, 24.8101810213254, 0.00092671811580658],
    [118.506017641547, 24.8106868278929, 0.000926781445741653],
  ],
  [
    [118.506568864958, 24.810168387734, 0.00092671811580658],
    [118.506003520866, 24.8106736802513, 0.000926780514419079],
  ],
  [
    [118.506555308672, 24.8101557360757, 0.00092671625316143],
    [118.505989410055, 24.8106605145427, 0.000926777720451355],
  ],
  [
    [118.506541772158, 24.8101430753678, 0.000926712527871132],
    [118.505975309116, 24.810647330767, 0.00092677865177393],
  ],
  [
    [118.506528235636, 24.8101304056309, 0.000926710665225983],
    [118.505961227962, 24.8106341469694, 0.000926774926483631],
  ],
  [
    [118.506514728767, 24.8101177178064, 0.000926709733903408],
    [118.505947166558, 24.8106209360667, 0.000926774926483631],
  ],
  [
    [118.506501221888, 24.8101050209529, 0.000926708802580833],
    [118.505933115047, 24.8106077251524, 0.000926772132515907],
  ],
  [
    [118.506487734771, 24.8100923060221, 0.000926707871258259],
    [118.505919073408, 24.810594496171, 0.000926770269870758],
  ],
  [
    [118.506474267427, 24.8100795820418, 0.00092670600861311],
    [118.505905051531, 24.8105812491124, 0.000926767475903034],
  ],
  [
    [118.506460800074, 24.8100668490325, 0.000926703214645386],
    [118.505891049438, 24.8105680020317, 0.00092676654458046],
  ],
  [
    [118.506447362385, 24.8100541069632, 0.000926703214645386],
    [118.505877057205, 24.8105547278564, 0.00092676468193531],
  ],
  [
    [118.506433924676, 24.8100413468373, 0.000926700420677662],
    [118.505863074866, 24.8105414536694, 0.000926763750612736],
  ],
  [
    [118.506420516619, 24.8100285686239, 0.000926698558032513],
    [118.505849112288, 24.8105281614051, 0.000926762819290161],
  ],
  [
    [118.506407108565, 24.8100157904092, 0.000926697626709938],
    [118.505835159582, 24.8105148510739, 0.000926761887967587],
  ],
  [
    [118.506393720272, 24.8100029941172, 0.000926696695387363],
    [118.505821226649, 24.810501531693, 0.000926760025322437],
  ],
  [
    [118.50638034185, 24.8099901797583, 0.00092669390141964],
    [118.505807303598, 24.8104882032728, 0.000926756300032139],
  ],
  [
    [118.506366983212, 24.8099773653775, 0.000926692970097065],
    [118.505793400309, 24.8104748567753, 0.000926755368709564],
  ],
  [
    [118.506353634445, 24.8099645329297, 0.000926691107451916],
    [118.505779506903, 24.8104615012385, 0.00092675257474184],
  ],
  [
    [118.50634030544, 24.8099516824048, 0.000926690176129341],
    [118.505765623379, 24.8104481366624, 0.00092675257474184],
  ],
  [
    [118.506326986328, 24.8099388318682, 0.000926688313484192],
    [118.505751769507, 24.8104347539987, 0.000926750712096691],
  ],
  [
    [118.506313677087, 24.8099259632648, 0.000926686450839043],
    [118.505737915616, 24.8104213532783, 0.000926749780774117],
  ],
  [
    [118.506300387607, 24.8099130765841, 0.000926683656871319],
    [118.50572408151, 24.8104079525361, 0.000926747918128967],
  ],
  [
    [118.5062871179, 24.8099001808539, 0.000926682725548744],
    [118.505710267154, 24.8103945246889, 0.000926746055483818],
  ],
  [
    [118.506273848184, 24.8098872760947, 0.000926680862903595],
    [118.505696462692, 24.8103810968301, 0.000926744192838669],
  ],
  [
    [118.506260608132, 24.8098743622757, 0.000926679000258446],
    [118.505682677991, 24.810367650894, 0.000926743261516094],
  ],
  [
    [118.50624736806, 24.8098614304001, 0.000926678068935871],
    [118.505668903173, 24.8103541959187, 0.000926738604903221],
  ],
  [
    [118.506234147761, 24.809848489475, 0.000926675274968147],
    [118.505655138226, 24.8103407228764, 0.000926737673580647],
  ],
  [
    [118.506220947223, 24.8098355304727, 0.000926675274968147],
    [118.505641393053, 24.8103272407846, 0.000926738604903221],
  ],
  [
    [118.506207756579, 24.8098225714588, 0.000926673412322998],
    [118.505627667652, 24.8103137496432, 0.000926736742258072],
  ],
  [
    [118.506194575805, 24.8098095943781, 0.000926671549677849],
    [118.505613952123, 24.8103002404348, 0.000926733948290348],
  ],
  [
    [118.506181414793, 24.8097965992201, 0.0009266696870327],
    [118.505600256355, 24.8102867131492, 0.000926732085645199],
  ],
  [
    [118.506168263663, 24.809783595023, 0.000926668755710125],
    [118.505586570481, 24.8102731858521, 0.000926729291677475],
  ],
  [
    [118.506155132306, 24.8097705817763, 0.00092666782438755],
    [118.505572894478, 24.810259640488, 0.000926727429032326],
  ],
  [
    [118.506142010831, 24.8097575594905, 0.000926662236452103],
    [118.505559238249, 24.8102460860744, 0.000926726497709751],
  ],
  [
    [118.506128909117, 24.8097445191275, 0.000926664099097252],
    [118.505545601781, 24.8102325135836, 0.000926724635064602],
  ],
  [
    [118.506115817286, 24.8097314697253, 0.000926662236452103],
    [118.505531975196, 24.8102189320536, 0.000926723703742027],
  ],
  [
    [118.506102735336, 24.8097184112839, 0.000926659442484379],
    [118.505518358482, 24.8102053324566, 0.000926721841096878],
  ],
  [
    [118.506089673148, 24.8097053347653, 0.00092665757983923],
    [118.505504771431, 24.8101917237998, 0.000926719978451729],
  ],
  [
    [118.506076620843, 24.8096922492076, 0.00092665571719408],
    [118.505491184373, 24.8101781061141, 0.00092671811580658],
  ],
  [
    [118.50606358831, 24.8096791546004, 0.000926654785871506],
    [118.505477617076, 24.8101644703512, 0.00092671625316143],
  ],
  [
    [118.506050565647, 24.8096660419263, 0.000926652923226357],
    [118.505464069552, 24.8101508255388, 0.00092671625316143],
  ],
  [
    [118.506037562758, 24.8096529202028, 0.000926651060581207],
    [118.505450531911, 24.8101371716872, 0.000926713459193707],
  ],
  [
    [118.506024569751, 24.8096397894401, 0.000926649197936058],
    [118.505437014032, 24.8101234997584, 0.000926710665225983],
  ],
  [
    [118.506011596505, 24.8096266406002, 0.000926648266613483],
    [118.505423506035, 24.8101098187904, 0.000926708802580833],
  ],
  [
    [118.505998633141, 24.8096134827212, 0.000926647335290909],
    [118.50541000792, 24.8100961287831, 0.000926707871258259],
  ],
  [
    [118.50598568955, 24.8096003157927, 0.00092664547264576],
    [118.505396539458, 24.8100824206885, 0.00092670600861311],
  ],
  [
    [118.505972755841, 24.8095871398251, 0.000926644541323185],
    [118.505383070988, 24.8100687035649, 0.00092670414596796],
  ],
  [
    [118.505959832003, 24.8095739457907, 0.000926639884710312],
    [118.50536963217, 24.8100549683539, 0.000926701352000237],
  ],
  [
    [118.505946927937, 24.8095607427068, 0.000926639884710312],
    [118.505356193344, 24.810041224114, 0.000926700420677662],
  ],
  [
    [118.505934043633, 24.8095475215458, 0.000926638022065163],
    [118.505342784182, 24.8100274708143, 0.000926699489355087],
  ],
  [
    [118.505921159321, 24.809534291356, 0.000926638022065163],
    [118.505329375011, 24.8100137084857, 0.000926697626709938],
  ],
  [
    [118.505908304672, 24.8095210521065, 0.000926635228097439],
    [118.505315995493, 24.8099999280697, 0.000926695764064789],
  ],
  [
    [118.505895459905, 24.8095078038178, 0.000926634296774864],
    [118.505302625846, 24.8099861295869, 0.00092669390141964],
  ],
  [
    [118.505882625009, 24.8094945374623, 0.00092663150280714],
    [118.505289266093, 24.8099723310926, 0.000926691107451916],
  ],
  [
    [118.505869809897, 24.809481271085, 0.000926630571484566],
    [118.505275926102, 24.8099585145211, 0.000926689244806767],
  ],
  [
    [118.505857004644, 24.8094679776133, 0.000926627777516842],
    [118.505262595982, 24.8099446798828, 0.000926689244806767],
  ],
  [
    [118.505844219175, 24.8094546841199, 0.000926625914871693],
    [118.505249285646, 24.8099308452227, 0.000926686450839043],
  ],
  [
    [118.505831443578, 24.8094413725596, 0.000926624052226543],
    [118.505235995072, 24.8099169924856, 0.000926685519516468],
  ],
  [
    [118.505818677862, 24.8094280519603, 0.000926624052226543],
    [118.505222714369, 24.8099031216816, 0.000926684588193893],
  ],
  [
    [118.505805931919, 24.8094147223115, 0.00092662125825882],
    [118.50520945345, 24.8098892508558, 0.000926680862903595],
  ],
  [
    [118.505793205737, 24.8094013745857, 0.000926618464291096],
    [118.505196202403, 24.8098753619632, 0.00092667993158102],
  ],
  [
    [118.505780489438, 24.8093880178208, 0.000926617532968521],
    [118.505182971117, 24.8098614549936, 0.000926677137613297],
  ],
  [
    [118.505767792911, 24.8093746520065, 0.000926615670323372],
    [118.505169749714, 24.8098475389848, 0.000926678068935871],
  ],
  [
    [118.505755106255, 24.8093612681254, 0.000926613807678223],
    [118.505156548084, 24.8098336139266, 0.000926674343645573],
  ],
  [
    [118.505742429482, 24.8093478752052, 0.000926612876355648],
    [118.505143356336, 24.8098196798292, 0.000926670618355274],
  ],
  [
    [118.50572977248, 24.8093344732357, 0.000926611013710499],
    [118.505130184351, 24.8098057276548, 0.000926670618355274],
  ],
  [
    [118.505717135252, 24.8093210622168, 0.000926610082387924],
    [118.505117022247, 24.8097917664412, 0.00092666782438755],
  ],
  [
    [118.505704507895, 24.8093076331311, 0.0009266072884202],
    [118.505103879917, 24.8097777961783, 0.00092666782438755],
  ],
  [
    [118.50569189043, 24.809294204034, 0.0009266072884202],
    [118.505090757348, 24.8097638078383, 0.000926665961742401],
  ],
  [
    [118.505679292716, 24.8092807478322, 0.000926604494452477],
    [118.505077644662, 24.8097498104592, 0.000926664099097252],
  ],
  [
    [118.505666714786, 24.8092672916087, 0.000926604494452477],
    [118.505064541858, 24.8097358040409, 0.000926662236452103],
  ],
  [
    [118.505654146727, 24.8092538173185, 0.000926600769162178],
    [118.505051458816, 24.8097217795457, 0.000926660373806953],
  ],
  [
    [118.50564158855, 24.8092403339893, 0.000926600769162178],
    [118.505038395547, 24.809707746001, 0.000926656648516655],
  ],
  [
    [118.505629050145, 24.8092268416106, 0.000926597975194454],
    [118.505025352052, 24.809693703407, 0.00092665757983923],
  ],
  [
    [118.505616521612, 24.8092133311653, 0.00092659518122673],
    [118.505012318438, 24.8096796517739, 0.000926654785871506],
  ],
  [
    [118.505604012851, 24.8091998116706, 0.000926594249904156],
    [118.504999304598, 24.8096655910915, 0.000926653854548931],
  ],
  [
    [118.50559150407, 24.8091862741195, 0.000926592387259007],
    [118.504986300628, 24.8096515123423, 0.000926652923226357],
  ],
  [
    [118.505579015062, 24.809172727519, 0.000926591455936432],
    [118.504973316443, 24.8096374335714, 0.000926649197936058],
  ],
  [
    [118.505566545815, 24.8091591628415, 0.000926588661968708],
    [118.50496035202, 24.8096233367235, 0.000926646403968334],
  ],
  [
    [118.50555407656, 24.8091455891353, 0.000926586799323559],
    [118.50494740737, 24.8096092308262, 0.00092664547264576],
  ],
  [
    [118.505541627078, 24.8091320063798, 0.000926585868000984],
    [118.504934472613, 24.8095951249176, 0.000926644541323185],
  ],
  [
    [118.505529187466, 24.8091184055575, 0.000926584005355835],
    [118.504921557619, 24.809581000932, 0.00092664361000061],
  ],
  [
    [118.505516767627, 24.8091047956859, 0.000926582142710686],
    [118.504908652506, 24.8095668679073, 0.000926639884710312],
  ],
  [
    [118.50550434778, 24.8090911767856, 0.000926581211388111],
    [118.504895767167, 24.8095527258333, 0.000926638022065163],
  ],
  [
    [118.505491947693, 24.8090775398083, 0.000926578417420387],
    [118.504882901612, 24.8095385837376, 0.000926637090742588],
  ],
  [
    [118.505479557489, 24.809063893792, 0.000926577486097813],
    [118.504870045928, 24.8095244235752, 0.000926635228097439],
  ],
  [
    [118.505467187047, 24.8090502296987, 0.000926576554775238],
    [118.504857210017, 24.8095102543635, 0.000926632434129715],
  ],
  [
    [118.505454816596, 24.8090365565767, 0.000926574692130089],
    [118.504844393879, 24.8094960761025, 0.000926632434129715],
  ],
  [
    [118.505442465917, 24.8090228744054, 0.000926571898162365],
    [118.504831587623, 24.8094818888025, 0.000926630571484566],
  ],
  [
    [118.505430125121, 24.809009183195, 0.000926570035517216],
    [118.504818791261, 24.8094677014911, 0.000926627777516842],
  ],
  [
    [118.505417794195, 24.808995473918, 0.000926570035517216],
    [118.504806014661, 24.8094534961027, 0.000926625914871693],
  ],
  [
    [118.505405483042, 24.8089817555917, 0.000926567241549492],
    [118.504793257834, 24.8094392816651, 0.000926624052226543],
  ],
  [
    [118.505393171881, 24.8089680282366, 0.000926564447581768],
    [118.504780520791, 24.8094250672058, 0.000926622189581394],
  ],
  [
    [118.505380880481, 24.8089542828046, 0.000926563516259193],
    [118.504767783728, 24.8094108346901, 0.00092662125825882],
  ],
  [
    [118.505368598963, 24.8089405283337, 0.000926561653614044],
    [118.504755076341, 24.8093966021426, 0.00092661939561367],
  ],
  [
    [118.505356327327, 24.8089267648237, 0.000926561653614044],
    [118.504742378835, 24.809382360556, 0.000926618464291096],
  ],
  [
    [118.505344065562, 24.808912983247, 0.000926557928323746],
    [118.504729691201, 24.8093681009027, 0.000926615670323372],
  ],
  [
    [118.50533181369, 24.8088992016591, 0.000926554203033447],
    [118.504717023351, 24.8093538412279, 0.000926613807678223],
  ],
  [
    [118.50531958158, 24.8088854019942, 0.000926555134356022],
    [118.504704365383, 24.809339572514, 0.000926611013710499],
  ],
  [
    [118.505307349461, 24.8088715933005, 0.000926553271710873],
    [118.504691727189, 24.8093252947509, 0.000926610082387924],
  ],
  [
    [118.505295137115, 24.8088577755577, 0.000926551409065723],
    [118.504679098887, 24.8093110169764, 0.000926608219742775],
  ],
  [
    [118.50528293464, 24.8088439397481, 0.000926549546420574],
    [118.504666490348, 24.8092967211251, 0.000926608219742775],
  ],
  [
    [118.505270732156, 24.8088300949099, 0.00092654675245285],
    [118.504653891702, 24.8092824252624, 0.000926602631807327],
  ],
  [
    [118.505258549445, 24.8088162410224, 0.00092654675245285],
    [118.504641312818, 24.8092681113228, 0.000926601700484753],
  ],
  [
    [118.505246376616, 24.808802378096, 0.000926543027162552],
    [118.504628743827, 24.8092537973718, 0.000926600769162178],
  ],
  [
    [118.505234223559, 24.8087885061203, 0.000926543027162552],
    [118.504616184719, 24.8092394743819, 0.000926599837839603],
  ],
  [
    [118.505222070494, 24.8087746251159, 0.000926541164517403],
    [118.504603645395, 24.8092251513705, 0.000926597975194454],
  ],
  [
    [118.5052099273, 24.8087607260449, 0.000926539301872253],
    [118.504591125833, 24.8092108102821, 0.000926594249904156],
  ],
  [
    [118.505197793988, 24.8087468179349, 0.000926538370549679],
    [118.504578606273, 24.8091964691927, 0.000926594249904156],
  ],
  [
    [118.505185680448, 24.8087329007757, 0.000926535576581955],
    [118.504566106487, 24.8091821190541, 0.000926591455936432],
  ],
  [
    [118.5051735669, 24.8087189745878, 0.000926533713936806],
    [118.504553626473, 24.8091677598662, 0.000926589593291283],
  ],
  [
    [118.505161463234, 24.8087050393609, 0.000926531851291656],
    [118.504541156342, 24.8091533916394, 0.000926587730646133],
  ],
  [
    [118.505149379341, 24.8086910950848, 0.000926530919969082],
    [118.504528696104, 24.8091390234013, 0.000926585868000984],
  ],
  [
    [118.505137295439, 24.80867714178, 0.000926528126001358],
    [118.504516245749, 24.8091246461242, 0.000926585868000984],
  ],
  [
    [118.505125221408, 24.8086631704086, 0.000926528126001358],
    [118.504503815166, 24.8091102597979, 0.000926584005355835],
  ],
  [
    [118.505113167161, 24.8086491990157, 0.000926523469388485],
    [118.504491394466, 24.8090958644327, 0.000926581211388111],
  ],
  [
    [118.505101112894, 24.8086352095664, 0.00092652253806591],
    [118.50447899355, 24.809081469046, 0.000926579348742962],
  ],
  [
    [118.505089068509, 24.8086212110782, 0.000926519744098186],
    [118.504466602516, 24.8090670646203, 0.000926577486097813],
  ],
  [
    [118.505077034006, 24.808607203551, 0.000926519744098186],
    [118.504454221376, 24.8090526601833, 0.000926576554775238],
  ],
  [
    [118.505065009397, 24.8085931960126, 0.000926516018807888],
    [118.504441850106, 24.8090382376797, 0.00092657282948494],
  ],
  [
    [118.505053004549, 24.8085791703973, 0.000926516950130463],
    [118.504429498621, 24.8090238151546, 0.000926573760807514],
  ],
  [
    [118.505040999692, 24.8085651357533, 0.000926515087485313],
    [118.504417157018, 24.8090093835905, 0.000926570035517216],
  ],
  [
    [118.505029004718, 24.8085510920704, 0.000926513224840164],
    [118.504404825309, 24.8089949520152, 0.000926566310226917],
  ],
  [
    [118.505017009735, 24.8085370393588, 0.000926509499549866],
    [118.504392503482, 24.808980511401, 0.000926567241549492],
  ],
  [
    [118.505005034524, 24.808522977598, 0.000926508568227291],
    [118.504380201428, 24.8089660617376, 0.000926565378904343],
  ],
  [
    [118.504993069196, 24.8085089067983, 0.000926506705582142],
    [118.504367909267, 24.8089516120629, 0.000926564447581768],
  ],
  [
    [118.504981103859, 24.80849482697, 0.000926504842936993],
    [118.504355626989, 24.8089371533493, 0.000926561653614044],
  ],
  [
    [118.504969158295, 24.8084807380925, 0.000926503911614418],
    [118.504343354604, 24.8089226946245, 0.00092655885964632],
  ],
  [
    [118.504957212722, 24.8084666401863, 0.000926502048969269],
    [118.50433110198, 24.8089082178228, 0.000926556997001171],
  ],
  [
    [118.504945277031, 24.8084525332411, 0.00092650018632412],
    [118.504318859262, 24.8088937500376, 0.000926554203033447],
  ],
  [
    [118.504933351222, 24.8084384172571, 0.00092649832367897],
    [118.504306626414, 24.8088792641858, 0.000926553271710873],
  ],
  [
    [118.504921435296, 24.8084242922342, 0.000926495529711246],
    [118.50429440346, 24.8088647783227, 0.000926552340388298],
  ],
  [
    [118.504909529251, 24.8084101581723, 0.000926493667066097],
    [118.5042821904, 24.8088502924484, 0.000926549546420574],
  ],
  [
    [118.504897623198, 24.8083960150818, 0.000926493667066097],
    [118.504269987221, 24.8088357975351, 0.000926548615098],
  ],
  [
    [118.504885736918, 24.8083818629422, 0.000926490873098373],
    [118.504257803816, 24.8088212935728, 0.000926545821130276],
  ],
  [
    [118.50487385064, 24.8083677108015, 0.00092648807913065],
    [118.504245630304, 24.8088067895992, 0.000926543958485127],
  ],
  [
    [118.504861974233, 24.8083535405943, 0.000926487147808075],
    [118.504233456783, 24.8087922765969, 0.000926543027162552],
  ],
  [
    [118.504850097829, 24.8083393703861, 0.000926485285162926],
    [118.504221303047, 24.8087777635732, 0.000926540233194828],
  ],
  [
    [118.504838241186, 24.8083251821011, 0.000926484353840351],
    [118.504209159193, 24.8087632415106, 0.000926540233194828],
  ],
  [
    [118.504826384546, 24.8083109938151, 0.000926481559872627],
    [118.504197025232, 24.8087487194368, 0.000926535576581955],
  ],
  [
    [118.504814537787, 24.8082967964902, 0.000926478765904903],
    [118.504184901154, 24.8087341883241, 0.00092653650790453],
  ],
  [
    [118.504802700911, 24.8082825901264, 0.000926477834582329],
    [118.504172796848, 24.8087196481622, 0.000926533713936806],
  ],
  [
    [118.504790864027, 24.8082683747339, 0.000926476903259754],
    [118.504160692557, 24.8087051170271, 0.000926532782614231],
  ],
  [
    [118.504779046915, 24.8082541502924, 0.00092647597193718],
    [118.504148598136, 24.8086905678253, 0.000926529057323933],
  ],
  [
    [118.504767229794, 24.8082399168222, 0.000926473177969456],
    [118.504136523511, 24.8086760276299, 0.000926528126001358],
  ],
  [
    [118.504755412677, 24.808225683351, 0.000926472246646881],
    [118.504124448866, 24.8086614693781, 0.000926527194678783],
  ],
  [
    [118.50474361532, 24.808211431803, 0.000926469452679157],
    [118.504112394016, 24.8086469201325, 0.000926523469388485],
  ],
  [
    [118.504731817967, 24.8081971802541, 0.000926467590034008],
    [118.504100339147, 24.8086323528306, 0.000926521606743336],
  ],
  [
    [118.504720020604, 24.8081829196765, 0.000926465727388859],
    [118.504088304073, 24.808617794535, 0.000926520675420761],
  ],
  [
    [118.504708243015, 24.8081686500498, 0.000926464796066284],
    [118.504076268991, 24.8086032272107, 0.000926519744098186],
  ],
  [
    [118.504696465417, 24.8081543713944, 0.00092646200209856],
    [118.504064253681, 24.8085886508373, 0.000926516950130463],
  ],
  [
    [118.504684697712, 24.8081400927279, 0.000926461070775986],
    [118.504052238375, 24.8085740744629, 0.000926514156162739],
  ],
  [
    [118.504672929999, 24.8081258050327, 0.000926460139453411],
    [118.504040232961, 24.8085594980774, 0.000926514156162739],
  ],
  [
    [118.504661172167, 24.8081115082986, 0.000926455482840538],
    [118.504028247321, 24.8085449126427, 0.000926511362195015],
  ],
  [
    [118.504649424218, 24.8080972025257, 0.000926455482840538],
    [118.504016261683, 24.8085303272071, 0.000926509499549866],
  ],
  [
    [118.50463767626, 24.8080828877241, 0.000926452688872814],
    [118.504004285939, 24.8085157417603, 0.000926507636904716],
  ],
  [
    [118.504625938196, 24.8080685729114, 0.00092645175755024],
    [118.503992320077, 24.8085011472746, 0.000926506705582142],
  ],
  [
    [118.504614200123, 24.80805424907, 0.000926448963582516],
    [118.503980364108, 24.8084865527778, 0.000926504842936993],
  ],
  [
    [118.504602471932, 24.8080399161897, 0.000926448032259941],
    [118.503968418021, 24.8084719492421, 0.000926502048969269],
  ],
  [
    [118.504590753623, 24.8080255742706, 0.000926445238292217],
    [118.503956481828, 24.8084573456952, 0.00092650018632412],
  ],
  [
    [118.504579035317, 24.8080112323506, 0.000926444306969643],
    [118.503944555529, 24.8084427421372, 0.00092649832367897],
  ],
  [
    [118.504567326881, 24.807996872364, 0.000926442444324493],
    [118.503932639111, 24.8084281295403, 0.000926496461033821],
  ],
  [
    [118.50455561846, 24.8079825214041, 0.000926440581679344],
    [118.503920722696, 24.8084135169424, 0.000926494598388672],
  ],
  [
    [118.504543919909, 24.8079681523777, 0.000926438719034195],
    [118.503908816175, 24.8083989043334, 0.000926492735743523],
  ],
  [
    [118.504532231252, 24.8079537833401, 0.000926436856389046],
    [118.503896929438, 24.808384291703, 0.000926491804420948],
  ],
  [
    [118.504520542586, 24.8079394052738, 0.000926435925066471],
    [118.503885042692, 24.8083696700439, 0.000926489941775799],
  ],
  [
    [118.504508853911, 24.807925018179, 0.000926433131098747],
    [118.503873155949, 24.8083550483839, 0.00092648807913065],
  ],
  [
    [118.50449717513, 24.807910631073, 0.000926431268453598],
    [118.503861288979, 24.8083404176748, 0.000926484353840351],
  ],
  [
    [118.504485496341, 24.8078962349383, 0.000926429405808449],
    [118.503849422011, 24.8083257869648, 0.000926484353840351],
  ],
  [
    [118.504473827433, 24.8078818297648, 0.000926428474485874],
    [118.503837574828, 24.8083111562334, 0.000926482491195202],
  ],
  [
    [118.504462168419, 24.8078674245802, 0.00092642568051815],
    [118.503825727647, 24.8082965255011, 0.000926481559872627],
  ],
  [
    [118.504450509396, 24.8078530103669, 0.000926423817873001],
    [118.503813890348, 24.8082818857299, 0.000926477834582329],
  ],
  [
    [118.504438850364, 24.8078385871249, 0.000926423817873001],
    [118.503802053064, 24.8082672549855, 0.000926476903259754],
  ],
  [
    [118.504427201226, 24.8078241638719, 0.000926421023905277],
    [118.503790225661, 24.8082526152022, 0.000926475040614605],
  ],
  [
    [118.50441555208, 24.8078097315902, 0.000926418229937553],
    [118.503778408141, 24.80823796638, 0.000926473177969456],
  ],
  [
    [118.504403912815, 24.8077952902696, 0.000926416367292404],
    [118.503766600525, 24.8082233265745, 0.000926470384001732],
  ],
  [
    [118.504392273553, 24.8077808489481, 0.00092641543596983],
    [118.503754802792, 24.8082086777301, 0.000926467590034008],
  ],
  [
    [118.504380634283, 24.807766398598, 0.00092641357332468],
    [118.503743005061, 24.8081940288847, 0.000926467590034008],
  ],
  [
    [118.504369004906, 24.8077519482367, 0.000926411710679531],
    [118.503731217224, 24.8081793800282, 0.000926465727388859],
  ],
  [
    [118.50435737552, 24.8077374888469, 0.000926408916711807],
    [118.503719429389, 24.8081647311707, 0.000926464796066284],
  ],
  [
    [118.504345756028, 24.8077230294458, 0.000926407985389233],
    [118.503707661327, 24.8081500732643, 0.00092646200209856],
  ],
  [
    [118.504334136516, 24.8077085519885, 0.000926405191421509],
    [118.503695893268, 24.8081354153569, 0.000926459208130836],
  ],
  [
    [118.504322517017, 24.8076940835579, 0.000926404260098934],
    [118.503684125212, 24.8081207574485, 0.000926458276808262],
  ],
  [
    [118.50431090739, 24.8076795970608, 0.000926402397453785],
    [118.503672367048, 24.808106099529, 0.000926455482840538],
  ],
  [
    [118.504299297777, 24.8076651195904, 0.00092640146613121],
    [118.503660618779, 24.8080914415983, 0.000926454551517963],
  ],
  [
    [118.504287688144, 24.8076506240637, 0.000926397740840912],
    [118.503648880402, 24.8080767836566, 0.000926452688872814],
  ],
  [
    [118.504276088404, 24.8076361285259, 0.000926396809518337],
    [118.503637142017, 24.8080621166862, 0.00092644989490509],
  ],
  [
    [118.504264488667, 24.8076216329872, 0.000926395878195763],
    [118.503625413537, 24.8080474587323, 0.000926448032259941],
  ],
  [
    [118.504252888921, 24.8076071284198, 0.000926394015550613],
    [118.503613685048, 24.8080327917499, 0.000926448032259941],
  ],
  [
    [118.504241299057, 24.8075926148136, 0.00092639122158289],
    [118.503601966453, 24.8080181247563, 0.000926445238292217],
  ],
  [
    [118.504229709196, 24.8075781012065, 0.000926390290260315],
    [118.503590257751, 24.8080034577516, 0.000926443375647068],
  ],
  [
    [118.504218119338, 24.8075635875984, 0.000926387496292591],
    [118.503578549051, 24.8079887907459, 0.000926441513001919],
  ],
  [
    [118.504206529471, 24.8075490649617, 0.000926384702324867],
    [118.503566840355, 24.8079741237393, 0.000926441513001919],
  ],
  [
    [118.504194949487, 24.8075345332862, 0.000926383771002293],
    [118.503555151442, 24.8079594567114, 0.00092643778771162],
  ],
  [
    [118.504183369505, 24.8075200016097, 0.000926380977034569],
    [118.50354345263, 24.807944780665, 0.000926435925066471],
  ],
  [
    [118.504171789526, 24.8075054699324, 0.000926380045711994],
    [118.503531773614, 24.807930113625, 0.000926434062421322],
  ],
  [
    [118.504160209538, 24.8074909292264, 0.000926378183066845],
    [118.503520084698, 24.8079154375666, 0.000926432199776173],
  ],
  [
    [118.504148639444, 24.8074763885093, 0.00092637725174427],
    [118.503508415577, 24.8079007705146, 0.000926430337131023],
  ],
  [
    [118.504137069341, 24.8074618387635, 0.000926375389099121],
    [118.503496736558, 24.8078860944441, 0.0009264275431633],
  ],
  [
    [118.504125499229, 24.8074472799892, 0.000926371663808823],
    [118.503485077322, 24.8078714183524, 0.000926426611840725],
  ],
  [
    [118.504113929132, 24.8074327302415, 0.000926370732486248],
    [118.503473408209, 24.8078567512975, 0.000926424749195576],
  ],
  [
    [118.504102359026, 24.8074181714653, 0.000926367938518524],
    [118.503461758869, 24.8078420751937, 0.000926421955227852],
  ],
  [
    [118.504090798802, 24.8074036036503, 0.000926367938518524],
    [118.503450099642, 24.8078273990991, 0.000926420092582703],
  ],
  [
    [118.50407922869, 24.8073890358445, 0.0009263651445508],
    [118.503438450308, 24.8078127229934, 0.000926419161260128],
  ],
  [
    [118.504067668471, 24.8073744680276, 0.000926363281905651],
    [118.503426810878, 24.8077980559044, 0.000926416367292404],
  ],
  [
    [118.504056108244, 24.8073598911821, 0.000926361419260502],
    [118.503415171439, 24.8077833797866, 0.000926414504647255],
  ],
  [
    [118.504044548009, 24.807345305308, 0.000926360487937927],
    [118.503403532004, 24.8077687036679, 0.00092641357332468],
  ],
  [
    [118.504032987787, 24.8073307284606, 0.000926357693970203],
    [118.503391902462, 24.8077540275382, 0.000926410779356956],
  ],
  [
    [118.504021427557, 24.8073161425846, 0.000926356762647629],
    [118.503380272933, 24.8077393604352, 0.000926409848034382],
  ],
  [
    [118.50400986733, 24.8073015567076, 0.000926353968679905],
    [118.503368653287, 24.8077246842934, 0.000926407054066658],
  ],
  [
    [118.503998316985, 24.8072869617919, 0.000926352106034756],
    [118.503357033643, 24.8077100081506, 0.000926406122744083],
  ],
  [
    [118.503986756752, 24.8072723668854, 0.000926350243389606],
    [118.503345414014, 24.8076953410346, 0.000926404260098934],
  ],
  [
    [118.503975206401, 24.8072577629401, 0.000926348380744457],
    [118.503333804266, 24.8076806648799, 0.000926402397453785],
  ],
  [
    [118.503963646162, 24.8072431590041, 0.000926345586776733],
    [118.503322194533, 24.8076659977519, 0.00092640146613121],
  ],
  [
    [118.503952095816, 24.807228555057, 0.000926345586776733],
    [118.503310584791, 24.8076513215952, 0.000926398672163486],
  ],
  [
    [118.503940545474, 24.8072139511089, 0.00092634279280901],
    [118.503298984953, 24.8076366544552, 0.000926397740840912],
  ],
  [
    [118.503928985232, 24.8071993381424, 0.000926341861486435],
    [118.503287385118, 24.8076219873142, 0.000926395878195763],
  ],
  [
    [118.503917434883, 24.8071847251647, 0.00092634093016386],
    [118.503275785275, 24.8076073111446, 0.000926393084228039],
  ],
  [
    [118.503905884537, 24.8071701121862, 0.000926339067518711],
    [118.503264195335, 24.8075926439916, 0.00092639122158289],
  ],
  [
    [118.503894324293, 24.8071554901892, 0.000926337204873562],
    [118.503252605399, 24.8075779768376, 0.00092639122158289],
  ],
  [
    [118.503882773941, 24.8071408681811, 0.000926334410905838],
    [118.503241015466, 24.8075633096827, 0.000926387496292591],
  ],
  [
    [118.503871223592, 24.807126246172, 0.000926333479583263],
    [118.503229425546, 24.8075486515546, 0.000926385633647442],
  ],
  [
    [118.503859663344, 24.8071116151445, 0.000926331616938114],
    [118.503217845508, 24.8075339843877, 0.000926384702324867],
  ],
  [
    [118.50384811299, 24.8070969841059, 0.000926327891647816],
    [118.503206265485, 24.8075193262476, 0.000926382839679718],
  ],
  [
    [118.503836552747, 24.8070823530766, 0.00092632882297039],
    [118.503194685453, 24.8075046590788, 0.000926380977034569],
  ],
  [
    [118.503825002398, 24.8070677220361, 0.000926323235034943],
    [118.503183105434, 24.8074900009368, 0.000926380045711994],
  ],
  [
    [118.50381344215, 24.8070530819772, 0.000926323235034943],
    [118.503171535309, 24.8074753427837, 0.000926375389099121],
  ],
  [
    [118.503801881905, 24.8070384419174, 0.000926321372389793],
    [118.503159965187, 24.8074606846297, 0.000926374457776546],
  ],
  [
    [118.503790321662, 24.8070238018566, 0.00092631857842207],
    [118.503148395067, 24.8074460264747, 0.000926374457776546],
  ],
  [
    [118.503778761422, 24.8070091617949, 0.00092631671577692],
    [118.503136824961, 24.8074313773465, 0.000926370732486248],
  ],
  [
    [118.503767201174, 24.8069945127046, 0.000926315784454346],
    [118.503125254847, 24.8074167191897, 0.000926369801163673],
  ],
  [
    [118.50375564094, 24.806979872641, 0.000926314853131771],
    [118.503113694637, 24.8074020700494, 0.00092636700719595],
  ],
  [
    [118.503744080697, 24.8069652235488, 0.000926311127841473],
    [118.50310212454, 24.8073874209184, 0.000926366075873375],
  ],
  [
    [118.503732510555, 24.8069505654382, 0.000926311127841473],
    [118.503090564346, 24.807372780804, 0.000926364213228226],
  ],
  [
    [118.503720950318, 24.8069359163441, 0.000926308333873749],
    [118.503079004145, 24.807358131661, 0.000926362350583076],
  ],
  [
    [118.503709380193, 24.8069212672592, 0.0009263064712286],
    [118.503067443957, 24.8073434915447, 0.000926358625292778],
  ],
  [
    [118.503697810059, 24.8069066091458, 0.000926305539906025],
    [118.503055883772, 24.8073288514275, 0.000926357693970203],
  ],
  [
    [118.503686230038, 24.8068919510416, 0.000926302745938301],
    [118.503044323589, 24.8073142113094, 0.000926355831325054],
  ],
  [
    [118.50367465991, 24.8068772929262, 0.000926300883293152],
    [118.5030327733, 24.8072995711802, 0.00092635490000248],
  ],
  [
    [118.503663079894, 24.8068626348201, 0.000926299951970577],
    [118.503021213134, 24.8072849400879, 0.00092635303735733],
  ],
  [
    [118.503651509771, 24.8068479767029, 0.000926297158002853],
    [118.50300965296, 24.8072702999669, 0.000926350243389606],
  ],
  [
    [118.50363992975, 24.8068333095672, 0.00092629436403513],
    [118.502998102701, 24.8072556778903, 0.000926350243389606],
  ],
  [
    [118.503628339841, 24.8068186424408, 0.000926295295357704],
    [118.502986542543, 24.8072410467951, 0.000926345586776733],
  ],
  [
    [118.503616759836, 24.8068039843309, 0.000926291570067406],
    [118.50297499229, 24.8072264247166, 0.000926344655454159],
  ],
  [
    [118.503605169932, 24.8067893172026, 0.000926290638744831],
    [118.502963442028, 24.8072117936095, 0.000926341861486435],
  ],
  [
    [118.503593580031, 24.8067746500733, 0.000926287844777107],
    [118.5029518819, 24.807197180567, 0.00092634093016386],
  ],
  [
    [118.503581990133, 24.8067599829431, 0.000926287844777107],
    [118.502940331655, 24.8071825584857, 0.000926339998841286],
  ],
  [
    [118.503570390347, 24.8067453158221, 0.000926285050809383],
    [118.502928781423, 24.8071679454311, 0.000926339067518711],
  ],
  [
    [118.503558790563, 24.8067306487002, 0.000926283188164234],
    [118.502917221304, 24.8071533323857, 0.000926335342228413],
  ],
  [
    [118.503547190772, 24.8067159725496, 0.00092628039419651],
    [118.502905671089, 24.807138728357, 0.000926333479583263],
  ],
  [
    [118.503535581104, 24.806701305436, 0.00092628039419651],
    [118.502894120866, 24.8071241152996, 0.000926332548260689],
  ],
  [
    [118.503523981329, 24.8066866383112, 0.000926277600228786],
    [118.502882560765, 24.8071095112791, 0.000926329754292965],
  ],
  [
    [118.503512361764, 24.8066719621781, 0.000926275737583637],
    [118.50287101057, 24.8070949162753, 0.000926329754292965],
  ],
  [
    [118.503500752104, 24.8066572950616, 0.000926273874938488],
    [118.502859450486, 24.8070803212806, 0.000926326960325241],
  ],
  [
    [118.503489132546, 24.8066426189267, 0.000926272012293339],
    [118.502847890405, 24.807065726285, 0.000926323235034943],
  ],
  [
    [118.50347751299, 24.8066279427907, 0.000926269218325615],
    [118.502836340217, 24.8070511312783, 0.000926322303712368],
  ],
  [
    [118.503465883557, 24.8066132756917, 0.000926267355680466],
    [118.502824780153, 24.8070365453085, 0.000926321372389793],
  ],
  [
    [118.503454254116, 24.806598599564, 0.000926264561712742],
    [118.502813220091, 24.8070219593377, 0.00092631857842207],
  ],
  [
    [118.503442624678, 24.8065839234354, 0.000926263630390167],
    [118.502801660043, 24.8070073823937, 0.000926317647099495],
  ],
  [
    [118.503430985363, 24.8065692563437, 0.000926261767745018],
    [118.502790099998, 24.8069928054488, 0.000926314853131771],
  ],
  [
    [118.50341934604, 24.8065545802233, 0.000926259905099869],
    [118.502778539956, 24.8069782285029, 0.000926312990486622],
  ],
  [
    [118.503407696829, 24.8065399041122, 0.000926259905099869],
    [118.502766970036, 24.8069636605939, 0.000926311127841473],
  ],
  [
    [118.503396047632, 24.8065252370277, 0.00092625617980957],
    [118.50275541001, 24.8069490926739, 0.000926310196518898],
  ],
  [
    [118.503384388536, 24.8065105609248, 0.00092625617980957],
    [118.502743840108, 24.8069345337906, 0.000926309265196323],
  ],
  [
    [118.503372729443, 24.8064958848209, 0.000926251523196697],
    [118.502732270208, 24.8069199749065, 0.000926305539906025],
  ],
  [
    [118.503361070364, 24.8064812177438, 0.000926250591874123],
    [118.502720700311, 24.8069054160214, 0.000926303677260876],
  ],
  [
    [118.503349401386, 24.8064665416481, 0.000926249660551548],
    [118.502709130427, 24.8068908661631, 0.000926302745938301],
  ],
  [
    [118.503337722531, 24.8064518745894, 0.000926247797906399],
    [118.502697560546, 24.8068763163038, 0.000926300883293152],
  ],
  [
    [118.503326053559, 24.8064371984918, 0.0009262440726161],
    [118.502685980789, 24.8068617754814, 0.000926299020648003],
  ],
  [
    [118.50331436482, 24.8064225314413, 0.0009262440726161],
    [118.502674401034, 24.806847234658, 0.000926296226680279],
  ],
  [
    [118.503302676072, 24.8064078553621, 0.000926241278648376],
    [118.502662821293, 24.8068327028614, 0.000926296226680279],
  ],
  [
    [118.503290987338, 24.8063931883096, 0.000926239416003227],
    [118.502651241555, 24.8068181710638, 0.00092629436403513],
  ],
  [
    [118.503279288716, 24.8063785212664, 0.000926238484680653],
    [118.50263965194, 24.8068036483031, 0.00092629250138998],
  ],
  [
    [118.503267580207, 24.8063638542323, 0.000926235690712929],
    [118.502628062327, 24.8067891255414, 0.000926289707422256],
  ],
  [
    [118.503255871701, 24.8063491871972, 0.00092623382806778],
    [118.502616472718, 24.8067746027788, 0.000926288776099682],
  ],
  [
    [118.503244153307, 24.8063345201713, 0.000926232896745205],
    [118.502604883122, 24.8067600890429, 0.000926286913454533],
  ],
  [
    [118.503232434927, 24.8063198621721, 0.000926230102777481],
    [118.502593283649, 24.8067455843439, 0.000926283188164234],
  ],
  [
    [118.503220706648, 24.8063051951545, 0.000926229171454906],
    [118.50258168418, 24.8067310796439, 0.00092628225684166],
  ],
  [
    [118.503208978371, 24.8062905281358, 0.000926225446164608],
    [118.502570084723, 24.8067165839707, 0.00092628039419651],
  ],
  [
    [118.503197240219, 24.806275870154, 0.000926226377487183],
    [118.50255848527, 24.8067020882965, 0.00092628039419651],
  ],
  [
    [118.503185492178, 24.8062612121814, 0.000926223583519459],
    [118.50254687594, 24.8066876016591, 0.000926278531551361],
  ],
  [
    [118.503173744141, 24.8062465542078, 0.000926220789551735],
    [118.502535266613, 24.8066731150208, 0.000926275737583637],
  ],
  [
    [118.503161986216, 24.8062318962434, 0.000926217995584011],
    [118.502523647409, 24.8066586374194, 0.000926272012293339],
  ],
  [
    [118.503150228293, 24.806217238278, 0.000926217064261436],
    [118.502512028207, 24.806644159817, 0.00092627014964819],
  ],
  [
    [118.503138460494, 24.8062025893494, 0.000926216132938862],
    [118.50250040902, 24.8066296912413, 0.00092627014964819],
  ],
  [
    [118.503126682808, 24.80618794043, 0.000926213338971138],
    [118.502488789835, 24.8066152226647, 0.000926267355680466],
  ],
  [
    [118.503114895222, 24.8061732824921, 0.000926213338971138],
    [118.502477160785, 24.8066007721526, 0.000926266424357891],
  ],
  [
    [118.503103107651, 24.8061586335808, 0.00092620961368084],
    [118.502465521835, 24.8065863126219, 0.000926265493035316],
  ],
  [
    [118.503091310203, 24.8061439937064, 0.000926208682358265],
    [118.50245389279, 24.8065718621079, 0.000926261767745018],
  ],
  [
    [118.503079512747, 24.8061293448034, 0.000926205888390541],
    [118.502442243978, 24.8065574206408, 0.000926259905099869],
  ],
  [
    [118.503067695523, 24.8061147049473, 0.000926203094422817],
    [118.50243060507, 24.8065429881903, 0.000926258973777294],
  ],
  [
    [118.503055878303, 24.8061000650902, 0.000926203094422817],
    [118.502418956274, 24.806528555749, 0.00092625804245472],
  ],
  [
    [118.503044061085, 24.8060854252322, 0.000926201231777668],
    [118.502407297602, 24.8065141323445, 0.00092625617980957],
  ],
  [
    [118.50303222409, 24.8060707853934, 0.000926199369132519],
    [118.502395638932, 24.806499708939, 0.000926253385841846],
  ],
  [
    [118.503020387108, 24.8060561545813, 0.00092619750648737],
    [118.502383980276, 24.8064852945603, 0.000926251523196697],
  ],
  [
    [118.503008540239, 24.8060415237783, 0.000926194712519646],
    [118.502372311732, 24.8064708801906, 0.000926250591874123],
  ],
  [
    [118.502996683482, 24.8060268929845, 0.000926193781197071],
    [118.502360643213, 24.8064564838754, 0.000926247797906399],
  ],
  [
    [118.502984816848, 24.8060122712275, 0.000926191918551922],
    [118.502348964807, 24.8064420875694, 0.000926246866583824],
  ],
  [
    [118.502972950207, 24.8059976404418, 0.000926189124584198],
    [118.502337286403, 24.8064276912623, 0.0009262440726161],
  ],
  [
    [118.502961073688, 24.805983018693, 0.000926189124584198],
    [118.502325598122, 24.8064133039921, 0.000926242209970951],
  ],
  [
    [118.502949187294, 24.8059684059809, 0.000926187261939049],
    [118.502313909855, 24.8063989257486, 0.000926240347325802],
  ],
  [
    [118.502937291, 24.8059537842503, 0.000926184467971325],
    [118.502302211712, 24.8063845565419, 0.000926238484680653],
  ],
  [
    [118.502925394721, 24.8059391715464, 0.000926182605326176],
    [118.502290513571, 24.8063701873342, 0.000926236622035503],
  ],
  [
    [118.502913478663, 24.8059245588617, 0.000926180742681026],
    [118.502278805553, 24.8063558271634, 0.000926234759390354],
  ],
  [
    [118.50290156262, 24.8059099552037, 0.000926178880035877],
    [118.50226709755, 24.8063414760192, 0.000926232896745205],
  ],
  [
    [118.502889636689, 24.8058953515548, 0.000926177017390728],
    [118.502255379669, 24.8063271339119, 0.000926231034100056],
  ],
  [
    [118.50287770087, 24.805880747915, 0.000926175154745579],
    [118.502243651901, 24.8063127918136, 0.000926230102777481],
  ],
  [
    [118.502865755175, 24.8058661533121, 0.00092617329210043],
    [118.502231924147, 24.8062984587421, 0.000926228240132332],
  ],
  [
    [118.502853799592, 24.8058515587182, 0.00092617142945528],
    [118.502220196395, 24.8062841256696, 0.000926225446164608],
  ],
  [
    [118.502841834121, 24.8058369641334, 0.000926168635487556],
    [118.502208448887, 24.8062698106717, 0.000926223583519459],
  ],
  [
    [118.502829868665, 24.8058223785754, 0.000926167704164982],
    [118.502196701382, 24.8062554956727, 0.000926222652196884],
  ],
  [
    [118.502817883431, 24.8058077930365, 0.000926166772842407],
    [118.502184953891, 24.8062411897005, 0.00092621985822916],
  ],
  [
    [118.502805898199, 24.8057932074966, 0.000926163978874683],
    [118.502173196512, 24.8062268837374, 0.000926218926906586],
  ],
  [
    [118.502793893201, 24.8057786310036, 0.000926163047552109],
    [118.502161429267, 24.8062125958388, 0.000926217995584011],
  ],
  [
    [118.502781888216, 24.8057640635373, 0.00092615932226181],
    [118.502149662025, 24.8061983079392, 0.000926215201616287],
  ],
  [
    [118.502769863442, 24.8057494870625, 0.00092615932226181],
    [118.502137884906, 24.8061840290764, 0.000926213338971138],
  ],
  [
    [118.502757838683, 24.8057349196144, 0.000926156528294086],
    [118.502126097911, 24.8061697592503, 0.000926212407648563],
  ],
  [
    [118.502745804047, 24.805720361203, 0.000926154665648937],
    [118.502114310929, 24.8061554984509, 0.000926208682358265],
  ],
  [
    [118.502733759523, 24.8057058028008, 0.000926152803003788],
    [118.50210251406, 24.8061412376607, 0.000926206819713116],
  ],
  [
    [118.502721695233, 24.8056912534454, 0.000926150940358639],
    [118.502090707314, 24.8061269859072, 0.000926206819713116],
  ],
  [
    [118.502709630934, 24.8056766950612, 0.000926150009036064],
    [118.502078890702, 24.8061127522181, 0.000926203094422817],
  ],
  [
    [118.50269755677, 24.8056621547416, 0.00092614721506834],
    [118.502067074093, 24.8060985185281, 0.000926202163100243],
  ],
  [
    [118.502685472718, 24.805647614431, 0.000926145352423191],
    [118.502055257487, 24.8060842848371, 0.000926201231777668],
  ],
  [
    [118.502673368889, 24.8056330741396, 0.000926144421100616],
    [118.502043421125, 24.8060700692206, 0.000926199369132519],
  ],
  [
    [118.502661265073, 24.8056185428748, 0.000926142558455467],
    [118.502031584765, 24.8060558536031, 0.000926200300455093],
  ],
  [
    [118.50264915137, 24.8056040116191, 0.000926139764487743],
    [118.50201973854, 24.8060416560501, 0.00092619564384222],
  ],
  [
    [118.5026370179, 24.8055894894103, 0.000926138833165169],
    [118.502007882427, 24.8060274585061, 0.000926193781197071],
  ],
  [
    [118.502624884433, 24.8055749672004, 0.000926137901842594],
    [118.501996016438, 24.8060132699989, 0.000926191918551922],
  ],
  [
    [118.502612731199, 24.8055604540374, 0.000926133245229721],
    [118.501984150462, 24.8059990905184, 0.000926189124584198],
  ],
  [
    [118.502600568077, 24.8055459408834, 0.000926132313907146],
    [118.501972274609, 24.8059849200746, 0.000926189124584198],
  ],
  [
    [118.502588395079, 24.8055314367662, 0.000926131382584572],
    [118.50196038888, 24.8059707586676, 0.0009261853992939],
  ],
  [
    [118.502576212205, 24.8055169416857, 0.000926128588616848],
    [118.501948503164, 24.8059566062873, 0.000926184467971325],
  ],
  [
    [118.502564019443, 24.8055024466142, 0.000926125794649124],
    [118.501936597671, 24.8059424539261, 0.00092618353664875],
  ],
  [
    [118.502551816794, 24.8054879515518, 0.00092612486332655],
    [118.501924692202, 24.8059283196192, 0.000926181674003601],
  ],
  [
    [118.502539604268, 24.8054734655261, 0.00092612486332655],
    [118.501912776846, 24.8059141853214, 0.000926179811358452],
  ],
  [
    [118.502527371975, 24.8054589885473, 0.000926121138036251],
    [118.501900851623, 24.8059000690881, 0.000926177948713303],
  ],
  [
    [118.502515139686, 24.8054445115674, 0.000926118344068527],
    [118.501888916514, 24.8058859528638, 0.000926175154745579],
  ],
  [
    [118.502502887629, 24.8054300436343, 0.000926118344068527],
    [118.501876981429, 24.8058718546938, 0.000926175154745579],
  ],
  [
    [118.502490625696, 24.8054155847379, 0.000926117412745953],
    [118.501865026565, 24.805857756543, 0.000926172360777855],
  ],
  [
    [118.502478353876, 24.8054011258505, 0.000926114618778229],
    [118.501853071716, 24.8058436674188, 0.00092617142945528],
  ],
  [
    [118.502466062277, 24.8053866669823, 0.00092611089348793],
    [118.501841107001, 24.805829596359, 0.000926170498132706],
  ],
  [
    [118.502453770704, 24.8053722261684, 0.000926109962165356],
    [118.501829132398, 24.8058155253083, 0.000926166772842407],
  ],
  [
    [118.502441459353, 24.8053577853736, 0.000926109030842781],
    [118.501817147919, 24.8058014632943, 0.000926164910197258],
  ],
  [
    [118.502429138115, 24.8053433445878, 0.000926108099520206],
    [118.501805153574, 24.8057874193447, 0.000926163047552109],
  ],
  [
    [118.50241679712, 24.8053289218764, 0.000926105305552483],
    [118.501793149341, 24.8057733754042, 0.00092615932226181],
  ],
  [
    [118.502404456129, 24.805314499164, 0.000926104374229908],
    [118.501781135232, 24.8057593405003, 0.000926160253584385],
  ],
  [
    [118.50239209536, 24.8053000764707, 0.000926102511584759],
    [118.501769121147, 24.8057453236508, 0.000926156528294086],
  ],
  [
    [118.502379724714, 24.8052856628141, 0.000926099717617035],
    [118.501757087284, 24.8057313068204, 0.000926155596971512],
  ],
  [
    [118.502367344192, 24.8052712581942, 0.000926097854971886],
    [118.501745053446, 24.8057173080443, 0.000926153734326363],
  ],
  [
    [118.502354943903, 24.805256862621, 0.000926095992326736],
    [118.50173299983, 24.8057033092873, 0.000926151871681213],
  ],
  [
    [118.502342533727, 24.8052424670568, 0.000926095061004162],
    [118.501720946239, 24.8056893285847, 0.000926150940358639],
  ],
  [
    [118.502330113674, 24.8052280805293, 0.000926091335713863],
    [118.50170887287, 24.8056753479011, 0.000926150940358639],
  ],
  [
    [118.502317683745, 24.8052137030385, 0.000926089473068714],
    [118.501696799525, 24.8056613852718, 0.00092614907771349],
  ],
  [
    [118.50230523405, 24.8051993345945, 0.00092608854174614],
    [118.501684716304, 24.8056474316792, 0.00092614721506834],
  ],
  [
    [118.502292774466, 24.8051849661594, 0.00092608667910099],
    [118.501672613315, 24.8056334871334, 0.000926143489778042],
  ],
  [
    [118.502280295116, 24.8051706067711, 0.000926085747778416],
    [118.501660510341, 24.8056195516142, 0.000926142558455467],
  ],
  [
    [118.50226780589, 24.8051562564194, 0.000926083885133266],
    [118.50164839749, 24.8056056251317, 0.000926138833165169],
  ],
  [
    [118.502255306776, 24.8051419060767, 0.000926082022488117],
    [118.501636274762, 24.8055917076859, 0.000926138833165169],
  ],
  [
    [118.502242797797, 24.8051275737984, 0.000926080159842968],
    [118.501624132267, 24.8055777992869, 0.000926137901842594],
  ],
  [
    [118.50223026904, 24.8051132415391, 0.000926077365875244],
    [118.501611989797, 24.8055639089421, 0.000926133245229721],
  ],
  [
    [118.502217720517, 24.8050989183265, 0.000926077365875244],
    [118.501599827559, 24.8055500276441, 0.000926131382584572],
  ],
  [
    [118.502205171996, 24.8050845951128, 0.00092607457190752],
    [118.501587665325, 24.805536146345, 0.000926132313907146],
  ],
  [
    [118.50219260372, 24.8050702899736, 0.000926072709262371],
    [118.501575483334, 24.8055222831203, 0.000926130451261997],
  ],
  [
    [118.502180015665, 24.8050559848533, 0.000926070846617222],
    [118.501563301357, 24.8055084289223, 0.000926128588616848],
  ],
  [
    [118.502167417735, 24.8050416887697, 0.000926067121326923],
    [118.501551099625, 24.8054945927986, 0.000926126725971699],
  ],
  [
    [118.502154809928, 24.8050274017227, 0.000926066190004349],
    [118.501538888004, 24.8054807566839, 0.00092612486332655],
  ],
  [
    [118.502142182355, 24.8050131237224, 0.000926065258681774],
    [118.501526666518, 24.8054669386336, 0.000926122069358826],
  ],
  [
    [118.502129544905, 24.8049988547588, 0.0009260643273592],
    [118.501514435155, 24.8054531296199, 0.000926121138036251],
  ],
  [
    [118.502116887677, 24.8049845858141, 0.00092606246471405],
    [118.501502193916, 24.8054393296429, 0.000926119275391102],
  ],
  [
    [118.502104220584, 24.8049703349338, 0.000926061533391476],
    [118.5014899428, 24.8054255387026, 0.000926117412745953],
  ],
  [
    [118.502091533713, 24.8049560840724, 0.000926057808101177],
    [118.501477681818, 24.8054117658265, 0.000926117412745953],
  ],
  [
    [118.502078836966, 24.8049418422477, 0.000926055945456028],
    [118.501465401058, 24.8053979929695, 0.000926114618778229],
  ],
  [
    [118.502066120453, 24.8049276094697, 0.000926055014133453],
    [118.501453110433, 24.8053842381768, 0.000926111824810505],
  ],
  [
    [118.502053394062, 24.8049133857282, 0.000926054082810879],
    [118.501440819832, 24.8053705014384, 0.000926109962165356],
  ],
  [
    [118.502040647906, 24.8048991710334, 0.00092605035752058],
    [118.501428509453, 24.805356764719, 0.000926108099520206],
  ],
  [
    [118.502027891873, 24.8048849653753, 0.000926049426198006],
    [118.501416189209, 24.8053430460639, 0.000926106236875057],
  ],
  [
    [118.502015116073, 24.8048707687637, 0.000926048494875431],
    [118.501403849198, 24.8053293364555, 0.000926105305552483],
  ],
  [
    [118.502002330397, 24.8048565811888, 0.000926044769585133],
    [118.5013915092, 24.8053156358737, 0.000926104374229908],
  ],
  [
    [118.501989524943, 24.8048423936329, 0.000926043838262558],
    [118.501379149447, 24.8053019533662, 0.000926103442907333],
  ],
  [
    [118.501976709624, 24.8048282241412, 0.000926041975617409],
    [118.501366779816, 24.8052882798954, 0.00092610064893961],
  ],
  [
    [118.501963874538, 24.8048140636961, 0.00092604011297226],
    [118.501354400309, 24.8052746154612, 0.000926097854971886],
  ],
  [
    [118.501951019674, 24.80479990327, 0.00092603825032711],
    [118.501342010937, 24.8052609690912, 0.000926096923649311],
  ],
  [
    [118.501938154946, 24.8047857609082, 0.000926036387681961],
    [118.501329611677, 24.8052473227303, 0.000926095061004162],
  ],
  [
    [118.501925280341, 24.804771627583, 0.000926035456359386],
    [118.501317192671, 24.8052337034713, 0.000926093198359013],
  ],
  [
    [118.501912376067, 24.8047574942867, 0.000926033593714237],
    [118.501304763778, 24.8052200842212, 0.000926090404391289],
  ],
  [
    [118.501899471819, 24.8047433790446, 0.000926031731069088],
    [118.50129232502, 24.8052064830355, 0.000926090404391289],
  ],
  [
    [118.501886537903, 24.8047292638315, 0.000926030799746513],
    [118.501279866494, 24.8051928908964, 0.000926089473068714],
  ],
  [
    [118.501873594122, 24.8047151666827, 0.000926028937101364],
    [118.501267407994, 24.8051793168115, 0.000926087610423565],
  ],
  [
    [118.501860630574, 24.8047010785804, 0.00092602614313364],
    [118.501254929726, 24.8051657517733, 0.000926083885133266],
  ],
  [
    [118.50184765715, 24.8046869995148, 0.000926024280488491],
    [118.501242431691, 24.8051521957816, 0.000926082022488117],
  ],
  [
    [118.501834663959, 24.8046729294957, 0.000926022417843342],
    [118.501229933681, 24.8051386578443, 0.000926082022488117],
  ],
  [
    [118.501821660902, 24.8046588775408, 0.000926019623875618],
    [118.501217406013, 24.8051251289635, 0.000926081091165543],
  ],
  [
    [118.501808638068, 24.8046448256048, 0.000926019623875618],
    [118.501204878349, 24.8051116000817, 0.000926078297197819],
  ],
  [
    [118.501795605369, 24.8046307917331, 0.000926016829907894],
    [118.501192330939, 24.8050980983018, 0.00092607643455267],
  ],
  [
    [118.501782552914, 24.8046167759356, 0.00092601589858532],
    [118.501179763751, 24.8050845965408, 0.00092607457190752],
  ],
  [
    [118.501769490572, 24.804602760147, 0.00092601403594017],
    [118.501167186687, 24.8050711038164, 0.000926071777939796],
  ],
  [
    [118.501756408474, 24.8045887624327, 0.000926012173295021],
    [118.501154599757, 24.8050576291563, 0.000926070846617222],
  ],
  [
    [118.5017433165, 24.8045747737548, 0.000926011241972446],
    [118.501141993061, 24.8050441635427, 0.000926068052649498],
  ],
  [
    [118.501730204759, 24.8045607941235, 0.000926009379327297],
    [118.501129376487, 24.8050307069657, 0.000926068052649498],
  ],
  [
    [118.501717083153, 24.8045468325565, 0.000926006585359573],
    [118.501116740158, 24.8050172684629, 0.000926066190004349],
  ],
  [
    [118.50170395166, 24.8045328709982, 0.00092600379139185],
    [118.501104093941, 24.805003829969, 0.0009260643273592],
  ],
  [
    [118.501690800411, 24.8045189275142, 0.000926002860069275],
    [118.501091437858, 24.8049904095394, 0.000926063396036625],
  ],
  [
    [118.501677629406, 24.8045050021045, 0.000926000997424126],
    [118.501078762008, 24.8049769981564, 0.000926061533391476],
  ],
  [
    [118.501664448514, 24.8044910767035, 0.000925999134778976],
    [118.501066076282, 24.8049635958099, 0.000926058739423752],
  ],
  [
    [118.501651257757, 24.8044771693668, 0.000925997272133827],
    [118.5010533708, 24.8049502115376, 0.000926057808101177],
  ],
  [
    [118.501638047233, 24.8044632710765, 0.000925997272133827],
    [118.50104065543, 24.8049368272742, 0.000926055945456028],
  ],
  [
    [118.501624816943, 24.8044493818328, 0.000925993546843529],
    [118.501027930194, 24.804923461075, 0.000926055014133453],
  ],
  [
    [118.501611586677, 24.8044355106433, 0.000925992615520954],
    [118.501015185192, 24.8049101039223, 0.00092605222016573],
  ],
  [
    [118.501598326755, 24.8044216485103, 0.000925990752875805],
    [118.501002420434, 24.8048967648439, 0.00092605035752058],
  ],
  [
    [118.501585056956, 24.8044077954138, 0.000925988890230656],
    [118.500989655678, 24.8048834257643, 0.00092605035752058],
  ],
  [
    [118.501571777292, 24.8043939603814, 0.000925987958908081],
    [118.500976861276, 24.8048701047689, 0.000926048494875431],
  ],
  [
    [118.50155847785, 24.8043801253679, 0.000925984233617783],
    [118.500964066888, 24.8048567928001, 0.000926046632230282],
  ],
  [
    [118.501545168544, 24.8043663084185, 0.000925984233617783],
    [118.500951252733, 24.8048434898778, 0.000926044769585133],
  ],
  [
    [118.501531849371, 24.8043525095333, 0.000925982370972633],
    [118.500938428712, 24.8048302050197, 0.000926042906939983],
  ],
  [
    [118.501518510421, 24.8043387106669, 0.000925980508327484],
    [118.500925584913, 24.8048169201804, 0.000926039181649685],
  ],
  [
    [118.501505151716, 24.8043249298747, 0.00092597957700491],
    [118.500912731249, 24.8048036534053, 0.00092603825032711],
  ],
  [
    [118.501491783134, 24.804311158119, 0.000925975851714611],
    [118.500899857828, 24.8047904047044, 0.000926037319004536],
  ],
  [
    [118.501478404687, 24.8042974044273, 0.000925974920392036],
    [118.50088697452, 24.8047771560123, 0.000926034525036812],
  ],
  [
    [118.501465006474, 24.8042836597822, 0.000925973989069462],
    [118.500874081347, 24.8047639253844, 0.000926034525036812],
  ],
  [
    [118.501451588493, 24.8042699241835, 0.000925971195101738],
    [118.500861168407, 24.8047507038031, 0.000926033593714237],
  ],
  [
    [118.501438170527, 24.8042561976113, 0.000925969332456589],
    [118.500848245589, 24.8047374912582, 0.000926028937101364],
  ],
  [
    [118.501424722904, 24.8042424800956, 0.000925968401134014],
    [118.500835303005, 24.8047242877597, 0.00092602800577879],
  ],
  [
    [118.501411275306, 24.8042287806339, 0.000925966538488865],
    [118.500822350556, 24.8047111023255, 0.000926027074456215],
  ],
  [
    [118.501397807952, 24.8042150992465, 0.000925964675843716],
    [118.50080938823, 24.8046979259278, 0.00092602614313364],
  ],
  [
    [118.501384320821, 24.8042014178777, 0.000925962813198566],
    [118.500796406136, 24.8046847585765, 0.000926022417843342],
  ],
  [
    [118.501370823824, 24.8041877545731, 0.000925961881875992],
    [118.500783414167, 24.8046716002617, 0.000926022417843342],
  ],
  [
    [118.501357316951, 24.8041741003049, 0.000925960019230843],
    [118.500770412331, 24.8046584600111, 0.000926021486520767],
  ],
  [
    [118.501343790312, 24.8041604550832, 0.000925958156585693],
    [118.500757390729, 24.8046453288069, 0.000926020555198193],
  ],
  [
    [118.501330243917, 24.8041468279356, 0.000925958156585693],
    [118.50074435925, 24.8046322066392, 0.000926017761230469],
  ],
  [
    [118.501316697536, 24.8041332098144, 0.00092595349997282],
    [118.500731308004, 24.804619093518, 0.00092601589858532],
  ],
  [
    [118.501303121498, 24.8041196007496, 0.000925951637327671],
    [118.500718246893, 24.8046059984609, 0.00092601403594017],
  ],
  [
    [118.501289545485, 24.8041060097389, 0.000925951637327671],
    [118.500705175905, 24.8045929124403, 0.000926013104617596],
  ],
  [
    [118.501275949705, 24.8040924277746, 0.000925949774682522],
    [118.50069208515, 24.8045798354661, 0.000926011241972446],
  ],
  [
    [118.501262334159, 24.8040788548568, 0.000925946980714798],
    [118.500678984518, 24.8045667675284, 0.000926009379327297],
  ],
  [
    [118.501248708737, 24.8040652909753, 0.000925945118069649],
    [118.500665864131, 24.8045537176648, 0.000926007516682148],
  ],
  [
    [118.501235073449, 24.8040517451579, 0.000925945118069649],
    [118.500652733867, 24.8045406768376, 0.000926005654036999],
  ],
  [
    [118.501221418395, 24.804038208387, 0.000925942324101925],
    [118.500639593726, 24.8045276450469, 0.00092600379139185],
  ],
  [
    [118.501207753475, 24.8040246896801, 0.000925939530134201],
    [118.500626433818, 24.8045146223026, 0.000926002860069275],
  ],
  [
    [118.501194068778, 24.8040111709919, 0.000925939530134201],
    [118.500613264045, 24.8045016176224, 0.0009260019287467],
  ],
  [
    [118.501180374216, 24.8039976703678, 0.000925937667489052],
    [118.500600084395, 24.8044886219787, 0.000925999134778976],
  ],
  [
    [118.501166669788, 24.8039841878077, 0.000925935804843903],
    [118.500586884978, 24.8044756353814, 0.000925999134778976],
  ],
  [
    [118.501152945594, 24.8039707142941, 0.000925933942198753],
    [118.500573675696, 24.8044626668482, 0.000925996340811253],
  ],
  [
    [118.501139201633, 24.8039572498268, 0.000925932079553604],
    [118.500560446647, 24.8044497073614, 0.000925994478166103],
  ],
  [
    [118.501125457686, 24.8039437943858, 0.000925932079553604],
    [118.500547217611, 24.804436756901, 0.000925993546843529],
  ],
  [
    [118.501111684093, 24.803930357029, 0.000925930216908455],
    [118.500533958918, 24.804423815497, 0.00092599168419838],
  ],
  [
    [118.501097910515, 24.8039169286985, 0.000925927422940731],
    [118.50052070025, 24.8044108921472, 0.00092598982155323],
  ],
  [
    [118.501084117169, 24.8039035094143, 0.000925926491618156],
    [118.500507421815, 24.8043979778437, 0.000925987958908081],
  ],
  [
    [118.501070304057, 24.8038900991765, 0.000925924628973007],
    [118.500494123613, 24.8043850725866, 0.000925986096262932],
  ],
  [
    [118.50105648108, 24.8038767070027, 0.000925922766327858],
    [118.500480825425, 24.804372176356, 0.000925985164940357],
  ],
  [
    [118.501042648238, 24.803863332893, 0.000925919972360134],
    [118.500467507481, 24.8043592981994, 0.000925984233617783],
  ],
  [
    [118.501028805508, 24.803849958792, 0.000925918109714985],
    [118.50045416977, 24.8043464290892, 0.000925980508327484],
  ],
  [
    [118.501014933132, 24.8038366027749, 0.000925918109714985],
    [118.500440822182, 24.8043335690154, 0.000925980508327484],
  ],
  [
    [118.501001060782, 24.8038232648119, 0.000925915315747261],
    [118.500427464729, 24.8043207270056, 0.00092597771435976],
  ],
  [
    [118.500987168653, 24.8038099268675, 0.000925913453102112],
    [118.500414097399, 24.8043078940323, 0.000925975851714611],
  ],
  [
    [118.50097326666, 24.8037966069872, 0.000925912521779537],
    [118.500400710302, 24.8042950701053, 0.000925976783037186],
  ],
  [
    [118.5009593449, 24.8037832961532, 0.000925909727811813],
    [118.500387313328, 24.8042822552147, 0.000925973057746887],
  ],
  [
    [118.500945413275, 24.8037700033832, 0.000925908796489239],
    [118.500373896599, 24.8042694583981, 0.000925972126424313],
  ],
  [
    [118.500931461883, 24.8037567196594, 0.00092590693384409],
    [118.500360469993, 24.8042566706179, 0.000925971195101738],
  ],
  [
    [118.500917510505, 24.8037434449621, 0.000925904139876366],
    [118.500347033511, 24.8042438918741, 0.000925969332456589],
  ],
  [
    [118.500903529481, 24.8037301883487, 0.000925904139876366],
    [118.500333577272, 24.8042311312043, 0.00092596560716629],
  ],
  [
    [118.500889538581, 24.8037169407716, 0.000925901345908642],
    [118.500320121047, 24.8042183795609, 0.000925964675843716],
  ],
  [
    [118.500875537805, 24.8037037022308, 0.000925900414586067],
    [118.500306635166, 24.8042056369738, 0.000925963744521141],
  ],
  [
    [118.500861527163, 24.803690481754, 0.000925898551940918],
    [118.500293149297, 24.8041929034131, 0.000925963744521141],
  ],
  [
    [118.500847496755, 24.8036772703235, 0.000925896689295769],
    [118.500279643673, 24.8041801879264, 0.000925960019230843],
  ],
  [
    [118.500833456481, 24.803664076957, 0.00092589482665062],
    [118.500266118282, 24.804167481486, 0.000925959087908268],
  ],
  [
    [118.50081939643, 24.8036508836091, 0.00092589482665062],
    [118.500252592916, 24.8041547930997, 0.000925957225263119],
  ],
  [
    [118.500805326514, 24.8036377083251, 0.000925891101360321],
    [118.500239047771, 24.804142104732, 0.000925956293940544],
  ],
  [
    [118.500791236842, 24.8036245511151, 0.000925890170037746],
    [118.500225482871, 24.8041294344383, 0.000925954431295395],
  ],
  [
    [118.500777147184, 24.8036114029314, 0.000925887376070023],
    [118.500211917985, 24.804116773171, 0.000925952568650246],
  ],
  [
    [118.500763027869, 24.8035982638039, 0.000925886444747448],
    [118.500198333342, 24.8041041299776, 0.000925950706005096],
  ],
  [
    [118.500748908569, 24.8035851337028, 0.000925885513424873],
    [118.500184728933, 24.8040914958306, 0.000925947912037373],
  ],
  [
    [118.500734769512, 24.8035720216756, 0.000925883650779724],
    [118.500171124537, 24.8040788707099, 0.000925946049392223],
  ],
  [
    [118.500720610689, 24.8035589186946, 0.000925881788134575],
    [118.500157500386, 24.8040662636632, 0.000925946049392223],
  ],
  [
    [118.500706442001, 24.8035458337776, 0.000925881788134575],
    [118.500143856456, 24.8040536566351, 0.000925945118069649],
  ],
  [
    [118.500692263437, 24.8035327578968, 0.000925878994166851],
    [118.500130212562, 24.8040410766888, 0.0009259432554245],
  ],
  [
    [118.500678074996, 24.8035196910523, 0.000925877131521702],
    [118.500116548891, 24.804028496761, 0.000925940461456776],
  ],
  [
    [118.500663866799, 24.8035066422818, 0.000925876200199127],
    [118.500102865463, 24.8040159349072, 0.000925939530134201],
  ],
  [
    [118.500649648727, 24.8034936025474, 0.000925874337553978],
    [118.500089182049, 24.8040033820798, 0.000925939530134201],
  ],
  [
    [118.500635410888, 24.8034805718593, 0.000925872474908829],
    [118.500075478869, 24.8039908382985, 0.000925936736166477],
  ],
  [
    [118.500621163183, 24.8034675592351, 0.00092586874961853],
    [118.500061755932, 24.8039783125913, 0.000925934873521328],
  ],
  [
    [118.500606895712, 24.8034545556572, 0.00092586874961853],
    [118.500048033009, 24.8039657959104, 0.000925933010876179],
  ],
  [
    [118.500592628266, 24.8034415701332, 0.000925866886973381],
    [118.500034290319, 24.8039532882757, 0.00092593114823103],
  ],
  [
    [118.500578331163, 24.8034285936653, 0.000925866886973381],
    [118.500020537764, 24.8039407987051, 0.000925930216908455],
  ],
  [
    [118.500564034074, 24.8034156262238, 0.000925863161683083],
    [118.500006765441, 24.8039283181806, 0.000925928354263306],
  ],
  [
    [118.50054971723, 24.8034026768561, 0.000925862230360508],
    [118.499992983242, 24.8039158466925, 0.000925926491618156],
  ],
  [
    [118.500535390509, 24.8033897365246, 0.000925859436392784],
    [118.499979191177, 24.8039033932683, 0.000925924628973007],
  ],
  [
    [118.500521044021, 24.8033768052393, 0.00092585850507021],
    [118.499965389236, 24.8038909488805, 0.000925924628973007],
  ],
  [
    [118.500506687669, 24.8033638920179, 0.00092585664242506],
    [118.499951567528, 24.8038785135388, 0.000925921835005283],
  ],
  [
    [118.50049232144, 24.8033509878328, 0.00092585664242506],
    [118.499937735954, 24.8038660962611, 0.000925921835005283],
  ],
  [
    [118.500477935455, 24.8033381017215, 0.000925852917134762],
    [118.499923884613, 24.8038536880296, 0.000925918109714985],
  ],
  [
    [118.500463539594, 24.8033252246464, 0.000925852917134762],
    [118.499910023396, 24.8038412888344, 0.00092591717839241],
  ],
  [
    [118.500449133857, 24.8033123566075, 0.000925851054489613],
    [118.499896152313, 24.8038289077031, 0.000925916247069836],
  ],
  [
    [118.500434708364, 24.8032995066425, 0.000925849191844463],
    [118.499882271343, 24.8038165265804, 0.000925914384424686],
  ],
  [
    [118.500420272995, 24.8032866657136, 0.00092584639787674],
    [118.499868370627, 24.8038041725593, 0.000925913453102112],
  ],
  [
    [118.50040581786, 24.8032738338309, 0.000925845466554165],
    [118.499854460024, 24.8037918185468, 0.000925910659134388],
  ],
  [
    [118.500391352859, 24.8032610200121, 0.000925843603909016],
    [118.499840539555, 24.8037794825982, 0.000925909727811813],
  ],
  [
    [118.500376877982, 24.8032482152295, 0.000925842672586441],
    [118.499826599331, 24.8037671647235, 0.000925908796489239],
  ],
  [
    [118.500362383349, 24.8032354285206, 0.000925840809941292],
    [118.499812659109, 24.8037548468474, 0.000925906002521515],
  ],
  [
    [118.50034788873, 24.8032226508381, 0.000925839878618717],
    [118.499798689241, 24.8037425470551, 0.00092590507119894],
  ],
  [
    [118.500333364455, 24.8032098822116, 0.000925837084650993],
    [118.499784719397, 24.8037302653168, 0.000925904139876366],
  ],
  [
    [118.500318840204, 24.803197131639, 0.000925836153328419],
    [118.499770729776, 24.803717983597, 0.000925900414586067],
  ],
  [
    [118.500304296187, 24.8031843901125, 0.000925833359360695],
    [118.499756730289, 24.8037057199411, 0.000925901345908642],
  ],
  [
    [118.500289732414, 24.8031716666598, 0.000925833359360695],
    [118.499742720936, 24.8036934743491, 0.000925897620618343],
  ],
  [
    [118.500275168655, 24.8031589522334, 0.000925830565392971],
    [118.499728691806, 24.8036812287756, 0.000925897620618343],
  ],
  [
    [118.500260585141, 24.8031462558807, 0.000925829634070396],
    [118.49971465281, 24.803669001266, 0.00092589482665062],
  ],
  [
    [118.500245991739, 24.8031335595365, 0.000925828702747822],
    [118.499700603948, 24.8036567918203, 0.000925893895328045],
  ],
  [
    [118.500231378593, 24.8031208902938, 0.000925826840102673],
    [118.499686535308, 24.8036445823931, 0.000925892032682896],
  ],
  [
    [118.500216755559, 24.8031082210596, 0.000925825908780098],
    [118.499672456814, 24.8036324000574, 0.000925892032682896],
  ],
  [
    [118.50020212266, 24.8030955698891, 0.000925824046134949],
    [118.499658368432, 24.8036202177303, 0.000925890170037746],
  ],
  [
    [118.500187470006, 24.8030829367925, 0.0009258221834898],
    [118.499644270184, 24.8036080534671, 0.000925888307392597],
  ],
  [
    [118.500172807475, 24.803070312732, 0.000925817526876926],
    [118.49963015217, 24.80359589825, 0.000925886444747448],
  ],
  [
    [118.500158135068, 24.8030576977076, 0.000925819389522076],
    [118.499616024289, 24.8035837610968, 0.000925885513424873],
  ],
  [
    [118.500143442905, 24.803045100757, 0.000925816595554352],
    [118.499601886522, 24.8035716239521, 0.00092588271945715],
  ],
  [
    [118.500128740866, 24.8030325128424, 0.000925817526876926],
    [118.499587738899, 24.803559513899, 0.00092588271945715],
  ],
  [
    [118.500114028951, 24.8030199339641, 0.000925814732909203],
    [118.499573571499, 24.8035474038643, 0.000925879925489426],
  ],
  [
    [118.50009929728, 24.8030073731595, 0.000925811007618904],
    [118.499559394233, 24.8035353118935, 0.000925878062844276],
  ],
  [
    [118.500084555732, 24.8029948213909, 0.000925811007618904],
    [118.499545197211, 24.8035232379965, 0.000925878062844276],
  ],
  [
    [118.50006980432, 24.8029822876862, 0.00092580821365118],
    [118.499531000192, 24.803511164098, 0.000925876200199127],
  ],
  [
    [118.500055033141, 24.8029697630276, 0.00092580821365118],
    [118.499516783417, 24.8034991082734, 0.000925874337553978],
  ],
  [
    [118.500040252096, 24.8029572564327, 0.000925805419683456],
    [118.499502556776, 24.8034870705126, 0.000925873406231403],
  ],
  [
    [118.500025461175, 24.8029447588739, 0.000925804488360882],
    [118.499488310368, 24.8034750417978, 0.000925871543586254],
  ],
  [
    [118.500010650488, 24.8029322703612, 0.000925801694393158],
    [118.499474063974, 24.8034630221094, 0.00092586874961853],
  ],
  [
    [118.499995839826, 24.8029197999023, 0.000925803557038307],
    [118.499459797813, 24.803451011467, 0.00092586874961853],
  ],
  [
    [118.499980999517, 24.8029073475271, 0.000925800763070583],
    [118.499445511896, 24.8034390188984, 0.000925865955650806],
  ],
  [
    [118.499966159212, 24.8028948951503, 0.000925797037780285],
    [118.499431225993, 24.8034270353561, 0.000925865024328232],
  ],
  [
    [118.499951299162, 24.8028824698749, 0.000925797037780285],
    [118.499416920334, 24.8034150698875, 0.000925863161683083],
  ],
  [
    [118.499936429225, 24.8028700446079, 0.000925795175135136],
    [118.499402604798, 24.803403113455, 0.000925862230360508],
  ],
  [
    [118.499921539532, 24.8028576374146, 0.000925792381167412],
    [118.499388279396, 24.8033911750864, 0.000925860367715359],
  ],
  [
    [118.499906649864, 24.8028452482752, 0.000925792381167412],
    [118.499373934217, 24.8033792367361, 0.000925859436392784],
  ],
  [
    [118.499891740418, 24.8028328591541, 0.000925790518522263],
    [118.499359579182, 24.8033673254774, 0.000925857573747635],
  ],
  [
    [118.499876811228, 24.8028204971343, 0.000925789587199688],
    [118.499345214261, 24.8033554142271, 0.00092585664242506],
  ],
  [
    [118.499861882041, 24.802808135113, 0.000925787724554539],
    [118.499330839473, 24.8033435210407, 0.000925854779779911],
  ],
  [
    [118.499846933109, 24.802795800193, 0.00092578586190939],
    [118.499316454809, 24.8033316368904, 0.000925853848457336],
  ],
  [
    [118.4998319644, 24.8027834652913, 0.00092578399926424],
    [118.499302050389, 24.8033197708138, 0.000925851985812187],
  ],
  [
    [118.499816995715, 24.8027711484435, 0.000925782136619091],
    [118.499287636093, 24.8033079137733, 0.000925851054489613],
  ],
  [
    [118.499802007275, 24.8027588496693, 0.000925780273973942],
    [118.49927320204, 24.8032960748065, 0.000925849191844463],
  ],
  [
    [118.499787008959, 24.8027465599311, 0.000925779342651367],
    [118.49925876799, 24.8032842358383, 0.000925847329199314],
  ],
  [
    [118.499771990876, 24.8027342792389, 0.000925776548683643],
    [118.499244314195, 24.8032724239715, 0.00092584453523159],
  ],
  [
    [118.499756962927, 24.8027220166105, 0.000925776548683643],
    [118.499229850512, 24.8032606121131, 0.000925843603909016],
  ],
  [
    [118.499741925103, 24.802709763018, 0.000925775617361069],
    [118.499215367074, 24.8032488183284, 0.000925842672586441],
  ],
  [
    [118.499726877412, 24.8026975274894, 0.000925773754715919],
    [118.49920088366, 24.8032370425976, 0.000925840809941292],
  ],
  [
    [118.499711809956, 24.8026853010066, 0.000925770960748196],
    [118.499186380479, 24.8032252759128, 0.000925839878618717],
  ],
  [
    [118.499696732634, 24.8026730925875, 0.000925770960748196],
    [118.499171867422, 24.8032135182641, 0.000925838947296143],
  ],
  [
    [118.499681645435, 24.8026608932045, 0.000925768166780472],
    [118.499157344487, 24.8032017696515, 0.000925837084650993],
  ],
  [
    [118.499666548361, 24.8026487028575, 0.000925767235457897],
    [118.499142801797, 24.8031900391126, 0.000925835222005844],
  ],
  [
    [118.49965143153, 24.8026365305841, 0.000925766304135323],
    [118.499128249241, 24.8031783266374, 0.000925833359360695],
  ],
  [
    [118.499636304834, 24.8026243763745, 0.000925763510167599],
    [118.499113686798, 24.8031666141706, 0.00092583242803812],
  ],
  [
    [118.499621168262, 24.8026122312008, 0.000925761647522449],
    [118.499099114489, 24.8031549197677, 0.00092583242803812],
  ],
  [
    [118.499606021825, 24.8026001040908, 0.000925761647522449],
    [118.499084522413, 24.8031432344107, 0.000925827771425247],
  ],
  [
    [118.499590865511, 24.8025879860169, 0.0009257597848773],
    [118.499069910581, 24.8031315671273, 0.000925827771425247],
  ],
  [
    [118.499575699331, 24.8025758860066, 0.000925757922232151],
    [118.499055298752, 24.8031198998424, 0.000925826840102673],
  ],
  [
    [118.499560513396, 24.8025638040699, 0.000925756059587002],
    [118.499040657277, 24.803108250641, 0.000925825908780098],
  ],
  [
    [118.499545327475, 24.8025517311593, 0.000925753265619278],
    [118.499026015804, 24.8030966014382, 0.000925823114812374],
  ],
  [
    [118.499530131677, 24.8025396672847, 0.000925753265619278],
    [118.499011354586, 24.8030849793367, 0.0009258221834898],
  ],
  [
    [118.499514926025, 24.8025276305015, 0.000925752334296703],
    [118.498996683481, 24.8030733572435, 0.000925821252167225],
  ],
  [
    [118.499499700595, 24.8025155937365, 0.000925749540328979],
    [118.498981992609, 24.8030617441962, 0.000925818458199501],
  ],
  [
    [118.49948447519, 24.8025035750253, 0.00092574767768383],
    [118.498967291861, 24.8030501401851, 0.000925817526876926],
  ],
  [
    [118.499469239919, 24.8024915743777, 0.00092574767768383],
    [118.498952581246, 24.8030385542376, 0.000925816595554352],
  ],
  [
    [118.499453994783, 24.8024795917938, 0.000925745815038681],
    [118.498937860755, 24.8030269773262, 0.000925814732909203],
  ],
  [
    [118.49943872987, 24.8024676092281, 0.000925743021070957],
    [118.498923120497, 24.8030154094607, 0.000925812870264053],
  ],
  [
    [118.499423464992, 24.8024556537438, 0.000925743021070957],
    [118.498908370363, 24.8030038506313, 0.000925811938941479],
  ],
  [
    [118.499408190227, 24.8024436982679, 0.000925740227103233],
    [118.498893600462, 24.8029923008477, 0.000925811938941479],
  ],
  [
    [118.499392905607, 24.8024317698833, 0.000925740227103233],
    [118.498878830574, 24.8029807600904, 0.00092580821365118],
  ],
  [
    [118.4993776111, 24.8024198415069, 0.000925737433135509],
    [118.49886404092, 24.8029692283789, 0.000925807282328606],
  ],
  [
    [118.499362316618, 24.8024079311844, 0.00092573557049036],
    [118.498849231509, 24.802957714741, 0.000925806351006031],
  ],
  [
    [118.49934700238, 24.8023960389353, 0.000925734639167786],
    [118.498834422102, 24.8029462011015, 0.000925804488360882],
  ],
  [
    [118.499331678265, 24.8023841557222, 0.000925734639167786],
    [118.498819592938, 24.8029347055357, 0.000925802625715733],
  ],
  [
    [118.499316354164, 24.8023722815353, 0.000925732776522636],
    [118.498804753887, 24.8029232099781, 0.000925803557038307],
  ],
  [
    [118.499301010308, 24.8023604254218, 0.000925730913877487],
    [118.49878990497, 24.8029117324843, 0.000925799831748009],
  ],
  [
    [118.499285666465, 24.8023485783344, 0.000925727188587189],
    [118.498775046176, 24.8029002640265, 0.00092579796910286],
  ],
  [
    [118.499270312757, 24.8023367493106, 0.000925728119909763],
    [118.498760167616, 24.8028888046145, 0.000925795175135136],
  ],
  [
    [118.499254949173, 24.8023249293228, 0.000925727188587189],
    [118.498745279168, 24.8028773452109, 0.000925797037780285],
  ],
  [
    [118.499239575722, 24.8023131273986, 0.000925724394619465],
    [118.498730390745, 24.8028659038611, 0.000925795175135136],
  ],
  [
    [118.499224192385, 24.8023013254827, 0.00092572346329689],
    [118.498715472665, 24.802854471567, 0.000925793312489986],
  ],
  [
    [118.499208809083, 24.8022895506482, 0.000925720669329166],
    [118.498700554598, 24.8028430482991, 0.000925791449844837],
  ],
  [
    [118.499193415894, 24.802277775822, 0.000925719738006592],
    [118.498685626654, 24.8028316340671, 0.000925788655877113],
  ],
  [
    [118.499178012839, 24.8022660190594, 0.000925716012716293],
    [118.498670678933, 24.8028202198533, 0.000925788655877113],
  ],
  [
    [118.499162599908, 24.8022542713327, 0.000925717875361443],
    [118.498655721347, 24.8028088237032, 0.00092578586190939],
  ],
  [
    [118.499147177112, 24.8022425416696, 0.000925714150071144],
    [118.498640753883, 24.8027974365891, 0.00092578586190939],
  ],
  [
    [118.499131754329, 24.8022308210326, 0.000925714150071144],
    [118.498625776532, 24.8027860494832, 0.000925784930586815],
  ],
  [
    [118.499116321669, 24.8022191094315, 0.000925714150071144],
    [118.498610789316, 24.8027746804411, 0.000925783067941666],
  ],
  [
    [118.499100879133, 24.8022074068664, 0.00092571135610342],
    [118.498595792222, 24.8027633204349, 0.000925781205296516],
  ],
  [
    [118.499085426732, 24.8021957223648, 0.000925709493458271],
    [118.498580775351, 24.8027519604468, 0.000925781205296516],
  ],
  [
    [118.499069974344, 24.8021840468893, 0.000925708562135696],
    [118.498565758505, 24.8027406185125, 0.000925777480006218],
  ],
  [
    [118.49905451208, 24.8021723804498, 0.000925705768167973],
    [118.498550721881, 24.8027292765964, 0.000925775617361069],
  ],
  [
    [118.499039039951, 24.8021607320738, 0.000925704836845398],
    [118.49853568527, 24.8027179437064, 0.000925775617361069],
  ],
  [
    [118.499023557945, 24.8021490927337, 0.000925702974200249],
    [118.498520628893, 24.8027066198622, 0.000925774686038494],
  ],
  [
    [118.499008075952, 24.8021374624197, 0.000925702042877674],
    [118.498505562649, 24.8026953140816, 0.000925772823393345],
  ],
  [
    [118.498992584084, 24.8021258411416, 0.000925701111555099],
    [118.498490486508, 24.8026839992816, 0.000925770960748196],
  ],
  [
    [118.498977082338, 24.8021142288994, 0.00092569924890995],
    [118.498475410391, 24.8026727025354, 0.000925770029425621],
  ],
  [
    [118.498961580618, 24.8021026347109, 0.000925698317587376],
    [118.498460314507, 24.802661414835, 0.000925768166780472],
  ],
  [
    [118.498946069021, 24.8020910495583, 0.000925697386264801],
    [118.498445208746, 24.8026501361706, 0.000925766304135323],
  ],
  [
    [118.498930547547, 24.8020794734416, 0.000925695523619652],
    [118.498430093098, 24.8026388575144, 0.000925767235457897],
  ],
  [
    [118.498915026087, 24.802067906351, 0.000925693660974503],
    [118.498414967574, 24.8026275878941, 0.000925763510167599],
  ],
  [
    [118.498899494762, 24.8020563573239, 0.000925691798329353],
    [118.498399832173, 24.8026163273098, 0.000925762578845024],
  ],
  [
    [118.49888396345, 24.8020448173229, 0.000925689004361629],
    [118.498384686895, 24.8026050757614, 0.000925760716199875],
  ],
  [
    [118.498868422251, 24.8020332773301, 0.000925689004361629],
    [118.49836953174, 24.802593833249, 0.0009257597848773],
  ],
  [
    [118.498852871186, 24.8020217554008, 0.00092568714171648],
    [118.498354366699, 24.8025825907447, 0.0009257597848773],
  ],
  [
    [118.498837320135, 24.8020102424976, 0.000925686210393906],
    [118.498339191791, 24.8025713663042, 0.000925758853554726],
  ],
  [
    [118.498821759208, 24.8019987386303, 0.000925683416426182],
    [118.498324006996, 24.8025601418718, 0.000925756990909576],
  ],
  [
    [118.498806188415, 24.8019872528265, 0.000925683416426182],
    [118.498308812324, 24.8025489264754, 0.000925755128264427],
  ],
  [
    [118.498790617625, 24.8019757670211, 0.000925681553781033],
    [118.498293617655, 24.8025377110774, 0.000925752334296703],
  ],
  [
    [118.498775036969, 24.8019642992792, 0.000925680622458458],
    [118.49827840323, 24.8025265137527, 0.000925752334296703],
  ],
  [
    [118.498759456316, 24.8019528315357, 0.000925680622458458],
    [118.498263178918, 24.8025153164364, 0.000925751402974129],
  ],
  [
    [118.498743875687, 24.8019413818459, 0.000925675965845585],
    [118.498247954619, 24.8025041281461, 0.000925748609006405],
  ],
  [
    [118.498728275292, 24.8019299412018, 0.000925675965845585],
    [118.498232710542, 24.8024929398738, 0.000925748609006405],
  ],
  [
    [118.498712674911, 24.8019185095838, 0.000925673171877861],
    [118.49821746649, 24.8024817696554, 0.000925745815038681],
  ],
  [
    [118.498697074532, 24.8019070779641, 0.000925674103200436],
    [118.498202212551, 24.8024705994451, 0.000925745815038681],
  ],
  [
    [118.498681464288, 24.8018956644079, 0.000925670377910137],
    [118.498186938834, 24.8024594292529, 0.000925743952393532],
  ],
  [
    [118.498665854058, 24.8018842598778, 0.000925669446587563],
    [118.498171665141, 24.8024482771144, 0.000925742089748383],
  ],
  [
    [118.49865023395, 24.8018728643835, 0.000925669446587563],
    [118.498156391451, 24.8024371249744, 0.000925741158425808],
  ],
  [
    [118.498634613857, 24.8018614779152, 0.000925665721297264],
    [118.498141097994, 24.80242598188, 0.000925738364458084],
  ],
  [
    [118.498618983887, 24.8018501004828, 0.000925667583942413],
    [118.49812579465, 24.8024148387939, 0.000925736501812935],
  ],
  [
    [118.498603353931, 24.8018387320764, 0.000925664789974689],
    [118.498110491319, 24.8024037047338, 0.000925734639167786],
  ],
  [
    [118.498587714098, 24.8018273727059, 0.000925664789974689],
    [118.498095168221, 24.8023925797194, 0.000925734639167786],
  ],
  [
    [118.498572074279, 24.8018160223614, 0.00092566292732954],
    [118.498079845137, 24.8023814637311, 0.000925733707845211],
  ],
  [
    [118.498556424584, 24.8018046810527, 0.000925661064684391],
    [118.498064512166, 24.802370347751, 0.000925732776522636],
  ],
  [
    [118.498540774891, 24.8017933397424, 0.000925659202039242],
    [118.498049169307, 24.8023592317791, 0.000925729982554913],
  ],
  [
    [118.498525115333, 24.8017820164956, 0.000925657339394093],
    [118.498033826473, 24.8023481338609, 0.000925729051232338],
  ],
  [
    [118.498509455788, 24.8017707022748, 0.000925656408071518],
    [118.498018463861, 24.8023370359607, 0.000925727188587189],
  ],
  [
    [118.498493796246, 24.8017593880524, 0.000925654545426369],
    [118.498003101252, 24.8023259380589, 0.000925727188587189],
  ],
  [
    [118.498478126838, 24.8017480918934, 0.000925654545426369],
    [118.497987728766, 24.802314849193, 0.000925725325942039],
  ],
  [
    [118.498462457433, 24.8017367957328, 0.000925651751458645],
    [118.497972356293, 24.8023037693531, 0.00092572346329689],
  ],
  [
    [118.498446788053, 24.8017255176259, 0.00092565082013607],
    [118.497956964043, 24.8022926895312, 0.000925721600651741],
  ],
  [
    [118.498431108785, 24.8017142395272, 0.000925648957490921],
    [118.497941571807, 24.8022816187354, 0.000925720669329166],
  ],
  [
    [118.498415419641, 24.8017029704642, 0.000925648026168346],
    [118.497926169683, 24.8022705479477, 0.000925718806684017],
  ],
  [
    [118.4983997404, 24.8016917104175, 0.000925647094845772],
    [118.497910757682, 24.8022594861959, 0.000925717875361443],
  ],
  [
    [118.498384051283, 24.8016804594066, 0.000925644300878048],
    [118.497895335805, 24.8022484334799, 0.000925716944038868],
  ],
  [
    [118.498368352279, 24.8016692084039, 0.000925643369555473],
    [118.497879913931, 24.8022373807623, 0.000925714150071144],
  ],
  [
    [118.498352663189, 24.801657975445, 0.000925640575587749],
    [118.497864482169, 24.8022263280529, 0.000925713218748569],
  ],
  [
    [118.498336964212, 24.8016467424942, 0.000925640575587749],
    [118.497849040531, 24.8022152843793, 0.000925713218748569],
  ],
  [
    [118.498321255359, 24.8016355185793, 0.000925639644265175],
    [118.497833598895, 24.8022042407041, 0.000925709493458271],
  ],
  [
    [118.498305556409, 24.8016243036806, 0.000925637781620026],
    [118.497818147383, 24.8021932060648, 0.000925709493458271],
  ],
  [
    [118.498289847582, 24.8016130978177, 0.000925636850297451],
    [118.497802685994, 24.8021821804612, 0.000925707630813122],
  ],
  [
    [118.498274138759, 24.8016018919531, 0.000925634987652302],
    [118.497787224608, 24.802171154856, 0.000925705768167973],
  ],
  [
    [118.498258420059, 24.8015906951243, 0.000925634056329727],
    [118.497771753334, 24.802160129259, 0.000925705768167973],
  ],
  [
    [118.498242701372, 24.8015795073215, 0.000925630331039429],
    [118.497756272184, 24.8021491126978, 0.000925704836845398],
  ],
  [
    [118.498226982699, 24.8015683285448, 0.000925629399716854],
    [118.497740781147, 24.8021380961447, 0.000925702042877674],
  ],
  [
    [118.49821126404, 24.801557158794, 0.000925629399716854],
    [118.497725290112, 24.8021270795901, 0.000925701111555099],
  ],
  [
    [118.498195535493, 24.8015459890514, 0.000925628468394279],
    [118.497709799101, 24.8021160810891, 0.00092569924890995],
  ],
  [
    [118.49817981685, 24.801534828325, 0.00092562660574913],
    [118.497694288303, 24.8021050735783, 0.000925698317587376],
  ],
  [
    [118.498164088331, 24.8015236766344, 0.000925622880458832],
    [118.497678777517, 24.8020940750936, 0.000925697386264801],
  ],
  [
    [118.498148349924, 24.8015125249518, 0.000925624743103981],
    [118.497663256845, 24.8020830766171, 0.000925695523619652],
  ],
  [
    [118.498132621421, 24.8015013822855, 0.000925621949136257],
    [118.497647736185, 24.8020720871665, 0.000925693660974503],
  ],
  [
    [118.498116883041, 24.801490248655, 0.000925621017813683],
    [118.497632205639, 24.8020610977241, 0.000925692729651928],
  ],
  [
    [118.498101144664, 24.8014791150229, 0.000925619155168533],
    [118.497616675095, 24.8020501082801, 0.000925691798329353],
  ],
  [
    [118.498085406301, 24.8014679904167, 0.000925618223845959],
    [118.497601134675, 24.8020391278719, 0.000925689004361629],
  ],
  [
    [118.498069667951, 24.8014568748365, 0.000925615429878235],
    [118.497585584367, 24.8020281474717, 0.000925688073039055],
  ],
  [
    [118.498053919725, 24.8014457682921, 0.000925616361200809],
    [118.497570034062, 24.8020171670699, 0.000925688073039055],
  ],
  [
    [118.498038171501, 24.801434661746, 0.000925613567233086],
    [118.49755447388, 24.802006195704, 0.000925686210393906],
  ],
  [
    [118.498022433171, 24.8014235551885, 0.000925612635910511],
    [118.497538913701, 24.8019952243363, 0.000925685279071331],
  ],
  [
    [118.498006684974, 24.8014124666944, 0.000925611704587936],
    [118.497523343635, 24.8019842529768, 0.000925682485103607],
  ],
  [
    [118.49799092688, 24.8014013691808, 0.000925608910620213],
    [118.497507773582, 24.8019732906433, 0.000925682485103607],
  ],
  [
    [118.4979751787, 24.801390289711, 0.000925607979297638],
    [118.497492193642, 24.801962328318, 0.000925678759813309],
  ],
  [
    [118.497959430522, 24.8013792102396, 0.000925607047975063],
    [118.497476603814, 24.8019513660007, 0.000925677828490734],
  ],
  [
    [118.497943672468, 24.8013681398039, 0.000925606116652489],
    [118.497461013989, 24.8019404036817, 0.000925676897168159],
  ],
  [
    [118.497927924307, 24.8013570693568, 0.00092560239136219],
    [118.497445424178, 24.8019294503888, 0.000925675965845585],
  ],
  [
    [118.49791216627, 24.8013460079454, 0.00092560239136219],
    [118.497429824479, 24.801918497104, 0.000925674103200436],
  ],
  [
    [118.497896408235, 24.8013349465324, 0.000925600528717041],
    [118.497414214893, 24.8019075438273, 0.000925672240555286],
  ],
  [
    [118.497880650214, 24.8013238941454, 0.000925599597394466],
    [118.49739860531, 24.8018965905489, 0.000925671309232712],
  ],
  [
    [118.497864892195, 24.8013128417566, 0.000925596803426743],
    [118.49738299574, 24.8018856462966, 0.000925671309232712],
  ],
  [
    [118.49784913419, 24.8013017983939, 0.000925596803426743],
    [118.497367376272, 24.8018746930246, 0.000925669446587563],
  ],
  [
    [118.497833366298, 24.8012907550393, 0.000925594940781593],
    [118.497351746928, 24.8018637487884, 0.000925668515264988],
  ],
  [
    [118.497817608309, 24.8012797207009, 0.000925594009459019],
    [118.497336117597, 24.8018528135783, 0.000925666652619839],
  ],
  [
    [118.497801850334, 24.8012686953885, 0.000925592146813869],
    [118.497320488258, 24.8018418693388, 0.000925666652619839],
  ],
  [
    [118.497786082461, 24.8012576610565, 0.000925593078136444],
    [118.497304849031, 24.8018309251074, 0.000925664789974689],
  ],
  [
    [118.497770324502, 24.8012466447684, 0.000925589352846146],
    [118.497289209818, 24.801819989902, 0.000925663858652115],
  ],
  [
    [118.497754566535, 24.8012356194509, 0.000925588421523571],
    [118.497273560718, 24.8018090547046, 0.000925661064684391],
  ],
  [
    [118.497738798702, 24.8012246121969, 0.000925587490200996],
    [118.497257911621, 24.8017981195056, 0.000925660133361816],
  ],
  [
    [118.497723040752, 24.8012135959037, 0.000925586558878422],
    [118.497242262526, 24.801787184305, 0.000925660133361816],
  ],
  [
    [118.497707272924, 24.8012025886463, 0.000925584696233273],
    [118.497226603544, 24.8017762491124, 0.000925657339394093],
  ],
  [
    [118.497691515001, 24.8011915904052, 0.000925582833588123],
    [118.497210944565, 24.8017653139181, 0.000925654545426369],
  ],
  [
    [118.49767574719, 24.8011805921721, 0.000925580970942974],
    [118.497195275709, 24.8017543877596, 0.000925653614103794],
  ],
  [
    [118.497659989272, 24.8011695939275, 0.000925580039620399],
    [118.497179606845, 24.8017434525717, 0.000925651751458645],
  ],
  [
    [118.497644221466, 24.8011585956911, 0.000925579108297825],
    [118.497163937995, 24.8017325264099, 0.00092565082013607],
  ],
  [
    [118.497628463565, 24.8011476064708, 0.000925579108297825],
    [118.497148259246, 24.8017215912284, 0.000925649888813496],
  ],
  [
    [118.497612695786, 24.8011366262864, 0.000925576314330101],
    [118.497132580511, 24.8017106650729, 0.000925648957490921],
  ],
  [
    [118.497596937901, 24.8011256460905, 0.000925575383007526],
    [118.497116891889, 24.8016997389255, 0.000925647094845772],
  ],
  [
    [118.497581180018, 24.8011146658929, 0.000925573520362377],
    [118.497101203269, 24.8016888127764, 0.000925644300878048],
  ],
  [
    [118.497565412248, 24.8011036857033, 0.000925572589039803],
    [118.497085514642, 24.8016778775979, 0.000925644300878048],
  ],
  [
    [118.497549654381, 24.80109271453, 0.000925570726394653],
    [118.497069816138, 24.8016669514552, 0.000925644300878048],
  ],
  [
    [118.497533896517, 24.801081743355, 0.000925568863749504],
    [118.497054127526, 24.8016560253011, 0.000925642438232899],
  ],
  [
    [118.497518138656, 24.8010707721784, 0.000925567932426929],
    [118.497038419138, 24.8016450991648, 0.000925639644265175],
  ],
  [
    [118.497502380808, 24.8010598100277, 0.000925567932426929],
    [118.497022720642, 24.801634173017, 0.0009256387129426],
  ],
  [
    [118.497486622963, 24.8010488478754, 0.000925565138459206],
    [118.497007012248, 24.8016232378496, 0.000925636850297451],
  ],
  [
    [118.497470875011, 24.8010378857116, 0.000925565138459206],
    [118.496991303868, 24.8016123117083, 0.000925634987652302],
  ],
  [
    [118.497455117172, 24.8010269235559, 0.000925561413168907],
    [118.49697559549, 24.8016013855652, 0.000925634056329727],
  ],
  [
    [118.497439369236, 24.8010159704164, 0.000925560481846333],
    [118.496959877225, 24.8015904594302, 0.000925633125007153],
  ],
  [
    [118.497423611413, 24.801005017285, 0.000925559550523758],
    [118.496944158952, 24.8015795242658, 0.000925631262362003],
  ],
  [
    [118.497407863482, 24.8009940641421, 0.000925557687878609],
    [118.496928440693, 24.8015685981274, 0.000925630331039429],
  ],
  [
    [118.497392115565, 24.8009831200253, 0.000925556756556034],
    [118.496912722426, 24.8015576629596, 0.000925628468394279],
  ],
  [
    [118.497376367641, 24.8009721668791, 0.000925554893910885],
    [118.496896994271, 24.8015467277999, 0.000925628468394279],
  ],
  [
    [118.497360619729, 24.8009612227589, 0.00092555396258831],
    [118.49688126613, 24.8015358016662, 0.00092562660574913],
  ],
  [
    [118.49734488171, 24.8009502786272, 0.000925553031265736],
    [118.496865537981, 24.8015248665031, 0.000925625674426556],
  ],
  [
    [118.497329133805, 24.8009393345036, 0.000925551168620586],
    [118.496849809835, 24.8015139313383, 0.000925622880458832],
  ],
  [
    [118.497313395802, 24.8009283993963, 0.000925549305975437],
    [118.496834071801, 24.8015029961816, 0.000925624743103981],
  ],
  [
    [118.497297657792, 24.8009174552597, 0.000925548374652863],
    [118.49681833377, 24.8014920610232, 0.000925620086491108],
  ],
  [
    [118.497281919795, 24.800906520149, 0.000925545580685139],
    [118.496802595732, 24.8014811168354, 0.000925620086491108],
  ],
  [
    [118.4972661818, 24.8008955850366, 0.000925545580685139],
    [118.496786867596, 24.8014701816639, 0.000925618223845959],
  ],
  [
    [118.497250443798, 24.8008846408949, 0.000925543718039989],
    [118.496771129563, 24.8014592374727, 0.000925617292523384],
  ],
  [
    [118.497234715699, 24.8008737057694, 0.00092554185539484],
    [118.496755391543, 24.8014483023075, 0.000925616361200809],
  ],
  [
    [118.497218977713, 24.800862770652, 0.000925540924072266],
    [118.496739653526, 24.8014373671407, 0.000925615429878235],
  ],
  [
    [118.49720323972, 24.8008518265052, 0.000925539061427116],
    [118.496723915501, 24.8014264229445, 0.000925612635910511],
  ],
  [
    [118.497187501739, 24.8008408913844, 0.000925539061427116],
    [118.49670817749, 24.8014154877742, 0.000925610773265362],
  ],
  [
    [118.497171763761, 24.8008299562619, 0.000925537198781967],
    [118.496692439481, 24.8014045526023, 0.000925610773265362],
  ],
  [
    [118.497156025776, 24.8008190121101, 0.000925536267459393],
    [118.496676701465, 24.8013936084011, 0.000925607047975063],
  ],
  [
    [118.497140287804, 24.8008080769843, 0.000925534404814243],
    [118.496660963461, 24.8013826732258, 0.000925607979297638],
  ],
  [
    [118.497124549834, 24.8007971418567, 0.000925533473491669],
    [118.496645225461, 24.8013717380488, 0.000925607047975063],
  ],
  [
    [118.497108811857, 24.8007861976998, 0.000925531610846519],
    [118.496629487453, 24.8013607938425, 0.000925606116652489],
  ],
  [
    [118.497093073893, 24.800775262569, 0.00092552974820137],
    [118.496613759348, 24.8013498586525, 0.000925604254007339],
  ],
  [
    [118.497077345822, 24.8007643274267, 0.00092552974820137],
    [118.496598021355, 24.8013389234705, 0.000925601460039616],
  ],
  [
    [118.497061607853, 24.8007533832647, 0.000925527885556221],
    [118.496582283355, 24.8013279792591, 0.000925600528717041],
  ],
  [
    [118.497045869897, 24.8007424481288, 0.000925527885556221],
    [118.496566545369, 24.8013170440738, 0.000925598666071892],
  ],
  [
    [118.497030131944, 24.8007315129911, 0.000925525091588497],
    [118.496550807385, 24.8013061088867, 0.000925596803426743],
  ],
  [
    [118.497014393983, 24.8007205688242, 0.000925524160265923],
    [118.496535069393, 24.8012951646703, 0.000925596803426743],
  ],
  [
    [118.496998656036, 24.8007096336832, 0.000925522297620773],
    [118.496519331414, 24.8012842294798, 0.000925594009459019],
  ],
  [
    [118.496982918081, 24.8006986895128, 0.000925520434975624],
    [118.496503593439, 24.8012732942877, 0.000925594940781593],
  ],
  [
    [118.496967180139, 24.8006877543684, 0.000925519503653049],
    [118.496487855455, 24.8012623500662, 0.000925592146813869],
  ],
  [
    [118.4969514422, 24.8006768192224, 0.000925518572330475],
    [118.496472117485, 24.8012514148708, 0.00092559028416872],
  ],
  [
    [118.496935704253, 24.800665875047, 0.000925516709685326],
    [118.496456389408, 24.8012404796639, 0.000925589352846146],
  ],
  [
    [118.496919976209, 24.8006549398879, 0.000925514847040176],
    [118.496440651432, 24.8012295354374, 0.000925587490200996],
  ],
  [
    [118.496904238278, 24.8006440047368, 0.000925513915717602],
    [118.496424913471, 24.8012186002369, 0.000925585627555847],
  ],
  [
    [118.49688850034, 24.8006330605563, 0.000925512984395027],
    [118.496409175511, 24.8012076650347, 0.000925585627555847],
  ],
  [
    [118.496872762414, 24.8006221254018, 0.000925512053072453],
    [118.496393437544, 24.8011967208031, 0.000925583764910698],
  ],
  [
    [118.496857024492, 24.8006111902457, 0.000925509259104729],
    [118.496377699591, 24.8011857855975, 0.000925581902265549],
  ],
  [
    [118.496841286561, 24.8006002460602, 0.000925508327782154],
    [118.496361961629, 24.8011748413626, 0.000925581902265549],
  ],
  [
    [118.496825548644, 24.8005893109006, 0.000925506465137005],
    [118.496346223681, 24.8011639061536, 0.000925580039620399],
  ],
  [
    [118.49680981073, 24.8005783757394, 0.00092550553381443],
    [118.496330485736, 24.801152970943, 0.000925577245652676],
  ],
  [
    [118.496794072808, 24.8005674315489, 0.000925504602491856],
    [118.496314747783, 24.801142026703, 0.000925577245652676],
  ],
  [
    [118.496778334899, 24.8005564963843, 0.000925500877201557],
    [118.496299019733, 24.8011310914793, 0.000925575383007526],
  ],
  [
    [118.496762606883, 24.8005455612084, 0.000925501808524132],
    [118.496283281796, 24.8011201562636, 0.000925574451684952],
  ],
  [
    [118.496746868969, 24.8005346170127, 0.000925500877201557],
    [118.496267543851, 24.8011092120186, 0.000925572589039803],
  ],
  [
    [118.496731131068, 24.8005236818431, 0.000925498083233833],
    [118.496251805919, 24.8010982767995, 0.000925571657717228],
  ],
  [
    [118.496715393171, 24.8005127466718, 0.000925495289266109],
    [118.496236067991, 24.8010873415788, 0.000925568863749504],
  ],
  [
    [118.496699655265, 24.8005018024712, 0.000925496220588684],
    [118.496220330054, 24.8010763973287, 0.000925567001104355],
  ],
  [
    [118.496683917373, 24.8004908672965, 0.000925494357943535],
    [118.496204592131, 24.8010654621046, 0.000925567001104355],
  ],
  [
    [118.496668179483, 24.8004799321201, 0.000925494357943535],
    [118.49618885421, 24.8010545268788, 0.000925565138459206],
  ],
  [
    [118.496652441586, 24.8004689879144, 0.000925491563975811],
    [118.496173116282, 24.8010435826236, 0.000925563275814056],
  ],
  [
    [118.496636703702, 24.8004580527347, 0.000925491563975811],
    [118.496157378367, 24.8010326473945, 0.000925562344491482],
  ],
  [
    [118.496620965821, 24.8004471175533, 0.000925488770008087],
    [118.496141650344, 24.801021712154, 0.000925561413168907],
  ],
  [
    [118.496605227932, 24.8004361733425, 0.000925486907362938],
    [118.496125912424, 24.8010107678938, 0.000925558619201183],
  ],
  [
    [118.496589499946, 24.800425238148, 0.000925485976040363],
    [118.496110174518, 24.8009998326596, 0.000925558619201183],
  ],
  [
    [118.496573762062, 24.8004142939339, 0.000925484113395214],
    [118.496094436614, 24.8009888974237, 0.000925557687878609],
  ],
  [
    [118.496558024192, 24.8004033587458, 0.000925483182072639],
    [118.496078698702, 24.8009779531584, 0.000925557687878609],
  ],
  [
    [118.496542286325, 24.8003924235559, 0.00092548131942749],
    [118.496062960803, 24.8009670179192, 0.000925554893910885],
  ],
  [
    [118.49652654845, 24.8003814793367, 0.000925479456782341],
    [118.496047222908, 24.8009560826782, 0.000925552099943161],
  ],
  [
    [118.496510810588, 24.8003705441436, 0.000925480388104916],
    [118.496031485004, 24.8009451384079, 0.000925552099943161],
  ],
  [
    [118.496495072728, 24.8003596089487, 0.000925478525459766],
    [118.496015747114, 24.8009342031636, 0.000925550237298012],
  ],
  [
    [118.496479334861, 24.8003486647244, 0.000925476662814617],
    [118.496000009216, 24.80092325889, 0.000925549305975437],
  ],
  [
    [118.496463597008, 24.8003377295262, 0.000925474800169468],
    [118.495984271331, 24.8009123236423, 0.000925548374652863],
  ],
  [
    [118.496447859157, 24.8003267943263, 0.000925473868846893],
    [118.495968543339, 24.8009013883833, 0.000925547443330288],
  ],
  [
    [118.496432131188, 24.8003158500873, 0.000925471074879169],
    [118.49595280545, 24.8008904441045, 0.000925546512007713],
  ],
  [
    [118.496416393343, 24.800304914884, 0.000925470143556595],
    [118.495937067573, 24.8008795088518, 0.000925543718039989],
  ],
  [
    [118.4964006555, 24.800293979679, 0.000925470143556595],
    [118.495921329699, 24.8008685735974, 0.000925542786717415],
  ],
  [
    [118.49638491765, 24.8002830354447, 0.000925468280911446],
    [118.495905591818, 24.8008576293136, 0.000925539992749691],
  ],
  [
    [118.496369179813, 24.8002721002363, 0.000925467349588871],
    [118.49588985395, 24.8008466940558, 0.000925539992749691],
  ],
  [
    [118.496353441978, 24.8002611650263, 0.000925466418266296],
    [118.495874116084, 24.8008357587964, 0.000925538130104542],
  ],
  [
    [118.496337704136, 24.8002502207869, 0.000925464555621147],
    [118.495858378211, 24.8008248145076, 0.000925537198781967],
  ],
  [
    [118.496321966307, 24.8002392855735, 0.000925463624298573],
    [118.495842640351, 24.8008138792447, 0.000925535336136818],
  ],
  [
    [118.496306228481, 24.8002283503584, 0.000925461761653423],
    [118.495826902494, 24.8008029439802, 0.000925535336136818],
  ],
  [
    [118.496290490647, 24.800217406114, 0.000925460830330849],
    [118.495811174519, 24.8007919996767, 0.000925533473491669],
  ],
  [
    [118.496274762717, 24.8002064708859, 0.000925458036363125],
    [118.495795436668, 24.8007810644088, 0.000925531610846519],
  ],
  [
    [118.496259024899, 24.8001955356657, 0.00092545710504055],
    [118.495779698819, 24.8007701291393, 0.000925528816878796],
  ],
  [
    [118.496243287073, 24.8001845914162, 0.000925456173717976],
    [118.495763960962, 24.8007591848403, 0.000925528816878796],
  ],
  [
    [118.496227549261, 24.8001736561927, 0.000925455242395401],
    [118.495748223119, 24.8007482495674, 0.000925527885556221],
  ],
  [
    [118.496211811451, 24.8001627209675, 0.000925452448427677],
    [118.495732485278, 24.8007373142928, 0.000925526954233646],
  ],
  [
    [118.496196073634, 24.800151776713, 0.000925451517105103],
    [118.49571674743, 24.8007263699888, 0.000925524160265923],
  ],
  [
    [118.49618033583, 24.8001408414844, 0.000925451517105103],
    [118.495701009595, 24.8007154347108, 0.000925522297620773],
  ],
  [
    [118.496164598018, 24.8001298972265, 0.000925448723137379],
    [118.495685271763, 24.8007044994311, 0.000925522297620773],
  ],
  [
    [118.49614886022, 24.8001189619946, 0.000925448723137379],
    [118.495669533923, 24.8006935551221, 0.000925520434975624],
  ],
  [
    [118.496133122424, 24.800108026761, 0.000925445929169655],
    [118.495653805986, 24.8006826198294, 0.000925519503653049],
  ],
  [
    [118.49611739451, 24.8000970824884, 0.00092544499784708],
    [118.495638068162, 24.8006716845447, 0.000925518572330475],
  ],
  [
    [118.49610165672, 24.8000861472514, 0.000925442203879356],
    [118.49562233033, 24.8006607402306, 0.000925514847040176],
  ],
  [
    [118.496085918932, 24.8000752120127, 0.000925441272556782],
    [118.495606592511, 24.8006498049426, 0.000925514847040176],
  ],
  [
    [118.496070181137, 24.8000642677447, 0.000925441272556782],
    [118.495590854685, 24.8006388606251, 0.000925513915717602],
  ],
  [
    [118.496054443355, 24.8000533325027, 0.000925439409911633],
    [118.495575116872, 24.8006279253336, 0.000925512053072453],
  ],
  [
    [118.496038705576, 24.800042397259, 0.000925438478589058],
    [118.495559379062, 24.8006169900405, 0.000925510190427303],
  ],
  [
    [118.496022967789, 24.8000314529859, 0.000925436615943909],
    [118.495543641244, 24.800606045718, 0.000925508327782154],
  ],
  [
    [118.496007230015, 24.8000205177388, 0.000925435684621334],
    [118.495527903439, 24.8005951104215, 0.000925507396459579],
  ],
  [
    [118.495991492244, 24.8000095824901, 0.000925431959331036],
    [118.495512165637, 24.8005841751233, 0.00092550553381443],
  ],
  [
    [118.495975754466, 24.799998638212, 0.000925431959331036],
    [118.495496437717, 24.8005732307861, 0.000925504602491856],
  ],
  [
    [118.4959600167, 24.7999877029598, 0.000925430096685886],
    [118.495480699921, 24.8005622954846, 0.000925503671169281],
  ],
  [
    [118.495944288827, 24.7999767676964, 0.000925428234040737],
    [118.495464962127, 24.8005513601813, 0.000925502739846706],
  ],
  [
    [118.495928551057, 24.7999658234132, 0.000925428234040737],
    [118.495449224326, 24.8005404158487, 0.000925499945878983],
  ],
  [
    [118.4959128133, 24.799954888156, 0.000925427302718163],
    [118.495433486537, 24.8005294805421, 0.000925499945878983],
  ],
  [
    [118.495897075545, 24.7999439528972, 0.000925424508750439],
    [118.495417748752, 24.8005185452339, 0.000925498083233833],
  ],
  [
    [118.495881337783, 24.799933008609, 0.000925423577427864],
    [118.495402010959, 24.8005076008962, 0.000925497151911259],
  ],
  [
    [118.495865600034, 24.7999220733467, 0.000925421714782715],
    [118.495386273179, 24.8004966655845, 0.000925496220588684],
  ],
  [
    [118.495849862288, 24.7999111380828, 0.00092542078346014],
    [118.495370535402, 24.8004857302712, 0.000925495289266109],
  ],
  [
    [118.495834124534, 24.7999001937895, 0.000925419852137566],
    [118.495354797617, 24.8004747859285, 0.000925492495298386],
  ],
  [
    [118.495818386794, 24.7998892585223, 0.000925418920814991],
    [118.495339059845, 24.8004638506118, 0.000925491563975811],
  ],
  [
    [118.495802649045, 24.7998783142256, 0.000925417058169842],
    [118.495323331966, 24.8004529152838, 0.000925491563975811],
  ],
  [
    [118.4957869212, 24.7998673789454, 0.000925416126847267],
    [118.495307594189, 24.800441970936, 0.000925487838685513],
  ],
  [
    [118.495771183468, 24.799856443673, 0.000925414264202118],
    [118.495291856426, 24.8004310356143, 0.000925486907362938],
  ],
  [
    [118.495755445728, 24.7998454993713, 0.000925414264202118],
    [118.495276118665, 24.8004201002908, 0.000925485976040363],
  ],
  [
    [118.495739708001, 24.7998345640956, 0.000925411470234394],
    [118.495260380897, 24.800409155938, 0.000925483182072639],
  ],
  [
    [118.495723970277, 24.7998236288183, 0.000925409607589245],
    [118.495244643142, 24.8003982206112, 0.000925483182072639],
  ],
  [
    [118.495708232545, 24.7998126845115, 0.000925409607589245],
    [118.49522890539, 24.8003872852827, 0.00092548131942749],
  ],
  [
    [118.495692494826, 24.7998017492308, 0.000925406813621521],
    [118.49521316763, 24.8003763409248, 0.000925479456782341],
  ],
  [
    [118.495676757111, 24.7997908139483, 0.000925406813621521],
    [118.495197429883, 24.800365405593, 0.000925477594137192],
  ],
  [
    [118.495661019387, 24.7997798696365, 0.000925404950976372],
    [118.495181692128, 24.8003544612318, 0.000925478525459766],
  ],
  [
    [118.495645281677, 24.7997689343507, 0.000925403088331223],
    [118.495165964277, 24.8003435258869, 0.000925476662814617],
  ],
  [
    [118.495629553859, 24.7997579990536, 0.000925402157008648],
    [118.495150226538, 24.80033259055, 0.000925472937524319],
  ],
  [
    [118.495613816144, 24.7997470547368, 0.000925401225686073],
    [118.495134488792, 24.8003216461837, 0.000925472937524319],
  ],
  [
    [118.495598078442, 24.7997361194459, 0.000925397500395775],
    [118.495118751059, 24.8003107108435, 0.000925472937524319],
  ],
  [
    [118.495582340742, 24.7997251841534, 0.000925397500395775],
    [118.495103013328, 24.8002997755015, 0.000925471074879169],
  ],
  [
    [118.495566603035, 24.7997142398315, 0.0009253965690732],
    [118.49508727559, 24.8002888311302, 0.000925470143556595],
  ],
  [
    [118.495550865342, 24.7997033045356, 0.000925395637750626],
    [118.495071537866, 24.8002778957848, 0.000925468280911446],
  ],
  [
    [118.495535127651, 24.799692369238, 0.000925393775105476],
    [118.495055800144, 24.8002669604378, 0.000925466418266296],
  ],
  [
    [118.495519389952, 24.7996814249111, 0.000925392843782902],
    [118.495040062414, 24.8002560160615, 0.000925464555621147],
  ],
  [
    [118.495503652266, 24.7996704896101, 0.000925390981137753],
    [118.495024324697, 24.8002450807111, 0.000925464555621147],
  ],
  [
    [118.495487914584, 24.7996595543075, 0.000925389118492603],
    [118.495008596874, 24.8002341453494, 0.000925461761653423],
  ],
  [
    [118.495472186783, 24.7996486099659, 0.000925388187170029],
    [118.494992859152, 24.800223200968, 0.000925460830330849],
  ],
  [
    [118.495456449106, 24.7996376746599, 0.000925389118492603],
    [118.494977121444, 24.8002122656126, 0.000925458967685699],
  ],
  [
    [118.495440711431, 24.7996267393522, 0.000925387255847454],
    [118.494961383738, 24.8002013302554, 0.000925458967685699],
  ],
  [
    [118.495424973749, 24.7996157950151, 0.00092538446187973],
    [118.494945646025, 24.800190385869, 0.000925456173717976],
  ],
  [
    [118.49540923608, 24.7996048597041, 0.000925381667912006],
    [118.494929908325, 24.8001794505085, 0.000925455242395401],
  ],
  [
    [118.495393498404, 24.7995939153637, 0.000925379805266857],
    [118.494914170628, 24.8001685151463, 0.000925453379750252],
  ],
  [
    [118.49537776074, 24.7995829800493, 0.000925377942621708],
    [118.494898432923, 24.8001575707548, 0.000925451517105103],
  ],
  [
    [118.49536202308, 24.7995720447332, 0.000925377942621708],
    [118.494882695231, 24.8001466353893, 0.000925450585782528],
  ],
  [
    [118.495346285411, 24.7995611003877, 0.000925377011299133],
    [118.494866957542, 24.800135700022, 0.000925450585782528],
  ],
  [
    [118.495330547756, 24.7995501650682, 0.000925377011299133],
    [118.494851229736, 24.8001247556159, 0.000925447791814804],
  ],
  [
    [118.495314810104, 24.7995392297471, 0.000925376079976559],
    [118.494835492052, 24.8001138202453, 0.000925447791814804],
  ],
  [
    [118.495299082333, 24.7995282853869, 0.000925373286008835],
    [118.494819754361, 24.8001028758453, 0.000925445929169655],
  ],
  [
    [118.495283344686, 24.7995173500624, 0.00092537235468626],
    [118.494804016683, 24.8000919404714, 0.000925445929169655],
  ],
  [
    [118.495267607042, 24.7995064147362, 0.000925369560718536],
    [118.494788279008, 24.8000810050958, 0.000925443135201931],
  ],
  [
    [118.49525186939, 24.7994954703806, 0.000925368629395962],
    [118.494772541325, 24.8000700606907, 0.000925441272556782],
  ],
  [
    [118.495236131752, 24.7994845350511, 0.000925368629395962],
    [118.494756803655, 24.8000591253117, 0.000925441272556782],
  ],
  [
    [118.495220394116, 24.7994735997198, 0.000925367698073387],
    [118.494741065989, 24.8000481899311, 0.000925438478589058],
  ],
  [
    [118.495204656472, 24.7994626553592, 0.000925365835428238],
    [118.494725328314, 24.800037245521, 0.000925437547266483],
  ],
  [
    [118.495188918842, 24.7994517200246, 0.000925363972783089],
    [118.494709590653, 24.800026310137, 0.000925436615943909],
  ],
  [
    [118.495173181215, 24.7994407846883, 0.000925363041460514],
    [118.494693852994, 24.8000153747512, 0.000925434753298759],
  ],
  [
    [118.495157443579, 24.7994298403226, 0.00092536024749279],
    [118.494678125218, 24.8000044303265, 0.00092543289065361],
  ],
  [
    [118.495141715847, 24.7994189049733, 0.000925358384847641],
    [118.494662387564, 24.7999934949374, 0.000925431959331036],
  ],
  [
    [118.495125978228, 24.799407969632, 0.000925356522202492],
    [118.494646649914, 24.7999825595467, 0.000925431959331036],
  ],
  [
    [118.495110240601, 24.7993970252613, 0.000925356522202492],
    [118.494630912256, 24.7999716151265, 0.000925428234040737],
  ],
  [
    [118.495094502987, 24.7993860899165, 0.000925354659557343],
    [118.494615174611, 24.7999606797324, 0.000925427302718163],
  ],
  [
    [118.495078765376, 24.7993751545701, 0.000925353728234768],
    [118.494599436969, 24.7999497443365, 0.000925426371395588],
  ],
  [
    [118.495063027757, 24.7993642101943, 0.000925351865589619],
    [118.494583699319, 24.7999387999113, 0.000925424508750439],
  ],
  [
    [118.495047290152, 24.7993532748446, 0.000925351865589619],
    [118.494567961683, 24.7999278645121, 0.000925422646105289],
  ],
  [
    [118.495031552538, 24.7993423304654, 0.000925349071621895],
    [118.494552224049, 24.7999169291112, 0.000925421714782715],
  ],
  [
    [118.495015814938, 24.7993313951123, 0.000925349071621895],
    [118.494536486408, 24.799905984681, 0.00092542078346014],
  ],
  [
    [118.495000077341, 24.7993204597575, 0.000925347208976746],
    [118.494520758669, 24.7998950492672, 0.000925418920814991],
  ],
  [
    [118.494984349626, 24.7993095153637, 0.000925346277654171],
    [118.494505021044, 24.7998841138612, 0.000925417989492416],
  ],
  [
    [118.494968612034, 24.7992985800055, 0.000925344415009022],
    [118.49448928341, 24.7998731694259, 0.000925417058169842],
  ],
  [
    [118.494952874445, 24.7992876446456, 0.000925343483686447],
    [118.49447354579, 24.7998622340166, 0.000925414264202118],
  ],
  [
    [118.494937136848, 24.7992767002564, 0.000925341621041298],
    [118.494457808173, 24.7998512986056, 0.000925414264202118],
  ],
  [
    [118.494921399265, 24.7992657648932, 0.000925341621041298],
    [118.494442070548, 24.7998403541653, 0.000925411470234394],
  ],
  [
    [118.494905661684, 24.7992548295282, 0.000925338827073574],
    [118.494426332936, 24.7998294187509, 0.000925412401556969],
  ],
  [
    [118.494889924096, 24.7992438851339, 0.000925338827073574],
    [118.494410595317, 24.7998184743072, 0.000925409607589245],
  ],
  [
    [118.494874186521, 24.7992329497656, 0.000925336964428425],
    [118.494394857711, 24.7998075388895, 0.00092540867626667],
  ],
  [
    [118.494858448948, 24.7992220143957, 0.00092533603310585],
    [118.494379120107, 24.79979660347, 0.000925407744944096],
  ],
  [
    [118.494842711368, 24.7992110699963, 0.000925334170460701],
    [118.494363392386, 24.7997856590117, 0.000925405882298946],
  ],
  [
    [118.494826983691, 24.7992001346134, 0.000925331376492977],
    [118.494347654788, 24.799774723589, 0.000925404019653797],
  ],
  [
    [118.494811246127, 24.7991891992384, 0.000925331376492977],
    [118.494331917193, 24.7997637881645, 0.000925402157008648],
  ],
  [
    [118.494795508555, 24.799178254834, 0.000925327651202679],
    [118.49431617959, 24.7997528437107, 0.000925401225686073],
  ],
  [
    [118.494779770996, 24.7991673194556, 0.000925326719880104],
    [118.494300442, 24.7997419082828, 0.000925399363040924],
  ],
  [
    [118.49476403344, 24.7991563840755, 0.000925324857234955],
    [118.494284704413, 24.7997309728533, 0.000925398431718349],
  ],
  [
    [118.494748295877, 24.7991454396661, 0.000925324857234955],
    [118.494268966819, 24.7997200283945, 0.000925397500395775],
  ],
  [
    [118.494732558326, 24.7991345042826, 0.000925322994589806],
    [118.494253229237, 24.7997090929616, 0.000925395637750626],
  ],
  [
    [118.494716820779, 24.7991235688975, 0.000925322063267231],
    [118.494237491659, 24.799698157527, 0.000925394706428051],
  ],
  [
    [118.494701083223, 24.799112624483, 0.000925320200622082],
    [118.494221754072, 24.7996872130631, 0.000925392843782902],
  ],
  [
    [118.494685345681, 24.7991016890945, 0.000925318337976933],
    [118.494206026389, 24.7996762776156, 0.000925390981137753],
  ],
  [
    [118.494669608142, 24.7990907537043, 0.000925318337976933],
    [118.494190288819, 24.799665342176, 0.000925390049815178],
  ],
  [
    [118.494653880485, 24.7990798092752, 0.000925317406654358],
    [118.494174551241, 24.7996543977071, 0.000925389118492603],
  ],
  [
    [118.494638142951, 24.7990688738817, 0.000925315544009209],
    [118.494158813676, 24.7996434622641, 0.000925389118492603],
  ],
  [
    [118.494622405409, 24.7990579294588, 0.000925313681364059],
    [118.494143076114, 24.7996325268194, 0.000925387255847454],
  ],
  [
    [118.494606667881, 24.7990469940619, 0.000925312750041485],
    [118.494127338544, 24.7996215823454, 0.000925385393202305],
  ],
  [
    [118.494590930355, 24.7990360586633, 0.000925310887396336],
    [118.494111600987, 24.7996106468974, 0.000925383530557156],
  ],
  [
    [118.494575192822, 24.7990251142353, 0.000925309024751186],
    [118.494095863433, 24.7995997114477, 0.000925381667912006],
  ],
  [
    [118.494559455302, 24.7990141788333, 0.000925309024751186],
    [118.494080125872, 24.7995887669686, 0.000925380736589432],
  ],
  [
    [118.494543717785, 24.7990032434297, 0.000925306230783463],
    [118.494064388323, 24.7995778315155, 0.000925380736589432],
  ],
  [
    [118.49452798026, 24.7989922989967, 0.000925306230783463],
    [118.494048650778, 24.7995668960607, 0.000925377942621708],
  ],
  [
    [118.494512242748, 24.7989813635897, 0.000925303436815739],
    [118.494032923114, 24.7995559515671, 0.000925377942621708],
  ],
  [
    [118.494496515129, 24.7989704281714, 0.000925302505493164],
    [118.494017185574, 24.799545016109, 0.000925375148653984],
  ],
  [
    [118.494480777612, 24.7989594837333, 0.000925301574170589],
    [118.494001448027, 24.7995340716215, 0.000925373286008835],
  ],
  [
    [118.494465040108, 24.7989485483213, 0.000925300642848015],
    [118.493985710492, 24.79952313616, 0.00092537235468626],
  ],
  [
    [118.494449302608, 24.7989376129075, 0.000925298780202866],
    [118.49396997296, 24.7995122006968, 0.000925371423363686],
  ],
  [
    [118.494433565099, 24.7989266684644, 0.000925296917557716],
    [118.493954235421, 24.7995012562043, 0.000925369560718536],
  ],
  [
    [118.494417827604, 24.7989157330473, 0.000925296917557716],
    [118.493938497895, 24.7994903207377, 0.000925369560718536],
  ],
  [
    [118.494402090111, 24.7989047976285, 0.000925294123589993],
    [118.493922760371, 24.7994793852695, 0.000925366766750813],
  ],
  [
    [118.494386352611, 24.7988938531803, 0.000925293192267418],
    [118.49390702284, 24.7994684407719, 0.000925364904105663],
  ],
  [
    [118.494370615124, 24.7988829177582, 0.000925291329622269],
    [118.493891285322, 24.7994575053003, 0.000925363972783089],
  ],
  [
    [118.49435487764, 24.7988719823343, 0.000925290398299694],
    [118.493875557697, 24.7994465698175, 0.000925362110137939],
  ],
  [
    [118.494339150038, 24.7988610378716, 0.00092528760433197],
    [118.493859820174, 24.7994356253149, 0.000925363041460514],
  ],
  [
    [118.494323412559, 24.7988501024444, 0.00092528760433197],
    [118.493844082664, 24.7994246898382, 0.000925358384847641],
  ],
  [
    [118.494307675083, 24.7988391670155, 0.000925286673009396],
    [118.493828345157, 24.7994137543599, 0.000925358384847641],
  ],
  [
    [118.4942919376, 24.7988282225572, 0.000925286673009396],
    [118.493812607642, 24.7994028098522, 0.000925358384847641],
  ],
  [
    [118.494276200129, 24.7988172871249, 0.000925282016396523],
    [118.493796870141, 24.7993918743705, 0.000925354659557343],
  ],
  [
    [118.494260462662, 24.798806351691, 0.000925281085073948],
    [118.493781132642, 24.7993809388871, 0.000925353728234768],
  ],
  [
    [118.494244725186, 24.7987954072277, 0.000925281085073948],
    [118.493765395136, 24.7993699943744, 0.000925352796912193],
  ],
  [
    [118.494228987724, 24.7987844717904, 0.000925279222428799],
    [118.493749657643, 24.7993590588876, 0.000925352796912193],
  ],
  [
    [118.494213250254, 24.7987735273237, 0.000925278291106224],
    [118.493733920152, 24.7993481233992, 0.000925350934267044],
  ],
  [
    [118.494197512798, 24.798762591883, 0.000925274565815926],
    [118.493718192544, 24.7993371788719, 0.000925349071621895],
  ],
  [
    [118.494181785233, 24.7987516564311, 0.000925273634493351],
    [118.493702455059, 24.7993262433801, 0.000925346277654171],
  ],
  [
    [118.494166047772, 24.7987407119594, 0.000925273634493351],
    [118.493686717577, 24.7993153078866, 0.000925345346331596],
  ],
  [
    [118.494150310324, 24.7987297765136, 0.000925271771848202],
    [118.493670980087, 24.7993043633638, 0.000925345346331596],
  ],
  [
    [118.494134572878, 24.7987188410662, 0.000925272703170776],
    [118.49365524261, 24.7992934278669, 0.000925343483686447],
  ],
  [
    [118.494118835425, 24.7987078965894, 0.000925269909203053],
    [118.493639505126, 24.7992824833407, 0.000925342552363873],
  ],
  [
    [118.494103097984, 24.7986969611387, 0.000925268046557903],
    [118.493623767655, 24.7992715478405, 0.000925340689718723],
  ],
  [
    [118.494087360547, 24.7986860256862, 0.000925265252590179],
    [118.493608030186, 24.7992606123386, 0.000925337895750999],
  ],
  [
    [118.494071623102, 24.7986750812044, 0.000925265252590179],
    [118.49359229271, 24.7992496678073, 0.000925337895750999],
  ],
  [
    [118.49405588567, 24.7986641457485, 0.000925264321267605],
    [118.493576555248, 24.7992387323021, 0.000925336964428425],
  ],
  [
    [118.494040148241, 24.798653210291, 0.000925262458622456],
    [118.493560827677, 24.7992277967856, 0.00092533603310585],
  ],
  [
    [118.494024410804, 24.7986422658041, 0.000925262458622456],
    [118.49354509021, 24.7992168522493, 0.000925334170460701],
  ],
  [
    [118.494008683271, 24.7986313303337, 0.000925259664654732],
    [118.493529352755, 24.799205916739, 0.000925332307815552],
  ],
  [
    [118.49399294585, 24.7986203948712, 0.000925259664654732],
    [118.493513615303, 24.799194981227, 0.000925330445170403],
  ],
  [
    [118.493977208421, 24.7986094503792, 0.000925255939364433],
    [118.493497877844, 24.7991840366856, 0.000925328582525253],
  ],
  [
    [118.493961471006, 24.7985985149133, 0.000925255008041859],
    [118.493482140397, 24.7991731011703, 0.000925329513847828],
  ],
  [
    [118.493945733593, 24.7985875794457, 0.000925255008041859],
    [118.493466402954, 24.7991621656532, 0.000925327651202679],
  ],
  [
    [118.493929996173, 24.7985766349487, 0.000925253145396709],
    [118.493450665503, 24.7991512211068, 0.000925325788557529],
  ],
  [
    [118.493914258766, 24.7985656994777, 0.00092525128275156],
    [118.493434928064, 24.7991402855864, 0.00092532392591238],
  ],
  [
    [118.493898521362, 24.798554764005, 0.000925250351428986],
    [118.493419190629, 24.7991293500643, 0.000925322063267231],
  ],
  [
    [118.49388278395, 24.798543819503, 0.000925247557461262],
    [118.493403453186, 24.7991184055128, 0.000925320200622082],
  ],
  [
    [118.493867046551, 24.798532884027, 0.000925246626138687],
    [118.493387725646, 24.7991074699779, 0.000925319269299507],
  ],
  [
    [118.493851319035, 24.7985219395121, 0.000925246626138687],
    [118.493371988219, 24.7990965344508, 0.000925318337976933],
  ],
  [
    [118.493835581641, 24.7985110040327, 0.000925244763493538],
    [118.493356250785, 24.7990855898942, 0.000925316475331783],
  ],
  [
    [118.493819844251, 24.7985000685516, 0.000925242900848389],
    [118.493340513363, 24.7990746543637, 0.000925316475331783],
  ],
  [
    [118.493804106853, 24.7984891240411, 0.000925241969525814],
    [118.493324775944, 24.7990637188315, 0.000925314612686634],
  ],
  [
    [118.493788369468, 24.7984781885567, 0.000925240106880665],
    [118.493309038518, 24.79905277427, 0.00092531181871891],
  ],
  [
    [118.493772632086, 24.7984672530705, 0.00092523917555809],
    [118.493293301105, 24.7990418387344, 0.000925310887396336],
  ],
  [
    [118.493756894696, 24.798456308555, 0.000925237312912941],
    [118.493277563694, 24.7990309031972, 0.000925310887396336],
  ],
  [
    [118.493741157319, 24.7984453730655, 0.000925236381590366],
    [118.493261826276, 24.7990199586305, 0.000925309956073761],
  ],
  [
    [118.493725419945, 24.7984344375744, 0.000925234518945217],
    [118.493246088871, 24.7990090230899, 0.000925307162106037],
  ],
  [
    [118.493709682563, 24.7984234930538, 0.000925232656300068],
    [118.493230361348, 24.7989980785105, 0.000925306230783463],
  ],
  [
    [118.493693955085, 24.7984125575498, 0.000925231724977493],
    [118.493214623949, 24.7989871429665, 0.000925305299460888],
  ],
  [
    [118.493678217719, 24.7984016220535, 0.000925229862332344],
    [118.493198886552, 24.7989762074208, 0.000925305299460888],
  ],
  [
    [118.493662480346, 24.7983906775279, 0.000925231724977493],
    [118.493183149148, 24.7989652628458, 0.000925300642848015],
  ],
  [
    [118.493646742986, 24.7983797420283, 0.000925227999687195],
    [118.493167411757, 24.7989543272968, 0.000925301574170589],
  ],
  [
    [118.493631005628, 24.798368806527, 0.000925227999687195],
    [118.493151674368, 24.7989433917461, 0.000925298780202866],
  ],
  [
    [118.493615268263, 24.7983578619964, 0.000925224274396896],
    [118.493135936972, 24.798932447166, 0.000925297848880291],
  ],
  [
    [118.493599530911, 24.7983469264917, 0.000925222411751747],
    [118.493120199589, 24.7989215116119, 0.000925295054912567],
  ],
  [
    [118.493583793562, 24.7983359909854, 0.000925222411751747],
    [118.493104462209, 24.7989105760561, 0.000925295054912567],
  ],
  [
    [118.493568056205, 24.7983250464497, 0.000925221480429173],
    [118.493088724821, 24.798899631471, 0.000925295054912567],
  ],
  [
    [118.493552318862, 24.79831411094, 0.000925220549106598],
    [118.493072997337, 24.7988886959024, 0.000925293192267418],
  ],
  [
    [118.493536591411, 24.7983031754191, 0.000925217755138874],
    [118.493057259965, 24.7988777603416, 0.000925290398299694],
  ],
  [
    [118.493520854062, 24.7982922308784, 0.000925216823816299],
    [118.493041522585, 24.7988668157514, 0.000925289466977119],
  ],
  [
    [118.493505116727, 24.7982812953636, 0.000925215892493725],
    [118.493025785219, 24.7988558801872, 0.000925288535654545],
  ],
  [
    [118.493489379394, 24.7982703598472, 0.000925214029848576],
    [118.493010047855, 24.7988449446214, 0.00092528760433197],
  ],
  [
    [118.493473642054, 24.7982594153014, 0.000925213098526001],
    [118.492994310484, 24.7988340000261, 0.000925285741686821],
  ],
  [
    [118.493457904727, 24.7982484797816, 0.000925212167203426],
    [118.492978573126, 24.7988230644569, 0.000925284810364246],
  ],
  [
    [118.493442167392, 24.7982375352324, 0.000925211235880852],
    [118.49296283577, 24.798812128886, 0.000925282947719097],
  ],
  [
    [118.493426430071, 24.7982265997093, 0.000925207510590553],
    [118.492947098408, 24.7988011842857, 0.000925281085073948],
  ],
  [
    [118.493410692752, 24.7982156641844, 0.000925206579267979],
    [118.492931361058, 24.7987902487114, 0.000925280153751373],
  ],
  [
    [118.493394955425, 24.7982047196302, 0.000925205647945404],
    [118.4929156336, 24.798779313126, 0.000925278291106224],
  ],
  [
    [118.493379218112, 24.798193784102, 0.000925204716622829],
    [118.492899896246, 24.7987683685207, 0.000925277359783649],
  ],
  [
    [118.493363490691, 24.7981828485626, 0.000925204716622829],
    [118.492884158904, 24.7987574329414, 0.0009252754971385],
  ],
  [
    [118.493347753373, 24.7981719040033, 0.000925201922655106],
    [118.492868421565, 24.7987464973604, 0.0009252754971385],
  ],
  [
    [118.493332016068, 24.7981609684701, 0.000925200060009956],
    [118.492852684219, 24.79873555275, 0.000925274565815926],
  ],
  [
    [118.493316278766, 24.7981500329351, 0.000925199128687382],
    [118.492836946886, 24.7987246171656, 0.000925271771848202],
  ],
  [
    [118.493300541456, 24.7981390883708, 0.000925198197364807],
    [118.492821209545, 24.7987136725518, 0.000925270840525627],
  ],
  [
    [118.493284804159, 24.7981281528325, 0.000925196334719658],
    [118.492805472217, 24.7987027369641, 0.000925268977880478],
  ],
  [
    [118.493269066865, 24.7981172172925, 0.000925194472074509],
    [118.492789734892, 24.7986918013747, 0.000925267115235329],
  ],
  [
    [118.493253329564, 24.7981062727231, 0.000925193540751934],
    [118.492773997559, 24.7986808567559, 0.000925267115235329],
  ],
  [
    [118.493237592275, 24.7980953371798, 0.000925191678106785],
    [118.49275826024, 24.7986699211631, 0.00092526338994503],
  ],
  [
    [118.493221854989, 24.7980844016347, 0.00092519074678421],
    [118.492742532813, 24.7986589855592, 0.00092526338994503],
  ],
  [
    [118.493206127586, 24.7980734570508, 0.000925189815461636],
    [118.492726795489, 24.7986480409353, 0.000925261527299881],
  ],
  [
    [118.493190390306, 24.7980625215024, 0.000925188884139061],
    [118.492711058177, 24.7986371053375, 0.000925260595977306],
  ],
  [
    [118.493174653028, 24.7980515859523, 0.000925188884139061],
    [118.492695320869, 24.798626169738, 0.000925259664654732],
  ],
  [
    [118.493158915743, 24.7980406413728, 0.000925185158848763],
    [118.492679583553, 24.798615225109, 0.000925257802009583],
  ],
  [
    [118.493143178471, 24.7980297058194, 0.000925183296203613],
    [118.49266384625, 24.7986042895061, 0.000925256870687008],
  ],
  [
    [118.493127441202, 24.7980187702642, 0.000925181433558464],
    [118.49264810895, 24.7985933539016, 0.000925255008041859],
  ],
  [
    [118.493111703925, 24.7980078256797, 0.000925180502235889],
    [118.492632371642, 24.7985824092676, 0.000925253145396709],
  ],
  [
    [118.493095966661, 24.7979968901212, 0.000925179570913315],
    [118.492616634347, 24.7985714736597, 0.000925253145396709],
  ],
  [
    [118.493080229401, 24.797985954561, 0.00092517863959074],
    [118.492600897055, 24.7985605380501, 0.000925249420106411],
  ],
  [
    [118.493064492132, 24.7979750099714, 0.000925176776945591],
    [118.492585169645, 24.7985495934016, 0.000925248488783836],
  ],
  [
    [118.493048764766, 24.7979640743984, 0.000925174914300442],
    [118.492569432359, 24.7985386577886, 0.000925248488783836],
  ],
  [
    [118.493033027503, 24.7979531298055, 0.000925173982977867],
    [118.492553695075, 24.798527722174, 0.000925247557461262],
  ],
  [
    [118.493017290253, 24.7979421942386, 0.000925172120332718],
    [118.492537957784, 24.7985167775299, 0.000925246626138687],
  ],
  [
    [118.493001553006, 24.7979312586699, 0.000925172120332718],
    [118.492522220506, 24.7985058419119, 0.000925243832170963],
  ],
  [
    [118.492985815752, 24.7979203140719, 0.000925172120332718],
    [118.492506483231, 24.7984949062921, 0.000925242900848389],
  ],
  [
    [118.49297007851, 24.7979093785, 0.000925169326364994],
    [118.492490745948, 24.798483961643, 0.000925240106880665],
  ],
  [
    [118.492954341271, 24.7978984429263, 0.000925169326364994],
    [118.492475008678, 24.79847302602, 0.000925238244235516],
  ],
  [
    [118.492938604025, 24.7978874983233, 0.000925165601074696],
    [118.4924592714, 24.7984620813675, 0.000925238244235516],
  ],
  [
    [118.492922866791, 24.7978765627463, 0.000925165601074696],
    [118.492443534136, 24.798451145741, 0.000925236381590366],
  ],
  [
    [118.492907129561, 24.7978656271675, 0.000925162807106972],
    [118.492427806764, 24.7984402101035, 0.000925236381590366],
  ],
  [
    [118.492891402212, 24.79785468255, 0.000925162807106972],
    [118.492412069495, 24.7984292654459, 0.000925234518945217],
  ],
  [
    [118.492875664987, 24.7978437469679, 0.000925160013139248],
    [118.492396332239, 24.7984183298144, 0.000925231724977493],
  ],
  [
    [118.492859927765, 24.7978328113842, 0.000925157219171524],
    [118.492380594985, 24.7984073941812, 0.000925230793654919],
  ],
  [
    [118.492844190535, 24.797821866771, 0.000925157219171524],
    [118.492364857725, 24.7983964495187, 0.000925229862332344],
  ],
  [
    [118.492828453318, 24.7978109311839, 0.000925157219171524],
    [118.492349120477, 24.7983855138821, 0.000925227999687195],
  ],
  [
    [118.492812716104, 24.7977999955951, 0.000925155356526375],
    [118.492333383232, 24.7983745782439, 0.000925227999687195],
  ],
  [
    [118.492796978882, 24.7977890509769, 0.000925153493881226],
    [118.492317645979, 24.7983636335763, 0.000925224274396896],
  ],
  [
    [118.492781241674, 24.7977781153847, 0.000925150699913502],
    [118.492301908739, 24.7983526979347, 0.000925224274396896],
  ],
  [
    [118.492765504468, 24.7977671797909, 0.000925149768590927],
    [118.492286171503, 24.7983417622914, 0.000925222411751747],
  ],
  [
    [118.492749767255, 24.7977562351676, 0.000925150699913502],
    [118.492270444148, 24.7983308176093, 0.000925223343074322],
  ],
  [
    [118.492734030054, 24.7977452995704, 0.000925148837268353],
    [118.492254706917, 24.7983198819626, 0.000925220549106598],
  ],
  [
    [118.492718302747, 24.7977343639621, 0.000925147905945778],
    [118.492238969688, 24.7983089463143, 0.000925218686461449],
  ],
  [
    [118.492702565542, 24.7977234193338, 0.000925145111978054],
    [118.492223232452, 24.7982980016366, 0.000925215892493725],
  ],
  [
    [118.49268682835, 24.7977124837315, 0.000925143249332905],
    [118.492207495229, 24.7982870659849, 0.000925215892493725],
  ],
  [
    [118.49267109115, 24.7977015390999, 0.00092514231801033],
    [118.492191758009, 24.7982761303315, 0.000925214029848576],
  ],
  [
    [118.492655353963, 24.7976906034942, 0.000925139524042606],
    [118.492176020781, 24.7982651856487, 0.000925213098526001],
  ],
  [
    [118.49263961678, 24.7976796678869, 0.000925140455365181],
    [118.492160283566, 24.798254249992, 0.000925212167203426],
  ],
  [
    [118.492623879588, 24.7976687232502, 0.000925137661397457],
    [118.492144546354, 24.7982433143335, 0.000925211235880852],
  ],
  [
    [118.49260814241, 24.7976577876395, 0.000925137661397457],
    [118.492128809135, 24.7982323696457, 0.000925209373235703],
  ],
  [
    [118.492592405235, 24.7976468520271, 0.000925135798752308],
    [118.492113071928, 24.7982214339839, 0.000925209373235703],
  ],
  [
    [118.492576668052, 24.7976359073854, 0.000925132073462009],
    [118.492097344614, 24.798210498311, 0.000925205647945404],
  ],
  [
    [118.492560940771, 24.7976249717602, 0.000925132073462009],
    [118.492081607403, 24.7981995536182, 0.000925204716622829],
  ],
  [
    [118.492545203604, 24.7976140361428, 0.000925131142139435],
    [118.492065870205, 24.7981886179513, 0.000925204716622829],
  ],
  [
    [118.49252946643, 24.797603091496, 0.00092513021081686],
    [118.492050132999, 24.7981776732551, 0.00092520285397768],
  ],
  [
    [118.492513729268, 24.7975921558752, 0.000925129279494286],
    [118.492034395806, 24.7981667375849, 0.000925200060009956],
  ],
  [
    [118.492497992109, 24.7975812202527, 0.000925129279494286],
    [118.492018658617, 24.798155801913, 0.000925199128687382],
  ],
  [
    [118.492482254942, 24.7975702756009, 0.000925125554203987],
    [118.492002921419, 24.7981448572117, 0.000925197266042233],
  ],
  [
    [118.492466517789, 24.797559339975, 0.000925123691558838],
    [118.491987184235, 24.7981339215364, 0.000925198197364807],
  ],
  [
    [118.492450780638, 24.7975484043475, 0.000925123691558838],
    [118.491971447053, 24.7981229858595, 0.000925194472074509],
  ],
  [
    [118.49243504348, 24.7975374596906, 0.000925120897591114],
    [118.491955709864, 24.7981120411531, 0.000925195403397083],
  ],
  [
    [118.492419306335, 24.7975265240597, 0.000925119966268539],
    [118.491939982577, 24.7981011054634, 0.000925193540751934],
  ],
  [
    [118.492403579082, 24.7975155884177, 0.00092511810362339],
    [118.491924245404, 24.7980901697814, 0.000925192609429359],
  ],
  [
    [118.492387841932, 24.7975046437558, 0.000925119034945965],
    [118.491908508223, 24.79807922507, 0.000925189815461636],
  ],
  [
    [118.492372104796, 24.7974937081198, 0.000925117172300816],
    [118.491892771055, 24.7980682893847, 0.00092519074678421],
  ],
  [
    [118.492356367661, 24.7974827724822, 0.000925116240978241],
    [118.49187703389, 24.7980573536976, 0.000925187021493912],
  ],
  [
    [118.49234063052, 24.7974718278152, 0.000925112515687943],
    [118.491861296717, 24.7980464089812, 0.000925187021493912],
  ],
  [
    [118.492324893391, 24.7974608921742, 0.000925111584365368],
    [118.491845559558, 24.7980354732908, 0.000925184227526188],
  ],
  [
    [118.492309156265, 24.7974499565316, 0.000925110653042793],
    [118.491829822401, 24.7980245375987, 0.000925183296203613],
  ],
  [
    [118.492293419132, 24.7974390118595, 0.000925108790397644],
    [118.491814085237, 24.7980135928772, 0.000925180502235889],
  ],
  [
    [118.492277682012, 24.7974280762135, 0.000925107859075069],
    [118.491798348085, 24.7980026571817, 0.000925180502235889],
  ],
  [
    [118.492261944884, 24.7974171315381, 0.000925106927752495],
    [118.491782620826, 24.7979917214752, 0.00092517863959074],
  ],
  [
    [118.492246217659, 24.7974061958793, 0.000925105065107346],
    [118.49176688367, 24.7979807767487, 0.000925177708268166],
  ],
  [
    [118.492230480547, 24.7973952602282, 0.000925104133784771],
    [118.491751146527, 24.7979698410482, 0.000925176776945591],
  ],
  [
    [118.492214743427, 24.7973843155477, 0.000925103202462196],
    [118.491735409387, 24.797958905346, 0.000925174914300442],
  ],
  [
    [118.49219900632, 24.7973733798933, 0.000925100408494473],
    [118.491719672239, 24.7979479606144, 0.000925175845623016],
  ],
  [
    [118.492183269217, 24.7973624442371, 0.000925099477171898],
    [118.491703935104, 24.7979370249088, 0.000925171189010143],
  ],
  [
    [118.492167532105, 24.7973514995516, 0.000925096683204174],
    [118.491688197962, 24.7979260801739, 0.000925171189010143],
  ],
  [
    [118.492151795007, 24.7973405638921, 0.000925096683204174],
    [118.491672460833, 24.797915144465, 0.000925169326364994],
  ],
  [
    [118.492136057912, 24.7973296282309, 0.000925094820559025],
    [118.491656723706, 24.7979042087543, 0.000925167463719845],
  ],
  [
    [118.492120320808, 24.7973186835404, 0.00092509388923645],
    [118.491640986572, 24.7978932640143, 0.00092516653239727],
  ],
  [
    [118.492104583718, 24.7973077478758, 0.000925092026591301],
    [118.491625259341, 24.797882328291, 0.000925164669752121],
  ],
  [
    [118.492088846631, 24.7972968122096, 0.000925091095268726],
    [118.491609522223, 24.7978713925753, 0.000925162807106972],
  ],
  [
    [118.492073119426, 24.7972858675046, 0.000925090163946152],
    [118.491593785097, 24.7978604478303, 0.000925163738429546],
  ],
  [
    [118.492057382344, 24.797274931835, 0.000925089232623577],
    [118.491578047984, 24.7978495121113, 0.000925161875784397],
  ],
  [
    [118.492041645265, 24.7972639961637, 0.000925087369978428],
    [118.491562310874, 24.7978385763905, 0.000925160013139248],
  ],
  [
    [118.492025908179, 24.797253051463, 0.000925086438655853],
    [118.491546573757, 24.7978276316405, 0.000925157219171524],
  ],
  [
    [118.492010171105, 24.7972421157884, 0.000925084576010704],
    [118.491530836652, 24.7978166959164, 0.0009251544252038],
  ],
  [
    [118.491994434035, 24.797231180112, 0.000925085507333279],
    [118.49151509955, 24.7978057601906, 0.000925155356526375],
  ],
  [
    [118.491978696957, 24.7972202354063, 0.000925080850720406],
    [118.491499362441, 24.7977948154355, 0.000925156287848949],
  ],
  [
    [118.491962959891, 24.7972092997266, 0.000925080850720406],
    [118.491483625345, 24.7977838797063, 0.000925153493881226],
  ],
  [
    [118.491947222829, 24.7971983640452, 0.000925078988075256],
    [118.491467888251, 24.7977729439755, 0.000925151631236076],
  ],
  [
    [118.491931485759, 24.7971874193345, 0.000925077125430107],
    [118.49145216104, 24.797761999206, 0.000925150699913502],
  ],
  [
    [118.491915758592, 24.7971764836404, 0.000925076194107533],
    [118.491436423952, 24.7977510634718, 0.000925147905945778],
  ],
  [
    [118.491900021538, 24.7971655479539, 0.000925073400139809],
    [118.491420686867, 24.7977401277359, 0.000925146974623203],
  ],
  [
    [118.491884284476, 24.7971546032381, 0.000925074331462383],
    [118.491404949774, 24.7977291829707, 0.000925146043300629],
  ],
  [
    [118.491868547427, 24.7971436675483, 0.000925072468817234],
    [118.491389212695, 24.7977182472315, 0.000925144180655479],
  ],
  [
    [118.491852810371, 24.7971327228291, 0.000925070606172085],
    [118.491373475618, 24.7977073114906, 0.000925143249332905],
  ],
  [
    [118.491837073328, 24.797121787136, 0.00092506967484951],
    [118.491357738533, 24.7976963667203, 0.00092514231801033],
  ],
  [
    [118.491821336287, 24.7971108514411, 0.000925066880881786],
    [118.491342001462, 24.797685430976, 0.000925143249332905],
  ],
  [
    [118.49180559924, 24.7970999067169, 0.000925065949559212],
    [118.491326264393, 24.7976744952301, 0.000925139524042606],
  ],
  [
    [118.491789862205, 24.7970889710187, 0.000925065949559212],
    [118.491310527317, 24.7976635504547, 0.000925137661397457],
  ],
  [
    [118.491774125173, 24.7970780353188, 0.000925065018236637],
    [118.491294800144, 24.7976526146961, 0.000925135798752308],
  ],
  [
    [118.491758398023, 24.7970670905802, 0.000925062224268913],
    [118.491279063073, 24.7976416699173, 0.000925134867429733],
  ],
  [
    [118.491742660996, 24.7970561548769, 0.000925060361623764],
    [118.491263326016, 24.7976307341647, 0.000925132073462009],
  ],
  [
    [118.491726923972, 24.797045219172, 0.000925060361623764],
    [118.491247588961, 24.7976197984103, 0.000925132073462009],
  ],
  [
    [118.491711186941, 24.7970342744376, 0.00092505756765604],
    [118.491231851898, 24.7976088536265, 0.000925131142139435],
  ],
  [
    [118.491695449923, 24.7970233387293, 0.00092505756765604],
    [118.491216114849, 24.7975979178688, 0.00092513021081686],
  ],
  [
    [118.491679712907, 24.7970124030193, 0.000925056636333466],
    [118.491200377803, 24.7975869821094, 0.000925128348171711],
  ],
  [
    [118.491663975884, 24.79700145828, 0.000925053842365742],
    [118.491184640749, 24.7975760373206, 0.000925126485526562],
  ],
  [
    [118.491648238874, 24.7969905225666, 0.000925052911043167],
    [118.491168903707, 24.7975651015578, 0.000925126485526562],
  ],
  [
    [118.491632501866, 24.7969795868516, 0.000925051048398018],
    [118.491153166669, 24.7975541657933, 0.000925123691558838],
  ],
  [
    [118.491616764852, 24.7969686421071, 0.000925049185752869],
    [118.491137439513, 24.7975432209901, 0.000925122760236263],
  ],
  [
    [118.49160103774, 24.7969577063794, 0.000925048254430294],
    [118.49112170248, 24.7975322852223, 0.000925120897591114],
  ],
  [
    [118.491585300741, 24.7969467706593, 0.000925046391785145],
    [118.49110596545, 24.7975213494528, 0.000925119966268539],
  ],
  [
    [118.491569563734, 24.7969358259098, 0.00092504546046257],
    [118.491090228413, 24.7975104046539, 0.00092511810362339],
  ],
  [
    [118.49155382674, 24.7969248901863, 0.00092504546046257],
    [118.491074491388, 24.797499468881, 0.00092511810362339],
  ],
  [
    [118.49153808975, 24.7969139544612, 0.000925041735172272],
    [118.491058754366, 24.7974885331064, 0.000925115309655666],
  ],
  [
    [118.491522352751, 24.7969030097067, 0.000925042666494846],
    [118.491043017337, 24.7974775883025, 0.000925112515687943],
  ],
  [
    [118.491506615766, 24.7968920739782, 0.000925039872527123],
    [118.491027280321, 24.7974666525245, 0.000925113447010517],
  ],
  [
    [118.491490878773, 24.7968811292203, 0.000925038941204548],
    [118.491011543307, 24.7974557167449, 0.000925110653042793],
  ],
  [
    [118.491475141794, 24.7968701934884, 0.000925037078559399],
    [118.490995806286, 24.7974447719359, 0.000925109721720219],
  ],
  [
    [118.491459404817, 24.7968592577549, 0.000925036147236824],
    [118.490980079168, 24.7974338361436, 0.000925109721720219],
  ],
  [
    [118.491443667832, 24.7968483129919, 0.000925035215914249],
    [118.490964342163, 24.7974229003589, 0.000925107859075069],
  ],
  [
    [118.49142794075, 24.7968373772457, 0.0009250333532691],
    [118.49094860515, 24.7974119555449, 0.000925105065107346],
  ],
  [
    [118.491412203782, 24.7968264415071, 0.000925031490623951],
    [118.49093286815, 24.7974010197569, 0.000925104133784771],
  ],
  [
    [118.491396466806, 24.7968154967391, 0.000925030559301376],
    [118.490917131153, 24.7973900839671, 0.000925103202462196],
  ],
  [
    [118.491380729842, 24.7968045609971, 0.000925027765333653],
    [118.490901394149, 24.797379139148, 0.000925102271139622],
  ],
  [
    [118.491364992882, 24.7967936252535, 0.000925026834011078],
    [118.490885657158, 24.7973682033549, 0.000925100408494473],
  ],
  [
    [118.491349255914, 24.7967826804804, 0.000925026834011078],
    [118.490869920159, 24.7973572585325, 0.000925099477171898],
  ],
  [
    [118.491333518959, 24.7967717447334, 0.000925025902688503],
    [118.490854183173, 24.797346322736, 0.000925096683204174],
  ],
  [
    [118.491317782007, 24.7967608089847, 0.000925024040043354],
    [118.49083844619, 24.7973353869379, 0.000925096683204174],
  ],
  [
    [118.491302045047, 24.7967498642066, 0.000925022177398205],
    [118.490822709199, 24.7973244421104, 0.000925094820559025],
  ],
  [
    [118.491286308101, 24.7967389284545, 0.000925022177398205],
    [118.490806982111, 24.7973135062996, 0.00092509388923645],
  ],
  [
    [118.491270581046, 24.7967279926915, 0.000925017520785332],
    [118.490791245136, 24.7973025704964, 0.000925092957913876],
  ],
  [
    [118.491254844095, 24.7967170479083, 0.000925017520785332],
    [118.490775508154, 24.7972916256639, 0.000925091095268726],
  ],
  [
    [118.491239107157, 24.7967061121512, 0.000925016589462757],
    [118.490759771184, 24.7972806898573, 0.000925088301301003],
  ],
  [
    [118.491223370221, 24.7966951763924, 0.000925014726817608],
    [118.490744034218, 24.7972697540491, 0.000925087369978428],
  ],
  [
    [118.491207633278, 24.7966842316042, 0.000925014726817608],
    [118.490728297244, 24.7972588092115, 0.000925088301301003],
  ],
  [
    [118.491191896348, 24.7966732958421, 0.000925011932849884],
    [118.490712560282, 24.7972478733999, 0.000925084576010704],
  ],
  [
    [118.49117615942, 24.7966623600782, 0.000925011932849884],
    [118.490696823324, 24.7972369375866, 0.000925084576010704],
  ],
  [
    [118.491160422486, 24.796651415285, 0.00092500913888216],
    [118.490681086358, 24.7972259927439, 0.000925082713365555],
  ],
  [
    [118.491144685564, 24.7966404795178, 0.000925007276237011],
    [118.490665349405, 24.7972150569273, 0.000925080850720406],
  ],
  [
    [118.491128948645, 24.7966295437489, 0.000925007276237011],
    [118.490649622345, 24.7972041210997, 0.000925079919397831],
  ],
  [
    [118.491113221608, 24.7966185989413, 0.000925005413591862],
    [118.490633885387, 24.797193176252, 0.000925078988075256],
  ],
  [
    [118.491097484694, 24.796607663169, 0.000925004482269287],
    [118.490618148443, 24.7971822404303, 0.000925077125430107],
  ],
  [
    [118.491081747773, 24.7965967183674, 0.000925003550946712],
    [118.490602411501, 24.7971713046069, 0.000925075262784958],
  ],
  [
    [118.491066010865, 24.7965857825917, 0.000925002619624138],
    [118.490586674552, 24.7971603597541, 0.000925074331462383],
  ],
  [
    [118.49105027396, 24.7965748468144, 0.000925000756978989],
    [118.490570937615, 24.7971494239274, 0.000925072468817234],
  ],
  [
    [118.491034537047, 24.7965639020077, 0.000924998894333839],
    [118.490555200682, 24.797138488099, 0.000925071537494659],
  ],
  [
    [118.491018800147, 24.7965529662271, 0.000924997963011265],
    [118.490539463741, 24.7971275432412, 0.000925068743526936],
  ],
  [
    [118.49100306325, 24.7965420304447, 0.000924995169043541],
    [118.490523726813, 24.7971166074094, 0.00092506967484951],
  ],
  [
    [118.490987326346, 24.796531085633, 0.000924994237720966],
    [118.490507989877, 24.7971056625482, 0.000925067812204361],
  ],
  [
    [118.490971589454, 24.7965201498472, 0.000924994237720966],
    [118.490492262845, 24.7970947267038, 0.000925065018236637],
  ],
  [
    [118.490955862455, 24.7965092140505, 0.000924992375075817],
    [118.490476525925, 24.7970837908669, 0.000925065018236637],
  ],
  [
    [118.490940125559, 24.7964982692337, 0.000924990512430668],
    [118.490460788998, 24.7970728460007, 0.000925063155591488],
  ],
  [
    [118.490924388675, 24.7964873334429, 0.000924988649785519],
    [118.490445052083, 24.7970619101605, 0.000925063155591488],
  ],
  [
    [118.490908651795, 24.7964763976505, 0.000924987718462944],
    [118.490429315172, 24.7970509743186, 0.000925061292946339],
  ],
  [
    [118.490892914907, 24.7964654528286, 0.000924986787140369],
    [118.490413578253, 24.7970400294474, 0.000925058498978615],
  ],
  [
    [118.490877178032, 24.7964545170328, 0.00092498492449522],
    [118.490397841347, 24.7970290936021, 0.000925058498978615],
  ],
  [
    [118.49086144116, 24.7964435812353, 0.000924983061850071],
    [118.490382104444, 24.7970181577552, 0.000925056636333466],
  ],
  [
    [118.49084570428, 24.7964326364084, 0.000924983993172646],
    [118.490366367533, 24.7970072128788, 0.000925054773688316],
  ],
  [
    [118.490829967413, 24.7964217006076, 0.000924980267882347],
    [118.490350630635, 24.7969962770285, 0.000925052911043167],
  ],
  [
    [118.490814230549, 24.796410764805, 0.000924980267882347],
    [118.49033490363, 24.7969853411673, 0.000925051048398018],
  ],
  [
    [118.490798493678, 24.7963998199731, 0.000924978405237198],
    [118.490319166728, 24.7969743962859, 0.000925051048398018],
  ],
  [
    [118.490782766709, 24.7963888841578, 0.000924977473914623],
    [118.490303429838, 24.7969634604306, 0.000925048254430294],
  ],
  [
    [118.490767029853, 24.7963779483502, 0.000924975611269474],
    [118.490287692951, 24.7969525245735, 0.000925046391785145],
  ],
  [
    [118.49075129299, 24.7963670035133, 0.000924974679946899],
    [118.490271956057, 24.7969415796871, 0.000925046391785145],
  ],
  [
    [118.49073555614, 24.7963560677023, 0.000924973748624325],
    [118.490256219176, 24.7969306438267, 0.00092504546046257],
  ],
  [
    [118.490719819293, 24.7963451318896, 0.000924970954656601],
    [118.490240482298, 24.7969197079646, 0.000925044529139996],
  ],
  [
    [118.490704082438, 24.7963341870476, 0.000924970023334026],
    [118.490224745412, 24.7969087630732, 0.000925042666494846],
  ],
  [
    [118.490688345596, 24.7963232512316, 0.000924968160688877],
    [118.490209008539, 24.7968978272077, 0.000925042666494846],
  ],
  [
    [118.490672608747, 24.7963123063862, 0.000924966298043728],
    [118.490193271669, 24.7968868913406, 0.000925039872527123],
  ],
  [
    [118.49065687191, 24.7963013705668, 0.000924965366721153],
    [118.490177534791, 24.7968759464441, 0.000925038941204548],
  ],
  [
    [118.490641135077, 24.7962904347457, 0.000924964435398579],
    [118.490161807816, 24.7968650105643, 0.000925036147236824],
  ],
  [
    [118.490625408125, 24.796279489886, 0.000924963504076004],
    [118.490146070954, 24.7968540746921, 0.000925034284591675],
  ],
  [
    [118.490609671297, 24.7962685540615, 0.000924961641430855],
    [118.490130334085, 24.7968431297906, 0.000925035215914249],
  ],
  [
    [118.490593934472, 24.7962576182354, 0.000924959778785706],
    [118.490114597229, 24.796832193915, 0.0009250333532691],
  ],
  [
    [118.490578197639, 24.7962466733799, 0.000924958847463131],
    [118.490098860365, 24.7968212490101, 0.000925031490623951],
  ],
  [
    [118.490562460819, 24.7962357375505, 0.000924957916140556],
    [118.490083123514, 24.7968103131312, 0.000925030559301376],
  ],
  [
    [118.490546724002, 24.7962248017193, 0.000924955122172832],
    [118.490067386666, 24.7967993772506, 0.000925029627978802],
  ],
  [
    [118.490530987177, 24.7962138568587, 0.000924956053495407],
    [118.490051649811, 24.7967884323406, 0.000925028696656227],
  ],
  [
    [118.490515250366, 24.7962029210242, 0.000924954190850258],
    [118.490035912968, 24.7967774964567, 0.000925024040043354],
  ],
  [
    [118.490499513557, 24.796191985188, 0.000924951396882534],
    [118.490020176128, 24.796766560571, 0.000925024971365929],
  ],
  [
    [118.490483776741, 24.7961810403224, 0.000924951396882534],
    [118.490004449171, 24.7967556156468, 0.000925022177398205],
  ],
  [
    [118.490468049827, 24.7961701044736, 0.000924949534237385],
    [118.489988712336, 24.7967446797578, 0.000925022177398205],
  ],
  [
    [118.490452313026, 24.7961591686323, 0.000924949534237385],
    [118.489972975505, 24.7967337438671, 0.00092502124607563],
  ],
  [
    [118.490436576218, 24.7961482237616, 0.000924946740269661],
    [118.489957238666, 24.796722798947, 0.000925018452107906],
  ],
  [
    [118.490420839423, 24.796137287917, 0.000924944877624512],
    [118.48994150184, 24.7967118630529, 0.000925016589462757],
  ],
  [
    [118.490405102631, 24.7961263520707, 0.000924943946301937],
    [118.489925765016, 24.7967009271572, 0.000925015658140183],
  ],
  [
    [118.490389365831, 24.796115407195, 0.000924943014979362],
    [118.489910028186, 24.7966899822321, 0.000925013795495033],
  ],
  [
    [118.490373629045, 24.7961044713453, 0.000924941152334213],
    [118.489894291368, 24.796679046333, 0.000925012864172459],
  ],
  [
    [118.490357892261, 24.796093535494, 0.000924939289689064],
    [118.489878554553, 24.7966681104322, 0.000925011001527309],
  ],
  [
    [118.490342155469, 24.7960825906132, 0.000924939289689064],
    [118.48986281773, 24.796657165502, 0.000925011001527309],
  ],
  [
    [118.490326418691, 24.7960716547585, 0.00092493649572134],
    [118.489847090811, 24.7966462295886, 0.00092500913888216],
  ],
  [
    [118.490310691794, 24.7960607098651, 0.000924935564398766],
    [118.489831354004, 24.7966352936828, 0.000925008207559586],
  ],
  [
    [118.490294955021, 24.7960497740071, 0.000924933701753616],
    [118.48981561719, 24.7966243487476, 0.000925006344914436],
  ],
  [
    [118.490279218251, 24.7960388381473, 0.000924931839108467],
    [118.489799880388, 24.7966134128384, 0.000925004482269287],
  ],
  [
    [118.490263481474, 24.7960278932581, 0.000924930907785892],
    [118.48978414359, 24.7966024769275, 0.000925004482269287],
  ],
  [
    [118.490247744709, 24.796016957395, 0.000924929976463318],
    [118.489768406784, 24.7965915319872, 0.000925001688301563],
  ],
  [
    [118.490232007947, 24.7960060215302, 0.000924928113818169],
    [118.489752669991, 24.796580596073, 0.000925001688301563],
  ],
  [
    [118.490216271177, 24.795995076636, 0.000924928113818169],
    [118.489736933201, 24.796569660157, 0.000924998894333839],
  ],
  [
    [118.490200534421, 24.7959841407678, 0.000924925319850445],
    [118.489721196403, 24.7965587152117, 0.000924998894333839],
  ],
  [
    [118.490184797667, 24.7959732048979, 0.00092492438852787],
    [118.489705459619, 24.7965477792924, 0.000924997963011265],
  ],
  [
    [118.490169060906, 24.7959622599987, 0.000924923457205296],
    [118.489689732716, 24.7965368343345, 0.000924996100366116],
  ],
  [
    [118.490153324158, 24.7959513241254, 0.000924922525882721],
    [118.489673995937, 24.7965258984119, 0.000924993306398392],
  ],
  [
    [118.490137597302, 24.7959403882413, 0.000924919731914997],
    [118.489658259161, 24.7965149624875, 0.000924991443753242],
  ],
  [
    [118.490121860549, 24.795929443337, 0.000924919731914997],
    [118.489642522377, 24.7965040175338, 0.000924992375075817],
  ],
  [
    [118.490106123809, 24.7959185074587, 0.000924917869269848],
    [118.489626785606, 24.7964930816061, 0.000924990512430668],
  ],
  [
    [118.490090387072, 24.7959075715787, 0.000924916006624699],
    [118.489611048838, 24.7964821456767, 0.000924988649785519],
  ],
  [
    [118.490074650328, 24.7958966266694, 0.000924915075302124],
    [118.489595312062, 24.7964712007179, 0.000924986787140369],
  ],
  [
    [118.490058913596, 24.795885690786, 0.000924914143979549],
    [118.4895795753, 24.7964602647851, 0.000924985855817795],
  ],
  [
    [118.490043176867, 24.795874754901, 0.000924911350011826],
    [118.48956383854, 24.7964493288507, 0.000924983993172646],
  ],
  [
    [118.490027440131, 24.7958638099866, 0.000924910418689251],
    [118.489548101772, 24.7964383838869, 0.000924983993172646],
  ],
  [
    [118.490011703408, 24.7958528740982, 0.000924908556044102],
    [118.489532365018, 24.7964274479491, 0.000924981199204922],
  ],
  [
    [118.489995966687, 24.7958419382082, 0.000924908556044102],
    [118.489516638156, 24.7964165120004, 0.000924980267882347],
  ],
  [
    [118.489980239849, 24.7958309932795, 0.000924907624721527],
    [118.489500901397, 24.7964055670315, 0.000924979336559772],
  ],
  [
    [118.489964503133, 24.7958200573861, 0.000924904830753803],
    [118.489485164651, 24.7963946310886, 0.000924977473914623],
  ],
  [
    [118.489948766421, 24.795809121491, 0.000924905762076378],
    [118.489469427908, 24.7963836951441, 0.000924976542592049],
  ],
  [
    [118.489933029701, 24.7957981765665, 0.000924902968108654],
    [118.489453691157, 24.7963727501702, 0.000924974679946899],
  ],
  [
    [118.489917292994, 24.795787240668, 0.000924899242818356],
    [118.489437954419, 24.7963618142223, 0.000924973748624325],
  ],
  [
    [118.48990155628, 24.7957762957401, 0.000924898311495781],
    [118.489422217684, 24.7963508782727, 0.000924970954656601],
  ],
  [
    [118.489885819579, 24.7957653598383, 0.000924899242818356],
    [118.489406480942, 24.7963399332937, 0.000924970954656601],
  ],
  [
    [118.48987008288, 24.7957544239348, 0.000924896448850632],
    [118.489390744212, 24.7963289973408, 0.000924970023334026],
  ],
  [
    [118.489854346174, 24.7957434790019, 0.000924895517528057],
    [118.489375007485, 24.7963180613861, 0.000924968160688877],
  ],
  [
    [118.489838609481, 24.795732543095, 0.000924893654882908],
    [118.489359280641, 24.7963071163929, 0.000924967229366302],
  ],
  [
    [118.489822882681, 24.7957216071772, 0.000924891792237759],
    [118.489343543919, 24.7962961804349, 0.000924965366721153],
  ],
  [
    [118.489807145983, 24.7957106622392, 0.000924890860915184],
    [118.489327807191, 24.7962852354475, 0.000924964435398579],
  ],
  [
    [118.489791409298, 24.7956997263273, 0.000924889929592609],
    [118.489312070475, 24.7962742994861, 0.000924962572753429],
  ],
  [
    [118.489775672616, 24.7956887904136, 0.000924889929592609],
    [118.489296333762, 24.7962633635231, 0.000924961641430855],
  ],
  [
    [118.489759935927, 24.7956778454706, 0.000924887135624886],
    [118.489280597042, 24.7962524185307, 0.000924959778785706],
  ],
  [
    [118.48974419925, 24.7956669095537, 0.000924884341657162],
    [118.489264860334, 24.7962414825642, 0.000924956984817982],
  ],
  [
    [118.489728462577, 24.795655973635, 0.000924884341657162],
    [118.489249123629, 24.7962305465962, 0.000924956053495407],
  ],
  [
    [118.489712725895, 24.7956450286869, 0.000924882479012012],
    [118.489233386917, 24.7962196015987, 0.000924956053495407],
  ],
  [
    [118.489696989227, 24.7956340927649, 0.000924880616366863],
    [118.489217650218, 24.7962086656272, 0.000924953259527683],
  ],
  [
    [118.489681252562, 24.7956231568412, 0.000924882479012012],
    [118.489201923411, 24.7961977296449, 0.000924953259527683],
  ],
  [
    [118.489665525778, 24.7956122118789, 0.000924877822399139],
    [118.489186186707, 24.7961867846423, 0.000924952328205109],
  ],
  [
    [118.489649789118, 24.7956012759518, 0.000924876891076565],
    [118.489170450016, 24.7961758486658, 0.000924950465559959],
  ],
  [
    [118.489634052461, 24.795590340023, 0.000924875028431416],
    [118.489154713328, 24.7961649126876, 0.000924949534237385],
  ],
  [
    [118.489618315797, 24.7955793950649, 0.000924875028431416],
    [118.489138976633, 24.7961539676801, 0.000924947671592236],
  ],
  [
    [118.489602579145, 24.7955684591327, 0.000924872234463692],
    [118.48912323995, 24.7961430316985, 0.000924945808947086],
  ],
  [
    [118.489586842496, 24.7955575231989, 0.000924872234463692],
    [118.48910750327, 24.7961320957153, 0.000924944877624512],
  ],
  [
    [118.48957110584, 24.7955465782357, 0.000924870371818542],
    [118.489091766583, 24.7961211507026, 0.000924943014979362],
  ],
  [
    [118.489555369196, 24.7955356422986, 0.000924869440495968],
    [118.489076029908, 24.796110214716, 0.000924942083656788],
  ],
  [
    [118.489539632556, 24.7955247063597, 0.000924868509173393],
    [118.489060293236, 24.7960992787277, 0.000924939289689064],
  ],
  [
    [118.489523895907, 24.7955137613915, 0.000924865715205669],
    [118.489044566447, 24.7960883337009, 0.000924939289689064],
  ],
  [
    [118.489508159272, 24.7955028254492, 0.000924866646528244],
    [118.489028829781, 24.7960773977092, 0.000924937427043915],
  ],
  [
    [118.489492432519, 24.7954918804684, 0.000924862921237946],
    [118.489013093118, 24.7960664617159, 0.000924937427043915],
  ],
  [
    [118.48947669589, 24.7954809445228, 0.000924861058592796],
    [118.488997356447, 24.7960555166932, 0.000924934633076191],
  ],
  [
    [118.489460959263, 24.7954700085755, 0.000924861058592796],
    [118.488981619789, 24.7960445806965, 0.000924933701753616],
  ],
  [
    [118.489445222629, 24.7954590635989, 0.000924859195947647],
    [118.488965883134, 24.7960336446981, 0.000924934633076191],
  ],
  [
    [118.489429486007, 24.7954481276482, 0.000924858264625072],
    [118.488950146471, 24.7960226996703, 0.000924931839108467],
  ],
  [
    [118.489413749389, 24.7954371916959, 0.000924857333302498],
    [118.488934409822, 24.7960117636686, 0.000924929976463318],
  ],
  [
    [118.489398012763, 24.7954262467142, 0.000924856401979923],
    [118.488918673165, 24.7960008186374, 0.000924929045140743],
  ],
  [
    [118.489382276149, 24.7954153107585, 0.000924854539334774],
    [118.488902936521, 24.7959898826323, 0.000924927182495594],
  ],
  [
    [118.489366539539, 24.7954043748012, 0.000924852676689625],
    [118.488887199879, 24.7959789466255, 0.000924925319850445],
  ],
  [
    [118.489350802921, 24.7953934298144, 0.000924849882721901],
    [118.48887147312, 24.7959680015802, 0.000924923457205296],
  ],
  [
    [118.489335076206, 24.7953824938445, 0.000924848951399326],
    [118.488855736484, 24.79595706557, 0.000924922525882721],
  ],
  [
    [118.489319339604, 24.795371557882, 0.000924847088754177],
    [118.488839999851, 24.7959461295581, 0.000924920663237572],
  ],
  [
    [118.489303602995, 24.7953606128902, 0.000924848020076752],
    [118.488824263211, 24.7959351845169, 0.000924918800592422],
  ],
  [
    [118.489287866398, 24.7953496769244, 0.000924845226109028],
    [118.488808526583, 24.7959242485017, 0.000924919731914997],
  ],
  [
    [118.489272129804, 24.795338740957, 0.000924844294786453],
    [118.488792789959, 24.7959133124848, 0.000924916937947273],
  ],
  [
    [118.489256393203, 24.7953277959601, 0.000924843363463879],
    [118.488777053326, 24.7959023674385, 0.000924915075302124],
  ],
  [
    [118.489240656615, 24.7953168599893, 0.000924840569496155],
    [118.488761316707, 24.7958914314183, 0.000924913212656975],
  ],
  [
    [118.489224920029, 24.7953059240168, 0.000924840569496155],
    [118.488745580091, 24.7958804953963, 0.0009249122813344],
  ],
  [
    [118.489209183436, 24.7952949790149, 0.000924838706851006],
    [118.488729843467, 24.795869550345, 0.000924911350011826],
  ],
  [
    [118.489193446856, 24.795284043039, 0.000924836844205856],
    [118.488714116745, 24.7958586143105, 0.000924909487366676],
  ],
  [
    [118.489177720169, 24.7952731070523, 0.000924835912883282],
    [118.488698380137, 24.7958476782835, 0.000924909487366676],
  ],
  [
    [118.489161983584, 24.7952621620453, 0.000924833118915558],
    [118.488682643521, 24.7958367332272, 0.000924907624721527],
  ],
  [
    [118.489146247012, 24.7952512260644, 0.000924834981560707],
    [118.488666906919, 24.7958257971968, 0.000924905762076378],
  ],
  [
    [118.489130510433, 24.7952402810541, 0.000924831256270409],
    [118.488651170319, 24.7958148611648, 0.000924904830753803],
  ],
  [
    [118.489114773867, 24.7952293450698, 0.000924830324947834],
    [118.488635433711, 24.7958039161033, 0.000924903899431229],
  ],
  [
    [118.489099037303, 24.7952184090838, 0.000924829393625259],
    [118.488619697117, 24.7957929800679, 0.000924902968108654],
  ],
  [
    [118.489083300732, 24.7952074640685, 0.00092482753098011],
    [118.488603960525, 24.7957820440309, 0.00092490017414093],
  ],
  [
    [118.489067564175, 24.7951965280791, 0.000924824737012386],
    [118.488588223926, 24.7957710989644, 0.000924898311495781],
  ],
  [
    [118.489051827619, 24.7951855920881, 0.000924825668334961],
    [118.48857248734, 24.7957601629239, 0.000924898311495781],
  ],
  [
    [118.489036091057, 24.7951746470677, 0.000924823805689812],
    [118.488556760646, 24.7957492268727, 0.000924896448850632],
  ],
  [
    [118.489020364397, 24.7951637110641, 0.000924822874367237],
    [118.488541024055, 24.7957382818011, 0.000924895517528057],
  ],
  [
    [118.48900462785, 24.7951527750681, 0.000924821011722088],
    [118.488525287477, 24.7957273457556, 0.000924892723560333],
  ],
  [
    [118.488988891295, 24.7951418300426, 0.000924820080399513],
    [118.488509550892, 24.7957164006808, 0.000924891792237759],
  ],
  [
    [118.488973154754, 24.7951308940432, 0.000924817286431789],
    [118.48849381432, 24.7957054646319, 0.000924890860915184],
  ],
  [
    [118.488957418215, 24.795119958042, 0.000924817286431789],
    [118.48847807775, 24.7956945285813, 0.000924889929592609],
  ],
  [
    [118.488941681669, 24.7951090130115, 0.000924816355109215],
    [118.488462341173, 24.7956835835014, 0.000924887135624886],
  ],
  [
    [118.488925945136, 24.7950980770071, 0.000924813561141491],
    [118.488446604609, 24.7956726474475, 0.000924887135624886],
  ],
  [
    [118.488910208606, 24.7950871410009, 0.000924812629818916],
    [118.488430868047, 24.7956617113919, 0.000924886204302311],
  ],
  [
    [118.488894472068, 24.7950761959653, 0.000924810767173767],
    [118.488415131479, 24.7956507663069, 0.000924882479012012],
  ],
  [
    [118.488878735543, 24.7950652599558, 0.000924809835851192],
    [118.488399404812, 24.7956398302388, 0.000924883410334587],
  ],
  [
    [118.488862999021, 24.7950543239446, 0.000924808904528618],
    [118.488383668259, 24.7956288941782, 0.000924881547689438],
  ],
  [
    [118.488847272381, 24.7950433788948, 0.000924807041883469],
    [118.488367931699, 24.7956179490882, 0.000924877822399139],
  ],
  [
    [118.488831535864, 24.7950324428803, 0.000924804247915745],
    [118.488352195151, 24.7956070130241, 0.000924878753721714],
  ],
  [
    [118.48881579935, 24.795021506864, 0.00092480331659317],
    [118.488336458606, 24.7955960769585, 0.000924876891076565],
  ],
  [
    [118.488800062829, 24.7950105618183, 0.00092480331659317],
    [118.488320722054, 24.7955851318634, 0.00092487595975399],
  ],
  [
    [118.488784326321, 24.7949996257987, 0.000924802385270596],
    [118.488304985515, 24.7955741957943, 0.000924874097108841],
  ],
  [
    [118.488768589815, 24.7949886897774, 0.000924799591302872],
    [118.488289248978, 24.7955632597236, 0.000924873165786266],
  ],
  [
    [118.488752853302, 24.7949777447267, 0.000924798659980297],
    [118.488273512434, 24.7955523146235, 0.000924872234463692],
  ],
  [
    [118.488737116802, 24.794966808702, 0.000924796797335148],
    [118.488257775903, 24.7955413785494, 0.000924870371818542],
  ],
  [
    [118.488721380295, 24.794955863648, 0.000924795866012573],
    [118.488242039375, 24.7955304424736, 0.000924869440495968],
  ],
  [
    [118.4887056438, 24.7949449276199, 0.000924795866012573],
    [118.488226312729, 24.7955194973593, 0.000924865715205669],
  ],
  [
    [118.488689917198, 24.7949339915811, 0.000924793072044849],
    [118.488210576206, 24.7955085612801, 0.000924867577850819],
  ],
  [
    [118.488674180699, 24.7949230465219, 0.0009247912093997],
    [118.488194839686, 24.7954976251993, 0.000924865715205669],
  ],
  [
    [118.488658444212, 24.7949121104889, 0.0009247912093997],
    [118.488179103159, 24.7954866800891, 0.000924862921237946],
  ],
  [
    [118.488642707729, 24.7949011744541, 0.000924789346754551],
    [118.488163366644, 24.7954757440049, 0.000924862921237946],
  ],
  [
    [118.488626971238, 24.7948902293899, 0.000924787484109402],
    [118.488147630122, 24.7954647988913, 0.000924861058592796],
  ],
  [
    [118.48861123476, 24.7948792933518, 0.000924786552786827],
    [118.488131893613, 24.7954538628037, 0.000924858264625072],
  ],
  [
    [118.488595498285, 24.794868357312, 0.000924785621464252],
    [118.488116157107, 24.7954429267145, 0.000924857333302498],
  ],
  [
    [118.488579761802, 24.7948574122428, 0.000924782827496529],
    [118.488100420593, 24.7954319815959, 0.000924855470657349],
  ],
  [
    [118.488564025332, 24.7948464761996, 0.000924782827496529],
    [118.488084684093, 24.7954210455033, 0.000924855470657349],
  ],
  [
    [118.488548288865, 24.7948355401548, 0.000924780964851379],
    [118.488068957484, 24.7954101093998, 0.000924853608012199],
  ],
  [
    [118.48853256228, 24.7948245950713, 0.00092477910220623],
    [118.488053220979, 24.7953991642762, 0.00092485174536705],
  ],
  [
    [118.488516825819, 24.7948136590231, 0.00092477910220623],
    [118.488037484486, 24.7953882281785, 0.000924850814044476],
  ],
  [
    [118.48850108936, 24.7948027229732, 0.000924777239561081],
    [118.488021747997, 24.7953772920792, 0.000924848951399326],
  ],
  [
    [118.488485352894, 24.7947917778939, 0.000924775376915932],
    [118.4880060115, 24.7953663469505, 0.000924848020076752],
  ],
  [
    [118.488469616441, 24.7947808418406, 0.000924774445593357],
    [118.487990275015, 24.7953554108477, 0.000924846157431602],
  ],
  [
    [118.48845387999, 24.7947699057857, 0.000924772582948208],
    [118.487974538534, 24.7953444747434, 0.000924845226109028],
  ],
  [
    [118.488438143533, 24.7947589607013, 0.000924769788980484],
    [118.487958802045, 24.7953335296096, 0.000924845226109028],
  ],
  [
    [118.488422407088, 24.794748024643, 0.000924769788980484],
    [118.487943065569, 24.7953225935018, 0.000924841500818729],
  ],
  [
    [118.488406670646, 24.794737088583, 0.000924769788980484],
    [118.487927329096, 24.7953116573924, 0.000924842432141304],
  ],
  [
    [118.488390934196, 24.7947261434936, 0.000924766063690186],
    [118.487911602505, 24.7953007122445, 0.00092483963817358],
  ],
  [
    [118.488375207649, 24.7947152074211, 0.000924766063690186],
    [118.487895866037, 24.7952897761317, 0.000924836844205856],
  ],
  [
    [118.488359471215, 24.794704271356, 0.000924765132367611],
    [118.487880129572, 24.7952788400172, 0.000924835912883282],
  ],
  [
    [118.488343734774, 24.7946933262616, 0.000924763269722462],
    [118.4878643931, 24.7952678948733, 0.000924834981560707],
  ],
  [
    [118.488327998345, 24.7946823901932, 0.000924761407077312],
    [118.487848656641, 24.7952569587555, 0.000924833118915558],
  ],
  [
    [118.48831226191, 24.7946714450954, 0.000924759544432163],
    [118.487832920184, 24.7952460226359, 0.000924832187592983],
  ],
  [
    [118.488296525487, 24.7946605090236, 0.000924757681787014],
    [118.48781718372, 24.795235077487, 0.000924831256270409],
  ],
  [
    [118.488280789066, 24.7946495729501, 0.000924758613109589],
    [118.487801447269, 24.7952241413641, 0.000924829393625259],
  ],
  [
    [118.488265052639, 24.7946386278473, 0.000924755819141865],
    [118.487785710821, 24.7952132052395, 0.000924830324947834],
  ],
  [
    [118.488249316224, 24.7946276917704, 0.00092475488781929],
    [118.487769974365, 24.7952022600856, 0.00092482753098011],
  ],
  [
    [118.488233579812, 24.7946167556919, 0.000924752093851566],
    [118.487754247812, 24.7951913239485, 0.000924825668334961],
  ],
  [
    [118.488217843393, 24.794605810584, 0.000924751162528992],
    [118.487738511362, 24.7951803787912, 0.000924823805689812],
  ],
  [
    [118.488202116876, 24.794594874493, 0.000924750231206417],
    [118.487722774924, 24.7951694426599, 0.000924821943044662],
  ],
  [
    [118.488186380473, 24.7945839384095, 0.000924749299883842],
    [118.48770703849, 24.7951585065269, 0.000924821011722088],
  ],
  [
    [118.488170644062, 24.7945729932965, 0.000924746505916119],
    [118.487691302048, 24.7951475613645, 0.000924820080399513],
  ],
  [
    [118.488154907664, 24.7945620572096, 0.000924747437238693],
    [118.487675565619, 24.7951366252282, 0.000924819149076939],
  ],
  [
    [118.488139171268, 24.794551121121, 0.000924746505916119],
    [118.487659829192, 24.7951256890901, 0.000924817286431789],
  ],
  [
    [118.488123434866, 24.794540176003, 0.000924741849303246],
    [118.487644092759, 24.7951147439227, 0.00092481542378664],
  ],
  [
    [118.488107698476, 24.794529239911, 0.00092474278062582],
    [118.487628356338, 24.7951038077813, 0.000924813561141491],
  ],
  [
    [118.488091962089, 24.7945183038173, 0.000924740917980671],
    [118.48761261992, 24.7950928716382, 0.000924814492464066],
  ],
  [
    [118.488076225695, 24.7945073586943, 0.000924739986658096],
    [118.487596883495, 24.7950819264658, 0.000924812629818916],
  ],
  [
    [118.488060489313, 24.7944964225973, 0.000924737192690372],
    [118.487581156972, 24.7950709903102, 0.000924810767173767],
  ],
  [
    [118.488044762824, 24.7944854864895, 0.000924738124012947],
    [118.487565420562, 24.7950600541621, 0.000924807973206043],
  ],
  [
    [118.488029026438, 24.7944745413614, 0.000924735330045223],
    [118.487549684145, 24.7950491089846, 0.000924807041883469],
  ],
  [
    [118.488013290064, 24.7944636052593, 0.000924732536077499],
    [118.48753394774, 24.7950381728331, 0.000924807041883469],
  ],
  [
    [118.487997553694, 24.7944526691555, 0.000924732536077499],
    [118.487518211339, 24.7950272366799, 0.000924805179238319],
  ],
  [
    [118.487981817316, 24.7944417240224, 0.00092473067343235],
    [118.48750247493, 24.7950162914973, 0.00092480331659317],
  ],
  [
    [118.487966080951, 24.7944307879153, 0.000924729742109776],
    [118.487486738534, 24.7950053553408, 0.000924801453948021],
  ],
  [
    [118.487950344579, 24.7944198427788, 0.000924729742109776],
    [118.487471002141, 24.7949944191826, 0.000924800522625446],
  ],
  [
    [118.487934608219, 24.7944089066683, 0.000924726016819477],
    [118.48745526574, 24.794983473995, 0.000924798659980297],
  ],
  [
    [118.487918871862, 24.7943979705562, 0.000924726016819477],
    [118.487439529353, 24.7949725378334, 0.000924798659980297],
  ],
  [
    [118.487903135498, 24.7943870254146, 0.000924723222851753],
    [118.487423802857, 24.794961601661, 0.000924798659980297],
  ],
  [
    [118.487887409037, 24.79437608929, 0.000924724154174328],
    [118.487408066465, 24.7949506564683, 0.000924794934689999],
  ],
  [
    [118.487871672688, 24.7943651531728, 0.000924721360206604],
    [118.487392330086, 24.7949397203017, 0.000924794934689999],
  ],
  [
    [118.487855936332, 24.7943542080262, 0.000924720428884029],
    [118.487376593709, 24.7949287841334, 0.000924790278077126],
  ],
  [
    [118.487840199989, 24.7943432719056, 0.000924717634916306],
    [118.487360857325, 24.7949178389357, 0.000924792140722275],
  ],
  [
    [118.487824463649, 24.7943323357833, 0.000924717634916306],
    [118.487345120954, 24.794906902764, 0.000924789346754551],
  ],
  [
    [118.487808727302, 24.7943213906317, 0.000924716703593731],
    [118.487329384575, 24.7948959575629, 0.000924788415431976],
  ],
  [
    [118.487792990967, 24.7943104545061, 0.000924716703593731],
    [118.48731364821, 24.7948850213879, 0.000924786552786827],
  ],
  [
    [118.487777254635, 24.7942995183788, 0.000924712978303432],
    [118.487297911847, 24.7948740852111, 0.000924784690141678],
  ],
  [
    [118.487761518296, 24.7942885732221, 0.000924712046980858],
    [118.487282175476, 24.794863140005, 0.000924783758819103],
  ],
  [
    [118.487745781969, 24.7942776370914, 0.000924710184335709],
    [118.487266449009, 24.7948522038159, 0.000924782827496529],
  ],
  [
    [118.487730055535, 24.7942667009499, 0.000924708321690559],
    [118.487250712654, 24.7948412676341, 0.000924781896173954],
  ],
  [
    [118.487714319204, 24.7942557557882, 0.000924707390367985],
    [118.487234976292, 24.7948303224229, 0.000924780033528805],
  ],
  [
    [118.487698582886, 24.7942448196525, 0.00092470645904541],
    [118.487219239943, 24.7948193862378, 0.00092477910220623],
  ],
  [
    [118.487682846571, 24.7942338835151, 0.000924704596400261],
    [118.487203503596, 24.7948084500509, 0.000924778170883656],
  ],
  [
    [118.487667110248, 24.7942229383483, 0.000924704596400261],
    [118.487187767243, 24.7947975048347, 0.000924776308238506],
  ],
  [
    [118.487651373938, 24.7942120022075, 0.000924701802432537],
    [118.487172030902, 24.7947865686445, 0.000924775376915932],
  ],
  [
    [118.487635637631, 24.7942010660651, 0.000924701802432537],
    [118.487156294564, 24.7947756324527, 0.000924772582948208],
  ],
  [
    [118.487619901317, 24.7941901208933, 0.000924699008464813],
    [118.487140558218, 24.7947646872314, 0.000924772582948208],
  ],
  [
    [118.487604165015, 24.7941791847475, 0.000924696214497089],
    [118.487124821886, 24.7947537510362, 0.000924769788980484],
  ],
  [
    [118.487588428716, 24.7941682486, 0.000924696214497089],
    [118.487109095445, 24.7947428148302, 0.000924768857657909],
  ],
  [
    [118.48757269241, 24.7941573034231, 0.000924695283174515],
    [118.487093359108, 24.7947318696039, 0.000924767926335335],
  ],
  [
    [118.487556966006, 24.7941463672631, 0.00092469435185194],
    [118.487077622784, 24.7947209334036, 0.00092476699501276],
  ],
  [
    [118.487541229705, 24.7941354220829, 0.000924693420529366],
    [118.487061886462, 24.7947099972016, 0.000924764201045036],
  ],
  [
    [118.487525493418, 24.7941244859287, 0.000924691557884216],
    [118.487046150134, 24.7946990519703, 0.000924763269722462],
  ],
  [
    [118.487509757133, 24.7941135497728, 0.000924687832593918],
    [118.487030413818, 24.7946881157649, 0.000924764201045036],
  ],
  [
    [118.48749402084, 24.7941026045875, 0.000924688763916492],
    [118.487014677504, 24.7946771795579, 0.000924761407077312],
  ],
  [
    [118.487478284561, 24.7940916684282, 0.000924687832593918],
    [118.486998941184, 24.7946662343215, 0.000924758613109589],
  ],
  [
    [118.487462548284, 24.7940807322673, 0.000924686901271343],
    [118.486983204876, 24.7946552981111, 0.000924757681787014],
  ],
  [
    [118.487446812, 24.7940697870769, 0.000924684107303619],
    [118.486967468561, 24.7946443528714, 0.000924758613109589],
  ],
  [
    [118.487431075728, 24.7940588509126, 0.000924683175981045],
    [118.486951732259, 24.7946334166576, 0.000924753956496716],
  ],
  [
    [118.48741533946, 24.7940479147466, 0.000924681313335896],
    [118.486936005849, 24.7946224804331, 0.000924753025174141],
  ],
  [
    [118.487399613074, 24.7940369695421, 0.000924678519368172],
    [118.486920269542, 24.7946115351883, 0.000924752093851566],
  ],
  [
    [118.487383876811, 24.7940260333728, 0.000924677588045597],
    [118.486904533248, 24.7946005989695, 0.000924752093851566],
  ],
  [
    [118.48736814055, 24.7940150972017, 0.000924677588045597],
    [118.486888796957, 24.7945896627491, 0.000924749299883842],
  ],
  [
    [118.487352404283, 24.7940041520013, 0.000924673862755299],
    [118.486873060658, 24.7945787174992, 0.000924748368561268],
  ],
  [
    [118.487336668028, 24.7939932158269, 0.000924672931432724],
    [118.486857324372, 24.7945677812754, 0.000924746505916119],
  ],
  [
    [118.487320931776, 24.7939822796508, 0.000924673862755299],
    [118.486841588089, 24.7945568450499, 0.000924744643270969],
  ],
  [
    [118.487305195517, 24.7939713344453, 0.000924671068787575],
    [118.486825851799, 24.794545899795, 0.000924745574593544],
  ],
  [
    [118.48728945927, 24.7939603982659, 0.000924672000110149],
    [118.486810115522, 24.7945349635661, 0.00092474278062582],
  ],
  [
    [118.487273723026, 24.7939494620847, 0.000924669206142426],
    [118.486794379247, 24.7945240273355, 0.000924740917980671],
  ],
  [
    [118.487257986776, 24.7939385168742, 0.000924668274819851],
    [118.486778652855, 24.7945130820665, 0.000924739055335522],
  ],
  [
    [118.487242260427, 24.7939275806806, 0.000924666412174702],
    [118.486762916585, 24.7945021458326, 0.000924738124012947],
  ],
  [
    [118.487226524191, 24.7939166444944, 0.000924663618206978],
    [118.486747180319, 24.7944912095969, 0.000924738124012947],
  ],
  [
    [118.487210787949, 24.7939056992788, 0.000924663618206978],
    [118.486731444045, 24.7944802643319, 0.000924736261367798],
  ],
  [
    [118.487195051719, 24.7938947630893, 0.000924662686884403],
    [118.486715707784, 24.794469328093, 0.000924735330045223],
  ],
  [
    [118.487179315481, 24.7938838178704, 0.000924660824239254],
    [118.486699971526, 24.7944583918523, 0.000924733467400074],
  ],
  [
    [118.487163579257, 24.7938728816774, 0.00092465803027153],
    [118.486684235261, 24.7944474465823, 0.000924732536077499],
  ],
  [
    [118.487147843035, 24.7938619454828, 0.000924658961594105],
    [118.486668499008, 24.7944365103382, 0.000924731604754925],
  ],
  [
    [118.487132106806, 24.7938510002589, 0.000924657098948956],
    [118.486652762758, 24.7944255740925, 0.000924728810787201],
  ],
  [
    [118.48711637059, 24.7938400640609, 0.000924655236303806],
    [118.486637026501, 24.7944146288174, 0.000924726948142052],
  ],
  [
    [118.487100634377, 24.7938291278613, 0.000924652442336082],
    [118.486621300146, 24.7944036925593, 0.000924725085496902],
  ],
  [
    [118.487084908046, 24.7938181826232, 0.000924653373658657],
    [118.486605563904, 24.7943927563086, 0.000924725085496902],
  ],
  [
    [118.487069171838, 24.7938072464202, 0.000924651511013508],
    [118.486589827656, 24.7943818110284, 0.000924723222851753],
  ],
  [
    [118.487053435632, 24.7937963102155, 0.000924650579690933],
    [118.486574091419, 24.7943708747743, 0.000924721360206604],
  ],
  [
    [118.48703769942, 24.7937853649814, 0.000924648717045784],
    [118.486558355176, 24.7943599294908, 0.000924721360206604],
  ],
  [
    [118.48702196322, 24.7937744287733, 0.000924647785723209],
    [118.486542618946, 24.7943489932333, 0.000924719497561455],
  ],
  [
    [118.487006227024, 24.7937634925636, 0.000924644991755486],
    [118.486526882718, 24.7943380569742, 0.00092471856623888],
  ],
  [
    [118.48699049082, 24.7937525473245, 0.000924644060432911],
    [118.486511146483, 24.7943271116856, 0.000924715772271156],
  ],
  [
    [118.486974754628, 24.7937416111113, 0.000924643129110336],
    [118.48649541026, 24.7943161754231, 0.000924713909626007],
  ],
  [
    [118.48695901844, 24.7937306748966, 0.000924642197787762],
    [118.486479674041, 24.7943052391589, 0.000924713909626007],
  ],
  [
    [118.486943282244, 24.7937197296524, 0.000924640335142612],
    [118.486463947703, 24.7942942938562, 0.000924712046980858],
  ],
  [
    [118.486927546061, 24.7937087934342, 0.000924638472497463],
    [118.486448211489, 24.7942833575886, 0.000924711115658283],
  ],
  [
    [118.48691181977, 24.7936978572054, 0.000924637541174889],
    [118.486432475278, 24.7942724213194, 0.000924709253013134],
  ],
  [
    [118.486896083582, 24.7936869119561, 0.000924635678529739],
    [118.48641673906, 24.7942614760207, 0.000924709253013134],
  ],
  [
    [118.486880347407, 24.7936759757329, 0.00092463381588459],
    [118.486401002854, 24.7942505397481, 0.000924707390367985],
  ],
  [
    [118.486864611235, 24.7936650395081, 0.000924632884562016],
    [118.486385266651, 24.7942396034738, 0.000924705527722836],
  ],
  [
    [118.486848875056, 24.7936540942538, 0.000924631953239441],
    [118.48636953044, 24.7942286581701, 0.000924705527722836],
  ],
  [
    [118.486833138889, 24.7936431580256, 0.000924631953239441],
    [118.486353794243, 24.7942177218924, 0.000924702733755112],
  ],
  [
    [118.486817402726, 24.7936322217956, 0.000924629159271717],
    [118.486338058048, 24.7942067856131, 0.000924702733755112],
  ],
  [
    [118.486801666555, 24.7936212765363, 0.000924627296626568],
    [118.486322321846, 24.7941958403044, 0.000924701802432537],
  ],
  [
    [118.486785930396, 24.793610340303, 0.000924626365303993],
    [118.486306585657, 24.7941849040216, 0.000924699939787388],
  ],
  [
    [118.486770194231, 24.7935993950403, 0.000924625433981419],
    [118.48629085936, 24.7941739677282, 0.000924697145819664],
  ],
  [
    [118.486754467967, 24.7935884587947, 0.000924622640013695],
    [118.486275123166, 24.7941630224144, 0.000924695283174515],
  ],
  [
    [118.486738731817, 24.7935775225563, 0.00092462170869112],
    [118.486259386985, 24.7941520861267, 0.00092469435185194],
  ],
  [
    [118.48672299566, 24.7935665772886, 0.000924620777368546],
    [118.486243650807, 24.7941411498372, 0.000924693420529366],
  ],
  [
    [118.486707259516, 24.7935556410469, 0.000924617983400822],
    [118.486227914621, 24.7941302045184, 0.000924691557884216],
  ],
  [
    [118.486691523374, 24.7935447048035, 0.000924617983400822],
    [118.486212178449, 24.7941192682256, 0.000924690626561642],
  ],
  [
    [118.486675787225, 24.7935337595307, 0.000924617052078247],
    [118.486196442279, 24.7941083319311, 0.000924689695239067],
  ],
  [
    [118.486660051089, 24.793522823284, 0.000924616120755672],
    [118.486180706102, 24.7940973866072, 0.000924687832593918],
  ],
  [
    [118.486644314955, 24.7935118870356, 0.000924614258110523],
    [118.486164969937, 24.7940864503093, 0.000924686901271343],
  ],
  [
    [118.486628578815, 24.7935009417577, 0.000924611464142799],
    [118.486149233766, 24.7940755049821, 0.000924685038626194],
  ],
  [
    [118.486612842687, 24.7934900055059, 0.000924611464142799],
    [118.486133507496, 24.7940645686719, 0.00092468224465847],
  ],
  [
    [118.486597116451, 24.7934790692434, 0.00092460960149765],
    [118.48611777134, 24.794053632369, 0.00092468224465847],
  ],
  [
    [118.486581380318, 24.7934681239606, 0.000924608670175076],
    [118.486102035176, 24.7940426870367, 0.000924679450690746],
  ],
  [
    [118.486565644199, 24.7934571877037, 0.000924606807529926],
    [118.486086299026, 24.7940317507304, 0.000924679450690746],
  ],
  [
    [118.486549908082, 24.7934462514452, 0.000924604944884777],
    [118.486070562878, 24.7940208144225, 0.000924678519368172],
  ],
  [
    [118.486534171958, 24.7934353061573, 0.000924604013562202],
    [118.486054826723, 24.7940098690851, 0.000924674794077873],
  ],
  [
    [118.486518435846, 24.7934243698954, 0.000924603082239628],
    [118.48603909058, 24.7939989327738, 0.000924675725400448],
  ],
  [
    [118.486502699737, 24.7934134336318, 0.000924600288271904],
    [118.486023354441, 24.7939879964608, 0.000924673862755299],
  ],
  [
    [118.486486963622, 24.7934024883389, 0.000924600288271904],
    [118.486007618294, 24.7939770511184, 0.000924672000110149],
  ],
  [
    [118.486471227518, 24.7933915520719, 0.000924600288271904],
    [118.48599188216, 24.7939661148021, 0.000924671068787575],
  ],
  [
    [118.486455491418, 24.7933806158033, 0.00092459749430418],
    [118.485976155918, 24.793955178475, 0.000924671068787575],
  ],
  [
    [118.4864397652, 24.7933696704963, 0.000924595631659031],
    [118.485960419779, 24.7939442331276, 0.000924669206142426],
  ],
  [
    [118.486424029105, 24.7933587342243, 0.000924593769013882],
    [118.485944683653, 24.7939332968062, 0.000924667343497276],
  ],
  [
    [118.486408293013, 24.7933477979507, 0.000924591906368732],
    [118.48592894753, 24.7939223604831, 0.000924664549529552],
  ],
  [
    [118.486392556913, 24.7933368526476, 0.000924592837691307],
    [118.4859132114, 24.7939114151306, 0.000924663618206978],
  ],
  [
    [118.486376820827, 24.7933259163706, 0.000924590043723583],
    [118.485897475282, 24.7939004788042, 0.000924661755561829],
  ],
  [
    [118.486361084733, 24.7933149710642, 0.000924589112401009],
    [118.485881739168, 24.793889542476, 0.000924660824239254],
  ],
  [
    [118.486345348652, 24.7933040347838, 0.000924587249755859],
    [118.485866003046, 24.7938785971185, 0.000924659892916679],
  ],
  [
    [118.486329612574, 24.7932930985017, 0.000924587249755859],
    [118.485850266936, 24.793867660787, 0.000924658961594105],
  ],
  [
    [118.486313876488, 24.7932821531902, 0.000924584455788136],
    [118.48583453083, 24.7938567244538, 0.000924658961594105],
  ],
  [
    [118.486298140415, 24.7932712169048, 0.000924582593142986],
    [118.485818804605, 24.7938457790823, 0.000924657098948956],
  ],
  [
    [118.486282404345, 24.7932602806177, 0.000924580730497837],
    [118.485803068504, 24.7938348427457, 0.000924653373658657],
  ],
  [
    [118.486266678157, 24.7932493352922, 0.000924580730497837],
    [118.485787332396, 24.7938238973798, 0.000924655236303806],
  ],
  [
    [118.486250942093, 24.7932383990017, 0.000924578867852688],
    [118.485771596301, 24.7938129610399, 0.000924650579690933],
  ],
  [
    [118.486235206031, 24.7932274627095, 0.000924577936530113],
    [118.485755860208, 24.7938020246983, 0.000924649648368359],
  ],
  [
    [118.486219469962, 24.793216517388, 0.000924575142562389],
    [118.485740124108, 24.7937910793273, 0.000924649648368359],
  ],
  [
    [118.486203733906, 24.7932055810924, 0.000924576073884964],
    [118.485724388021, 24.7937801429823, 0.000924647785723209],
  ],
  [
    [118.486187997852, 24.7931946447952, 0.000924572348594666],
    [118.485708651936, 24.7937692066357, 0.00092464592307806],
  ],
  [
    [118.486172261791, 24.7931836994686, 0.00092457327991724],
    [118.485692915844, 24.7937582612597, 0.000924644991755486],
  ],
  [
    [118.486156525743, 24.793172763168, 0.000924570485949516],
    [118.485677179765, 24.7937473249097, 0.000924643129110336],
  ],
  [
    [118.486140789698, 24.7931618268658, 0.000924568623304367],
    [118.485661443689, 24.793736388558, 0.000924642197787762],
  ],
  [
    [118.486125053646, 24.7931508815341, 0.000924568623304367],
    [118.485645717495, 24.7937254431679, 0.000924639403820038],
  ],
  [
    [118.486109327495, 24.7931399452195, 0.000924566760659218],
    [118.485629981424, 24.7937145068129, 0.000924639403820038],
  ],
  [
    [118.486093591458, 24.7931290089122, 0.000924564898014069],
    [118.485614245356, 24.7937035704561, 0.000924639403820038],
  ],
  [
    [118.486077855414, 24.7931180635755, 0.000924563035368919],
    [118.485598509281, 24.79369262507, 0.000924635678529739],
  ],
  [
    [118.486062119382, 24.7931071272648, 0.000924563035368919],
    [118.485582773219, 24.7936816887099, 0.000924635678529739],
  ],
  [
    [118.486046383354, 24.7930961909525, 0.000924562104046345],
    [118.485567037159, 24.7936707523481, 0.00092463381588459],
  ],
  [
    [118.486030647318, 24.7930852456107, 0.00092456117272377],
    [118.485551301092, 24.793659806957, 0.000924632884562016],
  ],
  [
    [118.486014911295, 24.793074309295, 0.000924559310078621],
    [118.485535565038, 24.7936488705918, 0.000924631021916866],
  ],
  [
    [118.485999175264, 24.7930633639499, 0.000924557447433472],
    [118.485519828987, 24.793637934225, 0.000924630090594292],
  ],
  [
    [118.485983439246, 24.7930524276308, 0.000924554653465748],
    [118.485504092928, 24.7936269888288, 0.000924628227949142],
  ],
  [
    [118.485967703232, 24.79304149131, 0.000924554653465748],
    [118.485488366771, 24.7936160524496, 0.000924627296626568],
  ],
  [
    [118.485951977099, 24.7930305459509, 0.000924552790820599],
    [118.485472630728, 24.7936051160778, 0.000924626365303993],
  ],
  [
    [118.485936241089, 24.7930196096268, 0.000924550928175449],
    [118.485456894678, 24.7935941706765, 0.000924624502658844],
  ],
  [
    [118.485920505083, 24.793008673301, 0.000924549996852875],
    [118.48544115864, 24.7935832343013, 0.000924623571336269],
  ],
  [
    [118.485904769069, 24.7929977279458, 0.000924549996852875],
    [118.485425422605, 24.7935722979243, 0.00092462170869112],
  ],
  [
    [118.485889033068, 24.7929867916166, 0.000924548134207726],
    [118.485409686563, 24.793561352518, 0.000924619846045971],
  ],
  [
    [118.485873297069, 24.7929758552857, 0.000924545340240002],
    [118.485393950534, 24.7935504161378, 0.000924619846045971],
  ],
  [
    [118.485857561064, 24.7929649099255, 0.000924544408917427],
    [118.485378214498, 24.7935394707281, 0.000924617052078247],
  ],
  [
    [118.485841825071, 24.7929539735913, 0.000924542546272278],
    [118.485362478474, 24.7935285343444, 0.000924616120755672],
  ],
  [
    [118.485826089081, 24.7929430372554, 0.000924542546272278],
    [118.485346742452, 24.7935175979591, 0.000924615189433098],
  ],
  [
    [118.485810353083, 24.7929320918901, 0.000924540683627129],
    [118.485331016314, 24.7935066525354, 0.000924613326787949],
  ],
  [
    [118.485794626988, 24.7929211555418, 0.000924537889659405],
    [118.485315280298, 24.7934957161467, 0.000924612395465374],
  ],
  [
    [118.485778891006, 24.7929102192009, 0.000924537889659405],
    [118.485299544285, 24.7934847797564, 0.000924610532820225],
  ],
  [
    [118.485763155017, 24.7928992738306, 0.000924536027014256],
    [118.485283808265, 24.7934738343366, 0.00092460960149765],
  ],
  [
    [118.485747419041, 24.7928883374862, 0.000924535095691681],
    [118.485268072258, 24.7934628979429, 0.000924607738852501],
  ],
  [
    [118.485731683067, 24.7928774011403, 0.000924534164369106],
    [118.485252336253, 24.7934519615474, 0.000924606807529926],
  ],
  [
    [118.485715947086, 24.7928664557649, 0.000924532301723957],
    [118.485236600242, 24.7934410161226, 0.000924605876207352],
  ],
  [
    [118.485700211118, 24.7928555194155, 0.000924530439078808],
    [118.485220864242, 24.7934300797238, 0.000924603082239628],
  ],
  [
    [118.485684475153, 24.7928445830645, 0.000924529507756233],
    [118.485205128246, 24.7934191433234, 0.000924602150917053],
  ],
  [
    [118.48566873918, 24.792833637684, 0.000924527645111084],
    [118.485189392243, 24.7934081978935, 0.000924601219594479],
  ],
  [
    [118.485653003221, 24.7928227013296, 0.000924527645111084],
    [118.485173666141, 24.7933972614807, 0.000924601219594479],
  ],
  [
    [118.485637267263, 24.7928117649735, 0.000924525782465935],
    [118.485157930153, 24.7933863250752, 0.000924598425626755],
  ],
  [
    [118.485621541189, 24.7928008195791, 0.000924523919820786],
    [118.485142194158, 24.7933753796403, 0.000924598425626755],
  ],
  [
    [118.485605805237, 24.7927898832197, 0.000924523919820786],
    [118.485126458176, 24.7933644432314, 0.000924595631659031],
  ],
  [
    [118.485590069278, 24.7927789378308, 0.000924520194530487],
    [118.485110722196, 24.7933535068209, 0.000924593769013882],
  ],
  [
    [118.485574333332, 24.792768001468, 0.000924519263207912],
    [118.485094986209, 24.7933425613809, 0.000924593769013882],
  ],
  [
    [118.485558597389, 24.7927570651035, 0.000924518331885338],
    [118.485079250235, 24.793331624967, 0.000924589112401009],
  ],
  [
    [118.485542861439, 24.7927461197096, 0.000924516469240189],
    [118.485063514263, 24.7933206885514, 0.000924590975046158],
  ],
  [
    [118.485527125501, 24.7927351833417, 0.000924516469240189],
    [118.485047778285, 24.7933097431064, 0.000924588181078434],
  ],
  [
    [118.485511389566, 24.7927242469722, 0.000924515537917614],
    [118.485032042319, 24.7932988066874, 0.000924586318433285],
  ],
  [
    [118.485495653624, 24.7927133015733, 0.00092451274394989],
    [118.485016306355, 24.7932878702668, 0.000924584455788136],
  ],
  [
    [118.485479917694, 24.7927023652004, 0.000924511812627316],
    [118.485000580274, 24.7932769248078, 0.000924583524465561],
  ],
  [
    [118.485464191657, 24.7926914288168, 0.000924509949982166],
    [118.484984844317, 24.7932659883838, 0.000924582593142986],
  ],
  [
    [118.485448455723, 24.7926804834128, 0.000924509018659592],
    [118.484969108352, 24.7932550429304, 0.000924581661820412],
  ],
  [
    [118.485432719802, 24.7926695470349, 0.000924508087337017],
    [118.4849533724, 24.793244106503, 0.000924579799175262],
  ],
  [
    [118.485416983883, 24.7926586106552, 0.000924506224691868],
    [118.48493763645, 24.7932331700739, 0.000924577936530113],
  ],
  [
    [118.485401247957, 24.7926476652462, 0.000924504362046719],
    [118.484921900494, 24.7932222246155, 0.000924577005207539],
  ],
  [
    [118.485385512044, 24.7926367288632, 0.000924503430724144],
    [118.48490616455, 24.7932112881831, 0.000924577005207539],
  ],
  [
    [118.485369776134, 24.7926257924785, 0.000924501568078995],
    [118.484890428608, 24.793200351749, 0.00092457327991724],
  ],
  [
    [118.485354040217, 24.7926148470645, 0.000924499705433846],
    [118.48487469266, 24.7931894062854, 0.000924572348594666],
  ],
  [
    [118.485338304312, 24.7926039106764, 0.000924499705433846],
    [118.484858956724, 24.793178469848, 0.000924572348594666],
  ],
  [
    [118.48532256841, 24.7925929742867, 0.000924496911466122],
    [118.484843230681, 24.7931675333999, 0.000924571417272091],
  ],
  [
    [118.485306842391, 24.7925820288586, 0.000924495980143547],
    [118.484827494741, 24.7931565879314, 0.000924568623304367],
  ],
  [
    [118.485291106494, 24.7925710924655, 0.000924495980143547],
    [118.484811758813, 24.7931456514888, 0.000924567691981792],
  ],
  [
    [118.4852753706, 24.7925601560708, 0.000924492254853249],
    [118.484796022889, 24.7931347150446, 0.000924564898014069],
  ],
  [
    [118.4852596347, 24.7925492106466, 0.000924493186175823],
    [118.484780286957, 24.7931237695711, 0.000924563966691494],
  ],
  [
    [118.485243898811, 24.7925382742485, 0.000924490392208099],
    [118.484764551038, 24.7931128331235, 0.000924563035368919],
  ],
  [
    [118.485228162926, 24.7925273378486, 0.000924489460885525],
    [118.484748815122, 24.7931018966742, 0.000924562104046345],
  ],
  [
    [118.485212427033, 24.7925163924194, 0.00092448852956295],
    [118.484733079198, 24.7930909511956, 0.000924559310078621],
  ],
  [
    [118.485196691154, 24.7925054560162, 0.000924486666917801],
    [118.484717343287, 24.793080014743, 0.000924560241401196],
  ],
  [
    [118.485180955267, 24.7924945105837, 0.000924486666917801],
    [118.484701607379, 24.7930690782887, 0.000924557447433472],
  ],
  [
    [118.485165219392, 24.7924835741771, 0.000924484804272652],
    [118.484685881353, 24.7930581327961, 0.000924556516110897],
  ],
  [
    [118.48514949341, 24.79247263776, 0.000924482941627502],
    [118.484670145451, 24.7930471963385, 0.000924556516110897],
  ],
  [
    [118.485133757531, 24.7924616923223, 0.000924480147659779],
    [118.484654409551, 24.7930362598791, 0.000924552790820599],
  ],
  [
    [118.485118021665, 24.7924507559107, 0.000924479216337204],
    [118.484638673644, 24.7930253143904, 0.000924552790820599],
  ],
  [
    [118.485102285802, 24.7924398194975, 0.000924478285014629],
    [118.48462293775, 24.7930143779277, 0.000924550928175449],
  ],
  [
    [118.485086549931, 24.7924288740548, 0.000924478285014629],
    [118.484607201848, 24.7930034324356, 0.0009245490655303],
  ],
  [
    [118.485070814073, 24.7924179376382, 0.000924473628401756],
    [118.484591465959, 24.7929924959695, 0.000924547202885151],
  ],
  [
    [118.485055078218, 24.7924070012198, 0.000924474559724331],
    [118.484575730073, 24.7929815595018, 0.000924546271562576],
  ],
  [
    [118.485039342356, 24.7923960557721, 0.000924474559724331],
    [118.48455999418, 24.7929706140046, 0.000924546271562576],
  ],
  [
    [118.485023606506, 24.7923851193504, 0.000924471765756607],
    [118.4845442583, 24.7929596775335, 0.000924542546272278],
  ],
  [
    [118.48500787066, 24.7923741829271, 0.000924470834434032],
    [118.484528532311, 24.7929487410518, 0.000924543477594852],
  ],
  [
    [118.484992134806, 24.7923632374743, 0.000924468971788883],
    [118.484512796426, 24.7929377955497, 0.000924542546272278],
  ],
  [
    [118.484976408854, 24.7923523010387, 0.000924467109143734],
    [118.484497060554, 24.7929268590735, 0.000924540683627129],
  ],
  [
    [118.484960673015, 24.7923413646102, 0.000924467109143734],
    [118.484481324684, 24.7929159225956, 0.000924537889659405],
  ],
  [
    [118.48494493717, 24.7923304191524, 0.000924465246498585],
    [118.484465588808, 24.7929049770884, 0.000924538820981979],
  ],
  [
    [118.484929201336, 24.7923194827207, 0.000924462452530861],
    [118.484449852944, 24.7928940406072, 0.000924536027014256],
  ],
  [
    [118.484913465506, 24.7923085462872, 0.000924462452530861],
    [118.484434117083, 24.7928831041243, 0.000924533233046532],
  ],
  [
    [118.484897729669, 24.7922976008244, 0.000924460589885712],
    [118.484418381214, 24.792872158612, 0.000924532301723957],
  ],
  [
    [118.484881993844, 24.7922866643875, 0.000924459658563137],
    [118.484402645359, 24.7928612221258, 0.000924531370401382],
  ],
  [
    [118.484866258022, 24.792275727949, 0.000924456864595413],
    [118.484386909506, 24.7928502856379, 0.000924531370401382],
  ],
  [
    [118.484850522193, 24.7922647824811, 0.000924455933272839],
    [118.484371173646, 24.7928393401205, 0.000924529507756233],
  ],
  [
    [118.484834786376, 24.7922538460393, 0.000924455001950264],
    [118.484355447687, 24.7928284036204, 0.000924528576433659],
  ],
  [
    [118.484819060442, 24.7922429005591, 0.000924453139305115],
    [118.484339711843, 24.7928174671274, 0.00092452485114336],
  ],
  [
    [118.484803324631, 24.7922319641139, 0.00092445220798254],
    [118.484323975991, 24.792806521605, 0.00092452485114336],
  ],
  [
    [118.484787588823, 24.7922210276669, 0.000924451276659966],
    [118.484308240152, 24.7927955851087, 0.000924523919820786],
  ],
  [
    [118.484771853008, 24.7922100821906, 0.000924450345337391],
    [118.484292504315, 24.7927846486106, 0.000924522057175636],
  ],
  [
    [118.484756117205, 24.7921991457404, 0.000924447551369667],
    [118.484276768472, 24.7927737030832, 0.000924520194530487],
  ],
  [
    [118.484740381405, 24.7921882092884, 0.000924447551369667],
    [118.484261032641, 24.7927627665818, 0.000924518331885338],
  ],
  [
    [118.484724645598, 24.792177263807, 0.000924445688724518],
    [118.484245296813, 24.7927518300788, 0.000924518331885338],
  ],
  [
    [118.484708909803, 24.7921663273517, 0.000924444757401943],
    [118.484229560977, 24.7927408845463, 0.000924517400562763],
  ],
  [
    [118.484693174012, 24.7921553908947, 0.000924442894756794],
    [118.484213825155, 24.7927299480399, 0.000924515537917614],
  ],
  [
    [118.484677438213, 24.7921444454083, 0.000924441032111645],
    [118.484198099214, 24.7927190024952, 0.000924513675272465],
  ],
  [
    [118.484661712316, 24.792133508939, 0.00092444010078907],
    [118.484182363397, 24.7927080659854, 0.000924511812627316],
  ],
  [
    [118.484645976532, 24.792122572477, 0.000924439169466496],
    [118.484166627583, 24.7926971294739, 0.000924511812627316],
  ],
  [
    [118.484630240742, 24.7921116269856, 0.000924437306821346],
    [118.484150891761, 24.7926861839331, 0.000924509018659592],
  ],
  [
    [118.484614504964, 24.7921006905201, 0.000924435444176197],
    [118.484135155953, 24.7926752474182, 0.000924508087337017],
  ],
  [
    [118.484598769189, 24.792089754053, 0.000924433581531048],
    [118.484119420146, 24.7926643109017, 0.000924506224691868],
  ],
  [
    [118.484583033407, 24.7920788085565, 0.000924433581531048],
    [118.484103684333, 24.7926533653558, 0.000924505293369293],
  ],
  [
    [118.484567297637, 24.7920678720861, 0.000924430787563324],
    [118.484087948533, 24.7926424288359, 0.000924504362046719],
  ],
  [
    [118.48455156187, 24.7920569356139, 0.000924430787563324],
    [118.484072212735, 24.7926314923143, 0.000924502499401569],
  ],
  [
    [118.484535826096, 24.7920459901124, 0.000924428924918175],
    [118.48405647693, 24.7926205467633, 0.000924501568078995],
  ],
  [
    [118.484520090335, 24.7920350536369, 0.000924427062273026],
    [118.484040751027, 24.7926096102296, 0.00092450063675642],
  ],
  [
    [118.484504354576, 24.7920241171597, 0.000924427062273026],
    [118.484025015237, 24.7925986737029, 0.000924497842788696],
  ],
  [
    [118.4844886287, 24.7920131716442, 0.000924424268305302],
    [118.484009279441, 24.7925877281469, 0.000924496911466122],
  ],
  [
    [118.484472892947, 24.7920022351637, 0.000924424268305302],
    [118.483993543657, 24.7925767916169, 0.000924495980143547],
  ],
  [
    [118.484457157196, 24.7919912986814, 0.000924421474337578],
    [118.483977807875, 24.7925658550853, 0.000924494117498398],
  ],
  [
    [118.484441421439, 24.7919803531698, 0.000924419611692429],
    [118.483962072087, 24.7925549095242, 0.000924493186175823],
  ],
  [
    [118.484425685694, 24.7919694166842, 0.000924420543015003],
    [118.483946336311, 24.7925439729892, 0.000924492254853249],
  ],
  [
    [118.484409949942, 24.7919584711692, 0.000924418680369854],
    [118.483930600538, 24.7925330364525, 0.000924490392208099],
  ],
  [
    [118.484394214203, 24.7919475346803, 0.00092441588640213],
    [118.483914864758, 24.7925220908864, 0.00092448852956295],
  ],
  [
    [118.484378478466, 24.7919365981896, 0.000924414023756981],
    [118.48389912899, 24.7925111543463, 0.000924487598240376],
  ],
  [
    [118.484362742723, 24.7919256526696, 0.000924412161111832],
    [118.483883403115, 24.7925002177957, 0.000924486666917801],
  ],
  [
    [118.484347006992, 24.7919147161756, 0.000924411229789257],
    [118.483867667343, 24.7924892722246, 0.000924483872950077],
  ],
  [
    [118.484331281152, 24.791903779671, 0.000924411229789257],
    [118.483851931584, 24.7924783356795, 0.000924483872950077],
  ],
  [
    [118.484315545417, 24.7918928341459, 0.000924409367144108],
    [118.483836195818, 24.792467390105, 0.000924482010304928],
  ],
  [
    [118.484299809694, 24.7918818976469, 0.000924407504498959],
    [118.483820460064, 24.7924564535565, 0.000924480147659779],
  ],
  [
    [118.484284073974, 24.7918709611461, 0.000924407504498959],
    [118.483804724313, 24.7924455170063, 0.000924479216337204],
  ],
  [
    [118.484268338247, 24.791860015616, 0.000924405641853809],
    [118.483788988555, 24.7924345714268, 0.000924477353692055],
  ],
  [
    [118.484252602533, 24.7918490791119, 0.000924404710531235],
    [118.483773252809, 24.7924236348732, 0.000924475491046906],
  ],
  [
    [118.484236866821, 24.7918381426061, 0.000924402847886086],
    [118.483757517067, 24.792412698318, 0.00092447642236948],
  ],
  [
    [118.484221131102, 24.791827197071, 0.000924401916563511],
    [118.483741781317, 24.7924017527334, 0.000924473628401756],
  ],
  [
    [118.484205395396, 24.7918162605618, 0.000924400053918362],
    [118.48372604558, 24.7923908161749, 0.000924472697079182],
  ],
  [
    [118.484189659692, 24.791805324051, 0.000924397259950638],
    [118.483710319734, 24.7923798796058, 0.000924470834434032],
  ],
  [
    [118.484173933871, 24.7917943785019, 0.000924397259950638],
    [118.483694583993, 24.7923689340161, 0.000924469903111458],
  ],
  [
    [118.484158198173, 24.7917834419877, 0.000924396328628063],
    [118.483678848264, 24.7923579974525, 0.000924468040466309],
  ],
  [
    [118.484142462478, 24.7917725054718, 0.000924394465982914],
    [118.483663112538, 24.7923470608872, 0.000924466177821159],
  ],
  [
    [118.484126726776, 24.7917615599266, 0.000924394465982914],
    [118.483647376805, 24.7923361152925, 0.000924465246498585],
  ],
  [
    [118.484110991086, 24.7917506234073, 0.000924392603337765],
    [118.483631641084, 24.7923251787239, 0.000924463383853436],
  ],
  [
    [118.484095255399, 24.7917396868864, 0.000924389809370041],
    [118.483615905366, 24.7923142421535, 0.000924462452530861],
  ],
  [
    [118.484079519705, 24.7917287413361, 0.000924388878047466],
    [118.483600169641, 24.7923032965538, 0.000924461521208286],
  ],
  [
    [118.484063784023, 24.7917178048118, 0.000924387946724892],
    [118.483584433929, 24.7922923599801, 0.000924459658563137],
  ],
  [
    [118.484048048345, 24.7917068682859, 0.000924387015402317],
    [118.483568698219, 24.7922814234047, 0.000924458727240562],
  ],
  [
    [118.484032312659, 24.7916959227305, 0.000924385152757168],
    [118.483552972392, 24.7922704777911, 0.000924456864595413],
  ],
  [
    [118.484016586875, 24.7916849861923, 0.000924383290112019],
    [118.483537236687, 24.7922595412123, 0.000924456864595413],
  ],
  [
    [118.484000851195, 24.7916740406336, 0.000924381427466869],
    [118.483521500986, 24.7922486046319, 0.000924453139305115],
  ],
  [
    [118.483985115527, 24.7916631041009, 0.000924381427466869],
    [118.483505765278, 24.792237659022, 0.000924453139305115],
  ],
  [
    [118.483969379862, 24.7916521675665, 0.000924377702176571],
    [118.483490029582, 24.7922267224383, 0.000924451276659966],
  ],
  [
    [118.48395364419, 24.7916412220028, 0.000924376770853996],
    [118.483474293889, 24.7922157858528, 0.000924450345337391],
  ],
  [
    [118.483937908531, 24.791630285465, 0.000924375839531422],
    [118.483458558189, 24.7922048402379, 0.000924449414014816],
  ],
  [
    [118.483922172874, 24.7916193489256, 0.000924375839531422],
    [118.483442822501, 24.7921939036491, 0.000924446620047092],
  ],
  [
    [118.483906437211, 24.7916084033568, 0.000924374908208847],
    [118.483427086806, 24.7921829580308, 0.000924446620047092],
  ],
  [
    [118.483890701559, 24.791597466814, 0.000924373045563698],
    [118.483411351124, 24.7921720214386, 0.000924444757401943],
  ],
  [
    [118.483874965911, 24.7915865302696, 0.000924371182918549],
    [118.483395625334, 24.7921610848359, 0.000924443826079369],
  ],
  [
    [118.483859230256, 24.7915755846957, 0.000924368388950825],
    [118.483379889648, 24.7921501392126, 0.000924442894756794],
  ],
  [
    [118.483843504502, 24.791564648139, 0.00092436745762825],
    [118.483364153974, 24.7921392026154, 0.000924441963434219],
  ],
  [
    [118.483827768862, 24.7915537115895, 0.00092436745762825],
    [118.483348418303, 24.7921282660164, 0.00092444010078907],
  ],
  [
    [118.483812033215, 24.7915427660106, 0.000924366526305676],
    [118.483332682625, 24.7921173203881, 0.000924436375498772],
  ],
  [
    [118.48379629758, 24.7915318294578, 0.000924362801015377],
    [118.483316946959, 24.7921063837858, 0.000924435444176197],
  ],
  [
    [118.483780561948, 24.7915208929032, 0.000924362801015377],
    [118.483301211297, 24.7920954471818, 0.000924434512853622],
  ],
  [
    [118.48376482631, 24.7915099473193, 0.000924361869692802],
    [118.483285475627, 24.7920845015485, 0.000924433581531048],
  ],
  [
    [118.483749090683, 24.7914990107614, 0.000924359075725079],
    [118.483269739969, 24.7920735649411, 0.000924433581531048],
  ],
  [
    [118.48373335506, 24.7914880742018, 0.000924357213079929],
    [118.483254004315, 24.7920626283321, 0.000924430787563324],
  ],
  [
    [118.483717619429, 24.7914771286128, 0.000924357213079929],
    [118.483238278543, 24.7920516826849, 0.000924429856240749],
  ],
  [
    [118.483701883811, 24.7914661920498, 0.000924356281757355],
    [118.483222542894, 24.7920407460725, 0.000924428924918175],
  ],
  [
    [118.483686158085, 24.7914552554763, 0.000924354419112206],
    [118.483206807247, 24.7920298094584, 0.000924427062273026],
  ],
  [
    [118.483670422463, 24.7914443098823, 0.000924352556467056],
    [118.483191071594, 24.7920188638149, 0.000924425199627876],
  ],
  [
    [118.483654686853, 24.7914333733143, 0.000924351625144482],
    [118.483175335953, 24.7920079271975, 0.000924423336982727],
  ],
  [
    [118.483638951236, 24.7914224277169, 0.000924349762499332],
    [118.483159600315, 24.7919969905784, 0.000924422405660152],
  ],
  [
    [118.483623215632, 24.7914114911455, 0.000924348831176758],
    [118.48314386467, 24.7919860449299, 0.000924421474337578],
  ],
  [
    [118.48360748003, 24.7914005545724, 0.000924346968531609],
    [118.483128129038, 24.7919751083074, 0.000924420543015003],
  ],
  [
    [118.483591744422, 24.79138960897, 0.000924346037209034],
    [118.483112393408, 24.7919641716832, 0.000924418680369854],
  ],
  [
    [118.483576008826, 24.7913786723936, 0.000924345105886459],
    [118.483096657772, 24.7919532260297, 0.000924416817724705],
  ],
  [
    [118.483560273232, 24.7913677358155, 0.00092434324324131],
    [118.483080922147, 24.7919422894022, 0.000924414955079556],
  ],
  [
    [118.483544537632, 24.791356790208, 0.000924341380596161],
    [118.483065196415, 24.7919313527642, 0.00092441588640213],
  ],
  [
    [118.483528811934, 24.7913458536177, 0.000924340449273586],
    [118.483049460787, 24.7919204071056, 0.000924412161111832],
  ],
  [
    [118.483513076349, 24.7913349170346, 0.000924339517951012],
    [118.483033725171, 24.791909470473, 0.000924411229789257],
  ],
  [
    [118.483497340757, 24.791323971422, 0.000924338586628437],
    [118.483017989548, 24.791898524811, 0.000924410298466682],
  ],
  [
    [118.483481605177, 24.7913130348355, 0.000924336723983288],
    [118.483002253937, 24.7918875881751, 0.000924409367144108],
  ],
  [
    [118.4834658696, 24.7913020982473, 0.000924336723983288],
    [118.48298651833, 24.7918766515375, 0.000924408435821533],
  ],
  [
    [118.483450134017, 24.7912911526298, 0.000924333930015564],
    [118.482970782715, 24.7918657058705, 0.000924406573176384],
  ],
  [
    [118.483434398445, 24.7912802160382, 0.000924332998692989],
    [118.482955047113, 24.7918547692295, 0.000924404710531235],
  ],
  [
    [118.483418662877, 24.791269279445, 0.000924330204725266],
    [118.482939311514, 24.7918438325868, 0.000924402847886086],
  ],
  [
    [118.483402927302, 24.7912583338223, 0.000924329273402691],
    [118.482923575907, 24.7918328869148, 0.000924401916563511],
  ],
  [
    [118.483387191739, 24.7912473972257, 0.000924327410757542],
    [118.482907850203, 24.79182195026, 0.000924401916563511],
  ],
  [
    [118.483371466068, 24.7912364606186, 0.000924327410757542],
    [118.482892114611, 24.7918110136123, 0.000924400053918362],
  ],
  [
    [118.483355730501, 24.791225514991, 0.000924325548112392],
    [118.482876379013, 24.7918000679352, 0.000924397259950638],
  ],
  [
    [118.483339994946, 24.7912145783893, 0.000924323685467243],
    [118.482860643428, 24.7917891312841, 0.000924395397305489],
  ],
  [
    [118.483324259394, 24.791203641786, 0.000924321822822094],
    [118.482844907845, 24.7917781946314, 0.000924395397305489],
  ],
  [
    [118.483308523835, 24.7911926961533, 0.000924320891499519],
    [118.482829172255, 24.7917672489492, 0.000924393534660339],
  ],
  [
    [118.483292788289, 24.7911817595466, 0.000924320891499519],
    [118.482813436678, 24.7917563122931, 0.000924392603337765],
  ],
  [
    [118.483277052745, 24.7911708229382, 0.00092431902885437],
    [118.482797701103, 24.7917453756353, 0.000924392603337765],
  ],
  [
    [118.483261317194, 24.7911598773005, 0.000924318097531796],
    [118.482781965521, 24.7917344299481, 0.000924389809370041],
  ],
  [
    [118.483245581656, 24.7911489406887, 0.000924314372241497],
    [118.482766229952, 24.791723493287, 0.000924388878047466],
  ],
  [
    [118.483229846111, 24.7911379950476, 0.000924314372241497],
    [118.482750504275, 24.7917125566154, 0.000924387015402317],
  ],
  [
    [118.483214110579, 24.7911270584325, 0.000924312509596348],
    [118.482734768702, 24.7917016109231, 0.000924384221434593],
  ],
  [
    [118.483198384938, 24.791116121807, 0.000924311578273773],
    [118.482719033141, 24.7916906742569, 0.000924385152757168],
  ],
  [
    [118.483182649401, 24.7911051761608, 0.000924309715628624],
    [118.482703297583, 24.791679737589, 0.000924382358789444],
  ],
  [
    [118.483166913877, 24.7910942395406, 0.000924308784306049],
    [118.482687562018, 24.7916687918917, 0.000924381427466869],
  ],
  [
    [118.483151178355, 24.7910833029188, 0.000924308784306049],
    [118.482671826466, 24.7916578552205, 0.000924381427466869],
  ],
  [
    [118.483135442827, 24.7910723572676, 0.000924305059015751],
    [118.482656090906, 24.7916469095199, 0.00092437956482172],
  ],
  [
    [118.48311970731, 24.7910614206424, 0.000924304127693176],
    [118.482640355359, 24.7916359728452, 0.000924377702176571],
  ],
  [
    [118.483103971797, 24.7910504840155, 0.000924304127693176],
    [118.482624619815, 24.7916250361689, 0.000924375839531422],
  ],
  [
    [118.483088236277, 24.7910395383593, 0.000924303196370602],
    [118.482608884264, 24.7916140904633, 0.000924373976886272],
  ],
  [
    [118.483072500769, 24.7910286017291, 0.000924300402402878],
    [118.482593158614, 24.7916031537748, 0.000924374908208847],
  ],
  [
    [118.483056765264, 24.7910176650971, 0.000924299471080303],
    [118.482577423078, 24.7915922170935, 0.000924372114241123],
  ],
  [
    [118.483041039641, 24.791006719427, 0.000924298539757729],
    [118.482561687535, 24.7915812713828, 0.000924369320273399],
  ],
  [
    [118.483025304142, 24.7909957827918, 0.00092429481446743],
    [118.482545952005, 24.7915703346981, 0.000924369320273399],
  ],
  [
    [118.483009568645, 24.7909848461548, 0.00092429481446743],
    [118.482530216477, 24.7915593980117, 0.00092436745762825],
  ],
  [
    [118.482993833141, 24.7909739004885, 0.000924292951822281],
    [118.482514480942, 24.7915484522959, 0.000924365594983101],
  ],
  [
    [118.48297809765, 24.7909629638481, 0.000924292951822281],
    [118.48249874542, 24.7915375156062, 0.000924364663660526],
  ],
  [
    [118.482962362161, 24.7909520272061, 0.000924289226531982],
    [118.4824830099, 24.7915265789147, 0.000924361869692802],
  ],
  [
    [118.482946626666, 24.7909410815347, 0.000924290157854557],
    [118.482467274374, 24.7915156331939, 0.000924361869692802],
  ],
  [
    [118.482930891183, 24.7909301448894, 0.000924289226531982],
    [118.48245153886, 24.7915046964991, 0.000924360938370228],
  ],
  [
    [118.482915155702, 24.7909192082423, 0.000924288295209408],
    [118.482435803349, 24.7914937598026, 0.000924360007047653],
  ],
  [
    [118.482899420215, 24.7909082625659, 0.000924284569919109],
    [118.48242007772, 24.791482814068, 0.000924357213079929],
  ],
  [
    [118.48288369463, 24.7908973259067, 0.000924284569919109],
    [118.482404342214, 24.7914718773682, 0.000924357213079929],
  ],
  [
    [118.482867959158, 24.7908863892546, 0.000924283638596535],
    [118.482388606711, 24.7914609406667, 0.00092435535043478],
  ],
  [
    [118.482852223679, 24.7908754435731, 0.000924281775951386],
    [118.482372871201, 24.7914499949358, 0.00092435535043478],
  ],
  [
    [118.482836488212, 24.7908645069177, 0.000924279913306236],
    [118.482357135704, 24.7914390582309, 0.000924351625144482],
  ],
  [
    [118.482820752739, 24.7908535612328, 0.000924278981983662],
    [118.482341400209, 24.7914281215243, 0.000924349762499332],
  ],
  [
    [118.482805017278, 24.790842624574, 0.000924277119338512],
    [118.482325664708, 24.7914171757884, 0.000924348831176758],
  ],
  [
    [118.48278928182, 24.7908316879135, 0.000924276188015938],
    [118.482309929219, 24.7914062390784, 0.000924348831176758],
  ],
  [
    [118.482773546355, 24.7908207422236, 0.000924274325370789],
    [118.482294193732, 24.7913953023668, 0.000924346037209034],
  ],
  [
    [118.482757810902, 24.7908098055597, 0.000924274325370789],
    [118.482278458239, 24.7913843566258, 0.000924346037209034],
  ],
  [
    [118.482742075452, 24.7907988688942, 0.000924273394048214],
    [118.482262732647, 24.7913734199021, 0.000924344174563885],
  ],
  [
    [118.482726349884, 24.7907879231905, 0.000924269668757916],
    [118.482246997159, 24.7913624741578, 0.000924341380596161],
  ],
  [
    [118.48271061444, 24.7907769865216, 0.000924268737435341],
    [118.482231261684, 24.7913515374394, 0.000924340449273586],
  ],
  [
    [118.482694878998, 24.790766049851, 0.000924267806112766],
    [118.482215526211, 24.7913406007194, 0.000924340449273586],
  ],
  [
    [118.482679143549, 24.790755104151, 0.000924265943467617],
    [118.482199790732, 24.79132965497, 0.000924339517951012],
  ],
  [
    [118.482663408113, 24.790744167477, 0.000924265012145042],
    [118.482184055265, 24.7913187182466, 0.000924336723983288],
  ],
  [
    [118.48264767268, 24.7907332308014, 0.000924261286854744],
    [118.4821683198, 24.7913077815216, 0.000924335792660713],
  ],
  [
    [118.48263193724, 24.7907222850964, 0.000924262218177319],
    [118.482152584329, 24.7912968357671, 0.000924333930015564],
  ],
  [
    [118.482616201812, 24.7907113484174, 0.000924259424209595],
    [118.48213684887, 24.7912858990387, 0.000924333930015564],
  ],
  [
    [118.482600466387, 24.7907004117367, 0.000924259424209595],
    [118.482121113414, 24.7912749623086, 0.00092433113604784],
  ],
  [
    [118.482584730954, 24.7906894660266, 0.000924257561564446],
    [118.48210538784, 24.7912640165403, 0.000924330204725266],
  ],
  [
    [118.482568995535, 24.7906785293426, 0.000924254767596722],
    [118.48208965239, 24.7912530798069, 0.000924328342080116],
  ],
  [
    [118.482553270007, 24.7906675926481, 0.000924255698919296],
    [118.482073916942, 24.7912421430717, 0.000924327410757542],
  ],
  [
    [118.482537534583, 24.790656646933, 0.000924254767596722],
    [118.482058181487, 24.7912311973072, 0.000924324616789818],
  ],
  [
    [118.482521799172, 24.7906457102439, 0.000924251973628998],
    [118.482042446045, 24.7912202605687, 0.000924323685467243],
  ],
  [
    [118.482506063763, 24.7906347735531, 0.000924251973628998],
    [118.482026710605, 24.7912093238285, 0.000924323685467243],
  ],
  [
    [118.482490328348, 24.790623827833, 0.000924250110983849],
    [118.482010975159, 24.7911983780589, 0.000924321822822094],
  ],
  [
    [118.482474592945, 24.7906128911388, 0.000924248248338699],
    [118.481995239725, 24.7911874413153, 0.00092431902885437],
  ],
  [
    [118.482458857535, 24.7906019454153, 0.000924247317016125],
    [118.481979504294, 24.7911765045701, 0.000924319960176945],
  ],
  [
    [118.482443122137, 24.7905910087178, 0.000924244523048401],
    [118.481963768855, 24.7911655587954, 0.000924318097531796],
  ],
  [
    [118.482427386742, 24.7905800720186, 0.000924245454370975],
    [118.481948043319, 24.7911546220381, 0.000924318097531796],
  ],
  [
    [118.482411651341, 24.7905691262901, 0.000924242660403252],
    [118.481932307896, 24.7911436852878, 0.000924314372241497],
  ],
  [
    [118.482395925841, 24.7905581895788, 0.000924240797758102],
    [118.481916572466, 24.7911327395082, 0.000924313440918922],
  ],
  [
    [118.482380190454, 24.7905472528746, 0.000924239866435528],
    [118.481900837048, 24.7911218027545, 0.000924312509596348],
  ],
  [
    [118.482364455061, 24.790536307141, 0.000924238935112953],
    [118.481885101634, 24.7911108659992, 0.000924310646951199],
  ],
  [
    [118.482348719679, 24.7905253704334, 0.000924237072467804],
    [118.481869366212, 24.7910999202145, 0.000924309715628624],
  ],
  [
    [118.482332984301, 24.7905144337241, 0.000924236141145229],
    [118.481853630803, 24.7910889834558, 0.000924308784306049],
  ],
  [
    [118.482317248916, 24.7905034879854, 0.000924232415854931],
    [118.481837895387, 24.7910780376677, 0.000924305990338326],
  ],
  [
    [118.482301513543, 24.7904925512728, 0.000924232415854931],
    [118.481822159983, 24.7910671009056, 0.000924305059015751],
  ],
  [
    [118.482285778173, 24.7904816145585, 0.000924231484532356],
    [118.481806424582, 24.7910561641419, 0.000924305059015751],
  ],
  [
    [118.482270042796, 24.7904706688148, 0.000924229621887207],
    [118.481790689174, 24.7910452183488, 0.000924301333725452],
  ],
  [
    [118.482254307432, 24.7904597320971, 0.000924227759242058],
    [118.481774963668, 24.791034281573, 0.000924300402402878],
  ],
  [
    [118.482238581959, 24.790448795369, 0.000924226827919483],
    [118.481759228275, 24.7910233448042, 0.000924298539757729],
  ],
  [
    [118.482222846591, 24.7904378496203, 0.000924226827919483],
    [118.481743492876, 24.791012399006, 0.000924299471080303],
  ],
  [
    [118.482207111234, 24.7904269128976, 0.000924224965274334],
    [118.481727757489, 24.7910014622339, 0.000924296677112579],
  ],
  [
    [118.482191375881, 24.7904159761732, 0.000924224033951759],
    [118.481712022104, 24.79099052546, 0.000924295745790005],
  ],
  [
    [118.48217564052, 24.7904050304194, 0.000924221239984035],
    [118.481696286713, 24.7909795796568, 0.000924293883144856],
  ],
  [
    [118.482159905172, 24.7903940936916, 0.000924221239984035],
    [118.481680551334, 24.7909686428796, 0.000924292951822281],
  ],
  [
    [118.482144169827, 24.7903831569622, 0.000924218446016312],
    [118.481664815958, 24.7909577061008, 0.000924291089177132],
  ],
  [
    [118.482128434475, 24.7903722112033, 0.000924217514693737],
    [118.481649080575, 24.7909467602925, 0.000924291089177132],
  ],
  [
    [118.482112699135, 24.7903612744705, 0.000924215652048588],
    [118.481633345204, 24.7909358235102, 0.000924289226531982],
  ],
  [
    [118.482096963798, 24.790350337736, 0.000924215652048588],
    [118.481617619725, 24.7909248867176, 0.000924288295209408],
  ],
  [
    [118.482081238344, 24.7903393919634, 0.000924214720726013],
    [118.481601884351, 24.7909139409043, 0.000924286432564259],
  ],
  [
    [118.482065503012, 24.7903284552256, 0.000924211926758289],
    [118.481586148988, 24.7909030041171, 0.000924284569919109],
  ],
  [
    [118.482049767674, 24.7903175094583, 0.000924210995435715],
    [118.481570413629, 24.7908920673281, 0.00092428270727396],
  ],
  [
    [118.482034032348, 24.7903065727171, 0.000924208201467991],
    [118.481554678262, 24.7908811215098, 0.00092428270727396],
  ],
  [
    [118.482018297025, 24.7902956359742, 0.000924208201467991],
    [118.481538942908, 24.7908701847174, 0.000924278981983662],
  ],
  [
    [118.482002561695, 24.7902846902019, 0.000924207270145416],
    [118.481523207557, 24.7908592479234, 0.000924279913306236],
  ],
  [
    [118.481986826377, 24.7902737534557, 0.000924205407500267],
    [118.481507472198, 24.7908483021, 0.000924277119338512],
  ],
  [
    [118.481971091062, 24.7902628167077, 0.000924204476177692],
    [118.481491736853, 24.7908373653027, 0.000924276188015938],
  ],
  [
    [118.481955355741, 24.7902518709304, 0.000924202613532543],
    [118.4814760015, 24.7908264194759, 0.000924276188015938],
  ],
  [
    [118.481939620431, 24.7902409341791, 0.000924200750887394],
    [118.481460276049, 24.7908154826665, 0.000924273394048214],
  ],
  [
    [118.481923885125, 24.7902299974261, 0.000924200750887394],
    [118.481444540711, 24.7908045458641, 0.000924271531403065],
  ],
  [
    [118.4819081597, 24.790219051635, 0.00092419795691967],
    [118.481428805367, 24.7907936000323, 0.000924272462725639],
  ],
  [
    [118.481892424399, 24.7902081148786, 0.000924197025597095],
    [118.481413070035, 24.7907826632265, 0.000924269668757916],
  ],
  [
    [118.481876689101, 24.7901971781206, 0.000924196094274521],
    [118.481397334705, 24.790771726419, 0.000924267806112766],
  ],
  [
    [118.481860953796, 24.7901862323332, 0.000924196094274521],
    [118.481381599369, 24.7907607805822, 0.000924265943467617],
  ],
  [
    [118.481845218503, 24.7901752955718, 0.000924193300306797],
    [118.481365864045, 24.7907498437714, 0.000924265012145042],
  ],
  [
    [118.481829483213, 24.7901643588087, 0.000924191437661648],
    [118.481350128724, 24.7907389069589, 0.000924264080822468],
  ],
  [
    [118.481813747916, 24.7901534130162, 0.000924191437661648],
    [118.481334393397, 24.790727961117, 0.000924265012145042],
  ],
  [
    [118.481798012631, 24.7901424762498, 0.000924188643693924],
    [118.481318658081, 24.7907170243011, 0.000924261286854744],
  ],
  [
    [118.481782277349, 24.7901315394817, 0.0009241858497262],
    [118.481302932657, 24.7907060874749, 0.00092425849288702],
  ],
  [
    [118.481766542061, 24.7901205936842, 0.0009241858497262],
    [118.481287197338, 24.7906951416279, 0.000924257561564446],
  ],
  [
    [118.481750816673, 24.790109656904, 0.000924184918403625],
    [118.481271462031, 24.790684204807, 0.000924256630241871],
  ],
  [
    [118.4817350814, 24.7900987201308, 0.000924183055758476],
    [118.481255726726, 24.7906732679845, 0.000924255698919296],
  ],
  [
    [118.481719346119, 24.7900877743283, 0.000924181193113327],
    [118.481239991415, 24.7906623221325, 0.000924253836274147],
  ],
  [
    [118.481703610851, 24.7900768375517, 0.000924180261790752],
    [118.481224256116, 24.7906513853065, 0.000924252904951572],
  ],
  [
    [118.481687875586, 24.7900659007735, 0.000924180261790752],
    [118.481208520819, 24.7906404484789, 0.000924252904951572],
  ],
  [
    [118.481672140314, 24.7900549549659, 0.000924178399145603],
    [118.481192785516, 24.7906295026219, 0.000924250110983849],
  ],
  [
    [118.481656405054, 24.7900440181844, 0.000924176536500454],
    [118.481177050226, 24.7906185657909, 0.000924249179661274],
  ],
  [
    [118.481640669787, 24.7900330723734, 0.000924174673855305],
    [118.481161314938, 24.7906076289582, 0.000924249179661274],
  ],
  [
    [118.481624934533, 24.7900221355885, 0.000924174673855305],
    [118.481145579643, 24.7905966830961, 0.00092424638569355],
  ],
  [
    [118.481609199282, 24.7900111988019, 0.000924172811210155],
    [118.48112985425, 24.7905857462514, 0.000924245454370975],
  ],
  [
    [118.481593473912, 24.7900002529772, 0.000924171879887581],
    [118.48111411897, 24.7905748094137, 0.000924244523048401],
  ],
  [
    [118.481577738666, 24.7899893161872, 0.000924170017242432],
    [118.481098383683, 24.7905638635466, 0.000924241729080677],
  ],
  [
    [118.481562003423, 24.7899783793955, 0.000924169085919857],
    [118.481082648409, 24.7905529267055, 0.000924239866435528],
  ],
  [
    [118.481546268173, 24.7899674335745, 0.000924167223274708],
    [118.481066913128, 24.790541980835, 0.000924238935112953],
  ],
  [
    [118.481530532935, 24.7899564967794, 0.000924165360629559],
    [118.48105117786, 24.7905310439906, 0.000924237072467804],
  ],
  [
    [118.4815147977, 24.7899455599827, 0.000924164429306984],
    [118.481035442594, 24.7905201071444, 0.000924235209822655],
  ],
  [
    [118.481499062459, 24.7899346141566, 0.000924162566661835],
    [118.481019707321, 24.7905091612689, 0.000924236141145229],
  ],
  [
    [118.481483327229, 24.7899236773566, 0.000924160704016685],
    [118.48100397206, 24.7904982244194, 0.000924233347177505],
  ],
  [
    [118.481467592002, 24.7899127405548, 0.000924159772694111],
    [118.480988236803, 24.7904872875682, 0.000924230553209782],
  ],
  [
    [118.481451856769, 24.7899017947237, 0.000924158841371536],
    [118.480972511428, 24.790476341679, 0.000924230553209782],
  ],
  [
    [118.481436131437, 24.7898908579099, 0.000924156978726387],
    [118.480956776175, 24.7904654048245, 0.000924231484532356],
  ],
  [
    [118.481420396218, 24.7898799211031, 0.000924155116081238],
    [118.480941040926, 24.7904544679683, 0.000924227759242058],
  ],
  [
    [118.481404660993, 24.7898689752669, 0.000924155116081238],
    [118.48092530567, 24.7904435220827, 0.000924226827919483],
  ],
  [
    [118.48138892578, 24.7898580384568, 0.000924152322113514],
    [118.480909570426, 24.7904325852231, 0.000924224965274334],
  ],
  [
    [118.48137319057, 24.7898471016449, 0.000924150459468365],
    [118.480893835185, 24.7904216483618, 0.000924224033951759],
  ],
  [
    [118.481357455353, 24.7898361558037, 0.000924151390790939],
    [118.480878099937, 24.7904107024712, 0.00092422217130661],
  ],
  [
    [118.481341720148, 24.7898252189885, 0.00092414952814579],
    [118.480862364701, 24.7903997656065, 0.00092422217130661],
  ],
  [
    [118.481325984946, 24.7898142821716, 0.000924147665500641],
    [118.480846629468, 24.7903888287402, 0.000924220308661461],
  ],
  [
    [118.481310249738, 24.7898033363253, 0.000924145802855492],
    [118.480830894229, 24.7903778828445, 0.000924217514693737],
  ],
  [
    [118.481294514541, 24.7897923995051, 0.000924144871532917],
    [118.480815168891, 24.7903669459662, 0.000924217514693737],
  ],
  [
    [118.481278779338, 24.7897814536555, 0.000924142077565193],
    [118.480799433666, 24.7903560090949, 0.000924215652048588],
  ],
  [
    [118.481263054036, 24.7897705168232, 0.000924143008887768],
    [118.480783698435, 24.7903450631941, 0.000924213789403439],
  ],
  [
    [118.481247318848, 24.7897595799979, 0.000924140214920044],
    [118.480767963216, 24.7903341263194, 0.000924213789403439],
  ],
  [
    [118.481231583653, 24.7897486341432, 0.000924139283597469],
    [118.480752227999, 24.790323189443, 0.000924210995435715],
  ],
  [
    [118.481215848471, 24.7897376973146, 0.000924138352274895],
    [118.480736492776, 24.7903122435372, 0.00092421006411314],
  ],
  [
    [118.481200113291, 24.7897267604842, 0.000924135558307171],
    [118.480720757565, 24.7903013066575, 0.00092421006411314],
  ],
  [
    [118.481184378104, 24.7897158146245, 0.000924135558307171],
    [118.480705022357, 24.7902903697761, 0.000924208201467991],
  ],
  [
    [118.48116864293, 24.7897048777908, 0.000924133695662022],
    [118.480689287143, 24.7902794238652, 0.000924207270145416],
  ],
  [
    [118.481152907758, 24.7896939409554, 0.000924131833016872],
    [118.48067355194, 24.7902684869804, 0.000924203544855118],
  ],
  [
    [118.48113717258, 24.7896829950907, 0.000924129970371723],
    [118.48065782662, 24.7902575410576, 0.000924204476177692],
  ],
  [
    [118.481121437414, 24.7896720582519, 0.000924128107726574],
    [118.480642091423, 24.7902466041694, 0.000924202613532543],
  ],
  [
    [118.481105712139, 24.7896611214029, 0.000924129039049149],
    [118.480626356228, 24.7902356672796, 0.000924201682209969],
  ],
  [
    [118.481089976969, 24.789650175533, 0.000924127176403999],
    [118.480610621028, 24.7902247213603, 0.000924198888242245],
  ],
  [
    [118.481074241812, 24.7896392386892, 0.000924124382436275],
    [118.480594885839, 24.7902137844671, 0.000924198888242245],
  ],
  [
    [118.481058506656, 24.7896283018438, 0.00092412531375885],
    [118.480579150653, 24.7902028475722, 0.000924195162951946],
  ],
  [
    [118.481042771495, 24.7896173559689, 0.000924123451113701],
    [118.48056341546, 24.790191901648, 0.000924196094274521],
  ],
  [
    [118.481027036345, 24.7896064191201, 0.000924121588468552],
    [118.480547680279, 24.7901809647497, 0.000924193300306797],
  ],
  [
    [118.481011301198, 24.7895954822696, 0.000924120657145977],
    [118.480531945102, 24.7901700278498, 0.000924191437661648],
  ],
  [
    [118.480995566045, 24.7895845363897, 0.000924118794500828],
    [118.480516209917, 24.7901590819204, 0.000924190506339073],
  ],
  [
    [118.480979830903, 24.7895735995358, 0.000924116931855679],
    [118.480500474745, 24.7901481450172, 0.000924189575016499],
  ],
  [
    [118.480964095765, 24.7895626626803, 0.000924115069210529],
    [118.480484749465, 24.7901372081035, 0.000924187712371349],
  ],
  [
    [118.480948370509, 24.7895517167867, 0.000924114137887955],
    [118.480469014289, 24.7901262621692, 0.000924186781048775],
  ],
  [
    [118.480932635376, 24.7895407799278, 0.000924114137887955],
    [118.480453279125, 24.7901153252608, 0.000924183987081051],
  ],
  [
    [118.480916900245, 24.7895298430672, 0.000924111343920231],
    [118.480437543963, 24.7901043883508, 0.000924183987081051],
  ],
  [
    [118.480901165108, 24.7895188971772, 0.000924111343920231],
    [118.480421808795, 24.7900934424114, 0.000924183055758476],
  ],
  [
    [118.480885429984, 24.7895079603132, 0.000924109481275082],
    [118.48040607364, 24.790082505498, 0.000924181193113327],
  ],
  [
    [118.480869694852, 24.7894970144199, 0.000924108549952507],
    [118.480390338487, 24.790071568583, 0.000924179330468178],
  ],
  [
    [118.480853959733, 24.7894860775525, 0.000924106687307358],
    [118.480374603327, 24.7900606226385, 0.000924178399145603],
  ],
  [
    [118.480838224616, 24.7894751406835, 0.000924103893339634],
    [118.48035886818, 24.7900496857201, 0.000924176536500454],
  ],
  [
    [118.480822489493, 24.7894641947851, 0.000924103893339634],
    [118.480343133035, 24.7900387488, 0.000924176536500454],
  ],
  [
    [118.480806754382, 24.7894532579128, 0.000924102030694485],
    [118.480327407773, 24.7900278028419, 0.000924174673855305],
  ],
  [
    [118.480791029163, 24.7894423210301, 0.000924099236726761],
    [118.480311672634, 24.7900168659184, 0.000924172811210155],
  ],
  [
    [118.480775294048, 24.7894313751267, 0.000924100168049335],
    [118.480295937488, 24.7900059199655, 0.000924170017242432],
  ],
  [
    [118.480759558945, 24.7894204382492, 0.000924098305404186],
    [118.480280202354, 24.7899949830387, 0.000924170017242432],
  ],
  [
    [118.480743823845, 24.7894095013702, 0.000924096442759037],
    [118.480264467223, 24.7899840461102, 0.000924169085919857],
  ],
  [
    [118.480728088739, 24.7893985554617, 0.000924094580113888],
    [118.480248732086, 24.7899731001523, 0.000924168154597282],
  ],
  [
    [118.480712353644, 24.7893876185792, 0.000924093648791313],
    [118.48023299696, 24.7899621632204, 0.000924165360629559],
  ],
  [
    [118.480696618553, 24.7893766816951, 0.000924091786146164],
    [118.480217261838, 24.7899512262868, 0.000924164429306984],
  ],
  [
    [118.480680883454, 24.7893657357816, 0.000924091786146164],
    [118.480201526708, 24.7899402803239, 0.000924163497984409],
  ],
  [
    [118.480665148368, 24.7893547988941, 0.000924090854823589],
    [118.480185791591, 24.7899293433869, 0.000924162566661835],
  ],
  [
    [118.480649413285, 24.7893438620049, 0.00092408899217844],
    [118.480170066366, 24.7899184064397, 0.000924159772694111],
  ],
  [
    [118.480633678195, 24.7893329160863, 0.000924086198210716],
    [118.480154331245, 24.7899074604718, 0.000924158841371536],
  ],
  [
    [118.480617953006, 24.7893219791851, 0.000924085266888142],
    [118.480138596136, 24.7898965235298, 0.000924156978726387],
  ],
  [
    [118.48060221793, 24.7893110422909, 0.000924084335565567],
    [118.48012286103, 24.7898855865861, 0.000924156978726387],
  ],
  [
    [118.480586482849, 24.7893000963673, 0.000924081541597843],
    [118.480107125917, 24.7898746406131, 0.000924155116081238],
  ],
  [
    [118.480570747779, 24.7892891594697, 0.000924080610275269],
    [118.480091390817, 24.7898637036661, 0.000924154184758663],
  ],
  [
    [118.480555012712, 24.7892782225705, 0.000924080610275269],
    [118.480075655719, 24.7898527667174, 0.000924152322113514],
  ],
  [
    [118.480539277639, 24.7892672766418, 0.000924078747630119],
    [118.480059920614, 24.7898418207393, 0.00092414952814579],
  ],
  [
    [118.480523542577, 24.7892563397392, 0.00092407688498497],
    [118.480044185522, 24.7898308837873, 0.000924148596823215],
  ],
  [
    [118.480507807519, 24.7892454028349, 0.000924075022339821],
    [118.480028450432, 24.7898199468335, 0.000924148596823215],
  ],
  [
    [118.480492072453, 24.7892344569012, 0.000924074091017246],
    [118.480012725225, 24.7898090008418, 0.000924146734178066],
  ],
  [
    [118.4804763374, 24.7892235199935, 0.000924074091017246],
    [118.479996990141, 24.7897980638847, 0.000924145802855492],
  ],
  [
    [118.480460612229, 24.7892125740478, 0.000924071297049522],
    [118.47998125506, 24.7897871269259, 0.000924143940210342],
  ],
  [
    [118.480444877182, 24.7892016371368, 0.000924070365726948],
    [118.479965519972, 24.7897761809378, 0.000924142077565193],
  ],
  [
    [118.480429142137, 24.789190700224, 0.000924069434404373],
    [118.479949784896, 24.7897652439756, 0.000924142077565193],
  ],
  [
    [118.480413407085, 24.7891797542819, 0.000924067571759224],
    [118.479934049823, 24.7897543070118, 0.000924140214920044],
  ],
  [
    [118.480397672046, 24.7891688173659, 0.000924066640436649],
    [118.479918314744, 24.7897433610186, 0.000924139283597469],
  ],
  [
    [118.480381937009, 24.7891578804481, 0.0009240647777915],
    [118.479902579676, 24.7897324240514, 0.000924136489629745],
  ],
  [
    [118.480366201966, 24.789146934501, 0.000924062915146351],
    [118.479886844602, 24.7897214780548, 0.000924136489629745],
  ],
  [
    [118.480350466935, 24.7891359975798, 0.000924061983823776],
    [118.47987110954, 24.7897105410843, 0.000924134626984596],
  ],
  [
    [118.480334731907, 24.789125060657, 0.000924060121178627],
    [118.479855374481, 24.789699604112, 0.000924133695662022],
  ],
  [
    [118.480318996872, 24.7891141147048, 0.000924059189856052],
    [118.479839649304, 24.7896886581018, 0.000924131833016872],
  ],
  [
    [118.480303271738, 24.7891031777701, 0.000924057327210903],
    [118.47982391425, 24.7896777211263, 0.000924129039049149],
  ],
  [
    [118.480287536718, 24.7890922408422, 0.000924055464565754],
    [118.479808179199, 24.789666784149, 0.000924128107726574],
  ],
  [
    [118.480271801691, 24.789081294885, 0.000924055464565754],
    [118.479792444141, 24.7896558381423, 0.000924127176403999],
  ],
  [
    [118.480256066677, 24.7890703579538, 0.000924053601920605],
    [118.479776709096, 24.7896449011617, 0.000924126245081425],
  ],
  [
    [118.480240331665, 24.7890594210209, 0.00092405267059803],
    [118.479760974053, 24.7896339641794, 0.00092412531375885],
  ],
  [
    [118.480224596647, 24.7890484750586, 0.000924049876630306],
    [118.479745239004, 24.7896230181677, 0.000924123451113701],
  ],
  [
    [118.48020886164, 24.7890375381223, 0.000924049876630306],
    [118.479729503967, 24.789612081182, 0.000924121588468552],
  ],
  [
    [118.480193126637, 24.7890266011844, 0.000924048013985157],
    [118.479713768932, 24.7896011441946, 0.000924122519791126],
  ],
  [
    [118.480177391627, 24.7890156552171, 0.000924044288694859],
    [118.479698033891, 24.7895901981779, 0.000924119725823402],
  ],
  [
    [118.480161656629, 24.7890047182758, 0.000924047082662582],
    [118.479682308751, 24.7895792611786, 0.000924117863178253],
  ],
  [
    [118.480145931523, 24.7889937813242, 0.000924044288694859],
    [118.479666573725, 24.7895683241862, 0.000924116000533104],
  ],
  [
    [118.480130196521, 24.7889828353518, 0.000924041494727135],
    [118.479650838692, 24.7895573781644, 0.000924115069210529],
  ],
  [
    [118.480114461531, 24.7889718984055, 0.000924041494727135],
    [118.479635103672, 24.7895464411686, 0.00092411320656538],
  ],
  [
    [118.480098726535, 24.7889609524298, 0.00092404056340456],
    [118.479619368654, 24.7895355041712, 0.000924112275242805],
  ],
  [
    [118.48008299155, 24.7889500154801, 0.000924038700759411],
    [118.479603633629, 24.7895245581443, 0.000924111343920231],
  ],
  [
    [118.480067256569, 24.7889390785287, 0.000924039632081985],
    [118.479587898617, 24.7895136211435, 0.000924110412597656],
  ],
  [
    [118.480051521581, 24.7889281325479, 0.000924035906791687],
    [118.479572163607, 24.789502684141, 0.000924107618629932],
  ],
  [
    [118.480035786605, 24.7889171955931, 0.000924034975469112],
    [118.479556428591, 24.7894917381091, 0.000924107618629932],
  ],
  [
    [118.480020051632, 24.7889062586367, 0.000924033112823963],
    [118.479540693587, 24.7894808011033, 0.000924104824662209],
  ],
  [
    [118.480004316652, 24.7888953126509, 0.000924031250178814],
    [118.479524968475, 24.7894698640872, 0.000924104824662209],
  ],
  [
    [118.479988581684, 24.7888843756911, 0.000924030318856239],
    [118.479509233467, 24.7894589180503, 0.000924102962017059],
  ],
  [
    [118.479972856608, 24.788873438721, 0.000924029387533665],
    [118.479493498471, 24.7894479810394, 0.000924102962017059],
  ],
  [
    [118.479957121637, 24.7888624927302, 0.000924026593565941],
    [118.479477763468, 24.7894370349991, 0.000924099236726761],
  ],
  [
    [118.479941386677, 24.7888515557653, 0.000924025662243366],
    [118.479462028478, 24.7894260979848, 0.000924098305404186],
  ],
  [
    [118.479925651721, 24.7888406187988, 0.000924024730920792],
    [118.47944629349, 24.7894151609689, 0.000924096442759037],
  ],
  [
    [118.479909916757, 24.7888296728029, 0.000924023799598217],
    [118.479430558496, 24.7894042149236, 0.000924096442759037],
  ],
  [
    [118.479894181806, 24.788818735833, 0.000924023799598217],
    [118.479414823514, 24.7893932779043, 0.000924093648791313],
  ],
  [
    [118.479878446858, 24.7888077988615, 0.000924021005630493],
    [118.479399088535, 24.7893823408833, 0.000924093648791313],
  ],
  [
    [118.479862711903, 24.7887968528605, 0.000924020074307919],
    [118.479383353549, 24.7893713948329, 0.000924090854823589],
  ],
  [
    [118.47984697696, 24.7887859158856, 0.000924019142985344],
    [118.479367628464, 24.7893604578, 0.000924089923501015],
  ],
  [
    [118.47983124202, 24.788774978909, 0.000924015417695045],
    [118.479351893493, 24.789349520774, 0.000924088060855865],
  ],
  [
    [118.479815516962, 24.7887640328945, 0.00092401634901762],
    [118.479336158515, 24.7893385747186, 0.000924087129533291],
  ],
  [
    [118.479799782027, 24.7887530959145, 0.000924013555049896],
    [118.47932042355, 24.7893276376892, 0.000924086198210716],
  ],
  [
    [118.479784047095, 24.7887421589329, 0.000924013555049896],
    [118.479304688587, 24.7893167006581, 0.000924083404242992],
  ],
  [
    [118.479768312157, 24.7887312129218, 0.000924010761082172],
    [118.479288953618, 24.7893057545977, 0.000924083404242992],
  ],
  [
    [118.479752577231, 24.7887202759368, 0.000924010761082172],
    [118.47927321866, 24.7892948175632, 0.000924081541597843],
  ],
  [
    [118.479736842307, 24.7887093389501, 0.000924006104469299],
    [118.479257483706, 24.7892838805271, 0.000924080610275269],
  ],
  [
    [118.479721107377, 24.788698392934, 0.000924007035791874],
    [118.479241748745, 24.7892729344616, 0.000924078747630119],
  ],
  [
    [118.479705372459, 24.788687455944, 0.000924005173146725],
    [118.479226013796, 24.7892619974221, 0.000924078747630119],
  ],
  [
    [118.479689637534, 24.7886765099245, 0.000924005173146725],
    [118.479210278849, 24.789251060381, 0.00092407688498497],
  ],
  [
    [118.479673902622, 24.7886655729311, 0.000924002379179001],
    [118.479194553786, 24.7892401143019, 0.000924075022339821],
  ],
  [
    [118.479658177601, 24.7886546359275, 0.000924001447856426],
    [118.479178818845, 24.7892291772574, 0.000924072228372097],
  ],
  [
    [118.479642442684, 24.788643689903, 0.000923999585211277],
    [118.479163083907, 24.7892182402112, 0.000924073159694672],
  ],
  [
    [118.47962670778, 24.7886327529045, 0.000923998653888702],
    [118.479147348962, 24.7892072941356, 0.000924071297049522],
  ],
  [
    [118.479610972878, 24.7886218159044, 0.000923996791243553],
    [118.47913161403, 24.789196357086, 0.000924069434404373],
  ],
  [
    [118.47959523797, 24.7886108698748, 0.000923994928598404],
    [118.479115879091, 24.7891854110071, 0.000924067571759224],
  ],
  [
    [118.479579503074, 24.7885999328714, 0.000923994928598404],
    [118.479100144164, 24.7891744739541, 0.000924067571759224],
  ],
  [
    [118.479563768181, 24.7885889958662, 0.00092399213463068],
    [118.47908440924, 24.7891635368995, 0.000924065709114075],
  ],
  [
    [118.479548033281, 24.7885780498316, 0.00092399213463068],
    [118.479068674309, 24.7891525908155, 0.000924063846468925],
  ],
  [
    [118.479532298393, 24.7885671128231, 0.000923990271985531],
    [118.47905293939, 24.7891416537576, 0.000924061052501202],
  ],
  [
    [118.479516563508, 24.7885561758128, 0.000923989340662956],
    [118.479037214363, 24.7891307166894, 0.000924061983823776],
  ],
  [
    [118.479500838506, 24.7885452297647, 0.000923985615372658],
    [118.479021479441, 24.7891197706003, 0.000924060121178627],
  ],
  [
    [118.479485103626, 24.7885342927511, 0.000923986546695232],
    [118.47900574453, 24.7891088335373, 0.000924057327210903],
  ],
  [
    [118.47946936875, 24.7885233557358, 0.000923984684050083],
    [118.478990009623, 24.7890978964726, 0.000924056395888329],
  ],
  [
    [118.479453633866, 24.7885124096911, 0.000923983752727509],
    [118.478974274708, 24.7890869503786, 0.000924055464565754],
  ],
  [
    [118.479437898995, 24.7885014726725, 0.000923981890082359],
    [118.478958539806, 24.7890760133105, 0.000924053601920605],
  ],
  [
    [118.479422164127, 24.7884905356522, 0.00092398002743721],
    [118.478942804907, 24.7890650762408, 0.000924053601920605],
  ],
  [
    [118.479406429251, 24.7884795896025, 0.000923979096114635],
    [118.478927070001, 24.7890541301416, 0.000924053601920605],
  ],
  [
    [118.479390694388, 24.7884686525788, 0.000923977233469486],
    [118.478911335107, 24.7890431930685, 0.000924050807952881],
  ],
  [
    [118.479374959528, 24.7884577155535, 0.000923976302146912],
    [118.478895600216, 24.7890322559938, 0.000924048945307732],
  ],
  [
    [118.479359224661, 24.7884467694987, 0.000923975370824337],
    [118.478879875207, 24.7890213098811, 0.000924048013985157],
  ],
  [
    [118.479343489807, 24.78843583247, 0.000923974439501762],
    [118.478864140322, 24.7890103728029, 0.000924046151340008],
  ],
  [
    [118.479327764844, 24.7884248954311, 0.000923971645534039],
    [118.478848405439, 24.7889994357231, 0.000924044288694859],
  ],
  [
    [118.479312029985, 24.7884139493713, 0.000923970714211464],
    [118.478832670549, 24.7889884896139, 0.000924043357372284],
  ],
  [
    [118.479296295139, 24.7884030123375, 0.000923968851566315],
    [118.478816935672, 24.7889775525307, 0.000924041494727135],
  ],
  [
    [118.479280560286, 24.7883920662744, 0.000923966988921165],
    [118.478801200797, 24.7889666154459, 0.000924039632081985],
  ],
  [
    [118.479264825445, 24.7883811292372, 0.000923966988921165],
    [118.478785465916, 24.7889556693316, 0.000924039632081985],
  ],
  [
    [118.479249090607, 24.7883701921984, 0.000923966057598591],
    [118.478769731047, 24.7889447322434, 0.000924037769436836],
  ],
  [
    [118.479233355762, 24.7883592461302, 0.000923964194953442],
    [118.478753996181, 24.7889337951535, 0.000924035906791687],
  ],
  [
    [118.479217620929, 24.7883483090881, 0.000923963263630867],
    [118.478738261308, 24.7889228490342, 0.000924034975469112],
  ],
  [
    [118.4792018861, 24.7883373720442, 0.000923960469663143],
    [118.478722536336, 24.7889119119324, 0.000924033112823963],
  ],
  [
    [118.479186151263, 24.788326425971, 0.000923959538340569],
    [118.478706801469, 24.7889009658097, 0.000924033112823963],
  ],
  [
    [118.479170426328, 24.7883154889153, 0.000923959538340569],
    [118.478691066613, 24.7888900287131, 0.000924030318856239],
  ],
  [
    [118.479154691506, 24.7883045518664, 0.000923957675695419],
    [118.478675331761, 24.7888790916148, 0.000924030318856239],
  ],
  [
    [118.479138956678, 24.7882936057881, 0.000923956744372845],
    [118.478659596902, 24.7888681454871, 0.00092402845621109],
  ],
  [
    [118.479123221862, 24.7882826687358, 0.000923953950405121],
    [118.478643862055, 24.7888572083854, 0.000924026593565941],
  ],
  [
    [118.479107487048, 24.7882717316819, 0.000923953019082546],
    [118.47862812721, 24.788846271282, 0.000924025662243366],
  ],
  [
    [118.479091752228, 24.7882607855986, 0.000923951156437397],
    [118.47861239236, 24.7888353251493, 0.000924023799598217],
  ],
  [
    [118.479076017421, 24.7882498485413, 0.000923950225114822],
    [118.478596657521, 24.7888243880426, 0.000924023799598217],
  ],
  [
    [118.479060282616, 24.7882389114823, 0.000923949293792248],
    [118.478580922685, 24.7888134509342, 0.000924021005630493],
  ],
  [
    [118.479044547804, 24.7882279653939, 0.000923948362469673],
    [118.478565187842, 24.7888025047964, 0.000924020074307919],
  ],
  [
    [118.479028813004, 24.7882170283316, 0.000923947431147099],
    [118.478549462901, 24.7887915676761, 0.000924019142985344],
  ],
  [
    [118.479013088096, 24.7882060912591, 0.000923945568501949],
    [118.478533728073, 24.7887806305627, 0.000924017280340195],
  ],
  [
    [118.478997353293, 24.7881951451657, 0.0009239437058568],
    [118.478517993239, 24.7887696844198, 0.000924015417695045],
  ],
  [
    [118.478981618502, 24.7881842080983, 0.000923941843211651],
    [118.478502258417, 24.788758747303, 0.000924014486372471],
  ],
  [
    [118.478965883713, 24.7881732710292, 0.000923940911889076],
    [118.478486523597, 24.7887478101846, 0.000924011692404747],
  ],
  [
    [118.478950148918, 24.7881623249308, 0.000923939049243927],
    [118.478470788771, 24.7887368640367, 0.000924012623727322],
  ],
  [
    [118.478934414135, 24.7881513878583, 0.000923937186598778],
    [118.478455053957, 24.7887259269148, 0.000924009829759598],
  ],
  [
    [118.478918679345, 24.7881404417565, 0.000923936255276203],
    [118.478439319146, 24.7887149897913, 0.000924008898437023],
  ],
  [
    [118.478902944568, 24.7881295046807, 0.000923934392631054],
    [118.478423584328, 24.7887040436384, 0.000924007035791874],
  ],
  [
    [118.478887209793, 24.7881185676033, 0.000923932529985905],
    [118.478407849522, 24.7886931065115, 0.000924006104469299],
  ],
  [
    [118.478871475012, 24.7881076214964, 0.00092393159866333],
    [118.478392124608, 24.7886821693744, 0.000924005173146725],
  ],
  [
    [118.478855750131, 24.7880966844071, 0.00092393159866333],
    [118.478376389799, 24.7886712232165, 0.000924002379179001],
  ],
  [
    [118.478840015365, 24.7880857473246, 0.000923928804695606],
    [118.478360655002, 24.7886602860845, 0.000924003310501575],
  ],
  [
    [118.478824280592, 24.7880748012127, 0.000923928804695606],
    [118.478344920207, 24.7886493489509, 0.000923999585211277],
  ],
  [
    [118.478808545831, 24.7880638641268, 0.000923927873373032],
    [118.478329185406, 24.7886384027879, 0.000923999585211277],
  ],
  [
    [118.478792811073, 24.7880529270392, 0.000923925079405308],
    [118.478313450617, 24.7886274656509, 0.000923998653888702],
  ],
  [
    [118.478777076308, 24.7880419809223, 0.000923924148082733],
    [118.478297715821, 24.7886165194846, 0.000923995859920979],
  ],
  [
    [118.478761341555, 24.7880310438314, 0.000923923216760159],
    [118.478281981037, 24.7886055823442, 0.000923995859920979],
  ],
  [
    [118.478745606805, 24.7880201067388, 0.000923920422792435],
    [118.478266246256, 24.7885946452022, 0.000923993065953255],
  ],
  [
    [118.478729872049, 24.7880091606168, 0.00092391949146986],
    [118.478250511469, 24.7885836990308, 0.000923993997275829],
  ],
  [
    [118.478714137304, 24.7879982235208, 0.000923918560147285],
    [118.478234786582, 24.7885727618769, 0.000923991203308105],
  ],
  [
    [118.478698402563, 24.7879872864232, 0.000923914834856987],
    [118.47821905181, 24.7885618247299, 0.000923988409340382],
  ],
  [
    [118.478682677703, 24.7879763402877, 0.000923915766179562],
    [118.478203317031, 24.7885508785534, 0.000923987478017807],
  ],
  [
    [118.478666942967, 24.7879654031867, 0.000923913903534412],
    [118.478187582264, 24.788539941403, 0.000923987478017807],
  ],
  [
    [118.478651208234, 24.787954466084, 0.000923912040889263],
    [118.478171847499, 24.7885290042509, 0.000923985615372658],
  ],
  [
    [118.478635473494, 24.7879435199519, 0.000923912040889263],
    [118.478156112728, 24.7885180580694, 0.000923982821404934],
  ],
  [
    [118.478619738766, 24.7879325828459, 0.000923909246921539],
    [118.47814037797, 24.7885071209139, 0.000923981890082359],
  ],
  [
    [118.478604004041, 24.7879216457381, 0.000923909246921539],
    [118.478124643213, 24.7884961837568, 0.000923980958759785],
  ],
  [
    [118.478588269309, 24.787910699601, 0.00092390738427639],
    [118.478108908451, 24.7884852375702, 0.000923980958759785],
  ],
  [
    [118.478572534589, 24.7878997624899, 0.000923906452953815],
    [118.4780931737, 24.7884743004097, 0.000923978164792061],
  ],
  [
    [118.478556799872, 24.7878888253772, 0.000923905521631241],
    [118.478077448841, 24.7884633632391, 0.000923977233469486],
  ],
  [
    [118.478541065149, 24.787877879235, 0.000923902727663517],
    [118.478061714087, 24.7884524170475, 0.000923975370824337],
  ],
  [
    [118.478525340326, 24.7878669421104, 0.000923901796340942],
    [118.478045979345, 24.7884414798819, 0.000923973508179188],
  ],
  [
    [118.478509605608, 24.7878559959649, 0.000923899933695793],
    [118.478030244605, 24.7884305427147, 0.000923973508179188],
  ],
  [
    [118.478493870903, 24.7878450588454, 0.000923899002373219],
    [118.478014509859, 24.7884195965181, 0.000923972576856613],
  ],
  [
    [118.478478136199, 24.7878341217242, 0.000923898071050644],
    [118.477998775125, 24.7884086593475, 0.000923968851566315],
  ],
  [
    [118.47846240149, 24.7878231755736, 0.000923897139728069],
    [118.477983040394, 24.7883977221752, 0.000923968851566315],
  ],
  [
    [118.478446666792, 24.7878122384491, 0.00092389527708292],
    [118.477967305656, 24.7883867759735, 0.000923966988921165],
  ],
  [
    [118.478430932097, 24.7878013013229, 0.00092389527708292],
    [118.47795157093, 24.7883758387979, 0.000923966057598591],
  ],
  [
    [118.478415197396, 24.7877903551673, 0.000923892483115196],
    [118.477935836198, 24.7883648925929, 0.000923965126276016],
  ],
  [
    [118.478399462707, 24.7877794180377, 0.000923889689147472],
    [118.477920101478, 24.7883539554139, 0.000923963263630867],
  ],
  [
    [118.47838372802, 24.7877684809065, 0.000923889689147472],
    [118.477904376649, 24.7883430182247, 0.000923961400985718],
  ],
  [
    [118.478368003216, 24.7877575347373, 0.000923888757824898],
    [118.477888641925, 24.7883320720147, 0.000923960469663143],
  ],
  [
    [118.478352268535, 24.7877465976027, 0.000923885963857174],
    [118.477872907213, 24.7883211348306, 0.000923958607017994],
  ],
  [
    [118.478336533856, 24.7877356604664, 0.000923885963857174],
    [118.477857172504, 24.7883101976449, 0.000923956744372845],
  ],
  [
    [118.478320799172, 24.7877247143007, 0.00092388316988945],
    [118.477841437788, 24.7882992514298, 0.000923956744372845],
  ],
  [
    [118.478305064499, 24.7877137771611, 0.00092388316988945],
    [118.477825703084, 24.7882883142407, 0.000923954881727695],
  ],
  [
    [118.478289329829, 24.7877028400197, 0.000923881307244301],
    [118.477809968383, 24.7882773770499, 0.000923953950405121],
  ],
  [
    [118.478273595152, 24.787691893849, 0.000923878513276577],
    [118.477794233676, 24.7882664308298, 0.000923952087759972],
  ],
  [
    [118.478257860488, 24.7876809567043, 0.000923879444599152],
    [118.477778498981, 24.7882554936356, 0.000923950225114822],
  ],
  [
    [118.478242125826, 24.7876700195579, 0.000923877581954002],
    [118.477762764288, 24.7882445564398, 0.000923949293792248],
  ],
  [
    [118.478226391158, 24.7876590733821, 0.000923874787986279],
    [118.477747039478, 24.7882336102062, 0.000923947431147099],
  ],
  [
    [118.47821066639, 24.7876481362239, 0.000923872925341129],
    [118.47773130479, 24.788222673007, 0.000923946499824524],
  ],
  [
    [118.478194931737, 24.7876371990725, 0.000923871994018555],
    [118.477715570106, 24.7882117358062, 0.000923944637179375],
  ],
  [
    [118.478179197077, 24.7876262528916, 0.000923870131373405],
    [118.477699835415, 24.7882007895759, 0.000923944637179375],
  ],
  [
    [118.478163462429, 24.7876153157369, 0.00092387106269598],
    [118.477684100736, 24.7881898523717, 0.000923942774534225],
  ],
  [
    [118.478147727774, 24.7876043695527, 0.000923870131373405],
    [118.47766836606, 24.7881789151658, 0.000923940911889076],
  ],
  [
    [118.478131993132, 24.7875934323945, 0.000923867337405682],
    [118.477652631377, 24.7881679689305, 0.000923939980566502],
  ],
  [
    [118.478116258492, 24.7875824952347, 0.000923864543437958],
    [118.477636896707, 24.7881570317213, 0.000923937186598778],
  ],
  [
    [118.478100523846, 24.7875715490455, 0.000923863612115383],
    [118.477621162039, 24.7881460945103, 0.000923936255276203],
  ],
  [
    [118.478084789211, 24.7875606118823, 0.000923862680792809],
    [118.477605427364, 24.78813514827, 0.000923936255276203],
  ],
  [
    [118.47806905458, 24.7875496747174, 0.000923860818147659],
    [118.477589702591, 24.7881242110473, 0.000923933461308479],
  ],
  [
    [118.478053319942, 24.7875387285231, 0.000923859886825085],
    [118.477573967931, 24.7881132738313, 0.000923933461308479],
  ],
  [
    [118.478037595205, 24.7875277913464, 0.000923859886825085],
    [118.477558233265, 24.7881023275859, 0.00092393159866333],
  ],
  [
    [118.478021860582, 24.7875168541765, 0.000923857092857361],
    [118.477542498611, 24.7880913903666, 0.000923929736018181],
  ],
  [
    [118.478006125952, 24.7875059079772, 0.000923856161534786],
    [118.47752676395, 24.7880804441178, 0.000923927873373032],
  ],
  [
    [118.477990391334, 24.7874949708039, 0.000923855230212212],
    [118.477511029302, 24.7880695068951, 0.000923926942050457],
  ],
  [
    [118.477974656719, 24.787484033629, 0.000923852436244488],
    [118.477495294656, 24.7880585696708, 0.000923924148082733],
  ],
  [
    [118.477958922098, 24.7874730874246, 0.000923851504921913],
    [118.477479560004, 24.788047623417, 0.000923924148082733],
  ],
  [
    [118.477943187489, 24.7874621502463, 0.000923852436244488],
    [118.477463825363, 24.7880366861892, 0.000923924148082733],
  ],
  [
    [118.477927452882, 24.7874512130663, 0.000923849642276764],
    [118.477448090726, 24.7880257489598, 0.000923921354115009],
  ],
  [
    [118.477911718269, 24.7874402668569, 0.000923848710954189],
    [118.477432365971, 24.7880148026926, 0.00092391949146986],
  ],
  [
    [118.477895983668, 24.7874293296735, 0.000923847779631615],
    [118.477416631339, 24.7880038654598, 0.00092391949146986],
  ],
  [
    [118.477880258958, 24.78741839248, 0.000923845916986465],
    [118.477400896709, 24.7879929282253, 0.000923916697502136],
  ],
  [
    [118.477864524353, 24.7874074462656, 0.000923843123018742],
    [118.477385162073, 24.7879819819614, 0.000923916697502136],
  ],
  [
    [118.47784878976, 24.7873965090772, 0.000923842191696167],
    [118.47736942745, 24.7879710447236, 0.000923915766179562],
  ],
  [
    [118.47783305517, 24.7873855718871, 0.000923840329051018],
    [118.477353692829, 24.7879601074841, 0.000923913903534412],
  ],
  [
    [118.477817320574, 24.7873746256676, 0.000923841260373592],
    [118.477337958201, 24.7879491612152, 0.000923912040889263],
  ],
  [
    [118.477801585989, 24.7873636884742, 0.000923838466405869],
    [118.477322223585, 24.7879382239723, 0.000923910178244114],
  ],
  [
    [118.477785851407, 24.787352751279, 0.000923837535083294],
    [118.477306488973, 24.7879272867278, 0.000923909246921539],
  ],
  [
    [118.477770116819, 24.7873418050545, 0.000923836603760719],
    [118.477290754353, 24.7879163404538, 0.000923908315598965],
  ],
  [
    [118.477754382242, 24.787330867856, 0.00092383474111557],
    [118.477275019746, 24.7879054032059, 0.000923906452953815],
  ],
  [
    [118.47773864766, 24.7873199216281, 0.000923831947147846],
    [118.477259295031, 24.7878944659479, 0.000923905521631241],
  ],
  [
    [118.477722922978, 24.7873089844178, 0.000923832878470421],
    [118.47724356042, 24.7878835196689, 0.000923903658986092],
  ],
  [
    [118.477707188409, 24.7872980472143, 0.000923829153180122],
    [118.477227825821, 24.787872582416, 0.000923902727663517],
  ],
  [
    [118.477691453835, 24.7872871009814, 0.000923827290534973],
    [118.477212091224, 24.7878616451613, 0.000923900865018368],
  ],
  [
    [118.477675719272, 24.7872761637745, 0.000923827290534973],
    [118.477196356622, 24.7878506988773, 0.000923899933695793],
  ],
  [
    [118.477659984713, 24.7872652265659, 0.000923825427889824],
    [118.477180622031, 24.7878397616193, 0.000923899002373219],
  ],
  [
    [118.477644250146, 24.7872542803279, 0.000923824496567249],
    [118.477164887443, 24.7878288243596, 0.000923898071050644],
  ],
  [
    [118.477628515592, 24.787243343116, 0.000923823565244675],
    [118.477149152849, 24.7878178780705, 0.00092389527708292],
  ],
  [
    [118.47761278104, 24.7872324059024, 0.000923820771276951],
    [118.477133418266, 24.7878069408075, 0.00092389527708292],
  ],
  [
    [118.477597046482, 24.7872214596594, 0.000923818908631802],
    [118.477117683677, 24.7877959945151, 0.000923893414437771],
  ],
  [
    [118.477581311936, 24.7872105224424, 0.000923818908631802],
    [118.477101958989, 24.7877850572402, 0.000923891551792622],
  ],
  [
    [118.477565587282, 24.7871995852153, 0.000923817977309227],
    [118.477086224415, 24.7877741199722, 0.000923889689147472],
  ],
  [
    [118.477549852732, 24.7871886389672, 0.000923816114664078],
    [118.477070489834, 24.7877631736747, 0.000923888757824898],
  ],
  [
    [118.477534118194, 24.7871777017452, 0.000923814252018929],
    [118.477054755266, 24.7877522364032, 0.000923886895179749],
  ],
  [
    [118.477518383659, 24.7871667645215, 0.000923812389373779],
    [118.4770390207, 24.7877412991301, 0.000923886895179749],
  ],
  [
    [118.477502649118, 24.7871558182684, 0.000923813320696354],
    [118.477023286127, 24.7877303528276, 0.000923884101212025],
  ],
  [
    [118.477486914588, 24.7871448810414, 0.000923809595406055],
    [118.477007551567, 24.7877194155511, 0.00092388316988945],
  ],
  [
    [118.477471180062, 24.7871339438126, 0.000923808664083481],
    [118.476991817009, 24.7877084782729, 0.000923882238566875],
  ],
  [
    [118.477455445528, 24.7871229975545, 0.000923806801438332],
    [118.476976082445, 24.7876975319654, 0.000923880375921726],
  ],
  [
    [118.477439711007, 24.7871120603224, 0.000923807732760906],
    [118.476960347893, 24.7876865946838, 0.000923879444599152],
  ],
  [
    [118.477423976489, 24.7871011230886, 0.000923804938793182],
    [118.476944623232, 24.7876756573922, 0.000923879444599152],
  ],
  [
    [118.477408241964, 24.7870901768254, 0.000923804007470608],
    [118.476928888677, 24.7876647110796, 0.000923874787986279],
  ],
  [
    [118.47739251734, 24.7870792395798, 0.000923802144825459],
    [118.476913154133, 24.7876537737931, 0.000923873856663704],
  ],
  [
    [118.477376782829, 24.787068302341, 0.000923802144825459],
    [118.476897419592, 24.7876428365048, 0.000923874787986279],
  ],
  [
    [118.477361048313, 24.7870573560728, 0.00092379841953516],
    [118.476881685044, 24.7876318901872, 0.000923872925341129],
  ],
  [
    [118.477345313808, 24.7870464188306, 0.00092379841953516],
    [118.476865950508, 24.7876209528955, 0.00092387106269598],
  ],
  [
    [118.477329579297, 24.787035472559, 0.000923796556890011],
    [118.476850215975, 24.7876100156022, 0.000923868268728256],
  ],
  [
    [118.477313844798, 24.7870245353134, 0.000923795625567436],
    [118.476834481436, 24.7875990692795, 0.000923870131373405],
  ],
  [
    [118.477298110301, 24.7870135980662, 0.000923794694244862],
    [118.476818746909, 24.7875881319829, 0.000923867337405682],
  ],
  [
    [118.477282375798, 24.7870026517896, 0.000923792831599712],
    [118.476803012384, 24.7875771946846, 0.000923865474760532],
  ],
  [
    [118.477266641307, 24.786991714539, 0.000923791900277138],
    [118.476787287742, 24.7875662483484, 0.000923863612115383],
  ],
  [
    [118.477250906819, 24.7869807772867, 0.000923789106309414],
    [118.476771553223, 24.7875553110467, 0.000923863612115383],
  ],
  [
    [118.477235182213, 24.7869698309966, 0.000923789106309414],
    [118.476755818698, 24.7875443647156, 0.000923860818147659],
  ],
  [
    [118.477219447731, 24.786958893741, 0.000923788174986839],
    [118.476740084184, 24.7875334274106, 0.00092385895550251],
  ],
  [
    [118.477203713251, 24.7869479564837, 0.000923785381019115],
    [118.476724349673, 24.7875224901038, 0.00092385895550251],
  ],
  [
    [118.477187978765, 24.786937010197, 0.000923783518373966],
    [118.476708615156, 24.7875115437677, 0.000923857092857361],
  ],
  [
    [118.47717224429, 24.7869260729363, 0.000923783518373966],
    [118.476692880651, 24.7875006064576, 0.000923855230212212],
  ],
  [
    [118.477156509819, 24.7869151356739, 0.000923781655728817],
    [118.476677146148, 24.7874896691458, 0.000923854298889637],
  ],
  [
    [118.47714077534, 24.7869041893822, 0.000923780724406242],
    [118.476661411639, 24.7874787228046, 0.000923853367567062],
  ],
  [
    [118.477125040874, 24.7868932521164, 0.000923780724406242],
    [118.476645677142, 24.7874677854895, 0.000923850573599339],
  ],
  [
    [118.477109306411, 24.786882314849, 0.000923776999115944],
    [118.476629942648, 24.7874568481727, 0.000923849642276764],
  ],
  [
    [118.477093571941, 24.7868713685522, 0.000923776999115944],
    [118.476614218036, 24.7874459018181, 0.000923848710954189],
  ],
  [
    [118.477077847372, 24.7868604312731, 0.000923773273825645],
    [118.476598483547, 24.7874349644979, 0.000923848710954189],
  ],
  [
    [118.477062112917, 24.7868494940006, 0.000923772342503071],
    [118.476582749061, 24.787424027176, 0.000923845916986465],
  ],
  [
    [118.477046378456, 24.7868385476988, 0.000923771411180496],
    [118.476567014569, 24.7874130808248, 0.000923844054341316],
  ],
  [
    [118.477030644006, 24.786827610423, 0.000923769548535347],
    [118.476551280088, 24.7874021434995, 0.000923843123018742],
  ],
  [
    [118.477014909559, 24.7868166731455, 0.000923769548535347],
    [118.47653554561, 24.7873912061726, 0.000923841260373592],
  ],
  [
    [118.476999175106, 24.7868057268386, 0.000923766754567623],
    [118.476519811126, 24.7873802598163, 0.000923841260373592],
  ],
  [
    [118.476983440664, 24.7867947895577, 0.000923765823245049],
    [118.476504076654, 24.787369322486, 0.000923838466405869],
  ],
  [
    [118.476967706217, 24.7867838432475, 0.000923764891922474],
    [118.476488342185, 24.7873583851541, 0.000923838466405869],
  ],
  [
    [118.476951971781, 24.7867729059633, 0.000923764891922474],
    [118.476472607709, 24.7873474387927, 0.000923835672438145],
  ],
  [
    [118.476936237348, 24.7867619686774, 0.000923761166632175],
    [118.476456883134, 24.7873365014491, 0.000923835672438145],
  ],
  [
    [118.476920512797, 24.7867510223537, 0.00092376209795475],
    [118.476441148672, 24.7873255641121, 0.000923831947147846],
  ],
  [
    [118.47690477837, 24.7867400850645, 0.000923759303987026],
    [118.476425414205, 24.7873146177457, 0.000923831947147846],
  ],
  [
    [118.476889043945, 24.7867291477736, 0.000923756510019302],
    [118.476409679749, 24.7873036804053, 0.000923831015825272],
  ],
  [
    [118.476873309514, 24.7867182014532, 0.000923756510019302],
    [118.476393945296, 24.7872927430633, 0.000923829153180122],
  ],
  [
    [118.476857575094, 24.7867072641589, 0.000923755578696728],
    [118.476378210837, 24.7872817966919, 0.000923829153180122],
  ],
  [
    [118.476841840678, 24.786696326863, 0.000923755578696728],
    [118.476362476389, 24.7872708593465, 0.000923829153180122],
  ],
  [
    [118.476826106255, 24.7866853805376, 0.000923753716051579],
    [118.476346741936, 24.7872599129717, 0.000923825427889824],
  ],
  [
    [118.476810371844, 24.7866744432382, 0.000923750922083855],
    [118.476331007494, 24.7872489756229, 0.000923824496567249],
  ],
  [
    [118.476794637436, 24.7866635059372, 0.00092374999076128],
    [118.476315273054, 24.7872380382725, 0.0009238226339221],
  ],
  [
    [118.476778903021, 24.7866525596068, 0.00092374999076128],
    [118.476299548498, 24.7872270918843, 0.000923820771276951],
  ],
  [
    [118.476763168618, 24.7866416223024, 0.000923746265470982],
    [118.476283814064, 24.7872161545305, 0.000923819839954376],
  ],
  [
    [118.476747444107, 24.786630684988, 0.000923744402825832],
    [118.476268079633, 24.787205217175, 0.000923818908631802],
  ],
  [
    [118.476731709701, 24.7866197386526, 0.000923743471503258],
    [118.476252345196, 24.7871942707901, 0.000923817977309227],
  ],
  [
    [118.476715975306, 24.7866088013431, 0.000923743471503258],
    [118.476236610771, 24.7871833334313, 0.000923816114664078],
  ],
  [
    [118.476700240914, 24.786597864032, 0.000923741608858109],
    [118.476220876348, 24.7871723960708, 0.000923814252018929],
  ],
  [
    [118.476684506516, 24.7865869176915, 0.000923739746212959],
    [118.476205141919, 24.7871614496808, 0.000923813320696354],
  ],
  [
    [118.47666877213, 24.7865759803771, 0.000923739746212959],
    [118.476189407502, 24.7871505123169, 0.000923812389373779],
  ],
  [
    [118.476653037747, 24.7865650430609, 0.000923736020922661],
    [118.476173673087, 24.7871395749514, 0.000923809595406055],
  ],
  [
    [118.476637303357, 24.7865540967154, 0.000923736020922661],
    [118.476157938667, 24.7871286285564, 0.000923808664083481],
  ],
  [
    [118.476621568979, 24.7865431593959, 0.000923735089600086],
    [118.476142214147, 24.7871176911792, 0.000923807732760906],
  ],
  [
    [118.476605834604, 24.7865322220747, 0.000923733226954937],
    [118.476126479741, 24.7871067538085, 0.000923806801438332],
  ],
  [
    [118.476590110111, 24.7865212757158, 0.000923730432987213],
    [118.476110745328, 24.7870958074086, 0.000923804007470608],
  ],
  [
    [118.476574375741, 24.7865103383912, 0.000923730432987213],
    [118.476095010928, 24.7870848700346, 0.000923804007470608],
  ],
  [
    [118.476558641365, 24.7864993920373, 0.000923728570342064],
    [118.47607927653, 24.7870739326589, 0.000923801213502884],
  ],
  [
    [118.476542907001, 24.7864884547094, 0.000923727639019489],
    [118.476063542125, 24.7870629862539, 0.000923801213502884],
  ],
  [
    [118.47652717264, 24.7864775173798, 0.000923726707696915],
    [118.476047807733, 24.7870520488749, 0.00092379841953516],
  ],
  [
    [118.476511438272, 24.7864665710208, 0.000923724845051765],
    [118.476032073344, 24.7870411114942, 0.00092379841953516],
  ],
  [
    [118.476495703916, 24.7864556336878, 0.00092372577637434],
    [118.476016338948, 24.7870301650841, 0.000923795625567436],
  ],
  [
    [118.476479969563, 24.7864446963532, 0.000923722982406616],
    [118.476000604564, 24.7870192277, 0.000923794694244862],
  ],
  [
    [118.476464235203, 24.7864337499892, 0.000923722051084042],
    [118.475984870173, 24.7870082812866, 0.000923793762922287],
  ],
  [
    [118.476448500856, 24.7864228126512, 0.000923719257116318],
    [118.475969145683, 24.7869973438908, 0.000923790968954563],
  ],
  [
    [118.4764327764, 24.7864118753032, 0.000923718325793743],
    [118.475953411308, 24.7869864065018, 0.000923790037631989],
  ],
  [
    [118.476417042048, 24.7864009289341, 0.000923717394471169],
    [118.475937676926, 24.7869754600833, 0.000923790037631989],
  ],
  [
    [118.476401307709, 24.7863899915911, 0.000923715531826019],
    [118.475921942555, 24.7869645226908, 0.000923789106309414],
  ],
  [
    [118.476385573372, 24.7863790542464, 0.000923714600503445],
    [118.475906208188, 24.7869535852967, 0.000923787243664265],
  ],
  [
    [118.476369839029, 24.7863681078722, 0.000923712737858295],
    [118.475890473814, 24.7869426388731, 0.00092378631234169],
  ],
  [
    [118.476354104698, 24.7863571705242, 0.000923710875213146],
    [118.475874739452, 24.7869317014756, 0.000923782587051392],
  ],
  [
    [118.47633837037, 24.7863462331744, 0.000923710875213146],
    [118.475859005093, 24.7869207640765, 0.000923782587051392],
  ],
  [
    [118.476322636035, 24.7863352867953, 0.000923709012567997],
    [118.475843270727, 24.7869098176479, 0.000923780724406242],
  ],
  [
    [118.476306901712, 24.7863243494421, 0.000923708081245422],
    [118.475827536373, 24.7868988802453, 0.000923779793083668],
  ],
  [
    [118.476291167392, 24.7863134120874, 0.000923707149922848],
    [118.475811811911, 24.7868879428328, 0.000923776999115944],
  ],
  [
    [118.476275442955, 24.7863024656948, 0.000923705287277699],
    [118.475796077554, 24.7868769963992, 0.000923776999115944],
  ],
  [
    [118.47625970864, 24.7862915283367, 0.000923703424632549],
    [118.475780343208, 24.7868660589916, 0.000923776067793369],
  ],
  [
    [118.476243974328, 24.7862805909768, 0.000923700630664825],
    [118.475764608866, 24.7868551215824, 0.000923775136470795],
  ],
  [
    [118.47622824001, 24.7862696445876, 0.000923699699342251],
    [118.475748874517, 24.7868441751437, 0.000923773273825645],
  ],
  [
    [118.476212505704, 24.7862587072244, 0.000923696905374527],
    [118.475733140179, 24.7868332377311, 0.000923771411180496],
  ],
  [
    [118.4761967714, 24.7862477698595, 0.000923697836697102],
    [118.475717405845, 24.7868223003168, 0.000923770479857922],
  ],
  [
    [118.47618103709, 24.7862368234652, 0.000923696905374527],
    [118.475701671504, 24.7868113538731, 0.000923770479857922],
  ],
  [
    [118.476165302792, 24.786225886097, 0.000923695974051952],
    [118.475685937175, 24.7868004164554, 0.000923766754567623],
  ],
  [
    [118.476149568488, 24.7862149396993, 0.000923693180084229],
    [118.475670202849, 24.7867894790361, 0.000923766754567623],
  ],
  [
    [118.476133834195, 24.7862040023277, 0.000923692248761654],
    [118.475654478405, 24.786778532579, 0.000923764891922474],
  ],
  [
    [118.476118099906, 24.7861930649545, 0.000923690386116505],
    [118.475638744085, 24.7867675951563, 0.000923763960599899],
  ],
  [
    [118.476102375498, 24.7861821185435, 0.00092368945479393],
    [118.475623009767, 24.7867566577319, 0.000923761166632175],
  ],
  [
    [118.476086641214, 24.7861711811668, 0.000923688523471355],
    [118.475607275442, 24.7867457112781, 0.000923759303987026],
  ],
  [
    [118.476070906932, 24.7861602437885, 0.000923685729503632],
    [118.47559154113, 24.7867347738504, 0.000923760235309601],
  ],
  [
    [118.476055172645, 24.7861492973808, 0.000923684798181057],
    [118.475575806811, 24.7867238273932, 0.000923757441341877],
  ],
  [
    [118.476039438369, 24.7861383599991, 0.000923683866858482],
    [118.475560072504, 24.7867128899621, 0.000923755578696728],
  ],
  [
    [118.476023704095, 24.7861274226157, 0.000923682004213333],
    [118.4755443382, 24.7867019525294, 0.000923754647374153],
  ],
  [
    [118.476007969816, 24.7861164762029, 0.000923682004213333],
    [118.47552860389, 24.7866910060672, 0.000923752784729004],
  ],
  [
    [118.475992235548, 24.7861055388162, 0.000923679210245609],
    [118.475512869591, 24.786680068631, 0.000923750922083855],
  ],
  [
    [118.475976501283, 24.7860946014278, 0.000923678278923035],
    [118.475497145184, 24.7866691311849, 0.000923751853406429],
  ],
  [
    [118.475960767012, 24.78608365501, 0.000923676416277885],
    [118.475481410882, 24.7866581847177, 0.00092374999076128],
  ],
  [
    [118.475945042641, 24.7860727176099, 0.000923675484955311],
    [118.475465676592, 24.7866472472765, 0.000923748128116131],
  ],
  [
    [118.475929308384, 24.7860617802165, 0.000923674553632736],
    [118.475449942304, 24.7866363098336, 0.000923747196793556],
  ],
  [
    [118.475913574121, 24.7860508337936, 0.000923672690987587],
    [118.47543420801, 24.7866253633613, 0.000923747196793556],
  ],
  [
    [118.47589783987, 24.7860398963968, 0.000923672690987587],
    [118.475418473728, 24.7866144259151, 0.000923744402825832],
  ],
  [
    [118.475882105622, 24.7860289589983, 0.000923669897019863],
    [118.475402739449, 24.7866034884672, 0.000923742540180683],
  ],
  [
    [118.475866371367, 24.7860180125704, 0.000923668965697289],
    [118.475387005163, 24.7865925419899, 0.000923740677535534],
  ],
  [
    [118.475850637124, 24.7860070751686, 0.000923666171729565],
    [118.475371270889, 24.7865816045386, 0.000923738814890385],
  ],
  [
    [118.475834902884, 24.785996137765, 0.000923664309084415],
    [118.475355536618, 24.7865706670856, 0.00092373788356781],
  ],
  [
    [118.475819168637, 24.7859851913321, 0.000923664309084415],
    [118.475339802341, 24.7865597206033, 0.000923736020922661],
  ],
  [
    [118.475803434403, 24.7859742539252, 0.000923662446439266],
    [118.475324077964, 24.7865487831387, 0.000923736952245235],
  ],
  [
    [118.475787710051, 24.7859633074806, 0.000923662446439266],
    [118.475308343701, 24.7865378456807, 0.000923735089600086],
  ],
  [
    [118.475771975821, 24.7859523700704, 0.000923659652471542],
    [118.475292609432, 24.7865268991933, 0.000923733226954937],
  ],
  [
    [118.475756241595, 24.7859414326584, 0.000923659652471542],
    [118.475276875175, 24.7865159617319, 0.000923732295632362],
  ],
  [
    [118.475740507362, 24.7859304862171, 0.000923657789826393],
    [118.47526114092, 24.7865050242689, 0.000923729501664639],
  ],
  [
    [118.475724773141, 24.7859195488018, 0.000923654995858669],
    [118.475245406659, 24.7864940777765, 0.000923728570342064],
  ],
  [
    [118.475709038923, 24.7859086113848, 0.000923654064536095],
    [118.47522967241, 24.7864831403101, 0.000923726707696915],
  ],
  [
    [118.475693304699, 24.7858976649384, 0.00092365313321352],
    [118.475213938164, 24.786472202842, 0.00092372577637434],
  ],
  [
    [118.475677570486, 24.7858867275181, 0.000923652201890945],
    [118.475198203911, 24.7864612563445, 0.000923724845051765],
  ],
  [
    [118.475661836276, 24.7858757900961, 0.000923649407923222],
    [118.475182469671, 24.7864503188731, 0.000923722982406616],
  ],
  [
    [118.47564610206, 24.7858648436447, 0.000923650339245796],
    [118.475166745312, 24.7864393723639, 0.000923720188438892],
  ],
  [
    [118.475630377745, 24.785853906211, 0.000923649407923222],
    [118.475151011077, 24.7864284348892, 0.000923720188438892],
  ],
  [
    [118.475614643543, 24.7858429687839, 0.000923645682632923],
    [118.475135276845, 24.7864174974127, 0.000923719257116318],
  ],
  [
    [118.475598909335, 24.7858320223275, 0.000923644751310349],
    [118.475119542606, 24.7864065509068, 0.000923717394471169],
  ],
  [
    [118.475583175139, 24.7858210848971, 0.000923643819987774],
    [118.475103808379, 24.7863956134269, 0.000923716463148594],
  ],
  [
    [118.475567440946, 24.785810147465, 0.000923641957342625],
    [118.475088074155, 24.7863846759454, 0.000923715531826019],
  ],
  [
    [118.475551706746, 24.7857992010035, 0.000923641957342625],
    [118.475072339924, 24.7863737294345, 0.00092371366918087],
  ],
  [
    [118.475535972558, 24.785788263568, 0.000923639163374901],
    [118.475056605706, 24.7863627919496, 0.000923711806535721],
  ],
  [
    [118.475520238373, 24.7857773261309, 0.000923637300729752],
    [118.47504087149, 24.786351854463, 0.000923711806535721],
  ],
  [
    [118.475504504182, 24.7857663796643, 0.000923635438084602],
    [118.475025137267, 24.7863409079471, 0.000923709012567997],
  ],
  [
    [118.475488770002, 24.7857554422238, 0.000923636369407177],
    [118.475009412946, 24.7863299704489, 0.000923707149922848],
  ],
  [
    [118.475473035826, 24.7857445047816, 0.000923633575439453],
    [118.474993678738, 24.7863190329573, 0.000923708081245422],
  ],
  [
    [118.475457311531, 24.7857335583018, 0.000923632644116879],
    [118.474977944524, 24.7863080864363, 0.000923706218600273],
  ],
  [
    [118.475441547675, 24.7857226028256, 0.000923630781471729],
    [118.474962240006, 24.786297166972, 0.000923703424632549],
  ],
  [
    [118.475425724444, 24.785711602259, 0.000923629850149155],
    [118.474946584981, 24.7862862926033, 0.000923702493309975],
  ],
  [
    [118.475409901225, 24.7857006107183, 0.00092362891882658],
    [118.474930929958, 24.786275418233, 0.000923699699342251],
  ],
  [
    [118.47539406812, 24.7856896191842, 0.000923626124858856],
    [118.474915274938, 24.786264543861, 0.000923698768019676],
  ],
  [
    [118.475378244915, 24.7856786366678, 0.000923626124858856],
    [118.474899610041, 24.7862536785234, 0.000923697836697102],
  ],
  [
    [118.475362411825, 24.7856676541581, 0.000923624262213707],
    [118.474883955035, 24.7862428131758, 0.000923696905374527],
  ],
  [
    [118.475346568857, 24.7856566806826, 0.000923623330891132],
    [118.474868280264, 24.7862319568707, 0.000923694111406803],
  ],
  [
    [118.475330735782, 24.7856457071971, 0.000923620536923409],
    [118.474852615384, 24.7862211005558, 0.000923694111406803],
  ],
  [
    [118.47531488294, 24.7856347427543, 0.000923620536923409],
    [118.474836940627, 24.7862102532751, 0.000923693180084229],
  ],
  [
    [118.475299039981, 24.7856237692737, 0.000923619605600834],
    [118.474821265872, 24.7861994059928, 0.000923690386116505],
  ],
  [
    [118.475283187154, 24.7856128138551, 0.000923617742955685],
    [118.474805581232, 24.786188558717, 0.00092368945479393],
  ],
  [
    [118.47526733433, 24.7856018584348, 0.00092361681163311],
    [118.474789896603, 24.7861777204673, 0.000923687592148781],
  ],
  [
    [118.475251481508, 24.7855909030128, 0.000923615880310535],
    [118.474774211978, 24.7861668822159, 0.000923686660826206],
  ],
  [
    [118.47523561881, 24.7855799566251, 0.000923612155020237],
    [118.474758517475, 24.7861560529988, 0.000923686660826206],
  ],
  [
    [118.475219756114, 24.7855690102357, 0.000923612155020237],
    [118.474742832863, 24.7861452237718, 0.000923683866858482],
  ],
  [
    [118.475203893422, 24.7855580638446, 0.000923610292375088],
    [118.474727128477, 24.7861343945597, 0.000923682004213333],
  ],
  [
    [118.475188020852, 24.7855471264878, 0.000923608429729939],
    [118.474711433991, 24.7861235743653, 0.000923681072890759],
  ],
  [
    [118.475172158183, 24.7855361981486, 0.000923606567084789],
    [118.474695729628, 24.7861127632052, 0.000923680141568184],
  ],
  [
    [118.47515627573, 24.7855252607967, 0.000923605635762215],
    [118.474680025259, 24.7861019430157, 0.000923680141568184],
  ],
  [
    [118.475140403187, 24.7855143414901, 0.00092360470443964],
    [118.474664320911, 24.7860911408799, 0.00092367734760046],
  ],
  [
    [118.475124520748, 24.7855034131624, 0.000923602841794491],
    [118.474648606667, 24.7860803297231, 0.000923676416277885],
  ],
  [
    [118.475108628433, 24.785492493869, 0.000923601910471916],
    [118.474632892435, 24.7860695275922, 0.000923674553632736],
  ],
  [
    [118.475092746018, 24.7854815835933, 0.000923600979149342],
    [118.474617168326, 24.7860587344956, 0.000923674553632736],
  ],
  [
    [118.475076853718, 24.7854706733242, 0.000923599116504192],
    [118.474601454109, 24.7860479413891, 0.000923671759665012],
  ],
  [
    [118.47506096142, 24.7854597630533, 0.000923598185181618],
    [118.474585720117, 24.7860371482974, 0.000923670828342438],
  ],
  [
    [118.475045059245, 24.7854488618167, 0.000923597253859043],
    [118.474569996025, 24.7860263642236, 0.000923670828342438],
  ],
  [
    [118.475029157073, 24.7854379605784, 0.000923595391213894],
    [118.474554262047, 24.7860155801562, 0.000923667103052139],
  ],
  [
    [118.475013254913, 24.7854270683661, 0.000923595391213894],
    [118.474538528081, 24.7860048051149, 0.000923666171729565],
  ],
  [
    [118.474997342867, 24.7854161761604, 0.000923593528568745],
    [118.474522794118, 24.7859940300719, 0.000923667103052139],
  ],
  [
    [118.474981430832, 24.7854052929806, 0.000923590734601021],
    [118.474507050269, 24.7859832550355, 0.000923664309084415],
  ],
  [
    [118.474965518801, 24.7853944097991, 0.000923589803278446],
    [118.474491306431, 24.7859724890251, 0.000923662446439266],
  ],
  [
    [118.474949606772, 24.7853835266159, 0.000923587940633297],
    [118.474475562605, 24.7859617320407, 0.000923660583794117],
  ],
  [
    [118.474933684866, 24.785372652467, 0.000923587009310722],
    [118.474459808884, 24.7859509660352, 0.000923660583794117],
  ],
  [
    [118.474917762963, 24.7853617783163, 0.000923585146665573],
    [118.474444055175, 24.7859402090556, 0.000923658721148968],
  ],
  [
    [118.474901831183, 24.7853509131999, 0.000923584215342999],
    [118.474428301477, 24.7859294611022, 0.000923658721148968],
  ],
  [
    [118.474885899406, 24.7853400480818, 0.000923582352697849],
    [118.474412547782, 24.785918713147, 0.000923656858503819],
  ],
  [
    [118.474869967641, 24.7853291919896, 0.000923582352697849],
    [118.47439678421, 24.7859079742261, 0.000923654064536095],
  ],
  [
    [118.474854035878, 24.7853183358958, 0.0009235804900527],
    [118.474381010752, 24.7858972353117, 0.000923652201890945],
  ],
  [
    [118.47483809423, 24.7853074798084, 0.000923578627407551],
    [118.474365247185, 24.7858864963874, 0.00092365313321352],
  ],
  [
    [118.474822152593, 24.7852966327471, 0.000923577696084976],
    [118.474349473742, 24.7858757664974, 0.000923651270568371],
  ],
  [
    [118.474806201079, 24.78528579472, 0.000923576764762402],
    [118.474333700301, 24.7858650366057, 0.000923649407923222],
  ],
  [
    [118.474790259448, 24.7852749476552, 0.000923575833439827],
    [118.474317916983, 24.7858543157482, 0.000923646613955498],
  ],
  [
    [118.474774307949, 24.7852641186523, 0.000923573039472103],
    [118.474302133667, 24.785843594889, 0.000923646613955498],
  ],
  [
    [118.474758346555, 24.7852532806283, 0.000923572108149529],
    [118.474286350355, 24.7858328740281, 0.000923645682632923],
  ],
  [
    [118.474742385172, 24.7852424516302, 0.000923571176826954],
    [118.474270567054, 24.7858221621933, 0.000923644751310349],
  ],
  [
    [118.474726423802, 24.7852316316581, 0.00092356838285923],
    [118.474254773867, 24.785811450365, 0.000923641957342625],
  ],
  [
    [118.474710462434, 24.7852208116843, 0.000923567451536655],
    [118.474238980692, 24.7858007475627, 0.000923641957342625],
  ],
  [
    [118.47469449118, 24.7852099917171, 0.000923567451536655],
    [118.47422317763, 24.7857900447669, 0.00092364102602005],
  ],
  [
    [118.474678519938, 24.7851991807758, 0.000923566520214081],
    [118.474207384469, 24.7857793509889, 0.000923638232052326],
  ],
  [
    [118.474662548699, 24.7851883698327, 0.000923561863601208],
    [118.474191581422, 24.7857686572175, 0.000923637300729752],
  ],
  [
    [118.474646567583, 24.7851775679239, 0.000923562794923782],
    [118.474175768489, 24.7857579634525, 0.000923636369407177],
  ],
  [
    [118.474630586469, 24.7851667660134, 0.000923561863601208],
    [118.474159955568, 24.7857472787136, 0.000923635438084602],
  ],
  [
    [118.474614605368, 24.7851559731288, 0.000923559069633484],
    [118.474144142658, 24.7857366030007, 0.000923632644116879],
  ],
  [
    [118.47459861438, 24.7851451802508, 0.000923559069633484],
    [118.474128329751, 24.7857259272861, 0.000923631712794304],
  ],
  [
    [118.474582623395, 24.785134387371, 0.000923557206988335],
    [118.474112506958, 24.785715251578, 0.000923629850149155],
  ],
  [
    [118.474566632422, 24.7851236035172, 0.000923555344343185],
    [118.474096684168, 24.7857045758682, 0.00092362891882658],
  ],
  [
    [118.474550641452, 24.7851128196616, 0.000923554413020611],
    [118.474080861389, 24.7856939091845, 0.000923627056181431],
  ],
  [
    [118.474534640605, 24.7851020448403, 0.000923552550375462],
    [118.474065038622, 24.7856832515267, 0.000923626124858856],
  ],
  [
    [118.474518629871, 24.7850912700255, 0.000923550687730312],
    [118.474049205969, 24.7856725938755, 0.000923624262213707],
  ],
  [
    [118.47450262903, 24.7850804952006, 0.000923550687730312],
    [118.47403336343, 24.7856619362307, 0.000923623330891132],
  ],
  [
    [118.47448661832, 24.7850697384378, 0.000923549756407738],
    [118.474017530791, 24.7856512876038, 0.000923623330891132],
  ],
  [
    [118.474470607604, 24.7850589726454, 0.000923546962440014],
    [118.474001688266, 24.7856406389833, 0.000923621468245983],
  ],
  [
    [118.474454587011, 24.7850482158873, 0.000923547893762589],
    [118.473985845753, 24.7856299993889, 0.000923618674278259],
  ],
  [
    [118.474438566421, 24.7850374591274, 0.00092354416847229],
    [118.473969993354, 24.7856193598009, 0.000923618674278259],
  ],
  [
    [118.474422545843, 24.7850267113935, 0.00092354416847229],
    [118.473954140967, 24.785608729239, 0.00092361681163311],
  ],
  [
    [118.474406525267, 24.7850159636579, 0.000923540443181992],
    [118.473938288573, 24.7855980896476, 0.000923615880310535],
  ],
  [
    [118.474390494814, 24.7850052249564, 0.000923541374504566],
    [118.4739224362, 24.78558746811, 0.000923614017665386],
  ],
  [
    [118.474374464365, 24.7849944862532, 0.000923540443181992],
    [118.47390657394, 24.7855768465789, 0.000923612155020237],
  ],
  [
    [118.474358424029, 24.7849837475565, 0.000923537649214268],
    [118.473890711684, 24.785566225046, 0.000923611223697662],
  ],
  [
    [118.474342393593, 24.7849730178776, 0.000923535786569119],
    [118.47387483955, 24.7855556125474, 0.000923610292375088],
  ],
  [
    [118.474326343392, 24.784962297241, 0.000923535786569119],
    [118.473858977308, 24.7855450000388, 0.000923608429729939],
  ],
  [
    [118.474310303074, 24.7849515675668, 0.000923533923923969],
    [118.47384310518, 24.7855343875368, 0.000923607498407364],
  ],
  [
    [118.474294252887, 24.7849408559544, 0.000923532992601395],
    [118.473827223175, 24.7855237840689, 0.000923605635762215],
  ],
  [
    [118.474278202694, 24.7849301353126, 0.00092353206127882],
    [118.473811341181, 24.785513189627, 0.000923605635762215],
  ],
  [
    [118.474262152513, 24.7849194236968, 0.000923528335988522],
    [118.473795459181, 24.7855025861557, 0.00092360470443964],
  ],
  [
    [118.474246092455, 24.7849087211152, 0.000923529267311096],
    [118.473779577202, 24.7854920007381, 0.000923602841794491],
  ],
  [
    [118.4742300324, 24.7848980185318, 0.000923527404665947],
    [118.473763685327, 24.7854814062993, 0.000923600979149342],
  ],
  [
    [118.474213972348, 24.7848873159466, 0.000923526473343372],
    [118.473747803353, 24.7854708208783, 0.000923600047826767],
  ],
  [
    [118.474197902418, 24.7848766223956, 0.000923523679375649],
    [118.473731901613, 24.7854602444996, 0.000923598185181618],
  ],
  [
    [118.4741818325, 24.7848659378706, 0.000923523679375649],
    [118.473716009765, 24.7854496681111, 0.000923597253859043],
  ],
  [
    [118.474165762577, 24.7848552443162, 0.000923521816730499],
    [118.473700108031, 24.785439091729, 0.000923595391213894],
  ],
  [
    [118.474149682785, 24.7848445688236, 0.00092351995408535],
    [118.473684206308, 24.785428524373, 0.00092359259724617],
  ],
  [
    [118.474133602986, 24.7848338843015, 0.000923520885407925],
    [118.473668294708, 24.7854179660511, 0.000923593528568745],
  ],
  [
    [118.4741175232, 24.7848232088054, 0.000923517160117626],
    [118.473652383102, 24.7854073986997, 0.000923591665923595],
  ],
  [
    [118.474101443425, 24.7848125423353, 0.000923516228795052],
    [118.473636471507, 24.7853968403744, 0.000923589803278446],
  ],
  [
    [118.474085353764, 24.7848018758716, 0.000923515297472477],
    [118.473620559924, 24.7853862910751, 0.000923588871955872],
  ],
  [
    [118.474069264106, 24.7847912094062, 0.000923514366149902],
    [118.473604638455, 24.7853757417822, 0.000923587009310722],
  ],
  [
    [118.474053164572, 24.7847805519749, 0.000923513434827328],
    [118.473588716989, 24.7853651924876, 0.000923586077988148],
  ],
  [
    [118.474037065039, 24.7847698945419, 0.000923511572182179],
    [118.473572785645, 24.7853546522272, 0.000923585146665573],
  ],
  [
    [118.474020965519, 24.7847592461348, 0.000923509709537029],
    [118.473556854314, 24.7853441209927, 0.000923584215342999],
  ],
  [
    [118.474004866001, 24.7847485977259, 0.00092350784689188],
    [118.473540922976, 24.7853335807289, 0.000923582352697849],
  ],
  [
    [118.473988756597, 24.7847379493235, 0.000923508778214455],
    [118.473524991658, 24.7853230585187, 0.000923581421375275],
  ],
  [
    [118.473972647205, 24.7847273099471, 0.000923505984246731],
    [118.473509050446, 24.7853125272873, 0.000923579558730125],
  ],
  [
    [118.473956527936, 24.7847166796048, 0.000923504121601582],
    [118.473493109245, 24.7853020050818, 0.000923578627407551],
  ],
  [
    [118.473940418559, 24.7847060492526, 0.000923501327633858],
    [118.473477168056, 24.7852914919024, 0.000923576764762402],
  ],
  [
    [118.473924299295, 24.7846954189067, 0.000923502258956432],
    [118.47346121698, 24.7852809787293, 0.000923576764762402],
  ],
  [
    [118.473908170155, 24.7846847975951, 0.000923501327633858],
    [118.473445275796, 24.7852704655464, 0.000923573970794678],
  ],
  [
    [118.473892050906, 24.7846741762735, 0.000923498533666134],
    [118.473429314847, 24.7852599614058, 0.000923573039472103],
  ],
  [
    [118.473875921771, 24.7846635549582, 0.000923498533666134],
    [118.473413363788, 24.7852494572554, 0.000923572108149529],
  ],
  [
    [118.473859782759, 24.7846529426772, 0.000923497602343559],
    [118.473397402853, 24.7852389621391, 0.000923569314181805],
  ],
  [
    [118.473843653647, 24.7846423394139, 0.00092349573969841],
    [118.47338144192, 24.785228467021, 0.000923569314181805],
  ],
  [
    [118.47382751465, 24.784631736157, 0.000923494808375835],
    [118.473365471101, 24.7852179719094, 0.00092356838285923],
  ],
  [
    [118.473811365766, 24.7846211329066, 0.000923492014408112],
    [118.473349500294, 24.7852074858237, 0.000923567451536655],
  ],
  [
    [118.473795226783, 24.7846105386739, 0.000923490151762962],
    [118.473333529498, 24.7851970087641, 0.000923565588891506],
  ],
  [
    [118.473779077914, 24.7845999444476, 0.000923490151762962],
    [118.473317558697, 24.785186522675, 0.000923564657568932],
  ],
  [
    [118.473762929057, 24.7845893592473, 0.000923488289117813],
    [118.473301578026, 24.7851760546477, 0.000923560932278633],
  ],
  [
    [118.473746770314, 24.7845787740534, 0.000923486426472664],
    [118.47328559735, 24.785165577591, 0.000923559069633484],
  ],
  [
    [118.473730611582, 24.7845681978854, 0.000923484563827515],
    [118.473269616685, 24.7851551095603, 0.000923560932278633],
  ],
  [
    [118.473714452853, 24.7845576217157, 0.000923484563827515],
    [118.473253626144, 24.7851446505637, 0.000923558138310909],
  ],
  [
    [118.473698294127, 24.7845470455442, 0.000923482701182365],
    [118.473237635604, 24.7851341915654, 0.00092355627566576],
  ],
  [
    [118.473682125524, 24.7845364784068, 0.000923481769859791],
    [118.473221645068, 24.7851237325654, 0.000923555344343185],
  ],
  [
    [118.473665956923, 24.7845259112676, 0.000923479907214642],
    [118.473205644654, 24.7851132825994, 0.000923555344343185],
  ],
  [
    [118.473649778446, 24.7845153531626, 0.000923478975892067],
    [118.473189644243, 24.7851028326318, 0.000923553481698036],
  ],
  [
    [118.47363360986, 24.7845047950476, 0.000923477113246918],
    [118.473173643844, 24.7850923916901, 0.000923550687730312],
  ],
  [
    [118.473617431397, 24.7844942459667, 0.000923476181924343],
    [118.473157633558, 24.7850819507548, 0.000923548825085163],
  ],
  [
    [118.473601243048, 24.7844836968922, 0.000923476181924343],
    [118.473141623284, 24.7850715188455, 0.000923547893762589],
  ],
  [
    [118.473585054702, 24.784473147816, 0.000923475250601768],
    [118.473125613013, 24.7850610869345, 0.000923548825085163],
  ],
  [
    [118.473568866367, 24.7844626077656, 0.000923472456634045],
    [118.473109602745, 24.7850506550218, 0.000923546031117439],
  ],
  [
    [118.473552678044, 24.7844520767413, 0.00092347152531147],
    [118.473093582599, 24.7850402321431, 0.00092354416847229],
  ],
  [
    [118.473536489724, 24.7844415457151, 0.000923470593988895],
    [118.473077562465, 24.7850298182904, 0.000923545099794865],
  ],
  [
    [118.473520291518, 24.7844310146954, 0.000923469662666321],
    [118.473061532436, 24.7850193954164, 0.000923543237149715],
  ],
  [
    [118.473504083435, 24.7844204927097, 0.000923467800021172],
    [118.473045512316, 24.785008990588, 0.000923541374504566],
  ],
  [
    [118.473487885243, 24.7844099707141, 0.000923465006053448],
    [118.473029482301, 24.7849985767382, 0.000923540443181992],
  ],
  [
    [118.473471677165, 24.7843994487249, 0.000923464074730873],
    [118.473013442409, 24.7849881719226, 0.000923537649214268],
  ],
  [
    [118.473455469099, 24.7843889357616, 0.000923463143408298],
    [118.472997412418, 24.7849777761248, 0.000923537649214268],
  ],
  [
    [118.473439251156, 24.7843784318324, 0.000923460349440575],
    [118.47298137254, 24.7849673803333, 0.000923535786569119],
  ],
  [
    [118.473423033216, 24.7843679279014, 0.000923460349440575],
    [118.472965322776, 24.7849569845483, 0.000923533923923969],
  ],
  [
    [118.473406815278, 24.7843574239687, 0.000923459418118],
    [118.472949282913, 24.7849465977811, 0.000923532992601395],
  ],
  [
    [118.473390597352, 24.7843469290618, 0.000923458486795425],
    [118.472933233163, 24.7849362110203, 0.000923532992601395],
  ],
  [
    [118.473374369541, 24.7843364341614, 0.000923455692827702],
    [118.472917183425, 24.7849258332854, 0.000923531129956245],
  ],
  [
    [118.47335814174, 24.7843259482869, 0.000923454761505127],
    [118.472901123801, 24.7849154555569, 0.000923529267311096],
  ],
  [
    [118.473341913943, 24.7843154624106, 0.000923452898859978],
    [118.472885064189, 24.7849050868544, 0.000923527404665947],
  ],
  [
    [118.473325676268, 24.7843049855683, 0.000923452898859978],
    [118.472869004579, 24.7848947181502, 0.000923527404665947],
  ],
  [
    [118.473309438597, 24.7842945087243, 0.000923451036214828],
    [118.472852944972, 24.7848843494442, 0.000923526473343372],
  ],
  [
    [118.473293200928, 24.7842840318785, 0.000923450104892254],
    [118.472836875488, 24.7848739897723, 0.000923525542020798],
  ],
  [
    [118.473276953381, 24.7842735640668, 0.000923449173569679],
    [118.472820806006, 24.7848636300986, 0.000923521816730499],
  ],
  [
    [118.473260705838, 24.7842630962533, 0.000923446379601955],
    [118.472804726647, 24.784853279459, 0.000923520885407925],
  ],
  [
    [118.473244458306, 24.7842526374658, 0.000923446379601955],
    [118.47278865718, 24.7848429288096, 0.00092351995408535],
  ],
  [
    [118.473228200889, 24.7842421786845, 0.000923444516956806],
    [118.472772577835, 24.7848325871942, 0.000923519022762775],
  ],
  [
    [118.473211943483, 24.7842317289292, 0.000923443585634232],
    [118.472756488605, 24.7848222455852, 0.000923517160117626],
  ],
  [
    [118.473195686079, 24.7842212791722, 0.000923441722989082],
    [118.472740409265, 24.7848119039663, 0.000923516228795052],
  ],
  [
    [118.473179428688, 24.784210838441, 0.000923440791666508],
    [118.472724320049, 24.7848015713816, 0.000923514366149902],
  ],
  [
    [118.47316316141, 24.7842003977162, 0.000923437997698784],
    [118.472708230844, 24.7847912478227, 0.000923511572182179],
  ],
  [
    [118.473146894135, 24.7841899569896, 0.000923438929021358],
    [118.472692131753, 24.7847809242702, 0.000923512503504753],
  ],
  [
    [118.473130616983, 24.784179525297, 0.000923437066376209],
    [118.472676032665, 24.784770600716, 0.000923510640859604],
  ],
  [
    [118.473114339834, 24.7841690936027, 0.00092343520373106],
    [118.472659933588, 24.7847602861877, 0.000923510640859604],
  ],
  [
    [118.473098062696, 24.7841586709343, 0.000923434272408485],
    [118.472643834514, 24.7847499716577, 0.000923508778214455],
  ],
  [
    [118.473081785561, 24.7841482482641, 0.000923433341085911],
    [118.472627725554, 24.784739657134, 0.000923506915569305],
  ],
  [
    [118.473065498549, 24.7841378346279, 0.000923432409763336],
    [118.472611616605, 24.7847293516363, 0.000923506915569305],
  ],
  [
    [118.47304921154, 24.78412742099, 0.000923431478440762],
    [118.47259549778, 24.7847190551727, 0.000923503190279007],
  ],
  [
    [118.473032924534, 24.7841170073502, 0.000923429615795612],
    [118.472579388845, 24.7847087586991, 0.000923502258956432],
  ],
  [
    [118.47301662765, 24.7841066027445, 0.000923425890505314],
    [118.472563270025, 24.784698462232, 0.000923503190279007],
  ],
  [
    [118.473000330778, 24.7840962071648, 0.000923425890505314],
    [118.472547141327, 24.7846881747988, 0.000923500396311283],
  ],
  [
    [118.472984033909, 24.7840858115832, 0.000923424959182739],
    [118.472531022521, 24.7846778873559, 0.000923499464988709],
  ],
  [
    [118.472967737043, 24.7840754159998, 0.00092342309653759],
    [118.472514893829, 24.7846675999192, 0.000923497602343559],
  ],
  [
    [118.472951430299, 24.7840650294505, 0.000923422165215015],
    [118.472498765148, 24.7846573215085, 0.000923496671020985],
  ],
  [
    [118.472935123558, 24.7840546428993, 0.000923420302569866],
    [118.47248262659, 24.7846470521319, 0.000923494808375835],
  ],
  [
    [118.472918806931, 24.7840442563545, 0.000923421233892441],
    [118.472466488034, 24.7846367827535, 0.00092349573969841],
  ],
  [
    [118.472902490316, 24.7840338788356, 0.000923417508602142],
    [118.472450349482, 24.7846265133733, 0.000923492945730686],
  ],
  [
    [118.472886173713, 24.7840235103427, 0.000923417508602142],
    [118.472434210941, 24.7846162530191, 0.000923492014408112],
  ],
  [
    [118.472869857112, 24.7840131418479, 0.000923416577279568],
    [118.472418062513, 24.7846059926712, 0.000923492014408112],
  ],
  [
    [118.472853530625, 24.7840027733594, 0.000923414714634418],
    [118.472401914098, 24.7845957413493, 0.000923489220440388],
  ],
  [
    [118.47283720415, 24.7839924138968, 0.000923414714634418],
    [118.472385755796, 24.7845854900336, 0.000923488289117813],
  ],
  [
    [118.472820877677, 24.7839820544325, 0.000923412851989269],
    [118.472369607394, 24.7845752477359, 0.000923486426472664],
  ],
  [
    [118.472804541328, 24.7839717040021, 0.000923409126698971],
    [118.472353449107, 24.7845650054445, 0.000923485495150089],
  ],
  [
    [118.472788204981, 24.78396135357, 0.000923409126698971],
    [118.472337290822, 24.7845547631513, 0.00092348363250494],
  ],
  [
    [118.472771868646, 24.7839510121638, 0.000923407264053822],
    [118.47232112266, 24.7845445298921, 0.000923482701182365],
  ],
  [
    [118.472755522424, 24.7839406707638, 0.000923407264053822],
    [118.4723049545, 24.7845342966311, 0.000923480838537216],
  ],
  [
    [118.472739186103, 24.7839303383817, 0.000923405401408672],
    [118.472288786352, 24.7845240723961, 0.000923480838537216],
  ],
  [
    [118.472722830008, 24.783920006014, 0.000923403538763523],
    [118.472272608318, 24.7845138481675, 0.000923478975892067],
  ],
  [
    [118.472706483804, 24.7839096736363, 0.000923402607440948],
    [118.472256440184, 24.7845036329566, 0.000923478044569492],
  ],
  [
    [118.472690127722, 24.7838993502927, 0.000923400744795799],
    [118.472240252276, 24.7844934177602, 0.000923476181924343],
  ],
  [
    [118.472673771644, 24.7838890269473, 0.000923399813473225],
    [118.472224074267, 24.7844832115816, 0.000923475250601768],
  ],
  [
    [118.472657415577, 24.7838787126278, 0.00092339888215065],
    [118.472207886373, 24.7844730054094, 0.000923473387956619],
  ],
  [
    [118.472641049624, 24.7838683983145, 0.000923397950828075],
    [118.472191698481, 24.7844627992353, 0.000923473387956619],
  ],
  [
    [118.472624683683, 24.7838580930272, 0.000923396088182926],
    [118.472175510601, 24.7844526020872, 0.00092347152531147],
  ],
  [
    [118.472608307855, 24.7838477877461, 0.000923394225537777],
    [118.472159312834, 24.7844424049454, 0.000923469662666321],
  ],
  [
    [118.472591941919, 24.7838374824552, 0.000923394225537777],
    [118.47214311508, 24.7844322168296, 0.000923466868698597],
  ],
  [
    [118.472575566106, 24.7838271861982, 0.000923392362892628],
    [118.472126917327, 24.7844220287119, 0.000923466868698597],
  ],
  [
    [118.472559190296, 24.7838168899395, 0.000923391431570053],
    [118.472110719587, 24.7844118496203, 0.000923465937376022],
  ],
  [
    [118.472542804609, 24.7838066027147, 0.000923390500247478],
    [118.47209451196, 24.7844016705349, 0.000923465006053448],
  ],
  [
    [118.472526418933, 24.7837963245158, 0.000923388637602329],
    [118.472078304336, 24.7843914914477, 0.000923463143408298],
  ],
  [
    [118.472510033251, 24.7837860372874, 0.00092338677495718],
    [118.472062086834, 24.7843813213945, 0.000923461280763149],
  ],
  [
    [118.472493637692, 24.783775759093, 0.000923387706279755],
    [118.472045869344, 24.7843711603673, 0.000923461280763149],
  ],
  [
    [118.472477252033, 24.7837654899164, 0.000923384912312031],
    [118.472029651848, 24.7843609903105, 0.000923460349440575],
  ],
  [
    [118.472460856488, 24.7837552207461, 0.000923383049666882],
    [118.472013434372, 24.7843508383075, 0.000923458486795425],
  ],
  [
    [118.472444451066, 24.7837449606097, 0.000923383049666882],
    [118.471997207002, 24.7843406772829, 0.000923457555472851],
  ],
  [
    [118.472428045647, 24.7837347004715, 0.000923379324376583],
    [118.471980979643, 24.7843305252843, 0.000923456624150276],
  ],
  [
    [118.472411640231, 24.7837244403315, 0.000923379324376583],
    [118.471964752295, 24.7843203823117, 0.000923453830182552],
  ],
  [
    [118.472395234826, 24.7837141892175, 0.000923378393054008],
    [118.471948515061, 24.7843102393453, 0.000923453830182552],
  ],
  [
    [118.472378819535, 24.7837039381096, 0.000923376530408859],
    [118.471932277839, 24.7843001054049, 0.000923451967537403],
  ],
  [
    [118.472362414144, 24.7836936960196, 0.000923375599086285],
    [118.47191604061, 24.7842899624349, 0.000923451036214828],
  ],
  [
    [118.472345988979, 24.7836834539439, 0.00092337466776371],
    [118.471899803402, 24.7842798375187, 0.000923448242247105],
  ],
  [
    [118.472329573714, 24.7836732208861, 0.000923372805118561],
    [118.471883556308, 24.7842697126086, 0.000923448242247105],
  ],
  [
    [118.472313148563, 24.7836629878345, 0.000923371873795986],
    [118.471867309216, 24.7842595876968, 0.00092344731092453],
  ],
  [
    [118.472296723415, 24.783652754781, 0.000923370942473412],
    [118.471851062127, 24.7842494627832, 0.000923444516956806],
  ],
  [
    [118.472280288389, 24.7836425307616, 0.000923370011150837],
    [118.47183480517, 24.7842393559313, 0.000923443585634232],
  ],
  [
    [118.472263863264, 24.7836323157599, 0.000923367217183113],
    [118.471818548206, 24.7842292400499, 0.000923442654311657],
  ],
  [
    [118.472247418364, 24.7836221007726, 0.000923367217183113],
    [118.471802291254, 24.7842191331944, 0.000923441722989082],
  ],
  [
    [118.472230983356, 24.7836118857754, 0.000923363491892815],
    [118.471786024425, 24.784209035373, 0.000923440791666508],
  ],
  [
    [118.47221453847, 24.7836016798121, 0.000923364423215389],
    [118.471769757589, 24.7841989285219, 0.000923439860343933],
  ],
  [
    [118.472198093587, 24.783591473847, 0.000923361629247665],
    [118.471753490774, 24.7841888397246, 0.000923437997698784],
  ],
  [
    [118.472181648716, 24.7835812769078, 0.000923360697925091],
    [118.471737214064, 24.7841787419058, 0.000923437997698784],
  ],
  [
    [118.472165203847, 24.7835710799668, 0.000923360697925091],
    [118.471720947263, 24.7841686621325, 0.00092343520373106],
  ],
  [
    [118.472148749093, 24.783560883032, 0.000923358835279942],
    [118.471704660678, 24.7841585733459, 0.000923433341085911],
  ],
  [
    [118.472132284461, 24.7835506951312, 0.000923356972634792],
    [118.471688383993, 24.7841484935771, 0.000923430547118187],
  ],
  [
    [118.472115829729, 24.7835405162481, 0.000923356972634792],
    [118.471672097431, 24.7841384228423, 0.000923432409763336],
  ],
  [
    [118.472099365112, 24.7835303373714, 0.000923356041312218],
    [118.471655810872, 24.7841283521057, 0.000923432409763336],
  ],
  [
    [118.472082900497, 24.7835201584927, 0.000923354178667068],
    [118.471639524315, 24.7841182813673, 0.000923428684473038],
  ],
  [
    [118.472066435894, 24.78350998864, 0.000923352316021919],
    [118.471623227882, 24.7841082196629, 0.000923427753150463],
  ],
  [
    [118.472049961404, 24.7834998187935, 0.000923351384699345],
    [118.471606931459, 24.7840981669844, 0.000923427753150463],
  ],
  [
    [118.472033486927, 24.7834896579729, 0.000923348590731621],
    [118.471590635031, 24.7840881052763, 0.000923425890505314],
  ],
  [
    [118.472017012452, 24.7834794971504, 0.000923348590731621],
    [118.471574338613, 24.7840780525942, 0.000923424027860165],
  ],
  [
    [118.472000528091, 24.7834693363342, 0.000923346728086472],
    [118.471558032319, 24.7840680089461, 0.000923424027860165],
  ],
  [
    [118.471984043741, 24.7834591845438, 0.000923345796763897],
    [118.471541726027, 24.7840579652961, 0.000923421233892441],
  ],
  [
    [118.471967559403, 24.7834490417793, 0.000923343934118748],
    [118.471525409858, 24.7840479306801, 0.000923420302569866],
  ],
  [
    [118.471951065179, 24.7834388990211, 0.000923343934118748],
    [118.47150910358, 24.7840378960542, 0.000923418439924717],
  ],
  [
    [118.471934570958, 24.783428756261, 0.000923342071473598],
    [118.471492787417, 24.7840278614346, 0.000923416577279568],
  ],
  [
    [118.471918076748, 24.7834186225267, 0.000923340208828449],
    [118.471476461376, 24.784017835849, 0.000923417508602142],
  ],
  [
    [118.471901582541, 24.7834084887907, 0.000923339277505875],
    [118.471460145226, 24.7840078102535, 0.000923415645956993],
  ],
  [
    [118.471885078457, 24.7833983640886, 0.0009233383461833],
    [118.471443819199, 24.7839977936919, 0.000923412851989269],
  ],
  [
    [118.471868574376, 24.7833882393846, 0.0009233383461833],
    [118.471427493175, 24.7839877771286, 0.000923412851989269],
  ],
  [
    [118.471852070306, 24.7833781237065, 0.000923336483538151],
    [118.471411157273, 24.7839777695992, 0.000923411920666695],
  ],
  [
    [118.47183555635, 24.7833680080346, 0.000923334620893002],
    [118.471394821374, 24.7839677620679, 0.000923410058021545],
  ],
  [
    [118.471819042397, 24.7833578923609, 0.000923332758247852],
    [118.471378485477, 24.7839577545349, 0.000923409126698971],
  ],
  [
    [118.471802528455, 24.783347785713, 0.000923331826925278],
    [118.471362149592, 24.7839477560278, 0.000923408195376396],
  ],
  [
    [118.471786004636, 24.783337688099, 0.000923332758247852],
    [118.47134580383, 24.7839377665546, 0.000923405401408672],
  ],
  [
    [118.47176948082, 24.7833275904832, 0.000923329032957554],
    [118.471329458062, 24.7839277680519, 0.000923403538763523],
  ],
  [
    [118.471752957006, 24.7833174928656, 0.000923328101634979],
    [118.471313112314, 24.7839177876028, 0.000923404470086098],
  ],
  [
    [118.471736433204, 24.7833074042738, 0.00092332623898983],
    [118.471296756671, 24.7839077981322, 0.000923401676118374],
  ],
  [
    [118.471719899516, 24.7832973156883, 0.000923325307667255],
    [118.471280410936, 24.7838978267072, 0.000923402607440948],
  ],
  [
    [118.471703365831, 24.7832872271009, 0.000923323445022106],
    [118.471264045419, 24.7838878462687, 0.000923399813473225],
  ],
  [
    [118.471686832166, 24.783277156567, 0.000923321582376957],
    [118.471247689801, 24.7838778748481, 0.00092339888215065],
  ],
  [
    [118.471670288606, 24.7832670770117, 0.000923322513699532],
    [118.471231324306, 24.7838679124614, 0.00092339888215065],
  ],
  [
    [118.471653745058, 24.7832570064822, 0.000923320651054382],
    [118.471214958814, 24.783857950073, 0.000923396088182926],
  ],
  [
    [118.471637201521, 24.7832469449785, 0.000923318788409233],
    [118.471198593324, 24.7838479876827, 0.000923395156860352],
  ],
  [
    [118.47162064809, 24.7832368744534, 0.000923317857086658],
    [118.471182217957, 24.7838380343263, 0.000923394225537777],
  ],
  [
    [118.471604094678, 24.7832268219818, 0.000923317857086658],
    [118.471165842593, 24.7838280809681, 0.000923394225537777],
  ],
  [
    [118.47158754127, 24.7832167695084, 0.000923315063118935],
    [118.47114946724, 24.7838181366358, 0.000923390500247478],
  ],
  [
    [118.471570987864, 24.7832067170331, 0.00092331413179636],
    [118.471133082001, 24.7838081923097, 0.000923389568924904],
  ],
  [
    [118.471554424581, 24.7831966735917, 0.000923313200473785],
    [118.471116696773, 24.7837982570095, 0.000923388637602329],
  ],
  [
    [118.4715378613, 24.7831866301485, 0.000923311337828636],
    [118.471100311548, 24.7837883217075, 0.000923387706279755],
  ],
  [
    [118.471521288134, 24.7831765867114, 0.000923310406506062],
    [118.471083926326, 24.7837783864037, 0.00092338677495718],
  ],
  [
    [118.471504724868, 24.7831665522921, 0.000923310406506062],
    [118.471067531226, 24.7837684601337, 0.000923383980989456],
  ],
  [
    [118.471488151724, 24.7831565269068, 0.000923308543860912],
    [118.471051136138, 24.7837585428897, 0.000923383980989456],
  ],
  [
    [118.471471578583, 24.7831465015196, 0.000923305749893188],
    [118.471034741052, 24.7837486256439, 0.000923383049666882],
  ],
  [
    [118.471454995557, 24.7831364761386, 0.000923306681215763],
    [118.47101833608, 24.7837387084042, 0.000923381187021732],
  ],
  [
    [118.471438412542, 24.7831264597834, 0.000923304818570614],
    [118.47100193112, 24.7837288001904, 0.000923380255699158],
  ],
  [
    [118.471421829529, 24.7831164434263, 0.00092330202460289],
    [118.470985526162, 24.7837188919748, 0.000923378393054008],
  ],
  [
    [118.471405236639, 24.7831064361032, 0.00092330202460289],
    [118.470969111327, 24.7837089927931, 0.000923378393054008],
  ],
  [
    [118.471388653641, 24.7830964287701, 0.000923298299312592],
    [118.470952696495, 24.7836990936096, 0.00092337466776371],
  ],
  [
    [118.471372060765, 24.783086430471, 0.000923299230635166],
    [118.470936281665, 24.7836891944243, 0.00092337466776371],
  ],
  [
    [118.471355458004, 24.783076432178, 0.000923298299312592],
    [118.470919866846, 24.7836793042648, 0.000923373736441135],
  ],
  [
    [118.471338865142, 24.7830664429028, 0.000923297367990017],
    [118.47090344215, 24.7836694231392, 0.000923371873795986],
  ],
  [
    [118.471322262395, 24.7830564536338, 0.000923295505344868],
    [118.470887017448, 24.7836595329841, 0.000923371873795986],
  ],
  [
    [118.471305649761, 24.7830464643709, 0.000923294574022293],
    [118.470870592767, 24.7836496608826, 0.000923370942473412],
  ],
  [
    [118.471289047028, 24.7830364841259, 0.000923294574022293],
    [118.47085415819, 24.7836397797596, 0.000923369079828262],
  ],
  [
    [118.471272434409, 24.783026503887, 0.000923290848731995],
    [118.470837733522, 24.7836299166822, 0.000923369079828262],
  ],
  [
    [118.471255821801, 24.783016532674, 0.000923291780054569],
    [118.470821289071, 24.7836200445912, 0.000923365354537964],
  ],
  [
    [118.471239209204, 24.7830065704869, 0.000923288054764271],
    [118.470804854519, 24.7836101815181, 0.000923363491892815],
  ],
  [
    [118.471222586713, 24.7829965992781, 0.000923287123441696],
    [118.470788410091, 24.7836003274789, 0.000923363491892815],
  ],
  [
    [118.471205964233, 24.7829866370952, 0.000923287123441696],
    [118.470771965665, 24.7835904734378, 0.00092336256057024],
  ],
  [
    [118.471189331877, 24.7829766839462, 0.000923285260796547],
    [118.470755521241, 24.7835806193949, 0.000923360697925091],
  ],
  [
    [118.471172709411, 24.7829667307873, 0.000923283398151398],
    [118.470739066941, 24.7835707743859, 0.000923359766602516],
  ],
  [
    [118.471156077068, 24.7829567866622, 0.000923282466828823],
    [118.470722612651, 24.7835609384028, 0.000923358835279942],
  ],
  [
    [118.471139444728, 24.7829468425353, 0.000923282466828823],
    [118.470706158356, 24.7835510933901, 0.000923356972634792],
  ],
  [
    [118.471122802502, 24.7829368984145, 0.000923279672861099],
    [118.470689694192, 24.783541266439, 0.000923356041312218],
  ],
  [
    [118.471106160287, 24.7829269633195, 0.000923278741538525],
    [118.47067323991, 24.7835314304504, 0.000923356041312218],
  ],
  [
    [118.471089518075, 24.7829170282227, 0.000923276878893375],
    [118.470656765863, 24.7835216035036, 0.000923353247344494],
  ],
  [
    [118.471072875875, 24.7829071021517, 0.000923276878893375],
    [118.470640301715, 24.7835117855748, 0.000923351384699345],
  ],
  [
    [118.471056223788, 24.7828971760869, 0.000923275947570801],
    [118.470623827681, 24.783501967652, 0.000923352316021919],
  ],
  [
    [118.471039571713, 24.7828872590479, 0.000923274084925652],
    [118.470607353659, 24.7834921587552, 0.00092335045337677],
  ],
  [
    [118.471022919641, 24.782877342007, 0.000923272222280502],
    [118.470590879631, 24.7834823408288, 0.000923348590731621],
  ],
  [
    [118.471006257691, 24.782867434, 0.000923270359635353],
    [118.470574405622, 24.783472540956, 0.000923349522054195],
  ],
  [
    [118.470989595744, 24.782857525991, 0.000923269428312778],
    [118.470557921728, 24.7834627410893, 0.000923344865441322],
  ],
  [
    [118.4709729338, 24.7828476179802, 0.000923267565667629],
    [118.470541437836, 24.7834529412208, 0.000923345796763897],
  ],
  [
    [118.470956271867, 24.7828377189953, 0.000923267565667629],
    [118.470524944067, 24.7834431503861, 0.000923344865441322],
  ],
  [
    [118.470939600057, 24.7828278290442, 0.000923267565667629],
    [118.4705084503, 24.7834333595496, 0.000923343934118748],
  ],
  [
    [118.470922928249, 24.7828179390912, 0.00092326570302248],
    [118.470491956536, 24.7834235687113, 0.000923341140151024],
  ],
  [
    [118.470906256444, 24.7828080491363, 0.000923261977732182],
    [118.470475462784, 24.7834137868988, 0.000923340208828449],
  ],
  [
    [118.470889574762, 24.7827981682152, 0.000923261977732182],
    [118.470458959154, 24.7834040141202, 0.000923339277505875],
  ],
  [
    [118.470872893083, 24.7827882872923, 0.000923261977732182],
    [118.470442455526, 24.7833942413397, 0.000923339277505875],
  ],
  [
    [118.470856211415, 24.7827784153952, 0.000923259183764458],
    [118.470425951901, 24.7833844685574, 0.000923335552215576],
  ],
  [
    [118.470839519861, 24.7827685435042, 0.000923259183764458],
    [118.470409448288, 24.783374704801, 0.000923334620893002],
  ],
  [
    [118.47082282831, 24.7827586716114, 0.000923256389796734],
    [118.470392934788, 24.7833649410507, 0.000923333689570427],
  ],
  [
    [118.47080613677, 24.7827488087443, 0.000923256389796734],
    [118.4703764213, 24.7833551863263, 0.000923332758247852],
  ],
  [
    [118.470789445241, 24.7827389549031, 0.000923256389796734],
    [118.470359907814, 24.7833454316, 0.000923330895602703],
  ],
  [
    [118.470772743827, 24.782729101068, 0.000923254527151585],
    [118.470343384451, 24.7833356859075, 0.000923330895602703],
  ],
  [
    [118.470756042415, 24.782719247231, 0.000923252664506435],
    [118.470326861091, 24.7833259402132, 0.000923329032957554],
  ],
  [
    [118.470739341014, 24.7827094024199, 0.000923251733183861],
    [118.470310337742, 24.7833162035448, 0.000923329032957554],
  ],
  [
    [118.470722629728, 24.7826995576148, 0.000923249870538712],
    [118.470293804507, 24.7833064668825, 0.000923327170312405],
  ],
  [
    [118.470705918453, 24.7826897218356, 0.000923248939216137],
    [118.470277271274, 24.7832967302183, 0.00092332623898983],
  ],
  [
    [118.470689207181, 24.7826798860544, 0.000923248007893562],
    [118.470260738053, 24.78328700258, 0.000923324376344681],
  ],
  [
    [118.47067249592, 24.7826700592992, 0.000923246145248413],
    [118.470244204834, 24.7832772749399, 0.000923322513699532],
  ],
  [
    [118.470655774773, 24.7826602325499, 0.000923246145248413],
    [118.470227661738, 24.7832675563335, 0.000923321582376957],
  ],
  [
    [118.470639053637, 24.7826504148266, 0.000923244282603264],
    [118.470211118645, 24.7832578377253, 0.000923321582376957],
  ],
  [
    [118.470622322616, 24.7826405971093, 0.000923243351280689],
    [118.470194575562, 24.783248128143, 0.000923319719731808],
  ],
  [
    [118.470605601486, 24.7826307793821, 0.000923244282603264],
    [118.470178022594, 24.7832384185668, 0.000923320651054382],
  ],
  [
    [118.470588870478, 24.7826209706888, 0.000923239625990391],
    [118.470161469637, 24.7832287180164, 0.000923315994441509],
  ],
  [
    [118.470572139473, 24.7826111619935, 0.000923240557312965],
    [118.470144916683, 24.7832190174642, 0.000923315994441509],
  ],
  [
    [118.470555398591, 24.7826013623321, 0.000923237763345242],
    [118.470128363731, 24.7832093169102, 0.00092331413179636],
  ],
  [
    [118.47053865772, 24.7825915716964, 0.000923236832022667],
    [118.470111800902, 24.7831996253899, 0.000923313200473785],
  ],
  [
    [118.470521916844, 24.7825817720312, 0.000923236832022667],
    [118.470095238075, 24.7831899338678, 0.000923313200473785],
  ],
  [
    [118.470505175987, 24.7825719904195, 0.000923234969377518],
    [118.47007867526, 24.7831802513716, 0.000923312269151211],
  ],
  [
    [118.470488425235, 24.7825621997861, 0.000923233106732368],
    [118.470062102567, 24.7831705779091, 0.000923309475183487],
  ],
  [
    [118.470471674495, 24.7825524181786, 0.000923232175409794],
    [118.470045529869, 24.7831608954171, 0.000923307612538338],
  ],
  [
    [118.470454923767, 24.7825426455969, 0.000923230312764645],
    [118.47002895719, 24.7831512309787, 0.000923305749893188],
  ],
  [
    [118.470438163152, 24.7825328730212, 0.00092322938144207],
    [118.470012384505, 24.7831415575106, 0.000923305749893188],
  ],
  [
    [118.470421402549, 24.7825231094714, 0.000923227518796921],
    [118.469995801943, 24.7831318930764, 0.000923304818570614],
  ],
  [
    [118.470404641939, 24.782513336892, 0.000923225656151772],
    [118.469979219392, 24.7831222376681, 0.00092330202460289],
  ],
  [
    [118.47038788135, 24.7825035823661, 0.000923225656151772],
    [118.469962636843, 24.7831125822578, 0.00092330202460289],
  ],
  [
    [118.470371110875, 24.7824938278462, 0.000923224724829197],
    [118.469946044409, 24.7831029268537, 0.000923301093280315],
  ],
  [
    [118.470354340402, 24.7824840733245, 0.000923221930861473],
    [118.469929451985, 24.7830932804754, 0.000923301093280315],
  ],
  [
    [118.470337569941, 24.7824743278285, 0.000923221930861473],
    [118.469912859565, 24.7830836340952, 0.000923299230635166],
  ],
  [
    [118.470320789594, 24.7824645823387, 0.000923220999538898],
    [118.469896267155, 24.7830739967409, 0.000923298299312592],
  ],
  [
    [118.470304009258, 24.7824548458746, 0.000923219136893749],
    [118.46987966486, 24.7830643593927, 0.000923296436667442],
  ],
  [
    [118.470287228925, 24.7824451094086, 0.000923218205571175],
    [118.469863062576, 24.7830547310703, 0.000923294574022293],
  ],
  [
    [118.470270448603, 24.7824353819685, 0.0009232172742486],
    [118.469846460294, 24.7830451027461, 0.000923294574022293],
  ],
  [
    [118.470253658395, 24.7824256545344, 0.000923213548958302],
    [118.469829848135, 24.7830354834556, 0.000923292711377144],
  ],
  [
    [118.47023686819, 24.7824159270984, 0.000923215411603451],
    [118.469813235978, 24.7830258641633, 0.000923290848731995],
  ],
  [
    [118.470220068107, 24.7824062086961, 0.000923213548958302],
    [118.469796623824, 24.7830162448691, 0.00092328991740942],
  ],
  [
    [118.470203277916, 24.782396490284, 0.000923213548958302],
    [118.469780001793, 24.7830066346086, 0.00092328991740942],
  ],
  [
    [118.470186477847, 24.7823867809057, 0.000923211686313152],
    [118.469763389662, 24.7829970333661, 0.000923288986086845],
  ],
  [
    [118.47016967779, 24.7823770805532, 0.000923208892345428],
    [118.469746767644, 24.7829874321297, 0.000923288054764271],
  ],
  [
    [118.470152867838, 24.7823673711789, 0.000923208892345428],
    [118.469730135741, 24.7829778308993, 0.000923284329473972],
  ],
  [
    [118.470136057906, 24.7823576798582, 0.000923207029700279],
    [118.469713513737, 24.7829682386868, 0.000923284329473972],
  ],
  [
    [118.470119247968, 24.7823479795079, 0.000923206098377705],
    [118.469696881847, 24.7829586464804, 0.000923282466828823],
  ],
  [
    [118.47010243805, 24.7823382972111, 0.00092320516705513],
    [118.469680249969, 24.7829490632999, 0.000923281535506248],
  ],
  [
    [118.470085618238, 24.7823286058927, 0.000923204235732555],
    [118.469663608204, 24.7829394801253, 0.000923279672861099],
  ],
  [
    [118.470068798436, 24.7823189236, 0.000923203304409981],
    [118.469646966442, 24.7829298969489, 0.000923279672861099],
  ],
  [
    [118.470051978646, 24.7823092503331, 0.000923200510442257],
    [118.469630324692, 24.7829203227984, 0.000923278741538525],
  ],
  [
    [118.470035148971, 24.7822995770723, 0.000923199579119682],
    [118.469613682952, 24.7829107576737, 0.000923276878893375],
  ],
  [
    [118.470018329186, 24.7822899038016, 0.000923198647797108],
    [118.469597031326, 24.782901192555, 0.000923275016248226],
  ],
  [
    [118.470001499524, 24.7822802395646, 0.000923197716474533],
    [118.469580379703, 24.7828916274345, 0.000923275947570801],
  ],
  [
    [118.469984659985, 24.7822705843614, 0.000923196785151958],
    [118.469563728092, 24.7828820713398, 0.000923273153603077],
  ],
  [
    [118.469967820439, 24.7822609201286, 0.000923194922506809],
    [118.469547076482, 24.7828725152432, 0.000923272222280502],
  ],
  [
    [118.469950990802, 24.7822512739413, 0.000923192128539085],
    [118.469530414996, 24.7828629681804, 0.000923271290957928],
  ],
  [
    [118.469934141383, 24.7822416187403, 0.00092319305986166],
    [118.469513753512, 24.7828534211157, 0.000923269428312778],
  ],
  [
    [118.469917301871, 24.7822319815848, 0.000923191197216511],
    [118.469497092039, 24.7828438830768, 0.000923268496990204],
  ],
  [
    [118.469900452465, 24.7822223354077, 0.000923191197216511],
    [118.46948042068, 24.782834345044, 0.000923266634345055],
  ],
  [
    [118.46988360307, 24.7822126982563, 0.000923189334571362],
    [118.469463749323, 24.7828248070093, 0.000923267565667629],
  ],
  [
    [118.469866743798, 24.7822030701387, 0.000923186540603638],
    [118.469447077978, 24.7828152780004, 0.000923262909054756],
  ],
  [
    [118.469849894417, 24.7821934420112, 0.000923187471926212],
    [118.469430396756, 24.7828057580253, 0.000923266634345055],
  ],
  [
    [118.469833035151, 24.7821838138898, 0.000923184677958488],
    [118.469413725424, 24.7827962380404, 0.000923262909054756],
  ],
  [
    [118.469816166006, 24.782174194802, 0.000923183746635914],
    [118.469397044207, 24.7827867180614, 0.000923261046409607],
  ],
  [
    [118.469799306762, 24.7821645847321, 0.000923181883990765],
    [118.469380353112, 24.7827772071163, 0.000923261046409607],
  ],
  [
    [118.469782437632, 24.7821549746683, 0.00092318095266819],
    [118.469363671908, 24.7827676961614, 0.000923259183764458],
  ],
  [
    [118.469765568504, 24.7821453646025, 0.00092318095266819],
    [118.469346980827, 24.7827581942401, 0.000923257321119308],
  ],
  [
    [118.469748689499, 24.7821357635704, 0.000923178158700466],
    [118.469330289748, 24.782748692317, 0.000923256389796734],
  ],
  [
    [118.469731820386, 24.7821261625285, 0.000923178158700466],
    [118.469313588792, 24.7827391994277, 0.000923255458474159],
  ],
  [
    [118.469714941395, 24.7821165705203, 0.000923176296055317],
    [118.469296887839, 24.7827297065364, 0.000923255458474159],
  ],
  [
    [118.469698062406, 24.7821069785101, 0.000923176296055317],
    [118.469280186888, 24.7827202136433, 0.000923252664506435],
  ],
  [
    [118.469681173532, 24.782097386506, 0.000923174433410168],
    [118.469263485948, 24.782710729776, 0.000923251733183861],
  ],
  [
    [118.469664284669, 24.7820878035276, 0.000923173502087593],
    [118.469246785019, 24.7827012549345, 0.000923250801861286],
  ],
  [
    [118.469647395817, 24.782078229575, 0.000923173502087593],
    [118.469230074205, 24.782691780099, 0.000923248007893562],
  ],
  [
    [118.469630506968, 24.7820686556205, 0.000923171639442444],
    [118.469213363393, 24.7826823052617, 0.000923248007893562],
  ],
  [
    [118.469613608233, 24.782059081672, 0.00092316884547472],
    [118.469196642703, 24.782672839458, 0.000923248007893562],
  ],
  [
    [118.469596709509, 24.7820495167493, 0.000923169776797295],
    [118.469179922016, 24.7826633736525, 0.000923245213925838],
  ],
  [
    [118.469579810796, 24.7820399608524, 0.000923166051506996],
    [118.469163201341, 24.7826539168727, 0.000923244282603264],
  ],
  [
    [118.469562902197, 24.7820304049614, 0.000923165120184422],
    [118.469146480667, 24.7826444600911, 0.000923243351280689],
  ],
  [
    [118.469545993602, 24.7820208490685, 0.000923166051506996],
    [118.469129760005, 24.7826350123354, 0.00092324148863554],
  ],
  [
    [118.469529085017, 24.7820113022014, 0.000923163257539272],
    [118.469113029457, 24.7826255645856, 0.000923240557312965],
  ],
  [
    [118.469512176435, 24.7820017553324, 0.000923161394894123],
    [118.469096298912, 24.7826161168339, 0.000923240557312965],
  ],
  [
    [118.469495257966, 24.7819922084693, 0.000923161394894123],
    [118.469079558489, 24.782606678116, 0.000923238694667816],
  ],
  [
    [118.469478339518, 24.7819826796598, 0.000923158600926399],
    [118.469062818077, 24.7825972484238, 0.000923236832022667],
  ],
  [
    [118.469461421064, 24.7819731418205, 0.000923158600926399],
    [118.469046087556, 24.7825878187219, 0.000923235900700092],
  ],
  [
    [118.469444492732, 24.781963613015, 0.000923160463571548],
    [118.469029337261, 24.7825783890338, 0.000923234038054943],
  ],
  [
    [118.469427564412, 24.7819540932352, 0.00092315673828125],
    [118.469012596865, 24.7825689683637, 0.000923232175409794],
  ],
  [
    [118.469410636094, 24.7819445734536, 0.000923155806958675],
    [118.468995846583, 24.7825595476996, 0.000923232175409794],
  ],
  [
    [118.469393707779, 24.7819350536699, 0.000923153944313526],
    [118.468979096313, 24.7825501360613, 0.000923231244087219],
  ],
  [
    [118.469376769587, 24.78192554292, 0.000923151150345802],
    [118.468962336156, 24.7825407244289, 0.00092322938144207],
  ],
  [
    [118.469359831397, 24.7819160321681, 0.000923152081668377],
    [118.468945585899, 24.7825313218145, 0.000923228450119495],
  ],
  [
    [118.469342893218, 24.781906530442, 0.000923150219023228],
    [118.468928825756, 24.7825219192061, 0.000923227518796921],
  ],
  [
    [118.469325945154, 24.7818970287219, 0.000923148356378078],
    [118.468912065616, 24.7825125165958, 0.000923227518796921],
  ],
  [
    [118.4693089971, 24.7818875360275, 0.000923148356378078],
    [118.468895295598, 24.7825031230192, 0.000923226587474346],
  ],
  [
    [118.46929204905, 24.7818780433312, 0.000923146493732929],
    [118.468878525592, 24.7824937384684, 0.000923224724829197],
  ],
  [
    [118.46927510101, 24.7818685596606, 0.00092314463108778],
    [118.468861755588, 24.7824843539157, 0.000923223793506622],
  ],
  [
    [118.469258143084, 24.781859075996, 0.00092314463108778],
    [118.468844985586, 24.782474969361, 0.000923222862184048],
  ],
  [
    [118.46924118517, 24.7818496013572, 0.000923142768442631],
    [118.468828205707, 24.7824655938401, 0.000923221930861473],
  ],
  [
    [118.469224227258, 24.7818401267165, 0.000923141837120056],
    [118.46881142583, 24.7824562183173, 0.000923219136893749],
  ],
  [
    [118.469207269349, 24.7818306520738, 0.000923141837120056],
    [118.468794645965, 24.7824468518202, 0.000923218205571175],
  ],
  [
    [118.469190301563, 24.7818211864647, 0.000923140905797482],
    [118.468777866102, 24.7824374853213, 0.0009232172742486],
  ],
  [
    [118.469173333788, 24.7818117298815, 0.000923137180507183],
    [118.468761076362, 24.7824281278561, 0.000923216342926025],
  ],
  [
    [118.469156356118, 24.7818022642764, 0.000923135317862034],
    [118.468744286624, 24.7824187703889, 0.000923215411603451],
  ],
  [
    [118.469139388356, 24.781792816717, 0.000923136249184608],
    [118.468727496889, 24.7824094129198, 0.000923214480280876],
  ],
  [
    [118.469122410709, 24.7817833691635, 0.000923136249184608],
    [118.468710697276, 24.7824000644844, 0.000923212617635727],
  ],
  [
    [118.469105433064, 24.781773921608, 0.000923133455216885],
    [118.468693897674, 24.7823907250748, 0.000923209823668003],
  ],
  [
    [118.469088445542, 24.7817644830862, 0.00092313252389431],
    [118.468677098075, 24.7823813856633, 0.000923208892345428],
  ],
  [
    [118.469071458023, 24.7817550445625, 0.000923130661249161],
    [118.468660298479, 24.7823720462499, 0.000923208892345428],
  ],
  [
    [118.469054470506, 24.7817456060368, 0.000923130661249161],
    [118.468643489005, 24.7823627158702, 0.000923207961022854],
  ],
  [
    [118.469037483008, 24.7817361855645, 0.000923128798604012],
    [118.468626679533, 24.7823533854885, 0.000923206098377705],
  ],
  [
    [118.469020485617, 24.7817267560705, 0.000923127867281437],
    [118.468609870073, 24.7823440641327, 0.00092320516705513],
  ],
  [
    [118.469003488236, 24.7817173356023, 0.000923126004636288],
    [118.468593050726, 24.7823347427828, 0.000923204235732555],
  ],
  [
    [118.468986490867, 24.7817079241598, 0.000923125073313713],
    [118.46857624128, 24.7823254304509, 0.000923203304409981],
  ],
  [
    [118.4689694935, 24.7816985127154, 0.000923123210668564],
    [118.468559421947, 24.7823161181249, 0.000923202373087406],
  ],
  [
    [118.468952486247, 24.7816891012769, 0.000923122279345989],
    [118.468542592736, 24.7823068148325, 0.000923200510442257],
  ],
  [
    [118.468935479006, 24.7816796988641, 0.000923121348023415],
    [118.468525773417, 24.7822975115304, 0.000923198647797108],
  ],
  [
    [118.468918471767, 24.7816702964494, 0.000923119485378265],
    [118.468508944212, 24.7822882082342, 0.000923197716474533],
  ],
  [
    [118.46890145465, 24.7816609030683, 0.000923118554055691],
    [118.468492105129, 24.7822789139716, 0.000923197716474533],
  ],
  [
    [118.468884437537, 24.7816515096853, 0.000923117622733116],
    [118.468475275938, 24.7822696196993, 0.000923194922506809],
  ],
  [
    [118.468867420434, 24.781642125328, 0.000923116691410542],
    [118.468458436869, 24.7822603344607, 0.000923193991184235],
  ],
  [
    [118.468850403334, 24.7816327409688, 0.000923115760087967],
    [118.46844159781, 24.7822510582478, 0.000923193991184235],
  ],
  [
    [118.468833376357, 24.7816233656432, 0.000923114828765392],
    [118.468424758746, 24.7822417730053, 0.000923192128539085],
  ],
  [
    [118.468816349382, 24.7816139903157, 0.000923112966120243],
    [118.468407909813, 24.7822325058242, 0.000923192128539085],
  ],
  [
    [118.468799322418, 24.7816046240139, 0.000923112034797668],
    [118.468391070763, 24.7822232296056, 0.000923190265893936],
  ],
  [
    [118.468782285569, 24.781595257718, 0.000923111103475094],
    [118.468374211955, 24.7822139714562, 0.000923189334571362],
  ],
  [
    [118.468765248722, 24.7815858914201, 0.000923109240829945],
    [118.468357363029, 24.7822047042693, 0.000923186540603638],
  ],
  [
    [118.468748211886, 24.781576534148, 0.000923109240829945],
    [118.468340504226, 24.782195446116, 0.000923187471926212],
  ],
  [
    [118.468731175052, 24.7815671768739, 0.000923106446862221],
    [118.468323645435, 24.7821861969886, 0.000923184677958488],
  ],
  [
    [118.468714128342, 24.7815578286335, 0.000923106446862221],
    [118.468306786645, 24.7821769478592, 0.000923184677958488],
  ],
  [
    [118.468697081642, 24.7815484894188, 0.000923104584217072],
    [118.468289927858, 24.7821676987279, 0.000923181883990765],
  ],
  [
    [118.468680034945, 24.7815391502021, 0.000923104584217072],
    [118.468273059194, 24.7821584586302, 0.000923182815313339],
  ],
  [
    [118.468662978363, 24.7815298109913, 0.000923102721571922],
    [118.468256190532, 24.7821492185306, 0.00092318095266819],
  ],
  [
    [118.468645931679, 24.7815204807985, 0.000923100858926773],
    [118.468239311993, 24.7821399874646, 0.000923180021345615],
  ],
  [
    [118.46862887511, 24.7815111506115, 0.000923099927604198],
    [118.468222443353, 24.7821307654167, 0.000923178158700466],
  ],
  [
    [118.468611808664, 24.7815018294581, 0.000923099927604198],
    [118.468205564819, 24.7821215343468, 0.000923177227377892],
  ],
  [
    [118.468594752108, 24.7814925082949, 0.000923098064959049],
    [118.468188686304, 24.7821123213305, 0.000923177227377892],
  ],
  [
    [118.468577685667, 24.7814831871376, 0.0009230962023139],
    [118.468171797895, 24.7821030992924, 0.000923175364732742],
  ],
  [
    [118.468560619236, 24.781473875006, 0.0009230962023139],
    [118.468154919385, 24.7820938862722, 0.000923175364732742],
  ],
  [
    [118.468543542929, 24.7814645719081, 0.000923093408346176],
    [118.468138030998, 24.7820846822856, 0.000923172570765018],
  ],
  [
    [118.468526476512, 24.7814552688003, 0.000923093408346176],
    [118.468121132725, 24.782075478305, 0.00092316884547472],
  ],
  [
    [118.46850940021, 24.7814459656984, 0.000923092477023602],
    [118.468104244342, 24.7820662743146, 0.000923171639442444],
  ],
  [
    [118.46849231403, 24.7814366716301, 0.000923091545701027],
    [118.468087346083, 24.7820570793578, 0.000923169776797295],
  ],
  [
    [118.46847523775, 24.7814273865796, 0.000923089683055878],
    [118.468070447834, 24.7820478934267, 0.000923167914152145],
  ],
  [
    [118.468458151575, 24.7814180925074, 0.000923088751733303],
    [118.468053549588, 24.7820387074938, 0.000923166051506996],
  ],
  [
    [118.46844106542, 24.7814088164886, 0.000923086889088154],
    [118.468036641455, 24.7820295215667, 0.000923165120184422],
  ],
  [
    [118.468423969379, 24.7813995404756, 0.000923085957765579],
    [118.468019733334, 24.7820203446654, 0.000923165120184422],
  ],
  [
    [118.468406883229, 24.7813902644529, 0.000923085026443005],
    [118.468002825216, 24.7820111677623, 0.000923162326216698],
  ],
  [
    [118.468389787201, 24.7813809974637, 0.00092308409512043],
    [118.467985917108, 24.7820019998848, 0.000923163257539272],
  ],
  [
    [118.468372691176, 24.7813717304726, 0.000923081301152706],
    [118.467968999114, 24.7819928320133, 0.000923160463571548],
  ],
  [
    [118.468355585266, 24.7813624634873, 0.000923082232475281],
    [118.467952081132, 24.7819836731675, 0.000923159532248974],
  ],
  [
    [118.468338479366, 24.7813532055278, 0.000923082232475281],
    [118.467935163151, 24.7819745143198, 0.000923158600926399],
  ],
  [
    [118.468321373477, 24.781343956594, 0.000923079438507557],
    [118.467918235285, 24.781965355478, 0.00092315673828125],
  ],
  [
    [118.468304267591, 24.7813347076582, 0.000923077575862408],
    [118.46790130743, 24.781956205662, 0.000923155806958675],
  ],
  [
    [118.468287151828, 24.781325467756, 0.000923076644539833],
    [118.467884379586, 24.7819470648717, 0.000923154875636101],
  ],
  [
    [118.468270036067, 24.7813162278519, 0.000923074781894684],
    [118.467867451744, 24.7819379240795, 0.000923154875636101],
  ],
  [
    [118.468252920309, 24.7813069879457, 0.000923074781894684],
    [118.467850514016, 24.7819287832932, 0.000923153012990952],
  ],
  [
    [118.468235804562, 24.7812977570653, 0.000923073850572109],
    [118.467833576299, 24.7819196515326, 0.000923151150345802],
  ],
  [
    [118.468218678928, 24.7812885261907, 0.000923072919249535],
    [118.467816638585, 24.7819105197701, 0.000923151150345802],
  ],
  [
    [118.468201553306, 24.7812793043419, 0.00092307198792696],
    [118.467799700882, 24.7819013970334, 0.000923150219023228],
  ],
  [
    [118.468184427687, 24.7812700824911, 0.000923071056604385],
    [118.467782753293, 24.7818922743026, 0.000923148356378078],
  ],
  [
    [118.46816729219, 24.7812608696738, 0.000923068262636662],
    [118.467765805714, 24.7818831605975, 0.000923147425055504],
  ],
  [
    [118.468150166584, 24.7812516568467, 0.000923066399991512],
    [118.467748858139, 24.7818740468905, 0.000923147425055504],
  ],
  [
    [118.468133031101, 24.7812424530532, 0.000923067331314087],
    [118.467731900685, 24.781864942217, 0.000923143699765205],
  ],
  [
    [118.468115885731, 24.7812332492656, 0.000923065468668938],
    [118.467714943234, 24.7818558375416, 0.00092314463108778],
  ],
  [
    [118.468098750262, 24.7812240544958, 0.000923064537346363],
    [118.467697985786, 24.7818467328643, 0.000923141837120056],
  ],
  [
    [118.468081604906, 24.7812148597319, 0.000923063606023788],
    [118.467681028349, 24.7818376372128, 0.000923141837120056],
  ],
  [
    [118.468064459553, 24.781205664966, 0.000923060812056065],
    [118.467664061034, 24.7818285505948, 0.000923140905797482],
  ],
  [
    [118.468047304322, 24.7811964792336, 0.000923060812056065],
    [118.467647093721, 24.7818194639749, 0.000923139043152332],
  ],
  [
    [118.468030149103, 24.781187302527, 0.00092305988073349],
    [118.467630126411, 24.781810377353, 0.000923138111829758],
  ],
  [
    [118.468012993886, 24.7811781258184, 0.000923058018088341],
    [118.467613159113, 24.7818012997569, 0.000923135317862034],
  ],
  [
    [118.467995838672, 24.7811689491078, 0.000923056155443192],
    [118.467596181928, 24.7817922221666, 0.000923136249184608],
  ],
  [
    [118.467978683469, 24.7811597814229, 0.000923057086765766],
    [118.467579204754, 24.7817831536021, 0.000923136249184608],
  ],
  [
    [118.467961518388, 24.7811506227716, 0.000923055224120617],
    [118.467562227582, 24.7817740850357, 0.000923133455216885],
  ],
  [
    [118.467944353301, 24.7811414550905, 0.000923052430152893],
    [118.467545240533, 24.7817650255028, 0.000923133455216885],
  ],
  [
    [118.467927178346, 24.7811323054707, 0.000923052430152893],
    [118.467528253486, 24.7817559659679, 0.000923129729926586],
  ],
  [
    [118.467910013272, 24.7811231468134, 0.000923049636185169],
    [118.467511266451, 24.7817469154589, 0.000923130661249161],
  ],
  [
    [118.46789283833, 24.7811140062174, 0.000923049636185169],
    [118.467494279418, 24.7817378649479, 0.000923129729926586],
  ],
  [
    [118.467875663382, 24.7811048565916, 0.000923049636185169],
    [118.467477282498, 24.7817288144427, 0.000923126935958862],
  ],
  [
    [118.467858478557, 24.7810957159993, 0.00092304777354002],
    [118.467460295479, 24.7817197729555, 0.000923126004636288],
  ],
  [
    [118.467841293743, 24.7810865844328, 0.000923046842217445],
    [118.467443288693, 24.7817107405096, 0.000923126004636288],
  ],
  [
    [118.467824108931, 24.7810774528643, 0.000923046842217445],
    [118.467426291798, 24.781701708054, 0.000923124141991138],
  ],
  [
    [118.46780692413, 24.7810683303215, 0.000923043116927147],
    [118.467409285017, 24.7816926756042, 0.000923122279345989],
  ],
  [
    [118.467789739332, 24.7810592077767, 0.000923043116927147],
    [118.467392278247, 24.7816836521802, 0.000923121348023415],
  ],
  [
    [118.467772544647, 24.7810500852378, 0.000923042185604572],
    [118.46737527148, 24.7816746287542, 0.000923121348023415],
  ],
  [
    [118.467755379656, 24.7810409897566, 0.000923041254281998],
    [118.467358225153, 24.7816655963295, 0.00092312041670084],
  ],
  [
    [118.467738283921, 24.78103193033, 0.000923040322959423],
    [118.467341119463, 24.7816565278385, 0.000923119485378265],
  ],
  [
    [118.467721178291, 24.7810228618814, 0.000923039391636848],
    [118.467324013784, 24.7816474683733, 0.000923118554055691],
  ],
  [
    [118.467704072672, 24.7810138024586, 0.000923038460314274],
    [118.467306917988, 24.7816383998706, 0.000923115760087967],
  ],
  [
    [118.467686967047, 24.7810047340061, 0.00092303566634655],
    [118.467289812306, 24.7816293313736, 0.000923115760087967],
  ],
  [
    [118.467669861425, 24.7809956655516, 0.000923033803701401],
    [118.467272706635, 24.7816202719025, 0.000923115760087967],
  ],
  [
    [118.467652765702, 24.780986606115, 0.000923034735023975],
    [118.467255600958, 24.7816112034016, 0.000923113897442818],
  ],
  [
    [118.467635660084, 24.7809775376566, 0.000923033803701401],
    [118.467238495292, 24.7816021439264, 0.000923111103475094],
  ],
  [
    [118.467618554478, 24.7809684782239, 0.000923032872378826],
    [118.467221389619, 24.7815930754216, 0.000923111103475094],
  ],
  [
    [118.467601448865, 24.7809594097615, 0.000923031009733677],
    [118.467204293847, 24.7815840159348, 0.000923109240829945],
  ],
  [
    [118.467584343255, 24.7809503412971, 0.000923030078411102],
    [118.467187188179, 24.781574947426, 0.00092310830950737],
  ],
  [
    [118.467567247544, 24.7809412818507, 0.000923029147088528],
    [118.467170082515, 24.7815658789153, 0.000923107378184795],
  ],
  [
    [118.467550141939, 24.7809322133824, 0.000923028215765953],
    [118.467152976861, 24.7815568194303, 0.000923105515539646],
  ],
  [
    [118.467533036345, 24.7809231539399, 0.000923025421798229],
    [118.467135871201, 24.7815477509156, 0.000923105515539646],
  ],
  [
    [118.467515930745, 24.7809140854676, 0.000923025421798229],
    [118.467118775441, 24.7815386914189, 0.000923104584217072],
  ],
  [
    [118.467498825156, 24.7809050260211, 0.00092302355915308],
    [118.467101669786, 24.7815296229002, 0.000923102721571922],
  ],
  [
    [118.46748171956, 24.7808959575449, 0.000923022627830505],
    [118.467084564133, 24.7815205543796, 0.000923102721571922],
  ],
  [
    [118.467464623856, 24.7808868890589, 0.000923021696507931],
    [118.467067458492, 24.7815114948847, 0.000923100858926773],
  ],
  [
    [118.467447518274, 24.7808778296065, 0.000923021696507931],
    [118.467050352845, 24.7815024263602, 0.000923100858926773],
  ],
  [
    [118.467430412686, 24.7808687611244, 0.000923019833862782],
    [118.467033257097, 24.7814933668536, 0.000923098064959049],
  ],
  [
    [118.46741330711, 24.780859701668, 0.000923018902540207],
    [118.467016151454, 24.7814842983251, 0.0009230962023139],
  ],
  [
    [118.467396201527, 24.7808506331819, 0.000923016108572483],
    [118.466999045814, 24.7814752297946, 0.000923097133636475],
  ],
  [
    [118.467379105835, 24.7808415646861, 0.000923016108572483],
    [118.466981940185, 24.7814661702899, 0.000923095270991325],
  ],
  [
    [118.467362000266, 24.7808325052238, 0.000923014245927334],
    [118.46696483455, 24.7814571017554, 0.000923093408346176],
  ],
  [
    [118.46734489469, 24.7808234367318, 0.000923014245927334],
    [118.466947728926, 24.7814480422467, 0.000923092477023602],
  ],
  [
    [118.467327789126, 24.7808143772655, 0.000923012383282185],
    [118.466930633184, 24.7814389737006, 0.000923091545701027],
  ],
  [
    [118.467310683555, 24.7808053087695, 0.00092301145195961],
    [118.466913527565, 24.781429914188, 0.000923089683055878],
  ],
  [
    [118.467293587876, 24.7807962402639, 0.000923010520637035],
    [118.46689642194, 24.7814208456457, 0.000923089683055878],
  ],
  [
    [118.467276482319, 24.7807871807917, 0.000923008657991886],
    [118.466879316318, 24.7814117771013, 0.000923087820410728],
  ],
  [
    [118.467259376756, 24.7807781122898, 0.000923007726669312],
    [118.466862210706, 24.7814027175828, 0.000923086889088154],
  ],
  [
    [118.467242271204, 24.7807690528137, 0.000923007726669312],
    [118.466845114977, 24.7813936490268, 0.000923085957765579],
  ],
  [
    [118.467225165646, 24.7807599843079, 0.000923004932701588],
    [118.46682800937, 24.7813845895043, 0.000923083163797855],
  ],
  [
    [118.467208060099, 24.7807509248278, 0.000923004932701588],
    [118.466810903757, 24.7813755209521, 0.000923083163797855],
  ],
  [
    [118.467190964434, 24.7807418563103, 0.000923003070056438],
    [118.466793798147, 24.7813664523979, 0.000923082232475281],
  ],
  [
    [118.467173858884, 24.7807327877985, 0.000923002138733864],
    [118.466776692548, 24.7813573928695, 0.000923081301152706],
  ],
  [
    [118.467156753344, 24.7807237283125, 0.000923001207411289],
    [118.466759596831, 24.7813483243036, 0.000923080369830132],
  ],
  [
    [118.467139647798, 24.7807146597968, 0.000923000276088715],
    [118.466742491237, 24.7813392647712, 0.000923078507184982],
  ],
  [
    [118.467122542264, 24.7807056003069, 0.000922998413443565],
    [118.466725385636, 24.7813301962092, 0.000923078507184982],
  ],
  [
    [118.467105446611, 24.7806965317795, 0.000922996550798416],
    [118.466708280047, 24.7813211366728, 0.000923077575862408],
  ],
  [
    [118.467088341073, 24.7806874632579, 0.000922996550798416],
    [118.466691174452, 24.7813120681068, 0.000923075713217258],
  ],
  [
    [118.467071235546, 24.780678403762, 0.000922996550798416],
    [118.466674068859, 24.7813029995388, 0.000923074781894684],
  ],
  [
    [118.467054130013, 24.7806693352364, 0.000922993756830692],
    [118.466656973165, 24.7812939399888, 0.000923073850572109],
  ],
  [
    [118.46703702449, 24.7806602757366, 0.000922993756830692],
    [118.466639867577, 24.7812848714169, 0.00092307198792696],
  ],
  [
    [118.467019928851, 24.7806512071994, 0.000922992825508118],
    [118.466622762, 24.7812758118707, 0.000923070125281811],
  ],
  [
    [118.467002823325, 24.7806421386679, 0.000922990962862968],
    [118.466605656417, 24.7812667432948, 0.000923069193959236],
  ],
  [
    [118.46698571781, 24.7806330791621, 0.000922989100217819],
    [118.466588550837, 24.7812576747169, 0.000923067331314087],
  ],
  [
    [118.466968612289, 24.7806240106267, 0.000922989100217819],
    [118.466571455156, 24.7812486151571, 0.000923066399991512],
  ],
  [
    [118.466951506779, 24.780614951117, 0.000922989100217819],
    [118.46655434958, 24.7812395465753, 0.000923065468668938],
  ],
  [
    [118.466934401263, 24.7806058825776, 0.00092298723757267],
    [118.466537244016, 24.7812304870192, 0.000923065468668938],
  ],
  [
    [118.466917305647, 24.7805968230563, 0.000922984443604946],
    [118.466520138445, 24.7812214184334, 0.000923063606023788],
  ],
  [
    [118.466900200136, 24.7805877545129, 0.000922984443604946],
    [118.466503032877, 24.7812123498457, 0.000923062674701214],
  ],
  [
    [118.466883094627, 24.7805786859676, 0.000922981649637222],
    [118.466485937209, 24.781203290276, 0.000923062674701214],
  ],
  [
    [118.46686598913, 24.7805696264481, 0.000922982580959797],
    [118.466468831645, 24.7811942216843, 0.00092305988073349],
  ],
  [
    [118.466848883627, 24.7805605578988, 0.000922981649637222],
    [118.466451726093, 24.7811851621184, 0.00092305988073349],
  ],
  [
    [118.466831788022, 24.7805514983676, 0.000922978855669498],
    [118.466434620535, 24.7811760935227, 0.000923058018088341],
  ],
  [
    [118.466814682524, 24.7805424298144, 0.000922978855669498],
    [118.466417514988, 24.7811670339528, 0.000923058018088341],
  ],
  [
    [118.466797577028, 24.7805333612592, 0.000922977924346924],
    [118.466400409435, 24.7811579653532, 0.000923057086765766],
  ],
  [
    [118.466780471543, 24.7805243017298, 0.000922977924346924],
    [118.466383313772, 24.781148896744, 0.000923055224120617],
  ],
  [
    [118.466763366052, 24.7805152331706, 0.000922974199056625],
    [118.466366208233, 24.7811398371682, 0.000923053361475468],
  ],
  [
    [118.46674627046, 24.7805061736296, 0.000922972336411476],
    [118.466349102687, 24.7811307685627, 0.000923051498830318],
  ],
  [
    [118.466729164974, 24.7804971050665, 0.000922972336411476],
    [118.466331997152, 24.7811217089829, 0.000923051498830318],
  ],
  [
    [118.46671205949, 24.7804880365014, 0.000922971405088902],
    [118.466314891611, 24.7811126403734, 0.000923051498830318],
  ],
  [
    [118.466694954017, 24.7804789769621, 0.000922970473766327],
    [118.466297795961, 24.7811035717543, 0.000923048704862595],
  ],
  [
    [118.466677848539, 24.7804699083931, 0.000922968611121178],
    [118.466280690434, 24.7810945121686, 0.00092304777354002],
  ],
  [
    [118.466660743071, 24.7804608488499, 0.000922966748476028],
    [118.466263584901, 24.7810854435533, 0.00092304777354002],
  ],
  [
    [118.466643647486, 24.7804517802692, 0.000922967679798603],
    [118.466246479378, 24.7810763839636, 0.000923045910894871],
  ],
  [
    [118.466626542023, 24.780442720722, 0.000922966748476028],
    [118.46622937385, 24.7810673153443, 0.000923045910894871],
  ],
  [
    [118.466609436554, 24.7804336521451, 0.000922964885830879],
    [118.466212278212, 24.7810582467153, 0.000923044048249722],
  ],
  [
    [118.466592331088, 24.7804245835663, 0.00092296302318573],
    [118.466195172697, 24.7810491871198, 0.000923044048249722],
  ],
  [
    [118.466575225632, 24.7804155240132, 0.000922962091863155],
    [118.466178067176, 24.7810401184945, 0.000923041254281998],
  ],
  [
    [118.46655813006, 24.7804064554227, 0.00092296302318573],
    [118.466160961666, 24.781031058895, 0.000923040322959423],
  ],
  [
    [118.466541024609, 24.7803973958656, 0.000922960229218006],
    [118.46614385615, 24.7810219902658, 0.000923038460314274],
  ],
  [
    [118.466523919153, 24.7803883272788, 0.000922957435250282],
    [118.466126750645, 24.7810129306624, 0.000923038460314274],
  ],
  [
    [118.466506813699, 24.7803792586901, 0.000922957435250282],
    [118.466109655023, 24.7810038620216, 0.00092303566634655],
  ],
  [
    [118.466489708256, 24.7803701991271, 0.000922957435250282],
    [118.466092549514, 24.7809947933864, 0.00092303566634655],
  ],
  [
    [118.466472612695, 24.7803611305267, 0.000922955572605133],
    [118.466075444016, 24.7809857337771, 0.000923033803701401],
  ],
  [
    [118.466455507257, 24.7803520709598, 0.000922954641282558],
    [118.466058338513, 24.780976665138, 0.000923031941056252],
  ],
  [
    [118.466438401813, 24.7803430023631, 0.000922952778637409],
    [118.46604123302, 24.7809676055247, 0.000923031009733677],
  ],
  [
    [118.46642129638, 24.7803339427923, 0.000922951847314835],
    [118.46602413741, 24.780958536874, 0.000923030078411102],
  ],
  [
    [118.466404190941, 24.7803248741917, 0.00092295091599226],
    [118.466007031914, 24.780949468229, 0.000923029147088528],
  ],
  [
    [118.466387085505, 24.7803158055891, 0.000922949984669685],
    [118.465989926428, 24.7809404086098, 0.000923029147088528],
  ],
  [
    [118.466369989968, 24.7803067460046, 0.000922948122024536],
    [118.465972820937, 24.7809313399608, 0.000923028215765953],
  ],
  [
    [118.466352884536, 24.7802976773981, 0.000922948122024536],
    [118.465955715457, 24.7809222803376, 0.000923025421798229],
  ],
  [
    [118.466335779115, 24.7802886178174, 0.000922946259379387],
    [118.465938619859, 24.7809132116771, 0.000923024490475655],
  ],
  [
    [118.466318673689, 24.7802795492069, 0.000922945328056812],
    [118.465921514375, 24.7809041430222, 0.00092302355915308],
  ],
  [
    [118.466301568265, 24.7802704805945, 0.000922944396734238],
    [118.465904408902, 24.7808950833931, 0.00092302355915308],
  ],
  [
    [118.46628447274, 24.7802614210001, 0.000922943465411663],
    [118.465887303424, 24.7808860147343, 0.000923020765185356],
  ],
  [
    [118.466267367321, 24.7802523523838, 0.000922941602766514],
    [118.465870197956, 24.7808769551012, 0.000923019833862782],
  ],
  [
    [118.466250261912, 24.7802432927931, 0.000922939740121365],
    [118.465853092482, 24.7808678864385, 0.000923018902540207],
  ],
  [
    [118.466233156498, 24.7802342241728, 0.000922939740121365],
    [118.465835996907, 24.7808588267938, 0.000923017039895058],
  ],
  [
    [118.466216051086, 24.7802251555505, 0.000922937877476215],
    [118.465818891438, 24.7808497581271, 0.000923017039895058],
  ],
  [
    [118.466198955574, 24.7802160959463, 0.000922936946153641],
    [118.465801785972, 24.7808406894584, 0.000923016108572483],
  ],
  [
    [118.466181850167, 24.78020702732, 0.000922936946153641],
    [118.465784680516, 24.7808316298155, 0.000923014245927334],
  ],
  [
    [118.466164744771, 24.7801979677195, 0.000922935083508492],
    [118.465767575055, 24.7808225611429, 0.000923013314604759],
  ],
  [
    [118.466147639369, 24.7801888990893, 0.000922934152185917],
    [118.465750479493, 24.7808135014883, 0.00092301145195961],
  ],
  [
    [118.466130533979, 24.7801798394849, 0.000922932289540768],
    [118.465733374036, 24.7808044328118, 0.00092301145195961],
  ],
  [
    [118.466113428582, 24.7801707708508, 0.000922931358218193],
    [118.465716268582, 24.7807953641332, 0.000923010520637035],
  ],
  [
    [118.466096333076, 24.780161702207, 0.000922929495573044],
    [118.465699163139, 24.7807863044804, 0.000923009589314461],
  ],
  [
    [118.466079227692, 24.7801526425966, 0.000922927632927895],
    [118.46568205769, 24.7807772357979, 0.000923007726669312],
  ],
  [
    [118.466062122303, 24.7801435739566, 0.00092292670160532],
    [118.46566496214, 24.7807681761335, 0.000923004932701588],
  ],
  [
    [118.466045016924, 24.7801345143422, 0.00092292670160532],
    [118.465647856696, 24.7807591074471, 0.000923005864024162],
  ],
  [
    [118.46602791154, 24.7801254456982, 0.00092292670160532],
    [118.465630751263, 24.7807500477864, 0.000923004001379013],
  ],
  [
    [118.466010816046, 24.7801163770446, 0.000922924838960171],
    [118.465613645824, 24.780740979096, 0.000923002138733864],
  ],
  [
    [118.465993710675, 24.7801073174244, 0.000922923907637596],
    [118.465596540387, 24.7807319104036, 0.000923003070056438],
  ],
  [
    [118.465976605298, 24.7800982487744, 0.000922922044992447],
    [118.465579434962, 24.780722850737, 0.000923002138733864],
  ],
  [
    [118.465959499932, 24.7800891891502, 0.000922922044992447],
    [118.465562339418, 24.780713782033, 0.00092299934476614],
  ],
  [
    [118.46594239456, 24.7800801204964, 0.000922920182347298],
    [118.465545233997, 24.7807047223625, 0.000922998413443565],
  ],
  [
    [118.465925299079, 24.7800710518328, 0.000922919251024723],
    [118.465528128571, 24.7806956536622, 0.000922996550798416],
  ],
  [
    [118.46590819372, 24.7800619922027, 0.000922917388379574],
    [118.465511023147, 24.78068658496, 0.000922997482120991],
  ],
  [
    [118.465891088355, 24.7800529235429, 0.000922916457056999],
    [118.465493917733, 24.7806775252835, 0.000922994688153267],
  ],
  [
    [118.465873983002, 24.7800438639089, 0.00092291459441185],
    [118.465476822202, 24.7806684565697, 0.000922994688153267],
  ],
  [
    [118.465856877642, 24.7800347952451, 0.00092291459441185],
    [118.465459716794, 24.7806593968892, 0.000922993756830692],
  ],
  [
    [118.465839772293, 24.7800257356071, 0.000922912731766701],
    [118.465442611379, 24.7806503281791, 0.000922990962862968],
  ],
  [
    [118.465822676827, 24.7800166669318, 0.000922911800444126],
    [118.465425505968, 24.780641259467, 0.000922990031540394],
  ],
  [
    [118.465805571475, 24.7800075982621, 0.000922911800444126],
    [118.465408400567, 24.7806321997806, 0.000922990031540394],
  ],
  [
    [118.465788466133, 24.7799985386182, 0.000922909006476402],
    [118.465391305048, 24.780623131057, 0.000922988168895245],
  ],
  [
    [118.465771360786, 24.7799894699446, 0.000922909006476402],
    [118.465374199652, 24.7806140713667, 0.000922986306250095],
  ],
  [
    [118.46575425545, 24.7799804102967, 0.000922909006476402],
    [118.46535709425, 24.7806050026466, 0.000922986306250095],
  ],
  [
    [118.465737159996, 24.7799713416115, 0.000922907143831253],
    [118.465339988859, 24.7805959429524, 0.000922985374927521],
  ],
  [
    [118.465720054656, 24.7799622729319, 0.000922904349863529],
    [118.465322883462, 24.7805868742284, 0.000922985374927521],
  ],
  [
    [118.465702949327, 24.7799532132782, 0.000922903418540955],
    [118.465305778068, 24.7805778055025, 0.000922984443604946],
  ],
  [
    [118.465685843992, 24.7799441445947, 0.000922903418540955],
    [118.465288682572, 24.7805687457947, 0.000922981649637222],
  ],
  [
    [118.465668738668, 24.7799350849369, 0.000922901555895805],
    [118.465271577183, 24.7805596770648, 0.000922980718314648],
  ],
  [
    [118.465651633338, 24.7799260162495, 0.000922901555895805],
    [118.465254471804, 24.7805506173607, 0.000922978855669498],
  ],
  [
    [118.465634537899, 24.7799169475524, 0.000922899693250656],
    [118.46523736642, 24.7805415486269, 0.000922978855669498],
  ],
  [
    [118.465617432582, 24.7799078878888, 0.000922898761928082],
    [118.465220261038, 24.7805324798911, 0.000922976993024349],
  ],
  [
    [118.46560032726, 24.7798988191954, 0.000922896899282932],
    [118.465203165555, 24.7805234201734, 0.0009229751303792],
  ],
  [
    [118.465583221948, 24.7798897595278, 0.000922895036637783],
    [118.465186060177, 24.7805143514337, 0.0009229751303792],
  ],
  [
    [118.465566116631, 24.7798806908305, 0.000922894105315208],
    [118.465168954811, 24.7805052917197, 0.000922974199056625],
  ],
  [
    [118.465549021212, 24.7798716311513, 0.000922893173992634],
    [118.465151849439, 24.780496222976, 0.000922973267734051],
  ],
  [
    [118.4655319159, 24.77986256245, 0.000922893173992634],
    [118.465134744069, 24.7804871542303, 0.000922971405088902],
  ],
  [
    [118.46551481059, 24.7798534937468, 0.000922892242670059],
    [118.465117648599, 24.7804780945028, 0.000922969542443752],
  ],
  [
    [118.465497705291, 24.7798444340693, 0.00092289038002491],
    [118.465100543234, 24.7804690257532, 0.000922970473766327],
  ],
  [
    [118.465480599986, 24.7798353653622, 0.000922888517379761],
    [118.46508343788, 24.7804599660294, 0.000922967679798603],
  ],
  [
    [118.46546350458, 24.7798263056731, 0.000922888517379761],
    [118.46506633252, 24.7804508972758, 0.000922966748476028],
  ],
  [
    [118.465446399279, 24.779817236962, 0.000922887586057186],
    [118.465049227171, 24.780441837548, 0.000922965817153454],
  ],
  [
    [118.465429293982, 24.7798081682489, 0.000922883860766888],
    [118.465032121817, 24.7804327687905, 0.000922965817153454],
  ],
  [
    [118.465412188695, 24.7797991085615, 0.000922884792089462],
    [118.465015026353, 24.7804237000234, 0.00092296302318573],
  ],
  [
    [118.465395083402, 24.7797900398445, 0.000922882929444313],
    [118.464997921011, 24.7804146402897, 0.00092296302318573],
  ],
  [
    [118.46537797812, 24.7797809801532, 0.000922883860766888],
    [118.464980815664, 24.7804055715262, 0.000922962091863155],
  ],
  [
    [118.465360882721, 24.7797719114246, 0.000922881066799164],
    [118.464963710327, 24.7803965117886, 0.000922958366572857],
  ],
  [
    [118.465343777436, 24.7797628427016, 0.000922881066799164],
    [118.464946604985, 24.7803874430212, 0.000922959297895432],
  ],
  [
    [118.465326672161, 24.7797537830044, 0.000922877341508865],
    [118.464929509533, 24.7803783742442, 0.000922957435250282],
  ],
  [
    [118.465309566881, 24.7797447142775, 0.00092287827283144],
    [118.464912404204, 24.7803693145006, 0.000922955572605133],
  ],
  [
    [118.465292461611, 24.7797356545763, 0.000922875478863716],
    [118.464895298869, 24.7803602457273, 0.000922955572605133],
  ],
  [
    [118.465275366224, 24.7797265858378, 0.000922876410186291],
    [118.464878193545, 24.7803511859798, 0.000922954641282558],
  ],
  [
    [118.46525826096, 24.7797175261327, 0.000922873616218567],
    [118.464861088215, 24.7803421172025, 0.000922953709959984],
  ],
  [
    [118.465241155689, 24.7797084573979, 0.000922873616218567],
    [118.464843982887, 24.7803330484233, 0.000922951847314835],
  ],
  [
    [118.465224050422, 24.7796993886611, 0.000922871753573418],
    [118.464826887459, 24.7803239886622, 0.000922949984669685],
  ],
  [
    [118.465206945164, 24.7796903289501, 0.000922871753573418],
    [118.464809782136, 24.7803149198791, 0.000922949984669685],
  ],
  [
    [118.46518984979, 24.7796812602017, 0.000922869890928268],
    [118.464792676825, 24.7803058601217, 0.000922947190701962],
  ],
  [
    [118.465172744538, 24.7796722004868, 0.00092286616563797],
    [118.464775571507, 24.7802967913345, 0.000922948122024536],
  ],
  [
    [118.46515563928, 24.7796631317421, 0.00092286616563797],
    [118.4647584662, 24.7802877315732, 0.000922946259379387],
  ],
  [
    [118.465138534024, 24.7796540629954, 0.000922868028283119],
    [118.464741370776, 24.7802786627745, 0.000922946259379387],
  ],
  [
    [118.46512142878, 24.7796450032745, 0.000922865234315395],
    [118.464724265466, 24.7802695939815, 0.000922943465411663],
  ],
  [
    [118.465104323529, 24.7796359345239, 0.000922865234315395],
    [118.464707160166, 24.7802605342142, 0.000922942534089088],
  ],
  [
    [118.465087228178, 24.7796268747915, 0.000922862440347672],
    [118.464690054861, 24.7802514654172, 0.000922941602766514],
  ],
  [
    [118.465070122932, 24.7796178060369, 0.000922862440347672],
    [118.464672949567, 24.780242405646, 0.000922940671443939],
  ],
  [
    [118.465053017697, 24.7796087463081, 0.000922861509025097],
    [118.464655854155, 24.7802333368375, 0.000922939740121365],
  ],
  [
    [118.465035912457, 24.7795996775496, 0.000922858715057373],
    [118.464638748857, 24.7802242680345, 0.000922939740121365],
  ],
  [
    [118.465018807218, 24.7795906087891, 0.000922857783734798],
    [118.46462164357, 24.7802152082574, 0.000922936946153641],
  ],
  [
    [118.465001711879, 24.7795815490468, 0.000922858715057373],
    [118.464604538277, 24.7802061394505, 0.000922936014831066],
  ],
  [
    [118.464984606646, 24.7795724802824, 0.000922854989767075],
    [118.464587432995, 24.7801970796694, 0.000922935083508492],
  ],
  [
    [118.464967501424, 24.7795634205437, 0.000922854989767075],
    [118.464570327707, 24.7801880108586, 0.000922933220863342],
  ],
  [
    [118.464950396195, 24.7795543517754, 0.0009228540584445],
    [118.464553232319, 24.780178951066, 0.000922931358218193],
  ],
  [
    [118.46493329097, 24.779545283005, 0.000922851264476776],
    [118.464536127036, 24.7801698822512, 0.000922930426895618],
  ],
  [
    [118.464916195643, 24.7795362232528, 0.000922851264476776],
    [118.464519021755, 24.7801608134345, 0.000922930426895618],
  ],
  [
    [118.464899090422, 24.7795271544786, 0.000922850333154202],
    [118.464501916486, 24.7801517536435, 0.000922928564250469],
  ],
  [
    [118.464881985212, 24.77951809473, 0.000922849401831627],
    [118.46448481121, 24.7801426848229, 0.000922927632927895],
  ],
  [
    [118.464864879996, 24.7795090259518, 0.000922848470509052],
    [118.464467715834, 24.7801336250204, 0.00092292670160532],
  ],
  [
    [118.464847774783, 24.7794999571716, 0.000922847539186478],
    [118.464450610563, 24.7801245561958, 0.000922927632927895],
  ],
  [
    [118.46483066958, 24.7794908974171, 0.000922846607863903],
    [118.464433505295, 24.7801154873692, 0.000922923907637596],
  ],
  [
    [118.46481357426, 24.7794818286254, 0.000922844745218754],
    [118.464416400038, 24.7801064275683, 0.000922924838960171],
  ],
  [
    [118.464796469063, 24.779472768867, 0.00092284195125103],
    [118.464399294775, 24.7800973587378, 0.000922922044992447],
  ],
  [
    [118.464779363859, 24.7794637000789, 0.000922841019928455],
    [118.464382199411, 24.7800882989254, 0.000922921113669872],
  ],
  [
    [118.464762258667, 24.7794546403165, 0.00092284195125103],
    [118.464365094153, 24.7800792300909, 0.000922919251024723],
  ],
  [
    [118.464745153468, 24.7794455715244, 0.000922841019928455],
    [118.464347988897, 24.7800701612545, 0.000922917388379574],
  ],
  [
    [118.46472805816, 24.7794365027228, 0.000922839157283306],
    [118.464330883653, 24.7800611014438, 0.000922918319702148],
  ],
  [
    [118.464710952975, 24.7794274429546, 0.000922838225960732],
    [118.464313778402, 24.7800520326034, 0.000922917388379574],
  ],
  [
    [118.464693847784, 24.7794183741566, 0.000922836363315582],
    [118.464296673162, 24.7800429727887, 0.00092291459441185],
  ],
  [
    [118.464676742604, 24.7794093143844, 0.000922836363315582],
    [118.464279577805, 24.7800339039368, 0.000922913663089275],
  ],
  [
    [118.464659637418, 24.7794002455824, 0.000922833569347858],
    [118.46426247257, 24.7800248441182, 0.000922912731766701],
  ],
  [
    [118.464642542123, 24.779391176771, 0.000922833569347858],
    [118.464245367329, 24.7800157752699, 0.000922911800444126],
  ],
  [
    [118.46462543695, 24.7793821169928, 0.000922832638025284],
    [118.464228262091, 24.7800067064196, 0.000922909937798977],
  ],
  [
    [118.464608331771, 24.779373048185, 0.000922831706702709],
    [118.464211156863, 24.7799976465951, 0.000922909006476402],
  ],
  [
    [118.464591226603, 24.7793639884029, 0.00092282984405756],
    [118.464194061518, 24.7799885777333, 0.000922909006476402],
  ],
  [
    [118.46457412143, 24.7793549195911, 0.000922827981412411],
    [118.464176956296, 24.7799795179048, 0.000922907143831253],
  ],
  [
    [118.464557016258, 24.7793458507773, 0.000922827981412411],
    [118.464159851067, 24.7799704490466, 0.000922906212508678],
  ],
  [
    [118.464539920986, 24.7793367909818, 0.000922825187444687],
    [118.464142745841, 24.7799613801865, 0.000922906212508678],
  ],
  [
    [118.46452281582, 24.779327722164, 0.000922824256122112],
    [118.464125640626, 24.7799523203521, 0.000922904349863529],
  ],
  [
    [118.464505710664, 24.7793186623721, 0.000922823324799538],
    [118.464108545294, 24.7799432514804, 0.00092290248721838],
  ],
  [
    [118.464488605503, 24.7793095935504, 0.000922824256122112],
    [118.464091440084, 24.7799341916421, 0.00092290248721838],
  ],
  [
    [118.464471500353, 24.7793005337545, 0.000922820530831814],
    [118.464074334868, 24.779925122774, 0.000922900624573231],
  ],
  [
    [118.464454405085, 24.7792914649214, 0.000922821462154388],
    [118.464057229654, 24.779916053904, 0.000922898761928082],
  ],
  [
    [118.464437299931, 24.7792823960938, 0.000922819599509239],
    [118.464040124451, 24.7799069940598, 0.000922898761928082],
  ],
  [
    [118.464420194788, 24.7792733362919, 0.000922815874218941],
    [118.464023019243, 24.7798979251858, 0.000922897830605507],
  ],
  [
    [118.464403089639, 24.7792642674604, 0.00092281773686409],
    [118.464005923933, 24.77988886533, 0.000922896899282932],
  ],
  [
    [118.464385984501, 24.7792552076546, 0.000922816805541515],
    [118.46398881873, 24.7798797964521, 0.000922894105315208],
  ],
  [
    [118.464368889245, 24.7792461388116, 0.000922815874218941],
    [118.463971713537, 24.7798707366, 0.000922895036637783],
  ],
  [
    [118.464351784104, 24.7792370699742, 0.000922814011573792],
    [118.463954608338, 24.7798616677181, 0.000922894105315208],
  ],
  [
    [118.464334678973, 24.7792280101625, 0.000922813080251217],
    [118.463937503142, 24.7798525988343, 0.000922891311347485],
  ],
  [
    [118.464317573836, 24.7792189413211, 0.000922813080251217],
    [118.463920407845, 24.7798435389687, 0.000922889448702335],
  ],
  [
    [118.464300468711, 24.7792098815054, 0.000922810286283493],
    [118.463903302654, 24.7798344700809, 0.000922888517379761],
  ],
  [
    [118.464283363579, 24.7792008126601, 0.000922811217606068],
    [118.463886197474, 24.7798254102189, 0.000922888517379761],
  ],
  [
    [118.464266268338, 24.7791917438052, 0.000922807492315769],
    [118.463869092288, 24.7798163413271, 0.000922887586057186],
  ],
  [
    [118.46424916322, 24.7791826839836, 0.000922807492315769],
    [118.463851987104, 24.7798072724334, 0.000922885723412037],
  ],
  [
    [118.464232058096, 24.7791736151324, 0.000922804698348045],
    [118.463834891819, 24.7797982125579, 0.000922884792089462],
  ],
  [
    [118.464214952983, 24.7791645553068, 0.000922804698348045],
    [118.46381778664, 24.7797891436603, 0.000922884792089462],
  ],
  [
    [118.464197847863, 24.7791554864516, 0.000922804698348045],
    [118.463800681472, 24.7797800837884, 0.000922881066799164],
  ],
  [
    [118.464180752643, 24.7791464266146, 0.000922801904380322],
    [118.463783576299, 24.7797710148868, 0.000922882929444313],
  ],
  [
    [118.464163647529, 24.7791373577555, 0.000922801904380322],
    [118.463766471127, 24.7797619459832, 0.000922881066799164],
  ],
  [
    [118.464146542417, 24.7791282888943, 0.000922799110412598],
    [118.463749365967, 24.7797528861054, 0.00092287827283144],
  ],
  [
    [118.464129437316, 24.779119229059, 0.000922800041735172],
    [118.463732270689, 24.7797438171904, 0.00092287827283144],
  ],
  [
    [118.46411233221, 24.7791101601939, 0.000922797247767448],
    [118.463715165533, 24.7797347573086, 0.000922875478863716],
  ],
  [
    [118.464095237002, 24.779101100347, 0.000922797247767448],
    [118.463698060372, 24.7797256883971, 0.000922876410186291],
  ],
  [
    [118.4640781319, 24.779092031478, 0.000922794453799725],
    [118.463680955213, 24.7797166194837, 0.000922874547541142],
  ],
  [
    [118.464061026809, 24.7790829716347, 0.000922794453799725],
    [118.463663850065, 24.779707559596, 0.000922872684895992],
  ],
  [
    [118.464043931601, 24.7790739027542, 0.000922794453799725],
    [118.463646744911, 24.7796984906786, 0.000922871753573418],
  ],
  [
    [118.464026836403, 24.7790648428994, 0.000922792591154575],
    [118.463629629871, 24.7796894217667, 0.000922869890928268],
  ],
  [
    [118.464009741207, 24.7790557830427, 0.000922791659832001],
    [118.463612524722, 24.7796803528454, 0.000922868959605694],
  ],
  [
    [118.463992646015, 24.779046723184, 0.000922788865864277],
    [118.463595409679, 24.7796712749019, 0.000922868959605694],
  ],
  [
    [118.463975550816, 24.7790376542956, 0.000922788865864277],
    [118.463578304535, 24.7796622059766, 0.000922867096960545],
  ],
  [
    [118.463958465516, 24.7790285944254, 0.000922787934541702],
    [118.463561189505, 24.7796531370568, 0.000922865234315395],
  ],
  [
    [118.463941370331, 24.7790195345608, 0.000922786071896553],
    [118.463544074469, 24.7796440591073, 0.000922864302992821],
  ],
  [
    [118.463924285036, 24.7790104746867, 0.000922784209251404],
    [118.463526959436, 24.7796349811559, 0.000922863371670246],
  ],
  [
    [118.463907199744, 24.7790014148107, 0.000922785140573978],
    [118.463509844414, 24.7796259122302, 0.000922862440347672],
  ],
  [
    [118.463890114454, 24.7789923549326, 0.000922783277928829],
    [118.463492729386, 24.7796168342748, 0.000922860577702522],
  ],
  [
    [118.463873029158, 24.7789832860249, 0.000922783277928829],
    [118.463475614352, 24.7796077472897, 0.000922860577702522],
  ],
  [
    [118.463855953762, 24.7789742261354, 0.000922780483961105],
    [118.46345848944, 24.7795986693378, 0.000922859646379948],
  ],
  [
    [118.46383886848, 24.7789651662514, 0.000922779552638531],
    [118.46344137442, 24.7795895913765, 0.000922858715057373],
  ],
  [
    [118.463821793088, 24.778956106358, 0.000922779552638531],
    [118.463424259393, 24.7795805043855, 0.000922856852412224],
  ],
  [
    [118.463804717691, 24.7789470374349, 0.000922778621315956],
    [118.463407134481, 24.7795714174, 0.000922855921089649],
  ],
  [
    [118.463787642304, 24.7789379775375, 0.000922775827348232],
    [118.46339001946, 24.779562330405, 0.0009228540584445],
  ],
  [
    [118.46377056692, 24.7789289176381, 0.000922774896025658],
    [118.463372894552, 24.7795532434155, 0.0009228540584445],
  ],
  [
    [118.463753501418, 24.7789198487016, 0.000922773964703083],
    [118.46335576964, 24.7795441473963, 0.000922852195799351],
  ],
  [
    [118.463736435927, 24.7789107887908, 0.000922772102057934],
    [118.463338654626, 24.7795350603954, 0.000922852195799351],
  ],
  [
    [118.46371937043, 24.7789017198503, 0.000922773033380508],
    [118.463321529718, 24.7795259643723, 0.000922849401831627],
  ],
  [
    [118.463702304944, 24.7788926599356, 0.000922770239412785],
    [118.463304404812, 24.7795168683471, 0.000922849401831627],
  ],
  [
    [118.463685239452, 24.7788835909912, 0.00092276930809021],
    [118.463287279901, 24.7795077632923, 0.000922847539186478],
  ],
  [
    [118.463668183851, 24.7788745220373, 0.000922767445445061],
    [118.463270155001, 24.7794986672632, 0.000922845676541328],
  ],
  [
    [118.463651128261, 24.7788654621092, 0.000922768376767635],
    [118.463253039983, 24.779489562197, 0.000922844745218754],
  ],
  [
    [118.463634072665, 24.7788563931514, 0.000922764651477337],
    [118.463235915079, 24.7794804571362, 0.000922843813896179],
  ],
  [
    [118.463617017071, 24.7788473241917, 0.000922763720154762],
    [118.463218790178, 24.7794713520735, 0.000922843813896179],
  ],
  [
    [118.46359997136, 24.7788382461947, 0.000922763720154762],
    [118.463201665271, 24.7794622379811, 0.00092284195125103],
  ],
  [
    [118.463582925659, 24.7788291772235, 0.000922763720154762],
    [118.463184540366, 24.7794531238866, 0.00092284195125103],
  ],
  [
    [118.463565879961, 24.7788201082504, 0.000922760926187038],
    [118.463167415464, 24.7794440097902, 0.000922839157283306],
  ],
  [
    [118.463548834258, 24.7788110302475, 0.000922759063541889],
    [118.463150290565, 24.7794348956918, 0.000922840088605881],
  ],
  [
    [118.463531798453, 24.778801961263, 0.000922759994864464],
    [118.46313316566, 24.7794257725638, 0.000922837294638157],
  ],
  [
    [118.463514762642, 24.7787928832487, 0.000922756269574165],
    [118.463116040757, 24.7794166494337, 0.000922837294638157],
  ],
  [
    [118.463497726834, 24.7787838052325, 0.000922756269574165],
    [118.463098915857, 24.7794075263016, 0.000922833569347858],
  ],
  [
    [118.463480691028, 24.7787747272143, 0.000922755338251591],
    [118.463081790952, 24.7793983941399, 0.000922832638025284],
  ],
  [
    [118.463463665105, 24.778765640159, 0.000922754406929016],
    [118.463064666048, 24.7793892619762, 0.000922832638025284],
  ],
  [
    [118.463446629304, 24.7787565621369, 0.000922753475606442],
    [118.463047541147, 24.7793801298104, 0.000922830775380135],
  ],
  [
    [118.463429613275, 24.7787474750701, 0.000922752544283867],
    [118.463030416249, 24.7793709976428, 0.000922830775380135],
  ],
  [
    [118.463412587367, 24.7787383970366, 0.000922750681638718],
    [118.463013291345, 24.7793618564454, 0.000922828912734985],
  ],
  [
    [118.463395571342, 24.778729309966, 0.000922751612961292],
    [118.462996166444, 24.779352715246, 0.00092282984405756],
  ],
  [
    [118.463378555311, 24.7787202138656, 0.000922748818993568],
    [118.462979041537, 24.7793435650169, 0.000922827050089836],
  ],
  [
    [118.463361539291, 24.7787111267911, 0.000922747887670994],
    [118.462961916632, 24.7793344147858, 0.000922827050089836],
  ],
  [
    [118.463344533154, 24.7787020306793, 0.000922746956348419],
    [118.46294479173, 24.7793252645528, 0.000922824256122112],
  ],
  [
    [118.463327517138, 24.7786929436008, 0.000922746025025845],
    [118.46292767671, 24.7793161052826, 0.000922823324799538],
  ],
  [
    [118.463310520894, 24.7786838474777, 0.00092274509370327],
    [118.462910551805, 24.7793069460179, 0.000922823324799538],
  ],
  [
    [118.463293514756, 24.7786747423324, 0.000922743231058121],
    [118.462893426902, 24.7792977867512, 0.000922821462154388],
  ],
  [
    [118.463276518516, 24.7786656462054, 0.000922741368412972],
    [118.462876311882, 24.7792886184473, 0.000922820530831814],
  ],
  [
    [118.463259522271, 24.7786565410487, 0.000922741368412972],
    [118.462859186976, 24.7792794501489, 0.00092281773686409],
  ],
  [
    [118.463242526028, 24.77864743589, 0.000922739505767822],
    [118.462842071961, 24.7792702818411, 0.00092281773686409],
  ],
  [
    [118.463225539676, 24.7786383307219, 0.000922737643122673],
    [118.462824947052, 24.779261104511, 0.000922815874218941],
  ],
  [
    [118.463208553327, 24.7786292255519, 0.000922736711800098],
    [118.462807832026, 24.7792519181438, 0.000922816805541515],
  ],
  [
    [118.463191566972, 24.7786201113522, 0.000922736711800098],
    [118.46279071701, 24.7792427408023, 0.000922814011573792],
  ],
  [
    [118.463174590507, 24.7786109971431, 0.000922734849154949],
    [118.462773592092, 24.7792335454108, 0.000922815874218941],
  ],
  [
    [118.463157614045, 24.778601882932, 0.000922733917832375],
    [118.462756477073, 24.7792243590377, 0.000922813080251217],
  ],
  [
    [118.463140637577, 24.7785927596913, 0.000922732055187225],
    [118.462739362049, 24.7792151636348, 0.000922812148928642],
  ],
  [
    [118.463123671, 24.7785836364411, 0.000922732055187225],
    [118.462722247019, 24.7792059592022, 0.000922810286283493],
  ],
  [
    [118.463106704426, 24.778574513189, 0.000922730192542076],
    [118.462705131991, 24.7791967547677, 0.000922809354960918],
  ],
  [
    [118.463089747742, 24.7785653899275, 0.000922729261219502],
    [118.462688026854, 24.7791875503237, 0.000922806560993195],
  ],
  [
    [118.463072781164, 24.7785562576438, 0.000922728329896927],
    [118.462670911823, 24.7791783368575, 0.000922806560993195],
  ],
  [
    [118.463055824477, 24.7785471253507, 0.000922726467251778],
    [118.462653796795, 24.7791691233893, 0.000922804698348045],
  ],
  [
    [118.46303887768, 24.7785379930481, 0.000922726467251778],
    [118.46263669165, 24.7791599008839, 0.000922804698348045],
  ],
  [
    [118.463021930878, 24.7785288517159, 0.000922725535929203],
    [118.462619576618, 24.779150678384, 0.000922802835702896],
  ],
  [
    [118.463004984078, 24.7785197103818, 0.000922724604606628],
    [118.46260247147, 24.779141446847, 0.000922801904380322],
  ],
  [
    [118.462988047169, 24.7785105690383, 0.000922721810638905],
    [118.462585366323, 24.779132215308, 0.000922800973057747],
  ],
  [
    [118.462971100367, 24.7785014186725, 0.000922721810638905],
    [118.462568261172, 24.7791229747392, 0.000922799110412598],
  ],
  [
    [118.462954173343, 24.77849226829, 0.000922719016671181],
    [118.462551156022, 24.7791137341686, 0.000922798179090023],
  ],
  [
    [118.462937236433, 24.7784831179129, 0.000922718085348606],
    [118.462534050867, 24.7791044845682, 0.000922797247767448],
  ],
  [
    [118.462920319294, 24.7784739584912, 0.000922718085348606],
    [118.462516955603, 24.7790952349584, 0.000922797247767448],
  ],
  [
    [118.462903392269, 24.7784647990751, 0.000922717154026031],
    [118.462499850445, 24.7790859763263, 0.000922795385122299],
  ],
  [
    [118.462886475127, 24.7784556306219, 0.000922716222703457],
    [118.462482755178, 24.7790767176848, 0.000922794453799725],
  ],
  [
    [118.462869557995, 24.7784464711944, 0.000922715291380882],
    [118.462465659906, 24.7790674500137, 0.000922792591154575],
  ],
  [
    [118.462852650738, 24.7784372937021, 0.000922712497413158],
    [118.462448564635, 24.7790581823405, 0.000922791659832001],
  ],
  [
    [118.462835743492, 24.7784281252356, 0.000922711566090584],
    [118.462431469359, 24.7790489056377, 0.000922789797186852],
  ],
  [
    [118.462818846128, 24.778418947732, 0.000922710634768009],
    [118.462414374078, 24.7790396199051, 0.000922789797186852],
  ],
  [
    [118.46280193887, 24.7784097612062, 0.000922709703445435],
    [118.462397288687, 24.7790303341632, 0.000922787003219128],
  ],
  [
    [118.462785051391, 24.7784005746636, 0.00092270877212286],
    [118.462380193411, 24.7790210484267, 0.000922787934541702],
  ],
  [
    [118.462768163914, 24.778391388119, 0.000922706909477711],
    [118.462363108009, 24.7790117446253, 0.000922785140573978],
  ],
  [
    [118.462751276432, 24.7783821925448, 0.000922705046832561],
    [118.462346022618, 24.7790024498498, 0.000922785140573978],
  ],
  [
    [118.462734388952, 24.7783729969687, 0.000922704115509987],
    [118.462328937213, 24.7789931370167, 0.000922783277928829],
  ],
  [
    [118.462717511363, 24.7783638013832, 0.000922703184187412],
    [118.462311851811, 24.7789838241818, 0.000922782346606255],
  ],
  [
    [118.462700643656, 24.7783545967606, 0.000922703184187412],
    [118.462294776299, 24.7789745113374, 0.000922780483961105],
  ],
  [
    [118.462683775944, 24.7783453831084, 0.000922702252864838],
    [118.462277700782, 24.7789651894633, 0.000922779552638531],
  ],
  [
    [118.462666908235, 24.7783361694542, 0.000922702252864838],
    [118.46226062526, 24.7789558585596, 0.000922777689993382],
  ],
  [
    [118.462650050416, 24.7783269557907, 0.000922701321542263],
    [118.462243549731, 24.7789465186261, 0.000922775827348232],
  ],
  [
    [118.462633192591, 24.7783177330975, 0.00092269666492939],
    [118.462226474206, 24.7789371786907, 0.000922774896025658],
  ],
  [
    [118.462616344657, 24.7783085103949, 0.00092269666492939],
    [118.462209398683, 24.7789278387533, 0.000922774896025658],
  ],
  [
    [118.462599496717, 24.7782992786628, 0.000922695733606815],
    [118.462192333034, 24.778918480751, 0.000922774896025658],
  ],
  [
    [118.462582658668, 24.7782900469212, 0.000922693870961666],
    [118.462175267388, 24.7789091227468, 0.000922773033380508],
  ],
  [
    [118.462565820614, 24.7782808061501, 0.000922692939639091],
    [118.462158201745, 24.7788997647407, 0.000922771170735359],
  ],
  [
    [118.462548982561, 24.778271565377, 0.000922692939639091],
    [118.462141145984, 24.7788903976974, 0.00092276930809021],
  ],
  [
    [118.46253216428, 24.7782623155594, 0.000922691076993942],
    [118.462124080329, 24.7788810216318, 0.000922770239412785],
  ],
  [
    [118.462515336113, 24.7782530657473, 0.000922690145671368],
    [118.462107024557, 24.7788716365292, 0.000922768376767635],
  ],
  [
    [118.462498517828, 24.7782438068982, 0.000922688283026218],
    [118.462089968788, 24.7788622514246, 0.000922766514122486],
  ],
  [
    [118.462481709434, 24.7782345480397, 0.000922687351703644],
    [118.462072913013, 24.7788528572903, 0.000922766514122486],
  ],
  [
    [118.462464901035, 24.7782252801516, 0.000922686420381069],
    [118.462055867121, 24.7788434541188, 0.000922764651477337],
  ],
  [
    [118.46244809263, 24.7782160032338, 0.000922685489058495],
    [118.462038821231, 24.7788340509455, 0.000922763720154762],
  ],
  [
    [118.462431294115, 24.7782067263067, 0.00092268455773592],
    [118.462021775336, 24.7788246387424, 0.000922761857509613],
  ],
  [
    [118.462414505491, 24.7781974493703, 0.000922682695090771],
    [118.462004729436, 24.7788152175097, 0.000922760926187038],
  ],
  [
    [118.462397716862, 24.7781881634043, 0.000922682695090771],
    [118.461987693426, 24.7788057962675, 0.000922759063541889],
  ],
  [
    [118.462380928227, 24.7781788684086, 0.000922679901123047],
    [118.461970647514, 24.7787963569754, 0.000922758132219315],
  ],
  [
    [118.462364149482, 24.7781695734036, 0.000922678969800472],
    [118.461953611501, 24.7787869267017, 0.000922756269574165],
  ],
  [
    [118.462347380629, 24.7781602783892, 0.000922678969800472],
    [118.461936585363, 24.7787774783631, 0.000922755338251591],
  ],
  [
    [118.462330611761, 24.7781509653176, 0.000922676175832748],
    [118.461919549339, 24.77876803003, 0.000922754406929016],
  ],
  [
    [118.462313852784, 24.7781416522366, 0.000922675244510174],
    [118.46190252319, 24.778758563632, 0.000922751612961292],
  ],
  [
    [118.46229709381, 24.7781323391537, 0.000922674313187599],
    [118.461885506939, 24.7787491062525, 0.000922752544283867],
  ],
  [
    [118.46228033483, 24.7781230170411, 0.000922674313187599],
    [118.461868480787, 24.7787396308229, 0.000922750681638718],
  ],
  [
    [118.462263595621, 24.7781136858842, 0.00092267245054245],
    [118.461851464518, 24.7787301463562, 0.000922748818993568],
  ],
  [
    [118.462246846526, 24.7781043547327, 0.000922671519219875],
    [118.461834448251, 24.7787206618876, 0.000922748818993568],
  ],
  [
    [118.462230117202, 24.7780950145368, 0.000922670587897301],
    [118.461817431978, 24.7787111683893, 0.000922746956348419],
  ],
  [
    [118.46221338788, 24.778085674339, 0.000922668725252151],
    [118.461800425597, 24.7787016748816, 0.00092274509370327],
  ],
  [
    [118.462196658553, 24.7780763251116, 0.000922667793929577],
    [118.461783419202, 24.7786921633166, 0.000922746025025845],
  ],
  [
    [118.462179939108, 24.7780669668472, 0.000922666862607002],
    [118.461766412809, 24.7786826517496, 0.000922743231058121],
  ],
  [
    [118.462163229554, 24.7780576085734, 0.000922664999961853],
    [118.461749416299, 24.7786731311455, 0.000922743231058121],
  ],
  [
    [118.462146519995, 24.7780482412701, 0.000922664068639278],
    [118.461732419784, 24.7786636015118, 0.000922740437090397],
  ],
  [
    [118.46212981043, 24.7780388649371, 0.000922663137316704],
    [118.461715423263, 24.7786540628483, 0.000922741368412972],
  ],
  [
    [118.462113120643, 24.7780294885874, 0.000922662205994129],
    [118.461698436625, 24.7786445151478, 0.000922738574445248],
  ],
  [
    [118.462096430851, 24.7780201032082, 0.000922659412026405],
    [118.461681449989, 24.7786349674454, 0.000922736711800098],
  ],
  [
    [118.462079741054, 24.7780107087993, 0.000922659412026405],
    [118.461664463348, 24.7786254107133, 0.000922737643122673],
  ],
  [
    [118.462063061147, 24.7780013143811, 0.000922658480703831],
    [118.461647486582, 24.7786158359164, 0.000922736711800098],
  ],
  [
    [118.462046391123, 24.7779919109259, 0.000922656618058681],
    [118.461630509826, 24.7786062701453, 0.000922735780477524],
  ],
  [
    [118.462029721093, 24.7779824984412, 0.000922656618058681],
    [118.461613533057, 24.7785966863168, 0.0009227329865098],
  ],
  [
    [118.462013060953, 24.7779730859471, 0.000922654755413532],
    [118.46159656617, 24.7785870934512, 0.0009227329865098],
  ],
  [
    [118.461996400809, 24.7779636644234, 0.000922652892768383],
    [118.461579599287, 24.7785775005837, 0.000922730192542076],
  ],
  [
    [118.461979750546, 24.7779542338628, 0.000922652892768383],
    [118.461562642277, 24.7785678896514, 0.000922731123864651],
  ],
  [
    [118.461963110167, 24.7779447942651, 0.000922650098800659],
    [118.461545675383, 24.7785582787246, 0.000922728329896927],
  ],
  [
    [118.46194646979, 24.7779353546656, 0.000922647304832935],
    [118.461528728259, 24.7785486587533, 0.000922726467251778],
  ],
  [
    [118.461929839295, 24.7779259060291, 0.000922649167478085],
    [118.461511771241, 24.7785390297597, 0.000922724604606628],
  ],
  [
    [118.461913218691, 24.7779164573833, 0.000922647304832935],
    [118.461494824107, 24.7785293917291, 0.000922725535929203],
  ],
  [
    [118.461896598073, 24.7779069906802, 0.000922645442187786],
    [118.461477876966, 24.7785197446688, 0.000922722741961479],
  ],
  [
    [118.461879987347, 24.7778975239678, 0.000922645442187786],
    [118.461460939709, 24.7785100885715, 0.000922724604606628],
  ],
  [
    [118.461863376614, 24.7778880482259, 0.000922643579542637],
    [118.461444002454, 24.7785004324723, 0.00092272087931633],
  ],
  [
    [118.461846775772, 24.7778785724747, 0.000922641716897488],
    [118.461427075074, 24.7784907583083, 0.000922719016671181],
  ],
  [
    [118.461830184813, 24.7778690876865, 0.000922641716897488],
    [118.461410147689, 24.7784810751146, 0.000922718085348606],
  ],
  [
    [118.46181359384, 24.777859584841, 0.000922640785574913],
    [118.461393220306, 24.778471391919, 0.000922717154026031],
  ],
  [
    [118.461797012766, 24.777850091014, 0.000922640785574913],
    [118.461376302806, 24.7784616996864, 0.000922716222703457],
  ],
  [
    [118.461780441567, 24.7778405791223, 0.000922637991607189],
    [118.461359385292, 24.7784519893964, 0.000922714360058308],
  ],
  [
    [118.46176387037, 24.7778310672287, 0.000922637060284615],
    [118.461342477669, 24.7784422790971, 0.000922713428735733],
  ],
  [
    [118.461747309047, 24.7778215372704, 0.00092263612896204],
    [118.461325570041, 24.7784325597681, 0.000922712497413158],
  ],
  [
    [118.461730757615, 24.7778120073029, 0.000922634266316891],
    [118.461308662399, 24.7784228223818, 0.000922711566090584],
  ],
  [
    [118.461714206186, 24.7778024773336, 0.000922633334994316],
    [118.461291764648, 24.7784130849861, 0.000922710634768009],
  ],
  [
    [118.461697664631, 24.7777929292995, 0.000922632403671741],
    [118.46127487678, 24.7784033385535, 0.00092270877212286],
  ],
  [
    [118.461681132967, 24.7777833812563, 0.000922630541026592],
    [118.461257979019, 24.7783935830985, 0.00092270877212286],
  ],
  [
    [118.461664611177, 24.7777738151483, 0.000922629609704018],
    [118.461241101028, 24.7783838185992, 0.000922706909477711],
  ],
  [
    [118.46164808939, 24.7777642490386, 0.000922625884413719],
    [118.461224213144, 24.7783740450776, 0.000922704115509987],
  ],
  [
    [118.461631577494, 24.7777546829195, 0.000922625884413719],
    [118.461207345022, 24.7783642534839, 0.000922703184187412],
  ],
  [
    [118.461615065584, 24.7777450987432, 0.000922625884413719],
    [118.461190467015, 24.7783544618956, 0.000922701321542263],
  ],
  [
    [118.461598563557, 24.77773550553, 0.000922624953091145],
    [118.461173598891, 24.7783446612704, 0.000922699458897114],
  ],
  [
    [118.46158207142, 24.7777259123075, 0.00092262402176857],
    [118.46115674065, 24.7783348516081, 0.000922700390219688],
  ],
  [
    [118.461565589166, 24.7777163100481, 0.000922621227800846],
    [118.461139882403, 24.7783250329162, 0.000922699458897114],
  ],
  [
    [118.461549106906, 24.7777066987592, 0.000922620296478271],
    [118.461123034032, 24.7783151961596, 0.000922698527574539],
  ],
  [
    [118.461532644417, 24.7776970784259, 0.000922620296478271],
    [118.461106185662, 24.778305359401, 0.000922697596251965],
  ],
  [
    [118.461516172035, 24.7776874490705, 0.000922618433833122],
    [118.461089337288, 24.7782955136128, 0.00092269666492939],
  ],
  [
    [118.461499719431, 24.7776778196984, 0.000922617502510548],
    [118.461072498788, 24.7782856497599, 0.000922694802284241],
  ],
  [
    [118.461483266814, 24.7776681722691, 0.000922615639865398],
    [118.461055670179, 24.7782757858977, 0.000922692008316517],
  ],
  [
    [118.461466824087, 24.7776585248306, 0.000922615639865398],
    [118.461038841556, 24.7782659039782, 0.000922690145671368],
  ],
  [
    [118.461450391235, 24.7776488593275, 0.000922613777220249],
    [118.461022012937, 24.7782560220567, 0.000922688283026218],
  ],
  [
    [118.461433968274, 24.7776391938151, 0.0009226119145751],
    [118.46100520408, 24.7782461220632, 0.000922689214348793],
  ],
  [
    [118.461417545307, 24.7776295192733, 0.0009226119145751],
    [118.460988385338, 24.7782362220752, 0.000922688283026218],
  ],
  [
    [118.461401132222, 24.7776198356945, 0.000922610051929951],
    [118.46097157647, 24.7782263040224, 0.000922687351703644],
  ],
  [
    [118.461384729021, 24.7776101430788, 0.000922609120607376],
    [118.460954777485, 24.7782163769327, 0.00092268455773592],
  ],
  [
    [118.46136833571, 24.7776004504539, 0.000922607257962227],
    [118.460937978495, 24.7782064408133, 0.000922682695090771],
  ],
  [
    [118.461351942385, 24.7775907397717, 0.000922606326639652],
    [118.460921189388, 24.7781964956569, 0.000922683626413345],
  ],
  [
    [118.461335558943, 24.7775810200527, 0.000922606326639652],
    [118.460904400268, 24.7781865324432, 0.000922682695090771],
  ],
  [
    [118.461319185392, 24.7775713003245, 0.000922602601349354],
    [118.460887621038, 24.7781765692203, 0.000922679901123047],
  ],
  [
    [118.461302821716, 24.7775615625316, 0.000922602601349354],
    [118.460870851691, 24.7781665969604, 0.000922678969800472],
  ],
  [
    [118.461286458041, 24.7775518247369, 0.000922601670026779],
    [118.460854082331, 24.7781566066431, 0.000922677107155323],
  ],
  [
    [118.46127011413, 24.7775420688703, 0.00092259980738163],
    [118.460837312965, 24.7781466072962, 0.000922677107155323],
  ],
  [
    [118.461253770221, 24.7775323130019, 0.00092259980738163],
    [118.460820553483, 24.7781365989124, 0.000922676175832748],
  ],
  [
    [118.461237436195, 24.7775225480966, 0.000922597944736481],
    [118.460803803883, 24.7781265814916, 0.000922671519219875],
  ],
  [
    [118.461221112044, 24.7775127651266, 0.000922596082091331],
    [118.460787054278, 24.7781165550412, 0.000922671519219875],
  ],
  [
    [118.461204787895, 24.7775029821549, 0.000922595150768757],
    [118.460770314555, 24.7781065195539, 0.000922671519219875],
  ],
  [
    [118.461188483516, 24.777493190139, 0.000922594219446182],
    [118.46075357482, 24.7780964660091, 0.000922670587897301],
  ],
  [
    [118.461172179133, 24.7774833890935, 0.000922592356801033],
    [118.460736844975, 24.7780864124552, 0.000922668725252151],
  ],
  [
    [118.461155884632, 24.7774735790112, 0.000922592356801033],
    [118.460720125005, 24.7780763408366, 0.000922667793929577],
  ],
  [
    [118.461139600005, 24.7774637508642, 0.000922589562833309],
    [118.46070340503, 24.7780662601884, 0.000922665931284428],
  ],
  [
    [118.461123315381, 24.7774539227155, 0.000922588631510735],
    [118.460686694929, 24.7780561614756, 0.000922664999961853],
  ],
  [
    [118.461107050528, 24.7774440855225, 0.00092258770018816],
    [118.46066999472, 24.7780460627535, 0.000922663137316704],
  ],
  [
    [118.46109078567, 24.7774342393001, 0.000922586768865585],
    [118.460653294497, 24.7780359459741, 0.000922662205994129],
  ],
  [
    [118.461074540582, 24.7774243840335, 0.000922584906220436],
    [118.460636594269, 24.7780258201651, 0.000922662205994129],
  ],
  [
    [118.46105829548, 24.7774145107096, 0.000922583974897861],
    [118.460619913812, 24.7780156853118, 0.00092266034334898],
  ],
  [
    [118.46104206027, 24.7774046373765, 0.000922582112252712],
    [118.460603233349, 24.7780055414289, 0.000922658480703831],
  ],
  [
    [118.461025834942, 24.7773947550067, 0.000922582112252712],
    [118.460586552882, 24.7779953885164, 0.000922657549381256],
  ],
  [
    [118.461009609608, 24.7773848636073, 0.000922581180930138],
    [118.460569892177, 24.777985217532, 0.000922656618058681],
  ],
  [
    [118.460993404038, 24.7773749541361, 0.000922579318284988],
    [118.460553221579, 24.7779750375253, 0.000922654755413532],
  ],
  [
    [118.46097719847, 24.777365044663, 0.000922578386962414],
    [118.460536570752, 24.7779648484743, 0.000922652892768383],
  ],
  [
    [118.460961012664, 24.7773551171181, 0.000922576524317265],
    [118.460519919912, 24.777954641366, 0.000922652892768383],
  ],
  [
    [118.460944826862, 24.7773451895714, 0.000922574661672115],
    [118.460503278955, 24.7779444252209, 0.000922651030123234],
  ],
  [
    [118.460928650934, 24.7773352439601, 0.000922573730349541],
    [118.46048664788, 24.7779342000388, 0.000922650098800659],
  ],
  [
    [118.460912484896, 24.7773252983397, 0.000922572799026966],
    [118.4604700168, 24.7779239658271, 0.000922650098800659],
  ],
  [
    [118.460896328733, 24.7773153346548, 0.000922571867704391],
    [118.460453395604, 24.7779137225785, 0.000922646373510361],
  ],
  [
    [118.460880182453, 24.7773053619331, 0.000922570005059242],
    [118.460436774393, 24.7779034612726, 0.000922645442187786],
  ],
  [
    [118.460864046056, 24.7772953801745, 0.000922568142414093],
    [118.460420172954, 24.7778931909225, 0.000922645442187786],
  ],
  [
    [118.460847909653, 24.7772853893864, 0.000922567211091518],
    [118.460403571502, 24.777882902515, 0.000922643579542637],
  ],
  [
    [118.460831793021, 24.7772753895543, 0.000922566279768944],
    [118.460386970053, 24.7778726141057, 0.000922641716897488],
  ],
  [
    [118.460815686272, 24.7772653806853, 0.000922565348446369],
    [118.460370388366, 24.7778623076245, 0.000922639854252338],
  ],
  [
    [118.460799579517, 24.7772553627868, 0.000922564417123795],
    [118.460353806675, 24.7778519921137, 0.000922639854252338],
  ],
  [
    [118.460783482637, 24.7772453268238, 0.000922564417123795],
    [118.460337234858, 24.7778416585383, 0.000922638922929764],
  ],
  [
    [118.460767405535, 24.7772352908444, 0.000922561623156071],
    [118.460320663036, 24.7778313159334, 0.000922637060284615],
  ],
  [
    [118.46075132842, 24.7772252368078, 0.000922561623156071],
    [118.460304110985, 24.7778209642842, 0.000922634266316891],
  ],
  [
    [118.460735261196, 24.7772151827621, 0.000922559760510921],
    [118.460287558921, 24.7778105945777, 0.000922634266316891],
  ],
  [
    [118.460719213735, 24.7772051106446, 0.000922557897865772],
    [118.460271006851, 24.7778002158417, 0.000922632403671741],
  ],
  [
    [118.460703166268, 24.7771950294977, 0.000922556035220623],
    [118.460254474553, 24.7777898280615, 0.000922631472349167],
  ],
  [
    [118.460687128684, 24.7771849393139, 0.000922555103898048],
    [118.460237942242, 24.777779422224, 0.000922629609704018],
  ],
  [
    [118.460671100975, 24.7771748310656, 0.000922553241252899],
    [118.460221419821, 24.7777690163773, 0.000922627747058868],
  ],
  [
    [118.460655083156, 24.7771647228083, 0.000922553241252899],
    [118.460204907268, 24.7777585834384, 0.000922627747058868],
  ],
  [
    [118.460639075212, 24.7771545964865, 0.000922552309930325],
    [118.460188394717, 24.7777481504976, 0.000922625884413719],
  ],
  [
    [118.460623077159, 24.7771444701556, 0.000922550447285175],
    [118.460171901929, 24.7777376994849, 0.000922624953091145],
  ],
  [
    [118.460607088981, 24.7771343257603, 0.000922549515962601],
    [118.460155409128, 24.777727230415, 0.00092262402176857],
  ],
  [
    [118.460591110677, 24.7771241633004, 0.000922547653317451],
    [118.46013892621, 24.7777167523081, 0.000922622159123421],
  ],
  [
    [118.460575142264, 24.7771140008315, 0.000922546721994877],
    [118.460122443287, 24.7777062651718, 0.000922621227800846],
  ],
  [
    [118.460559183733, 24.7771038293258, 0.000922544859349728],
    [118.460105980135, 24.7776957689913, 0.000922621227800846],
  ],
  [
    [118.460543244966, 24.7770936397484, 0.000922544859349728],
    [118.46008951697, 24.7776852547535, 0.000922618433833122],
  ],
  [
    [118.460527306193, 24.7770834411415, 0.000922542065382004],
    [118.46007306368, 24.7776747224511, 0.000922616571187973],
  ],
  [
    [118.460511377302, 24.7770732334979, 0.000922541134059429],
    [118.460056620273, 24.7776641811119, 0.000922613777220249],
  ],
  [
    [118.460495458295, 24.7770630168175, 0.000922540202736855],
    [118.460040186749, 24.7776536307359, 0.000922614708542824],
  ],
  [
    [118.460479549162, 24.7770527820726, 0.00092253927141428],
    [118.460023753219, 24.7776430713303, 0.000922612845897675],
  ],
  [
    [118.460463649912, 24.777042538291, 0.000922537408769131],
    [118.460007339453, 24.7776324938529, 0.0009226119145751],
  ],
  [
    [118.460447750656, 24.77703228548, 0.000922535546123981],
    [118.45999093557, 24.7776219073387, 0.0009226119145751],
  ],
  [
    [118.460431871171, 24.7770220236249, 0.000922534614801407],
    [118.459974531681, 24.7776113117949, 0.000922608189284801],
  ],
  [
    [118.460416001561, 24.7770117437054, 0.000922533683478832],
    [118.459958147556, 24.7776006981793, 0.000922607257962227],
  ],
  [
    [118.460400131946, 24.7770014547564, 0.000922532752156258],
    [118.459941763425, 24.7775900755342, 0.000922606326639652],
  ],
  [
    [118.460384272213, 24.7769911567707, 0.000922531820833683],
    [118.45992538917, 24.7775794348245, 0.000922606326639652],
  ],
  [
    [118.460368432243, 24.7769808407133, 0.000922529026865959],
    [118.459909034693, 24.7775687940985, 0.000922603532671928],
  ],
  [
    [118.460352592268, 24.7769705156264, 0.00092252716422081],
    [118.459892680196, 24.7775581262875, 0.000922601670026779],
  ],
  [
    [118.460336762176, 24.7769601815028, 0.00092252716422081],
    [118.459876335589, 24.7775474584674, 0.000922601670026779],
  ],
  [
    [118.460320941966, 24.7769498383425, 0.000922525301575661],
    [118.459860000858, 24.7775367725828, 0.000922598876059055],
  ],
  [
    [118.460305131631, 24.7769394771177, 0.000922525301575661],
    [118.459843676009, 24.7775260776614, 0.000922597944736481],
  ],
  [
    [118.460289331179, 24.7769291068562, 0.000922523438930511],
    [118.459827361044, 24.7775153737032, 0.000922595150768757],
  ],
  [
    [118.460273540609, 24.7769187275581, 0.000922521576285362],
    [118.459811055953, 24.7775046516805, 0.000922596082091331],
  ],
  [
    [118.460257759914, 24.7769083301955, 0.000922521576285362],
    [118.459794760754, 24.7774939296488, 0.000922594219446182],
  ],
  [
    [118.460241979222, 24.7768979328312, 0.000922519713640213],
    [118.459778475422, 24.7774831805247, 0.000922593288123608],
  ],
  [
    [118.460226218285, 24.7768875083674, 0.000922519713640213],
    [118.45976219998, 24.7774724313917, 0.000922590494155884],
  ],
  [
    [118.46021045735, 24.776877083902, 0.000922515988349915],
    [118.459745934414, 24.7774616641941, 0.000922589562833309],
  ],
  [
    [118.460194716187, 24.7768666503926, 0.000922516919672489],
    [118.459729668842, 24.7774508879671, 0.000922588631510735],
  ],
  [
    [118.46017897501, 24.7768561988261, 0.00092251505702734],
    [118.459713423034, 24.7774400936682, 0.000922586768865585],
  ],
  [
    [118.460163243707, 24.7768457291952, 0.000922512263059616],
    [118.459697187108, 24.7774292903327, 0.000922584906220436],
  ],
  [
    [118.460147532184, 24.776835259548, 0.000922511331737041],
    [118.459680951178, 24.7774184779676, 0.000922584906220436],
  ],
  [
    [118.460131820647, 24.7768247718437, 0.000922510400414467],
    [118.459664735018, 24.7774076565584, 0.000922583043575287],
  ],
  [
    [118.460116118993, 24.7768142751027, 0.000922507606446743],
    [118.459648518846, 24.7773968170921, 0.000922582112252712],
  ],
  [
    [118.460100427222, 24.776803769325, 0.000922506675124168],
    [118.459632322445, 24.7773859685817, 0.000922581180930138],
  ],
  [
    [118.460084745333, 24.7767932545107, 0.000922505743801594],
    [118.45961612603, 24.7773751020141, 0.000922579318284988],
  ],
  [
    [118.460069073319, 24.776782721632, 0.000922505743801594],
    [118.459599949395, 24.7773642354303, 0.000922579318284988],
  ],
  [
    [118.4600534013, 24.7767721797238, 0.000922503881156445],
    [118.459583772747, 24.7773533507892, 0.000922576524317265],
  ],
  [
    [118.460037749052, 24.7767616287718, 0.000922502018511295],
    [118.459567605973, 24.7773424480837, 0.000922574661672115],
  ],
  [
    [118.460022106678, 24.7767510597553, 0.000922501087188721],
    [118.459551458979, 24.7773315453619, 0.000922573730349541],
  ],
  [
    [118.4600064643, 24.7767404817095, 0.000922499224543571],
    [118.459535311972, 24.7773206245828, 0.000922571867704391],
  ],
  [
    [118.459990841692, 24.7767298946197, 0.000922498293220997],
    [118.459519174848, 24.7773096947671, 0.000922571867704391],
  ],
  [
    [118.459975219079, 24.7767192985006, 0.000922496430575848],
    [118.459503047599, 24.7772987468869, 0.000922569073736668],
  ],
  [
    [118.459959616228, 24.7767086843098, 0.000922495499253273],
    [118.459486940121, 24.7772877899627, 0.000922568142414093],
  ],
  [
    [118.459944013373, 24.7766980610897, 0.000922493636608124],
    [118.459470832638, 24.777276824009, 0.000922567211091518],
  ],
  [
    [118.4599284204, 24.7766874288328, 0.000922491773962975],
    [118.459454735038, 24.7772658490187, 0.000922566279768944],
  ],
  [
    [118.459912847198, 24.7766767875321, 0.0009224908426404],
    [118.459438647313, 24.7772548559638, 0.000922564417123795],
  ],
  [
    [118.459897273982, 24.7766661281743, 0.000922488979995251],
    [118.459422569471, 24.7772438538723, 0.000922562554478645],
  ],
  [
    [118.45988171065, 24.7766554597799, 0.000922488048672676],
    [118.459406501512, 24.777232842744, 0.000922561623156071],
  ],
  [
    [118.4598661572, 24.7766447823488, 0.000922486186027527],
    [118.459390443428, 24.7772218135513, 0.000922560691833496],
  ],
  [
    [118.459850613633, 24.7766340958811, 0.000922486186027527],
    [118.459374395228, 24.7772107753219, 0.000922557897865772],
  ],
  [
    [118.459835079941, 24.776623391349, 0.000922484323382378],
    [118.45935835691, 24.7771997280558, 0.000922556966543198],
  ],
  [
    [118.459819556132, 24.7766126777803, 0.000922482460737228],
    [118.459342328468, 24.7771886627253, 0.000922556035220623],
  ],
  [
    [118.459804042205, 24.776601955175, 0.000922482460737228],
    [118.459326309916, 24.7771775973858, 0.000922554172575474],
  ],
  [
    [118.459788538154, 24.7765912145053, 0.000922480598092079],
    [118.459310301232, 24.7771665049542, 0.000922553241252899],
  ],
  [
    [118.459773034105, 24.7765804738341, 0.00092247873544693],
    [118.459294302438, 24.7771554125136, 0.000922550447285175],
  ],
  [
    [118.459757549818, 24.7765697150912, 0.00092247873544693],
    [118.45927831352, 24.7771443020086, 0.000922549515962601],
  ],
  [
    [118.459742075415, 24.7765589473117, 0.000922475941479206],
    [118.459262324597, 24.7771331824741, 0.000922548584640026],
  ],
  [
    [118.459726610887, 24.7765481614679, 0.000922475010156631],
    [118.459246355445, 24.7771220538957, 0.000922546721994877],
  ],
  [
    [118.459711146361, 24.7765373756225, 0.000922473147511482],
    [118.459230396176, 24.7771109162807, 0.000922543928027153],
  ],
  [
    [118.459695701598, 24.7765265717054, 0.000922474078834057],
    [118.459214446782, 24.7770997606012, 0.000922543928027153],
  ],
  [
    [118.459680256822, 24.7765157497313, 0.000922471284866333],
    [118.459198507271, 24.7770885958851, 0.000922543928027153],
  ],
  [
    [118.459664831825, 24.7765049277411, 0.000922471284866333],
    [118.459182577635, 24.7770774131046, 0.000922542996704578],
  ],
  [
    [118.459649406814, 24.7764940876939, 0.000922468490898609],
    [118.459166648002, 24.7770662303223, 0.000922540202736855],
  ],
  [
    [118.459633991694, 24.7764832476377, 0.00092246662825346],
    [118.459150738132, 24.7770550294685, 0.00092253927141428],
  ],
  [
    [118.45961859633, 24.7764723804823, 0.00092246662825346],
    [118.459134838138, 24.7770438105502, 0.000922538340091705],
  ],
  [
    [118.459603200967, 24.7764615133253, 0.000922463834285736],
    [118.459118948034, 24.7770325916231, 0.000922536477446556],
  ],
  [
    [118.45958781548, 24.7764506281039, 0.000922462902963161],
    [118.459103067806, 24.7770213546315, 0.000922534614801407],
  ],
  [
    [118.459572449764, 24.7764397338388, 0.000922461040318012],
    [118.459087187573, 24.7770101086105, 0.000922533683478832],
  ],
  [
    [118.459557084042, 24.7764288305443, 0.000922461971640587],
    [118.459071327103, 24.776998844518, 0.000922530889511108],
  ],
  [
    [118.459541728203, 24.7764179182132, 0.000922459177672863],
    [118.459055476523, 24.7769875804165, 0.000922529958188534],
  ],
  [
    [118.45952638224, 24.7764069878179, 0.000922456383705139],
    [118.459039635819, 24.7769762982506, 0.000922528095543385],
  ],
  [
    [118.459511046159, 24.7763960483859, 0.00092245452105999],
    [118.45902379511, 24.7769650070554, 0.000922526232898235],
  ],
  [
    [118.45949571996, 24.7763850999175, 0.00092245452105999],
    [118.459007974165, 24.7769536977885, 0.000922526232898235],
  ],
  [
    [118.459480403645, 24.7763741424124, 0.000922452658414841],
    [118.458992163102, 24.776942379485, 0.000922524370253086],
  ],
  [
    [118.459465097212, 24.7763631758708, 0.000922451727092266],
    [118.458976361923, 24.776931052145, 0.000922523438930511],
  ],
  [
    [118.459449800654, 24.776352191265, 0.000922450795769691],
    [118.458960560738, 24.7769197157754, 0.000922523438930511],
  ],
  [
    [118.459434513979, 24.7763411976225, 0.000922449864447117],
    [118.458944779317, 24.7769083613343, 0.000922520644962788],
  ],
  [
    [118.459419237179, 24.7763301859158, 0.000922447070479393],
    [118.458929007778, 24.7768969978566, 0.000922519713640213],
  ],
  [
    [118.45940397027, 24.7763191742003, 0.000922446139156818],
    [118.458913246123, 24.7768856253423, 0.000922517850995064],
  ],
  [
    [118.459388713236, 24.7763081444205, 0.000922444276511669],
    [118.458897494351, 24.7768742437914, 0.000922516919672489],
  ],
  [
    [118.459373466084, 24.7762971056042, 0.00092244241386652],
    [118.458881742566, 24.7768628441833, 0.000922514125704765],
  ],
  [
    [118.459358228815, 24.7762860577514, 0.000922440551221371],
    [118.458866010552, 24.7768514355315, 0.000922512263059616],
  ],
  [
    [118.45934300143, 24.776275000862, 0.000922441482543945],
    [118.458850288422, 24.776840017843, 0.000922512263059616],
  ],
  [
    [118.45932777403, 24.7762639259156, 0.000922436825931072],
    [118.458834576166, 24.7768285820902, 0.000922509469091892],
  ],
  [
    [118.459312566402, 24.7762528419254, 0.000922437757253647],
    [118.458818873794, 24.7768171373008, 0.000922509469091892],
  ],
  [
    [118.459297368657, 24.7762417488987, 0.000922437757253647],
    [118.458803181304, 24.7768056834748, 0.000922508537769318],
  ],
  [
    [118.459282180794, 24.7762306468355, 0.000922435894608498],
    [118.45878748881, 24.7767942206195, 0.000922506675124168],
  ],
  [
    [118.459266992919, 24.7762195267152, 0.000922434031963348],
    [118.458771816079, 24.7767827396926, 0.000922505743801594],
  ],
  [
    [118.459251824814, 24.7762083975513, 0.000922432169318199],
    [118.458756153231, 24.7767712497291, 0.000922502018511295],
  ],
  [
    [118.459236666592, 24.7761972593508, 0.00092243030667305],
    [118.458740500266, 24.776759750729, 0.000922502018511295],
  ],
  [
    [118.459221518253, 24.7761861121138, 0.000922428444027901],
    [118.458724857185, 24.7767482426924, 0.000922500155866146],
  ],
  [
    [118.459206369909, 24.7761749558475, 0.000922427512705326],
    [118.458709223978, 24.7767367165915, 0.000922500155866146],
  ],
  [
    [118.459191241328, 24.7761637815098, 0.000922425650060177],
    [118.458693600655, 24.7767251814539, 0.000922496430575848],
  ],
  [
    [118.459176122629, 24.7761525981356, 0.000922424718737602],
    [118.458677987214, 24.7767136372799, 0.000922496430575848],
  ],
  [
    [118.459161003925, 24.7761414057321, 0.000922422856092453],
    [118.458662383657, 24.7767020840692, 0.000922494567930698],
  ],
  [
    [118.459145904993, 24.7761302042849, 0.000922421924769878],
    [118.458646789975, 24.7766905127943, 0.000922491773962975],
  ],
  [
    [118.459130806047, 24.7761189847806, 0.000922420062124729],
    [118.458631206176, 24.7766789324828, 0.000922491773962975],
  ],
  [
    [118.459115726872, 24.7761077562327, 0.000922419130802155],
    [118.458615632261, 24.7766673431347, 0.000922489911317825],
  ],
  [
    [118.45910065758, 24.7760965186483, 0.00092241819947958],
    [118.458600078108, 24.7766557357152, 0.000922488048672676],
  ],
  [
    [118.459085588282, 24.7760852720346, 0.000922417268157005],
    [118.458584523958, 24.7766441282941, 0.000922486186027527],
  ],
  [
    [118.459070538756, 24.7760740163773, 0.000922416336834431],
    [118.458568979684, 24.7766325028086, 0.000922485254704952],
  ],
  [
    [118.459055499104, 24.7760627426557, 0.000922413542866707],
    [118.458553445293, 24.7766208682867, 0.000922483392059803],
  ],
  [
    [118.459040459448, 24.7760514599049, 0.000922411680221558],
    [118.458537920777, 24.7766092157004, 0.000922483392059803],
  ],
  [
    [118.459025439562, 24.7760401681104, 0.000922409817576408],
    [118.458522416032, 24.7765975540705, 0.000922480598092079],
  ],
  [
    [118.459010419671, 24.7760288672866, 0.000922409817576408],
    [118.458506911283, 24.7765858834111, 0.00092247873544693],
  ],
  [
    [118.458995419543, 24.7760175483914, 0.000922407954931259],
    [118.458491416416, 24.7765742037153, 0.00092247873544693],
  ],
  [
    [118.458980429305, 24.7760062294875, 0.00092240609228611],
    [118.45847594132, 24.7765625149758, 0.000922476872801781],
  ],
  [
    [118.458965439055, 24.7759948925266, 0.000922405160963535],
    [118.458460466212, 24.7765508081791, 0.000922474078834057],
  ],
  [
    [118.458950468568, 24.7759835374944, 0.00092240609228611],
    [118.458445010875, 24.7765390923388, 0.000922474078834057],
  ],
  [
    [118.458935507971, 24.7759721824534, 0.000922402366995811],
    [118.458429555533, 24.7765273674691, 0.000922471284866333],
  ],
  [
    [118.45892054737, 24.7759608183831, 0.000922400504350662],
    [118.458414119954, 24.776515624528, 0.000922469422221184],
  ],
  [
    [118.458905606531, 24.7759494362415, 0.000922399573028088],
    [118.458398684371, 24.7765038725576, 0.000922469422221184],
  ],
  [
    [118.458890675575, 24.7759380450634, 0.000922397710382938],
    [118.458383268558, 24.7764921115435, 0.000922468490898609],
  ],
  [
    [118.458875744614, 24.7759266448561, 0.000922395847737789],
    [118.458367862629, 24.7764803414929, 0.000922465696930885],
  ],
  [
    [118.458860833416, 24.7759152265774, 0.000922394916415215],
    [118.458352466583, 24.7764685624058, 0.000922465696930885],
  ],
  [
    [118.458845932109, 24.7759038082901, 0.00092239398509264],
    [118.458337070524, 24.7764567652616, 0.000922464765608311],
  ],
  [
    [118.458831030788, 24.7758923719457, 0.000922391191124916],
    [118.458321694236, 24.7764449590737, 0.000922461040318012],
  ],
  [
    [118.458816149239, 24.7758809265577, 0.000922389328479767],
    [118.458306327832, 24.7764331438494, 0.000922460108995438],
  ],
  [
    [118.458801277572, 24.7758694721334, 0.000922390259802341],
    [118.458290971302, 24.7764213105608, 0.000922459177672863],
  ],
  [
    [118.458786415781, 24.7758579996448, 0.000922387465834618],
    [118.458275624664, 24.7764094772635, 0.000922459177672863],
  ],
  [
    [118.458771553992, 24.7758465271548, 0.000922386534512043],
    [118.458260287901, 24.776397625902, 0.000922455452382565],
  ],
  [
    [118.458756711966, 24.7758350365934, 0.000922386534512043],
    [118.458244961021, 24.7763857655039, 0.00092245452105999],
  ],
  [
    [118.458741879823, 24.7758235369956, 0.000922384671866894],
    [118.458229644016, 24.7763738870417, 0.000922452658414841],
  ],
  [
    [118.458727057563, 24.7758120283614, 0.00092238187789917],
    [118.458214336894, 24.776361999543, 0.000922451727092266],
  ],
  [
    [118.458712245178, 24.775800501663, 0.000922380946576595],
    [118.458199039664, 24.7763501120356, 0.000922449864447117],
  ],
  [
    [118.458697432795, 24.7757889749632, 0.000922380015254021],
    [118.458183762197, 24.7763382064568, 0.000922447070479393],
  ],
  [
    [118.458682640176, 24.775777430192, 0.000922376289963722],
    [118.458168484717, 24.776326282821, 0.000922447070479393],
  ],
  [
    [118.458667857439, 24.7757658763845, 0.000922375358641148],
    [118.458153217128, 24.7763143591764, 0.000922445207834244],
  ],
  [
    [118.458653084586, 24.7757543135405, 0.000922375358641148],
    [118.458137969302, 24.7763024174605, 0.000922443345189095],
  ],
  [
    [118.458638321615, 24.7757427416602, 0.000922374427318573],
    [118.458122721471, 24.7762904667152, 0.000922441482543945],
  ],
  [
    [118.458623568519, 24.7757311517157, 0.000922371633350849],
    [118.458107493412, 24.7762785069264, 0.000922441482543945],
  ],
  [
    [118.458608825306, 24.7757195527349, 0.0009223697707057],
    [118.45809226534, 24.7762665290806, 0.000922439619898796],
  ],
  [
    [118.458594091976, 24.7757079447176, 0.000922368839383125],
    [118.458077057039, 24.7762545421911, 0.000922438688576221],
  ],
  [
    [118.458579368529, 24.775696327664, 0.0009223697707057],
    [118.458061858621, 24.7762425462652, 0.000922435894608498],
  ],
  [
    [118.458564654965, 24.775684701574, 0.000922366045415401],
    [118.458046670086, 24.7762305413029, 0.000922434963285923],
  ],
  [
    [118.458549951284, 24.7756730664477, 0.000922366045415401],
    [118.458031491435, 24.7762185273041, 0.000922433100640774],
  ],
  [
    [118.458535267365, 24.77566141325, 0.000922363251447678],
    [118.458016312771, 24.7762064952483, 0.000922431237995625],
  ],
  [
    [118.458520583442, 24.7756497510232, 0.000922362320125103],
    [118.458001153877, 24.7761944541489, 0.00092243030667305],
  ],
  [
    [118.458505909401, 24.77563807976, 0.000922360457479954],
    [118.457986004868, 24.7761824040131, 0.000922428444027901],
  ],
  [
    [118.458491245244, 24.7756263994604, 0.000922359526157379],
    [118.457970875629, 24.7761703448338, 0.000922427512705326],
  ],
  [
    [118.458476600849, 24.7756147010895, 0.00092235766351223],
    [118.457955746377, 24.7761582675974, 0.000922425650060177],
  ],
  [
    [118.458461956457, 24.7756030027172, 0.000922356732189655],
    [118.457940627017, 24.7761461903523, 0.000922424718737602],
  ],
  [
    [118.45844732194, 24.7755912862809, 0.000922353938221931],
    [118.457925517532, 24.7761340950431, 0.000922421924769878],
  ],
  [
    [118.458432707194, 24.7755795608009, 0.000922353006899357],
    [118.45791042781, 24.7761219816626, 0.000922420062124729],
  ],
  [
    [118.458418092443, 24.7755678262919, 0.000922352075576782],
    [118.457895338091, 24.7761098682806, 0.000922419130802155],
  ],
  [
    [118.458403497463, 24.7755560827393, 0.000922351144254208],
    [118.457880268136, 24.7760977368273, 0.000922417268157005],
  ],
  [
    [118.45838890247, 24.7755443211297, 0.000922350212931633],
    [118.457865208071, 24.7760856053653, 0.000922416336834431],
  ],
  [
    [118.458374327247, 24.7755325504767, 0.000922346487641335],
    [118.457850147994, 24.7760734558463, 0.000922415405511856],
  ],
  [
    [118.458359752028, 24.7755207798223, 0.000922347418963909],
    [118.45783510768, 24.7760612882561, 0.000922413542866707],
  ],
  [
    [118.458345196571, 24.7755089910966, 0.000922344624996185],
    [118.457820077257, 24.7760491206572, 0.000922412611544132],
  ],
  [
    [118.45833065099, 24.7754971843068, 0.000922340899705887],
    [118.45780505671, 24.7760369349941, 0.000922410748898983],
  ],
  [
    [118.458316105411, 24.7754853775157, 0.000922340899705887],
    [118.457790046045, 24.7760247402947, 0.000922407954931259],
  ],
  [
    [118.458301579596, 24.7754735526532, 0.000922339037060738],
    [118.457775045264, 24.7760125365589, 0.00092240609228611],
  ],
  [
    [118.458287063671, 24.7754617277823, 0.000922338105738163],
    [118.457760054366, 24.7760003237867, 0.00092240609228611],
  ],
  [
    [118.458272557621, 24.7754498848472, 0.000922337174415588],
    [118.457745073343, 24.7759880929504, 0.000922403298318386],
  ],
  [
    [118.458258061454, 24.7754380328759, 0.000922335311770439],
    [118.457730112092, 24.7759758530706, 0.000922402366995811],
  ],
  [
    [118.458243575162, 24.7754261628404, 0.00092233344912529],
    [118.457715150836, 24.7759636041616, 0.000922402366995811],
  ],
  [
    [118.458229098761, 24.7754142927964, 0.000922331586480141],
    [118.45770020935, 24.775951346209, 0.000922398641705513],
  ],
  [
    [118.458214632234, 24.7754024046884, 0.000922331586480141],
    [118.45768526786, 24.7759390792272, 0.000922398641705513],
  ],
  [
    [118.458200175599, 24.7753905165718, 0.000922329723834991],
    [118.457670346134, 24.7759267941742, 0.000922395847737789],
  ],
  [
    [118.458185728839, 24.7753786103912, 0.000922328792512417],
    [118.457655434298, 24.7759145091126, 0.00092239398509264],
  ],
  [
    [118.458171301849, 24.7753666951671, 0.000922326929867268],
    [118.457640532338, 24.7759022059869, 0.000922393053770065],
  ],
  [
    [118.458156874855, 24.7753547709139, 0.000922325067222118],
    [118.457625640253, 24.7758898847971, 0.000922392122447491],
  ],
  [
    [118.458142457735, 24.7753428285966, 0.000922323204576969],
    [118.457610758058, 24.7758775635987, 0.000922391191124916],
  ],
  [
    [118.458128060394, 24.7753308862636, 0.000922322273254395],
    [118.45759588574, 24.7758652243362, 0.000922388397157192],
  ],
  [
    [118.458113663041, 24.7753189258738, 0.000922320410609245],
    [118.457581023312, 24.775852885065, 0.000922387465834618],
  ],
  [
    [118.458099285458, 24.7753069564405, 0.000922318547964096],
    [118.45756617076, 24.7758405277298, 0.000922386534512043],
  ],
  [
    [118.45808490787, 24.7752949779781, 0.000922317616641521],
    [118.457551337971, 24.7758281523234, 0.000922383740544319],
  ],
  [
    [118.458070550053, 24.7752829904723, 0.000922315753996372],
    [118.457536505185, 24.7758157769156, 0.000922380946576595],
  ],
  [
    [118.458056202111, 24.7752709849024, 0.000922312960028648],
    [118.457521692162, 24.7758033834365, 0.00092238187789917],
  ],
  [
    [118.45804186406, 24.7752589793241, 0.000922312960028648],
    [118.45750688903, 24.7757909899489, 0.000922379083931446],
  ],
  [
    [118.458027535884, 24.7752469556817, 0.000922311097383499],
    [118.457492095774, 24.7757785783972, 0.000922378152608871],
  ],
  [
    [118.458013207703, 24.7752349230102, 0.000922308303415775],
    [118.457477312401, 24.7757661578092, 0.000922375358641148],
  ],
  [
    [118.457998899292, 24.7752228812952, 0.000922307372093201],
    [118.457462538903, 24.7757537191571, 0.000922373495995998],
  ],
  [
    [118.457984610653, 24.7752108305369, 0.000922307372093201],
    [118.457447775297, 24.7757412804964, 0.000922372564673424],
  ],
  [
    [118.457970322008, 24.7751987707495, 0.000922305509448051],
    [118.457433021565, 24.7757288237717, 0.000922371633350849],
  ],
  [
    [118.457956043239, 24.7751866928981, 0.000922303646802902],
    [118.457418277717, 24.7757163580107, 0.000922371633350849],
  ],
  [
    [118.45794177436, 24.7751746150381, 0.000922303646802902],
    [118.45740355364, 24.7757038832063, 0.000922368839383125],
  ],
  [
    [118.457927515357, 24.7751625191142, 0.000922300852835178],
    [118.45738882955, 24.7756913903449, 0.000922366976737976],
  ],
  [
    [118.457913276124, 24.7751504141469, 0.000922298990190029],
    [118.457374125239, 24.7756788974679, 0.000922364182770252],
  ],
  [
    [118.457899036886, 24.7751383001505, 0.00092229712754488],
    [118.457359430804, 24.7756663865268, 0.000922364182770252],
  ],
  [
    [118.457884817419, 24.7751261771107, 0.000922295264899731],
    [118.457344736364, 24.7756538665565, 0.000922362320125103],
  ],
  [
    [118.457870607827, 24.7751140360069, 0.000922292470932007],
    [118.457330061695, 24.7756413375429, 0.000922360457479954],
  ],
  [
    [118.457856398238, 24.7751018949018, 0.000922293402254581],
    [118.457315406797, 24.7756287994858, 0.000922360457479954],
  ],
  [
    [118.457842208412, 24.7750897357256, 0.000922291539609432],
    [118.457300751894, 24.7756162523996, 0.000922356732189655],
  ],
  [
    [118.457828028469, 24.7750775675131, 0.000922288745641708],
    [118.457286106867, 24.7756036872493, 0.000922356732189655],
  ],
  [
    [118.457813858409, 24.7750653902644, 0.000922288745641708],
    [118.457271471723, 24.7755911130628, 0.000922353938221931],
  ],
  [
    [118.457799698232, 24.7750532039795, 0.000922285951673985],
    [118.45725685635, 24.7755785298329, 0.000922352075576782],
  ],
  [
    [118.457785547937, 24.7750410086584, 0.00092228502035141],
    [118.457242250861, 24.7755659375667, 0.000922351144254208],
  ],
  [
    [118.457771407526, 24.775028804301, 0.000922284089028835],
    [118.457227645366, 24.7755533362714, 0.000922349281609058],
  ],
  [
    [118.457757276989, 24.7750165818797, 0.000922283157706261],
    [118.457213059635, 24.7755407169049, 0.000922347418963909],
  ],
  [
    [118.457743166224, 24.7750043504151, 0.000922280363738537],
    [118.457198483787, 24.7755280885022, 0.000922347418963909],
  ],
  [
    [118.457729055461, 24.7749921189491, 0.000922279432415962],
    [118.45718391783, 24.775515460091, 0.00092234555631876],
  ],
  [
    [118.457714964461, 24.7749798694121, 0.000922278501093388],
    [118.457169371636, 24.7755028136087, 0.000922343693673611],
  ],
  [
    [118.457700873457, 24.774967610846, 0.000922276638448238],
    [118.45715482543, 24.7754901490694, 0.000922341831028461],
  ],
  [
    [118.457686802215, 24.7749553342088, 0.000922274775803089],
    [118.457140299003, 24.7754774845146, 0.000922339968383312],
  ],
  [
    [118.457672740864, 24.7749430575631, 0.000922271050512791],
    [118.457125772563, 24.7754648019029, 0.000922339968383312],
  ],
  [
    [118.457658689396, 24.7749307718813, 0.000922270119190216],
    [118.457111265902, 24.7754521192755, 0.000922336243093014],
  ],
  [
    [118.457644647803, 24.7749184681355, 0.000922269187867641],
    [118.457096769116, 24.7754394185843, 0.000922335311770439],
  ],
  [
    [118.457630616093, 24.7749061553536, 0.000922268256545067],
    [118.457082282214, 24.7754267088567, 0.00092233344912529],
  ],
  [
    [118.457616594266, 24.7748938335354, 0.000922266393899918],
    [118.457067805187, 24.7754139810652, 0.000922332517802715],
  ],
  [
    [118.457602582322, 24.7748815026811, 0.000922264531254768],
    [118.457053338051, 24.7754012532652, 0.000922328792512417],
  ],
  [
    [118.457588580261, 24.7748691627906, 0.000922262668609619],
    [118.457038880791, 24.7753885074012, 0.000922327861189842],
  ],
  [
    [118.45757459797, 24.7748568138568, 0.000922261737287045],
    [118.457024443309, 24.7753757615217, 0.000922325067222118],
  ],
  [
    [118.457560615667, 24.7748444468662, 0.000922259874641895],
    [118.457010015703, 24.7753629975782, 0.000922325998544693],
  ],
  [
    [118.457546653142, 24.7748320798601, 0.000922258943319321],
    [118.456995588092, 24.7753502246055, 0.000922323204576969],
  ],
  [
    [118.457532690605, 24.7748196947972, 0.000922256149351597],
    [118.456981180244, 24.7753374335618, 0.000922323204576969],
  ],
  [
    [118.457518747838, 24.774807300691, 0.000922255218029022],
    [118.456966782287, 24.7753246425097, 0.000922319479286671],
  ],
  [
    [118.457504814963, 24.7747949065764, 0.000922252424061298],
    [118.456952394206, 24.7753118333936, 0.000922319479286671],
  ],
  [
    [118.457490891954, 24.7747824853701, 0.000922252424061298],
    [118.456938025904, 24.7752990242619, 0.000922316685318947],
  ],
  [
    [118.457476978836, 24.7747700641554, 0.000922251492738724],
    [118.456923657589, 24.7752861970734, 0.000922316685318947],
  ],
  [
    [118.457463075601, 24.7747576339046, 0.000922248698771],
    [118.456909309045, 24.7752733608416, 0.000922313891351223],
  ],
  [
    [118.457449192137, 24.7747451946105, 0.000922247767448425],
    [118.456894960489, 24.7752605065529, 0.000922312028706074],
  ],
  [
    [118.457435308661, 24.7747327372597, 0.000922246836125851],
    [118.456880631711, 24.7752476522487, 0.000922311097383499],
  ],
  [
    [118.457421444955, 24.7747202708655, 0.000922244973480701],
    [118.456866312809, 24.7752347798806, 0.000922311097383499],
  ],
  [
    [118.457407581251, 24.7747078044701, 0.000922244042158127],
    [118.456852003798, 24.775221907504, 0.000922307372093201],
  ],
  [
    [118.457393737311, 24.7746953200037, 0.000922241248190403],
    [118.456837714551, 24.7752090170564, 0.000922306440770626],
  ],
  [
    [118.457379903254, 24.7746828265012, 0.000922240316867828],
    [118.456823425298, 24.7751961175798, 0.000922303646802902],
  ],
  [
    [118.45736607908, 24.7746703239625, 0.000922239385545254],
    [118.456809145929, 24.7751832090669, 0.000922302715480328],
  ],
  [
    [118.45735226478, 24.77465780336, 0.000922234728932381],
    [118.456794886331, 24.7751702915108, 0.000922301784157753],
  ],
  [
    [118.457338460372, 24.7746452827491, 0.00092223659157753],
    [118.456780636608, 24.7751573558907, 0.000922301784157753],
  ],
  [
    [118.457324665846, 24.7746327531021, 0.000922233797609806],
    [118.456766396769, 24.7751444112345, 0.000922298058867455],
  ],
  [
    [118.457310881196, 24.7746202053911, 0.000922232866287231],
    [118.45675216682, 24.7751314665699, 0.00092229712754488],
  ],
  [
    [118.457297116316, 24.774607648637, 0.000922230072319508],
    [118.456737946747, 24.7751185038414, 0.000922296196222305],
  ],
  [
    [118.457283351432, 24.7745950828539, 0.000922229140996933],
    [118.456723746445, 24.7751055320696, 0.000922292470932007],
  ],
  [
    [118.457269606326, 24.7745825170553, 0.000922227278351784],
    [118.456709546138, 24.7750925512688, 0.000922292470932007],
  ],
  [
    [118.457255871095, 24.7745699331928, 0.000922225415706635],
    [118.456695365595, 24.775079552397, 0.000922290608286858],
  ],
  [
    [118.457242145739, 24.7745573312665, 0.000922223553061485],
    [118.456681194943, 24.7750665535167, 0.000922288745641708],
  ],
  [
    [118.457228430274, 24.7745447293319, 0.000922225415706635],
    [118.456667034166, 24.7750535365726, 0.000922286882996559],
  ],
  [
    [118.457214724692, 24.7745321183611, 0.000922220759093761],
    [118.456652883272, 24.7750405105924, 0.00092228502035141],
  ],
  [
    [118.457201028985, 24.7745194893265, 0.000922220759093761],
    [118.456638742261, 24.7750274755759, 0.000922284089028835],
  ],
  [
    [118.457187353056, 24.7745068602765, 0.000922217033803463],
    [118.456624621022, 24.7750144315163, 0.000922280363738537],
  ],
  [
    [118.457173677115, 24.7744942131697, 0.000922216102480888],
    [118.456610509665, 24.7750013784206, 0.000922279432415962],
  ],
  [
    [118.457160020945, 24.7744815570197, 0.000922216102480888],
    [118.456596398304, 24.7749883162958, 0.000922279432415962],
  ],
  [
    [118.457146374658, 24.7744688918337, 0.000922214239835739],
    [118.456582306707, 24.7749752361, 0.000922278501093388],
  ],
  [
    [118.457132738253, 24.7744562176115, 0.000922210514545441],
    [118.456568225, 24.7749621558959, 0.000922274775803089],
  ],
  [
    [118.457119111732, 24.7744435343533, 0.000922209583222866],
    [118.456554163057, 24.7749490576209, 0.00092227291315794],
  ],
  [
    [118.457105495093, 24.774430842059, 0.000922207720577717],
    [118.456540101108, 24.7749359503167, 0.000922271050512791],
  ],
  [
    [118.457091888337, 24.7744181407287, 0.000922206789255142],
    [118.456526058931, 24.7749228339694, 0.000922271050512791],
  ],
  [
    [118.457078291464, 24.7744054303622, 0.000922205857932568],
    [118.456512026638, 24.774909708586, 0.000922268256545067],
  ],
  [
    [118.457064714355, 24.7743927019249, 0.000922203063964844],
    [118.456497994339, 24.7748965741735, 0.000922266393899918],
  ],
  [
    [118.457051137248, 24.7743799734863, 0.000922201201319695],
    [118.456483991692, 24.7748834216831, 0.000922265462577343],
  ],
  [
    [118.457037579904, 24.7743672269769, 0.000922201201319695],
    [118.456469989047, 24.7748702691914, 0.000922263599932194],
  ],
  [
    [118.457024032443, 24.7743544714313, 0.000922198407351971],
    [118.456455996279, 24.7748570986358, 0.000922262668609619],
  ],
  [
    [118.457010494865, 24.7743417068498, 0.000922197476029396],
    [118.456442023281, 24.7748439190371, 0.000922259874641895],
  ],
  [
    [118.456996967169, 24.7743289332321, 0.000922195613384247],
    [118.456428060166, 24.7748307304023, 0.000922259874641895],
  ],
  [
    [118.456983459245, 24.7743161505714, 0.000922193750739098],
    [118.456414097047, 24.7748175327384, 0.000922258011996746],
  ],
  [
    [118.456969951316, 24.7743033588817, 0.000922192819416523],
    [118.456400163587, 24.7748043260243, 0.000922256149351597],
  ],
  [
    [118.456956463157, 24.7742905581488, 0.000922191888093948],
    [118.456386230122, 24.7747911102812, 0.000922254286706448],
  ],
  [
    [118.456942974994, 24.774277748387, 0.000922189094126225],
    [118.456372306532, 24.7747778764743, 0.000922252424061298],
  ],
  [
    [118.456929506593, 24.7742649205543, 0.000922186300158501],
    [118.456358402721, 24.774764642652, 0.000922250561416149],
  ],
  [
    [118.456916048083, 24.7742520927133, 0.000922186300158501],
    [118.456344508786, 24.7747513907658, 0.000922249630093575],
  ],
  [
    [118.456902599449, 24.7742392468086, 0.000922183506190777],
    [118.456330624734, 24.7747381298436, 0.000922246836125851],
  ],
  [
    [118.456889160705, 24.7742264008955, 0.000922182574868202],
    [118.456316750565, 24.7747248598853, 0.000922244042158127],
  ],
  [
    [118.456875741724, 24.7742135369117, 0.000922181643545628],
    [118.456302886279, 24.774711580891, 0.000922244042158127],
  ],
  [
    [118.456862322738, 24.7742006638988, 0.000922178849577904],
    [118.456289041765, 24.7746982928535, 0.000922243110835552],
  ],
  [
    [118.456848923523, 24.7741877818429, 0.000922177918255329],
    [118.456275197245, 24.774684995787, 0.000922240316867828],
  ],
  [
    [118.456835534191, 24.774174890751, 0.00092217605561018],
    [118.45626137249, 24.7746716806497, 0.000922237522900105],
  ],
  [
    [118.456822154741, 24.774161990623, 0.000922175124287605],
    [118.456247557624, 24.7746583655041, 0.00092223659157753],
  ],
  [
    [118.456808785175, 24.774149081459, 0.000922173261642456],
    [118.456233752635, 24.7746450322946, 0.000922235660254955],
  ],
  [
    [118.456795425491, 24.7741361632591, 0.000922170467674732],
    [118.456219967416, 24.7746316900421, 0.000922234728932381],
  ],
  [
    [118.456782075683, 24.7741232269953, 0.000922169536352158],
    [118.456206182201, 24.7746183477883, 0.000922231934964657],
  ],
  [
    [118.456768745653, 24.7741102907163, 0.000922167673707008],
    [118.456192416748, 24.7746049874637, 0.000922229140996933],
  ],
  [
    [118.456755415619, 24.7740973454082, 0.000922165811061859],
    [118.456178661179, 24.774591618103, 0.000922229140996933],
  ],
  [
    [118.456742105347, 24.7740843820295, 0.000922164879739285],
    [118.456164915486, 24.7745782306786, 0.000922226347029209],
  ],
  [
    [118.456728804958, 24.7740714096147, 0.000922162085771561],
    [118.456151179683, 24.7745648432459, 0.000922225415706635],
  ],
  [
    [118.45671551446, 24.7740584371916, 0.000922161154448986],
    [118.456137463652, 24.7745514467701, 0.000922222621738911],
  ],
  [
    [118.456702243725, 24.7740454466978, 0.000922160223126411],
    [118.456123747608, 24.7745380322375, 0.000922221690416336],
  ],
  [
    [118.456688972985, 24.774032447175, 0.000922157429158688],
    [118.456110051342, 24.7745246176897, 0.000922221690416336],
  ],
  [
    [118.456675712128, 24.7740194386162, 0.000922156497836113],
    [118.456096364953, 24.774511185078, 0.000922217033803463],
  ],
  [
    [118.456662471041, 24.7740064210144, 0.000922153703868389],
    [118.456082698334, 24.7744977434234, 0.000922217965126038],
  ],
  [
    [118.456649239838, 24.7739933943766, 0.00092215184122324],
    [118.456069031711, 24.7744842927397, 0.000922215171158314],
  ],
  [
    [118.456636018517, 24.7739803587029, 0.00092215184122324],
    [118.456055384858, 24.774470833013, 0.000922213308513165],
  ],
  [
    [118.45662280708, 24.7739673139931, 0.000922149978578091],
    [118.456041738001, 24.7744573642573, 0.000922211445868015],
  ],
  [
    [118.456609615413, 24.7739542602404, 0.000922147184610367],
    [118.456028110915, 24.7744438864586, 0.000922210514545441],
  ],
  [
    [118.456596423733, 24.773941188431, 0.000922146253287792],
    [118.456014503593, 24.7744303905891, 0.000922207720577717],
  ],
  [
    [118.456583251832, 24.7739281166063, 0.000922143459320068],
    [118.456000896273, 24.7744168947184, 0.000922206789255142],
  ],
  [
    [118.456570089814, 24.7739150357456, 0.000922143459320068],
    [118.455987308717, 24.7744033807769, 0.000922206789255142],
  ],
  [
    [118.456556927783, 24.7739019368283, 0.000922140665352345],
    [118.455973721163, 24.7743898668341, 0.000922203063964844],
  ],
  [
    [118.456543795419, 24.7738888378887, 0.00092213973402977],
    [118.455960153373, 24.7743763348206, 0.000922202132642269],
  ],
  [
    [118.456530663042, 24.7738757208924, 0.000922137871384621],
    [118.455946605354, 24.7743627937642, 0.00092220026999712],
  ],
  [
    [118.456517540547, 24.7738625948602, 0.000922136940062046],
    [118.455933057331, 24.7743492436787, 0.000922198407351971],
  ],
  [
    [118.456504437832, 24.7738494688127, 0.000922135077416897],
    [118.455919529078, 24.7743356845502, 0.000922196544706821],
  ],
  [
    [118.456491344991, 24.7738363247016, 0.000922132283449173],
    [118.455906000821, 24.7743221163928, 0.000922195613384247],
  ],
  [
    [118.456478262033, 24.7738231715545, 0.000922132283449173],
    [118.455892492335, 24.7743085391924, 0.000922191888093948],
  ],
  [
    [118.456465188958, 24.7738100093715, 0.000922130420804024],
    [118.455878993732, 24.7742949529559, 0.000922192819416523],
  ],
  [
    [118.456452125767, 24.7737968381525, 0.0009221276268363],
    [118.455865514892, 24.7742813486488, 0.000922190025448799],
  ],
  [
    [118.456439072458, 24.7737836578976, 0.000922126695513725],
    [118.455852036055, 24.7742677443405, 0.000922187231481075],
  ],
  [
    [118.456426038919, 24.7737704685997, 0.000922123901546001],
    [118.455838576982, 24.7742541219614, 0.000922186300158501],
  ],
  [
    [118.456413015264, 24.7737572702659, 0.000922123901546001],
    [118.4558251278, 24.7742404995741, 0.000922184437513351],
  ],
  [
    [118.456400001492, 24.7737440628961, 0.000922121107578278],
    [118.45581169838, 24.7742268591161, 0.000922183506190777],
  ],
  [
    [118.456386997602, 24.7737308464905, 0.000922120176255703],
    [118.455798268957, 24.7742132096292, 0.000922181643545628],
  ],
  [
    [118.456374003588, 24.7737176120211, 0.000922118313610554],
    [118.455784859304, 24.7741995510993, 0.000922178849577904],
  ],
  [
    [118.456361029352, 24.7737043775366, 0.000922116450965405],
    [118.455771449646, 24.7741858835404, 0.000922176986932755],
  ],
  [
    [118.456348055111, 24.7736911340232, 0.000922116450965405],
    [118.455758069648, 24.7741722069316, 0.000922175124287605],
  ],
  [
    [118.456335100633, 24.7736778724391, 0.000922112725675106],
    [118.455744689644, 24.7741585212938, 0.000922173261642456],
  ],
  [
    [118.456322156046, 24.7736646108468, 0.000922112725675106],
    [118.455731319524, 24.7741448266201, 0.000922171398997307],
  ],
  [
    [118.456309221334, 24.7736513311909, 0.000922109000384808],
    [118.455717969167, 24.7741311138757, 0.000922169536352158],
  ],
  [
    [118.456296296512, 24.7736380515268, 0.000922109000384808],
    [118.455704628701, 24.7741174011231, 0.000922169536352158],
  ],
  [
    [118.456283391454, 24.7736247537921, 0.000922107137739658],
    [118.455691298118, 24.7741036793346, 0.000922165811061859],
  ],
  [
    [118.456270496286, 24.7736114560492, 0.000922106206417084],
    [118.455677977411, 24.7740899394824, 0.000922165811061859],
  ],
  [
    [118.456257601105, 24.7735981402496, 0.00092210341244936],
    [118.455664676475, 24.7740761905873, 0.000922163017094135],
  ],
  [
    [118.456244735584, 24.7735848154002, 0.000922101549804211],
    [118.455651385429, 24.774062441684, 0.000922160223126411],
  ],
  [
    [118.456231870057, 24.7735714815218, 0.000922098755836487],
    [118.455638104259, 24.774048674717, 0.000922160223126411],
  ],
  [
    [118.45621901442, 24.7735581476354, 0.000922097824513912],
    [118.455624832972, 24.7740348987141, 0.000922159291803837],
  ],
  [
    [118.456206178547, 24.7735447956783, 0.000922096893191338],
    [118.455611571569, 24.7740211136753, 0.000922157429158688],
  ],
  [
    [118.456193342669, 24.7735314346923, 0.000922095030546188],
    [118.455598329936, 24.7740073195936, 0.000922154635190964],
  ],
  [
    [118.456180526562, 24.7735180646634, 0.000922093167901039],
    [118.455585098186, 24.773993516476, 0.000922153703868389],
  ],
  [
    [118.456167730225, 24.7735046855916, 0.000922092236578465],
    [118.45557187632, 24.7739797043225, 0.000922149978578091],
  ],
  [
    [118.456154933883, 24.773491297491, 0.000922089442610741],
    [118.455558664337, 24.773965883133, 0.000922149978578091],
  ],
  [
    [118.456142147424, 24.7734779003545, 0.000922087579965591],
    [118.455545472125, 24.7739520529007, 0.000922147184610367],
  ],
  [
    [118.456129380736, 24.7734644941751, 0.000922086648643017],
    [118.455532289795, 24.7739382136325, 0.000922147184610367],
  ],
  [
    [118.456116623931, 24.7734510789598, 0.000922084785997868],
    [118.455519117342, 24.7739243563006, 0.000922145321965218],
  ],
  [
    [118.456103877009, 24.7734376547087, 0.000922082923352718],
    [118.455505954779, 24.7739104989606, 0.000922142527997494],
  ],
  [
    [118.456091139969, 24.7734242214218, 0.000922081992030144],
    [118.455492802092, 24.7738966235569, 0.000922141596674919],
  ],
  [
    [118.4560784227, 24.7734107790919, 0.00092207919806242],
    [118.455479669183, 24.7738827481382, 0.000922140665352345],
  ],
  [
    [118.456065705427, 24.7733973277333, 0.000922077335417271],
    [118.45546654615, 24.7738688546558, 0.000922137871384621],
  ],
  [
    [118.456053007916, 24.773383858304, 0.000922076404094696],
    [118.455453433, 24.7738549521375, 0.000922136008739471],
  ],
  [
    [118.456040320296, 24.7733703888666, 0.000922074541449547],
    [118.455440339629, 24.7738410496041, 0.000922134146094322],
  ],
  [
    [118.456027642559, 24.7733569103933, 0.000922072678804398],
    [118.455427246245, 24.773827129014, 0.000922132283449173],
  ],
  [
    [118.456014984592, 24.7733434228772, 0.000922071747481823],
    [118.455414172632, 24.7738131993811, 0.000922130420804024],
  ],
  [
    [118.456002326613, 24.7733299173046, 0.000922069884836674],
    [118.455401108903, 24.7737992607124, 0.000922128558158875],
  ],
  [
    [118.455989688412, 24.7733164117168, 0.000922068022191525],
    [118.455388055056, 24.7737853130078, 0.000922126695513725],
  ],
  [
    [118.455977060094, 24.7733028970932, 0.000922068022191525],
    [118.455375020981, 24.7737713562603, 0.000922123901546001],
  ],
  [
    [118.455964441652, 24.7732893644061, 0.000922065228223801],
    [118.455361996788, 24.773757390477, 0.000922123901546001],
  ],
  [
    [118.455951842987, 24.7732758317038, 0.000922062434256077],
    [118.455348982479, 24.7737434156578, 0.000922121107578278],
  ],
  [
    [118.455939244318, 24.7732622899727, 0.000922062434256077],
    [118.455335978053, 24.7737294318027, 0.000922121107578278],
  ],
  [
    [118.455926665412, 24.7732487301711, 0.000922058708965778],
    [118.455322993398, 24.7737154389049, 0.000922118313610554],
  ],
  [
    [118.455914096396, 24.7732351703613, 0.000922057777643204],
    [118.455310008731, 24.7737014279504, 0.000922116450965405],
  ],
  [
    [118.455901537255, 24.773221592488, 0.000922056846320629],
    [118.455297043842, 24.7736874169808, 0.000922114588320255],
  ],
  [
    [118.455888997893, 24.7732080145997, 0.000922054052352905],
    [118.455284088836, 24.7736733969754, 0.000922113656997681],
  ],
  [
    [118.455876458518, 24.7731944186548, 0.000922053121030331],
    [118.455271153594, 24.7736593588995, 0.000922111794352531],
  ],
  [
    [118.455863938922, 24.7731808226948, 0.000922051258385181],
    [118.455258228242, 24.7736453208154, 0.000922109000384808],
  ],
  [
    [118.4558514292, 24.7731672086713, 0.000922049395740032],
    [118.455245312774, 24.7736312736955, 0.000922108069062233],
  ],
  [
    [118.455838939257, 24.7731535946327, 0.000922045670449734],
    [118.455232407181, 24.7736172085121, 0.000922106206417084],
  ],
  [
    [118.455826449302, 24.7731399625375, 0.000922045670449734],
    [118.455219511471, 24.7736031342928, 0.00092210341244936],
  ],
  [
    [118.455813979125, 24.7731263304273, 0.00092204287648201],
    [118.455206635539, 24.7735890600584, 0.000922102481126785],
  ],
  [
    [118.455801508935, 24.7731126802606, 0.000922041945159435],
    [118.455193769484, 24.7735749677605, 0.000922100618481636],
  ],
  [
    [118.455789058523, 24.7730990300788, 0.000922040082514286],
    [118.455180913319, 24.7735608754546, 0.000922097824513912],
  ],
  [
    [118.455776627875, 24.7730853618265, 0.000922039151191711],
    [118.455168076917, 24.7735467650781, 0.000922097824513912],
  ],
  [
    [118.455764197229, 24.7730716935732, 0.000922035425901413],
    [118.455155240511, 24.7735326456727, 0.000922095030546188],
  ],
  [
    [118.455751786346, 24.7730580072493, 0.000922036357223988],
    [118.455142423875, 24.7735185172246, 0.000922093167901039],
  ],
  [
    [118.455739385354, 24.7730443209174, 0.000922032631933689],
    [118.455129617123, 24.7735043797407, 0.000922092236578465],
  ],
  [
    [118.455726994237, 24.773030616522, 0.00092203076928854],
    [118.455116830149, 24.7734902422417, 0.000922090373933315],
  ],
  [
    [118.45571461301, 24.7730169121185, 0.00092203076928854],
    [118.455104053051, 24.7734760866792, 0.000922087579965591],
  ],
  [
    [118.455702251547, 24.7730031896446, 0.000922027975320816],
    [118.455091275948, 24.7734619220879, 0.000922085717320442],
  ],
  [
    [118.455689899974, 24.7729894671626, 0.000922027043998241],
    [118.455078528503, 24.7734477484468, 0.000922084785997868],
  ],
  [
    [118.455677548388, 24.7729757266241, 0.000922023318707943],
    [118.455065781055, 24.7734335657769, 0.000922081992030144],
  ],
  [
    [118.455665226468, 24.7729619860636, 0.000922023318707943],
    [118.455053053377, 24.7734193740643, 0.000922080129384995],
  ],
  [
    [118.455652904536, 24.7729482274465, 0.000922020524740219],
    [118.455040335582, 24.7734051733159, 0.000922080129384995],
  ],
  [
    [118.455640602382, 24.7729344688145, 0.000922020524740219],
    [118.45502762767, 24.7733909635317, 0.000922077335417271],
  ],
  [
    [118.455628310104, 24.772920692119, 0.00092201866209507],
    [118.455014939529, 24.7733767447047, 0.000922075472772121],
  ],
  [
    [118.455616027715, 24.7729069154154, 0.000922015868127346],
    [118.455002251383, 24.773362516849, 0.000922073610126972],
  ],
  [
    [118.455603755202, 24.7728931206484, 0.000922014005482197],
    [118.454989583001, 24.7733482709227, 0.000922071747481823],
  ],
  [
    [118.45559149258, 24.7728793258734, 0.000922014005482197],
    [118.454976934397, 24.7733340249815, 0.000922070816159248],
  ],
  [
    [118.45557924972, 24.7728655130279, 0.000922011211514473],
    [118.454964285789, 24.7733197700115, 0.000922068953514099],
  ],
  [
    [118.455567016751, 24.7728517001744, 0.000922008417546749],
    [118.454951656951, 24.7733055059987, 0.000922066159546375],
  ],
  [
    [118.455554793658, 24.7728378692574, 0.0009220065549016],
    [118.454939037997, 24.7732912329502, 0.000922063365578651],
  ],
  [
    [118.455542590342, 24.7728240383254, 0.0009220065549016],
    [118.454926428918, 24.7732769418382, 0.000922063365578651],
  ],
  [
    [118.455530387021, 24.7728101983647, 0.000922003760933876],
    [118.454913839618, 24.7732626507112, 0.000922061502933502],
  ],
  [
    [118.455518203464, 24.7727963403335, 0.000922002829611301],
    [118.4549012602, 24.7732483505485, 0.000922059640288353],
  ],
  [
    [118.455506029797, 24.7727824822944, 0.000922001898288727],
    [118.454888690666, 24.77323404135, 0.000922057777643204],
  ],
  [
    [118.455493866005, 24.7727686061917, 0.000921999104321003],
    [118.454876131007, 24.773219714088, 0.000922056846320629],
  ],
  [
    [118.455481721991, 24.7727547300741, 0.000921996310353279],
    [118.454863591127, 24.7732053868111, 0.000922054052352905],
  ],
  [
    [118.45546958786, 24.7727408449209, 0.000921995379030705],
    [118.45485106113, 24.7731910504984, 0.000922053121030331],
  ],
  [
    [118.455457463605, 24.7727269417041, 0.000921992585062981],
    [118.454838541008, 24.7731766961222, 0.000922049395740032],
  ],
  [
    [118.45544534924, 24.7727130384793, 0.000921991653740406],
    [118.454826040665, 24.7731623417312, 0.000922048464417458],
  ],
  [
    [118.455433244757, 24.7726991262189, 0.000921989791095257],
    [118.454813540317, 24.7731479783113, 0.000922045670449734],
  ],
  [
    [118.455421160046, 24.7726852049158, 0.000921988859772682],
    [118.454801059733, 24.7731335968209, 0.000922044739127159],
  ],
  [
    [118.455409085209, 24.7726712655492, 0.000921986997127533],
    [118.454788598927, 24.7731192153157, 0.000922041945159435],
  ],
  [
    [118.455397020263, 24.7726573261747, 0.000921985134482384],
    [118.454776138116, 24.7731048247817, 0.000922041945159435],
  ],
  [
    [118.455384975087, 24.7726433777575, 0.000921983271837235],
    [118.454763697068, 24.7730904161773, 0.000922039151191711],
  ],
  [
    [118.455372929907, 24.7726294203115, 0.000921980477869511],
    [118.454751265911, 24.7730760075649, 0.000922038219869137],
  ],
  [
    [118.455360904497, 24.7726154538229, 0.000921980477869511],
    [118.454738854518, 24.7730615808821, 0.000922036357223988],
  ],
  [
    [118.45534888897, 24.7726014782986, 0.000921976752579212],
    [118.454726443127, 24.7730471541983, 0.000922034494578838],
  ],
  [
    [118.455336893214, 24.7725874937317, 0.000921974889934063],
    [118.454714051507, 24.7730327184718, 0.00092203076928854],
  ],
  [
    [118.455324897452, 24.772573500136, 0.000921973958611488],
    [118.454701669763, 24.7730182646819, 0.000922029837965965],
  ],
  [
    [118.455312921461, 24.7725594974977, 0.000921972095966339],
    [118.454689307797, 24.7730038108771, 0.000922028906643391],
  ],
  [
    [118.455300955353, 24.7725454858237, 0.000921971164643765],
    [118.454676955707, 24.7729893390088, 0.000922027043998241],
  ],
  [
    [118.455288999128, 24.772531465114, 0.000921969301998615],
    [118.454664613507, 24.7729748671326, 0.000922024250030518],
  ],
  [
    [118.455277062674, 24.7725174353617, 0.000921966508030891],
    [118.45465228119, 24.7729603862206, 0.000922022387385368],
  ],
  [
    [118.455265136102, 24.7725033965737, 0.000921965576708317],
    [118.454639968637, 24.7729458872383, 0.000922023318707943],
  ],
  [
    [118.455253219413, 24.77248934875, 0.000921963714063168],
    [118.454627665974, 24.7729313882481, 0.000922019593417645],
  ],
  [
    [118.455241312614, 24.7724753009184, 0.000921961851418018],
    [118.454615373194, 24.7729168802222, 0.000922016799449921],
  ],
  [
    [118.455229425579, 24.7724612350165, 0.000921960920095444],
    [118.45460309029, 24.7729023541328, 0.000922014936804771],
  ],
  [
    [118.455217538538, 24.7724471600858, 0.000921957194805145],
    [118.454590827164, 24.7728878280286, 0.000922014005482197],
  ],
  [
    [118.455205671276, 24.7724330851402, 0.000921957194805145],
    [118.454578573921, 24.7728732928887, 0.000922011211514473],
  ],
  [
    [118.455193823776, 24.7724189921244, 0.000921955332159996],
    [118.454566340442, 24.7728587396785, 0.000922010280191898],
  ],
  [
    [118.455181976272, 24.7724048900797, 0.000921951606869698],
    [118.454554106965, 24.7728441864672, 0.000922008417546749],
  ],
  [
    [118.455170148545, 24.7723907880203, 0.000921951606869698],
    [118.45454189326, 24.7728296242133, 0.0009220065549016],
  ],
  [
    [118.455158330694, 24.7723766678974, 0.000921949744224548],
    [118.454529689429, 24.7728150438961, 0.000922003760933876],
  ],
  [
    [118.455146522734, 24.7723625477667, 0.000921947881579399],
    [118.454517505377, 24.772800463564, 0.000922001898288727],
  ],
  [
    [118.455134734543, 24.7723484185933, 0.00092194601893425],
    [118.454505331209, 24.7727858741962, 0.000922000966966152],
  ],
  [
    [118.455122946341, 24.7723342713635, 0.000921944156289101],
    [118.454493166923, 24.7727712757928, 0.000922000035643578],
  ],
  [
    [118.455111177916, 24.7723201241189, 0.000921943224966526],
    [118.454481012513, 24.7727566593259, 0.000921997241675854],
  ],
  [
    [118.455099429262, 24.7723059678317, 0.000921941362321377],
    [118.454468877881, 24.7727420428443, 0.000921995379030705],
  ],
  [
    [118.455087680603, 24.7722918025157, 0.000921938568353653],
    [118.454456753132, 24.772727417327, 0.000921993516385555],
  ],
  [
    [118.455075951707, 24.7722776191295, 0.000921936705708504],
    [118.454444638266, 24.772712782774, 0.000921991653740406],
  ],
  [
    [118.455064232701, 24.7722634357354, 0.00092193391174078],
    [118.454432543171, 24.7726981391785, 0.000921989791095257],
  ],
  [
    [118.455052523579, 24.7722492433057, 0.000921932980418205],
    [118.454420457959, 24.7726834865473, 0.000921988859772682],
  ],
  [
    [118.455040834226, 24.7722350418333, 0.000921931117773056],
    [118.45440838263, 24.7726688248805, 0.000921986065804958],
  ],
  [
    [118.455029154764, 24.7722208403532, 0.000921930186450481],
    [118.454396317176, 24.7726541451503, 0.000921984203159809],
  ],
  [
    [118.455017485177, 24.7722066208096, 0.000921928323805332],
    [118.454384271501, 24.7726394654053, 0.000921983271837235],
  ],
  [
    [118.455005825473, 24.7721923922304, 0.000921926461160183],
    [118.454372235709, 24.7726247766247, 0.000921980477869511],
  ],
  [
    [118.45499418554, 24.7721781546087, 0.000921925529837608],
    [118.454360219688, 24.7726100788016, 0.000921979546546936],
  ],
  [
    [118.454982545609, 24.7721639169861, 0.000921922735869884],
    [118.454348203662, 24.7725953719497, 0.000921976752579212],
  ],
  [
    [118.454970935329, 24.7721496612862, 0.000921919941902161],
    [118.454336207414, 24.772580665083, 0.000921974889934063],
  ],
  [
    [118.454959325044, 24.7721353965577, 0.000921920873224735],
    [118.454324221042, 24.772565940153, 0.000921973027288914],
  ],
  [
    [118.454947734536, 24.7721211318143, 0.000921917147934437],
    [118.454312254441, 24.7725512061804, 0.000921971164643765],
  ],
  [
    [118.454936144024, 24.7721068580423, 0.000921915285289288],
    [118.454300297722, 24.7725364631722, 0.000921969301998615],
  ],
  [
    [118.454924583163, 24.7720925661931, 0.000921914353966713],
    [118.454288350887, 24.7725217111284, 0.000921966508030891],
  ],
  [
    [118.454913022304, 24.772078274343, 0.000921910628676414],
    [118.45427642383, 24.7725069590699, 0.000921966508030891],
  ],
  [
    [118.454901481216, 24.7720639734503, 0.00092190969735384],
    [118.454264496761, 24.7724921889549, 0.000921963714063168],
  ],
  [
    [118.45488995001, 24.7720496635221, 0.000921907834708691],
    [118.45425259935, 24.7724774097905, 0.000921962782740593],
  ],
  [
    [118.45487842868, 24.7720353355305, 0.000921905972063541],
    [118.454240701942, 24.7724626306251, 0.000921959988772869],
  ],
  [
    [118.45486691724, 24.7720210075311, 0.000921905040740967],
    [118.454228824297, 24.7724478333895, 0.00092195812612772],
  ],
  [
    [118.454855425578, 24.7720066795169, 0.000921902246773243],
    [118.454216956535, 24.7724330271183, 0.000921956263482571],
  ],
  [
    [118.454843943791, 24.7719923334394, 0.000921901315450668],
    [118.454205098664, 24.7724182208393, 0.000921953469514847],
  ],
  [
    [118.454832481775, 24.7719779783194, 0.000921899452805519],
    [118.454193260556, 24.77240339649, 0.000921951606869698],
  ],
  [
    [118.454821019753, 24.7719636141707, 0.00092189759016037],
    [118.454181432339, 24.7723885721328, 0.000921950675547123],
  ],
  [
    [118.45480957751, 24.7719492500073, 0.000921896658837795],
    [118.454169614004, 24.7723737387401, 0.000921949744224548],
  ],
  [
    [118.454798145142, 24.7719348677806, 0.000921893864870071],
    [118.454157815433, 24.7723588872772, 0.00092194601893425],
  ],
  [
    [118.454786732544, 24.7719204765114, 0.000921892002224922],
    [118.454146026752, 24.7723440358064, 0.000921945087611675],
  ],
  [
    [118.454775319949, 24.7719060852413, 0.000921889208257198],
    [118.454134247955, 24.7723291753001, 0.000921944156289101],
  ],
  [
    [118.454763927125, 24.7718916849287, 0.000921888276934624],
    [118.45412247904, 24.7723143057581, 0.000921942293643951],
  ],
  [
    [118.454752544183, 24.7718772755806, 0.000921886414289474],
    [118.454110729896, 24.7722994271737, 0.000921939499676228],
  ],
  [
    [118.454741181004, 24.7718628481622, 0.0009218854829669],
    [118.454099000515, 24.7722845305192, 0.000921937637031078],
  ],
  [
    [118.454729827715, 24.771848420736, 0.000921882688999176],
    [118.454087271137, 24.7722696338636, 0.000921935774385929],
  ],
  [
    [118.45471848431, 24.7718339842743, 0.000921879895031452],
    [118.45407556153, 24.7722547281657, 0.00092193391174078],
  ],
  [
    [118.454707150786, 24.771819538777, 0.000921880826354027],
    [118.454063861813, 24.7722398224599, 0.000921932980418205],
  ],
  [
    [118.454695837041, 24.771805093265, 0.000921878032386303],
    [118.45405218186, 24.7722248986839, 0.000921928323805332],
  ],
  [
    [118.454684533171, 24.7717906296897, 0.000921875238418579],
    [118.454040501901, 24.7722099658793, 0.000921928323805332],
  ],
  [
    [118.454673239184, 24.7717761570789, 0.000921872444450855],
    [118.454028841714, 24.7721950240322, 0.000921927392482758],
  ],
  [
    [118.454661955087, 24.7717616844603, 0.000921872444450855],
    [118.454017201297, 24.7721800731427, 0.000921925529837608],
  ],
  [
    [118.454650690753, 24.7717471937715, 0.000921869650483131],
    [118.454005570771, 24.7721651222454, 0.000921924598515034],
  ],
  [
    [118.454639436309, 24.7717327030749, 0.000921868719160557],
    [118.45399395012, 24.7721501532848, 0.000921922735869884],
  ],
  [
    [118.454628191741, 24.771718194315, 0.000921866856515408],
    [118.453982339359, 24.7721351843164, 0.000921919941902161],
  ],
  [
    [118.45461696695, 24.7717036855404, 0.000921865925192833],
    [118.453970748362, 24.7721201972778, 0.000921916216611862],
  ],
  [
    [118.454605752042, 24.7716891677304, 0.000921864062547684],
    [118.453959167255, 24.7721052102314, 0.000921916216611862],
  ],
  [
    [118.454594547017, 24.7716746408847, 0.000921862199902534],
    [118.453947596032, 24.7720902141495, 0.000921914353966713],
  ],
  [
    [118.454583351874, 24.7716601050036, 0.00092186126857996],
    [118.453936044571, 24.7720751999975, 0.000921912491321564],
  ],
  [
    [118.454572176502, 24.7716455600801, 0.000921857543289661],
    [118.453924503001, 24.7720601858377, 0.00092190969735384],
  ],
  [
    [118.45456101102, 24.7716310151487, 0.000921855680644512],
    [118.453912981202, 24.7720451626355, 0.000921908766031265],
  ],
  [
    [118.454549855414, 24.7716164521541, 0.000921854749321938],
    [118.453901459397, 24.7720301304046, 0.000921905040740967],
  ],
  [
    [118.454538719585, 24.7716018891449, 0.000921851955354214],
    [118.453889957364, 24.7720150891313, 0.000921904109418392],
  ],
  [
    [118.454527593631, 24.7715873080724, 0.000921850092709064],
    [118.453878475101, 24.7720000388157, 0.000921903178095818],
  ],
  [
    [118.454516477568, 24.7715727269921, 0.000921848230063915],
    [118.453866992841, 24.7719849884991, 0.000921898521482944],
  ],
  [
    [118.454505381275, 24.7715581368695, 0.000921847298741341],
    [118.453855530344, 24.7719699201124, 0.000921900384128094],
  ],
  [
    [118.454494284977, 24.7715435377182, 0.000921844504773617],
    [118.453844087618, 24.7719548426834, 0.000921896658837795],
  ],
  [
    [118.45448320845, 24.7715289295245, 0.000921842642128468],
    [118.453832654782, 24.7719397652466, 0.000921894796192646],
  ],
  [
    [118.454472151692, 24.7715143122885, 0.000921839848160744],
    [118.453821231822, 24.7719246697465, 0.000921892002224922],
  ],
  [
    [118.45446109493, 24.7714996860238, 0.000921838916838169],
    [118.453809818752, 24.7719095742387, 0.000921891070902348],
  ],
  [
    [118.454450057939, 24.7714850507168, 0.000921836122870445],
    [118.453798425445, 24.7718944606608, 0.000921888276934624],
  ],
  [
    [118.454439040725, 24.7714704153951, 0.000921834260225296],
    [118.453787042029, 24.7718793470751, 0.000921888276934624],
  ],
  [
    [118.454428023498, 24.7714557620171, 0.000921834260225296],
    [118.453775668496, 24.7718642244539, 0.000921883620321751],
  ],
  [
    [118.45441702605, 24.7714411086245, 0.000921831466257572],
    [118.453764314733, 24.7718490927904, 0.000921882688999176],
  ],
  [
    [118.454406038484, 24.7714264461963, 0.000921829603612423],
    [118.453752970853, 24.7718339520914, 0.000921881757676601],
  ],
  [
    [118.454395070681, 24.7714117656981, 0.000921829603612423],
    [118.453741636856, 24.7718188023568, 0.000921879895031452],
  ],
  [
    [118.454384102881, 24.7713970851991, 0.000921826809644699],
    [118.45373032263, 24.77180364358, 0.000921877101063728],
  ],
  [
    [118.454373154858, 24.7713824046854, 0.000921823084354401],
    [118.453719018287, 24.7717884757677, 0.000921877101063728],
  ],
  [
    [118.454362226598, 24.7713677061016, 0.000921823084354401],
    [118.453707733714, 24.771773298913, 0.000921872444450855],
  ],
  [
    [118.454351298334, 24.7713529984892, 0.000921821221709251],
    [118.453696459032, 24.7717581220506, 0.00092187337577343],
  ],
  [
    [118.454340389847, 24.7713382908622, 0.000921819359064102],
    [118.453685194225, 24.771742927125, 0.000921870581805706],
  ],
  [
    [118.454329501123, 24.7713235651652, 0.000921815633773804],
    [118.453673939309, 24.7717277321917, 0.000921868719160557],
  ],
  [
    [118.454318612401, 24.7713088394673, 0.000921814702451229],
    [118.453662704163, 24.7717125282161, 0.000921864993870258],
  ],
  [
    [118.45430774345, 24.771294104727, 0.00092181283980608],
    [118.453651478893, 24.7716973061772, 0.000921864993870258],
  ],
  [
    [118.454296884382, 24.7712793609513, 0.000921811908483505],
    [118.4536402734, 24.7716820841238, 0.000921862199902534],
  ],
  [
    [118.454286045083, 24.7712646081333, 0.000921809114515781],
    [118.453629077791, 24.7716668530349, 0.000921860337257385],
  ],
  [
    [118.45427520578, 24.7712498462867, 0.000921808183193207],
    [118.453617892065, 24.7716516129105, 0.000921859405934811],
  ],
  [
    [118.454264386248, 24.7712350753978, 0.000921806320548058],
    [118.453606726109, 24.7716363637439, 0.000921854749321938],
  ],
  [
    [118.454253586492, 24.7712203044943, 0.000921802595257759],
    [118.453595560156, 24.7716211145764, 0.000921853817999363],
  ],
  [
    [118.454242796613, 24.7712055155276, 0.000921801663935184],
    [118.453584423853, 24.771605847332, 0.000921851955354214],
  ],
  [
    [118.454232016623, 24.7711907265532, 0.000921799801290035],
    [118.453573287554, 24.7715905800868, 0.000921851024031639],
  ],
  [
    [118.454221246516, 24.7711759285434, 0.000921798869967461],
    [118.453562171017, 24.7715752947715, 0.00092184916138649],
  ],
  [
    [118.454210486292, 24.7711611214981, 0.000921796075999737],
    [118.453551074259, 24.7715600094417, 0.000921846367418766],
  ],
  [
    [118.454199745837, 24.7711463054106, 0.000921796075999737],
    [118.453539977495, 24.7715447150833, 0.000921843573451042],
  ],
  [
    [118.454189025154, 24.7711314802807, 0.000921793282032013],
    [118.453528900495, 24.7715294026548, 0.000921843573451042],
  ],
  [
    [118.454178304472, 24.77111665515, 0.000921790488064289],
    [118.453517843273, 24.7715140902119, 0.000921840779483318],
  ],
  [
    [118.454167603554, 24.7711018119493, 0.000921787694096565],
    [118.453506795941, 24.7714987777612, 0.000921837985515594],
  ],
  [
    [118.454156912526, 24.7710869687409, 0.000921786762773991],
    [118.453495758485, 24.7714834472474, 0.000921835191547871],
  ],
  [
    [118.454146241267, 24.7710721164902, 0.000921784900128841],
    [118.453484730912, 24.7714681076981, 0.000921835191547871],
  ],
  [
    [118.454135579885, 24.7710572461763, 0.000921783968806267],
    [118.453473723109, 24.7714527591066, 0.000921834260225296],
  ],
  [
    [118.454124928399, 24.7710423848826, 0.000921781174838543],
    [118.453462725196, 24.7714374105074, 0.000921829603612423],
  ],
  [
    [118.454114286789, 24.7710275055256, 0.000921779312193394],
    [118.453451747054, 24.771422052866, 0.000921828672289848],
  ],
  [
    [118.454103664949, 24.7710126171264, 0.000921777449548244],
    [118.453440778788, 24.7714066771614, 0.000921827740967274],
  ],
  [
    [118.454093052999, 24.7709977287196, 0.00092177651822567],
    [118.453429820411, 24.7713913014492, 0.000921825878322124],
  ],
  [
    [118.454082460813, 24.7709828222427, 0.000921772792935371],
    [118.453418881806, 24.7713759166947, 0.000921824015676975],
  ],
  [
    [118.454071868628, 24.770967915765, 0.000921771861612797],
    [118.453407953083, 24.7713605229048, 0.000921821221709251],
  ],
  [
    [118.454061296214, 24.770953000245, 0.000921769998967648],
    [118.45339703425, 24.7713451291072, 0.000921818427741528],
  ],
  [
    [118.454050733675, 24.7709380666619, 0.000921768136322498],
    [118.453386135188, 24.7713297262674, 0.000921816565096378],
  ],
  [
    [118.454040190913, 24.7709231330644, 0.000921766273677349],
    [118.453375246009, 24.7713143143922, 0.000921815633773804],
  ],
  [
    [118.454029648147, 24.7709081904382, 0.0009217644110322],
    [118.453364376601, 24.7712988934748, 0.000921814702451229],
  ],
  [
    [118.454019125151, 24.7708932387698, 0.000921762548387051],
    [118.453353517075, 24.7712834635219, 0.00092181283980608],
  ],
  [
    [118.454008612037, 24.7708782780661, 0.000921759754419327],
    [118.453342677327, 24.7712680335546, 0.000921810977160931],
  ],
  [
    [118.453998108806, 24.7708633083269, 0.000921758823096752],
    [118.453331847462, 24.771252594552, 0.000921807251870632],
  ],
  [
    [118.453987625346, 24.7708483295455, 0.000921756029129028],
    [118.45332102748, 24.7712371465139, 0.000921807251870632],
  ],
  [
    [118.45397714188, 24.7708333417356, 0.000921755097806454],
    [118.453310227276, 24.7712216984614, 0.000921804457902908],
  ],
  [
    [118.453966678184, 24.7708183448834, 0.000921753235161304],
    [118.453299436955, 24.7712062413735, 0.000921802595257759],
  ],
  [
    [118.453956224379, 24.7708033480237, 0.00092175230383873],
    [118.453288666404, 24.7711907752433, 0.000921798869967461],
  ],
  [
    [118.453945780449, 24.7707883331008, 0.000921749509871006],
    [118.453277905736, 24.7711753000779, 0.000921797007322311],
  ],
  [
    [118.453935356289, 24.7707733091356, 0.000921747647225857],
    [118.453267154959, 24.7711598249048, 0.000921795144677162],
  ],
  [
    [118.453924932131, 24.7707582851697, 0.000921746715903282],
    [118.453256414064, 24.7711443406963, 0.000921794213354588],
  ],
  [
    [118.453914527736, 24.7707432431339, 0.000921742990612984],
    [118.453245692947, 24.7711288564733, 0.000921793282032013],
  ],
  [
    [118.453904133232, 24.7707282010904, 0.000921742059290409],
    [118.453234991593, 24.7711133541805, 0.000921791419386864],
  ],
  [
    [118.45389374861, 24.7707131500115, 0.00092174019664526],
    [118.453224290242, 24.7710978518868, 0.00092178862541914],
  ],
  [
    [118.45388337387, 24.7706980898973, 0.000921737402677536],
    [118.453213608669, 24.7710823495787, 0.000921785831451416],
  ],
  [
    [118.453873009013, 24.7706830207477, 0.000921736471354961],
    [118.453202946858, 24.7710668292007, 0.000921783968806267],
  ],
  [
    [118.453862654039, 24.7706679425628, 0.000921734608709812],
    [118.453192285051, 24.7710513088219, 0.000921782106161118],
  ],
  [
    [118.453852318835, 24.7706528553357, 0.000921732746064663],
    [118.453181643021, 24.7710357884287, 0.000921781174838543],
  ],
  [
    [118.45384199352, 24.770637768101, 0.000921730883419514],
    [118.453171020762, 24.7710202589933, 0.000921778380870819],
  ],
  [
    [118.453831668194, 24.77062266281, 0.000921727158129215],
    [118.453160398498, 24.7710047205294, 0.000921777449548244],
  ],
  [
    [118.453821362645, 24.7706075575046, 0.000921727158129215],
    [118.453149796004, 24.7709891730233, 0.000921773724257946],
  ],
  [
    [118.453811066979, 24.7705924431638, 0.000921723432838917],
    [118.4531392034, 24.7709736255096, 0.000921773724257946],
  ],
  [
    [118.453800781195, 24.7705773197877, 0.000921722501516342],
    [118.453128630567, 24.7709580689538, 0.000921769998967648],
  ],
  [
    [118.453790505294, 24.7705621873762, 0.000921719707548618],
    [118.453118067625, 24.7709425123904, 0.000921769067645073],
  ],
  [
    [118.453780249163, 24.7705470459226, 0.000921719707548618],
    [118.453107514565, 24.7709269467916, 0.000921767204999924],
  ],
  [
    [118.453769993034, 24.7705319044682, 0.000921717844903469],
    [118.453096971388, 24.7709113721575, 0.000921765342354774],
  ],
  [
    [118.453759756668, 24.7705167449439, 0.00092171598225832],
    [118.453086447988, 24.770895797509, 0.000921762548387051],
  ],
  [
    [118.453749520305, 24.7705015854188, 0.000921714119613171],
    [118.453075934472, 24.7708802138252, 0.000921760685741901],
  ],
  [
    [118.453739303712, 24.7704864168516, 0.000921710394322872],
    [118.453065430838, 24.7708646211061, 0.000921757891774178],
  ],
  [
    [118.453729087113, 24.7704712392559, 0.000921709463000298],
    [118.453054937095, 24.7708490283793, 0.000921756960451603],
  ],
  [
    [118.453718890285, 24.770456052618, 0.000921707600355148],
    [118.453044463129, 24.7708334356382, 0.000921756029129028],
  ],
  [
    [118.453708703347, 24.7704408659726, 0.000921706669032574],
    [118.453033989159, 24.7708178338686, 0.00092175230383873],
  ],
  [
    [118.453698526292, 24.7704256702918, 0.000921702943742275],
    [118.453023544846, 24.7708022230501, 0.000921750441193581],
  ],
  [
    [118.453688359111, 24.770410456548, 0.000921702012419701],
    [118.453013100529, 24.770786603203, 0.000921749509871006],
  ],
  [
    [118.453678201821, 24.7703952427966, 0.000921699218451977],
    [118.453002666102, 24.7707709833484, 0.000921747647225857],
  ],
  [
    [118.453668054421, 24.7703800290376, 0.000921697355806828],
    [118.452992251452, 24.7707553634794, 0.000921745784580708],
  ],
  [
    [118.453657916895, 24.7703647972156, 0.000921695493161678],
    [118.452981846686, 24.7707397345751, 0.000921742990612984],
  ],
  [
    [118.45364778926, 24.7703495653859, 0.000921693630516529],
    [118.452971451802, 24.7707240966355, 0.000921742059290409],
  ],
  [
    [118.453637671508, 24.770334324521, 0.00092169176787138],
    [118.452961066809, 24.7707084586884, 0.000921739265322685],
  ],
  [
    [118.453627563637, 24.7703190746208, 0.000921689905226231],
    [118.452950701586, 24.7706928116991, 0.000921737402677536],
  ],
  [
    [118.45361746565, 24.7703038156853, 0.000921688042581081],
    [118.452940346253, 24.7706771647023, 0.000921736471354961],
  ],
  [
    [118.453607377552, 24.7702885567422, 0.000921686179935932],
    [118.452930000802, 24.7706615086702, 0.000921732746064663],
  ],
  [
    [118.45359729933, 24.7702732797361, 0.000921684317290783],
    [118.452919665235, 24.7706458436028, 0.000921731814742088],
  ],
  [
    [118.453587231005, 24.7702580117501, 0.000921682454645634],
    [118.452909339558, 24.7706301785279, 0.000921729020774364],
  ],
  [
    [118.453577172555, 24.7702427257011, 0.000921680592000484],
    [118.452899023771, 24.7706145134454, 0.000921727158129215],
  ],
  [
    [118.453567123988, 24.7702274306169, 0.000921678729355335],
    [118.452888727754, 24.7705988393208, 0.000921724364161491],
  ],
  [
    [118.45355708531, 24.7702121355251, 0.000921676866710186],
    [118.45287843174, 24.7705831651955, 0.000921723432838917],
  ],
  [
    [118.453547056516, 24.7701968313979, 0.000921674072742462],
    [118.452868155496, 24.7705674820281, 0.000921721570193768],
  ],
  [
    [118.453537027716, 24.7701815182424, 0.000921672210097313],
    [118.452857889135, 24.7705517898254, 0.000921718776226044],
  ],
  [
    [118.453527018694, 24.7701662050724, 0.000921671278774738],
    [118.452847632664, 24.7705360976152, 0.000921716913580894],
  ],
  [
    [118.453517019554, 24.7701508828672, 0.000921670347452164],
    [118.452837386083, 24.7705204053975, 0.00092171598225832],
  ],
  [
    [118.453507030297, 24.7701355516267, 0.00092166755348444],
    [118.452827159273, 24.7705047041377, 0.000921714119613171],
  ],
  [
    [118.453497041034, 24.7701202113577, 0.000921666622161865],
    [118.452816932457, 24.7704889938494, 0.000921713188290596],
  ],
  [
    [118.45348707155, 24.7701048710744, 0.000921661965548992],
    [118.45280672542, 24.7704732835468, 0.000921710394322872],
  ],
  [
    [118.45347710206, 24.7700895217626, 0.000921661965548992],
    [118.452796518385, 24.7704575732435, 0.000921707600355148],
  ],
  [
    [118.453467152341, 24.7700741634087, 0.000921659171581268],
    [118.45278633112, 24.7704418538981, 0.000921705737709999],
  ],
  [
    [118.453457202616, 24.7700587960264, 0.000921656377613544],
    [118.452776153738, 24.7704261255174, 0.000921702943742275],
  ],
  [
    [118.453447272669, 24.7700434286297, 0.000921654514968395],
    [118.452765986246, 24.7704103971293, 0.000921702012419701],
  ],
  [
    [118.453437342717, 24.7700280522045, 0.000921654514968395],
    [118.452755828644, 24.7703946687336, 0.000921700149774551],
  ],
  [
    [118.453427422655, 24.7700126757719, 0.000921651721000671],
    [118.452745680925, 24.7703789313026, 0.000921697355806828],
  ],
  [
    [118.453417512467, 24.7699972812762, 0.000921648927032948],
    [118.452735543097, 24.7703631938642, 0.000921696424484253],
  ],
  [
    [118.45340761217, 24.769981886773, 0.000921647995710373],
    [118.45272541515, 24.7703474473905, 0.000921694561839104],
  ],
  [
    [118.453397711876, 24.7699664922691, 0.000921646133065224],
    [118.452715297094, 24.7703317009093, 0.000921690836548805],
  ],
  [
    [118.453387831344, 24.7699510796954, 0.000921644270420074],
    [118.452705188921, 24.7703159453929, 0.000921689905226231],
  ],
  [
    [118.453377950814, 24.769935667121, 0.0009216433390975],
    [118.452695100525, 24.7703001898621, 0.000921688042581081],
  ],
  [
    [118.453368090054, 24.7699202455045, 0.000921639613807201],
    [118.452685012132, 24.7702844343306, 0.000921686179935932],
  ],
  [
    [118.453358229297, 24.7699048238873, 0.000921638682484627],
    [118.452674933622, 24.770268669764, 0.000921684317290783],
  ],
  [
    [118.453348378423, 24.7698893932349, 0.000921636819839478],
    [118.452664874889, 24.770252905183, 0.000921682454645634],
  ],
  [
    [118.45333853743, 24.7698739535472, 0.000921634025871754],
    [118.452654816152, 24.7702371315735, 0.000921682454645634],
  ],
  [
    [118.453328696441, 24.7698585138589, 0.000921632163226604],
    [118.452644767304, 24.7702213579566, 0.000921680592000484],
  ],
  [
    [118.453318875221, 24.7698430651284, 0.00092163123190403],
    [118.452634738227, 24.7702055752977, 0.000921675935387611],
  ],
  [
    [118.453309053996, 24.7698276073695, 0.000921626575291157],
    [118.452624709152, 24.770189792638, 0.000921675004065037],
  ],
  [
    [118.453299252549, 24.7698121495963, 0.000921626575291157],
    [118.452614689968, 24.7701740099709, 0.000921673141419888],
  ],
  [
    [118.453289451097, 24.7697966827947, 0.000921624712646008],
    [118.452604690553, 24.7701582182617, 0.000921671278774738],
  ],
  [
    [118.453279659527, 24.7697812069579, 0.000921621918678284],
    [118.452594691141, 24.7701424265519, 0.000921666622161865],
  ],
  [
    [118.45326986796, 24.7697657311203, 0.000921620987355709],
    [118.452584701612, 24.7701266258068, 0.000921665690839291],
  ],
  [
    [118.453260096162, 24.7697502462407, 0.000921618193387985],
    [118.452574731861, 24.7701108250475, 0.000921664759516716],
  ],
  [
    [118.453250324368, 24.7697347613604, 0.000921617262065411],
    [118.452564762112, 24.7700950242875, 0.000921661034226418],
  ],
  [
    [118.453240562455, 24.7697192674449, 0.000921615399420261],
    [118.452554802245, 24.7700792144922, 0.000921660102903843],
  ],
  [
    [118.453230810425, 24.7697037644942, 0.000921612605452538],
    [118.452544852269, 24.7700634046895, 0.000921658240258694],
  ],
  [
    [118.453221058398, 24.7696882615428, 0.000921611674129963],
    [118.452534912183, 24.7700475948793, 0.00092165544629097],
  ],
  [
    [118.45321132614, 24.7696727495493, 0.000921608880162239],
    [118.452524981979, 24.7700317760339, 0.000921653583645821],
  ],
  [
    [118.453201593878, 24.7696572285274, 0.00092160701751709],
    [118.452515061666, 24.770015957181, 0.000921651721000671],
  ],
  [
    [118.453191871505, 24.7696417074981, 0.000921605154871941],
    [118.452505151235, 24.7700001292929, 0.000921650789678097],
  ],
  [
    [118.453182149135, 24.769626186468, 0.000921603292226791],
    [118.452495240806, 24.7699843014042, 0.000921648927032948],
  ],
  [
    [118.453172446527, 24.7696106473682, 0.000921602360904217],
    [118.452485350156, 24.7699684735011, 0.000921645201742649],
  ],
  [
    [118.453162743922, 24.7695951082677, 0.000921597704291344],
    [118.4524754595, 24.7699526365697, 0.000921644270420074],
  ],
  [
    [118.453153051207, 24.7695795691597, 0.000921596772968769],
    [118.452465588622, 24.769936799624, 0.000921642407774925],
  ],
  [
    [118.453143358486, 24.7695640210234, 0.00092159491032362],
    [118.452455717747, 24.7699209626777, 0.000921640545129776],
  ],
  [
    [118.453133685536, 24.769548463845, 0.000921593979001045],
    [118.452445856761, 24.7699051257239, 0.000921638682484627],
  ],
  [
    [118.453124012588, 24.7695329066659, 0.000921589322388172],
    [118.452436005658, 24.7698892797348, 0.000921635888516903],
  ],
  [
    [118.453114339635, 24.7695173404584, 0.000921589322388172],
    [118.452426164438, 24.7698734247106, 0.000921634957194328],
  ],
  [
    [118.453104686459, 24.7695017742366, 0.000921587459743023],
    [118.452416333115, 24.7698575787067, 0.000921632163226604],
  ],
  [
    [118.453095033279, 24.7694861989865, 0.000921585597097874],
    [118.452406511675, 24.7698417236676, 0.000921630300581455],
  ],
  [
    [118.453085389981, 24.7694706147011, 0.000921583734452724],
    [118.452396690237, 24.7698258686278, 0.000921628437936306],
  ],
  [
    [118.453075746685, 24.7694550304151, 0.000921580940485001],
    [118.45238688857, 24.7698100045461, 0.000921625643968582],
  ],
  [
    [118.453066113279, 24.7694394461216, 0.000921580009162426],
    [118.452377086905, 24.7697941404637, 0.000921623781323433],
  ],
  [
    [118.453056489756, 24.7694238527929, 0.000921577215194702],
    [118.45236729513, 24.7697782763738, 0.000921622850000858],
  ],
  [
    [118.453046876115, 24.769408250429, 0.000921575352549553],
    [118.452357513245, 24.7697624122765, 0.000921620987355709],
  ],
  [
    [118.453037262476, 24.7693926480644, 0.000921573489904404],
    [118.452347731355, 24.7697465391508, 0.00092161912471056],
  ],
  [
    [118.45302765872, 24.7693770366646, 0.000921572558581829],
    [118.452337969243, 24.7697306660108, 0.000921616330742836],
  ],
  [
    [118.453018054966, 24.7693614252642, 0.000921569764614105],
    [118.452328207133, 24.7697147928703, 0.000921612605452538],
  ],
  [
    [118.453008470983, 24.7693458048218, 0.000921567901968956],
    [118.452318454906, 24.7696989106945, 0.000921612605452538],
  ],
  [
    [118.452998877114, 24.7693301843855, 0.000921566970646381],
    [118.452308712568, 24.7696830285113, 0.000921609811484814],
  ],
  [
    [118.452989303015, 24.7693145549072, 0.000921564176678658],
    [118.452298970234, 24.7696671463274, 0.00092160701751709],
  ],
  [
    [118.452979728911, 24.7692989164005, 0.000921561382710934],
    [118.452289247676, 24.7696512641293, 0.00092160701751709],
  ],
  [
    [118.452970164704, 24.7692832869141, 0.000921560451388359],
    [118.452279525114, 24.7696353729029, 0.000921604223549366],
  ],
  [
    [118.452960600485, 24.7692676393716, 0.00092155858874321],
    [118.452269812442, 24.769619481669, 0.000921601429581642],
  ],
  [
    [118.452951046156, 24.7692519918216, 0.000921555794775486],
    [118.45226010966, 24.7696035904276, 0.000921600498259068],
  ],
  [
    [118.452941491829, 24.769236344271, 0.000921554863452911],
    [118.452250406873, 24.7695876901579, 0.000921597704291344],
  ],
  [
    [118.452931957273, 24.7692206876784, 0.000921551138162613],
    [118.452240713983, 24.7695717989085, 0.000921595841646194],
  ],
  [
    [118.452922412831, 24.769205031092, 0.000921549275517464],
    [118.452231030976, 24.7695558986239, 0.00092159491032362],
  ],
  [
    [118.452912888159, 24.7691893654635, 0.00092154648154974],
    [118.452221357859, 24.7695399983319, 0.000921592116355896],
  ],
  [
    [118.452903353594, 24.7691736908135, 0.00092154648154974],
    [118.452211694624, 24.7695240890048, 0.000921590253710747],
  ],
  [
    [118.452893838814, 24.769158025177, 0.000921543687582016],
    [118.4522020314, 24.7695081887047, 0.000921586528420448],
  ],
  [
    [118.452884324022, 24.7691423414843, 0.000921541824936867],
    [118.452192378057, 24.7694922793695, 0.000921585597097874],
  ],
  [
    [118.452874809232, 24.769126657791, 0.000921541824936867],
    [118.452182724718, 24.7694763700336, 0.000921583734452724],
  ],
  [
    [118.45286531422, 24.7691109740835, 0.000921539030969143],
    [118.452173081261, 24.7694604516625, 0.00092158280313015],
  ],
  [
    [118.452855809315, 24.7690952813544, 0.000921535305678844],
    [118.452163447701, 24.7694445423118, 0.000921580940485001],
  ],
  [
    [118.452846314299, 24.7690795886178, 0.000921533443033695],
    [118.452153824024, 24.769428623926, 0.000921577215194702],
  ],
  [
    [118.452836829174, 24.7690638958738, 0.000921530649065971],
    [118.452144210237, 24.7694127055327, 0.000921576283872128],
  ],
  [
    [118.452827353924, 24.7690481850669, 0.000921530649065971],
    [118.452134596452, 24.7693967871388, 0.000921573489904404],
  ],
  [
    [118.452817868796, 24.7690324832939, 0.000921529717743397],
    [118.452124982662, 24.7693808597165, 0.000921571627259254],
  ],
  [
    [118.452808403438, 24.7690167724789, 0.000921526923775673],
    [118.452115388657, 24.7693649413078, 0.000921569764614105],
  ],
  [
    [118.452798938075, 24.7690010526356, 0.000921524129807949],
    [118.452105794648, 24.7693490138707, 0.000921567901968956],
  ],
  [
    [118.452789472714, 24.7689853327916, 0.000921523198485374],
    [118.45209620064, 24.7693330864329, 0.000921566039323807],
  ],
  [
    [118.452780017243, 24.7689696129401, 0.000921520404517651],
    [118.45208662641, 24.769317158981, 0.000921565108001232],
  ],
  [
    [118.452770561767, 24.7689538840603, 0.000921518541872501],
    [118.452077052175, 24.7693012225007, 0.000921562314033508],
  ],
  [
    [118.452761116181, 24.7689381551731, 0.000921516679227352],
    [118.45206747795, 24.7692852950475, 0.000921561382710934],
  ],
  [
    [118.45275167059, 24.7689224172575, 0.000921513885259628],
    [118.452057923495, 24.7692693585524, 0.00092155858874321],
  ],
  [
    [118.452742234889, 24.7689066793345, 0.000921511091291904],
    [118.452048359155, 24.7692534220634, 0.000921555794775486],
  ],
  [
    [118.45273279919, 24.7688909414108, 0.000921509228646755],
    [118.452038814593, 24.7692374855603, 0.000921553000807762],
  ],
  [
    [118.452723373373, 24.768875194452, 0.000921508297324181],
    [118.452029270033, 24.7692215490565, 0.000921552069485188],
  ],
  [
    [118.452713947552, 24.7688594384648, 0.000921506434679031],
    [118.452019735362, 24.7692056125453, 0.000921550206840038],
  ],
  [
    [118.452704531627, 24.7688436914979, 0.000921504572033882],
    [118.452010200687, 24.7691896670058, 0.000921547412872314],
  ],
  [
    [118.452695115698, 24.7688279355027, 0.000921502709388733],
    [118.452000675902, 24.7691737214588, 0.000921545550227165],
  ],
  [
    [118.452685699764, 24.7688121704791, 0.000921499915421009],
    [118.451991151119, 24.7691577759112, 0.000921543687582016],
  ],
  [
    [118.452676293719, 24.768796405448, 0.000921498984098434],
    [118.451981636226, 24.7691418303563, 0.000921542756259441],
  ],
  [
    [118.452666897564, 24.7687806404096, 0.000921497121453285],
    [118.451972131223, 24.7691258847939, 0.000921540893614292],
  ],
  [
    [118.452657491517, 24.7687648663495, 0.000921494327485561],
    [118.451962626223, 24.769109939231, 0.000921538099646568],
  ],
  [
    [118.452648105247, 24.7687490922753, 0.000921492464840412],
    [118.451953131112, 24.7690939936606, 0.000921535305678844],
  ],
  [
    [118.452638709085, 24.7687333091795, 0.000921489670872688],
    [118.451943635997, 24.7690780390618, 0.00092153437435627],
  ],
  [
    [118.452629322812, 24.7687175260763, 0.000921489670872688],
    [118.451934150771, 24.7690620844557, 0.000921530649065971],
  ],
  [
    [118.45261994643, 24.7687017429656, 0.000921488739550114],
    [118.451924665548, 24.769046129849, 0.000921529717743397],
  ],
  [
    [118.452610560154, 24.7686859508334, 0.00092148594558239],
    [118.451915190222, 24.7690301842626, 0.000921528786420822],
  ],
  [
    [118.452601193656, 24.768670158687, 0.000921482220292091],
    [118.451905724771, 24.7690142206133, 0.000921528786420822],
  ],
  [
    [118.452591817273, 24.7686543665467, 0.000921480357646942],
    [118.45189625933, 24.7689982659912, 0.000921524129807949],
  ],
  [
    [118.452582450773, 24.7686385653713, 0.000921478495001793],
    [118.451886793891, 24.7689823113684, 0.000921521335840225],
  ],
  [
    [118.452573084274, 24.7686227641953, 0.000921476632356644],
    [118.451877338342, 24.7689663567383, 0.000921520404517651],
  ],
  [
    [118.452563727666, 24.7686069630119, 0.000921474769711494],
    [118.451867882789, 24.7689503930797, 0.000921518541872501],
  ],
  [
    [118.452554371052, 24.7685911528001, 0.000921471044421196],
    [118.451858437125, 24.7689344294138, 0.000921517610549927],
  ],
  [
    [118.452545014441, 24.7685753425876, 0.000921471044421196],
    [118.451849001358, 24.7689184747683, 0.000921514816582203],
  ],
  [
    [118.452535667712, 24.7685595233401, 0.000921468250453472],
    [118.451839565587, 24.7689025110944, 0.000921511091291904],
  ],
  [
    [118.452526320986, 24.7685437040919, 0.000921467319130898],
    [118.451830129818, 24.7688865474199, 0.00092151015996933],
  ],
  [
    [118.452516974262, 24.7685278848431, 0.000921465456485748],
    [118.451820703939, 24.768870583738, 0.000921507366001606],
  ],
  [
    [118.45250763742, 24.7685120565591, 0.000921460799872875],
    [118.451811278062, 24.7688546200555, 0.000921505503356457],
  ],
  [
    [118.452498300581, 24.7684962282745, 0.000921459868550301],
    [118.451801862075, 24.7688386563656, 0.000921504572033882],
  ],
  [
    [118.452488963744, 24.7684803999894, 0.000921458005905151],
    [118.45179244609, 24.7688226926751, 0.000921500846743584],
  ],
  [
    [118.452479636797, 24.7684645716968, 0.000921456143260002],
    [118.451783039988, 24.7688067199495, 0.000921499915421009],
  ],
  [
    [118.452470309845, 24.7684487343758, 0.000921454280614853],
    [118.451773633896, 24.768790756251, 0.00092149805277586],
  ],
  [
    [118.452460982895, 24.7684328970542, 0.000921452417969704],
    [118.451764237694, 24.7687747925452, 0.000921497121453285],
  ],
  [
    [118.45245165594, 24.7684170507043, 0.00092144962400198],
    [118.451754841486, 24.7687588198109, 0.000921493396162987],
  ],
  [
    [118.452442338876, 24.768401204347, 0.000921448692679405],
    [118.451745445289, 24.7687428561038, 0.000921492464840412],
  ],
  [
    [118.452433021813, 24.768385357989, 0.000921446830034256],
    [118.451736058974, 24.7687268833616, 0.000921490602195263],
  ],
  [
    [118.452423704753, 24.7683695116305, 0.000921444967389107],
    [118.451726672661, 24.7687109106188, 0.000921487808227539],
  ],
  [
    [118.452414397575, 24.7683536562368, 0.000921443104743958],
    [118.451717296245, 24.7686949468964, 0.00092148594558239],
  ],
  [
    [118.452405090399, 24.7683378008424, 0.000921439379453659],
    [118.451707909938, 24.7686789741523, 0.000921485014259815],
  ],
  [
    [118.452395783226, 24.7683219454475, 0.00092143751680851],
    [118.451698543407, 24.7686630013941, 0.000921481288969517],
  ],
  [
    [118.452386476048, 24.7683060810242, 0.00092143751680851],
    [118.451689176879, 24.7686470286354, 0.000921479426324368],
  ],
  [
    [118.452377168872, 24.7682902166003, 0.000921435654163361],
    [118.451679810353, 24.768631055876, 0.000921477563679218],
  ],
  [
    [118.452367871586, 24.768274352169, 0.000921432860195637],
    [118.45167044383, 24.7686150831159, 0.000921475701034069],
  ],
  [
    [118.452358574295, 24.7682584787093, 0.000921430066227913],
    [118.451661087203, 24.7685991193763, 0.00092147383838892],
  ],
  [
    [118.452349277014, 24.7682426142768, 0.000921430066227913],
    [118.451651730572, 24.7685831466083, 0.000921472907066345],
  ],
  [
    [118.452339989607, 24.7682267317814, 0.000921426340937614],
    [118.451642383831, 24.768567173833, 0.000921470113098621],
  ],
  [
    [118.452330692323, 24.7682108583199, 0.000921424478292465],
    [118.451633037092, 24.7685512010571, 0.000921467319130898],
  ],
  [
    [118.452321404929, 24.768194984851, 0.000921422615647316],
    [118.451623690356, 24.7685352282805, 0.000921466387808323],
  ],
  [
    [118.45231211753, 24.7681791023538, 0.000921422615647316],
    [118.451614343621, 24.7685192555033, 0.000921464525163174],
  ],
  [
    [118.452302830133, 24.7681632198559, 0.000921418890357018],
    [118.451605006777, 24.7685032827187, 0.000921460799872875],
  ],
  [
    [118.452293542731, 24.7681473283297, 0.000921417027711868],
    [118.451595669935, 24.7684873099336, 0.000921459868550301],
  ],
  [
    [118.452284265227, 24.7681314458238, 0.000921415165066719],
    [118.451586342983, 24.7684713371411, 0.000921458005905151],
  ],
  [
    [118.45227497783, 24.7681155542964, 0.00092141330242157],
    [118.451577006146, 24.7684553643547, 0.000921456143260002],
  ],
  [
    [118.452265700322, 24.7680996627615, 0.000921411439776421],
    [118.451567689086, 24.7684393915542, 0.000921451486647129],
  ],
  [
    [118.45225642281, 24.7680837621983, 0.000921406783163548],
    [118.451558362141, 24.7684234187599, 0.000921451486647129],
  ],
  [
    [118.452247145307, 24.7680678706623, 0.000921405851840973],
    [118.451549035199, 24.7684074459649, 0.000921447761356831],
  ],
  [
    [118.452237867799, 24.7680519700979, 0.000921403989195824],
    [118.451539718146, 24.7683914731626, 0.000921447761356831],
  ],
  [
    [118.452228600182, 24.7680360695261, 0.000921403057873249],
    [118.451530410983, 24.768375500353, 0.000921445898711681],
  ],
  [
    [118.452219322679, 24.7680201689604, 0.000921400263905525],
    [118.451521093935, 24.7683595275494, 0.000921443104743958],
  ],
  [
    [118.452210055058, 24.7680042593596, 0.000921399332582951],
    [118.451511786777, 24.7683435547386, 0.000921441242098808],
  ],
  [
    [118.452200777552, 24.767988349765, 0.000921396538615227],
    [118.451502479621, 24.7683275819271, 0.000921439379453659],
  ],
  [
    [118.452191509937, 24.767972440163, 0.000921393744647503],
    [118.451493172468, 24.768311609115, 0.00092143751680851],
  ],
  [
    [118.452182242323, 24.7679565305604, 0.000921394675970078],
    [118.451483865324, 24.76829564533, 0.000921435654163361],
  ],
  [
    [118.452172974712, 24.7679406209572, 0.000921390019357204],
    [118.451474568063, 24.7682796725099, 0.000921433791518211],
  ],
  [
    [118.452163707096, 24.7679247023256, 0.000921388156712055],
    [118.451465270804, 24.7682636996893, 0.000921431928873062],
  ],
  [
    [118.452154439482, 24.7679087836934, 0.000921386294066906],
    [118.451455973555, 24.7682477358957, 0.000921430997550488],
  ],
  [
    [118.452145171871, 24.7678928650606, 0.000921384431421757],
    [118.451446676301, 24.7682317630738, 0.000921428203582764],
  ],
  [
    [118.452135914149, 24.7678769464204, 0.000921383500099182],
    [118.451437379057, 24.7682157992791, 0.000921424478292465],
  ],
  [
    [118.452126646543, 24.7678610277864, 0.000921380706131458],
    [118.451428091695, 24.7681998264492, 0.000921424478292465],
  ],
  [
    [118.452117378931, 24.767845100124, 0.000921378843486309],
    [118.451418804343, 24.7681838626465, 0.000921421684324741],
  ],
  [
    [118.452108121209, 24.7678291724542, 0.000921376049518585],
    [118.451409516986, 24.7681678898155, 0.000921418890357018],
  ],
  [
    [118.452098853602, 24.7678132447906, 0.000921375118196011],
    [118.451400229638, 24.7681519260115, 0.000921417027711868],
  ],
  [
    [118.452089595885, 24.7677973171196, 0.000921373255550861],
    [118.451390952181, 24.7681359622003, 0.000921414233744144],
  ],
  [
    [118.45208033817, 24.767781389448, 0.000921370461583138],
    [118.451381664838, 24.7681199983951, 0.00092141330242157],
  ],
  [
    [118.452071070563, 24.7677654527548, 0.000921369530260563],
    [118.451372387385, 24.7681040345826, 0.000921411439776421],
  ],
  [
    [118.452061812845, 24.7677495160542, 0.000921366736292839],
    [118.451363109935, 24.7680880707695, 0.000921410508453846],
  ],
  [
    [118.45205254525, 24.7677335883875, 0.00092136487364769],
    [118.451353832486, 24.7680721069558, 0.000921407714486122],
  ],
  [
    [118.45204328753, 24.7677176426579, 0.000921362079679966],
    [118.451344555041, 24.7680561431415, 0.000921405851840973],
  ],
  [
    [118.45203402982, 24.7677017059555, 0.000921360217034817],
    [118.451335277605, 24.7680401883543, 0.000921402126550674],
  ],
  [
    [118.452024762225, 24.7676857692592, 0.000921357423067093],
    [118.451326010051, 24.768024224532, 0.000921402126550674],
  ],
  [
    [118.452015504512, 24.7676698235278, 0.000921358354389668],
    [118.45131673262, 24.7680082697436, 0.0009214011952281],
  ],
  [
    [118.452006236921, 24.7676538868303, 0.000921355560421944],
    [118.451307465071, 24.7679923059201, 0.000921398401260376],
  ],
  [
    [118.451996979213, 24.7676379410977, 0.000921350903809071],
    [118.451298197532, 24.7679763511237, 0.000921394675970078],
  ],
  [
    [118.45198771162, 24.7676219953712, 0.000921350903809071],
    [118.451288929995, 24.7679603963268, 0.000921393744647503],
  ],
  [
    [118.451978453916, 24.7676060496373, 0.000921349972486496],
    [118.451279662461, 24.7679444415292, 0.000921390950679779],
  ],
  [
    [118.451969186328, 24.7675901039096, 0.000921347178518772],
    [118.451270394929, 24.767928486731, 0.000921390019357204],
  ],
  [
    [118.451959928621, 24.7675741491468, 0.000921345315873623],
    [118.451261127399, 24.7679125319322, 0.000921386294066906],
  ],
  [
    [118.451950661038, 24.7675582034178, 0.000921343453228474],
    [118.451251859872, 24.7678965771327, 0.000921385362744331],
  ],
  [
    [118.451941393449, 24.7675422486605, 0.00092134065926075],
    [118.451242592354, 24.7678806313604, 0.000921384431421757],
  ],
  [
    [118.451932135757, 24.7675263029236, 0.000921338796615601],
    [118.451233334719, 24.7678646765531, 0.000921380706131458],
  ],
  [
    [118.451922868173, 24.767510348165, 0.000921336002647877],
    [118.451224067206, 24.7678487307796, 0.000921379774808884],
  ],
  [
    [118.451913600592, 24.7674943934058, 0.000921336002647877],
    [118.451214799688, 24.7678327759777, 0.000921378843486309],
  ],
  [
    [118.45190433302, 24.7674784476738, 0.000921330414712429],
    [118.451205532173, 24.7678168211752, 0.000921376049518585],
  ],
  [
    [118.45189507533, 24.7674624929067, 0.000921331346035004],
    [118.451196274555, 24.7678008753931, 0.000921372324228287],
  ],
  [
    [118.451885807763, 24.7674465471734, 0.000921329483389854],
    [118.451187007044, 24.7677849205894, 0.000921369530260563],
  ],
  [
    [118.451876540191, 24.7674305924118, 0.000921325758099556],
    [118.451177739543, 24.7677689748128, 0.000921369530260563],
  ],
  [
    [118.451867272621, 24.7674146376496, 0.000921323895454407],
    [118.451168481924, 24.7677530200012, 0.000921367667615414],
  ],
  [
    [118.451858014949, 24.7673986919077, 0.000921322964131832],
    [118.451159214421, 24.7677370651956, 0.00092136487364769],
  ],
  [
    [118.451848747384, 24.7673827371442, 0.000921320170164108],
    [118.451149946927, 24.7677211194171, 0.000921363942325115],
  ],
  [
    [118.451839479828, 24.7673667914079, 0.000921318307518959],
    [118.451140679428, 24.7677051646103, 0.000921361148357391],
  ],
  [
    [118.451830212268, 24.7673508366432, 0.00092131644487381],
    [118.451131421827, 24.767689218824, 0.000921357423067093],
  ],
  [
    [118.451820954598, 24.7673348818712, 0.000921314582228661],
    [118.451122154333, 24.7676732640159, 0.000921356491744518],
  ],
  [
    [118.451811687049, 24.767318936133, 0.000921312719583511],
    [118.451112886841, 24.7676573092073, 0.000921357423067093],
  ],
  [
    [118.451802419496, 24.7673029813664, 0.000921309925615788],
    [118.451103619359, 24.7676413634258, 0.00092135276645422],
  ],
  [
    [118.451793151953, 24.767287035627, 0.000921307131648064],
    [118.451094361759, 24.7676254086092, 0.000921353697776794],
  ],
  [
    [118.451783894292, 24.7672710808525, 0.000921306200325489],
    [118.451085094282, 24.7676094628265, 0.000921349972486496],
  ],
  [
    [118.451774626746, 24.7672551260842, 0.000921305269002914],
    [118.4510758268, 24.7675935080154, 0.000921347178518772],
  ],
  [
    [118.451765359209, 24.7672391803429, 0.000921303406357765],
    [118.45106655932, 24.7675775532036, 0.000921345315873623],
  ],
  [
    [118.451756091668, 24.7672232255733, 0.000921300612390041],
    [118.451057301737, 24.7675616074124, 0.000921343453228474],
  ],
  [
    [118.451746834024, 24.7672072798241, 0.000921298749744892],
    [118.451048034262, 24.7675456525994, 0.000921341590583324],
  ],
  [
    [118.451737566487, 24.7671913250532, 0.000921297818422318],
    [118.451038766797, 24.7675297068136, 0.000921339727938175],
  ],
  [
    [118.451728298953, 24.7671753702818, 0.000921295955777168],
    [118.451029499327, 24.7675137519994, 0.000921336933970451],
  ],
  [
    [118.451719041316, 24.7671594245307, 0.00092129223048687],
    [118.451020241746, 24.7674977971779, 0.000921336002647877],
  ],
  [
    [118.451709773787, 24.767143469758, 0.000921290367841721],
    [118.451010974288, 24.7674818513903, 0.000921333208680153],
  ],
  [
    [118.451700506267, 24.7671275240125, 0.000921289436519146],
    [118.451001706824, 24.7674658965743, 0.000921331346035004],
  ],
  [
    [118.451691238742, 24.7671115692386, 0.000921286642551422],
    [118.450992439371, 24.7674499507854, 0.000921329483389854],
  ],
  [
    [118.451681981107, 24.7670956144573, 0.000921284779906273],
    [118.4509831818, 24.7674339959614, 0.000921327620744705],
  ],
  [
    [118.451672713595, 24.7670796687099, 0.000921281985938549],
    [118.450973914344, 24.7674180411436, 0.000921323895454407],
  ],
  [
    [118.451663446077, 24.7670637139341, 0.000921281054615974],
    [118.450964646897, 24.7674020953528, 0.000921323895454407],
  ],
  [
    [118.45165417857, 24.7670477681855, 0.000921279191970825],
    [118.450955389333, 24.7673861405271, 0.000921321101486683],
  ],
  [
    [118.451644920944, 24.7670318134018, 0.000921277329325676],
    [118.450946121892, 24.7673701947351, 0.000921318307518959],
  ],
  [
    [118.451635653434, 24.7670158586242, 0.000921274535357952],
    [118.450936854445, 24.7673542399148, 0.000921317376196384],
  ],
  [
    [118.451626385933, 24.7669999128737, 0.000921272672712803],
    [118.450927587001, 24.7673382850938, 0.000921315513551235],
  ],
  [
    [118.451617118427, 24.7669839580949, 0.000921269878745079],
    [118.450918329454, 24.7673223392934, 0.000921313650906086],
  ],
  [
    [118.451607860819, 24.7669680123364, 0.00092126801609993],
    [118.450909062014, 24.7673063844712, 0.000921309925615788],
  ],
  [
    [118.451598593318, 24.7669520575564, 0.000921267084777355],
    [118.450899794584, 24.7672904386761, 0.000921308994293213],
  ],
  [
    [118.451589325826, 24.7669361118034, 0.000921264290809631],
    [118.45089052715, 24.7672744838527, 0.000921307131648064],
  ],
  [
    [118.45158005833, 24.7669201570221, 0.000921262428164482],
    [118.450881269605, 24.7672585290221, 0.000921305269002914],
  ],
  [
    [118.451570800724, 24.7669042022335, 0.000921259634196758],
    [118.450872002182, 24.7672425832252, 0.000921303406357765],
  ],
  [
    [118.45156153324, 24.7668882564787, 0.000921259634196758],
    [118.450862734754, 24.7672266283999, 0.000921300612390041],
  ],
  [
    [118.451552265751, 24.7668723016956, 0.00092125590890646],
    [118.450853467337, 24.7672106826018, 0.000921298749744892],
  ],
  [
    [118.451542998271, 24.7668563559396, 0.000921254046261311],
    [118.450844209801, 24.7671947277687, 0.000921297818422318],
  ],
  [
    [118.451533740674, 24.7668404011485, 0.000921252183616161],
    [118.450834942388, 24.7671787819693, 0.000921294093132019],
  ],
  [
    [118.451524473192, 24.7668244463635, 0.000921250320971012],
    [118.45082567497, 24.7671628271416, 0.000921293161809444],
  ],
  [
    [118.45151520572, 24.7668085006057, 0.000921249389648438],
    [118.450816407554, 24.7671468723133, 0.000921291299164295],
  ],
  [
    [118.451505938243, 24.7667925458195, 0.000921245664358139],
    [118.450807150035, 24.7671309265055, 0.000921288505196571],
  ],
  [
    [118.451496680663, 24.7667766000537, 0.00092124380171299],
    [118.450797882624, 24.7671149716759, 0.000921286642551422],
  ],
  [
    [118.45148741319, 24.7667606452662, 0.000921242870390415],
    [118.450788615223, 24.7670990258735, 0.000921284779906273],
  ],
  [
    [118.45147814572, 24.7667446904782, 0.000921241007745266],
    [118.450779347817, 24.7670830710427, 0.000921282917261124],
  ],
  [
    [118.451468888147, 24.7667287447105, 0.000921237282454968],
    [118.4507700903, 24.7670671162047, 0.000921281054615974],
  ],
  [
    [118.451459620682, 24.7667127899212, 0.000921236351132393],
    [118.450760822906, 24.7670511704004, 0.000921278260648251],
  ],
  [
    [118.451450353226, 24.7666968441591, 0.000921233557164669],
    [118.450751555507, 24.7670352155678, 0.000921276398003101],
  ],
  [
    [118.451441085765, 24.7666808893686, 0.000921233557164669],
    [118.450742298005, 24.7670192697556, 0.000921275466680527],
  ],
  [
    [118.451431828195, 24.7666649345707, 0.000921230763196945],
    [118.45073303061, 24.7670033149218, 0.000921273604035378],
  ],
  [
    [118.451422560746, 24.7666489888067, 0.000921227969229221],
    [118.450723763218, 24.7669873600873, 0.000921270810067654],
  ],
  [
    [118.451413293293, 24.7666330340144, 0.000921227037906647],
    [118.450714495836, 24.76697141428, 0.000921268947422504],
  ],
  [
    [118.451404025849, 24.7666170882491, 0.000921224243938923],
    [118.450705238336, 24.7669554594376, 0.000921267084777355],
  ],
  [
    [118.451394768287, 24.7666011334488, 0.000921222381293774],
    [118.450695970958, 24.7669395136291, 0.000921265222132206],
  ],
  [
    [118.451385500841, 24.7665851786546, 0.000921220518648624],
    [118.450686703576, 24.7669235587921, 0.000921263359487057],
  ],
  [
    [118.451376233404, 24.7665692328876, 0.000921217724680901],
    [118.450677436196, 24.7669076039546, 0.000921260565519333],
  ],
  [
    [118.451366965963, 24.7665532780921, 0.000921216793358326],
    [118.450668178713, 24.7668916581375, 0.000921258702874184],
  ],
  [
    [118.451357708418, 24.7665373323171, 0.000921214930713177],
    [118.450658911337, 24.7668757032988, 0.000921256840229034],
  ],
  [
    [118.451348440981, 24.7665213775204, 0.000921212136745453],
    [118.450649643971, 24.7668597574871, 0.00092125590890646],
  ],
  [
    [118.451339173547, 24.7665054227232, 0.000921211205422878],
    [118.450640376601, 24.7668438026471, 0.000921253114938736],
  ],
  [
    [118.451329906122, 24.766489476953, 0.000921208411455154],
    [118.45063111912, 24.7668278477999, 0.000921251252293587],
  ],
  [
    [118.45132064858, 24.7664735221478, 0.000921206548810005],
    [118.450621851761, 24.7668119019864, 0.000921247527003288],
  ],
  [
    [118.45131138116, 24.7664575763764, 0.000921203754842281],
    [118.450612584398, 24.7667959471445, 0.000921247527003288],
  ],
  [
    [118.451302113735, 24.7664416215767, 0.000921201892197132],
    [118.450603317044, 24.7667800013298, 0.00092124380171299],
  ],
  [
    [118.451292846312, 24.7664256667763, 0.000921199098229408],
    [118.450594059572, 24.7667640464801, 0.000921241939067841],
  ],
  [
    [118.451283588786, 24.7664097209964, 0.000921198166906834],
    [118.450584792216, 24.7667480916364, 0.000921241007745266],
  ],
  [
    [118.451274321368, 24.7663937661948, 0.000921198166906834],
    [118.450575524869, 24.7667321458199, 0.000921240076422691],
  ],
  [
    [118.45126505396, 24.7663778204204, 0.000921193510293961],
    [118.450566257517, 24.766716190975, 0.000921236351132393],
  ],
  [
    [118.451255796434, 24.7663618656109, 0.000921192578971386],
    [118.450557000063, 24.7667002451505, 0.000921233557164669],
  ],
  [
    [118.451246529031, 24.7663459198352, 0.000921190716326237],
    [118.450547732716, 24.7666842903044, 0.00092123169451952],
  ],
  [
    [118.451237261623, 24.7663299650312, 0.000921187922358513],
    [118.450538465371, 24.7666683354576, 0.00092123169451952],
  ],
  [
    [118.451227994217, 24.7663140102265, 0.000921186991035938],
    [118.450529207924, 24.7666523896314, 0.000921228900551796],
  ],
  [
    [118.451218736707, 24.7662980644423, 0.000921185128390789],
    [118.450519940584, 24.7666364347834, 0.000921226106584072],
  ],
  [
    [118.451209469306, 24.7662821096364, 0.000921181403100491],
    [118.450510673254, 24.7666204889625, 0.000921225175261498],
  ],
  [
    [118.451200201915, 24.7662661638577, 0.000921179540455341],
    [118.450501405919, 24.7666045341133, 0.000921222381293774],
  ],
  [
    [118.451190934518, 24.7662502090505, 0.000921178609132767],
    [118.45049214848, 24.7665885882846, 0.00092121958732605],
  ],
  [
    [118.451181677011, 24.7662342542361, 0.000921176746487617],
    [118.45048288115, 24.7665726334341, 0.00092121958732605],
  ],
  [
    [118.451172409627, 24.7662183084555, 0.000921173021197319],
    [118.450473613822, 24.7665566785831, 0.000921216793358326],
  ],
  [
    [118.451163142237, 24.7662023536466, 0.00092117115855217],
    [118.450464346504, 24.7665407327591, 0.000921215862035751],
  ],
  [
    [118.451153874858, 24.7661864078647, 0.000921169295907021],
    [118.450455089068, 24.7665247779002, 0.000921213068068028],
  ],
  [
    [118.45114461736, 24.7661704530479, 0.000921167433261871],
    [118.450445821754, 24.766508832075, 0.000921211205422878],
  ],
  [
    [118.451135349978, 24.7661544982371, 0.000921163707971573],
    [118.450436554436, 24.7664928772215, 0.000921208411455154],
  ],
  [
    [118.451126082605, 24.7661385524534, 0.000921164639294147],
    [118.45042728712, 24.7664769223674, 0.000921205617487431],
  ],
  [
    [118.451116815228, 24.7661225976413, 0.000921161845326424],
    [118.450418029701, 24.7664609765337, 0.000921204686164856],
  ],
  [
    [118.451107557747, 24.7661066518498, 0.0009211590513587],
    [118.450408762389, 24.7664450216784, 0.000921202823519707],
  ],
  [
    [118.451098290374, 24.7660906970365, 0.0009211590513587],
    [118.450399495088, 24.7664290758501, 0.000921200960874558],
  ],
  [
    [118.451089023004, 24.7660747422226, 0.000921155326068401],
    [118.450390227781, 24.7664131209935, 0.000921197235584259],
  ],
  [
    [118.451079755643, 24.7660587964359, 0.000921154394745827],
    [118.450380970364, 24.7663971661297, 0.000921197235584259],
  ],
  [
    [118.451070498165, 24.7660428416141, 0.000921151600778103],
    [118.45037170307, 24.7663812202996, 0.000921194441616535],
  ],
  [
    [118.451061230809, 24.7660268958261, 0.000921149738132954],
    [118.45036243577, 24.7663652654412, 0.000921192578971386],
  ],
  [
    [118.451051963448, 24.7660109410098, 0.000921147875487804],
    [118.45035316848, 24.7663493196099, 0.000921190716326237],
  ],
  [
    [118.451042705977, 24.7659949861862, 0.00092114694416523],
    [118.450343911073, 24.7663333647436, 0.000921187922358513],
  ],
  [
    [118.451033438628, 24.7659790403963, 0.000921144150197506],
    [118.450334643781, 24.7663174098833, 0.000921187922358513],
  ],
  [
    [118.451024171274, 24.7659630855781, 0.000921142287552357],
    [118.450325376498, 24.7663014640501, 0.000921185128390789],
  ],
  [
    [118.45101490393, 24.7659471397871, 0.000921139493584633],
    [118.450316119098, 24.766285509182, 0.000921182334423065],
  ],
  [
    [118.451005646468, 24.765931184961, 0.000921137630939484],
    [118.45030685182, 24.7662695633476, 0.000921181403100491],
  ],
  [
    [118.450996379121, 24.765915230141, 0.000921136699616909],
    [118.450297584537, 24.7662536084849, 0.000921178609132767],
  ],
  [
    [118.450987111784, 24.7658992843481, 0.000921132974326611],
    [118.450288317256, 24.7662376536215, 0.000921175815165043],
  ],
  [
    [118.450977844442, 24.7658833295268, 0.000921132974326611],
    [118.450279059873, 24.7662217077787, 0.000921174883842468],
  ],
  [
    [118.450968586997, 24.7658673837261, 0.000921129249036312],
    [118.450269792597, 24.7662057529141, 0.000921172089874744],
  ],
  [
    [118.45095931966, 24.7658514289036, 0.000921127386391163],
    [118.450260525331, 24.7661898070767, 0.00092117115855217],
  ],
  [
    [118.450950052325, 24.7658354740805, 0.000921124592423439],
    [118.45025125806, 24.7661738522108, 0.000921168364584446],
  ],
  [
    [118.450940785, 24.7658195282845, 0.000921123661100864],
    [118.450242000679, 24.7661578973378, 0.000921167433261871],
  ],
  [
    [118.450931527557, 24.7658035734535, 0.000921121798455715],
    [118.45023273342, 24.7661419514985, 0.000921163707971573],
  ],
  [
    [118.450922260237, 24.7657876276563, 0.000921120867133141],
    [118.450223466156, 24.7661259966308, 0.000921161845326424],
  ],
  [
    [118.450912992912, 24.7657716728307, 0.000921117141842842],
    [118.450214198901, 24.7661100507903, 0.000921161845326424],
  ],
  [
    [118.450903725589, 24.7657557180046, 0.000921116210520267],
    [118.45020494153, 24.7660940959148, 0.000921158120036125],
  ],
  [
    [118.450894468163, 24.7657397721989, 0.000921113416552544],
    [118.450195674273, 24.7660781410453, 0.000921157188713551],
  ],
  [
    [118.450885200844, 24.7657238173715, 0.00092111062258482],
    [118.450186407026, 24.7660621952029, 0.000921153463423252],
  ],
  [
    [118.450875933536, 24.7657078715712, 0.000921108759939671],
    [118.450177139774, 24.7660462403322, 0.000921151600778103],
  ],
  [
    [118.450866666222, 24.7656919167426, 0.000921107828617096],
    [118.450167882419, 24.766030294482, 0.000921149738132954],
  ],
  [
    [118.450857408806, 24.7656759709344, 0.000921105034649372],
    [118.450158615171, 24.76601433961, 0.000921147875487804],
  ],
  [
    [118.450848141497, 24.7656600161045, 0.000921104103326797],
    [118.450149347926, 24.7659983847374, 0.00092114694416523],
  ],
  [
    [118.450838874191, 24.7656440612741, 0.000921101309359074],
    [118.450140080691, 24.765982438892, 0.000921143218874931],
  ],
  [
    [118.450829616781, 24.7656281154641, 0.000921101309359074],
    [118.450130823338, 24.7659664840116, 0.000921142287552357],
  ],
  [
    [118.45082034948, 24.7656121606324, 0.000921097584068775],
    [118.450121556108, 24.7659505381649, 0.000921139493584633],
  ],
  [
    [118.450811082188, 24.7655962148278, 0.000921094790101051],
    [118.450112288872, 24.7659345832899, 0.000921137630939484],
  ],
  [
    [118.450801814891, 24.7655802599949, 0.000921093858778477],
    [118.450103031534, 24.7659186374354, 0.000921136699616909],
  ],
  [
    [118.450792557484, 24.7655643051547, 0.000921091064810753],
    [118.450093764303, 24.7659026825591, 0.000921132974326611],
  ],
  [
    [118.450783290199, 24.7655483593482, 0.000921089202165604],
    [118.450084497075, 24.7658867276822, 0.000921132974326611],
  ],
  [
    [118.450774022909, 24.7655324045135, 0.000921087339520454],
    [118.450075229856, 24.7658707818325, 0.000921131111681461],
  ],
  [
    [118.450764755629, 24.7655164587058, 0.00092108640819788],
    [118.45006597252, 24.7658548269478, 0.000921127386391163],
  ],
  [
    [118.450755498231, 24.7655005038632, 0.000921083614230156],
    [118.450056705306, 24.7658388810968, 0.000921126455068588],
  ],
  [
    [118.450746230949, 24.7654845490265, 0.000921081751585007],
    [118.450047438087, 24.7658229262174, 0.000921124592423439],
  ],
  [
    [118.450736963676, 24.765468603217, 0.000921078026294708],
    [118.450038170871, 24.7658069713375, 0.00092112272977829],
  ],
  [
    [118.450727696398, 24.7654526483792, 0.000921077094972134],
    [118.450028913551, 24.7657910254781, 0.000921120867133141],
  ],
  [
    [118.450718439017, 24.7654367025618, 0.00092107430100441],
    [118.45001964634, 24.7657750705969, 0.000921116210520267],
  ],
  [
    [118.450709171744, 24.7654207477227, 0.000921075232326984],
    [118.450010379138, 24.7657591247428, 0.000921115279197693],
  ],
  [
    [118.450699904473, 24.765404792883, 0.000921071507036686],
    [118.450001111931, 24.7657431698604, 0.000921114347875118],
  ],
  [
    [118.450690637212, 24.7653888470705, 0.000921068713068962],
    [118.449991854613, 24.7657272149708, 0.000921112485229969],
  ],
  [
    [118.450681379833, 24.7653728922229, 0.000921068713068962],
    [118.449982587418, 24.7657112691149, 0.000921108759939671],
  ],
  [
    [118.450672112577, 24.7653569464091, 0.000921065919101238],
    [118.449973320219, 24.7656953142307, 0.000921108759939671],
  ],
  [
    [118.450662845315, 24.765340991567, 0.00092106219381094],
    [118.449964053028, 24.7656793683735, 0.000921107828617096],
  ],
  [
    [118.450653578056, 24.7653250367242, 0.000921060331165791],
    [118.449954795721, 24.7656634134815, 0.000921103172004223],
  ],
  [
    [118.450644320694, 24.7653090909019, 0.000921059399843216],
    [118.449945528528, 24.7656474585954, 0.000921102240681648],
  ],
  [
    [118.45063505344, 24.7652931360579, 0.000921056605875492],
    [118.449936261345, 24.7656315127364, 0.000921101309359074],
  ],
  [
    [118.450625786196, 24.765277190241, 0.000921056605875492],
    [118.449926994157, 24.7656155578491, 0.000921099446713924],
  ],
  [
    [118.450616528834, 24.7652612353892, 0.000921053811907768],
    [118.449917736866, 24.7655996119823, 0.000921096652746201],
  ],
  [
    [118.450607261587, 24.7652452805433, 0.000921051017940044],
    [118.449908469683, 24.7655836570937, 0.000921094790101051],
  ],
  [
    [118.450597994349, 24.7652293347246, 0.000921049155294895],
    [118.449899202502, 24.7655677022045, 0.000921091064810753],
  ],
  [
    [118.450588727107, 24.7652133798775, 0.000921047292649746],
    [118.449889945218, 24.7655517563359, 0.000921089202165604],
  ],
  [
    [118.450579469761, 24.765197434051, 0.000921045430004597],
    [118.449880678042, 24.7655358014455, 0.000921087339520454],
  ],
  [
    [118.450570202524, 24.7651814792027, 0.000921043567359447],
    [118.449871410875, 24.7655198555822, 0.000921084545552731],
  ],
  [
    [118.450560935289, 24.7651655243538, 0.000921041704714298],
    [118.449862143704, 24.7655039006906, 0.000921085476875305],
  ],
  [
    [118.450551668063, 24.765149578532, 0.000921039842069149],
    [118.449852886422, 24.7654879457918, 0.000921081751585007],
  ],
  [
    [118.45054241072, 24.7651336236752, 0.000921037048101425],
    [118.449843619263, 24.7654719999267, 0.000921079888939857],
  ],
  [
    [118.450533143499, 24.7651176778522, 0.000921035185456276],
    [118.449834352099, 24.7654560450332, 0.000921078026294708],
  ],
  [
    [118.450523876274, 24.7651017230008, 0.000921033322811127],
    [118.449825084944, 24.7654400991669, 0.000921076163649559],
  ],
  [
    [118.450514609057, 24.7650857771766, 0.000921031460165977],
    [118.449815827672, 24.7654241442656, 0.00092107430100441],
  ],
  [
    [118.450505351724, 24.7650698223173, 0.000921028666198254],
    [118.449806560515, 24.7654081893702, 0.000921071507036686],
  ],
  [
    [118.450496084505, 24.7650538674641, 0.000921026803553104],
    [118.449797293367, 24.7653922435021, 0.000921069644391537],
  ],
  [
    [118.450486817296, 24.765037921638, 0.000921024940907955],
    [118.449788026215, 24.7653762886055, 0.000921068713068962],
  ],
  [
    [118.450477550082, 24.7650219667836, 0.000921021215617657],
    [118.449778768959, 24.7653603427295, 0.000921065919101238],
  ],
  [
    [118.450468292765, 24.7650060209496, 0.000921020284295082],
    [118.449769501812, 24.7653443878317, 0.000921064056456089],
  ],
  [
    [118.450459025556, 24.764990066094, 0.000921020284295082],
    [118.449760234674, 24.7653284419611, 0.00092106219381094],
  ],
  [
    [118.45044975835, 24.7649741112377, 0.000921018421649933],
    [118.449750967531, 24.7653124870621, 0.000921060331165791],
  ],
  [
    [118.450440491153, 24.7649581654085, 0.000921016559004784],
    [118.449741710277, 24.7652965321559, 0.000921057537198067],
  ],
  [
    [118.450431233838, 24.7649422105444, 0.00092101376503706],
    [118.449732443147, 24.7652805862834, 0.000921055674552917],
  ],
  [
    [118.450421966646, 24.764926264714, 0.000921010971069336],
    [118.449723176011, 24.7652646313826, 0.000921052880585194],
  ],
  [
    [118.450412699448, 24.7649103098552, 0.000921007245779037],
    [118.449713908885, 24.7652486855089, 0.000921051949262619],
  ],
  [
    [118.450403442141, 24.7648943549892, 0.000921006314456463],
    [118.449704651641, 24.7652327306002, 0.000921049155294895],
  ],
  [
    [118.450394174956, 24.764878409157, 0.000921005383133888],
    [118.449695384512, 24.7652167756975, 0.000921048223972321],
  ],
  [
    [118.450384907765, 24.7648624542964, 0.000921003520488739],
    [118.449686117393, 24.7652008298219, 0.000921046361327171],
  ],
  [
    [118.450375640585, 24.7648465084629, 0.000921000726521015],
    [118.449676850269, 24.765184874918, 0.000921043567359447],
  ],
  [
    [118.450366383287, 24.7648305535945, 0.000920997001230717],
    [118.449667593042, 24.7651689290347, 0.000921041704714298],
  ],
  [
    [118.450357116104, 24.764814598732, 0.000920998863875866],
    [118.449658325923, 24.7651529741295, 0.000921040773391724],
  ],
  [
    [118.450347848931, 24.7647986528967, 0.000920995138585567],
    [118.449649058806, 24.7651370192237, 0.000921037979424],
  ],
  [
    [118.450338581752, 24.7647826980331, 0.000920992344617844],
    [118.449639801586, 24.7651210733385, 0.000921036116778851],
  ],
  [
    [118.450329324471, 24.7647667521899, 0.000920992344617844],
    [118.449630534474, 24.7651051184315, 0.000921033322811127],
  ],
  [
    [118.450320057297, 24.764750797325, 0.00092098955065012],
    [118.449621267372, 24.7650891725517, 0.000921031460165977],
  ],
  [
    [118.450310790126, 24.7647348424595, 0.000920987688004971],
    [118.449612000265, 24.7650732176435, 0.000921030528843403],
  ],
  [
    [118.450301522965, 24.7647188966211, 0.000920985825359821],
    [118.449602743047, 24.7650572627281, 0.000921028666198254],
  ],
  [
    [118.450292265686, 24.7647029417478, 0.000920982100069523],
    [118.449593475952, 24.7650413168463, 0.000921026803553104],
  ],
  [
    [118.450282998529, 24.7646869959082, 0.000920982100069523],
    [118.449584208852, 24.7650253619363, 0.000921024940907955],
  ],
  [
    [118.450273731367, 24.7646710410402, 0.00092097744345665],
    [118.449574941761, 24.7650094160534, 0.000921021215617657],
  ],
  [
    [118.450264464208, 24.7646550861716, 0.00092097744345665],
    [118.449565684553, 24.7649934611355, 0.000921020284295082],
  ],
  [
    [118.450255206946, 24.7646391403236, 0.000920975580811501],
    [118.44955641746, 24.7649775062236, 0.000921017490327358],
  ],
  [
    [118.450245939791, 24.7646231854537, 0.000920973718166351],
    [118.449547150376, 24.7649615603388, 0.000921014696359634],
  ],
  [
    [118.450236672646, 24.7646072396111, 0.000920971855521202],
    [118.449537883288, 24.7649456054257, 0.00092101376503706],
  ],
  [
    [118.450227405497, 24.76459128474, 0.000920969992876053],
    [118.449528626096, 24.7649296595331, 0.000921010971069336],
  ],
  [
    [118.450218148236, 24.7645753298617, 0.00092096533626318],
    [118.449519359013, 24.7649137046187, 0.000921010039746761],
  ],
  [
    [118.450208881099, 24.7645593840172, 0.000920964404940605],
    [118.449510091932, 24.7648977497037, 0.000921008177101612],
  ],
  [
    [118.450199613956, 24.7645434291443, 0.000920964404940605],
    [118.44950082486, 24.7648818038159, 0.000921005383133888],
  ],
  [
    [118.45019035671, 24.764527483292, 0.000920960679650307],
    [118.449491567671, 24.7648658488931, 0.000921003520488739],
  ],
  [
    [118.450181089572, 24.7645115284179, 0.000920958817005157],
    [118.449482300604, 24.764849903004, 0.000921003520488739],
  ],
  [
    [118.450171822437, 24.7644955735431, 0.000920956954360008],
    [118.449473033532, 24.7648339480866, 0.000920998863875866],
  ],
  [
    [118.450162555311, 24.7644796276955, 0.000920955091714859],
    [118.449463766463, 24.7648179931685, 0.000920997001230717],
  ],
  [
    [118.450153298067, 24.764463672813, 0.00092095322906971],
    [118.44945450929, 24.764802047271, 0.000920997001230717],
  ],
  [
    [118.450144030946, 24.7644477269641, 0.000920950435101986],
    [118.449445242226, 24.7647860923518, 0.000920994207262993],
  ],
  [
    [118.45013476382, 24.764431772087, 0.000920948572456837],
    [118.449435975171, 24.7647701464596, 0.000920991413295269],
  ],
  [
    [118.450125496704, 24.7644158262369, 0.000920945778489113],
    [118.449426717998, 24.7647541915325, 0.000920988619327545],
  ],
  [
    [118.450116239469, 24.7643998713519, 0.000920944847166538],
    [118.449417450941, 24.7647382366114, 0.000920987688004971],
  ],
  [
    [118.45010697235, 24.7643839164728, 0.000920943915843964],
    [118.449408183893, 24.7647222907174, 0.000920985825359821],
  ],
  [
    [118.450097705241, 24.7643679706209, 0.000920940190553665],
    [118.44939891684, 24.764706335795, 0.000920983962714672],
  ],
  [
    [118.450088438127, 24.7643520157407, 0.000920938327908516],
    [118.449389659684, 24.7646903898933, 0.000920982100069523],
  ],
  [
    [118.45007918091, 24.764336069881, 0.000920936465263367],
    [118.449380392636, 24.7646744349697, 0.000920978374779224],
  ],
  [
    [118.4500699138, 24.7643201149995, 0.000920935533940792],
    [118.449371125598, 24.7646584890732, 0.000920978374779224],
  ],
  [
    [118.450060646693, 24.7643041601174, 0.000920933671295643],
    [118.449361858555, 24.7646425341484, 0.000920974649488926],
  ],
  [
    [118.450051379596, 24.7642882142624, 0.000920930877327919],
    [118.449352601401, 24.7646265792164, 0.000920972786843777],
  ],
  [
    [118.450042122381, 24.7642722593725, 0.00092092901468277],
    [118.44934333437, 24.7646106333181, 0.000920972786843777],
  ],
  [
    [118.450032855288, 24.7642563135163, 0.000920925289392471],
    [118.449334067334, 24.7645946783915, 0.000920968130230904],
  ],
  [
    [118.45002358819, 24.7642403586317, 0.000920923426747322],
    [118.449324800307, 24.764578732492, 0.000920967198908329],
  ],
  [
    [118.450014321095, 24.7642244037465, 0.000920923426747322],
    [118.449315543163, 24.7645627775575, 0.000920966267585754],
  ],
  [
    [118.450005063897, 24.7642084578819, 0.000920922495424747],
    [118.449306276134, 24.764546822629, 0.000920963473618031],
  ],
  [
    [118.449995796806, 24.7641925029955, 0.0009209169074893],
    [118.449297009115, 24.7645308767276, 0.000920961610972881],
  ],
  [
    [118.449986529725, 24.7641765571362, 0.000920915976166725],
    [118.44928774209, 24.7645149217979, 0.000920960679650307],
  ],
  [
    [118.449977272527, 24.764160602242, 0.000920915976166725],
    [118.449278484963, 24.7644989758888, 0.000920956954360008],
  ],
  [
    [118.449968005444, 24.7641446473537, 0.000920913182199001],
    [118.449269217943, 24.7644830209578, 0.000920955091714859],
  ],
  [
    [118.44995873837, 24.7641287014926, 0.000920911319553852],
    [118.449259950926, 24.7644670660262, 0.000920952297747135],
  ],
  [
    [118.449949471291, 24.7641127466031, 0.000920909456908703],
    [118.449250683919, 24.7644511201218, 0.000920951366424561],
  ],
  [
    [118.449940214109, 24.7640968007342, 0.000920907594263554],
    [118.449241426794, 24.7644351651824, 0.000920949503779411],
  ],
  [
    [118.449930947036, 24.7640808458435, 0.000920905731618404],
    [118.449232159791, 24.7644192192768, 0.000920947641134262],
  ],
  [
    [118.449921679964, 24.7640648909521, 0.000920902937650681],
    [118.449222892783, 24.7644032643427, 0.000920946709811687],
  ],
  [
    [118.449912412902, 24.7640489450879, 0.000920899212360382],
    [118.449213635665, 24.7643873094015, 0.000920942053198814],
  ],
  [
    [118.449903155723, 24.7640329901888, 0.000920899212360382],
    [118.449204368669, 24.764371363494, 0.00092094112187624],
  ],
  [
    [118.449893888666, 24.7640170443234, 0.000920897349715233],
    [118.449195101669, 24.7643554085582, 0.000920938327908516],
  ],
  [
    [118.449884621604, 24.7640010894296, 0.000920894555747509],
    [118.449185834678, 24.7643394626494, 0.000920938327908516],
  ],
  [
    [118.449875354544, 24.7639851345352, 0.000920894555747509],
    [118.449176577569, 24.7643235077058, 0.000920936465263367],
  ],
  [
    [118.449866097381, 24.7639691886614, 0.000920889899134636],
    [118.449167310576, 24.764307552768, 0.000920933671295643],
  ],
  [
    [118.449856830326, 24.7639532337657, 0.000920888036489487],
    [118.449158043592, 24.7642916068575, 0.000920930877327919],
  ],
  [
    [118.449847563281, 24.7639372878972, 0.000920886173844337],
    [118.449148776603, 24.7642756519185, 0.00092092901468277],
  ],
  [
    [118.449838296231, 24.7639213330004, 0.000920884311199188],
    [118.449139519511, 24.7642597060001, 0.000920926220715046],
  ],
  [
    [118.44982903907, 24.7639053780963, 0.000920883379876614],
    [118.449130252528, 24.76424375106, 0.000920926220715046],
  ],
  [
    [118.449819772032, 24.763889432226, 0.000920881517231464],
    [118.449120985546, 24.7642277961192, 0.000920923426747322],
  ],
  [
    [118.449810504989, 24.7638734773273, 0.000920879654586315],
    [118.449111718574, 24.7642118502055, 0.000920920632779598],
  ],
  [
    [118.449801237956, 24.7638575314557, 0.000920876860618591],
    [118.449102461484, 24.764195895257, 0.000920919701457024],
  ],
  [
    [118.449791980805, 24.7638415765492, 0.000920873135328293],
    [118.449093194517, 24.7641799493421, 0.000920918770134449],
  ],
  [
    [118.449782713769, 24.7638256216487, 0.000920873135328293],
    [118.449083927545, 24.7641639943988, 0.000920915976166725],
  ],
  [
    [118.449773446743, 24.7638096757753, 0.000920870341360569],
    [118.449074660576, 24.764148039455, 0.000920913182199001],
  ],
  [
    [118.449764189599, 24.7637937208669, 0.000920867547392845],
    [118.449065403503, 24.7641320935317, 0.000920910388231277],
  ],
  [
    [118.449754922577, 24.7637777749923, 0.000920866616070271],
    [118.449056136538, 24.7641161385866, 0.000920909456908703],
  ],
  [
    [118.449745655551, 24.7637618200893, 0.000920863822102547],
    [118.449046869582, 24.7641001926686, 0.000920907594263554],
  ],
  [
    [118.449736388534, 24.7637458742134, 0.000920862890779972],
    [118.449037602622, 24.7640842377223, 0.000920906662940979],
  ],
  [
    [118.449727131399, 24.7637299193026, 0.000920860096812248],
    [118.449028345559, 24.7640682917966, 0.000920903868973255],
  ],
  [
    [118.44971786438, 24.7637139643978, 0.000920858234167099],
    [118.449019078603, 24.764052336849, 0.000920902006328106],
  ],
  [
    [118.449708597371, 24.7636980185201, 0.000920857302844524],
    [118.44900981165, 24.7640363819009, 0.000920899212360382],
  ],
  [
    [118.449699330356, 24.763682063614, 0.000920855440199375],
    [118.449000554594, 24.7640204359733, 0.000920896418392658],
  ],
  [
    [118.449690073238, 24.7636661177285, 0.000920852646231651],
    [118.448991287645, 24.7640044810239, 0.000920895487070084],
  ],
  [
    [118.449680806228, 24.7636501628212, 0.000920850783586502],
    [118.448982020707, 24.7639885351017, 0.000920893624424934],
  ],
  [
    [118.449671539221, 24.7636342079133, 0.000920847989618778],
    [118.448972753763, 24.763972580151, 0.00092089269310236],
  ],
  [
    [118.449662272223, 24.7636182620325, 0.000920847058296204],
    [118.448963496709, 24.7639566251933, 0.000920889899134636],
  ],
  [
    [118.449653015108, 24.7636023071168, 0.00092084426432848],
    [118.448954229777, 24.7639406792692, 0.000920887105166912],
  ],
  [
    [118.449643748115, 24.7635863612347, 0.000920843333005905],
    [118.448944962841, 24.7639247243167, 0.000920886173844337],
  ],
  [
    [118.449634481117, 24.7635704063244, 0.000920841470360756],
    [118.448935695914, 24.7639087783914, 0.000920882448554039],
  ],
  [
    [118.449625214121, 24.7635544514134, 0.000920836813747883],
    [118.448926438869, 24.7638928234311, 0.00092088058590889],
  ],
  [
    [118.449615957022, 24.763538505523, 0.000920836813747883],
    [118.44891717194, 24.7638768684768, 0.000920878723263741],
  ],
  [
    [118.449606690031, 24.7635225506107, 0.000920834951102734],
    [118.44890790502, 24.7638609225497, 0.000920877791941166],
  ],
  [
    [118.44959742305, 24.7635066047257, 0.000920833088457584],
    [118.448898638096, 24.7638449675941, 0.000920874997973442],
  ],
  [
    [118.449588156064, 24.7634906498122, 0.000920829363167286],
    [118.448889381068, 24.7638290216592, 0.000920873135328293],
  ],
  [
    [118.449578898968, 24.7634746948916, 0.000920829363167286],
    [118.448880114148, 24.7638130667024, 0.000920871272683144],
  ],
  [
    [118.449569631994, 24.7634587490047, 0.000920826569199562],
    [118.448870847231, 24.763797111745, 0.000920869410037994],
  ],
  [
    [118.449560365015, 24.7634427940894, 0.000920823775231838],
    [118.448861580323, 24.7637811658148, 0.000920866616070271],
  ],
  [
    [118.449551098045, 24.7634268482012, 0.000920822843909264],
    [118.448852323297, 24.7637652108497, 0.000920864753425121],
  ],
  [
    [118.449541840958, 24.7634108932781, 0.000920821912586689],
    [118.448843056394, 24.7637492649182, 0.000920864753425121],
  ],
  [
    [118.449532573986, 24.763394938361, 0.000920818187296391],
    [118.448833789486, 24.7637333099583, 0.000920861959457397],
  ],
  [
    [118.449523307024, 24.763378992471, 0.000920816324651241],
    [118.44882452258, 24.7637173549979, 0.000920860096812248],
  ],
  [
    [118.449514049944, 24.7633630375461, 0.000920814462006092],
    [118.448815265571, 24.763701409058, 0.000920858234167099],
  ],
  [
    [118.449504782987, 24.7633470916548, 0.000920812599360943],
    [118.44880599867, 24.7636854540964, 0.000920855440199375],
  ],
  [
    [118.449495516024, 24.7633311367352, 0.000920811668038368],
    [118.448796731779, 24.7636695081618, 0.000920853577554226],
  ],
  [
    [118.449486249064, 24.763315181815, 0.00092080794274807],
    [118.44878747477, 24.7636535531924, 0.000920850783586502],
  ],
  [
    [118.449476992001, 24.7632992359154, 0.000920806080102921],
    [118.448778207876, 24.7636375982288, 0.000920849852263927],
  ],
  [
    [118.449467725046, 24.763283280994, 0.000920805148780346],
    [118.448768940992, 24.7636216522925, 0.000920847989618778],
  ],
  [
    [118.4494584581, 24.7632673350997, 0.000920803286135197],
    [118.448759674103, 24.7636056973277, 0.000920845195651054],
  ],
  [
    [118.44944919115, 24.763251380177, 0.000920801423490047],
    [118.448750417111, 24.7635897513836, 0.00092084426432848],
  ],
  [
    [118.449439934089, 24.7632354252472, 0.000920797698199749],
    [118.448741150226, 24.7635737964176, 0.000920840539038181],
  ],
  [
    [118.44943066715, 24.763219479351, 0.000920797698199749],
    [118.448731883345, 24.763557841451, 0.000920840539038181],
  ],
  [
    [118.449421400207, 24.7632035244265, 0.000920794904232025],
    [118.448722616472, 24.7635418955115, 0.000920835882425308],
  ],
  [
    [118.449412133273, 24.7631875785292, 0.000920792110264301],
    [118.448713359482, 24.7635259405372, 0.000920834951102734],
  ],
  [
    [118.449402876222, 24.7631716235969, 0.000920790247619152],
    [118.448704092615, 24.7635099945965, 0.000920833088457584],
  ],
  [
    [118.449393609293, 24.7631556776983, 0.000920788384974003],
    [118.448694825742, 24.7634940396274, 0.000920831225812435],
  ],
  [
    [118.449384342359, 24.7631397227713, 0.000920787453651428],
    [118.448685558872, 24.7634780846577, 0.000920829363167286],
  ],
  [
    [118.449375075427, 24.7631237678437, 0.000920784659683704],
    [118.448676301899, 24.7634621387087, 0.000920827500522137],
  ],
  [
    [118.449365818392, 24.7631078219367, 0.000920782797038555],
    [118.448667035034, 24.7634461837378, 0.000920825637876987],
  ],
  [
    [118.449356551466, 24.7630918670079, 0.000920780934393406],
    [118.448657768178, 24.763430237794, 0.000920823775231838],
  ],
  [
    [118.449347284549, 24.7630759211062, 0.000920778140425682],
    [118.448648501317, 24.7634142828219, 0.000920820981264114],
  ],
  [
    [118.449338017627, 24.7630599661762, 0.000920778140425682],
    [118.448639244353, 24.7633983368704, 0.000920817255973816],
  ],
  [
    [118.449328760594, 24.763044011239, 0.000920774415135384],
    [118.448629977498, 24.763382381897, 0.000920818187296391],
  ],
  [
    [118.449319493684, 24.7630280653355, 0.00092077162116766],
    [118.448620710644, 24.7633664269231, 0.000920815393328667],
  ],
  [
    [118.449310226769, 24.7630121104036, 0.000920769758522511],
    [118.4486114438, 24.7633504809762, 0.000920811668038368],
  ],
  [
    [118.449300969751, 24.7629961644923, 0.000920767895877361],
    [118.448602186839, 24.7633345259945, 0.000920810736715794],
  ],
  [
    [118.449291702841, 24.7629802095592, 0.000920766964554787],
    [118.44859292, 24.7633185800465, 0.000920808874070644],
  ],
  [
    [118.449282435933, 24.7629642546255, 0.000920763239264488],
    [118.448583653156, 24.76330262507, 0.000920807011425495],
  ],
  [
    [118.449273169035, 24.7629483087189, 0.000920762307941914],
    [118.448574396201, 24.7632866700865, 0.000920805148780346],
  ],
  [
    [118.449263912019, 24.7629323537774, 0.00092075951397419],
    [118.448565129369, 24.7632707241366, 0.000920802354812622],
  ],
  [
    [118.449254645125, 24.7629164078696, 0.000920758582651615],
    [118.448555862532, 24.7632547691583, 0.000920800492167473],
  ],
  [
    [118.449245378227, 24.7629004529334, 0.000920755788683891],
    [118.448546595705, 24.7632388232072, 0.000920798629522324],
  ],
  [
    [118.449236111331, 24.7628844979966, 0.000920754857361317],
    [118.44853733876, 24.7632228682212, 0.000920796766877174],
  ],
  [
    [118.449226854332, 24.7628685520804, 0.000920752063393593],
    [118.44852807193, 24.7632069132411, 0.000920793972909451],
  ],
  [
    [118.449217587441, 24.7628525971423, 0.000920750200748444],
    [118.44851880511, 24.7631909672881, 0.000920793041586876],
  ],
  [
    [118.449208320559, 24.7628366512315, 0.000920749269425869],
    [118.448509538285, 24.7631750123067, 0.000920791178941727],
  ],
  [
    [118.449199053673, 24.7628206962922, 0.000920745544135571],
    [118.448500281357, 24.763159066346, 0.000920787453651428],
  ],
  [
    [118.449189796676, 24.7628047413458, 0.000920744612812996],
    [118.448491014537, 24.7631431113635, 0.000920786522328854],
  ],
  [
    [118.449180529801, 24.762788795433, 0.000920742750167847],
    [118.448481747719, 24.7631271563803, 0.000920785591006279],
  ],
  [
    [118.449171262922, 24.762772840492, 0.000920739956200123],
    [118.448472480911, 24.7631112104242, 0.00092078372836113],
  ],
  [
    [118.449161996052, 24.762756894578, 0.000920739956200123],
    [118.448463223984, 24.7630952554333, 0.000920780934393406],
  ],
  [
    [118.449152739065, 24.7627409396291, 0.000920737162232399],
    [118.448453957181, 24.763079309476, 0.000920777209103107],
  ],
  [
    [118.449143472193, 24.7627249846862, 0.00092073529958725],
    [118.448444690373, 24.7630633544904, 0.000920777209103107],
  ],
  [
    [118.44913420533, 24.7627090387704, 0.000920731574296951],
    [118.448435423567, 24.7630473995041, 0.000920775346457958],
  ],
  [
    [118.449124938463, 24.7626930838262, 0.000920729711651802],
    [118.448426166657, 24.7630314535385, 0.000920772552490234],
  ],
  [
    [118.449115681492, 24.7626771379026, 0.000920729711651802],
    [118.448416899856, 24.763015498551, 0.000920769758522511],
  ],
  [
    [118.449106414629, 24.7626611829572, 0.000920726917684078],
    [118.448407633064, 24.7629995525906, 0.000920768827199936],
  ],
  [
    [118.449097147769, 24.7626452280112, 0.000920724123716354],
    [118.448398366268, 24.7629835976019, 0.000920766964554787],
  ],
  [
    [118.449087890805, 24.7626292820858, 0.00092072319239378],
    [118.448389109361, 24.7629676426061, 0.000920765101909637],
  ],
  [
    [118.449078623949, 24.7626133271386, 0.000920720398426056],
    [118.448379842576, 24.7629516966439, 0.000920762307941914],
  ],
  [
    [118.449069357103, 24.7625973812185, 0.000920717604458332],
    [118.448370575787, 24.7629357416533, 0.000920760445296764],
  ],
  [
    [118.449060090253, 24.76258142627, 0.000920716673135757],
    [118.448361318894, 24.7629197956834, 0.000920758582651615],
  ],
  [
    [118.449050833291, 24.7625654713144, 0.000920714810490608],
    [118.448352052109, 24.7629038406916, 0.000920756720006466],
  ],
  [
    [118.449041566452, 24.7625495253924, 0.000920712947845459],
    [118.448342785327, 24.7628878856992, 0.000920753926038742],
  ],
  [
    [118.449032299609, 24.7625335704421, 0.000920709222555161],
    [118.448333518554, 24.762871939734, 0.000920752063393593],
  ],
  [
    [118.449023032774, 24.7625176245189, 0.000920708291232586],
    [118.448324261664, 24.7628559847339, 0.000920750200748444],
  ],
  [
    [118.449013775822, 24.7625016695608, 0.000920706428587437],
    [118.448314994896, 24.7628400387674, 0.000920748338103294],
  ],
  [
    [118.449004508993, 24.7624857236364, 0.000920703634619713],
    [118.448305728123, 24.7628240837725, 0.000920745544135571],
  ],
  [
    [118.448995242159, 24.7624697686837, 0.000920702703297138],
    [118.44829646136, 24.7628081378048, 0.000920743681490421],
  ],
  [
    [118.448985975327, 24.7624538137303, 0.000920700840651989],
    [118.448287204479, 24.7627921828022, 0.000920743681490421],
  ],
  [
    [118.448976718392, 24.7624378677975, 0.000920698046684265],
    [118.448277937713, 24.7627762278055, 0.000920740887522697],
  ],
  [
    [118.448967451565, 24.7624219128429, 0.000920697115361691],
    [118.448268670957, 24.7627602818359, 0.000920739024877548],
  ],
  [
    [118.448958184747, 24.7624059669154, 0.000920694321393967],
    [118.448259404196, 24.762744326838, 0.000920737162232399],
  ],
  [
    [118.448948917925, 24.7623900119596, 0.000920692458748817],
    [118.448250147332, 24.7627283808607, 0.000920734368264675],
  ],
  [
    [118.448939660992, 24.7623740569966, 0.000920689664781094],
    [118.448240880576, 24.7627124258616, 0.000920730642974377],
  ],
  [
    [118.448930394181, 24.7623581110673, 0.000920687802135944],
    [118.448231613822, 24.7626964708618, 0.000920730642974377],
  ],
  [
    [118.448921127366, 24.7623421561096, 0.000920685008168221],
    [118.448222347078, 24.7626805248891, 0.000920729711651802],
  ],
  [
    [118.44891186056, 24.762326210179, 0.000920684076845646],
    [118.448213090216, 24.7626645698816, 0.000920725986361504],
  ],
  [
    [118.448902603637, 24.7623102552136, 0.000920682214200497],
    [118.448203823476, 24.7626486239078, 0.000920725055038929],
  ],
  [
    [118.448893336829, 24.7622943002541, 0.000920679420232773],
    [118.448194556732, 24.7626326689055, 0.000920722261071205],
  ],
  [
    [118.44888407003, 24.7622783543217, 0.000920678488910198],
    [118.44818528999, 24.7626167139027, 0.000920720398426056],
  ],
  [
    [118.448874813114, 24.7622623993544, 0.000920675694942474],
    [118.448176033145, 24.7626007679205, 0.000920717604458332],
  ],
  [
    [118.44886554632, 24.7622464534208, 0.0009206747636199],
    [118.448166766408, 24.7625848129164, 0.000920717604458332],
  ],
  [
    [118.448856279521, 24.7622304984588, 0.000920671969652176],
    [118.44815749968, 24.7625688669395, 0.000920714810490608],
  ],
  [
    [118.448847012725, 24.7622145434962, 0.000920669175684452],
    [118.448148242834, 24.7625529119277, 0.00092071108520031],
  ],
  [
    [118.448837755825, 24.7621985975542, 0.000920668244361877],
    [118.448138976104, 24.7625369569218, 0.000920710153877735],
  ],
  [
    [118.448828489034, 24.7621826425903, 0.000920665450394154],
    [118.448129709384, 24.762521010943, 0.000920707359910011],
  ],
  [
    [118.448819222252, 24.7621666966537, 0.000920664519071579],
    [118.448120442659, 24.7625050559359, 0.000920706428587437],
  ],
  [
    [118.448809955465, 24.7621507416886, 0.000920661725103855],
    [118.44811118583, 24.7624891099494, 0.000920704565942287],
  ],
  [
    [118.448800698568, 24.7621347867164, 0.000920660793781281],
    [118.448101919109, 24.762473154941, 0.000920702703297138],
  ],
  [
    [118.448791431793, 24.7621188407779, 0.000920657999813557],
    [118.448092652391, 24.762457199932, 0.000920700840651989],
  ],
  [
    [118.448782165013, 24.762102885811, 0.000920656137168407],
    [118.448083385682, 24.7624412539502, 0.000920698046684265],
  ],
  [
    [118.448772898243, 24.7620869398712, 0.000920654274523258],
    [118.448074128856, 24.7624252989335, 0.000920697115361691],
  ],
  [
    [118.448763641355, 24.7620709848965, 0.000920652411878109],
    [118.448064862152, 24.7624093529504, 0.000920693390071392],
  ],
  [
    [118.448754374583, 24.7620550299278, 0.000920649617910385],
    [118.448055595443, 24.7623933979389, 0.000920693390071392],
  ],
  [
    [118.44874510782, 24.7620390839862, 0.000920648686587811],
    [118.448046328737, 24.7623774429269, 0.000920691527426243],
  ],
  [
    [118.448735841052, 24.7620231290162, 0.000920646823942661],
    [118.448037071927, 24.7623614969355, 0.000920688733458519],
  ],
  [
    [118.448726584181, 24.7620071830669, 0.000920643098652363],
    [118.448027805225, 24.7623455419222, 0.000920685939490795],
  ],
  [
    [118.448717317418, 24.7619912280957, 0.000920642167329788],
    [118.448018538533, 24.762329595936, 0.000920684076845646],
  ],
  [
    [118.448708050657, 24.7619752731238, 0.00092063844203949],
    [118.448009271836, 24.7623136409215, 0.000920682214200497],
  ],
  [
    [118.448698783906, 24.7619593271792, 0.00092063844203949],
    [118.448000015029, 24.7622976858999, 0.000920681282877922],
  ],
  [
    [118.448689527037, 24.7619433721996, 0.000920635648071766],
    [118.447990748344, 24.7622817399119, 0.000920678488910198],
  ],
  [
    [118.44868026029, 24.7619274262537, 0.000920632854104042],
    [118.447981481654, 24.7622657848955, 0.000920675694942474],
  ],
  [
    [118.448670993539, 24.7619114712794, 0.000920633785426617],
    [118.447972214974, 24.7622498389063, 0.0009206747636199],
  ],
  [
    [118.448661736684, 24.7618955253258, 0.000920630991458893],
    [118.447962958176, 24.7622338838822, 0.000920672900974751],
  ],
  [
    [118.448652469938, 24.7618795703503, 0.000920628197491169],
    [118.447953691493, 24.762217928864, 0.000920671038329601],
  ],
  [
    [118.448643203194, 24.7618636153742, 0.000920625403523445],
    [118.44794442482, 24.762201982873, 0.000920669175684452],
  ],
  [
    [118.448633936459, 24.7618476694252, 0.000920624472200871],
    [118.447935168029, 24.7621860278471, 0.000920666381716728],
  ],
  [
    [118.448624679607, 24.7618317144413, 0.000920622609555721],
    [118.447925901361, 24.7621700818548, 0.000920664519071579],
  ],
  [
    [118.448615412877, 24.7618157684911, 0.000920619815587997],
    [118.447916634688, 24.7621541268341, 0.00092066265642643],
  ],
  [
    [118.448606146143, 24.7617998135125, 0.000920617021620274],
    [118.447907368024, 24.7621381808406, 0.000920660793781281],
  ],
  [
    [118.448596879411, 24.7617838585333, 0.000920616090297699],
    [118.447898111243, 24.7621222258122, 0.000920658931136131],
  ],
  [
    [118.448587622575, 24.7617679125748, 0.000920613296329975],
    [118.447888844577, 24.7621062707897, 0.000920656137168407],
  ],
  [
    [118.448578355847, 24.7617519575944, 0.000920611433684826],
    [118.44787957792, 24.7620903247944, 0.000920653343200684],
  ],
  [
    [118.448569089129, 24.7617360116411, 0.000920608639717102],
    [118.447870311259, 24.7620743697706, 0.000920652411878109],
  ],
  [
    [118.448559822407, 24.7617200566594, 0.000920607708394527],
    [118.447861054494, 24.7620584237676, 0.00092065054923296],
  ],
  [
    [118.448550565573, 24.7617041016707, 0.000920605845749378],
    [118.447851787838, 24.7620424687426, 0.000920648686587811],
  ],
  [
    [118.448541298862, 24.7616881557155, 0.000920603051781654],
    [118.447842521184, 24.762026513717, 0.000920646823942661],
  ],
  [
    [118.448532032147, 24.7616722007321, 0.00092060212045908],
    [118.447833254539, 24.7620105677186, 0.000920644029974937],
  ],
  [
    [118.448522765441, 24.7616562547757, 0.000920599326491356],
    [118.447823997777, 24.7619946126853, 0.000920641236007214],
  ],
  [
    [118.448513508617, 24.7616402997845, 0.000920598395168781],
    [118.447814731137, 24.7619786666857, 0.000920639373362064],
  ],
  [
    [118.448504241908, 24.7616243447991, 0.000920594669878483],
    [118.447805464492, 24.7619627116576, 0.000920639373362064],
  ],
  [
    [118.448494975209, 24.7616083988409, 0.000920595601201057],
    [118.44779619785, 24.761946756629, 0.000920635648071766],
  ],
  [
    [118.448485708506, 24.7615924438544, 0.000920590944588184],
    [118.447786941104, 24.761930810621, 0.000920633785426617],
  ],
  [
    [118.448476451698, 24.7615764978884, 0.000920589081943035],
    [118.447777674466, 24.7619148555911, 0.000920632854104042],
  ],
  [
    [118.448467184999, 24.7615605429007, 0.000920589081943035],
    [118.447768407838, 24.7618989095884, 0.000920630991458893],
  ],
  [
    [118.448457918303, 24.7615445879123, 0.000920585356652737],
    [118.447759141206, 24.7618829545573, 0.000920628197491169],
  ],
  [
    [118.448448661503, 24.7615286419445, 0.000920584425330162],
    [118.447749884462, 24.7618669995191, 0.000920625403523445],
  ],
  [
    [118.448439394811, 24.7615126869549, 0.000920580700039864],
    [118.447740617841, 24.7618510535145, 0.000920623540878296],
  ],
  [
    [118.448430128128, 24.7614967409924, 0.000920578837394714],
    [118.447731351215, 24.7618350984816, 0.000920622609555721],
  ],
  [
    [118.448420861441, 24.7614807860015, 0.00092057790607214],
    [118.447722084599, 24.7618191524758, 0.000920619815587997],
  ],
  [
    [118.448411604643, 24.7614648310035, 0.000920575112104416],
    [118.447712827865, 24.7618031974351, 0.000920617952942848],
  ],
  [
    [118.448402337968, 24.7614488850392, 0.000920573249459267],
    [118.447703561247, 24.7617872424004, 0.000920616090297699],
  ],
  [
    [118.448393071288, 24.7614329300465, 0.000920570455491543],
    [118.447694294638, 24.7617712963927, 0.000920613296329975],
  ],
  [
    [118.448383804618, 24.7614169840809, 0.000920570455491543],
    [118.447685037911, 24.7617553413502, 0.000920611433684826],
  ],
  [
    [118.448374547829, 24.7614010290805, 0.000920567661523819],
    [118.447675771306, 24.7617393953413, 0.000920611433684826],
  ],
  [
    [118.448365281156, 24.7613850740859, 0.00092056579887867],
    [118.447666504697, 24.7617234403041, 0.000920607708394527],
  ],
  [
    [118.448356014493, 24.7613691281185, 0.000920563936233521],
    [118.447657238091, 24.7617074852662, 0.000920605845749378],
  ],
  [
    [118.448346747825, 24.7613531731227, 0.000920562073588371],
    [118.44764798138, 24.7616915392491, 0.000920603983104229],
  ],
  [
    [118.448337491053, 24.7613372271476, 0.000920559279620647],
    [118.447638714778, 24.76167558421, 0.000920601189136505],
  ],
  [
    [118.44832822439, 24.7613212721506, 0.000920558348298073],
    [118.447629448186, 24.761659638198, 0.000920600257813931],
  ],
  [
    [118.448318957729, 24.761305317153, 0.000920555554330349],
    [118.447620181589, 24.7616436831577, 0.000920598395168781],
  ],
  [
    [118.448309691077, 24.7612893711825, 0.000920554623007774],
    [118.447610924881, 24.7616277281103, 0.000920595601201057],
  ],
  [
    [118.448300434308, 24.7612734161772, 0.000920551829040051],
    [118.447601658295, 24.7616117820965, 0.000920594669878483],
  ],
  [
    [118.448291167661, 24.7612574702055, 0.000920549035072327],
    [118.447592391705, 24.7615958270544, 0.000920591875910759],
  ],
  [
    [118.448281901009, 24.7612415152054, 0.000920548103749752],
    [118.447583125125, 24.7615798810393, 0.00092059001326561],
  ],
  [
    [118.448272634367, 24.7612255692324, 0.000920546241104603],
    [118.447573868426, 24.7615639259895, 0.000920589081943035],
  ],
  [
    [118.448263377607, 24.7612096142247, 0.000920543447136879],
    [118.44756460185, 24.7615479799732, 0.000920587219297886],
  ],
  [
    [118.448254110963, 24.7611936592227, 0.000920542515814304],
    [118.44755533527, 24.7615320249286, 0.000920584425330162],
  ],
  [
    [118.448244844328, 24.7611777132479, 0.000920540653169155],
    [118.447546068692, 24.7615160698834, 0.000920581631362438],
  ],
  [
    [118.448235587575, 24.7611617582383, 0.000920535996556282],
    [118.44753681201, 24.7615001238589, 0.000920580700039864],
  ],
  [
    [118.448226320945, 24.7611458122623, 0.000920535996556282],
    [118.447527545436, 24.7614841688124, 0.00092057790607214],
  ],
  [
    [118.44821705431, 24.7611298572579, 0.000920533202588558],
    [118.447518278872, 24.7614682227931, 0.000920576043426991],
  ],
  [
    [118.448207787678, 24.7611139022529, 0.000920530408620834],
    [118.447509012303, 24.7614522677454, 0.000920573249459267],
  ],
  [
    [118.448198530941, 24.7610979562686, 0.000920528545975685],
    [118.447499755624, 24.7614363126906, 0.000920572318136692],
  ],
  [
    [118.448189264313, 24.7610820012624, 0.000920526683330536],
    [118.447490489067, 24.7614203666695, 0.000920570455491543],
  ],
  [
    [118.448179997695, 24.7610660552833, 0.000920526683330536],
    [118.447481222505, 24.7614044116199, 0.000920567661523819],
  ],
  [
    [118.448170731072, 24.7610501002758, 0.000920522958040237],
    [118.44747196584, 24.7613884655911, 0.00092056579887867],
  ],
  [
    [118.448161474338, 24.7610341452613, 0.000920521095395088],
    [118.447462699283, 24.7613725105403, 0.000920564867556095],
  ],
  [
    [118.448152207727, 24.7610181992804, 0.000920518301427364],
    [118.447453432729, 24.761356555489, 0.000920561142265797],
  ],
  [
    [118.448142941111, 24.7610022442711, 0.000920516438782215],
    [118.447444166184, 24.7613406094647, 0.000920560210943222],
  ],
  [
    [118.448133674505, 24.7609862982889, 0.000920515507459641],
    [118.447434909521, 24.7613246544057, 0.000920558348298073],
  ],
  [
    [118.44812441778, 24.7609703432719, 0.000920514576137066],
    [118.447425642981, 24.7613087083802, 0.000920556485652924],
  ],
  [
    [118.448115151171, 24.7609543882608, 0.000920510850846767],
    [118.447416376436, 24.7612927533264, 0.000920554623007774],
  ],
  [
    [118.448105884572, 24.7609384422768, 0.000920508988201618],
    [118.447407109893, 24.7612767982719, 0.000920550897717476],
  ],
  [
    [118.448096617968, 24.7609224872644, 0.000920508056879044],
    [118.447397853247, 24.7612608522382, 0.000920548103749752],
  ],
  [
    [118.44808736126, 24.7609065412727, 0.00092050526291132],
    [118.447388586709, 24.7612448971825, 0.000920549035072327],
  ],
  [
    [118.448078094661, 24.7608905862591, 0.000920502468943596],
    [118.44737932018, 24.761228951154, 0.000920546241104603],
  ],
  [
    [118.448068828064, 24.7608746312449, 0.000920501537621021],
    [118.447370053647, 24.7612129960971, 0.000920544378459454],
  ],
  [
    [118.448059561476, 24.7608586852579, 0.000920498743653297],
    [118.447360797003, 24.7611970410331, 0.00092054158449173],
  ],
  [
    [118.448050304771, 24.760842730236, 0.000920497812330723],
    [118.447351530482, 24.7611810950028, 0.000920539721846581],
  ],
  [
    [118.448041038188, 24.7608267842477, 0.000920494087040424],
    [118.447342263956, 24.761165139944, 0.000920538790524006],
  ],
  [
    [118.448031771601, 24.760810829231, 0.000920492224395275],
    [118.447332997439, 24.7611491939124, 0.000920535996556282],
  ],
  [
    [118.448022514902, 24.7607948742073, 0.000920492224395275],
    [118.447323740805, 24.761133238846, 0.000920534133911133],
  ],
  [
    [118.448013248327, 24.7607789282171, 0.000920489430427551],
    [118.447314474286, 24.7611172837854, 0.000920531339943409],
  ],
  [
    [118.448003981746, 24.7607629731986, 0.000920486636459827],
    [118.447305207776, 24.761101337752, 0.00092052947729826],
  ],
  [
    [118.447994715175, 24.7607470272072, 0.000920484773814678],
    [118.447295941262, 24.7610853826901, 0.000920527614653111],
  ],
  [
    [118.447985458487, 24.760731072181, 0.000920483842492104],
    [118.447286684644, 24.761069436649, 0.000920524820685387],
  ],
  [
    [118.447976191913, 24.7607151171607, 0.000920481979846954],
    [118.447277418135, 24.761053481586, 0.000920523889362812],
  ],
  [
    [118.44796692535, 24.7606991711675, 0.000920479185879231],
    [118.447268151628, 24.7610375265223, 0.000920522958040237],
  ],
  [
    [118.447957658781, 24.7606832161459, 0.000920475460588932],
    [118.447258895017, 24.7610215804794, 0.000920520164072514],
  ],
  [
    [118.447948402109, 24.760667270145, 0.000920475460588932],
    [118.447249628515, 24.7610056254145, 0.00092051737010479],
  ],
  [
    [118.447939135545, 24.7606513151222, 0.000920471735298634],
    [118.447240362022, 24.7609896793767, 0.000920515507459641],
  ],
  [
    [118.447929868991, 24.7606353691265, 0.000920471735298634],
    [118.447231095524, 24.7609737243106, 0.000920514576137066],
  ],
  [
    [118.447920602432, 24.7606194141025, 0.000920469872653484],
    [118.447221838916, 24.7609577692375, 0.000920511782169342],
  ],
  [
    [118.447911345762, 24.7606034590714, 0.000920468010008335],
    [118.44721257243, 24.7609418231979, 0.000920509919524193],
  ],
  [
    [118.447902079215, 24.7605875130739, 0.000920466147363186],
    [118.44720330594, 24.7609258681299, 0.000920506194233894],
  ],
  [
    [118.447892812663, 24.760571558048, 0.000920463353395462],
    [118.447194039459, 24.7609099220891, 0.000920506194233894],
  ],
  [
    [118.44788354612, 24.7605556120492, 0.000920461490750313],
    [118.44718478286, 24.7608939670135, 0.000920503400266171],
  ],
  [
    [118.44787428946, 24.7605396570157, 0.000920459628105164],
    [118.447175516384, 24.7608780209714, 0.000920501537621021],
  ],
  [
    [118.447865022915, 24.760523701988, 0.00092045683413744],
    [118.447166249903, 24.760862065901, 0.000920499674975872],
  ],
  [
    [118.44785575638, 24.7605077559874, 0.000920454971492291],
    [118.447156983424, 24.76084611083, 0.000920496881008148],
  ],
  [
    [118.44784648984, 24.7604918009584, 0.000920452177524567],
    [118.447147726842, 24.7608301647797, 0.000920495018362999],
  ],
  [
    [118.447837233196, 24.7604758549501, 0.000920453108847141],
    [118.447138460368, 24.7608142097074, 0.000920495018362999],
  ],
  [
    [118.447827966661, 24.76045989992, 0.000920450314879417],
    [118.447129193903, 24.7607982636623, 0.000920492224395275],
  ],
  [
    [118.447818700128, 24.7604439448892, 0.000920446589589119],
    [118.447119927434, 24.7607823085888, 0.000920489430427551],
  ],
  [
    [118.447809433604, 24.7604279988855, 0.000920446589589119],
    [118.447110670854, 24.7607663535083, 0.000920488499104977],
  ],
  [
    [118.447800176963, 24.7604120438471, 0.000920442864298821],
    [118.447101404397, 24.7607504074613, 0.000920486636459827],
  ],
  [
    [118.447790910444, 24.7603960978422, 0.000920441932976246],
    [118.447092137935, 24.760734452386, 0.000920484773814678],
  ],
  [
    [118.447781643921, 24.7603801428089, 0.000920439139008522],
    [118.447082871483, 24.7607185063378, 0.000920481979846954],
  ],
  [
    [118.447772387287, 24.7603641877686, 0.000920436345040798],
    [118.447073614912, 24.7607025512548, 0.000920479185879231],
  ],
  [
    [118.447763120775, 24.7603482417619, 0.000920436345040798],
    [118.447064348457, 24.7606865961776, 0.000920477323234081],
  ],
  [
    [118.447753854259, 24.7603322867268, 0.0009204326197505],
    [118.447055082012, 24.7606706501276, 0.000920475460588932],
  ],
  [
    [118.447744587752, 24.7603163407188, 0.000920431688427925],
    [118.447045825448, 24.7606546950428, 0.000920472666621208],
  ],
  [
    [118.447735331127, 24.7603003856761, 0.000920428894460201],
    [118.447036559008, 24.7606387489915, 0.000920472666621208],
  ],
  [
    [118.447726064618, 24.7602844306391, 0.000920427031815052],
    [118.447027292562, 24.7606227939119, 0.000920469872653484],
  ],
  [
    [118.447716798118, 24.7602684846293, 0.000920425169169903],
    [118.447018026119, 24.7606068388317, 0.000920468010008335],
  ],
  [
    [118.447707531614, 24.7602525295912, 0.000920423306524754],
    [118.447008769573, 24.7605908927722, 0.000920465216040611],
  ],
  [
    [118.447698275005, 24.7602365835737, 0.000920421443879604],
    [118.446999503134, 24.7605749376907, 0.000920463353395462],
  ],
  [
    [118.447689008506, 24.7602206285343, 0.000920419581234455],
    [118.446990236705, 24.7605589916363, 0.000920462422072887],
  ],
  [
    [118.447679742008, 24.7602046734943, 0.000920415855944157],
    [118.446980970272, 24.7605430365536, 0.000920459628105164],
  ],
  [
    [118.44767047552, 24.7601887274814, 0.000920415855944157],
    [118.446971713728, 24.7605270814639, 0.00092045683413744],
  ],
  [
    [118.447661218914, 24.7601727724338, 0.000920412130653858],
    [118.446962447306, 24.7605111354078, 0.000920455902814865],
  ],
  [
    [118.447651952431, 24.7601568264197, 0.000920411199331284],
    [118.446953180879, 24.7604951803232, 0.000920453108847141],
  ],
  [
    [118.447642685943, 24.7601408713772, 0.000920409336686134],
    [118.446943914462, 24.7604792342658, 0.000920452177524567],
  ],
  [
    [118.447633419458, 24.7601249163341, 0.000920407474040985],
    [118.446934657928, 24.7604632791736, 0.000920449383556843],
  ],
  [
    [118.447624162869, 24.7601089703117, 0.000920404680073261],
    [118.446925391508, 24.7604473240872, 0.000920449383556843],
  ],
  [
    [118.447614896388, 24.7600930152674, 0.000920402817428112],
    [118.446916125098, 24.760431378028, 0.000920446589589119],
  ],
  [
    [118.447605629917, 24.7600770692503, 0.000920400954782963],
    [118.446906858684, 24.7604154229404, 0.000920441932976246],
  ],
  [
    [118.447596363441, 24.7600611142047, 0.000920400023460388],
    [118.446897602165, 24.7603994768735, 0.000920442864298821],
  ],
  [
    [118.447587106854, 24.7600451591521, 0.00092039629817009],
    [118.446888335756, 24.7603835217847, 0.000920439139008522],
  ],
  [
    [118.44757784039, 24.7600292131331, 0.000920393504202366],
    [118.446879069348, 24.7603675666952, 0.000920438207685947],
  ],
  [
    [118.447568573921, 24.7600132580858, 0.000920392572879791],
    [118.44686980295, 24.7603516206329, 0.000920435413718224],
  ],
  [
    [118.447559317348, 24.7599973120591, 0.000920389778912067],
    [118.446860546434, 24.7603356655358, 0.0009204326197505],
  ],
  [
    [118.447550050884, 24.7599813570105, 0.000920389778912067],
    [118.446851280041, 24.7603197194723, 0.000920431688427925],
  ],
  [
    [118.447540784429, 24.759965410989, 0.000920387916266918],
    [118.446842013643, 24.7603037643803, 0.000920429825782776],
  ],
  [
    [118.44753151797, 24.7599494559392, 0.000920385122299194],
    [118.446832757141, 24.7602878183092, 0.000920427031815052],
  ],
  [
    [118.447522261399, 24.7599335008823, 0.000920383259654045],
    [118.446823490748, 24.760271863216, 0.000920425169169903],
  ],
  [
    [118.447512994952, 24.759917554859, 0.000920380465686321],
    [118.446814224357, 24.7602559081223, 0.000920423306524754],
  ],
  [
    [118.4475037285, 24.7599015998073, 0.000920378603041172],
    [118.446804957976, 24.7602399620557, 0.00092042051255703],
  ],
  [
    [118.447494462057, 24.7598856537828, 0.000920376740396023],
    [118.446795701477, 24.7602240069543, 0.000920417718589306],
  ],
  [
    [118.447485205496, 24.7598696987234, 0.000920374877750874],
    [118.4467864351, 24.7602080608864, 0.000920417718589306],
  ],
  [
    [118.447475939051, 24.7598537436699, 0.000920373015105724],
    [118.446777168719, 24.7601921057902, 0.000920415855944157],
  ],
  [
    [118.447466672615, 24.7598377976435, 0.00092037208378315],
    [118.44676790234, 24.7601761506934, 0.000920413061976433],
  ],
  [
    [118.447457406175, 24.7598218425888, 0.000920369289815426],
    [118.446758645857, 24.7601602046173, 0.000920412130653858],
  ],
  [
    [118.44744814963, 24.7598058965548, 0.000920367427170277],
    [118.446749379483, 24.7601442495193, 0.00092040840536356],
  ],
  [
    [118.447438883195, 24.7597899414988, 0.000920365564525127],
    [118.446740113118, 24.7601283034484, 0.000920407474040985],
  ],
  [
    [118.447429616761, 24.7597739864422, 0.000920361839234829],
    [118.446730846748, 24.7601123483491, 0.00092040654271841],
  ],
  [
    [118.447420350338, 24.7597580404127, 0.000920360907912254],
    [118.446721590268, 24.7600963932428, 0.000920403748750687],
  ],
  [
    [118.447411093796, 24.7597420853485, 0.000920359045267105],
    [118.44671232391, 24.76008044717, 0.000920401886105537],
  ],
  [
    [118.447401827377, 24.7597261393178, 0.000920357182621956],
    [118.446703057548, 24.7600644920689, 0.000920400954782963],
  ],
  [
    [118.447392560953, 24.7597101842588, 0.000920355319976807],
    [118.446693791195, 24.7600485459949, 0.000920397229492664],
  ],
  [
    [118.447383294531, 24.7596942291991, 0.000920352526009083],
    [118.446684534724, 24.7600325908862, 0.000920395366847515],
  ],
  [
    [118.447374038006, 24.7596782831602, 0.000920350663363934],
    [118.446675268369, 24.7600166357832, 0.000920393504202366],
  ],
  [
    [118.447364771589, 24.7596623280993, 0.00092034786939621],
    [118.446666002023, 24.7600006897074, 0.000920390710234642],
  ],
  [
    [118.447355505182, 24.7596463820655, 0.000920346938073635],
    [118.446656735672, 24.7599847346032, 0.000920388847589493],
  ],
  [
    [118.447346248657, 24.759630426997, 0.00092034600675106],
    [118.446647479218, 24.7599687885197, 0.000920386053621769],
  ],
  [
    [118.447336982247, 24.7596144719342, 0.000920342281460762],
    [118.446638212872, 24.7599528334143, 0.000920386053621769],
  ],
  [
    [118.447327715847, 24.7595985258987, 0.000920340418815613],
    [118.446628946529, 24.7599368783083, 0.000920383259654045],
  ],
  [
    [118.447318449442, 24.7595825708347, 0.000920338556170464],
    [118.446619690082, 24.759920932223, 0.000920380465686321],
  ],
  [
    [118.447309192933, 24.7595666247915, 0.000920337624847889],
    [118.446610423743, 24.7599049771157, 0.000920379534363747],
  ],
  [
    [118.447299926533, 24.7595506697263, 0.000920334830880165],
    [118.446601157414, 24.7598890310356, 0.000920376740396023],
  ],
  [
    [118.447290660136, 24.7595347146605, 0.000920332968235016],
    [118.44659189108, 24.7598730759271, 0.000920374877750874],
  ],
  [
    [118.447281393747, 24.7595187686218, 0.000920330174267292],
    [118.446582634635, 24.7598571208116, 0.000920373946428299],
  ],
  [
    [118.447272137241, 24.7595028135483, 0.000920328311622143],
    [118.446573368313, 24.7598411747296, 0.000920370221138],
  ],
  [
    [118.447262870858, 24.7594868675085, 0.000920327380299568],
    [118.446564101986, 24.7598252196193, 0.000920368358492851],
  ],
  [
    [118.447253604469, 24.7594709124402, 0.000920325517654419],
    [118.446554835669, 24.7598092735361, 0.000920367427170277],
  ],
  [
    [118.447244338083, 24.7594549573713, 0.000920320861041546],
    [118.446545579233, 24.7597933184182, 0.000920364633202553],
  ],
  [
    [118.447235081594, 24.7594390113232, 0.00092032179236412],
    [118.446536312914, 24.759777363306, 0.000920361839234829],
  ],
  [
    [118.447225815213, 24.7594230562531, 0.000920319929718971],
    [118.446527046603, 24.7597614172209, 0.000920361839234829],
  ],
  [
    [118.447216548841, 24.7594071102101, 0.000920316204428673],
    [118.446517780289, 24.7597454621075, 0.00092035811394453],
  ],
  [
    [118.447207282464, 24.7593911551388, 0.000920315273106098],
    [118.44650852387, 24.7597295160149, 0.00092035811394453],
  ],
  [
    [118.447198025984, 24.7593752090882, 0.000920313410460949],
    [118.446499257559, 24.7597135609002, 0.000920355319976807],
  ],
  [
    [118.447188759613, 24.7593592540156, 0.000920310616493225],
    [118.446489991252, 24.759697605785, 0.000920352526009083],
  ],
  [
    [118.447179493243, 24.7593432989424, 0.000920308753848076],
    [118.446480724953, 24.7596816596969, 0.000920351594686508],
  ],
  [
    [118.447170226883, 24.7593273528964, 0.000920306891202927],
    [118.446471468537, 24.759665704574, 0.000920349732041359],
  ],
  [
    [118.447160970406, 24.7593113978156, 0.000920304097235203],
    [118.446462202243, 24.7596497584847, 0.000920346938073635],
  ],
  [
    [118.44715170405, 24.7592954517683, 0.000920303165912628],
    [118.446452935945, 24.759633803367, 0.00092034600675106],
  ],
  [
    [118.447142437691, 24.7592794966927, 0.000920300371944904],
    [118.446443669656, 24.7596178572764, 0.000920343212783337],
  ],
  [
    [118.44713318122, 24.75926354161, 0.000920298509299755],
    [118.446434413249, 24.7596019021511, 0.000920341350138187],
  ],
  [
    [118.447123914872, 24.7592475955609, 0.00092029757797718],
    [118.446425146958, 24.7595859470316, 0.000920339487493038],
  ],
  [
    [118.447114648519, 24.7592316404835, 0.000920293852686882],
    [118.446415880676, 24.7595700009391, 0.000920337624847889],
  ],
  [
    [118.447105382176, 24.7592156944331, 0.000920292921364307],
    [118.446406624276, 24.759554045812, 0.00092033576220274],
  ],
  [
    [118.447096125715, 24.759199739348, 0.000920291058719158],
    [118.446397357999, 24.7595380997184, 0.00092033389955759],
  ],
  [
    [118.447086859369, 24.7591837842687, 0.000920289196074009],
    [118.446388091717, 24.7595221445964, 0.000920330174267292],
  ],
  [
    [118.447077593033, 24.7591678382165, 0.000920286402106285],
    [118.446378825438, 24.7595061894737, 0.000920329242944717],
  ],
  [
    [118.447068326692, 24.759151883136, 0.000920286402106285],
    [118.446369569055, 24.7594902433719, 0.000920327380299568],
  ],
  [
    [118.447059070248, 24.7591359370762, 0.000920282676815987],
    [118.44636030278, 24.759474288248, 0.000920324586331844],
  ],
  [
    [118.447049803912, 24.7591199819944, 0.000920279882848263],
    [118.446351036515, 24.7594583421513, 0.00092032365500927],
  ],
  [
    [118.447040537578, 24.759104026912, 0.000920278951525688],
    [118.446341770245, 24.7594423870263, 0.000920320861041546],
  ],
  [
    [118.447031271254, 24.7590880808568, 0.000920277088880539],
    [118.446332513864, 24.7594264318942, 0.000920318067073822],
  ],
  [
    [118.447022014811, 24.7590721257668, 0.000920274294912815],
    [118.446323247606, 24.7594104857956, 0.000920317135751247],
  ],
  [
    [118.447012748492, 24.7590561797103, 0.00092027336359024],
    [118.446313981343, 24.7593945306687, 0.000920313410460949],
  ],
  [
    [118.447003482168, 24.7590402246255, 0.000920270569622517],
    [118.44630471509, 24.759378584569, 0.000920313410460949],
  ],
  [
    [118.446994215846, 24.75902426954, 0.000920268706977367],
    [118.446295458719, 24.7593626294345, 0.000920310616493225],
  ],
  [
    [118.44698495942, 24.7590083234753, 0.000920265913009644],
    [118.446286192463, 24.7593466743057, 0.00092030968517065],
  ],
  [
    [118.446975693103, 24.7589923683886, 0.000920264050364494],
    [118.446276926217, 24.7593307282041, 0.000920305959880352],
  ],
  [
    [118.446966426795, 24.7589764223291, 0.00092026311904192],
    [118.446267659966, 24.7593147730741, 0.000920304097235203],
  ],
  [
    [118.446957160483, 24.7589604672411, 0.00092026311904192],
    [118.446258403611, 24.7592988269649, 0.000920303165912628],
  ],
  [
    [118.44694790406, 24.7589445121462, 0.000920257531106472],
    [118.446249137365, 24.7592828718337, 0.000920301303267479],
  ],
  [
    [118.446938637759, 24.7589285660848, 0.000920255668461323],
    [118.446239871121, 24.7592669167018, 0.00092029944062233],
  ],
  [
    [118.446929371454, 24.7589126109951, 0.000920253805816174],
    [118.446230604887, 24.7592509705971, 0.000920296646654606],
  ],
  [
    [118.446920115045, 24.7588966649261, 0.00092025101184845],
    [118.446221348534, 24.7592350154577, 0.000920294784009457],
  ],
  [
    [118.446910848744, 24.7588807098351, 0.00092025101184845],
    [118.446212082305, 24.7592190693518, 0.000920292921364307],
  ],
  [
    [118.446901582446, 24.7588647547435, 0.0009202491492033],
    [118.446202816071, 24.7592031142175, 0.000920291990041733],
  ],
  [
    [118.446892316157, 24.758848808679, 0.000920246355235577],
    [118.446193559725, 24.7591871590762, 0.000920288264751434],
  ],
  [
    [118.446883059751, 24.7588328535798, 0.000920243561267853],
    [118.446184293503, 24.7591712129685, 0.000920286402106285],
  ],
  [
    [118.44687379346, 24.7588168984864, 0.000920241698622704],
    [118.446175027283, 24.7591552668601, 0.000920284539461136],
  ],
  [
    [118.446864527171, 24.7588009433923, 0.000920241698622704],
    [118.446165770951, 24.7591393207448, 0.000920283608138561],
  ],
  [
    [118.446855250998, 24.758784988304, 0.00092023704200983],
    [118.446156504736, 24.7591233746352, 0.000920280814170837],
  ],
  [
    [118.446845984714, 24.7587690332087, 0.000920235179364681],
    [118.44614724841, 24.7591074285186, 0.000920279882848263],
  ],
  [
    [118.446836718426, 24.7587530690851, 0.000920235179364681],
    [118.446137992092, 24.7590914914292, 0.000920277088880539],
  ],
  [
    [118.446827442253, 24.7587371049672, 0.000920232385396957],
    [118.446128725891, 24.7590755543455, 0.000920274294912815],
  ],
  [
    [118.446818166082, 24.7587211408487, 0.000920231454074383],
    [118.446119469579, 24.7590596172549, 0.000920274294912815],
  ],
  [
    [118.446808889914, 24.7587051767296, 0.000920227728784084],
    [118.446110213269, 24.7590436801636, 0.000920270569622517],
  ],
  [
    [118.446799613749, 24.7586892126099, 0.000920225866138935],
    [118.446100956968, 24.7590277520995, 0.000920269638299942],
  ],
  [
    [118.446790327692, 24.7586732394681, 0.00092022493481636],
    [118.44609170067, 24.7590118240348, 0.000920267775654793],
  ],
  [
    [118.446781051524, 24.7586572663194, 0.000920222140848637],
    [118.446082444374, 24.7589958959694, 0.000920266844332218],
  ],
  [
    [118.446771765479, 24.7586413022042, 0.000920219346880913],
    [118.446073178193, 24.7589799679098, 0.00092026311904192],
  ],
  [
    [118.446762469542, 24.7586253290671, 0.000920218415558338],
    [118.446063921909, 24.758964048871, 0.000920260325074196],
  ],
  [
    [118.446753183495, 24.7586093559229, 0.000920216552913189],
    [118.446054665627, 24.7589481298316, 0.000920258462429047],
  ],
  [
    [118.446743887556, 24.7585933737567, 0.00092021469026804],
    [118.446045409348, 24.7589322107916, 0.000920256599783897],
  ],
  [
    [118.446734591627, 24.7585774006177, 0.000920211896300316],
    [118.446036143191, 24.758916300785, 0.000920255668461323],
  ],
  [
    [118.4467252957, 24.758561427478, 0.000920209102332592],
    [118.446026886923, 24.7589003907716, 0.000920251943171024],
  ],
  [
    [118.446715989882, 24.7585454453164, 0.000920209102332592],
    [118.446017630657, 24.7588844807574, 0.00092025101184845],
  ],
  [
    [118.446706684066, 24.7585294631541, 0.000920206308364868],
    [118.446008364514, 24.7588685797768, 0.000920248217880726],
  ],
  [
    [118.44669737826, 24.758513490019, 0.000920205377042294],
    [118.445999098374, 24.7588526787956, 0.000920245423913002],
  ],
  [
    [118.446688072449, 24.7584975078555, 0.000920201651751995],
    [118.445989842122, 24.7588367778074, 0.000920244492590427],
  ],
  [
    [118.446678756754, 24.7584815256977, 0.000920201651751995],
    [118.445980575987, 24.7588208768249, 0.000920243561267853],
  ],
  [
    [118.446669431174, 24.7584655435457, 0.000920196995139122],
    [118.44597130986, 24.7588049848696, 0.000920240767300129],
  ],
  [
    [118.446660115484, 24.7584495613867, 0.000920196995139122],
    [118.445962043743, 24.7587891019414, 0.00092023890465498],
  ],
  [
    [118.446650789909, 24.7584335792335, 0.000920192338526249],
    [118.445952767735, 24.7587732099912, 0.000920236110687256],
  ],
  [
    [118.446641454443, 24.7584175880583, 0.000920192338526249],
    [118.445943501622, 24.7587573270618, 0.000920235179364681],
  ],
  [
    [118.446632128873, 24.7584016059038, 0.0009201904758811],
    [118.445934225625, 24.7587414441381, 0.000920233316719532],
  ],
  [
    [118.446622783533, 24.7583856237614, 0.00092018861323595],
    [118.445924949638, 24.7587255702415, 0.000920231454074383],
  ],
  [
    [118.446613448074, 24.7583696325843, 0.000920185819268227],
    [118.445915673653, 24.7587096963444, 0.000920228660106659],
  ],
  [
    [118.446604102738, 24.7583536504408, 0.000920184887945652],
    [118.445906397677, 24.7586938314744, 0.000920227728784084],
  ],
  [
    [118.446594747511, 24.7583376592751, 0.000920181162655354],
    [118.445897121697, 24.758677957576, 0.000920225866138935],
  ],
  [
    [118.446585392293, 24.7583216771367, 0.000920181162655354],
    [118.445887835846, 24.7586621017388, 0.000920224003493786],
  ],
  [
    [118.446576037071, 24.7583056859698, 0.000920177437365055],
    [118.44587854999, 24.7586462368733, 0.000920221209526062],
  ],
  [
    [118.446566671971, 24.7582897038365, 0.00092017650604248],
    [118.445869264144, 24.7586303810349, 0.000920218415558338],
  ],
  [
    [118.446557306867, 24.7582737126748, 0.000920175574719906],
    [118.445859978308, 24.7586145342236, 0.000920217484235764],
  ],
  [
    [118.446547931885, 24.7582577305465, 0.000920170918107033],
    [118.445850682587, 24.7585986874181, 0.000920215621590614],
  ],
  [
    [118.446538547013, 24.7582417393963, 0.000920169055461884],
    [118.445841386868, 24.7585828406119, 0.000920211896300316],
  ],
  [
    [118.44652916215, 24.7582257572732, 0.000920169055461884],
    [118.445832091158, 24.7585670028329, 0.000920209102332592],
  ],
  [
    [118.446519777282, 24.7582097661216, 0.000920165330171585],
    [118.445822795451, 24.7585511650533, 0.000920208171010017],
  ],
  [
    [118.446510382537, 24.7581937840036, 0.00092016439884901],
    [118.44581348986, 24.7585353272793, 0.000920206308364868],
  ],
  [
    [118.446500987787, 24.7581777928572, 0.000920161604881287],
    [118.445804184278, 24.7585194985325, 0.000920204445719719],
  ],
  [
    [118.44649158316, 24.7581618107443, 0.000920161604881287],
    [118.445794868819, 24.7585036788192, 0.000920203514397144],
  ],
  [
    [118.446482168642, 24.7581458196094, 0.000920157879590988],
    [118.445785563248, 24.7584878590989, 0.000920201651751995],
  ],
  [
    [118.446472754134, 24.7581298375016, 0.000920156016945839],
    [118.445776237907, 24.7584720393907, 0.000920198857784271],
  ],
  [
    [118.446463329734, 24.7581138463718, 0.000920155085623264],
    [118.445766922462, 24.7584562287033, 0.000920196063816547],
  ],
  [
    [118.446453895457, 24.7580978642754, 0.00092015229165554],
    [118.445757597132, 24.7584404180215, 0.000920195132493973],
  ],
  [
    [118.446444461183, 24.7580818821785, 0.000920149497687817],
    [118.445748271812, 24.7584246163669, 0.000920193269848824],
  ],
  [
    [118.446435026904, 24.7580658910531, 0.000920147635042667],
    [118.445738936607, 24.758408814718, 0.000920191407203674],
  ],
  [
    [118.446425582747, 24.7580499089612, 0.000920145772397518],
    [118.445729601412, 24.7583930220963, 0.0009201904758811],
  ],
  [
    [118.446416128707, 24.7580339268751, 0.000920143909752369],
    [118.445720266219, 24.7583772294739, 0.000920185819268227],
  ],
  [
    [118.446406664782, 24.7580179447946, 0.000920141115784645],
    [118.445710921148, 24.758361445885, 0.000920183956623077],
  ],
  [
    [118.44639720086, 24.7580019627136, 0.000920138321816921],
    [118.44570157608, 24.7583456622954, 0.000920183025300503],
  ],
  [
    [118.44638772706, 24.757985989666, 0.000920138321816921],
    [118.445692221135, 24.7583298877393, 0.000920180231332779],
  ],
  [
    [118.44637824337, 24.7579700075963, 0.000920135527849197],
    [118.445682866192, 24.7583141131826, 0.00092017836868763],
  ],
  [
    [118.446368759682, 24.7579540255261, 0.000920131802558899],
    [118.445673501372, 24.7582983476593, 0.000920177437365055],
  ],
  [
    [118.446359266116, 24.7579380524893, 0.000920131802558899],
    [118.445664136554, 24.7582825821354, 0.000920175574719906],
  ],
  [
    [118.44634976266, 24.7579220704304, 0.000920130871236324],
    [118.445654761859, 24.758266825645, 0.000920172780752182],
  ],
  [
    [118.446340259213, 24.7579060973987, 0.000920127145946026],
    [118.445645387166, 24.7582510691539, 0.000920170918107033],
  ],
  [
    [118.446330745882, 24.7578901243727, 0.000920126214623451],
    [118.445636012482, 24.7582353216899, 0.000920169986784458],
  ],
  [
    [118.446321222667, 24.7578741513524, 0.000920123420655727],
    [118.445626627922, 24.7582195832594, 0.000920167192816734],
  ],
  [
    [118.446311689567, 24.7578581783378, 0.000920121558010578],
    [118.445617233476, 24.7582038448346, 0.000920165330171585],
  ],
  [
    [118.446302146583, 24.7578422053289, 0.000920118764042854],
    [118.445607839041, 24.7581881154369, 0.000920162536203861],
  ],
  [
    [118.446292603609, 24.7578262413471, 0.00092011783272028],
    [118.44559843472, 24.7581723860449, 0.000920161604881287],
  ],
  [
    [118.446283050744, 24.7578102683433, 0.000920115038752556],
    [118.445589030403, 24.7581566566523, 0.000920158810913563],
  ],
  [
    [118.446273488001, 24.7577943043729, 0.000920114107429981],
    [118.445579616215, 24.7581409453208, 0.000920157879590988],
  ],
  [
    [118.446263915375, 24.7577783404083, 0.000920111313462257],
    [118.445570202029, 24.7581252339888, 0.000920156016945839],
  ],
  [
    [118.446254342751, 24.7577623764429, 0.000920109450817108],
    [118.445560777959, 24.7581095226623, 0.00092015229165554],
  ],
  [
    [118.446244760249, 24.7577464215111, 0.000920107588171959],
    [118.445551344011, 24.7580938203694, 0.00092015229165554],
  ],
  [
    [118.44623515797, 24.7577304575635, 0.00092010572552681],
    [118.445541910073, 24.7580781271035, 0.000920149497687817],
  ],
  [
    [118.446225555701, 24.757714502643, 0.00092010386288166],
    [118.445532466251, 24.7580624338433, 0.000920148566365242],
  ],
  [
    [118.446215943547, 24.7576985477282, 0.000920102000236511],
    [118.445523022438, 24.7580467496103, 0.000920145772397518],
  ],
  [
    [118.446206331396, 24.7576825928128, 0.000920100137591362],
    [118.445513568748, 24.7580310744106, 0.000920142978429794],
  ],
  [
    [118.446196699474, 24.7576666379094, 0.000920097343623638],
    [118.445504105173, 24.7580153992167, 0.00092014204710722],
  ],
  [
    [118.446187057675, 24.7576506920394, 0.000920096412301064],
    [118.445494641608, 24.7579997330498, 0.00092014018446207],
  ],
  [
    [118.446177415872, 24.757634737141, 0.000920092687010765],
    [118.445485168166, 24.7579840759164, 0.000920137390494347],
  ],
  [
    [118.446167754304, 24.7576187912824, 0.000920092687010765],
    [118.445475684839, 24.7579684187887, 0.000920133665204048],
  ],
  [
    [118.446158092747, 24.7576028544509, 0.000920088961720467],
    [118.445466201514, 24.7579527616603, 0.000920133665204048],
  ],
  [
    [118.446148421298, 24.7575869085973, 0.000920088961720467],
    [118.44545670832, 24.7579371225931, 0.000920130871236324],
  ],
  [
    [118.446138739972, 24.7575709717772, 0.000920087099075317],
    [118.445447205241, 24.7579214835315, 0.00092012993991375],
  ],
  [
    [118.446129038875, 24.7575550349691, 0.000920084305107594],
    [118.445437692284, 24.7579058535034, 0.0009201280772686],
  ],
  [
    [118.446119337781, 24.7575390981603, 0.000920082442462444],
    [118.44542817933, 24.7578902234746, 0.000920126214623451],
  ],
  [
    [118.44610962681, 24.7575231703849, 0.000920080579817295],
    [118.445418656499, 24.7578746024792, 0.000920124351978302],
  ],
  [
    [118.446099905947, 24.7575072335875, 0.000920078717172146],
    [118.445409123791, 24.7578589905172, 0.000920121558010578],
  ],
  [
    [118.446090175215, 24.7574913148512, 0.000920075923204422],
    [118.445399591091, 24.7578433875824, 0.000920120626688004],
  ],
  [
    [118.446080424705, 24.7574753870992, 0.000920073129236698],
    [118.445390048508, 24.7578277846532, 0.000920116901397705],
  ],
  [
    [118.446070674204, 24.7574594683743, 0.000920072197914124],
    [118.445380496047, 24.7578121907574, 0.00092011597007513],
  ],
  [
    [118.44606091382, 24.757443549655, 0.0009200694039464],
    [118.445370933709, 24.757796605895, 0.000920114107429981],
  ],
  [
    [118.446051143551, 24.7574276309414, 0.00092006754130125],
    [118.445361361487, 24.7577810210382, 0.000920111313462257],
  ],
  [
    [118.446041353519, 24.7574117212676, 0.000920064747333527],
    [118.445351789274, 24.7577654452086, 0.000920109450817108],
  ],
  [
    [118.446031563482, 24.7573958025653, 0.000920062884688377],
    [118.445342207184, 24.7577498784123, 0.000920107588171959],
  ],
  [
    [118.446021753688, 24.7573799019305, 0.000920061953365803],
    [118.445332615209, 24.7577343116217, 0.000920106656849384],
  ],
  [
    [118.44601194389, 24.7573639922673, 0.000920061022043228],
    [118.445323013365, 24.7577187628923, 0.00092010386288166],
  ],
  [
    [118.446002114329, 24.7573480916438, 0.00092005729675293],
    [118.445313401636, 24.7577032141685, 0.000920102000236511],
  ],
  [
    [118.44599227489, 24.7573322000537, 0.00092005543410778],
    [118.445303789916, 24.7576876744718, 0.000920100137591362],
  ],
  [
    [118.44598242556, 24.7573162994416, 0.000920053571462631],
    [118.445294158425, 24.757672134787, 0.000920098274946213],
  ],
  [
    [118.445972566353, 24.7573004078628, 0.000920051708817482],
    [118.445284526951, 24.7576566131571, 0.000920095480978489],
  ],
  [
    [118.44596269727, 24.7572845253174, 0.000920048914849758],
    [118.445274885593, 24.7576410915328, 0.000920094549655914],
  ],
  [
    [118.445952818302, 24.7572686427777, 0.000920047983527184],
    [118.445265234357, 24.7576255789419, 0.00092009175568819],
  ],
  [
    [118.445942919563, 24.7572527602499, 0.00092004518955946],
    [118.445255573237, 24.7576100663566, 0.000920088961720467],
  ],
  [
    [118.445933010941, 24.7572368777278, 0.00092004332691431],
    [118.445245902247, 24.7575945718324, 0.000920088961720467],
  ],
  [
    [118.445923092441, 24.757221004239, 0.000920042395591736],
    [118.445236221372, 24.7575790773139, 0.000920087099075317],
  ],
  [
    [118.445913164065, 24.7572051397837, 0.000920040532946587],
    [118.445226540507, 24.7575635918225, 0.000920086167752743],
  ],
  [
    [118.445903225797, 24.7571892663062, 0.000920036807656288],
    [118.445216839878, 24.7575481153707, 0.000920083373785019],
  ],
  [
    [118.445893267773, 24.7571734108962, 0.000920034945011139],
    [118.445207129372, 24.7575326479523, 0.00092008151113987],
  ],
  [
    [118.445883309744, 24.7571575464577, 0.00092003308236599],
    [118.445197418868, 24.7575171805333, 0.000920078717172146],
  ],
  [
    [118.445873331952, 24.757141691059, 0.00092003121972084],
    [118.445187688607, 24.7575017311816, 0.000920078717172146],
  ],
  [
    [118.445863344283, 24.7571258446936, 0.000920030288398266],
    [118.445177958349, 24.7574862818293, 0.000920074060559273],
  ],
  [
    [118.445853336843, 24.7571099983402, 0.000920027494430542],
    [118.445168208327, 24.7574708415167, 0.000920073129236698],
  ],
  [
    [118.445843319519, 24.7570941519924, 0.000920025631785393],
    [118.445158458314, 24.7574554102311, 0.000920071266591549],
  ],
  [
    [118.445833292319, 24.7570783146779, 0.000920024700462818],
    [118.445148688537, 24.7574399879851, 0.0009200694039464],
  ],
  [
    [118.445823255234, 24.7570624773691, 0.000920021906495094],
    [118.445138918763, 24.7574245657385, 0.00092006754130125],
  ],
  [
    [118.445813198385, 24.7570466491, 0.00092001911252737],
    [118.445129129231, 24.7574091615593, 0.000920064747333527],
  ],
  [
    [118.445803131653, 24.7570308208364, 0.000920017249882221],
    [118.445119339703, 24.7573937573794, 0.000920063816010952],
  ],
  [
    [118.445793055044, 24.7570150016062, 0.000920014455914497],
    [118.445109530417, 24.7573783712669, 0.000920061953365803],
  ],
  [
    [118.445782968551, 24.7569991823817, 0.000920013524591923],
    [118.445099711247, 24.75736298516, 0.000920058228075504],
  ],
  [
    [118.445772862294, 24.7569833721968, 0.000920012593269348],
    [118.4450898822, 24.7573476080865, 0.000920058228075504],
  ],
  [
    [118.445762736266, 24.7569675620238, 0.000920010730624199],
    [118.445080053162, 24.75733224004, 0.000920056365430355],
  ],
  [
    [118.445752610249, 24.7569517608779, 0.0009200070053339],
    [118.445070204361, 24.7573168810332, 0.000920053571462631],
  ],
  [
    [118.44574246446, 24.7569359597438, 0.000920006074011326],
    [118.445060345682, 24.7573015310597, 0.000920051708817482],
  ],
  [
    [118.445732298909, 24.7569201676495, 0.000920003280043602],
    [118.445050477119, 24.7572861810918, 0.000920050777494907],
  ],
  [
    [118.445722133366, 24.7569043845821, 0.000920002348721027],
    [118.445040588799, 24.7572708491912, 0.000920048914849758],
  ],
  [
    [118.44571193816, 24.7568885925053, 0.000920000486075878],
    [118.445030700488, 24.7572555263177, 0.00092004518955946],
  ],
  [
    [118.44570174297, 24.7568728184832, 0.000919997692108154],
    [118.445020792407, 24.7572402034561, 0.00092004332691431],
  ],
  [
    [118.44569152801, 24.756857044473, 0.000919995829463005],
    [118.445010884342, 24.7572248986493, 0.000920041464269161],
  ],
  [
    [118.445681293286, 24.7568412795024, 0.00091999489814043],
    [118.445000956506, 24.7572095938544, 0.000920041464269161],
  ],
  [
    [118.445671048679, 24.7568255145374, 0.000919992104172707],
    [118.4449910188, 24.7571943071205, 0.000920038670301437],
  ],
  [
    [118.445660794194, 24.7568097586058, 0.000919991172850132],
    [118.44498107121, 24.7571790203922, 0.000920035876333714],
  ],
  [
    [118.445650519939, 24.756794002686, 0.000919989310204983],
    [118.444971113743, 24.7571637426973, 0.000920034013688564],
  ],
  [
    [118.445640235807, 24.7567782557996, 0.000919986516237259],
    [118.444961136519, 24.7571484830697, 0.000920034013688564],
  ],
  [
    [118.445629931905, 24.756762508925, 0.00091998465359211],
    [118.444951159297, 24.7571332234414, 0.00092003121972084],
  ],
  [
    [118.445619618132, 24.7567467801115, 0.000919983722269535],
    [118.444941162318, 24.7571179818804, 0.000920028425753117],
  ],
  [
    [118.445609284582, 24.7567310422822, 0.000919980928301811],
    [118.444931155455, 24.757102740325, 0.000920025631785393],
  ],
  [
    [118.445598941163, 24.7567153225139, 0.000919979065656662],
    [118.444921128829, 24.7570875078092, 0.000920023769140244],
  ],
  [
    [118.445588577972, 24.7566996027574, 0.000919976271688938],
    [118.444911102218, 24.7570722933482, 0.000920022837817669],
  ],
  [
    [118.445578204898, 24.7566838830065, 0.000919975340366364],
    [118.444901055837, 24.757057078899, 0.00092002097517252],
  ],
  [
    [118.445567812068, 24.756668181323, 0.000919971615076065],
    [118.444890999586, 24.7570418825109, 0.00092001911252737],
  ],
  [
    [118.445557399467, 24.7566524796513, 0.000919971615076065],
    [118.444880933451, 24.7570266861283, 0.000920018181204796],
  ],
  [
    [118.445546976982, 24.7566367779852, 0.000919967889785767],
    [118.444870847558, 24.7570115078131, 0.000920015387237072],
  ],
  [
    [118.445536544627, 24.7566210943801, 0.000919966027140617],
    [118.444860751782, 24.7569963295034, 0.000920012593269348],
  ],
  [
    [118.445526092502, 24.7566054107869, 0.000919964164495468],
    [118.444850646136, 24.7569811692547, 0.000920011661946774],
  ],
  [
    [118.445515620613, 24.7565897362333, 0.000919963233172894],
    [118.444840530612, 24.7569660180394, 0.00092000886797905],
  ],
  [
    [118.445505128954, 24.7565740616915, 0.000919961370527744],
    [118.444830395324, 24.7569508758636, 0.000920007936656475],
  ],
  [
    [118.445494627418, 24.756558396183, 0.000919956713914871],
    [118.444820250152, 24.7569357336933, 0.000920005142688751],
  ],
  [
    [118.445484116005, 24.7565427397077, 0.000919955782592297],
    [118.444810085224, 24.7569206095904, 0.000920004211366177],
  ],
  [
    [118.445473584822, 24.7565270832443, 0.000919954851269722],
    [118.444799920312, 24.7569055035423, 0.000920001417398453],
  ],
  [
    [118.445463033882, 24.7565114448483, 0.000919952057301998],
    [118.444789735629, 24.7568903975059, 0.000919999554753304],
  ],
  [
    [118.445452463172, 24.756495806464, 0.000919951125979424],
    [118.444779531182, 24.7568753005091, 0.000920000486075878],
  ],
  [
    [118.445441882578, 24.7564801680853, 0.000919947400689125],
    [118.444769326752, 24.756860221567, 0.000919995829463005],
  ],
  [
    [118.445431282228, 24.7564645477738, 0.000919947400689125],
    [118.444759092664, 24.756845142643, 0.000919993966817856],
  ],
  [
    [118.445420662107, 24.7564489274742, 0.000919944606721401],
    [118.444748858593, 24.7568300817738, 0.000919992104172707],
  ],
  [
    [118.445410032109, 24.7564333162079, 0.000919941812753677],
    [118.444738604758, 24.7568150299441, 0.000919990241527557],
  ],
  [
    [118.445399382348, 24.7564177139811, 0.000919940881431103],
    [118.444728341046, 24.7567999871477, 0.000919990241527557],
  ],
  [
    [118.445388712824, 24.7564021207938, 0.000919939018785954],
    [118.44471805757, 24.7567849533908, 0.000919987447559834],
  ],
  [
    [118.445378033416, 24.7563865276121, 0.000919937156140804],
    [118.444707764217, 24.7567699286671, 0.00091998279094696],
  ],
  [
    [118.445367334244, 24.7563709434699, 0.000919935293495655],
    [118.444697451108, 24.7567549220108, 0.00091998465359211],
  ],
  [
    [118.445356615309, 24.7563553683672, 0.000919932499527931],
    [118.444687128114, 24.7567399153599, 0.000919981859624386],
  ],
  [
    [118.445345876611, 24.7563398023041, 0.000919931568205357],
    [118.44467679525, 24.7567249267701, 0.000919978134334087],
  ],
  [
    [118.445335128036, 24.7563242452742, 0.000919929705560207],
    [118.444666442622, 24.7567099472197, 0.000919978134334087],
  ],
  [
    [118.445324359691, 24.7563086882561, 0.000919927842915058],
    [118.444656080117, 24.7566949767027, 0.000919974409043789],
  ],
  [
    [118.445313571589, 24.7562931493053, 0.00091992411762476],
    [118.444645697855, 24.7566800242528, 0.000919973477721214],
  ],
  [
    [118.445302763717, 24.7562776103662, 0.000919923186302185],
    [118.444635305716, 24.7566650808363, 0.000919971615076065],
  ],
  [
    [118.445291936081, 24.7562620804667, 0.000919921323657036],
    [118.444624893813, 24.7566501464592, 0.000919969752430916],
  ],
  [
    [118.445281098569, 24.7562465596004, 0.000919921323657036],
    [118.444614472034, 24.7566352211153, 0.000919967889785767],
  ],
  [
    [118.445270241287, 24.7562310387458, 0.000919917598366737],
    [118.44460403049, 24.756620304811, 0.000919966958463192],
  ],
  [
    [118.445259364248, 24.7562155359585, 0.000919915735721588],
    [118.444593579077, 24.7566054065676, 0.000919964164495468],
  ],
  [
    [118.445248467445, 24.7562000422107, 0.000919912941753864],
    [118.444583107892, 24.756590508336, 0.000919963233172894],
  ],
  [
    [118.44523755088, 24.7561845575024, 0.000919911079108715],
    [118.444572626838, 24.7565756281654, 0.000919959507882595],
  ],
  [
    [118.445226624431, 24.7561690727995, 0.00091991014778614],
    [118.44456212602, 24.7565607570342, 0.000919959507882595],
  ],
  [
    [118.445215678225, 24.7561536061639, 0.000919908285140991],
    [118.444551605438, 24.7565458949425, 0.000919956713914871],
  ],
  [
    [118.445204722142, 24.7561381485615, 0.000919907353818417],
    [118.444541074979, 24.756531041884, 0.000919954851269722],
  ],
  [
    [118.445193736417, 24.7561227090326, 0.000919901765882969],
    [118.444530524757, 24.756516197865, 0.000919952988624573],
  ],
  [
    [118.445182740808, 24.7561072695092, 0.000919902697205544],
    [118.44451995477, 24.7565013628854, 0.000919951125979424],
  ],
  [
    [118.445171725435, 24.7560918390252, 0.000919900834560394],
    [118.444509374914, 24.7564865459668, 0.000919950194656849],
  ],
  [
    [118.445160700193, 24.7560764266022, 0.000919897109270096],
    [118.444498775287, 24.7564717290599, 0.000919947400689125],
  ],
  [
    [118.44514965518, 24.7560610141909, 0.000919897109270096],
    [118.444488155897, 24.7564569211925, 0.000919944606721401],
  ],
  [
    [118.445138590411, 24.7560456198468, 0.000919893383979797],
    [118.444477526636, 24.756442131386, 0.000919944606721401],
  ],
  [
    [118.445127505879, 24.7560302345422, 0.000919892452657223],
    [118.444466877605, 24.7564273415912, 0.000919941812753677],
  ],
  [
    [118.44511641147, 24.7560148582707, 0.000919889658689499],
    [118.444456218703, 24.7564125698573, 0.000919939950108528],
  ],
  [
    [118.445105297297, 24.7559994910387, 0.000919886864721775],
    [118.444445540031, 24.7563977981351, 0.000919939018785954],
  ],
  [
    [118.445094163362, 24.7559841328462, 0.000919886864721775],
    [118.444434841603, 24.7563830444801, 0.00091993622481823],
  ],
  [
    [118.445083019549, 24.7559687836868, 0.000919884070754051],
    [118.444424133297, 24.7563682998583, 0.000919933430850506],
  ],
  [
    [118.44507185598, 24.7559534525946, 0.000919882208108902],
    [118.444413405228, 24.7563535642759, 0.00091993436217308],
  ],
  [
    [118.445060672642, 24.7559381215141, 0.000919880345463753],
    [118.444402657395, 24.756338837733, 0.000919931568205357],
  ],
  [
    [118.445049479433, 24.7559228084945, 0.000919879414141178],
    [118.444391899685, 24.7563241202232, 0.000919928774237633],
  ],
  [
    [118.445038256574, 24.7559075045206, 0.000919876620173454],
    [118.444381122211, 24.7563094117528, 0.000919926911592484],
  ],
  [
    [118.445027033725, 24.7558922095736, 0.00091987568885088],
    [118.444370334861, 24.7562947123156, 0.000919925980269909],
  ],
  [
    [118.445015781227, 24.7558769236723, 0.000919872894883156],
    [118.444359527746, 24.7562800219178, 0.000919923186302185],
  ],
  [
    [118.445004518851, 24.7558616468042, 0.000919870100915432],
    [118.444348700875, 24.7562653495872, 0.000919921323657036],
  ],
  [
    [118.444993236712, 24.7558463789754, 0.000919868238270283],
    [118.44433786412, 24.756250677262, 0.000919920392334461],
  ],
  [
    [118.444981934817, 24.7558311292138, 0.000919867306947708],
    [118.444327007609, 24.7562360230039, 0.000919917598366737],
  ],
  [
    [118.444970623046, 24.7558158884854, 0.00091986358165741],
    [118.444316131327, 24.7562213687574, 0.000919917598366737],
  ],
  [
    [118.444959291504, 24.7558006477686, 0.00091986358165741],
    [118.444305245175, 24.7562067325719, 0.000919914804399014],
  ],
  [
    [118.444947950092, 24.7557854251127, 0.000919859856367111],
    [118.444294339259, 24.7561921054257, 0.00091991201043129],
  ],
  [
    [118.444936579031, 24.7557702115024, 0.000919859856367111],
    [118.444283423466, 24.7561774873127, 0.000919911079108715],
  ],
  [
    [118.444925198092, 24.7557550069253, 0.000919857062399387],
    [118.44427248791, 24.7561628782391, 0.000919908285140991],
  ],
  [
    [118.444913807284, 24.755739820409, 0.000919856131076813],
    [118.44426153259, 24.7561482782048, 0.000919907353818417],
  ],
  [
    [118.44490238682, 24.7557246339107, 0.000919853337109089],
    [118.444250567393, 24.7561336872037, 0.000919904559850693],
  ],
  [
    [118.444890956485, 24.7557094654732, 0.00091985147446394],
    [118.444239582439, 24.7561191142697, 0.000919901765882969],
  ],
  [
    [118.444879516274, 24.7556943060688, 0.00091984961181879],
    [118.444228577715, 24.7561045413473, 0.000919902697205544],
  ],
  [
    [118.444868046413, 24.75567915571, 0.000919845886528492],
    [118.444217563121, 24.7560899864858, 0.00091989990323782],
  ],
  [
    [118.444856566675, 24.7556640143844, 0.000919845886528492],
    [118.444206528756, 24.7560754316359, 0.000919896177947521],
  ],
  [
    [118.444845067174, 24.7556488820981, 0.000919844023883343],
    [118.444195484521, 24.7560608948469, 0.000919894315302372],
  ],
  [
    [118.444833557797, 24.7556337588449, 0.000919843092560768],
    [118.444184420523, 24.7560463670972, 0.000919892452657223],
  ],
  [
    [118.444822028663, 24.7556186536589, 0.000919841229915619],
    [118.444173346648, 24.7560318483806, 0.000919891521334648],
  ],
  [
    [118.444810479766, 24.7556035575121, 0.00091983750462532],
    [118.444162253009, 24.7560173387034, 0.000919890590012074],
  ],
  [
    [118.444798920992, 24.7555884703985, 0.000919836573302746],
    [118.444151139613, 24.7560028470933, 0.000919888727366924],
  ],
  [
    [118.444787342455, 24.7555733923242, 0.000919833779335022],
    [118.444140016334, 24.7559883554885, 0.00091988779604435],
  ],
  [
    [118.444775744154, 24.7555583232893, 0.000919832848012447],
    [118.444128873298, 24.7559738819508, 0.000919885002076626],
  ],
  [
    [118.444764135978, 24.7555432632874, 0.000919831916689873],
    [118.444117710491, 24.7559594084246, 0.000919883139431477],
  ],
  [
    [118.444752508044, 24.7555282213526, 0.000919828191399574],
    [118.444106537815, 24.7559449529594, 0.000919881276786327],
  ],
  [
    [118.444740860348, 24.7555131884571, 0.000919827260077],
    [118.444095345374, 24.7559305065334, 0.000919879414141178],
  ],
  [
    [118.444729192881, 24.7554981555732, 0.000919824466109276],
    [118.444084143057, 24.7559160691405, 0.000919877551496029],
  ],
  [
    [118.444717515552, 24.7554831497779, 0.000919822603464127],
    [118.444072920977, 24.755901640787, 0.00091987568885088],
  ],
  [
    [118.444705828339, 24.7554681439879, 0.000919820740818977],
    [118.444061689019, 24.7558872214665, 0.000919874757528305],
  ],
  [
    [118.444694111476, 24.7554531472434, 0.000919819809496403],
    [118.444050427418, 24.7558728202193, 0.000919871032238007],
  ],
  [
    [118.444682384744, 24.7554381685598, 0.000919817015528679],
    [118.44403916582, 24.7558584189712, 0.000919870100915432],
  ],
  [
    [118.444670648135, 24.7554231989092, 0.000919816084206104],
    [118.444027884465, 24.7558440357902, 0.000919868238270283],
  ],
  [
    [118.444658881876, 24.7554082383042, 0.000919814221560955],
    [118.444016583347, 24.7558296616484, 0.000919865444302559],
  ],
  [
    [118.444647105741, 24.7553932867322, 0.00091981329023838],
    [118.444005262465, 24.7558152965459, 0.000919864512979984],
  ],
  [
    [118.444635319729, 24.7553783441932, 0.000919809564948082],
    [118.443993931707, 24.7558009404765, 0.000919862650334835],
  ],
  [
    [118.44462351396, 24.7553634197213, 0.000919808633625507],
    [118.443982591071, 24.7557865934402, 0.000919860787689686],
  ],
  [
    [118.444611688429, 24.7553485042887, 0.000919805839657784],
    [118.443971220785, 24.7557722554494, 0.000919859856367111],
  ],
  [
    [118.444599843134, 24.7553335978953, 0.000919805839657784],
    [118.443959850516, 24.7557579355131, 0.000919857993721962],
  ],
  [
    [118.444587987963, 24.755318700535, 0.000919802114367485],
    [118.44394845059, 24.7557436155946, 0.000919856131076813],
  ],
  [
    [118.444576113028, 24.755303812214, 0.000919800251722336],
    [118.443937040793, 24.7557293137369, 0.000919856131076813],
  ],
  [
    [118.444564228217, 24.7552889329259, 0.000919798389077187],
    [118.44392562112, 24.7557150209123, 0.00091985147446394],
  ],
  [
    [118.444552313763, 24.7552740717112, 0.000919795595109463],
    [118.443914181683, 24.7557007371269, 0.000919850543141365],
  ],
  [
    [118.444540399319, 24.7552592195232, 0.000919794663786888],
    [118.44390272249, 24.7556864714085, 0.000919848680496216],
  ],
  [
    [118.444528455225, 24.7552443763807, 0.000919792801141739],
    [118.443891253413, 24.7556722056954, 0.000919846817851067],
  ],
  [
    [118.444516501262, 24.755229551299, 0.00091979093849659],
    [118.443879764579, 24.7556579580493, 0.000919844023883343],
  ],
  [
    [118.444504527528, 24.7552147262287, 0.000919788144528866],
    [118.443868255975, 24.7556437104146, 0.000919843092560768],
  ],
  [
    [118.444492543925, 24.7551999192192, 0.000919787213206291],
    [118.443856737501, 24.7556294808408, 0.000919841229915619],
  ],
  [
    [118.444480540559, 24.755185121249, 0.000919785350561142],
    [118.44384520915, 24.7556152603, 0.000919838435947895],
  ],
  [
    [118.444468527316, 24.7551703323117, 0.000919784419238567],
    [118.443833661042, 24.7556010578262, 0.000919838435947895],
  ],
  [
    [118.444456484423, 24.7551555524199, 0.000919782556593418],
    [118.443822093164, 24.7555868553638, 0.000919835641980171],
  ],
  [
    [118.444444431661, 24.7551407905889, 0.000919779762625694],
    [118.443810515409, 24.7555726619345, 0.000919833779335022],
  ],
  [
    [118.444432369022, 24.7551260377908, 0.000919777899980545],
    [118.443798917897, 24.7555584865721, 0.000919831916689873],
  ],
  [
    [118.44442028662, 24.755111294032, 0.00091977696865797],
    [118.443787310508, 24.7555443202428, 0.000919830054044724],
  ],
  [
    [118.444408184455, 24.7550965593124, 0.000919774174690247],
    [118.443775683356, 24.7555301629527, 0.000919829122722149],
  ],
  [
    [118.444396072413, 24.7550818336257, 0.000919774174690247],
    [118.443764036441, 24.7555160147018, 0.000919827260077],
  ],
  [
    [118.444383940615, 24.7550671260061, 0.000919769518077374],
    [118.443752379655, 24.7555018845116, 0.000919826328754425],
  ],
  [
    [118.444371789054, 24.7550524274256, 0.000919768586754799],
    [118.4437407031, 24.7554877543329, 0.000919822603464127],
  ],
  [
    [118.444359627616, 24.755037737878, 0.000919767655432224],
    [118.443729016674, 24.7554736422149, 0.000919820740818977],
  ],
  [
    [118.444347446415, 24.7550230573697, 0.000919765792787075],
    [118.443717310484, 24.7554595391361, 0.000919820740818977],
  ],
  [
    [118.444335245458, 24.7550083949283, 0.000919763930141926],
    [118.443705594418, 24.7554454450903, 0.000919817946851254],
  ],
  [
    [118.444323034624, 24.7549937415199, 0.000919762067496777],
    [118.443693858589, 24.7554313600837, 0.000919817015528679],
  ],
  [
    [118.444310813914, 24.7549790971444, 0.000919759273529053],
    [118.443682112889, 24.7554172931379, 0.00091981329023838],
  ],
  [
    [118.444298563554, 24.7549644618144, 0.000919757410883904],
    [118.443670347425, 24.7554032352312, 0.00091981329023838],
  ],
  [
    [118.444286303324, 24.754949844545, 0.000919757410883904],
    [118.443658562192, 24.7553891773359, 0.000919811427593231],
  ],
  [
    [118.444274033211, 24.7549352272808, 0.000919755548238754],
    [118.443646767088, 24.7553751375014, 0.000919807702302933],
  ],
  [
    [118.444261733455, 24.7549206280898, 0.00091975275427103],
    [118.443634962115, 24.7553611157276, 0.000919809564948082],
  ],
  [
    [118.444249433709, 24.7549060379254, 0.000919750891625881],
    [118.443623127484, 24.7553470939714, 0.000919805839657784],
  ],
  [
    [118.444237104321, 24.7548914658342, 0.000919749028980732],
    [118.44361129287, 24.7553330902697, 0.000919803977012634],
  ],
  [
    [118.444224765056, 24.754876902776, 0.000919747166335583],
    [118.4435994286, 24.7553190865856, 0.00091980304569006],
  ],
  [
    [118.444212406027, 24.7548623487569, 0.000919744372367859],
    [118.443587564345, 24.755305100956, 0.000919800251722336],
  ],
  [
    [118.444200037122, 24.7548478037707, 0.000919743441045284],
    [118.443575670448, 24.7552911333996, 0.000919799320399761],
  ],
  [
    [118.444187648455, 24.7548332678236, 0.000919741578400135],
    [118.443563766667, 24.7552771658483, 0.000919796526432037],
  ],
  [
    [118.444175249917, 24.7548187499372, 0.000919738784432411],
    [118.443551853016, 24.7552632163577, 0.000919795595109463],
  ],
  [
    [118.444162831616, 24.75480424109, 0.000919737853109837],
    [118.443539919594, 24.7552492668785, 0.000919793732464314],
  ],
  [
    [118.444150393552, 24.7547897412819, 0.000919735990464687],
    [118.443527966416, 24.7552353354662, 0.000919791869819164],
  ],
  [
    [118.444137945612, 24.7547752505066, 0.000919735059142113],
    [118.443516003368, 24.7552214221146, 0.000919790007174015],
  ],
  [
    [118.444125477915, 24.7547607777983, 0.000919732265174389],
    [118.443504030436, 24.7552075087682, 0.000919786281883717],
  ],
  [
    [118.444113000342, 24.7547463141228, 0.000919729471206665],
    [118.443492027862, 24.7551936134948, 0.000919786281883717],
  ],
  [
    [118.444100503006, 24.7547318594865, 0.000919729471206665],
    [118.44348002529, 24.7551797182204, 0.000919785350561142],
  ],
  [
    [118.444087985914, 24.754717422917, 0.000919726677238941],
    [118.443468002961, 24.7551658410129, 0.000919782556593418],
  ],
  [
    [118.444075458938, 24.7547029863527, 0.000919724814593792],
    [118.443455960876, 24.7551519818722, 0.000919780693948269],
  ],
  [
    [118.444062912206, 24.7546885678552, 0.000919723883271217],
    [118.44344389902, 24.7551381227429, 0.000919780693948269],
  ],
  [
    [118.444050345718, 24.7546741674245, 0.000919720157980919],
    [118.443431837181, 24.7551242816681, 0.000919777899980545],
  ],
  [
    [118.444037769346, 24.754659766999, 0.000919719226658344],
    [118.443419745692, 24.7551104496386, 0.000919776037335396],
  ],
  [
    [118.444025183105, 24.7546453846341, 0.00091971829533577],
    [118.443407644327, 24.755096626642, 0.000919775106012821],
  ],
  [
    [118.4440125771, 24.7546310113083, 0.00091971643269062],
    [118.443395533084, 24.7550828126782, 0.000919774174690247],
  ],
  [
    [118.443999951333, 24.7546166470216, 0.000919714570045471],
    [118.443383402085, 24.7550690167814, 0.000919770449399948],
  ],
  [
    [118.443987305809, 24.7546023008016, 0.000919711776077747],
    [118.443371261202, 24.7550552208896, 0.000919769518077374],
  ],
  [
    [118.443974650409, 24.7545879636146, 0.000919709913432598],
    [118.443359100563, 24.7550414430647, 0.00091976672410965],
  ],
  [
    [118.443961985132, 24.7545736354604, 0.000919707119464874],
    [118.443346920167, 24.7550276833067, 0.00091976672410965],
  ],
  [
    [118.443949300093, 24.7545593163453, 0.000919707119464874],
    [118.443334729887, 24.7550139235537, 0.000919762998819351],
  ],
  [
    [118.443936595297, 24.7545450152969, 0.0009197061881423],
    [118.443322529737, 24.7550001818614, 0.000919761136174202],
  ],
  [
    [118.443923880624, 24.7545307232815, 0.000919702462852001],
    [118.443310309824, 24.7549864492082, 0.000919761136174202],
  ],
  [
    [118.443911146189, 24.754516440305, 0.000919701531529427],
    [118.443298070148, 24.754972725594, 0.000919759273529053],
  ],
  [
    [118.443898391997, 24.7545021753954, 0.000919699668884277],
    [118.443285820594, 24.7549590110127, 0.000919757410883904],
  ],
  [
    [118.443885627929, 24.7544879195186, 0.000919697806239128],
    [118.443273551284, 24.7549453144982, 0.00091975461691618],
  ],
  [
    [118.443872853984, 24.7544736726747, 0.000919695012271404],
    [118.443261272098, 24.7549316270166, 0.00091975275427103],
  ],
  [
    [118.443860060276, 24.7544594348697, 0.000919695012271404],
    [118.443248983034, 24.7549179485679, 0.000919750891625881],
  ],
  [
    [118.443847246812, 24.7544452151316, 0.000919693149626255],
    [118.443236674207, 24.7549042791582, 0.000919749960303307],
  ],
  [
    [118.443834423472, 24.7544310044263, 0.000919690355658531],
    [118.443224345623, 24.7548906278153, 0.000919748097658157],
  ],
  [
    [118.443821580368, 24.75441680276, 0.000919689424335957],
    [118.443212007156, 24.7548769764774, 0.000919748097658157],
  ],
  [
    [118.443808717509, 24.7544026191604, 0.000919688493013382],
    [118.443199648932, 24.7548633432064, 0.000919746235013008],
  ],
  [
    [118.443795844773, 24.7543884445937, 0.000919684767723084],
    [118.443187280839, 24.754849727996, 0.000919744372367859],
  ],
  [
    [118.44378296216, 24.7543742790598, 0.000919682905077934],
    [118.443174892975, 24.7548361127968, 0.000919741578400135],
  ],
  [
    [118.443770059784, 24.7543601225649, 0.00091968197375536],
    [118.443162495241, 24.7548225156583, 0.00091974064707756],
  ],
  [
    [118.443757137652, 24.7543459841367, 0.00091968011111021],
    [118.44315008763, 24.7548089275525, 0.000919737853109837],
  ],
  [
    [118.443744205643, 24.7543318547413, 0.000919678248465061],
    [118.443137650369, 24.754795348492, 0.000919735990464687],
  ],
  [
    [118.443731253879, 24.7543177434127, 0.000919675454497337],
    [118.443125213125, 24.7547817874859, 0.000919734127819538],
  ],
  [
    [118.443718282345, 24.7543036320953, 0.000919674523174763],
    [118.443112756117, 24.7547682355188, 0.000919733196496964],
  ],
  [
    [118.44370530094, 24.7542895388384, 0.000919673591852188],
    [118.443100279346, 24.7547546925906, 0.000919732265174389],
  ],
  [
    [118.443692309666, 24.7542754636421, 0.000919671729207039],
    [118.443087792698, 24.7547411586953, 0.00091972853988409],
  ],
  [
    [118.443679298623, 24.754261388457, 0.000919668935239315],
    [118.443075286294, 24.7547276428668, 0.000919727608561516],
  ],
  [
    [118.443666267823, 24.7542473313387, 0.000919667072594166],
    [118.443062770013, 24.754714136071, 0.000919727608561516],
  ],
  [
    [118.443653227147, 24.7542332832531, 0.000919666141271591],
    [118.443050233968, 24.7547006383143, 0.000919723883271217],
  ],
  [
    [118.443640166714, 24.7542192532342, 0.000919665209949017],
    [118.443037688047, 24.7546871495903, 0.000919722020626068],
  ],
  [
    [118.443627096405, 24.7542052322481, 0.000919663347303867],
    [118.443025132255, 24.7546736789269, 0.000919721089303494],
  ],
  [
    [118.443614006333, 24.7541912203009, 0.000919661484658718],
    [118.443012546808, 24.7546602082809, 0.00091971829533577],
  ],
  [
    [118.443600906384, 24.7541772173865, 0.000919659622013569],
    [118.442999961383, 24.7546467647171, 0.00091971829533577],
  ],
  [
    [118.44358778668, 24.7541632325388, 0.000919656828045845],
    [118.442987356188, 24.7546333211644, 0.000919717364013195],
  ],
  [
    [118.443574657098, 24.7541492567238, 0.00091965589672327],
    [118.442974731236, 24.7546198956785, 0.000919713638722897],
  ],
  [
    [118.443561507761, 24.7541352989755, 0.000919653102755547],
    [118.442962096408, 24.7546064792253, 0.000919711776077747],
  ],
  [
    [118.443548338661, 24.7541213502662, 0.000919651240110397],
    [118.442949451703, 24.754593071805, 0.000919710844755173],
  ],
  [
    [118.443535159684, 24.7541074105896, 0.000919650308787823],
    [118.442936787234, 24.7545796734236, 0.000919708982110024],
  ],
  [
    [118.443521960944, 24.7540934799519, 0.000919648446142673],
    [118.442924103009, 24.7545662931089, 0.000919708982110024],
  ],
  [
    [118.443508752335, 24.7540795673747, 0.00091964565217495],
    [118.442911408908, 24.7545529218269, 0.0009197061881423],
  ],
  [
    [118.443495533848, 24.7540656638303, 0.0009196437895298],
    [118.442898704936, 24.7545395686055, 0.000919705256819725],
  ],
  [
    [118.44348228572, 24.7540517783586, 0.000919642858207226],
    [118.442885981194, 24.7545262153953, 0.000919703394174576],
  ],
  [
    [118.443469037594, 24.7540378928858, 0.000919642858207226],
    [118.442873247582, 24.7545128802456, 0.000919700600206852],
  ],
  [
    [118.443455759826, 24.7540240254858, 0.000919640064239502],
    [118.442860494206, 24.7544995541348, 0.000919698737561703],
  ],
  [
    [118.443442472188, 24.7540101761463, 0.000919636338949203],
    [118.442847721075, 24.7544862460907, 0.000919696874916554],
  ],
  [
    [118.443429174674, 24.7539963358395, 0.000919636338949203],
    [118.442834947952, 24.7544729470732, 0.000919695012271404],
  ],
  [
    [118.443415857397, 24.7539825045716, 0.000919634476304054],
    [118.44282214518, 24.7544596571007, 0.00091969408094883],
  ],
  [
    [118.443402530243, 24.7539686823364, 0.00091963354498148],
    [118.442809342418, 24.7544463761549, 0.00091969221830368],
  ],
  [
    [118.443389183333, 24.7539548781678, 0.000919630751013756],
    [118.442796510013, 24.7544331132819, 0.000919691286981106],
  ],
  [
    [118.44337581666, 24.7539410830381, 0.000919628888368607],
    [118.442783677617, 24.7544198594355, 0.000919688493013382],
  ],
  [
    [118.443362440117, 24.7539273059688, 0.000919628888368607],
    [118.442770825458, 24.7544066146279, 0.000919687561690807],
  ],
  [
    [118.443349053698, 24.7539135379322, 0.000919626094400883],
    [118.442757953535, 24.7543933788593, 0.000919686630368233],
  ],
  [
    [118.443335647516, 24.7538997789345, 0.000919624231755733],
    [118.442745071743, 24.7543801611511, 0.000919683836400509],
  ],
  [
    [118.443322221571, 24.7538860289757, 0.000919623300433159],
    [118.442732170187, 24.7543669524818, 0.000919682905077934],
  ],
  [
    [118.443308785757, 24.7538722970773, 0.000919620506465435],
    [118.442719258762, 24.754353761873, 0.00091968197375536],
  ],
  [
    [118.443295340072, 24.7538585832393, 0.000919618643820286],
    [118.442706337452, 24.7543405712692, 0.00091968011111021],
  ],
  [
    [118.443281874618, 24.7538448694124, 0.000919616781175137],
    [118.442693396387, 24.754327398732, 0.000919678248465061],
  ],
  [
    [118.443268389408, 24.7538311736521, 0.000919615849852562],
    [118.44268044545, 24.7543142442553, 0.000919675454497337],
  ],
  [
    [118.443254894328, 24.7538174959522, 0.000919613055884838],
    [118.442667474745, 24.7543010897897, 0.000919674523174763],
  ],
  [
    [118.443241379478, 24.7538038182634, 0.000919611193239689],
    [118.442654494169, 24.7542879533845, 0.000919673591852188],
  ],
  [
    [118.443227854758, 24.7537901586351, 0.000919611193239689],
    [118.442641493836, 24.754274835046, 0.000919671729207039],
  ],
  [
    [118.443214320169, 24.7537765170671, 0.000919608399271965],
    [118.44262848362, 24.7542617167124, 0.00091966986656189],
  ],
  [
    [118.443200755931, 24.7537628845441, 0.000919606536626816],
    [118.442615453647, 24.7542486164454, 0.000919668935239315],
  ],
  [
    [118.443187191702, 24.7537492610476, 0.000919604673981667],
    [118.442602413798, 24.7542355252111, 0.000919666141271591],
  ],
  [
    [118.44317360771, 24.7537356465899, 0.000919603742659092],
    [118.442589364078, 24.7542224520373, 0.000919664278626442],
  ],
  [
    [118.443160003963, 24.7537220501988, 0.000919601880013943],
    [118.442576294589, 24.7542093788745, 0.000919662415981293],
  ],
  [
    [118.443146390339, 24.7537084628403, 0.000919600017368793],
    [118.442563205349, 24.7541963328061, 0.000919661484658718],
  ],
  [
    [118.443132756958, 24.7536948935483, 0.000919599086046219],
    [118.442550116113, 24.7541832867365, 0.000919659622013569],
  ],
  [
    [118.443119113702, 24.753681333289, 0.000919596292078495],
    [118.442536997233, 24.7541702587396, 0.000919656828045845],
  ],
  [
    [118.443105450682, 24.7536677820685, 0.000919593498110771],
    [118.442523878363, 24.7541572397692, 0.000919656828045845],
  ],
  [
    [118.443091777792, 24.7536542489084, 0.000919593498110771],
    [118.44251073973, 24.7541442298377, 0.000919654965400696],
  ],
  [
    [118.44307808514, 24.753640724787, 0.000919589772820473],
    [118.442497581341, 24.7541312379727, 0.000919653102755547],
  ],
  [
    [118.443064382618, 24.753627218726, 0.000919589772820473],
    [118.442484413074, 24.7541182551404, 0.000919650308787823],
  ],
  [
    [118.443050670219, 24.7536137216977, 0.000919587910175323],
    [118.442471234931, 24.7541052813408, 0.000919649377465248],
  ],
  [
    [118.443036928171, 24.7536002337142, 0.000919586047530174],
    [118.442458037031, 24.7540923256077, 0.000919648446142673],
  ],
  [
    [118.44302318614, 24.7535867637849, 0.000919586047530174],
    [118.442444819368, 24.7540793789134, 0.000919646583497524],
  ],
  [
    [118.443009424346, 24.7535733028945, 0.000919582322239876],
    [118.442431601721, 24.7540664502734, 0.000919644720852375],
  ],
  [
    [118.442995642789, 24.7535598510427, 0.000919582322239876],
    [118.442418364305, 24.7540535216444, 0.000919640995562077],
  ],
  [
    [118.442981851362, 24.7535464172513, 0.000919580459594727],
    [118.442405107132, 24.7540406110819, 0.000919640995562077],
  ],
  [
    [118.442968040173, 24.7535329924987, 0.000919577665627003],
    [118.442391840088, 24.7540277185799, 0.000919640064239502],
  ],
  [
    [118.442954219113, 24.7535195858064, 0.000919575802981853],
    [118.442378563161, 24.7540148260827, 0.000919637270271778],
  ],
  [
    [118.442940388177, 24.7535061881467, 0.000919573940336704],
    [118.442365266485, 24.7540019606798, 0.000919636338949203],
  ],
  [
    [118.442926537478, 24.7534927995257, 0.000919572077691555],
    [118.442351950038, 24.7539890952879, 0.000919634476304054],
  ],
  [
    [118.442912667023, 24.7534794289712, 0.000919570215046406],
    [118.442338633608, 24.7539762479504, 0.00091963354498148],
  ],
  [
    [118.442898786692, 24.7534660674492, 0.000919569283723831],
    [118.442325297414, 24.7539634096515, 0.000919630751013756],
  ],
  [
    [118.442884896491, 24.7534527239877, 0.000919567421078682],
    [118.442311941458, 24.7539505803914, 0.000919632613658905],
  ],
  [
    [118.442870986527, 24.7534393895648, 0.000919566489756107],
    [118.442298575631, 24.7539377691917, 0.000919628888368607],
  ],
  [
    [118.442857066686, 24.7534260641745, 0.000919563695788383],
    [118.442285199927, 24.7539249670246, 0.000919627025723457],
  ],
  [
    [118.442843127089, 24.7534127568506, 0.000919562764465809],
    [118.442271804467, 24.753912182924, 0.000919627025723457],
  ],
  [
    [118.442829177616, 24.7533994585593, 0.00091956090182066],
    [118.442258399123, 24.7538993988283, 0.000919624231755733],
  ],
  [
    [118.442815208387, 24.7533861783345, 0.00091955903917551],
    [118.442244974029, 24.7538866418268, 0.000919623300433159],
  ],
  [
    [118.442801229281, 24.7533729071422, 0.000919558107852936],
    [118.442231539052, 24.7538738848301, 0.000919622369110584],
  ],
  [
    [118.442787230412, 24.7533596449886, 0.000919557176530361],
    [118.442218094205, 24.7538611458939, 0.000919618643820286],
  ],
  [
    [118.442773221674, 24.7533464008952, 0.000919554382562637],
    [118.442204629595, 24.7538484159963, 0.000919616781175137],
  ],
  [
    [118.442759193172, 24.7533331658406, 0.000919553451240063],
    [118.442191155114, 24.7538357041591, 0.000919615849852562],
  ],
  [
    [118.442745154801, 24.7533199488463, 0.000919550657272339],
    [118.44217766087, 24.7538230013606, 0.000919613987207413],
  ],
  [
    [118.442731096667, 24.7533067408906, 0.00091954879462719],
    [118.44216415675, 24.7538103075947, 0.000919612124562263],
  ],
  [
    [118.442717028663, 24.7532935509952, 0.00091954693198204],
    [118.442150642759, 24.7537976318892, 0.000919611193239689],
  ],
  [
    [118.442702950783, 24.7532803701323, 0.000919545069336891],
    [118.442137109005, 24.7537849652223, 0.00091960933059454],
  ],
  [
    [118.44268885314, 24.7532671983081, 0.000919545069336891],
    [118.442123555488, 24.7537723075941, 0.00091960746794939],
  ],
  [
    [118.442674735741, 24.7532540445503, 0.000919542275369167],
    [118.442110001987, 24.7537596680202, 0.00091960746794939],
  ],
  [
    [118.442660618351, 24.7532408998189, 0.000919541344046593],
    [118.442096428723, 24.7537470374849, 0.000919604673981667],
  ],
  [
    [118.442646471319, 24.75322777316, 0.000919538550078869],
    [118.442082835702, 24.7537344250161, 0.000919603742659092],
  ],
  [
    [118.442632324297, 24.7532146555275, 0.000919539481401443],
    [118.442069242684, 24.753721812546, 0.000919601880013943],
  ],
  [
    [118.442618147626, 24.7532015469398, 0.00091953482478857],
    [118.442055620031, 24.7537092271761, 0.000919600017368793],
  ],
  [
    [118.442603970971, 24.7531884564061, 0.000919535756111145],
    [118.442041997379, 24.753696641805, 0.000919598154723644],
  ],
  [
    [118.442589774554, 24.7531753749111, 0.000919532962143421],
    [118.442028354972, 24.7536840745003, 0.00091959722340107],
  ],
  [
    [118.44257555838, 24.7531623114825, 0.000919530168175697],
    [118.442014692808, 24.753671525262, 0.00091959536075592],
  ],
  [
    [118.44256133233, 24.7531492570864, 0.000919529236853123],
    [118.442001030646, 24.7536589760225, 0.000919594429433346],
  ],
  [
    [118.44254709641, 24.7531362207505, 0.000919527374207973],
    [118.441987338842, 24.7536464448554, 0.000919592566788197],
  ],
  [
    [118.442532840727, 24.7531231934532, 0.000919525511562824],
    [118.441973647054, 24.7536339317425, 0.000919589772820473],
  ],
  [
    [118.442518565281, 24.7531101751945, 0.00091952458024025],
    [118.441959935503, 24.7536214276683, 0.000919589772820473],
  ],
  [
    [118.442504289852, 24.75309717499, 0.000919523648917675],
    [118.441946214075, 24.7536089326266, 0.000919587910175323],
  ],
  [
    [118.442489994667, 24.7530841928518, 0.000919520854949951],
    [118.441932472891, 24.7535964556513, 0.0009195851162076],
  ],
  [
    [118.442475679712, 24.7530712107244, 0.000919519923627377],
    [118.441918721829, 24.7535839877085, 0.0009195851162076],
  ],
  [
    [118.442461354894, 24.753058255685, 0.000919518060982227],
    [118.441904951005, 24.7535715288044, 0.00091958325356245],
  ],
  [
    [118.442447010307, 24.7530453006564, 0.000919516198337078],
    [118.441891180197, 24.7535590879544, 0.000919581390917301],
  ],
  [
    [118.442432665736, 24.7530323636819, 0.000919515267014503],
    [118.441877379739, 24.7535466561491, 0.000919579528272152],
  ],
  [
    [118.442418291522, 24.7530194447798, 0.000919514335691929],
    [118.441863579297, 24.7535342423981, 0.000919577665627003],
  ],
  [
    [118.442403907433, 24.7530065349102, 0.000919511541724205],
    [118.441849759092, 24.7535218376857, 0.000919576734304428],
  ],
  [
    [118.442389513473, 24.7529936431008, 0.000919507816433907],
    [118.44183592901, 24.7535094420057, 0.000919574871659279],
  ],
  [
    [118.442375109637, 24.7529807603239, 0.000919506885111332],
    [118.441822079172, 24.7534970643922, 0.00091957300901413],
  ],
  [
    [118.442360686037, 24.7529678865855, 0.000919506885111332],
    [118.441808219457, 24.7534846958111, 0.00091957114636898],
  ],
  [
    [118.442346242682, 24.7529550309134, 0.000919504091143608],
    [118.441794349872, 24.7534723452903, 0.000919569283723831],
  ],
  [
    [118.442331789451, 24.7529421842737, 0.000919504091143608],
    [118.441780460524, 24.7534600038081, 0.000919568352401257],
  ],
  [
    [118.442317326349, 24.7529293556943, 0.00091950036585331],
    [118.441766561298, 24.7534476713583, 0.000919567421078682],
  ],
  [
    [118.442302843485, 24.7529165361533, 0.00091950036585331],
    [118.441752642317, 24.7534353569749, 0.000919565558433533],
  ],
  [
    [118.44228835075, 24.7529037346726, 0.000919499434530735],
    [118.441738713458, 24.753423051624, 0.000919563695788383],
  ],
  [
    [118.44227384814, 24.7528909422243, 0.00091949850320816],
    [118.441724774723, 24.7534107553056, 0.00091956090182066],
  ],
  [
    [118.442259325766, 24.7528781588144, 0.000919495709240437],
    [118.441710826117, 24.7533984770475, 0.000919559970498085],
  ],
  [
    [118.442244783637, 24.7528653934709, 0.000919492915272713],
    [118.441696857755, 24.7533862168556, 0.00091956090182066],
  ],
  [
    [118.442230241523, 24.7528526461814, 0.000919492915272713],
    [118.441682869623, 24.7533739566746, 0.000919558107852936],
  ],
  [
    [118.442215669761, 24.7528399079365, 0.000919490121304989],
    [118.441668881514, 24.7533617235755, 0.000919557176530361],
  ],
  [
    [118.442201098008, 24.752827178718, 0.000919489189982414],
    [118.441654873635, 24.7533494904871, 0.000919553451240063],
  ],
  [
    [118.4421865065, 24.7528144675656, 0.00091948825865984],
    [118.441640846, 24.753337275465, 0.000919554382562637],
  ],
  [
    [118.442171895235, 24.7528017744796, 0.00091948639601469],
    [118.44162681838, 24.7533250784972, 0.000919551588594913],
  ],
  [
    [118.44215728398, 24.7527890904198, 0.000919483602046967],
    [118.441612770998, 24.7533128905678, 0.000919549725949764],
  ],
  [
    [118.442142643076, 24.7527764154046, 0.000919483602046967],
    [118.441598703852, 24.753300711677, 0.000919547863304615],
  ],
  [
    [118.442128002188, 24.7527637584435, 0.000919481739401817],
    [118.441584636716, 24.7532885418125, 0.000919545069336891],
  ],
  [
    [118.442113341537, 24.7527511105208, 0.000919478945434093],
    [118.44157054983, 24.7532763990421, 0.000919546000659466],
  ],
  [
    [118.442098661131, 24.7527384806643, 0.000919478014111519],
    [118.441556443174, 24.7532642562825, 0.000919544138014317],
  ],
  [
    [118.442083980734, 24.7527258598342, 0.000919475220143795],
    [118.441542326648, 24.753252131583, 0.000919544138014317],
  ],
  [
    [118.442069280581, 24.7527132570702, 0.000919475220143795],
    [118.441528200245, 24.753240015916, 0.000919542275369167],
  ],
  [
    [118.442054560665, 24.7527006633447, 0.000919473357498646],
    [118.441514063972, 24.7532279183092, 0.000919542275369167],
  ],
  [
    [118.442039830879, 24.7526880876794, 0.000919471494853497],
    [118.441499907935, 24.7532158297409, 0.00091953668743372],
  ],
  [
    [118.442025091217, 24.7526755210463, 0.000919469632208347],
    [118.441485742029, 24.7532037592328, 0.00091953668743372],
  ],
  [
    [118.442010331799, 24.7526629724795, 0.000919469632208347],
    [118.441471566245, 24.7531916977571, 0.00091953482478857],
  ],
  [
    [118.441995562504, 24.7526504329451, 0.000919466838240623],
    [118.441457370705, 24.7531796543477, 0.00091953482478857],
  ],
  [
    [118.441980773446, 24.752637902449, 0.0009194640442729],
    [118.441443165282, 24.7531676109429, 0.000919532030820847],
  ],
  [
    [118.441965974525, 24.7526253990409, 0.000919463112950325],
    [118.441428940109, 24.7531555946321, 0.000919531099498272],
  ],
  [
    [118.441951165721, 24.7526128956373, 0.000919463112950325],
    [118.441414714945, 24.7531435873477, 0.000919529236853123],
  ],
  [
    [118.441936337161, 24.7526004102999, 0.000919461250305176],
    [118.441400470018, 24.7531315891018, 0.000919528305530548],
  ],
  [
    [118.441921498731, 24.7525879430226, 0.000919459387660027],
    [118.441386205328, 24.7531195998943, 0.000919526442885399],
  ],
  [
    [118.441906650424, 24.7525754847776, 0.000919456593692303],
    [118.44137194066, 24.7531076377687, 0.000919525511562824],
  ],
  [
    [118.441891782361, 24.7525630445988, 0.000919456593692303],
    [118.441357656223, 24.7530956756538, 0.0009195227175951],
  ],
  [
    [118.441876904422, 24.7525506134523, 0.000919454731047153],
    [118.44134335203, 24.7530837316051, 0.000919521786272526],
  ],
  [
    [118.441862016606, 24.7525381913381, 0.000919453799724579],
    [118.441329037959, 24.7530717965887, 0.000919518060982227],
  ],
  [
    [118.44184710904, 24.7525257963178, 0.000919451005756855],
    [118.441314714018, 24.7530598796326, 0.000919518992304802],
  ],
  [
    [118.441832181706, 24.7525134013082, 0.00091945007443428],
    [118.441300380207, 24.7530479807366, 0.000919516198337078],
  ],
  [
    [118.441817254387, 24.7525010243525, 0.000919447280466557],
    [118.441286036512, 24.7530360818452, 0.000919514335691929],
  ],
  [
    [118.441802307312, 24.752488665463, 0.000919446349143982],
    [118.441271673068, 24.7530242100478, 0.000919514335691929],
  ],
  [
    [118.441787340475, 24.7524763156119, 0.000919444486498833],
    [118.441257289854, 24.753012338261, 0.00091951247304678],
  ],
  [
    [118.441772373654, 24.7524639838147, 0.000919441692531109],
    [118.441242906656, 24.7530004845283, 0.000919509679079056],
  ],
  [
    [118.44175738707, 24.7524516610559, 0.000919441692531109],
    [118.441228503701, 24.7529886488618, 0.000919508747756481],
  ],
  [
    [118.441742380723, 24.7524393473355, 0.000919441692531109],
    [118.441214090869, 24.7529768222277, 0.000919507816433907],
  ],
  [
    [118.441727364513, 24.7524270607029, 0.000919438898563385],
    [118.441199658275, 24.752965004632, 0.000919505022466183],
  ],
  [
    [118.44171233842, 24.7524147740748, 0.000919437035918236],
    [118.44118521581, 24.7529532050963, 0.000919504091143608],
  ],
  [
    [118.441697302464, 24.7524025145345, 0.000919435173273087],
    [118.441170763474, 24.7529414236209, 0.000919501297175884],
  ],
  [
    [118.441682246738, 24.7523902550048, 0.000919434241950512],
    [118.441156301256, 24.75292964215, 0.000919502228498459],
  ],
  [
    [118.441667171256, 24.7523780135411, 0.000919433310627937],
    [118.441141819287, 24.752917887773, 0.000919499434530735],
  ],
  [
    [118.44165209579, 24.7523657901315, 0.000919431447982788],
    [118.441127327435, 24.7529061334006, 0.00091949850320816],
  ],
  [
    [118.441637000562, 24.7523535757602, 0.000919428654015064],
    [118.441112825719, 24.7528944061161, 0.00091949850320816],
  ],
  [
    [118.441621895463, 24.7523413794488, 0.000919426791369915],
    [118.441098304233, 24.7528826788422, 0.000919497571885586],
  ],
  [
    [118.441606770609, 24.7523292012036, 0.00091942772269249],
    [118.441083782764, 24.7528709696224, 0.000919494777917862],
  ],
  [
    [118.441591635871, 24.7523170229629, 0.000919423997402191],
    [118.441069231652, 24.7528592784747, 0.000919492915272713],
  ],
  [
    [118.44157649127, 24.7523048718099, 0.000919423997402191],
    [118.441054680549, 24.7528475963533, 0.000919491983950138],
  ],
  [
    [118.441561326906, 24.7522927296953, 0.000919423066079617],
    [118.441040109682, 24.7528359232703, 0.000919491052627563],
  ],
  [
    [118.441546152666, 24.7522805966128, 0.000919420272111893],
    [118.441025528946, 24.7528242682474, 0.000919489189982414],
  ],
  [
    [118.441530968556, 24.7522684815904, 0.000919418409466743],
    [118.441010938339, 24.7528126312846, 0.000919487327337265],
  ],
  [
    [118.441515764689, 24.7522563846341, 0.000919417478144169],
    [118.44099632797, 24.7528010033601, 0.00091948639601469],
  ],
  [
    [118.441500550946, 24.7522442967099, 0.00091941561549902],
    [118.440981707723, 24.7527893844679, 0.000919484533369541],
  ],
  [
    [118.441485327326, 24.752232217818, 0.000919414684176445],
    [118.440967077606, 24.7527777836358, 0.000919481739401817],
  ],
  [
    [118.441470083951, 24.7522201569921, 0.000919411890208721],
    [118.440952437612, 24.752766191836, 0.000919480808079243],
  ],
  [
    [118.441454830705, 24.7522081142263, 0.000919411890208721],
    [118.440937777862, 24.7527546181023, 0.000919478945434093],
  ],
  [
    [118.441439557696, 24.7521960804986, 0.000919410027563572],
    [118.440923108241, 24.7527430624287, 0.000919478014111519],
  ],
  [
    [118.441424284704, 24.752184064825, 0.000919408164918423],
    [118.440908428737, 24.7527315067596, 0.000919478014111519],
  ],
  [
    [118.441408991949, 24.7521720581895, 0.000919407233595848],
    [118.440893729482, 24.7527199781843, 0.000919475220143795],
  ],
  [
    [118.441393679438, 24.7521600696201, 0.000919404439628124],
    [118.440879020345, 24.7527084496136, 0.00091947428882122],
  ],
  [
    [118.441378366936, 24.7521480900769, 0.00091940350830555],
    [118.440864301344, 24.7526969481307, 0.000919473357498646],
  ],
  [
    [118.441363034678, 24.7521361285996, 0.00091940350830555],
    [118.440849572459, 24.7526854466523, 0.000919472426176071],
  ],
  [
    [118.441347692544, 24.7521241761545, 0.000919400714337826],
    [118.440834823817, 24.75267396324, 0.000919468700885773],
  ],
  [
    [118.441332330653, 24.7521122417755, 0.000919398851692677],
    [118.440820065306, 24.7526624978877, 0.000919467769563198],
  ],
  [
    [118.441316958893, 24.7521003254564, 0.000919397920370102],
    [118.440805296917, 24.7526510415676, 0.000919466838240623],
  ],
  [
    [118.441301577256, 24.7520884181694, 0.000919396057724953],
    [118.440790508772, 24.7526396033137, 0.000919465906918049],
  ],
  [
    [118.441286175856, 24.7520765199207, 0.000919394195079803],
    [118.440775720636, 24.752628174086, 0.000919463112950325],
  ],
  [
    [118.441270764593, 24.7520646487597, 0.000919394195079803],
    [118.440760912744, 24.7526167629243, 0.000919463112950325],
  ],
  [
    [118.441255343446, 24.7520527776031, 0.00091939140111208],
    [118.440746085088, 24.7526053608009, 0.000919460318982601],
  ],
  [
    [118.441239912436, 24.7520409335343, 0.000919388607144356],
    [118.440731257449, 24.7525939767315, 0.000919460318982601],
  ],
  [
    [118.441224461657, 24.7520290894758, 0.000919390469789505],
    [118.440716410046, 24.7525826017004, 0.000919457525014877],
  ],
  [
    [118.441209001015, 24.752017272505, 0.000919388607144356],
    [118.440701552766, 24.7525712357015, 0.000919456593692303],
  ],
  [
    [118.441193520609, 24.7520054645725, 0.000919386744499207],
    [118.440686685616, 24.7525598877627, 0.000919455662369728],
  ],
  [
    [118.441178030327, 24.751993665672, 0.000919384881854057],
    [118.44067179871, 24.7525485578898, 0.000919453799724579],
  ],
  [
    [118.441162530175, 24.7519818848315, 0.000919383019208908],
    [118.440656911812, 24.7525372370432, 0.000919451005756855],
  ],
  [
    [118.441147020153, 24.7519701220509, 0.000919383019208908],
    [118.440642005159, 24.7525259342626, 0.000919451005756855],
  ],
  [
    [118.441131490369, 24.7519583683085, 0.000919380225241184],
    [118.440627078742, 24.7525146405203, 0.000919451005756855],
  ],
  [
    [118.441115950714, 24.751946632626, 0.00091937929391861],
    [118.440612152334, 24.7525033558041, 0.000919448211789131],
  ],
  [
    [118.441100401182, 24.7519349059756, 0.000919375568628311],
    [118.440597206176, 24.7524920981818, 0.000919447280466557],
  ],
  [
    [118.441084841781, 24.7519231973852, 0.000919374637305737],
    [118.440582250135, 24.7524808405638, 0.000919446349143982],
  ],
  [
    [118.441069262623, 24.7519115068606, 0.000919374637305737],
    [118.440567284224, 24.7524696010059, 0.000919444486498833],
  ],
  [
    [118.441053673589, 24.7518998253682, 0.000919373705983162],
    [118.440552298556, 24.752458379514, 0.000919442623853683],
  ],
  [
    [118.441038064792, 24.7518881529139, 0.000919370912015438],
    [118.440537303011, 24.7524471670542, 0.000919441692531109],
  ],
  [
    [118.441022456011, 24.7518764985135, 0.000919369049370289],
    [118.440522297595, 24.7524359726545, 0.00091943982988596],
  ],
  [
    [118.441006827474, 24.751864862179, 0.000919369980692863],
    [118.440507282303, 24.7524247872869, 0.00091943796724081],
  ],
  [
    [118.440991179175, 24.7518532348826, 0.00091936532407999],
    [118.440492257141, 24.7524136199794, 0.000919437035918236],
  ],
  [
    [118.440975530891, 24.7518416256401, 0.00091936532407999],
    [118.440477212215, 24.75240246171, 0.000919437035918236],
  ],
  [
    [118.440959862851, 24.7518300344634, 0.00091936532407999],
    [118.440462157419, 24.7523913215005, 0.000919433310627937],
  ],
  [
    [118.440944184934, 24.7518184523189, 0.000919362530112267],
    [118.440447092746, 24.7523801903233, 0.000919432379305363],
  ],
  [
    [118.440928497148, 24.7518068882342, 0.000919360667467117],
    [118.440432018202, 24.7523690772061, 0.000919432379305363],
  ],
  [
    [118.440912789598, 24.7517953331876, 0.000919357873499393],
    [118.440416923895, 24.7523579731269, 0.000919429585337639],
  ],
  [
    [118.440897072179, 24.7517837962009, 0.000919357873499393],
    [118.440401819719, 24.7523468871078, 0.000919428654015064],
  ],
  [
    [118.440881344883, 24.7517722682463, 0.00091935507953167],
    [118.440386705665, 24.7523358101208, 0.000919428654015064],
  ],
  [
    [118.440865597831, 24.7517607583575, 0.000919354148209095],
    [118.44037158174, 24.7523247511938, 0.000919424928724766],
  ],
  [
    [118.440849850788, 24.7517492574948, 0.000919352285563946],
    [118.440356438053, 24.7523137013049, 0.000919423997402191],
  ],
  [
    [118.440834083996, 24.7517377837257, 0.000919352285563946],
    [118.440341294381, 24.75230266947, 0.000919422134757042],
  ],
  [
    [118.440818297434, 24.7517263099669, 0.000919351354241371],
    [118.440326130953, 24.752291655701, 0.000919421203434467],
  ],
  [
    [118.440802510895, 24.7517148632898, 0.000919348560273647],
    [118.440310957648, 24.7522806509642, 0.000919421203434467],
  ],
  [
    [118.440786704593, 24.7517034256507, 0.000919347628951073],
    [118.440295764579, 24.7522696552655, 0.000919419340789318],
  ],
  [
    [118.440770888415, 24.7516919970436, 0.000919345766305923],
    [118.440280571527, 24.7522586776208, 0.000919417478144169],
  ],
  [
    [118.44075505248, 24.7516805865024, 0.000919345766305923],
    [118.440265358718, 24.7522477180419, 0.000919417478144169],
  ],
  [
    [118.440739216561, 24.751669194015, 0.0009193429723382],
    [118.440250136032, 24.7522367674952, 0.00091941561549902],
  ],
  [
    [118.44072336088, 24.7516578105657, 0.000919342041015625],
    [118.440234903469, 24.7522258259807, 0.00091941375285387],
  ],
  [
    [118.440707495328, 24.7516464451761, 0.000919340178370476],
    [118.440219651155, 24.7522149115598, 0.000919411890208721],
  ],
  [
    [118.440691610021, 24.7516350978524, 0.000919339247047901],
    [118.440204398845, 24.7522039971373, 0.000919410958886147],
  ],
  [
    [118.440675724722, 24.7516237595547, 0.000919337384402752],
    [118.440189126784, 24.7521931098084, 0.000919408164918423],
  ],
  [
    [118.440659819661, 24.7516124302951, 0.000919336453080177],
    [118.44017384484, 24.752182222484, 0.000919408164918423],
  ],
  [
    [118.440643904737, 24.751601128123, 0.000919335521757603],
    [118.440158553033, 24.7521713622471, 0.000919406302273273],
  ],
  [
    [118.440627970049, 24.751589834989, 0.000919333659112453],
    [118.440143241455, 24.7521605020206, 0.000919405370950699],
  ],
  [
    [118.440612035371, 24.7515785508809, 0.00091933086514473],
    [118.4401279299, 24.7521496688759, 0.00091940350830555],
  ],
  [
    [118.440596080937, 24.7515672848387, 0.000919329933822155],
    [118.440112598581, 24.7521388447691, 0.00091940350830555],
  ],
  [
    [118.440580116633, 24.7515560368562, 0.000919329933822155],
    [118.440097257386, 24.7521280296945, 0.0009194016456604],
  ],
  [
    [118.440564132566, 24.7515447979118, 0.000919328071177006],
    [118.440081896434, 24.7521172326858, 0.000919399783015251],
  ],
  [
    [118.440548148515, 24.7515335770211, 0.000919325277209282],
    [118.440066535497, 24.7521064537309, 0.000919397920370102],
  ],
  [
    [118.440532144707, 24.7515223741962, 0.000919325277209282],
    [118.440051154798, 24.7520956838142, 0.000919396989047527],
  ],
  [
    [118.440516131024, 24.7515111804033, 0.000919324345886707],
    [118.440035774114, 24.7520849319513, 0.000919394195079803],
  ],
  [
    [118.440500107469, 24.7515000046702, 0.000919321551918983],
    [118.440020373667, 24.7520741891265, 0.000919395126402378],
  ],
  [
    [118.440484064153, 24.751488837975, 0.000919320620596409],
    [118.44000496335, 24.7520634643616, 0.000919392332434654],
  ],
  [
    [118.440468010966, 24.7514776893397, 0.000919319689273834],
    [118.439989533269, 24.7520527486347, 0.00091939140111208],
  ],
  [
    [118.440451947908, 24.751466558764, 0.00091931689530611],
    [118.439974103205, 24.7520420509617, 0.000919390469789505],
  ],
  [
    [118.440435874975, 24.7514554372204, 0.000919315963983536],
    [118.439958653377, 24.7520313623268, 0.00091938953846693],
  ],
  [
    [118.440419782284, 24.7514443337425, 0.000919315963983536],
    [118.439943193678, 24.7520206917517, 0.00091938953846693],
  ],
  [
    [118.44040368961, 24.7514332483183, 0.000919315032660961],
    [118.439927724109, 24.7520100392365, 0.000919386744499207],
  ],
  [
    [118.440387577173, 24.7514221719321, 0.000919312238693237],
    [118.439912244663, 24.7519993957533, 0.000919384881854057],
  ],
  [
    [118.44037145486, 24.7514111045779, 0.000919310376048088],
    [118.439896745461, 24.7519887703359, 0.000919383019208908],
  ],
  [
    [118.440355312796, 24.7514000643172, 0.000919309444725513],
    [118.439881246268, 24.7519781539447, 0.000919381156563759],
  ],
  [
    [118.440339170742, 24.7513890330824, 0.000919307582080364],
    [118.439865727317, 24.7519675556192, 0.000919381156563759],
  ],
  [
    [118.440323008926, 24.7513780108856, 0.00091930665075779],
    [118.43985019849, 24.7519569663258, 0.000919382087886333],
  ],
  [
    [118.440306837245, 24.7513670157763, 0.00091930478811264],
    [118.439834659793, 24.7519463950923, 0.000919378362596035],
  ],
  [
    [118.440290655688, 24.7513560296989, 0.000919303856790066],
    [118.439819111225, 24.7519358419185, 0.000919378362596035],
  ],
  [
    [118.440274454368, 24.7513450526594, 0.000919302925467491],
    [118.439803542894, 24.7519252977828, 0.000919374637305737],
  ],
  [
    [118.440258253064, 24.7513340936737, 0.000919301994144917],
    [118.439787974572, 24.7519147626731, 0.000919373705983162],
  ],
  [
    [118.440242032004, 24.7513231527537, 0.000919300131499767],
    [118.4397723865, 24.751904254657, 0.000919373705983162],
  ],
  [
    [118.440225801067, 24.7513122208656, 0.000919298268854618],
    [118.439756788544, 24.7518937466452, 0.000919370912015438],
  ],
  [
    [118.440209550381, 24.751301316071, 0.000919297337532043],
    [118.439741180724, 24.7518832657209, 0.000919370912015438],
  ],
  [
    [118.440193299697, 24.7512904112745, 0.000919295474886894],
    [118.439725563027, 24.7518727938287, 0.000919369980692863],
  ],
  [
    [118.440177029263, 24.7512795335715, 0.000919295474886894],
    [118.439709925567, 24.7518623309744, 0.00091936718672514],
  ],
  [
    [118.440160748953, 24.7512686649004, 0.00091929268091917],
    [118.439694288123, 24.7518518861741, 0.00091936718672514],
  ],
  [
    [118.440144458766, 24.7512578052612, 0.000919290818274021],
    [118.439678630922, 24.7518414594394, 0.000919366255402565],
  ],
  [
    [118.440128158708, 24.7512469636818, 0.000919289886951447],
    [118.439662963844, 24.7518310417368, 0.000919362530112267],
  ],
  [
    [118.440111838895, 24.7512361401679, 0.000919290818274021],
    [118.439647286896, 24.7518206420939, 0.000919362530112267],
  ],
  [
    [118.440095519097, 24.7512253347078, 0.000919287092983723],
    [118.43963160007, 24.7518102514831, 0.000919360667467117],
  ],
  [
    [118.440079179537, 24.7512145382855, 0.000919286161661148],
    [118.439615893488, 24.751799878938, 0.000919358804821968],
  ],
  [
    [118.440062830106, 24.7512037599229, 0.000919286161661148],
    [118.439600186921, 24.7517895244467, 0.000919359736144543],
  ],
  [
    [118.440046460913, 24.7511929905982, 0.000919284299015999],
    [118.439584460592, 24.7517791789934, 0.000919356942176819],
  ],
  [
    [118.440030091741, 24.751182248355, 0.00091928243637085],
    [118.439568734277, 24.7517688515939, 0.000919356010854244],
  ],
  [
    [118.440013702801, 24.7511715061218, 0.000919281505048275],
    [118.4395529882, 24.7517585332323, 0.00091935507953167],
  ],
  [
    [118.439997303997, 24.751160790976, 0.0009192805737257],
    [118.439537232252, 24.7517482329305, 0.00091935321688652],
  ],
  [
    [118.439980895316, 24.7511500848622, 0.000919278711080551],
    [118.439521466434, 24.7517379506885, 0.00091935321688652],
  ],
  [
    [118.439964476764, 24.751139396808, 0.000919276848435402],
    [118.439505680852, 24.7517276774844, 0.000919349491596222],
  ],
  [
    [118.439948048337, 24.7511287177856, 0.000919274985790253],
    [118.439489895279, 24.7517174133064, 0.000919348560273647],
  ],
  [
    [118.439931600152, 24.7511180568289, 0.000919274985790253],
    [118.439474089956, 24.7517071762218, 0.000919347628951073],
  ],
  [
    [118.439915151984, 24.7511074139258, 0.000919273123145103],
    [118.439458284636, 24.7516969391355, 0.000919347628951073],
  ],
  [
    [118.439898684053, 24.7510967800606, 0.00091927032917738],
    [118.439442459566, 24.7516867291426, 0.000919345766305923],
  ],
  [
    [118.439882206251, 24.751086164255, 0.000919269397854805],
    [118.439426624618, 24.7516765281817, 0.000919343903660774],
  ],
  [
    [118.439865708693, 24.751075566515, 0.000919269397854805],
    [118.4394107798, 24.7516663452805, 0.0009193429723382],
  ],
  [
    [118.439849211145, 24.7510649778009, 0.000919266603887081],
    [118.439394925105, 24.7516561714113, 0.00091934110969305],
  ],
  [
    [118.43983269384, 24.7510544071523, 0.000919265672564507],
    [118.439379050653, 24.7516460156078, 0.000919339247047901],
  ],
  [
    [118.439816176551, 24.7510438545575, 0.000919265672564507],
    [118.43936317621, 24.7516358688303, 0.000919339247047901],
  ],
  [
    [118.439799639499, 24.7510333110004, 0.000919264741241932],
    [118.439347282011, 24.7516257401184, 0.000919337384402752],
  ],
  [
    [118.43978308269, 24.7510227855088, 0.000919261947274208],
    [118.439331387827, 24.7516156294604, 0.000919335521757603],
  ],
  [
    [118.439766525898, 24.751012278071, 0.000919260084629059],
    [118.43931547388, 24.7516055278402, 0.000919335521757603],
  ],
  [
    [118.439749959229, 24.751001779665, 0.000919259153306484],
    [118.439299550062, 24.7515954442797, 0.000919333659112453],
  ],
  [
    [118.439733372803, 24.7509912993245, 0.00091925822198391],
    [118.439283616367, 24.7515853697512, 0.000919333659112453],
  ],
  [
    [118.439716786393, 24.7509808370377, 0.00091925635933876],
    [118.439267672801, 24.7515753132824, 0.000919332727789879],
  ],
  [
    [118.439700180227, 24.7509703928164, 0.00091925635933876],
    [118.439251709479, 24.7515652748791, 0.000919329933822155],
  ],
  [
    [118.439683564184, 24.7509599576269, 0.000919253565371037],
    [118.439235746166, 24.751555245502, 0.00091932900249958],
  ],
  [
    [118.439666928378, 24.7509495314751, 0.000919252634048462],
    [118.439219772982, 24.7515452341845, 0.000919328071177006],
  ],
  [
    [118.439650292594, 24.7509391324048, 0.000919251702725887],
    [118.439203780042, 24.7515352409326, 0.000919325277209282],
  ],
  [
    [118.439633646934, 24.7509287423664, 0.000919251702725887],
    [118.439187777224, 24.7515252567127, 0.000919324345886707],
  ],
  [
    [118.439616981517, 24.7509183703934, 0.000919248908758163],
    [118.439171764536, 24.7515152905524, 0.000919323414564133],
  ],
  [
    [118.439600306224, 24.7509080074522, 0.000919247977435589],
    [118.439155751856, 24.7515053334182, 0.000919322483241558],
  ],
  [
    [118.43958362106, 24.7508976625706, 0.000919247977435589],
    [118.43913971942, 24.7514953943495, 0.000919322483241558],
  ],
  [
    [118.439566926025, 24.7508873357485, 0.000919245183467865],
    [118.439123667221, 24.7514854643187, 0.000919319689273834],
  ],
  [
    [118.439550221114, 24.7508770179583, 0.00091924425214529],
    [118.439107615044, 24.7514755613694, 0.000919319689273834],
  ],
  [
    [118.439533506339, 24.7508667272554, 0.000919242389500141],
    [118.439091552983, 24.7514656584242, 0.00091931875795126],
  ],
  [
    [118.439516771795, 24.7508564365624, 0.000919241458177567],
    [118.439075481058, 24.7514557825665, 0.00091931689530611],
  ],
  [
    [118.439500027387, 24.7508461729567, 0.000919239595532417],
    [118.439059389369, 24.7514459157466, 0.00091931689530611],
  ],
  [
    [118.439483282988, 24.7508359183769, 0.000919238664209843],
    [118.439043297697, 24.7514360669804, 0.000919315032660961],
  ],
  [
    [118.439466518833, 24.7508256818626, 0.000919236801564693],
    [118.43902718626, 24.7514262272521, 0.000919313170015812],
  ],
  [
    [118.439449744807, 24.7508154634078, 0.000919234938919544],
    [118.439011064954, 24.7514164055833, 0.000919309444725513],
  ],
  [
    [118.439432960905, 24.7508052539848, 0.000919234938919544],
    [118.438994943656, 24.7514065929406, 0.000919310376048088],
  ],
  [
    [118.439416157246, 24.7507950626272, 0.000919234938919544],
    [118.438978802601, 24.7513967983634, 0.000919308513402939],
  ],
  [
    [118.439399353602, 24.7507848893232, 0.00091923214495182],
    [118.438962651676, 24.7513870218459, 0.000919309444725513],
  ],
  [
    [118.439382530196, 24.7507747250569, 0.000919231213629246],
    [118.43894649088, 24.751377263388, 0.000919308513402939],
  ],
  [
    [118.439365706806, 24.7507645788442, 0.000919229350984097],
    [118.438930310321, 24.7513675139679, 0.000919307582080364],
  ],
  [
    [118.439348863659, 24.750754450697, 0.000919229350984097],
    [118.438914129771, 24.7513577735737, 0.000919303856790066],
  ],
  [
    [118.439332010635, 24.7507443315815, 0.000919225625693798],
    [118.438897939356, 24.751348060267, 0.000919302925467491],
  ],
  [
    [118.439315147748, 24.7507342395533, 0.000919226557016373],
    [118.438881739064, 24.7513383559921, 0.000919301062822342],
  ],
  [
    [118.439298274977, 24.750724147529, 0.000919224694371223],
    [118.43886551901, 24.751328660755, 0.000919299200177193],
  ],
  [
    [118.439281392342, 24.7507140825921, 0.000919222831726074],
    [118.43884929897, 24.7513189835716, 0.000919300131499767],
  ],
  [
    [118.439264489944, 24.7507040266927, 0.000919222831726074],
    [118.438833059174, 24.7513093244537, 0.000919297337532043],
  ],
  [
    [118.439247587562, 24.750693988847, 0.000919219106435776],
    [118.438816809507, 24.7512996833954, 0.000919296406209469],
  ],
  [
    [118.439230665423, 24.7506839690667, 0.00091922003775835],
    [118.438800559849, 24.7512900513631, 0.000919296406209469],
  ],
  [
    [118.439213743294, 24.7506739583122, 0.00091922003775835],
    [118.438784290434, 24.7512804373963, 0.00091929454356432],
  ],
  [
    [118.439196801408, 24.750663965623, 0.000919216312468052],
    [118.438768011142, 24.7512708324613, 0.00091929268091917],
  ],
  [
    [118.439179849652, 24.7506539909934, 0.000919216312468052],
    [118.438751721979, 24.751261245586, 0.000919291749596596],
  ],
  [
    [118.439162888025, 24.7506440344233, 0.000919214449822903],
    [118.438735422945, 24.7512516767702, 0.000919290818274021],
  ],
  [
    [118.439145916521, 24.7506340868848, 0.000919212587177753],
    [118.438719114035, 24.7512421169863, 0.000919288955628872],
  ],
  [
    [118.439128935147, 24.7506241574059, 0.000919212587177753],
    [118.438702795253, 24.7512325752619, 0.000919288024306297],
  ],
  [
    [118.439111943896, 24.7506142369586, 0.000919210724532604],
    [118.438686466601, 24.7512230515972, 0.000919287092983723],
  ],
  [
    [118.439094932895, 24.7506043436045, 0.000919208861887455],
    [118.438670128072, 24.7512135369643, 0.000919287092983723],
  ],
  [
    [118.439077921904, 24.7505944592761, 0.000919208861887455],
    [118.438653779671, 24.7512040403909, 0.000919284299015999],
  ],
  [
    [118.439060891155, 24.7505845930132, 0.000919206999242306],
    [118.438637421394, 24.7511945528494, 0.00091928243637085],
  ],
  [
    [118.43904385053, 24.7505747357819, 0.00091920793056488],
    [118.438621043366, 24.7511850924011, 0.00091928243637085],
  ],
  [
    [118.439026809921, 24.7505648966042, 0.000919204205274582],
    [118.438604665341, 24.7511756319509, 0.000919279642403126],
  ],
  [
    [118.439009749554, 24.7505550754918, 0.000919203273952007],
    [118.438588277451, 24.7511661985881, 0.000919281505048275],
  ],
  [
    [118.438992679318, 24.7505452724388, 0.000919202342629433],
    [118.438571869799, 24.751156774263, 0.000919279642403126],
  ],
  [
    [118.438975599204, 24.7505354784176, 0.000919200479984283],
    [118.438555462161, 24.7511473679916, 0.000919278711080551],
  ],
  [
    [118.43895850922, 24.7505257024558, 0.000919199548661709],
    [118.43853903476, 24.7511379707578, 0.000919275917112827],
  ],
  [
    [118.438941409366, 24.7505159445534, 0.00091919768601656],
    [118.438522607381, 24.7511286006055, 0.000919275917112827],
  ],
  [
    [118.438924299641, 24.7505062047104, 0.000919196754693985],
    [118.438506160232, 24.7511192304631, 0.000919274985790253],
  ],
  [
    [118.438907170153, 24.750496473905, 0.000919196754693985],
    [118.438489703219, 24.7511098874079, 0.000919273123145103],
  ],
  [
    [118.438890040681, 24.7504867611532, 0.000919194892048836],
    [118.438473246214, 24.7511005533788, 0.000919272191822529],
  ],
  [
    [118.438872891452, 24.7504770664666, 0.000919193960726261],
    [118.438456769453, 24.751091237415, 0.00091927032917738],
  ],
  [
    [118.438855742232, 24.7504673808058, 0.000919192098081112],
    [118.438440282815, 24.751081930483, 0.000919269397854805],
  ],
  [
    [118.438838573256, 24.7504577132103, 0.000919192098081112],
    [118.438423796191, 24.7510726416047, 0.00091926846653223],
  ],
  [
    [118.438821404295, 24.7504480636684, 0.000919189304113388],
    [118.438407289811, 24.7510633707917, 0.000919266603887081],
  ],
  [
    [118.438804215578, 24.7504384321917, 0.000919188372790813],
    [118.438390773554, 24.7510541090106, 0.000919264741241932],
  ],
  [
    [118.438787016984, 24.7504288097467, 0.000919187441468239],
    [118.438374247426, 24.751044865289, 0.000919265672564507],
  ],
  [
    [118.438769808525, 24.7504192143888, 0.000919186510145664],
    [118.438357711427, 24.7510356396268, 0.000919262878596783],
  ],
  [
    [118.438752600076, 24.7504096280567, 0.00091918557882309],
    [118.43834116555, 24.7510264229965, 0.000919261947274208],
  ],
  [
    [118.438735381756, 24.7504000597841, 0.00091918371617794],
    [118.438324599917, 24.7510172244315, 0.000919261015951633],
  ],
  [
    [118.438718143673, 24.7503905005489, 0.00091918371617794],
    [118.438308034293, 24.7510080348924, 0.000919259153306484],
  ],
  [
    [118.438700905612, 24.750380968395, 0.000919180922210217],
    [118.438291448912, 24.7509988634187, 0.000919259153306484],
  ],
  [
    [118.43868366756, 24.7503714452668, 0.000919179990887642],
    [118.438274853653, 24.7509897009767, 0.000919259153306484],
  ],
  [
    [118.438666409752, 24.7503619402039, 0.000919179990887642],
    [118.438258248517, 24.7509805475664, 0.00091925635933876],
  ],
  [
    [118.438649151959, 24.7503524531946, 0.000919179059565067],
    [118.438241623631, 24.7509714212493, 0.000919255428016186],
  ],
  [
    [118.438631874409, 24.7503429842505, 0.000919177196919918],
    [118.438224998747, 24.7509622949302, 0.000919253565371037],
  ],
  [
    [118.438614596869, 24.7503335243321, 0.000919174402952194],
    [118.438208354107, 24.7509531866765, 0.000919252634048462],
  ],
  [
    [118.43859731935, 24.750324091495, 0.00091917347162962],
    [118.438191699595, 24.7509440964823, 0.000919251702725887],
  ],
  [
    [118.438580022068, 24.7503146676954, 0.000919174402952194],
    [118.438175035206, 24.7509350153198, 0.000919251702725887],
  ],
  [
    [118.438562724795, 24.7503052529215, 0.000919172540307045],
    [118.43815836094, 24.750925943189, 0.000919249840080738],
  ],
  [
    [118.438545417658, 24.7502958652348, 0.00091917160898447],
    [118.438141676803, 24.7509168891177, 0.000919247977435589],
  ],
  [
    [118.438528100644, 24.7502864865797, 0.000919169746339321],
    [118.438124972903, 24.7509078440839, 0.000919247977435589],
  ],
  [
    [118.438510783646, 24.7502771259781, 0.000919169746339321],
    [118.438108269018, 24.7508988171038, 0.00091924611479044],
  ],
  [
    [118.438493446884, 24.7502677744139, 0.000919167883694172],
    [118.438091545369, 24.7508897991612, 0.000919245183467865],
  ],
  [
    [118.438476120031, 24.7502584499252, 0.000919165089726448],
    [118.43807482173, 24.7508807902445, 0.00091924425214529],
  ],
  [
    [118.438458773414, 24.7502491344738, 0.000919165089726448],
    [118.438058078333, 24.750871799393, 0.00091924425214529],
  ],
  [
    [118.438441426806, 24.7502398280483, 0.000919163227081299],
    [118.438041325059, 24.7508628175733, 0.000919242389500141],
  ],
  [
    [118.438424070328, 24.7502305396821, 0.000919162295758724],
    [118.438024561908, 24.7508538447852, 0.000919241458177567],
  ],
  [
    [118.438406703978, 24.7502212693752, 0.000919162295758724],
    [118.438007788886, 24.7508448900566, 0.000919239595532417],
  ],
  [
    [118.438389327759, 24.7502120171277, 0.000919160433113575],
    [118.437991005987, 24.7508359443596, 0.000919237732887268],
  ],
  [
    [118.438371951548, 24.7502027739059, 0.000919158570468426],
    [118.437974213217, 24.7508270167221, 0.000919237732887268],
  ],
  [
    [118.438354575352, 24.7501935487376, 0.000919157639145851],
    [118.437957410569, 24.7508180981163, 0.000919237732887268],
  ],
  [
    [118.438337179394, 24.7501843326067, 0.000919157639145851],
    [118.437940588158, 24.750809188548, 0.000919235870242119],
  ],
  [
    [118.438319783451, 24.7501751345293, 0.000919154845178127],
    [118.437923765756, 24.7508002880055, 0.000919234938919544],
  ],
  [
    [118.438302387523, 24.7501659545054, 0.000919153913855553],
    [118.437906933483, 24.7507914055224, 0.000919233076274395],
  ],
  [
    [118.438284971832, 24.7501567835189, 0.000919153913855553],
    [118.437890091333, 24.7507825320711, 0.00091923214495182],
  ],
  [
    [118.43826755615, 24.7501476215581, 0.000919152051210403],
    [118.437873229419, 24.7507736676571, 0.00091923214495182],
  ],
  [
    [118.43825014049, 24.7501384866786, 0.000919151119887829],
    [118.437856367521, 24.7507648212968, 0.000919230282306671],
  ],
  [
    [118.438232714946, 24.7501293518029, 0.00091914925724268],
    [118.437839495745, 24.7507559839682, 0.000919229350984097],
  ],
  [
    [118.438215279538, 24.7501202440143, 0.000919148325920105],
    [118.437822604206, 24.750747155677, 0.000919226557016373],
  ],
  [
    [118.438197844133, 24.7501111362236, 0.000919146463274956],
    [118.437805712675, 24.7507383364116, 0.000919226557016373],
  ],
  [
    [118.438180398863, 24.75010205552, 0.00091914739459753],
    [118.437788811274, 24.7507295352057, 0.000919224694371223],
  ],
  [
    [118.438162943716, 24.7500929838479, 0.000919145531952381],
    [118.437771890103, 24.7507207340094, 0.000919222831726074],
  ],
  [
    [118.438145488578, 24.7500839212016, 0.000919143669307232],
    [118.437754968947, 24.7507119508667, 0.0009192219004035],
  ],
  [
    [118.438128033456, 24.7500748766087, 0.000919143669307232],
    [118.43773803792, 24.7507031857834, 0.0009192219004035],
  ],
  [
    [118.43811055857, 24.7500658410532, 0.000919142737984657],
    [118.43772109701, 24.750694420704, 0.00091922003775835],
  ],
  [
    [118.438093093585, 24.7500568235454, 0.000919140875339508],
    [118.437704146222, 24.7506856646562, 0.000919220969080925],
  ],
  [
    [118.438075608838, 24.7500478150749, 0.000919139944016933],
    [118.437687175677, 24.7506769266736, 0.000919218175113201],
  ],
  [
    [118.438058133992, 24.7500388246521, 0.000919138081371784],
    [118.437670205141, 24.7506681977168, 0.000919218175113201],
  ],
  [
    [118.438040639382, 24.7500298432666, 0.000919136218726635],
    [118.437653234613, 24.7506594777858, 0.000919217243790627],
  ],
  [
    [118.438023154668, 24.750020870901, 0.00091913715004921],
    [118.437636244322, 24.7506507668923, 0.000919215381145477],
  ],
  [
    [118.438005650196, 24.7500119166006, 0.00091913528740406],
    [118.437619244154, 24.7506420650303, 0.000919215381145477],
  ],
  [
    [118.437988145734, 24.7500029713258, 0.00091913528740406],
    [118.437602234115, 24.7506333812278, 0.000919213518500328],
  ],
  [
    [118.437970641286, 24.7499940441045, 0.000919132493436337],
    [118.437585224078, 24.7506246974232, 0.000919211655855179],
  ],
  [
    [118.437953126962, 24.7499851259147, 0.000919132493436337],
    [118.437568194284, 24.7506160316839, 0.000919211655855179],
  ],
  [
    [118.437935612647, 24.7499762167507, 0.000919130630791187],
    [118.437551164499, 24.7506073749703, 0.000919210724532604],
  ],
  [
    [118.43791808846, 24.7499673256459, 0.000919129699468613],
    [118.437534124837, 24.7505987272883, 0.000919208861887455],
  ],
  [
    [118.437900564283, 24.7499584435668, 0.000919129699468613],
    [118.437517075297, 24.750590088638, 0.000919206067919731],
  ],
  [
    [118.437883030235, 24.7499495795469, 0.000919127836823463],
    [118.437500015874, 24.7505814499914, 0.000919206999242306],
  ],
  [
    [118.437865496189, 24.7499407155251, 0.000919125974178314],
    [118.437482946585, 24.750572838432, 0.000919205136597157],
  ],
  [
    [118.437847952279, 24.7499318785902, 0.000919124111533165],
    [118.437465867414, 24.7505642268763, 0.000919205136597157],
  ],
  [
    [118.437830408371, 24.7499230416533, 0.00091912318021059],
    [118.437448788251, 24.7505556243465, 0.000919205136597157],
  ],
  [
    [118.437812854593, 24.7499142227756, 0.000919124111533165],
    [118.437431689324, 24.7505470308541, 0.000919202342629433],
  ],
  [
    [118.437795300823, 24.7499054129237, 0.000919121317565441],
    [118.437414590406, 24.7505384463874, 0.000919200479984283],
  ],
  [
    [118.437777747062, 24.7498966120974, 0.000919119454920292],
    [118.437397481611, 24.7505298709523, 0.000919199548661709],
  ],
  [
    [118.437760183424, 24.7498878203027, 0.000919118523597717],
    [118.437380362939, 24.7505213045488, 0.000919199548661709],
  ],
  [
    [118.437742619801, 24.7498790465614, 0.000919117592275143],
    [118.437363244275, 24.750512747171, 0.00091919768601656],
  ],
  [
    [118.437725046301, 24.7498702818516, 0.000919117592275143],
    [118.437346105854, 24.7505042078584, 0.00091919768601656],
  ],
  [
    [118.43770747281, 24.7498615261674, 0.000919116660952568],
    [118.437328967435, 24.7504956685438, 0.00091919582337141],
  ],
  [
    [118.437689899334, 24.7498527885368, 0.000919114798307419],
    [118.437311819139, 24.7504871382607, 0.000919194892048836],
  ],
  [
    [118.437672315974, 24.7498440509098, 0.000919114798307419],
    [118.437294660966, 24.7504786170092, 0.000919193960726261],
  ],
  [
    [118.43765473263, 24.7498353313364, 0.000919112004339695],
    [118.437277492915, 24.7504701047892, 0.000919193029403687],
  ],
  [
    [118.437637139408, 24.7498266207943, 0.000919112004339695],
    [118.437260324867, 24.7504615925673, 0.000919191166758537],
  ],
  [
    [118.437619546195, 24.749817919278, 0.000919112004339695],
    [118.437243137062, 24.7504530984104, 0.000919190235435963],
  ],
  [
    [118.437601952998, 24.7498092358152, 0.000919110141694546],
    [118.437225949265, 24.7504446132793, 0.000919189304113388],
  ],
  [
    [118.437584349916, 24.749800552356, 0.000919107347726822],
    [118.437208761477, 24.750436137174, 0.000919188372790813],
  ],
  [
    [118.43756674685, 24.7497918869503, 0.000919107347726822],
    [118.437191553919, 24.7504276610782, 0.000919186510145664],
  ],
  [
    [118.437549143786, 24.7497832215425, 0.000919106416404247],
    [118.43717434637, 24.7504191940082, 0.000919186510145664],
  ],
  [
    [118.437531530852, 24.7497745741939, 0.000919104553759098],
    [118.43715712895, 24.7504107449975, 0.000919184647500515],
  ],
  [
    [118.437513927812, 24.7497659358653, 0.000919105485081673],
    [118.437139901646, 24.7504022959905, 0.000919184647500515],
  ],
  [
    [118.437496305015, 24.7497573156016, 0.000919102691113949],
    [118.43712267435, 24.7503938560094, 0.00091918371617794],
  ],
  [
    [118.437478692107, 24.7497486953301, 0.000919102691113949],
    [118.437105427285, 24.7503854160377, 0.000919181853532791],
  ],
  [
    [118.437461069321, 24.7497400840901, 0.0009191008284688],
    [118.437088190121, 24.7503769941138, 0.000919180922210217],
  ],
  [
    [118.437443446544, 24.7497314818757, 0.0009191008284688],
    [118.437070933194, 24.7503685812271, 0.000919179059565067],
  ],
  [
    [118.437425813897, 24.7497228977206, 0.00091909896582365],
    [118.437053676269, 24.7503601683385, 0.000919179059565067],
  ],
  [
    [118.437408181251, 24.7497143135633, 0.000919098034501076],
    [118.437036409466, 24.7503517644814, 0.000919178128242493],
  ],
  [
    [118.437390548621, 24.7497057474595, 0.000919096171855927],
    [118.437019132786, 24.7503433696558, 0.000919176265597343],
  ],
  [
    [118.437372915993, 24.7496971813537, 0.000919095240533352],
    [118.437001846223, 24.7503349748339, 0.000919176265597343],
  ],
  [
    [118.437355273494, 24.749688633307, 0.000919093377888203],
    [118.436984559674, 24.7503265980655, 0.000919174402952194],
  ],
  [
    [118.437337640884, 24.7496800852525, 0.000919093377888203],
    [118.436967263242, 24.7503182213009, 0.00091917347162962],
  ],
  [
    [118.437319998403, 24.7496715552572, 0.000919091515243053],
    [118.436949966818, 24.750309853562, 0.00091917160898447],
  ],
  [
    [118.437302346038, 24.7496630252656, 0.000919091515243053],
    [118.436932660511, 24.7503014858269, 0.000919170677661896],
  ],
  [
    [118.437284703574, 24.7496545133216, 0.000919089652597904],
    [118.436915344332, 24.750293136151, 0.000919170677661896],
  ],
  [
    [118.437267051226, 24.7496460013814, 0.000919089652597904],
    [118.436898028156, 24.7502847864731, 0.000919168815016747],
  ],
  [
    [118.437249398894, 24.7496375074945, 0.00091908685863018],
    [118.436880702102, 24.7502764458267, 0.000919168815016747],
  ],
  [
    [118.437231746564, 24.7496290136056, 0.000919087789952755],
    [118.436863366165, 24.750268105184, 0.000919166952371597],
  ],
  [
    [118.437214084357, 24.7496205287481, 0.000919084064662457],
    [118.436846030236, 24.7502597735671, 0.000919166952371597],
  ],
  [
    [118.437196422158, 24.7496120529163, 0.000919084064662457],
    [118.43682868443, 24.7502514509816, 0.000919164158403873],
  ],
  [
    [118.437178759968, 24.7496035861101, 0.000919083133339882],
    [118.436811328746, 24.7502431374276, 0.000919164158403873],
  ],
  [
    [118.437161097787, 24.7495951283297, 0.000919082202017307],
    [118.436793973065, 24.7502348238716, 0.000919162295758724],
  ],
  [
    [118.437143435615, 24.7495866795748, 0.000919081270694733],
    [118.436776607507, 24.750226519347, 0.000919162295758724],
  ],
  [
    [118.437125773451, 24.7495782398457, 0.000919081270694733],
    [118.436759232064, 24.7502182148262, 0.000919162295758724],
  ],
  [
    [118.437108101403, 24.7495698001202, 0.000919080339372158],
    [118.43674185663, 24.750209919331, 0.000919160433113575],
  ],
  [
    [118.437090429371, 24.7495613784482, 0.000919078476727009],
    [118.436724481205, 24.7502016328617, 0.000919156707823277],
  ],
  [
    [118.437072757341, 24.7495529567741, 0.000919077545404434],
    [118.43670708601, 24.7501933464017, 0.000919158570468426],
  ],
  [
    [118.437055085319, 24.7495445441256, 0.00091907661408186],
    [118.43668970071, 24.7501850689618, 0.000919157639145851],
  ],
  [
    [118.437037413307, 24.7495361405028, 0.00091907661408186],
    [118.436672295646, 24.750176800559, 0.000919155776500702],
  ],
  [
    [118.437019731417, 24.7495277459115, 0.00091907475143671],
    [118.436654890585, 24.7501685321542, 0.000919155776500702],
  ],
  [
    [118.437002059421, 24.74951936034, 0.000919072888791561],
    [118.436637485526, 24.7501602637473, 0.000919152982532978],
  ],
  [
    [118.436984377542, 24.7495109747722, 0.000919071026146412],
    [118.436620070589, 24.7501520043719, 0.000919152982532978],
  ],
  [
    [118.436966695672, 24.7495025982301, 0.000919070094823837],
    [118.436602645775, 24.750143754028, 0.000919152051210403],
  ],
  [
    [118.43694901381, 24.7494942307136, 0.000919070094823837],
    [118.436585220964, 24.750135503682, 0.000919150188565254],
  ],
  [
    [118.436931331957, 24.7494858722228, 0.000919068232178688],
    [118.436567786275, 24.7501272623674, 0.00091914925724268],
  ],
  [
    [118.436913650106, 24.7494775137299, 0.000919067300856113],
    [118.436550351588, 24.7501190210508, 0.00091914739459753],
  ],
  [
    [118.436895958378, 24.7494691642684, 0.000919065438210964],
    [118.436532907024, 24.7501107887657, 0.000919148325920105],
  ],
  [
    [118.436878276545, 24.7494608238269, 0.000919065438210964],
    [118.436515462468, 24.7501025655062, 0.00091914739459753],
  ],
  [
    [118.436860594714, 24.7494524833832, 0.000919065438210964],
    [118.436498008022, 24.7500943332227, 0.000919145531952381],
  ],
  [
    [118.436842903012, 24.7494441609987, 0.00091906450688839],
    [118.436480543706, 24.7500861189984, 0.000919144600629807],
  ],
  [
    [118.436825211312, 24.7494358386121, 0.000919061712920666],
    [118.436463079385, 24.7500778957442, 0.000919142737984657],
  ],
  [
    [118.436807519615, 24.7494275162234, 0.000919060781598091],
    [118.436445615073, 24.7500696815157, 0.000919141806662083],
  ],
  [
    [118.436789837812, 24.7494192028547, 0.000919059850275517],
    [118.436428140883, 24.7500614763187, 0.000919140875339508],
  ],
  [
    [118.436772146132, 24.7494108985173, 0.000919058918952942],
    [118.436410666696, 24.7500532711196, 0.000919139944016933],
  ],
  [
    [118.43675445446, 24.7494026032056, 0.000919057987630367],
    [118.436393182631, 24.750045074952, 0.000919139012694359],
  ],
  [
    [118.436736762791, 24.7493943078918, 0.000919059850275517],
    [118.436375698562, 24.7500368697545, 0.000919138081371784],
  ],
  [
    [118.43671907113, 24.7493860216037, 0.000919057056307793],
    [118.436358204622, 24.7500286826162, 0.000919136218726635],
  ],
  [
    [118.436701369593, 24.749377744347, 0.000919055193662643],
    [118.436340700792, 24.7500204864538, 0.00091913528740406],
  ],
  [
    [118.436683677943, 24.7493694670824, 0.000919054262340069],
    [118.436323206857, 24.7500122993114, 0.000919136218726635],
  ],
  [
    [118.436665986296, 24.7493611898158, 0.000919053331017494],
    [118.436305693158, 24.750004121206, 0.00091913528740406],
  ],
  [
    [118.436648294663, 24.7493529306025, 0.00091905239969492],
    [118.436288189341, 24.7499959340652, 0.000919132493436337],
  ],
  [
    [118.436630603027, 24.7493446623594, 0.000919048674404621],
    [118.436270675654, 24.7499877649835, 0.000919132493436337],
  ],
  [
    [118.436612901519, 24.7493364121755, 0.000919048674404621],
    [118.436253152076, 24.7499795868777, 0.000919131562113762],
  ],
  [
    [118.4365952099, 24.7493281619837, 0.000919049605727196],
    [118.436235628506, 24.7499714177976, 0.000919130630791187],
  ],
  [
    [118.436577518283, 24.7493199117898, 0.000919047743082047],
    [118.436218104939, 24.7499632487155, 0.000919127836823463],
  ],
  [
    [118.436559816789, 24.7493116706274, 0.000919047743082047],
    [118.436200571488, 24.7499550796369, 0.000919126905500889],
  ],
  [
    [118.436542125189, 24.7493034384848, 0.000919045880436897],
    [118.43618302816, 24.7499469195898, 0.000919125974178314],
  ],
  [
    [118.436524433592, 24.7492952063402, 0.000919044017791748],
    [118.43616549472, 24.7499387595349, 0.000919125974178314],
  ],
  [
    [118.436506741997, 24.7492869741934, 0.000919043086469173],
    [118.436147951397, 24.7499305994836, 0.000919125974178314],
  ],
  [
    [118.436489040525, 24.7492787510781, 0.000919044017791748],
    [118.436130398189, 24.7499224394359, 0.000919122248888016],
  ],
  [
    [118.436471348947, 24.7492705369827, 0.000919044017791748],
    [118.436112844991, 24.7499142884139, 0.00091912318021059],
  ],
  [
    [118.436453657365, 24.7492623138574, 0.000919043086469173],
    [118.436095291794, 24.7499061373899, 0.000919121317565441],
  ],
  [
    [118.436435965798, 24.7492541087856, 0.00091904029250145],
    [118.436077728714, 24.7498979863694, 0.000919120386242867],
  ],
  [
    [118.436418274233, 24.7492459037116, 0.000919039361178875],
    [118.436060165642, 24.7498898443747, 0.000919121317565441],
  ],
  [
    [118.436400582671, 24.7492376986356, 0.000919037498533726],
    [118.436042602567, 24.7498816933501, 0.000919118523597717],
  ],
  [
    [118.436382891117, 24.7492295025852, 0.000919037498533726],
    [118.436025029614, 24.7498735513569, 0.000919118523597717],
  ],
  [
    [118.436365199566, 24.7492213065327, 0.000919035635888577],
    [118.436007456663, 24.7498654093616, 0.000919115729629993],
  ],
  [
    [118.436347508016, 24.7492131104781, 0.000919034704566002],
    [118.435989873829, 24.7498572673699, 0.000919114798307419],
  ],
  [
    [118.436329826362, 24.7492049234435, 0.000919032841920853],
    [118.435972291003, 24.7498491344039, 0.000919113866984844],
  ],
  [
    [118.436312134823, 24.7491967364125, 0.000919030979275703],
    [118.435954708173, 24.7498409924081, 0.000919113866984844],
  ],
  [
    [118.436294443293, 24.7491885584071, 0.000919031910598278],
    [118.435937115465, 24.7498328594436, 0.000919112004339695],
  ],
  [
    [118.436276761652, 24.749180380394, 0.000919030047953129],
    [118.43591952276, 24.749824726477, 0.00091911107301712],
  ],
  [
    [118.436259070127, 24.7491722023844, 0.000919030047953129],
    [118.435901930058, 24.7498165935084, 0.000919110141694546],
  ],
  [
    [118.436241388496, 24.7491640333949, 0.000919027253985405],
    [118.435884327471, 24.7498084605433, 0.000919109210371971],
  ],
  [
    [118.436223706868, 24.7491558644032, 0.000919027253985405],
    [118.435866724887, 24.7498003275762, 0.000919109210371971],
  ],
  [
    [118.436206025242, 24.7491476954094, 0.000919027253985405],
    [118.435849122305, 24.749792194607, 0.000919108279049397],
  ],
  [
    [118.436188343618, 24.7491395264135, 0.000919025391340256],
    [118.435831519726, 24.7497840616356, 0.000919106416404247],
  ],
  [
    [118.436170662002, 24.7491313664433, 0.000919023528695107],
    [118.435813907269, 24.7497759376957, 0.000919105485081673],
  ],
  [
    [118.436152990275, 24.7491232064653, 0.000919023528695107],
    [118.435796294808, 24.7497678047259, 0.000919104553759098],
  ],
  [
    [118.436135308671, 24.7491150555187, 0.000919024460017681],
    [118.435778672469, 24.7497596807874, 0.000919103622436523],
  ],
  [
    [118.436117636948, 24.7491068955365, 0.000919019803404808],
    [118.435761050127, 24.7497515478191, 0.0009191008284688],
  ],
  [
    [118.436099955349, 24.7490987445857, 0.000919018872082233],
    [118.435743427793, 24.7497434238764, 0.0009191008284688],
  ],
  [
    [118.436082283637, 24.749090593627, 0.000919019803404808],
    [118.435725805456, 24.7497352909039, 0.000919099897146225],
  ],
  [
    [118.436064611934, 24.7490824516941, 0.000919017940759659],
    [118.43570817324, 24.7497271669628, 0.0009191008284688],
  ],
  [
    [118.436046940227, 24.7490743007313, 0.000919017940759659],
    [118.435690550907, 24.7497190339861, 0.00091909896582365],
  ],
  [
    [118.436029278414, 24.7490661587885, 0.000919017009437084],
    [118.435672908811, 24.7497109100464, 0.000919098034501076],
  ],
  [
    [118.436011606718, 24.7490580168492, 0.000919015146791935],
    [118.435655276596, 24.7497027770712, 0.000919097103178501],
  ],
  [
    [118.43599394491, 24.7490498749022, 0.00091901421546936],
    [118.435637634504, 24.7496946531273, 0.000919094309210777],
  ],
  [
    [118.435976283104, 24.7490417329531, 0.000919013284146786],
    [118.435620002294, 24.7496865201479, 0.000919094309210777],
  ],
  [
    [118.435958621307, 24.7490336000297, 0.000919012352824211],
    [118.435602350321, 24.7496783962055, 0.000919092446565628],
  ],
  [
    [118.435940959512, 24.7490254671042, 0.000919011421501637],
    [118.43558470823, 24.7496702632276, 0.000919090583920479],
  ],
  [
    [118.435923307599, 24.7490173251431, 0.000919010490179062],
    [118.435567066141, 24.7496621302476, 0.000919091515243053],
  ],
  [
    [118.435905655694, 24.7490091922077, 0.000919008627533913],
    [118.435549414168, 24.7496539972711, 0.000919090583920479],
  ],
  [
    [118.435888003792, 24.7490010592702, 0.000919007696211338],
    [118.435531762198, 24.7496458642926, 0.00091908872127533],
  ],
  [
    [118.435870351892, 24.7489929263307, 0.000919006764888763],
    [118.435514100344, 24.7496377313176, 0.000919087789952755],
  ],
  [
    [118.435852699995, 24.748984793389, 0.000919005833566189],
    [118.435496448378, 24.7496295983348, 0.00091908685863018],
  ],
  [
    [118.435835057991, 24.7489766694674, 0.000919004902243614],
    [118.435478786522, 24.7496214563279, 0.00091908685863018],
  ],
  [
    [118.435817406098, 24.7489685365215, 0.00091900397092104],
    [118.435461134561, 24.7496133233409, 0.000919085927307606],
  ],
  [
    [118.435799773979, 24.7489604035622, 0.000919003039598465],
    [118.43544347271, 24.7496051813298, 0.000919083133339882],
  ],
  [
    [118.435782131983, 24.7489522796343, 0.00091900210827589],
    [118.435425800982, 24.7495970483499, 0.000919082202017307],
  ],
  [
    [118.435764489983, 24.7489441466765, 0.000919001176953316],
    [118.435408139135, 24.7495889063346, 0.000919082202017307],
  ],
  [
    [118.435746857877, 24.7489360227388, 0.000918999314308167],
    [118.435390467399, 24.749580755295, 0.000919080339372158],
  ],
  [
    [118.435729225767, 24.7489278897711, 0.000918996520340443],
    [118.435372805557, 24.7495726132754, 0.000919079408049583],
  ],
  [
    [118.435711593666, 24.7489197658292, 0.000918999314308167],
    [118.435355133826, 24.7495644622316, 0.000919078476727009],
  ],
  [
    [118.435693971453, 24.7489116418795, 0.000918996520340443],
    [118.435337462102, 24.7495563202135, 0.000919078476727009],
  ],
  [
    [118.435676349236, 24.7489035089, 0.000918995589017868],
    [118.435319790375, 24.7495481691655, 0.000919077545404434],
  ],
  [
    [118.435658727027, 24.7488953849461, 0.000918994657695293],
    [118.435302108759, 24.7495400090933, 0.00091907475143671],
  ],
  [
    [118.435641104815, 24.7488872519624, 0.000918994657695293],
    [118.435284437036, 24.7495318580411, 0.000919075682759285],
  ],
  [
    [118.43562349249, 24.7488791189709, 0.000918990932404995],
    [118.435266755424, 24.7495236979647, 0.000919073820114136],
  ],
  [
    [118.435605880174, 24.7488709950051, 0.00091899000108242],
    [118.435249073814, 24.7495155378861, 0.000919071957468987],
  ],
  [
    [118.435588267855, 24.7488628620095, 0.00091899000108242],
    [118.435231402093, 24.7495073777999, 0.000919071026146412],
  ],
  [
    [118.435570665423, 24.7488547290062, 0.000918990932404995],
    [118.435213720481, 24.7494992086894, 0.000919070094823837],
  ],
  [
    [118.435553062994, 24.7488465960007, 0.000918988138437271],
    [118.435196038872, 24.7494910395767, 0.000919068232178688],
  ],
  [
    [118.435535460573, 24.748838472021, 0.000918986275792122],
    [118.435178347379, 24.7494828704676, 0.000919069163501263],
  ],
  [
    [118.435517868028, 24.748830329978, 0.000918987207114697],
    [118.435160665775, 24.7494747013508, 0.000919066369533539],
  ],
  [
    [118.435500265605, 24.7488221969663, 0.000918984413146973],
    [118.435142984166, 24.7494665232041, 0.000919066369533539],
  ],
  [
    [118.435482682957, 24.7488140639413, 0.000918982550501823],
    [118.435125292668, 24.7494583360332, 0.000919066369533539],
  ],
  [
    [118.435465090425, 24.7488059309198, 0.000918983481824398],
    [118.435107611065, 24.7494501578823, 0.000919063575565815],
  ],
  [
    [118.435447507775, 24.7487977888628, 0.000918982550501823],
    [118.435089919571, 24.7494419707072, 0.000919063575565815],
  ],
  [
    [118.435429925127, 24.7487896468037, 0.000918980687856674],
    [118.43507222808, 24.7494337835299, 0.000919061712920666],
  ],
  [
    [118.435412352368, 24.748781504737, 0.000918980687856674],
    [118.435054536585, 24.7494255873228, 0.000919061712920666],
  ],
  [
    [118.43539477961, 24.7487733626681, 0.000918980687856674],
    [118.435036854978, 24.7494173911079, 0.000919059850275517],
  ],
  [
    [118.435377206855, 24.7487652205972, 0.00091897789388895],
    [118.435019163482, 24.7494091858688, 0.000919059850275517],
  ],
  [
    [118.435359643982, 24.7487570694908, 0.000918976962566376],
    [118.435001471987, 24.7494009806276, 0.000919057056307793],
  ],
  [
    [118.435342081118, 24.7487489274101, 0.000918976031243801],
    [118.434983780495, 24.7493927753843, 0.000919057987630367],
  ],
  [
    [118.435324518249, 24.7487407762996, 0.000918975099921227],
    [118.434966089, 24.7493845611111, 0.000919057056307793],
  ],
  [
    [118.435306965263, 24.7487326161536, 0.000918974168598652],
    [118.434948397506, 24.7493763468358, 0.000919055193662643],
  ],
  [
    [118.435289412285, 24.7487244650333, 0.000918974168598652],
    [118.434930696123, 24.7493681235362, 0.000919054262340069],
  ],
  [
    [118.435271869189, 24.7487163048775, 0.000918971374630928],
    [118.434913004628, 24.7493599002289, 0.000919053331017494],
  ],
  [
    [118.435254326095, 24.7487081447197, 0.000918971374630928],
    [118.434895313136, 24.7493516769195, 0.000919053331017494],
  ],
  [
    [118.435236783003, 24.7486999845597, 0.000918970443308353],
    [118.434877621633, 24.7493434355525, 0.000919051468372345],
  ],
  [
    [118.4352192498, 24.7486918243921, 0.000918968580663204],
    [118.434859930139, 24.7493352032111, 0.000919048674404621],
  ],
  [
    [118.435201716593, 24.7486836551947, 0.000918968580663204],
    [118.434842238641, 24.7493269618399, 0.000919049605727196],
  ],
  [
    [118.435184193274, 24.7486754859896, 0.000918966718018055],
    [118.434824537254, 24.7493187114444, 0.000919048674404621],
  ],
  [
    [118.435166669951, 24.7486673077546, 0.00091896764934063],
    [118.434806845755, 24.7493104610411, 0.000919046811759472],
  ],
  [
    [118.435149146637, 24.7486591385453, 0.00091896578669548],
    [118.434789154251, 24.749302201608, 0.000919045880436897],
  ],
  [
    [118.435131633204, 24.7486509603006, 0.000918962061405182],
    [118.434771462751, 24.7492939421728, 0.000919044949114323],
  ],
  [
    [118.435114119768, 24.7486427730261, 0.000918963924050331],
    [118.434753771246, 24.7492856737078, 0.000919044017791748],
  ],
  [
    [118.435096616219, 24.7486345857438, 0.000918960198760033],
    [118.434736079738, 24.7492773962128, 0.000919042155146599],
  ],
  [
    [118.435079112674, 24.7486263984596, 0.000918960198760033],
    [118.434718388232, 24.7492691187157, 0.000919042155146599],
  ],
  [
    [118.435061619016, 24.7486182111676, 0.000918960198760033],
    [118.434700696722, 24.7492608321888, 0.000919041223824024],
  ],
  [
    [118.435044125354, 24.7486100148458, 0.000918959267437458],
    [118.434683005215, 24.7492525456598, 0.0009190384298563],
  ],
  [
    [118.435026641581, 24.7486018185164, 0.000918957404792309],
    [118.434665313703, 24.7492442501008, 0.0009190384298563],
  ],
  [
    [118.435009157803, 24.7485936131571, 0.000918956473469734],
    [118.434647622194, 24.7492359545398, 0.000919037498533726],
  ],
  [
    [118.434991683914, 24.7485854077901, 0.00091895554214716],
    [118.434629930682, 24.7492276499489, 0.000919036567211151],
  ],
  [
    [118.434974210021, 24.7485771933934, 0.000918956473469734],
    [118.434612239165, 24.7492193363281, 0.000919034704566002],
  ],
  [
    [118.434956746016, 24.748568978989, 0.000918954610824585],
    [118.434594557531, 24.7492110136719, 0.000919033773243427],
  ],
  [
    [118.434939282014, 24.7485607645825, 0.000918952748179436],
    [118.434576866013, 24.7492026910191, 0.000919034704566002],
  ],
  [
    [118.434921818007, 24.7485525411462, 0.000918950885534287],
    [118.434559184378, 24.7491943593309, 0.000919032841920853],
  ],
  [
    [118.434904363883, 24.7485443086745, 0.000918949022889137],
    [118.434541492858, 24.7491860276462, 0.000919030047953129],
  ],
  [
    [118.434886919653, 24.7485360852229, 0.000918949022889137],
    [118.434523811215, 24.7491776778982, 0.000919030979275703],
  ],
  [
    [118.434869475413, 24.7485278437137, 0.000918949022889137],
    [118.434506129574, 24.7491693281482, 0.000919029116630554],
  ],
  [
    [118.434852041061, 24.7485196021969, 0.000918947160243988],
    [118.434488447936, 24.749160978396, 0.00091902818530798],
  ],
  [
    [118.434834606711, 24.748511360678, 0.000918946228921413],
    [118.434470766288, 24.7491526105862, 0.00091902632266283],
  ],
  [
    [118.434817182243, 24.7485031101237, 0.000918946228921413],
    [118.434453084642, 24.7491442427743, 0.00091902632266283],
  ],
  [
    [118.434799757778, 24.7484948595674, 0.000918944366276264],
    [118.434435402992, 24.7491358659325, 0.000919024460017681],
  ],
  [
    [118.434782343195, 24.7484865999756, 0.000918942503631115],
    [118.434417721339, 24.7491274800608, 0.000919024460017681],
  ],
  [
    [118.434764938493, 24.7484783313485, 0.000918942503631115],
    [118.434400049573, 24.7491190941815, 0.000919023528695107],
  ],
  [
    [118.434747523908, 24.7484700627249, 0.00091894157230854],
    [118.434382377805, 24.7491106992722, 0.000919020734727383],
  ],
  [
    [118.434730129091, 24.7484617850603, 0.000918939709663391],
    [118.434364706032, 24.7491022953332, 0.000919019803404808],
  ],
  [
    [118.434712734277, 24.7484535073937, 0.000918938778340817],
    [118.434347034256, 24.7490938823642, 0.000919019803404808],
  ],
  [
    [118.434695349344, 24.7484452206917, 0.000918936915695667],
    [118.434329362476, 24.7490854603654, 0.000919018872082233],
  ],
  [
    [118.434677964414, 24.7484369339877, 0.000918937847018242],
    [118.434311690692, 24.7490770293367, 0.000919018872082233],
  ],
  [
    [118.434660589365, 24.7484286382483, 0.000918936915695667],
    [118.434294028796, 24.7490685983003, 0.000919017009437084],
  ],
  [
    [118.434643214313, 24.748420333479, 0.000918934121727943],
    [118.434276357011, 24.7490601582397, 0.00091901421546936],
  ],
  [
    [118.434625849149, 24.7484120287022, 0.000918934121727943],
    [118.434258695108, 24.7490517091435, 0.00091901421546936],
  ],
  [
    [118.434608493867, 24.74840371489, 0.000918933190405369],
    [118.434241033202, 24.7490432510176, 0.000919012352824211],
  ],
  [
    [118.434591138587, 24.7483954010757, 0.000918932259082794],
    [118.434223381177, 24.7490347838562, 0.000919011421501637],
  ],
  [
    [118.434573793183, 24.7483870691983, 0.000918933190405369],
    [118.434205719263, 24.7490263076704, 0.000919010490179062],
  ],
  [
    [118.434556457668, 24.7483787373133, 0.00091892946511507],
    [118.434188067232, 24.7490178224493, 0.000919010490179062],
  ],
  [
    [118.434539122154, 24.7483704054263, 0.000918930396437645],
    [118.434170415202, 24.7490093372261, 0.000919009558856487],
  ],
  [
    [118.434521786631, 24.7483620554817, 0.000918926671147347],
    [118.434152763163, 24.7490008339452, 0.000919006764888763],
  ],
  [
    [118.434504470882, 24.7483537055239, 0.000918926671147347],
    [118.434135111126, 24.7489923306622, 0.000919007696211338],
  ],
  [
    [118.434487155135, 24.7483453555642, 0.000918925739824772],
    [118.434117468966, 24.7489838093161, 0.000919005833566189],
  ],
  [
    [118.434469849264, 24.7483369875412, 0.000918923877179623],
    [118.434099816921, 24.7489752879734, 0.00091900397092104],
  ],
  [
    [118.434452543395, 24.7483286195163, 0.000918922945857048],
    [118.434082184645, 24.7489667575897, 0.00091900397092104],
  ],
  [
    [118.434435247409, 24.748320242456, 0.000918923877179623],
    [118.434064542474, 24.7489582091539, 0.00091900397092104],
  ],
  [
    [118.43441796131, 24.7483118653882, 0.000918922014534473],
    [118.434046900304, 24.7489496607161, 0.000919001176953316],
  ],
  [
    [118.434400675202, 24.7483034702627, 0.00091891922056675],
    [118.434029268017, 24.7489411032428, 0.000919001176953316],
  ],
  [
    [118.434383398982, 24.7482950751297, 0.00091891922056675],
    [118.434011635721, 24.7489325277119, 0.000918998382985592],
  ],
  [
    [118.434366132643, 24.7482866709614, 0.000918916426599026],
    [118.433994013312, 24.7489239521734, 0.000918996520340443],
  ],
  [
    [118.434348866301, 24.7482782577633, 0.000918915495276451],
    [118.4339763909, 24.748915367605, 0.000918997451663017],
  ],
  [
    [118.434331609848, 24.7482698445576, 0.000918916426599026],
    [118.433958758592, 24.7489067649845, 0.000918995589017868],
  ],
  [
    [118.43431436327, 24.7482614132888, 0.000918914563953877],
    [118.433941146059, 24.7488981623508, 0.000918994657695293],
  ],
  [
    [118.43429712658, 24.7482529820124, 0.000918914563953877],
    [118.43392352363, 24.7488895416651, 0.000918994657695293],
  ],
  [
    [118.434279889887, 24.7482445417063, 0.000918912701308727],
    [118.433905911089, 24.7488809209717, 0.000918992795050144],
  ],
  [
    [118.434262663075, 24.7482360923648, 0.000918912701308727],
    [118.433888298538, 24.7488722822207, 0.00091899186372757],
  ],
  [
    [118.43424543626, 24.7482276339936, 0.000918910838663578],
    [118.43387069587, 24.7488636344343, 0.000918990932404995],
  ],
  [
    [118.434228229219, 24.7482191756092, 0.000918909907341003],
    [118.433853093198, 24.748854977618, 0.000918989069759846],
  ],
  [
    [118.434211022168, 24.7482106991673, 0.000918908044695854],
    [118.433835490523, 24.7488463117719, 0.00091899000108242],
  ],
  [
    [118.434193825005, 24.7482022227179, 0.000918908976018429],
    [118.433817887844, 24.7488376368959, 0.000918987207114697],
  ],
  [
    [118.434176627838, 24.7481937372387, 0.00091890525072813],
    [118.433800295047, 24.7488289529845, 0.000918986275792122],
  ],
  [
    [118.43415945044, 24.7481852427186, 0.00091890525072813],
    [118.433782712126, 24.74882025101, 0.000918985344469547],
  ],
  [
    [118.434142273037, 24.7481767391688, 0.000918903388082981],
    [118.433765119316, 24.7488115400112, 0.000918983481824398],
  ],
  [
    [118.434125105517, 24.7481682265837, 0.000918902456760406],
    [118.433747536394, 24.7488028290047, 0.000918984413146973],
  ],
  [
    [118.434107947878, 24.7481597049633, 0.000918903388082981],
    [118.433729953463, 24.7487940999406, 0.000918980687856674],
  ],
  [
    [118.434090790236, 24.7481511743131, 0.000918900594115257],
    [118.433712380414, 24.7487853618412, 0.000918980687856674],
  ],
  [
    [118.434073642476, 24.7481426346276, 0.000918900594115257],
    [118.433694807355, 24.7487766056841, 0.000918980687856674],
  ],
  [
    [118.434056514484, 24.7481340859013, 0.000918899662792683],
    [118.433677244184, 24.7487678495194, 0.0009189797565341],
  ],
  [
    [118.434039376609, 24.7481255371785, 0.000918897800147533],
    [118.433659681004, 24.7487590752971, 0.000918976962566376],
  ],
  [
    [118.434022258495, 24.7481169703871, 0.000918896868824959],
    [118.43364211782, 24.748750292045, 0.000918976962566376],
  ],
  [
    [118.434005150263, 24.7481083945605, 0.00091889500617981],
    [118.433624554633, 24.748741499763, 0.000918973237276077],
  ],
  [
    [118.433988042034, 24.7480998187318, 0.00091889500617981],
    [118.433607011208, 24.7487326894123, 0.000918975099921227],
  ],
  [
    [118.433970943681, 24.7480912248402, 0.00091889314353466],
    [118.433589457893, 24.7487238700373, 0.000918972305953503],
  ],
  [
    [118.43395385521, 24.7480826219132, 0.00091889314353466],
    [118.433571914461, 24.748715041627, 0.000918972305953503],
  ],
  [
    [118.433936776627, 24.7480740189787, 0.000918891280889511],
    [118.433554371025, 24.7487062041868, 0.000918972305953503],
  ],
  [
    [118.433919698034, 24.7480653979868, 0.000918892212212086],
    [118.433536837466, 24.7486973486835, 0.000918970443308353],
  ],
  [
    [118.433902639209, 24.748056767954, 0.000918891280889511],
    [118.433519313788, 24.7486884841448, 0.00091896764934063],
  ],
  [
    [118.43388558038, 24.7480481288915, 0.000918889418244362],
    [118.433501780222, 24.7486796105818, 0.00091896764934063],
  ],
  [
    [118.433868531434, 24.7480394807937, 0.000918888486921787],
    [118.433484266417, 24.7486707189502, 0.00091896578669548],
  ],
  [
    [118.433851502255, 24.7480308236551, 0.000918885692954063],
    [118.433466742723, 24.7486618182942, 0.00091896578669548],
  ],
  [
    [118.433834463187, 24.7480221574924, 0.000918885692954063],
    [118.433449238797, 24.7486529085974, 0.00091896578669548],
  ],
  [
    [118.433817443887, 24.7480134822888, 0.000918883830308914],
    [118.433431724982, 24.7486439898763, 0.000918962992727757],
  ],
  [
    [118.433800434469, 24.74800479805, 0.000918883830308914],
    [118.433414221043, 24.748635053092, 0.000918962061405182],
  ],
  [
    [118.433783434933, 24.7479961047759, 0.00091888103634119],
    [118.433396726981, 24.7486260982446, 0.000918962061405182],
  ],
  [
    [118.433766435387, 24.7479873934444, 0.000918880105018616],
    [118.433379232915, 24.7486171343674, 0.000918959267437458],
  ],
  [
    [118.433749455616, 24.7479786820999, 0.00091888103634119],
    [118.433361748731, 24.7486081614549, 0.000918960198760033],
  ],
  [
    [118.433732475834, 24.7479699526978, 0.000918877311050892],
    [118.433344264544, 24.7485991795125, 0.000918957404792309],
  ],
  [
    [118.433715505935, 24.7479612142606, 0.000918877311050892],
    [118.433326790233, 24.7485901795071, 0.000918956473469734],
  ],
  [
    [118.433698545918, 24.7479524667881, 0.000918876379728317],
    [118.433309315912, 24.748581161444, 0.00091895554214716],
  ],
  [
    [118.433681595783, 24.7479437102803, 0.000918875448405743],
    [118.433291851474, 24.7485721343456, 0.000918954610824585],
  ],
  [
    [118.43366466541, 24.7479349357041, 0.000918873585760593],
    [118.433274387033, 24.7485630982174, 0.000918952748179436],
  ],
  [
    [118.433647735039, 24.7479261611259, 0.000918871723115444],
    [118.433256932467, 24.7485540440261, 0.000918950885534287],
  ],
  [
    [118.433630804658, 24.7479173684903, 0.000918873585760593],
    [118.433239487784, 24.7485449807994, 0.000918949954211712],
  ],
  [
    [118.433613894046, 24.7479085668139, 0.000918871723115444],
    [118.433222043092, 24.7485358995152, 0.000918950885534287],
  ],
  [
    [118.433596993316, 24.7478997561023, 0.000918869860470295],
    [118.433204598396, 24.7485268092011, 0.000918947160243988],
  ],
  [
    [118.433580102461, 24.7478909273277, 0.00091886892914772],
    [118.433187173462, 24.7485177008185, 0.000918948091566563],
  ],
  [
    [118.433563221495, 24.7478820985456, 0.000918866135179996],
    [118.433169738639, 24.7485085834116, 0.000918946228921413],
  ],
  [
    [118.433546350405, 24.7478732517006, 0.000918866135179996],
    [118.433152323585, 24.7484994569638, 0.000918945297598839],
  ],
  [
    [118.433529489197, 24.7478643958204, 0.000918865203857422],
    [118.433134908514, 24.7484903034307, 0.000918945297598839],
  ],
  [
    [118.43351262798, 24.7478555218828, 0.000918864272534847],
    [118.433117493441, 24.7484811408678, 0.00091894343495369],
  ],
  [
    [118.433495786536, 24.7478466479322, 0.000918863341212273],
    [118.433100098135, 24.7484719692641, 0.000918940640985966],
  ],
  [
    [118.433478954969, 24.7478377559186, 0.000918862409889698],
    [118.43308270282, 24.7484627796028, 0.000918940640985966],
  ],
  [
    [118.433462133283, 24.7478288548699, 0.000918860547244549],
    [118.433065307502, 24.7484535809117, 0.000918939709663391],
  ],
  [
    [118.433445311588, 24.7478199357637, 0.000918860547244549],
    [118.43304792206, 24.7484443641575, 0.000918938778340817],
  ],
  [
    [118.433428509661, 24.7478110076168, 0.0009188586845994],
    [118.433030546501, 24.7484351383681, 0.000918936915695667],
  ],
  [
    [118.433411707731, 24.7478020704402, 0.000918857753276825],
    [118.433013180817, 24.7484258945156, 0.000918935053050518],
  ],
  [
    [118.433394915676, 24.7477931152007, 0.000918857753276825],
    [118.432995825011, 24.7484166326, 0.000918935053050518],
  ],
  [
    [118.433378133504, 24.747784150926, 0.000918854027986526],
    [118.432978479092, 24.748407370677, 0.000918935053050518],
  ],
  [
    [118.433361361208, 24.7477751685884, 0.000918854027986526],
    [118.432961133159, 24.7483980816685, 0.000918932259082794],
  ],
  [
    [118.433344598794, 24.7477661772156, 0.000918851234018803],
    [118.432943806999, 24.7483887926472, 0.000918930396437645],
  ],
  [
    [118.433327836376, 24.7477571768131, 0.000918851234018803],
    [118.432926480824, 24.7483794765404, 0.000918930396437645],
  ],
  [
    [118.43331109372, 24.7477481583422, 0.000918851234018803],
    [118.432909164538, 24.7483701604262, 0.000918928533792496],
  ],
  [
    [118.433294351061, 24.7477391308416, 0.000918849371373653],
    [118.432891858128, 24.748360826249, 0.000918927602469921],
  ],
  [
    [118.433277618278, 24.7477300852781, 0.000918848440051079],
    [118.432874561594, 24.7483514740087, 0.000918925739824772],
  ],
  [
    [118.433260895377, 24.7477210306795, 0.000918848440051079],
    [118.432857274943, 24.7483421127331, 0.000918926671147347],
  ],
  [
    [118.433244172467, 24.7477119580234, 0.00091884657740593],
    [118.432839988289, 24.7483327424278, 0.000918922945857048],
  ],
  [
    [118.433227469324, 24.7477028763267, 0.000918843783438206],
    [118.432822721396, 24.748323354054, 0.000918922945857048],
  ],
  [
    [118.433210766178, 24.7476937856003, 0.000918841920793056],
    [118.432805454501, 24.7483139566504, 0.000918922014534473],
  ],
  [
    [118.433194072908, 24.747684676811, 0.000918841920793056],
    [118.432788197482, 24.7483045411838, 0.00091891922056675],
  ],
  [
    [118.43317738952, 24.7476755589866, 0.000918842852115631],
    [118.432770950345, 24.7482951166819, 0.00091891922056675],
  ],
  [
    [118.433160716015, 24.747666432127, 0.000918840058147907],
    [118.432753713085, 24.7482856741171, 0.000918916426599026],
  ],
  [
    [118.433144052386, 24.7476572872045, 0.000918839126825333],
    [118.432736485707, 24.7482762225169, 0.000918915495276451],
  ],
  [
    [118.433127388753, 24.7476481332524, 0.000918838195502758],
    [118.432719268205, 24.7482667528538, 0.000918915495276451],
  ],
  [
    [118.433110744882, 24.7476389612319, 0.000918836332857609],
    [118.432702050701, 24.748257274161, 0.000918915495276451],
  ],
  [
    [118.433094101007, 24.7476297801818, 0.000918835401535034],
    [118.432684843078, 24.7482477864329, 0.000918913632631302],
  ],
  [
    [118.433077467009, 24.7476205810687, 0.000918833538889885],
    [118.432667655219, 24.7482382806363, 0.000918910838663578],
  ],
  [
    [118.433060842899, 24.7476113819483, 0.000918833538889885],
    [118.432650467349, 24.7482287567822, 0.000918911769986153],
  ],
  [
    [118.433044228659, 24.7476021557373, 0.000918831676244736],
    [118.432633289368, 24.7482192329207, 0.000918909907341003],
  ],
  [
    [118.433027614422, 24.7475929295243, 0.000918831676244736],
    [118.432616121258, 24.7482096819684, 0.000918908976018429],
  ],
  [
    [118.433011019946, 24.7475836852431, 0.000918829813599586],
    [118.432598963036, 24.7482001310087, 0.000918908044695854],
  ],
  [
    [118.432994425462, 24.7475744229044, 0.000918826088309288],
    [118.432581804805, 24.7481905619914, 0.000918906182050705],
  ],
  [
    [118.432977840859, 24.7475651515306, 0.000918827019631863],
    [118.432564666336, 24.7481809749057, 0.00091890525072813],
  ],
  [
    [118.432961266139, 24.7475558711217, 0.000918825156986713],
    [118.432547527864, 24.7481713787903, 0.000918904319405556],
  ],
  [
    [118.432944701294, 24.74754657265, 0.000918826088309288],
    [118.432530399275, 24.7481617736396, 0.000918902456760406],
  ],
  [
    [118.432928146332, 24.7475372651431, 0.000918823294341564],
    [118.432513290447, 24.7481521504206, 0.000918900594115257],
  ],
  [
    [118.432911591367, 24.7475279486066, 0.000918823294341564],
    [118.432496181611, 24.748142509144, 0.000918900594115257],
  ],
  [
    [118.432895056164, 24.7475186140018, 0.000918821431696415],
    [118.432479082663, 24.74813286786, 0.000918898731470108],
  ],
  [
    [118.432878520957, 24.7475092703674, 0.000918821431696415],
    [118.432461993585, 24.7481231994853, 0.000918897800147533],
  ],
  [
    [118.432861995626, 24.7474999086701, 0.000918818637728691],
    [118.43244490451, 24.7481135311086, 0.000918895937502384],
  ],
  [
    [118.432845480177, 24.7474905379378, 0.000918817706406116],
    [118.432427835198, 24.7481038446635, 0.000918895937502384],
  ],
  [
    [118.432828974611, 24.7474811581703, 0.000918817706406116],
    [118.432410765876, 24.7480941401609, 0.000918892212212086],
  ],
  [
    [118.432812478921, 24.74747176034, 0.000918815843760967],
    [118.432393716322, 24.7480844266177, 0.00091889314353466],
  ],
  [
    [118.432795993114, 24.7474623534747, 0.000918814912438393],
    [118.432376666765, 24.7480747040448, 0.000918891280889511],
  ],
  [
    [118.432779507303, 24.7474529375797, 0.000918812118470669],
    [118.432359627085, 24.7480649634089, 0.000918890349566936],
  ],
  [
    [118.432763031368, 24.7474435036219, 0.00091881025582552],
    [118.432342597287, 24.7480552137379, 0.000918889418244362],
  ],
  [
    [118.432746575201, 24.7474340606236, 0.00091881025582552],
    [118.432325577366, 24.7480454460039, 0.000918887555599213],
  ],
  [
    [118.432730119025, 24.7474245995679, 0.000918809324502945],
    [118.432308567328, 24.7480356692348, 0.000918886624276638],
  ],
  [
    [118.432713672731, 24.7474151294771, 0.00091880839318037],
    [118.432291567172, 24.7480258834305, 0.000918886624276638],
  ],
  [
    [118.432697236313, 24.7474056413235, 0.000918807461857796],
    [118.432274576892, 24.7480160795633, 0.000918883830308914],
  ],
  [
    [118.432680799898, 24.7473961531681, 0.000918806530535221],
    [118.432257586609, 24.7480062666663, 0.00091888289898634],
  ],
  [
    [118.432664383239, 24.7473866379166, 0.000918805599212646],
    [118.432240616089, 24.7479964357011, 0.000918881967663765],
  ],
  [
    [118.432647966582, 24.7473771226633, 0.000918802805244923],
    [118.432223645565, 24.7479865957061, 0.000918880105018616],
  ],
  [
    [118.432631569687, 24.7473675893418, 0.000918801873922348],
    [118.432206694804, 24.7479767376427, 0.000918879173696041],
  ],
  [
    [118.432615172789, 24.7473580469906, 0.000918801873922348],
    [118.432189744039, 24.7479668705497, 0.000918878242373466],
  ],
  [
    [118.432598785768, 24.7473484865767, 0.000918800942599773],
    [118.432172803151, 24.7479569853937, 0.000918878242373466],
  ],
  [
    [118.432582408628, 24.7473389171277, 0.000918799079954624],
    [118.432155872152, 24.7479471002304, 0.000918875448405743],
  ],
  [
    [118.432566041371, 24.7473293386436, 0.00091879814863205],
    [118.432138951023, 24.7479371879765, 0.000918875448405743],
  ],
  [
    [118.43254968399, 24.7473197420968, 0.000918795354664326],
    [118.432122039783, 24.7479272757151, 0.000918872654438019],
  ],
  [
    [118.432533326606, 24.7473101365204, 0.000918795354664326],
    [118.432105138413, 24.7479173363631, 0.000918872654438019],
  ],
  [
    [118.432516988984, 24.7473005128758, 0.000918794423341751],
    [118.432088237046, 24.7479073970092, 0.00091887079179287],
  ],
  [
    [118.432500651359, 24.7472908802016, 0.000918792560696602],
    [118.432071355442, 24.747897439587, 0.000918869860470295],
  ],
  [
    [118.432484323615, 24.7472812384923, 0.000918792560696602],
    [118.432054483714, 24.7478874641019, 0.000918867997825146],
  ],
  [
    [118.432468005748, 24.7472715787203, 0.000918790698051453],
    [118.432037611989, 24.7478774886148, 0.000918867997825146],
  ],
  [
    [118.43245170765, 24.7472619099078, 0.000918789766728878],
    [118.432020750134, 24.7478674860371, 0.000918865203857422],
  ],
  [
    [118.432435409547, 24.7472522320658, 0.000918787904083729],
    [118.432003908054, 24.7478574834467, 0.000918865203857422],
  ],
  [
    [118.432419111436, 24.7472425361664, 0.000918786972761154],
    [118.431987065965, 24.7478474627988, 0.000918862409889698],
  ],
  [
    [118.432402833092, 24.7472328312266, 0.000918785110116005],
    [118.431970233752, 24.7478374240881, 0.000918862409889698],
  ],
  [
    [118.432386564625, 24.747223108224, 0.000918785110116005],
    [118.431953411422, 24.7478273763422, 0.000918860547244549],
  ],
  [
    [118.432370296154, 24.7472133761918, 0.000918782316148281],
    [118.431936598974, 24.7478173195613, 0.000918860547244549],
  ],
  [
    [118.432354047451, 24.7472036351192, 0.000918783247470856],
    [118.431919796404, 24.7478072447175, 0.00091885682195425],
  ],
  [
    [118.432337798745, 24.7471938850171, 0.000918782316148281],
    [118.431903003715, 24.7477971608386, 0.00091885682195425],
  ],
  [
    [118.432321559916, 24.7471841168522, 0.000918780453503132],
    [118.43188622091, 24.7477870679246, 0.000918855890631676],
  ],
  [
    [118.432305330963, 24.7471743306245, 0.000918778590857983],
    [118.431869438095, 24.7477769569532, 0.000918854027986526],
  ],
  [
    [118.432289111898, 24.7471645443896, 0.000918777659535408],
    [118.431852675042, 24.7477668279135, 0.000918853096663952],
  ],
  [
    [118.432272902709, 24.747154740092, 0.000918776728212833],
    [118.431835921879, 24.7477566988666, 0.000918853096663952],
  ],
  [
    [118.432256703397, 24.7471449177316, 0.000918774865567684],
    [118.4318191687, 24.7477465427344, 0.000918849371373653],
  ],
  [
    [118.432240513967, 24.7471350863363, 0.000918774865567684],
    [118.431802425409, 24.7477363865949, 0.000918848440051079],
  ],
  [
    [118.432224324534, 24.7471252459114, 0.00091877207159996],
    [118.431785701881, 24.7477262123872, 0.000918849371373653],
  ],
  [
    [118.432208154869, 24.7471153964461, 0.000918770208954811],
    [118.43176897835, 24.7477160291499, 0.00091884657740593],
  ],
  [
    [118.432191985194, 24.7471055289235, 0.000918770208954811],
    [118.431752264696, 24.7477058278497, 0.00091884471476078],
  ],
  [
    [118.432175835288, 24.7470956523605, 0.000918768346309662],
    [118.43173557081, 24.7476956175091, 0.000918842852115631],
  ],
  [
    [118.432159685372, 24.7470857577403, 0.000918766483664513],
    [118.431718876915, 24.747685389111, 0.000918841920793056],
  ],
  [
    [118.432143545339, 24.747075854085, 0.000918765552341938],
    [118.431702192902, 24.7476751516779, 0.000918840989470482],
  ],
  [
    [118.432127415188, 24.7470659413948, 0.000918765552341938],
    [118.431685518772, 24.7476649052097, 0.000918838195502758],
  ],
  [
    [118.432111294913, 24.7470560106419, 0.000918762758374214],
    [118.431668854519, 24.7476546406788, 0.000918838195502758],
  ],
  [
    [118.432095184521, 24.747046070854, 0.00091876182705164],
    [118.431652200149, 24.7476443671128, 0.000918838195502758],
  ],
  [
    [118.432079084011, 24.7470361220312, 0.000918760895729065],
    [118.431635545769, 24.7476340754893, 0.000918837264180183],
  ],
  [
    [118.432062993378, 24.7470261551457, 0.00091875996440649],
    [118.431618911158, 24.7476237748255, 0.00091883447021246],
  ],
  [
    [118.432046902741, 24.7470161792307, 0.000918758101761341],
    [118.431602286429, 24.7476134651266, 0.00091883447021246],
  ],
  [
    [118.432030831872, 24.7470061942753, 0.000918758101761341],
    [118.431585671578, 24.747603137365, 0.000918831676244736],
  ],
  [
    [118.432014760994, 24.7469961912626, 0.000918755307793617],
    [118.431569056723, 24.7475928005737, 0.000918829813599586],
  ],
  [
    [118.431998709884, 24.7469861792096, 0.000918754376471043],
    [118.43155246163, 24.7475824457142, 0.000918828882277012],
  ],
  [
    [118.431982658771, 24.746976158127, 0.000918755307793617],
    [118.431535866534, 24.7475720818251, 0.000918827950954437],
  ],
  [
    [118.43196662742, 24.7469661189764, 0.000918751582503319],
    [118.431519291207, 24.7475617088956, 0.000918827950954437],
  ],
  [
    [118.431950596066, 24.7469560707963, 0.000918751582503319],
    [118.431502715871, 24.7475513179087, 0.000918826088309288],
  ],
  [
    [118.431934574594, 24.7469460135812, 0.000918748788535595],
    [118.431486160303, 24.7475409178814, 0.000918824225664139],
  ],
  [
    [118.431918562998, 24.7469359383034, 0.000918748788535595],
    [118.431469604732, 24.7475305088245, 0.00091882236301899],
  ],
  [
    [118.431902561285, 24.7469258539908, 0.00091874785721302],
    [118.431453059038, 24.7475200817048, 0.00091882236301899],
  ],
  [
    [118.431886569448, 24.7469157516154, 0.000918745994567871],
    [118.431436533106, 24.7475096365169, 0.00091882050037384],
  ],
  [
    [118.431870587494, 24.7469056402052, 0.000918744131922722],
    [118.431420007177, 24.7474991913273, 0.000918817706406116],
  ],
  [
    [118.431854605536, 24.7468955197654, 0.000918742269277573],
    [118.431403491125, 24.7474887280748, 0.000918816775083542],
  ],
  [
    [118.431838643347, 24.7468853902854, 0.000918743200600147],
    [118.43138698495, 24.7474782467596, 0.000918816775083542],
  ],
  [
    [118.431822691034, 24.7468752427426, 0.000918740406632423],
    [118.431370498543, 24.7474677564041, 0.000918813981115818],
  ],
  [
    [118.431806738718, 24.7468650861704, 0.000918740406632423],
    [118.431354012133, 24.7474572570189, 0.000918813981115818],
  ],
  [
    [118.431790806163, 24.7468549115301, 0.000918738543987274],
    [118.4313375356, 24.747446739571, 0.000918812118470669],
  ],
  [
    [118.431774873606, 24.7468447278604, 0.0009187376126647],
    [118.431321068949, 24.7474362130881, 0.000918811187148094],
  ],
  [
    [118.431758960817, 24.7468345351503, 0.000918734818696976],
    [118.431304612181, 24.7474256775702, 0.000918809324502945],
  ],
  [
    [118.431743048018, 24.746824324383, 0.00091873575001955],
    [118.43128816529, 24.7474151239896, 0.00091880839318037],
  ],
  [
    [118.431727145108, 24.7468141136086, 0.000918732024729252],
    [118.431271728281, 24.7474045613741, 0.000918805599212646],
  ],
  [
    [118.431711252068, 24.7468038757438, 0.000918732956051826],
    [118.431255301155, 24.7473939897235, 0.000918804667890072],
  ],
  [
    [118.431695368917, 24.7467936378718, 0.000918731093406677],
    [118.431238883906, 24.7473834000103, 0.000918805599212646],
  ],
  [
    [118.431679495642, 24.7467833819373, 0.000918730162084103],
    [118.431222466654, 24.7473728012674, 0.000918805599212646],
  ],
  [
    [118.431663642135, 24.7467731169624, 0.000918727368116379],
    [118.431206069165, 24.7473621844565, 0.000918801873922348],
  ],
  [
    [118.431647778734, 24.7467628339357, 0.000918727368116379],
    [118.431189681558, 24.7473515586106, 0.000918800942599773],
  ],
  [
    [118.4316319351, 24.7467525418688, 0.000918726436793804],
    [118.431173303828, 24.747340914702, 0.000918799079954624],
  ],
  [
    [118.431616101349, 24.746742240767, 0.00091872550547123],
    [118.431156935986, 24.7473302707862, 0.000918797217309475],
  ],
  [
    [118.431600277481, 24.7467319306304, 0.000918722711503506],
    [118.431140578021, 24.7473196088077, 0.0009187962859869],
  ],
  [
    [118.431584463489, 24.7467216024311, 0.000918721780180931],
    [118.431124220048, 24.7473089287719, 0.000918794423341751],
  ],
  [
    [118.431568659373, 24.7467112561692, 0.000918718986213207],
    [118.431107881842, 24.7472982396957, 0.000918794423341751],
  ],
  [
    [118.43155285526, 24.7467009099056, 0.000918718054890633],
    [118.43109155352, 24.7472875415846, 0.000918791629374027],
  ],
  [
    [118.431537070909, 24.746690545574, 0.000918718986213207],
    [118.431075225188, 24.7472768254162, 0.000918790698051453],
  ],
  [
    [118.431521286555, 24.746680172213, 0.000918714329600334],
    [118.431058916625, 24.7472661002075, 0.000918789766728878],
  ],
  [
    [118.431505521964, 24.7466697807839, 0.000918714329600334],
    [118.431042617945, 24.7472553659639, 0.000918789766728878],
  ],
  [
    [118.431489757375, 24.7466593893532, 0.000918714329600334],
    [118.431026319256, 24.747244613663, 0.000918786972761154],
  ],
  [
    [118.431474012548, 24.7466489798545, 0.000918712466955185],
    [118.431010040335, 24.7472338523218, 0.00091878604143858],
  ],
  [
    [118.431458267712, 24.7466385522986, 0.000918709672987461],
    [118.430993771297, 24.7472230819457, 0.00091878417879343],
  ],
  [
    [118.431442542644, 24.7466281157025, 0.000918710604310036],
    [118.43097750225, 24.7472122935122, 0.000918783247470856],
  ],
  [
    [118.431426817573, 24.7466176700769, 0.000918707810342312],
    [118.430961252971, 24.7472014960385, 0.000918780453503132],
  ],
  [
    [118.431411102384, 24.7466072154165, 0.000918707810342312],
    [118.43094501357, 24.7471906805021, 0.000918780453503132],
  ],
  [
    [118.431395397072, 24.7465967426936, 0.000918706879019737],
    [118.430928774165, 24.7471798559361, 0.000918776728212833],
  ],
  [
    [118.431379711528, 24.7465862609304, 0.000918704085052013],
    [118.430912554529, 24.74716902233, 0.000918777659535408],
  ],
  [
    [118.431364025981, 24.7465757701378, 0.000918703153729439],
    [118.430896344769, 24.7471581706611, 0.000918776728212833],
  ],
  [
    [118.43134835031, 24.7465652612826, 0.000918702222406864],
    [118.430880135007, 24.7471473099627, 0.000918774865567684],
  ],
  [
    [118.431332684522, 24.7465547433927, 0.000918700359761715],
    [118.430863945013, 24.7471364402241, 0.000918773002922535],
  ],
  [
    [118.431317028616, 24.7465442164679, 0.000918698497116566],
    [118.43084775501, 24.7471255524282, 0.00091877207159996],
  ],
  [
    [118.431301382587, 24.7465336714805, 0.000918698497116566],
    [118.430831584776, 24.747114655592, 0.000918771140277386],
  ],
  [
    [118.43128574644, 24.7465231174584, 0.000918695703148842],
    [118.430815424418, 24.7471037406932, 0.000918769277632236],
  ],
  [
    [118.431270120176, 24.7465125544015, 0.000918694771826267],
    [118.430799264063, 24.7470928257926, 0.000918768346309662],
  ],
  [
    [118.431254503788, 24.7465019732819, 0.000918693840503693],
    [118.430783123465, 24.7470818837963, 0.000918767414987087],
  ],
  [
    [118.431238897283, 24.7464913831277, 0.000918693840503693],
    [118.430766992756, 24.7470709417929, 0.000918765552341938],
  ],
  [
    [118.431223300661, 24.7464807839386, 0.000918691977858543],
    [118.430750862038, 24.7470599817322, 0.000918764621019363],
  ],
  [
    [118.43120771392, 24.7464701757147, 0.000918690115213394],
    [118.430734751088, 24.7470490126313, 0.000918762758374214],
  ],
  [
    [118.431192137057, 24.7464595494283, 0.000918688252568245],
    [118.430718650015, 24.7470380254677, 0.000918760895729065],
  ],
  [
    [118.431176570075, 24.7464489141072, 0.000918688252568245],
    [118.430702548939, 24.7470270292747, 0.000918759033083916],
  ],
  [
    [118.431161003085, 24.7464382607288, 0.000918685458600521],
    [118.430686467632, 24.7470160240414, 0.000918759033083916],
  ],
  [
    [118.431145455869, 24.7464276073381, 0.000918684527277946],
    [118.430670396202, 24.7470050007456, 0.000918756239116192],
  ],
  [
    [118.431129918529, 24.7464169358849, 0.000918683595955372],
    [118.430654324768, 24.7469939684202, 0.000918755307793617],
  ],
  [
    [118.431114391066, 24.7464062463691, 0.000918681733310223],
    [118.430638273103, 24.7469829270546, 0.000918754376471043],
  ],
  [
    [118.431098873492, 24.7463955568463, 0.000918680801987648],
    [118.430622231315, 24.7469718676264, 0.000918752513825893],
  ],
  [
    [118.431083355908, 24.7463848492664, 0.000918679870665073],
    [118.43060619941, 24.7469607991634, 0.000918752513825893],
  ],
  [
    [118.431067858086, 24.7463741236185, 0.000918676145374775],
    [118.430590177387, 24.7469497216656, 0.000918748788535595],
  ],
  [
    [118.431052370153, 24.7463633979637, 0.000918676145374775],
    [118.430574155356, 24.7469386261105, 0.000918748788535595],
  ],
  [
    [118.431036882211, 24.7463526542518, 0.0009186752140522],
    [118.430558153093, 24.7469275215152, 0.000918748788535595],
  ],
  [
    [118.431021414037, 24.7463419014997, 0.000918673351407051],
    [118.430542160712, 24.7469164078851, 0.000918746925890446],
  ],
  [
    [118.431005955746, 24.7463311397129, 0.000918671488761902],
    [118.430526178209, 24.7469052761925, 0.000918743200600147],
  ],
  [
    [118.430990497445, 24.7463203598689, 0.000918671488761902],
    [118.430510205589, 24.746894135465, 0.000918743200600147],
  ],
  [
    [118.430975058913, 24.7463095709849, 0.000918669626116753],
    [118.430494242851, 24.7468829857027, 0.000918741337954998],
  ],
  [
    [118.430959630257, 24.7462987640383, 0.000918668694794178],
    [118.43047828999, 24.7468718178778, 0.000918740406632423],
  ],
  [
    [118.430944201604, 24.7462879570902, 0.000918665900826454],
    [118.430462347012, 24.7468606410181, 0.000918739475309849],
  ],
  [
    [118.430928792713, 24.7462771320742, 0.00091866496950388],
    [118.430446413911, 24.7468494460958, 0.000918738543987274],
  ],
  [
    [118.430913393705, 24.7462662980234, 0.00091866310685873],
    [118.430430490698, 24.7468382511665, 0.00091873575001955],
  ],
  [
    [118.430897994687, 24.7462554459155, 0.00091866310685873],
    [118.430414577357, 24.7468270291468, 0.000918734818696976],
  ],
  [
    [118.430882615438, 24.7462445847676, 0.000918662175536156],
    [118.430398673904, 24.7468158071202, 0.000918733887374401],
  ],
  [
    [118.430867246072, 24.7462337145849, 0.000918660312891006],
    [118.430382780328, 24.7468045670309, 0.000918731093406677],
  ],
  [
    [118.430851876702, 24.7462228353729, 0.000918659381568432],
    [118.430366896635, 24.7467933179069, 0.000918731093406677],
  ],
  [
    [118.430836527094, 24.7462119380931, 0.000918657518923283],
    [118.43035103271, 24.7467820597428, 0.000918727368116379],
  ],
  [
    [118.430821187369, 24.7462010317785, 0.000918656587600708],
    [118.430335168777, 24.7467707835214, 0.000918728299438953],
  ],
  [
    [118.430805847641, 24.7461901164346, 0.000918654724955559],
    [118.430319314726, 24.7467594982653, 0.000918726436793804],
  ],
  [
    [118.430790527681, 24.7461791920507, 0.00091865286231041],
    [118.430303470552, 24.7467481949466, 0.000918726436793804],
  ],
  [
    [118.430775217598, 24.7461682496042, 0.00091865286231041],
    [118.430287646153, 24.7467368916156, 0.00091872364282608],
  ],
  [
    [118.430759907512, 24.7461572981285, 0.00091865099966526],
    [118.430271821739, 24.7467255611996, 0.000918722711503506],
  ],
  [
    [118.430744617187, 24.7461463285849, 0.000918649137020111],
    [118.430256017099, 24.7467142307713, 0.000918718986213207],
  ],
  [
    [118.430729336752, 24.7461353590344, 0.000918649137020111],
    [118.430240212451, 24.7467028822858, 0.000918718986213207],
  ],
  [
    [118.430714056307, 24.7461243714268, 0.000918647274374962],
    [118.430224427571, 24.7466915247602, 0.000918718054890633],
  ],
  [
    [118.430698795625, 24.7461133657514, 0.000918645411729813],
    [118.430208642688, 24.7466801582051, 0.000918716192245483],
  ],
  [
    [118.43068354483, 24.7461023600691, 0.000918642617762089],
    [118.430192877568, 24.7466687735822, 0.000918715260922909],
  ],
  [
    [118.430668294027, 24.7460913363296, 0.000918641686439514],
    [118.430177122331, 24.7466573799246, 0.000918712466955185],
  ],
  [
    [118.430653062993, 24.7460803035502, 0.00091864075511694],
    [118.430161367091, 24.7466459772375, 0.000918712466955185],
  ],
  [
    [118.43063784184, 24.7460692617361, 0.000918639823794365],
    [118.430145631613, 24.7466345564826, 0.000918710604310036],
  ],
  [
    [118.430622630565, 24.7460582018596, 0.000918637961149216],
    [118.430129906018, 24.746623126693, 0.000918709672987461],
  ],
  [
    [118.430607429172, 24.7460471329484, 0.000918637961149216],
    [118.430114190306, 24.7466116878687, 0.000918707810342312],
  ],
  [
    [118.430592227775, 24.7460360550079, 0.000918634235858917],
    [118.430098484471, 24.7466002309818, 0.000918705947697163],
  ],
  [
    [118.430577046147, 24.7460249680274, 0.000918633304536343],
    [118.430082788519, 24.7465887650602, 0.000918705947697163],
  ],
  [
    [118.430561874396, 24.7460138629844, 0.000918632373213768],
    [118.43006710245, 24.7465772901038, 0.000918703153729439],
  ],
  [
    [118.430546712527, 24.7460027489068, 0.000918631441891193],
    [118.430051426257, 24.746565797085, 0.000918700359761715],
  ],
  [
    [118.430531560541, 24.7459916257946, 0.000918630510568619],
    [118.430035759948, 24.7465542950315, 0.00091870129108429],
  ],
  [
    [118.430516418431, 24.7459804846199, 0.00091862864792347],
    [118.430020103521, 24.7465427839432, 0.000918698497116566],
  ],
  [
    [118.430501286204, 24.7459693344106, 0.00091862678527832],
    [118.430004466857, 24.7465312547871, 0.000918696634471416],
  ],
  [
    [118.430486163859, 24.7459581751667, 0.000918623991310596],
    [118.42998883019, 24.7465197166017, 0.000918697565793991],
  ],
  [
    [118.430471051397, 24.7459470068881, 0.000918623991310596],
    [118.429973203405, 24.7465081693815, 0.000918695703148842],
  ],
  [
    [118.430455948812, 24.7459358205472, 0.000918623991310596],
    [118.42995759639, 24.7464966131213, 0.000918694771826267],
  ],
  [
    [118.430440856109, 24.7459246251715, 0.000918621197342873],
    [118.429941989365, 24.7464850388039, 0.000918691977858543],
  ],
  [
    [118.430425773289, 24.7459134207613, 0.000918620266020298],
    [118.429926402109, 24.7464734554466, 0.00091868918389082],
  ],
  [
    [118.430410700351, 24.7459022073165, 0.000918617472052574],
    [118.42991082473, 24.7464618540268, 0.00091868918389082],
  ],
  [
    [118.430395637291, 24.7458909758092, 0.00091861654073],
    [118.429895247354, 24.7464502526053, 0.00091868732124567],
  ],
  [
    [118.430380593998, 24.745879735262, 0.00091861654073],
    [118.429879689741, 24.7464386331161, 0.000918685458600521],
  ],
  [
    [118.430365550702, 24.7458684856855, 0.00091861467808485],
    [118.429864142005, 24.7464269955645, 0.000918683595955372],
  ],
  [
    [118.430350517283, 24.7458572180467, 0.000918612815439701],
    [118.429848604157, 24.7464153580059, 0.000918682664632797],
  ],
  [
    [118.430335493752, 24.745845950401, 0.000918610021471977],
    [118.429833076187, 24.7464037023849, 0.000918681733310223],
  ],
  [
    [118.430320489984, 24.7458346646876, 0.000918609090149403],
    [118.429817558099, 24.7463920377292, 0.000918678939342499],
  ],
  [
    [118.430305486206, 24.7458233609171, 0.000918608158826828],
    [118.429802049888, 24.7463803550111, 0.000918678939342499],
  ],
  [
    [118.430290502203, 24.7458120571345, 0.000918607227504253],
    [118.429786561446, 24.746368663253, 0.000918676145374775],
  ],
  [
    [118.430275518191, 24.7458007352948, 0.000918606296181679],
    [118.429771073001, 24.7463569624655, 0.0009186752140522],
  ],
  [
    [118.430260553947, 24.7457894044153, 0.000918605364859104],
    [118.429755594438, 24.7463452526434, 0.000918674282729626],
  ],
  [
    [118.4302455897, 24.7457780645064, 0.000918603502213955],
    [118.429740135639, 24.7463335247535, 0.000918671488761902],
  ],
  [
    [118.430230645215, 24.7457667065299, 0.000918601639568806],
    [118.429724676836, 24.7463217878343, 0.000918672420084476],
  ],
  [
    [118.430215700727, 24.7457553395241, 0.000918599776923656],
    [118.429709237797, 24.7463100328473, 0.000918669626116753],
  ],
  [
    [118.430200776007, 24.7457439634785, 0.000918598845601082],
    [118.429693808646, 24.7462982778535, 0.000918668694794178],
  ],
  [
    [118.43018586117, 24.7457325783982, 0.000918596051633358],
    [118.429678389371, 24.7462865047973, 0.000918665900826454],
  ],
  [
    [118.43017095621, 24.7457211752556, 0.000918596982955933],
    [118.429662970095, 24.7462747227117, 0.00091866496950388],
  ],
  [
    [118.430156051252, 24.7457097721115, 0.000918594188988209],
    [118.42964757058, 24.7462629225584, 0.000918664038181305],
  ],
  [
    [118.430141166057, 24.7456983508998, 0.000918593257665634],
    [118.429632180949, 24.7462511133704, 0.00091866310685873],
  ],
  [
    [118.430126290739, 24.7456869116257, 0.000918591395020485],
    [118.429616811086, 24.7462392951426, 0.000918661244213581],
  ],
  [
    [118.430111425309, 24.7456754723448, 0.000918589532375336],
    [118.42960144122, 24.7462274678854, 0.000918658450245857],
  ],
  [
    [118.430096569755, 24.7456640150016, 0.000918588601052761],
    [118.429586081232, 24.7462156225658, 0.000918658450245857],
  ],
  [
    [118.430081724085, 24.7456525486238, 0.000918586738407612],
    [118.429570741012, 24.7462037682063, 0.000918657518923283],
  ],
  [
    [118.430066888297, 24.7456410732115, 0.000918585807085037],
    [118.429555400789, 24.7461919048175, 0.000918653793632984],
  ],
  [
    [118.430052072271, 24.7456295797316, 0.000918583944439888],
    [118.429540080328, 24.746180023361, 0.00091865286231041],
  ],
  [
    [118.430037256242, 24.7456180772224, 0.000918582081794739],
    [118.429524759871, 24.7461681419029, 0.00091865099966526],
  ],
  [
    [118.430022450096, 24.7456065656786, 0.00091858021914959],
    [118.429509459171, 24.7461562333494, 0.000918651930987835],
  ],
  [
    [118.430007663718, 24.745595045095, 0.000918579287827015],
    [118.429494168359, 24.746144324789, 0.000918649137020111],
  ],
  [
    [118.429992877331, 24.7455835064544, 0.000918579287827015],
    [118.429478887424, 24.7461323981663, 0.000918646343052387],
  ],
  [
    [118.429978110718, 24.7455719678018, 0.000918576493859291],
    [118.429463616373, 24.746120462509, 0.000918644480407238],
  ],
  [
    [118.429963344096, 24.7455604110921, 0.000918575562536716],
    [118.429448355204, 24.7461085178171, 0.000918642617762089],
  ],
  [
    [118.429948597242, 24.7455488453426, 0.000918573699891567],
    [118.429433113803, 24.7460965640853, 0.000918641686439514],
  ],
  [
    [118.429933860265, 24.7455372615309, 0.000918573699891567],
    [118.429417872394, 24.7460845922964, 0.000918641686439514],
  ],
  [
    [118.429919123286, 24.7455256686898, 0.000918572768568993],
    [118.429402640868, 24.7460726114729, 0.000918639823794365],
  ],
  [
    [118.429904406074, 24.745514066809, 0.00091856811195612],
    [118.429387429105, 24.7460606125818, 0.00091863889247179],
  ],
  [
    [118.429889698745, 24.7455024558937, 0.00091856811195612],
    [118.42937222723, 24.7460486136839, 0.00091863889247179],
  ],
  [
    [118.429875001298, 24.7454908359438, 0.00091856624931097],
    [118.429357025346, 24.7460365967289, 0.000918635167181492],
  ],
  [
    [118.429860313728, 24.7454791979316, 0.000918565317988396],
    [118.429341843231, 24.7460245707341, 0.000918632373213768],
  ],
  [
    [118.429845636041, 24.745467550885, 0.000918563455343246],
    [118.429326670994, 24.7460125266769, 0.000918632373213768],
  ],
  [
    [118.429830968237, 24.7454558948038, 0.000918562524020672],
    [118.429311508639, 24.7460004735851, 0.000918630510568619],
  ],
  [
    [118.4298163202, 24.7454442296829, 0.000918560661375523],
    [118.429296366052, 24.7459884114536, 0.00091862864792347],
  ],
  [
    [118.429801672155, 24.7454325465049, 0.000918559730052948],
    [118.429281223463, 24.7459763402927, 0.00091862864792347],
  ],
  [
    [118.429787033998, 24.7454208633203, 0.000918557867407799],
    [118.429266090756, 24.7459642600972, 0.00091862678527832],
  ],
  [
    [118.429772415604, 24.7454091620681, 0.00091855600476265],
    [118.429250977813, 24.7459521618342, 0.000918625853955746],
  ],
  [
    [118.429757797201, 24.7453974427588, 0.0009185541421175],
    [118.429235874752, 24.7459400545366, 0.000918623059988022],
  ],
  [
    [118.429743198571, 24.7453857234376, 0.000918552279472351],
    [118.429220781568, 24.7459279291767, 0.000918622128665447],
  ],
  [
    [118.429728609819, 24.7453739860542, 0.000918553210794926],
    [118.429205688388, 24.7459158038153, 0.000918621197342873],
  ],
  [
    [118.429714030949, 24.7453622396363, 0.000918550416827202],
    [118.42919061497, 24.7459036603863, 0.000918618403375149],
  ],
  [
    [118.429699461962, 24.7453504841839, 0.000918548554182053],
    [118.42917556132, 24.7458915079175, 0.000918617472052574],
  ],
  [
    [118.429684892971, 24.7453387197022, 0.000918547622859478],
    [118.429160507662, 24.7458793373916, 0.000918617472052574],
  ],
  [
    [118.429670353629, 24.7453269371478, 0.000918546691536903],
    [118.429145463887, 24.7458671578312, 0.000918612815439701],
  ],
  [
    [118.429655814284, 24.7453151455642, 0.000918544828891754],
    [118.429130439886, 24.7458549782589, 0.000918611884117126],
  ],
  [
    [118.429641284821, 24.7453033449462, 0.000918542966246605],
    [118.429115415871, 24.7458427716016, 0.000918609090149403],
  ],
  [
    [118.429626765241, 24.7452915352936, 0.000918541103601456],
    [118.42910041163, 24.7458305649324, 0.000918609090149403],
  ],
  [
    [118.429612265423, 24.7452797075736, 0.000918540172278881],
    [118.429085417266, 24.7458183402009, 0.000918608158826828],
  ],
  [
    [118.429597765608, 24.7452678798522, 0.000918538309633732],
    [118.429070432785, 24.7458061064349, 0.000918605364859104],
  ],
  [
    [118.429583285556, 24.7452560340632, 0.000918538309633732],
    [118.429055458187, 24.7457938636343, 0.000918605364859104],
  ],
  [
    [118.4295688055, 24.7452441792451, 0.000918535515666008],
    [118.429040493466, 24.7457816027714, 0.00091860257089138],
  ],
  [
    [118.429554345207, 24.7452323063594, 0.000918534584343433],
    [118.429025548519, 24.7457693418967, 0.000918601639568806],
  ],
  [
    [118.429539894802, 24.7452204334671, 0.000918533653020859],
    [118.429010603564, 24.7457570629648, 0.000918601639568806],
  ],
  [
    [118.429525454274, 24.7452085425126, 0.00091853179037571],
    [118.428995678372, 24.7457447659654, 0.000918596982955933],
  ],
  [
    [118.429511023629, 24.7451966425237, 0.00091852992773056],
    [118.428980763068, 24.7457324689593, 0.000918598845601082],
  ],
  [
    [118.429496602866, 24.7451847335003, 0.000918528065085411],
    [118.428965847755, 24.7457201538962, 0.000918596051633358],
  ],
  [
    [118.429482191986, 24.7451728154425, 0.000918527133762836],
    [118.428950952211, 24.7457078297933, 0.00091859232634306],
  ],
  [
    [118.429467800868, 24.7451608793172, 0.000918525271117687],
    [118.428936076436, 24.7456954966508, 0.00091859232634306],
  ],
  [
    [118.429453409748, 24.7451489341627, 0.000918524339795113],
    [118.428921200652, 24.7456831454511, 0.00091859046369791],
  ],
  [
    [118.429439038395, 24.7451369799686, 0.000918521545827389],
    [118.428906334757, 24.7456707942448, 0.000918589532375336],
  ],
  [
    [118.42942466704, 24.7451250167453, 0.000918520614504814],
    [118.428891488624, 24.745658424971, 0.000918587669730186],
  ],
  [
    [118.429410315452, 24.7451130444823, 0.00091851782053709],
    [118.428876652369, 24.7456460376349, 0.000918585807085037],
  ],
  [
    [118.429395973742, 24.7451010541572, 0.000918515957891941],
    [118.428861826002, 24.7456336502922, 0.000918584875762463],
  ],
  [
    [118.429381641914, 24.7450890547976, 0.000918515026569366],
    [118.428847009513, 24.7456212448872, 0.000918583013117313],
  ],
  [
    [118.429367319969, 24.7450770464036, 0.000918514095246792],
    [118.428832202906, 24.7456088304477, 0.000918581150472164],
  ],
  [
    [118.429353007906, 24.7450650289752, 0.000918513163924217],
    [118.428817406182, 24.7455964069738, 0.000918579287827015],
  ],
  [
    [118.42933870572, 24.7450529934846, 0.000918511301279068],
    [118.428802619335, 24.7455839654376, 0.00091858021914959],
  ],
  [
    [118.429324413423, 24.7450409579874, 0.000918510369956493],
    [118.428787852263, 24.7455715238895, 0.000918577425181866],
  ],
  [
    [118.429310140888, 24.7450289044228, 0.000918509438633919],
    [118.428773095068, 24.7455590642792, 0.000918573699891567],
  ],
  [
    [118.42929586835, 24.745016841829, 0.00091850571334362],
    [118.428758347749, 24.7455465866067, 0.000918573699891567],
  ],
  [
    [118.42928161558, 24.7450047701956, 0.000918504782021046],
    [118.42874361032, 24.7455341089275, 0.000918571837246418],
  ],
  [
    [118.429267372687, 24.7449926805001, 0.000918504782021046],
    [118.428728882767, 24.745521613186, 0.000918569974601269],
  ],
  [
    [118.429253139682, 24.7449805907979, 0.000918501056730747],
    [118.428714165098, 24.7455091084102, 0.000918569043278694],
  ],
  [
    [118.429238916554, 24.7449684830335, 0.000918501056730747],
    [118.428699457311, 24.7454965945998, 0.00091856811195612],
  ],
  [
    [118.429224703309, 24.7449563662348, 0.000918500125408173],
    [118.428684769293, 24.7454840717499, 0.00091856624931097],
  ],
  [
    [118.429210499941, 24.744944231374, 0.000918498262763023],
    [118.428670091152, 24.7454715308377, 0.000918564386665821],
  ],
  [
    [118.429196316346, 24.7449320965012, 0.000918497331440449],
    [118.428655422899, 24.7454589899189, 0.000918563455343246],
  ],
  [
    [118.429182132743, 24.7449199435716, 0.00091849360615015],
    [118.428640764518, 24.7454464219101, 0.000918560661375523],
  ],
  [
    [118.429167968914, 24.7449077906302, 0.000918494537472725],
    [118.428626116026, 24.7454338538946, 0.000918557867407799],
  ],
  [
    [118.429153805076, 24.7448956196318, 0.000918489880859852],
    [118.428611477416, 24.7454212768447, 0.000918558798730373],
  ],
  [
    [118.429139661006, 24.7448834395939, 0.000918490812182426],
    [118.42859685857, 24.7454086817275, 0.00091855600476265],
  ],
  [
    [118.429125526813, 24.7448712414938, 0.000918487086892128],
    [118.428582249606, 24.7453960775758, 0.000918553210794926],
  ],
  [
    [118.429111402509, 24.7448590433871, 0.000918488018214703],
    [118.428567650525, 24.7453834643897, 0.0009185541421175],
  ],
  [
    [118.429097297967, 24.7448468272131, 0.000918487086892128],
    [118.428553061321, 24.7453708331414, 0.000918552279472351],
  ],
  [
    [118.429083193422, 24.74483460201, 0.00091848336160183],
    [118.428538482006, 24.7453582018865, 0.000918550416827202],
  ],
  [
    [118.429069098759, 24.7448223677725, 0.000918482430279255],
    [118.428523912568, 24.7453455525694, 0.000918546691536903],
  ],
  [
    [118.429055023865, 24.7448101244954, 0.00091848149895668],
    [118.428509362898, 24.7453328942127, 0.000918546691536903],
  ],
  [
    [118.429040958847, 24.7447978631563, 0.000918478704988956],
    [118.42849481322, 24.745320217799, 0.00091854389756918],
  ],
  [
    [118.429026903718, 24.7447856018105, 0.000918476842343807],
    [118.428480283316, 24.7453075413736, 0.000918542966246605],
  ],
  [
    [118.429012848581, 24.7447733224079, 0.000918476842343807],
    [118.42846576329, 24.7452948468859, 0.00091854203492403],
  ],
  [
    [118.428998823097, 24.7447610339605, 0.000918474979698658],
    [118.428451253146, 24.7452821433639, 0.000918541103601456],
  ],
  [
    [118.42898479761, 24.744748736484, 0.000918474979698658],
    [118.428436762771, 24.7452694308023, 0.000918538309633732],
  ],
  [
    [118.428970782, 24.7447364209454, 0.000918472185730934],
    [118.428422272387, 24.7452567001837, 0.000918538309633732],
  ],
  [
    [118.428956786163, 24.744724105395, 0.00091846939176321],
    [118.428407801777, 24.7452439695534, 0.000918535515666008],
  ],
  [
    [118.428942790318, 24.7447117717877, 0.00091846939176321],
    [118.428393341045, 24.7452312208609, 0.000918534584343433],
  ],
  [
    [118.428928814242, 24.744699429141, 0.000918466597795486],
    [118.428378890196, 24.745218463134, 0.000918532721698284],
  ],
  [
    [118.428914848048, 24.7446870774598, 0.000918464735150337],
    [118.428364449229, 24.7452056963727, 0.00091853179037571],
  ],
  [
    [118.428900891736, 24.7446747167444, 0.000918464735150337],
    [118.428350028025, 24.7451929115442, 0.000918528065085411],
  ],
  [
    [118.428886945307, 24.7446623469947, 0.000918461941182613],
    [118.428335606825, 24.7451801267142, 0.000918527133762836],
  ],
  [
    [118.428873018641, 24.7446499591777, 0.000918460078537464],
    [118.428321205387, 24.7451673238169, 0.000918526202440262],
  ],
  [
    [118.428859091971, 24.7446375623316, 0.000918458215892315],
    [118.428306813831, 24.7451545118853, 0.000918524339795113],
  ],
  [
    [118.428845185076, 24.7446251654737, 0.00091845728456974],
    [118.428292432153, 24.7451416818915, 0.000918522477149963],
  ],
  [
    [118.428831278172, 24.744612750559, 0.000918456353247166],
    [118.428278060364, 24.7451288518911, 0.000918521545827389],
  ],
  [
    [118.42881739103, 24.744600317577, 0.000918455421924591],
    [118.428263708338, 24.7451160038235, 0.000918518751859665],
  ],
  [
    [118.428803513777, 24.7445878845885, 0.000918453559279442],
    [118.428249356308, 24.7451031467267, 0.000918516889214516],
  ],
  [
    [118.4287896464, 24.7445754335379, 0.000918451696634293],
    [118.428235024047, 24.7450902805903, 0.000918516889214516],
  ],
  [
    [118.428775798798, 24.7445629824757, 0.000918449833989143],
    [118.42822070167, 24.7450774054197, 0.000918514095246792],
  ],
  [
    [118.428761951186, 24.7445505133565, 0.000918448902666569],
    [118.428206389169, 24.7450645121869, 0.000918514095246792],
  ],
  [
    [118.428748123343, 24.7445380351979, 0.00091844704002142],
    [118.428192096437, 24.7450516099146, 0.000918513163924217],
  ],
  [
    [118.428734305383, 24.744525548005, 0.000918444246053696],
    [118.428177803702, 24.7450386986132, 0.000918509438633919],
  ],
  [
    [118.428720497299, 24.7445130427501, 0.000918443314731121],
    [118.428163530735, 24.7450257782723, 0.00091850757598877],
  ],
  [
    [118.428706699104, 24.7445005374887, 0.000918443314731121],
    [118.428149267652, 24.745012848897, 0.000918506644666195],
  ],
  [
    [118.428692910785, 24.7444880141652, 0.000918441452085972],
    [118.428135014445, 24.7449999014597, 0.000918504782021046],
  ],
  [
    [118.42867913235, 24.7444754818074, 0.000918439589440823],
    [118.428120781013, 24.7449869540106, 0.000918502919375896],
  ],
  [
    [118.428665373682, 24.7444629404102, 0.000918437726795673],
    [118.428106547572, 24.7449739885047, 0.000918501056730747],
  ],
  [
    [118.428651615012, 24.744450389984, 0.000918436795473099],
    [118.4280923339, 24.7449610139592, 0.000918501056730747],
  ],
  [
    [118.428637876109, 24.7444378305182, 0.000918434001505375],
    [118.428078130105, 24.7449480213517, 0.000918498262763023],
  ],
  [
    [118.428624147084, 24.7444252529905, 0.000918432138860226],
    [118.428063936199, 24.7449350287376, 0.000918496400117874],
  ],
  [
    [118.428610427946, 24.7444126754563, 0.000918430276215076],
    [118.42804975217, 24.7449220180615, 0.000918494537472725],
  ],
  [
    [118.428596728572, 24.7444000798548, 0.000918427482247353],
    [118.428035587909, 24.7449089983459, 0.000918492674827576],
  ],
  [
    [118.428583029194, 24.7443874752244, 0.000918428413569927],
    [118.428021423645, 24.7448959696012, 0.000918490812182426],
  ],
  [
    [118.428569349585, 24.7443748615545, 0.000918426550924778],
    [118.42800727915, 24.7448829318171, 0.000918490812182426],
  ],
  [
    [118.428555679858, 24.7443622388503, 0.000918423756957054],
    [118.427993144533, 24.7448698759708, 0.000918488018214703],
  ],
  [
    [118.428542010128, 24.7443496071171, 0.000918423756957054],
    [118.427979029689, 24.7448568201129, 0.000918487086892128],
  ],
  [
    [118.428528370046, 24.7443369573115, 0.00091842096298933],
    [118.427964914837, 24.7448437461981, 0.000918484292924404],
  ],
  [
    [118.428514729961, 24.7443242984769, 0.000918419100344181],
    [118.427950819754, 24.7448306632439, 0.00091848336160183],
  ],
  [
    [118.428501099765, 24.7443116396358, 0.000918419100344181],
    [118.427936734553, 24.7448175712554, 0.00091848149895668],
  ],
  [
    [118.428487489331, 24.7442989627275, 0.000918417237699032],
    [118.42792265923, 24.7448044612049, 0.000918480567634106],
  ],
  [
    [118.428473888779, 24.7442862767851, 0.000918415375053883],
    [118.427908593795, 24.7447913511478, 0.000918478704988956],
  ],
  [
    [118.428460298105, 24.7442735727806, 0.000918414443731308],
    [118.427894548123, 24.7447782230236, 0.000918475911021233],
  ],
  [
    [118.428446717319, 24.7442608687697, 0.000918412581086159],
    [118.427880512333, 24.7447650858651, 0.000918475911021233],
  ],
  [
    [118.428433146415, 24.7442481557246, 0.00091840885579586],
    [118.427866486427, 24.7447519396724, 0.000918474979698658],
  ],
  [
    [118.428419585388, 24.7442354246175, 0.00091840885579586],
    [118.427852470404, 24.7447387844454, 0.000918474048376083],
  ],
  [
    [118.42840604413, 24.744222684471, 0.000918407924473286],
    [118.427838464257, 24.7447256111563, 0.000918472185730934],
  ],
  [
    [118.428392512754, 24.7442099352903, 0.000918406061828136],
    [118.427824477885, 24.7447124378557, 0.000918468460440636],
  ],
  [
    [118.428378991261, 24.7441971770754, 0.000918404199182987],
    [118.427810491505, 24.7446992464982, 0.000918467529118061],
  ],
  [
    [118.42836547965, 24.7441844098263, 0.000918404199182987],
    [118.427796524893, 24.7446860461012, 0.000918464735150337],
  ],
  [
    [118.428351977922, 24.744171633543, 0.000918400473892689],
    [118.427782578049, 24.7446728366649, 0.000918462872505188],
  ],
  [
    [118.428338495956, 24.7441588391926, 0.00091839861124754],
    [118.427768631203, 24.7446596181996, 0.000918462872505188],
  ],
  [
    [118.428325013993, 24.7441460448409, 0.00091839674860239],
    [118.427754704119, 24.744646381667, 0.00091845914721489],
  ],
  [
    [118.428311551793, 24.7441332324221, 0.000918395817279816],
    [118.427740786924, 24.744633145128, 0.00091845914721489],
  ],
  [
    [118.428298099475, 24.7441204109691, 0.000918393954634666],
    [118.427726879607, 24.744619890527, 0.00091845728456974],
  ],
  [
    [118.428284666925, 24.7441075804768, 0.000918392091989517],
    [118.427712982172, 24.7446066268918, 0.000918453559279442],
  ],
  [
    [118.428271234373, 24.7440947409555, 0.000918390229344368],
    [118.427699104506, 24.7445933542172, 0.000918453559279442],
  ],
  [
    [118.428257821588, 24.7440818923948, 0.000918389298021793],
    [118.427685226831, 24.7445800634857, 0.000918452627956867],
  ],
  [
    [118.428244408801, 24.7440690348051, 0.000918388366699219],
    [118.42767136893, 24.7445667727427, 0.000918449833989143],
  ],
  [
    [118.428231015776, 24.7440561591483, 0.00091838650405407],
    [118.427657530792, 24.7445534639326, 0.000918450765311718],
  ],
  [
    [118.428217632639, 24.7440432834852, 0.000918385572731495],
    [118.427643692652, 24.7445401460934, 0.00091844704002142],
  ],
  [
    [118.428204269265, 24.7440303897549, 0.000918383710086346],
    [118.42762987428, 24.7445268192148, 0.00091844517737627],
  ],
  [
    [118.428190905888, 24.7440174869956, 0.000918381847441196],
    [118.42761606579, 24.7445134833021, 0.000918444246053696],
  ],
  [
    [118.428177562279, 24.744004575197, 0.000918379984796047],
    [118.427602267184, 24.7445001383551, 0.000918443314731121],
  ],
  [
    [118.428164228552, 24.7439916543643, 0.000918379053473473],
    [118.427588478461, 24.7444867843739, 0.000918440520763397],
  ],
  [
    [118.428150904708, 24.7439787244974, 0.000918378122150898],
    [118.4275747095, 24.7444734123257, 0.000918438658118248],
  ],
  [
    [118.428137590747, 24.7439657855964, 0.000918375328183174],
    [118.427560940537, 24.7444600312484, 0.000918435864150524],
  ],
  [
    [118.428124286663, 24.7439528286334, 0.0009183743968606],
    [118.427547191342, 24.7444466411317, 0.000918435864150524],
  ],
  [
    [118.428111002352, 24.7439398716589, 0.000918373465538025],
    [118.427533461915, 24.7444332419758, 0.000918434001505375],
  ],
  [
    [118.428097727919, 24.7439268966225, 0.000918369740247726],
    [118.427519732486, 24.7444198337908, 0.000918432138860226],
  ],
  [
    [118.428084463368, 24.743913912552, 0.000918369740247726],
    [118.427506022825, 24.7444064165665, 0.000918431207537651],
  ],
  [
    [118.428071208699, 24.7439009194473, 0.000918366946280003],
    [118.427492323042, 24.7443929812803, 0.000918428413569927],
  ],
  [
    [118.428057973799, 24.7438879173033, 0.000918364152312279],
    [118.427478633146, 24.7443795459876, 0.000918427482247353],
  ],
  [
    [118.428044738896, 24.7438749061304, 0.000918364152312279],
    [118.427464963014, 24.7443660926279, 0.000918426550924778],
  ],
  [
    [118.428031523761, 24.7438618859182, 0.000918361358344555],
    [118.427451292879, 24.7443526302392, 0.00091842096298933],
  ],
  [
    [118.428018318508, 24.7438488566719, 0.000918361358344555],
    [118.427437642513, 24.7443391588111, 0.000918421894311905],
  ],
  [
    [118.428005123133, 24.7438358093637, 0.000918358564376831],
    [118.427424002029, 24.7443256783489, 0.000918420031666756],
  ],
  [
    [118.427991947531, 24.743822762044, 0.000918357633054256],
    [118.427410381308, 24.7443121798197, 0.000918418169021606],
  ],
  [
    [118.427978771921, 24.7438096966675, 0.000918356701731682],
    [118.42739676059, 24.7442986812892, 0.000918417237699032],
  ],
  [
    [118.427965616078, 24.7437966222518, 0.000918353907763958],
    [118.427383159635, 24.7442851646916, 0.000918415375053883],
  ],
  [
    [118.427952470124, 24.7437835478298, 0.000918352045118809],
    [118.427369568563, 24.7442716390599, 0.000918412581086159],
  ],
  [
    [118.427939334047, 24.7437704553459, 0.00091835018247366],
    [118.427355997259, 24.744258104389, 0.000918411649763584],
  ],
  [
    [118.427926217738, 24.7437573538228, 0.000918349251151085],
    [118.427342425953, 24.744244560689, 0.000918409787118435],
  ],
  [
    [118.427913101421, 24.7437442342429, 0.00091834831982851],
    [118.427328874414, 24.7442310079498, 0.00091840885579586],
  ],
  [
    [118.427900004877, 24.7437311146515, 0.000918346457183361],
    [118.427315332759, 24.7442174461764, 0.000918407924473286],
  ],
  [
    [118.427886918216, 24.7437179860261, 0.000918344594538212],
    [118.427301810867, 24.744203866336, 0.000918406061828136],
  ],
  [
    [118.427873841431, 24.7437048393388, 0.000918340869247913],
    [118.427288288971, 24.7441902774666, 0.000918402336537838],
  ],
  [
    [118.427860784421, 24.74369169264, 0.000918339937925339],
    [118.42727478685, 24.7441766885858, 0.000918401405215263],
  ],
  [
    [118.427847737287, 24.7436785278794, 0.000918339006602764],
    [118.427261294606, 24.744163081643, 0.000918400473892689],
  ],
  [
    [118.427834690151, 24.7436653540899, 0.00091833807528019],
    [118.427247822131, 24.744149465661, 0.000918397679924965],
  ],
  [
    [118.427821672674, 24.7436521802838, 0.000918335281312466],
    [118.427234349653, 24.74413584065, 0.000918397679924965],
  ],
  [
    [118.427808655188, 24.7436389884209, 0.000918333418667316],
    [118.427220896937, 24.7441221975721, 0.000918395817279816],
  ],
  [
    [118.427795647585, 24.743625787524, 0.000918330624699593],
    [118.42720745411, 24.7441085544877, 0.000918393023312092],
  ],
  [
    [118.427782659749, 24.7436125775879, 0.000918329693377018],
    [118.427194031046, 24.7440948933364, 0.000918391160666943],
  ],
  [
    [118.427769681791, 24.7435993495899, 0.000918328762054443],
    [118.427180607985, 24.7440812321839, 0.000918388366699219],
  ],
  [
    [118.427756713721, 24.7435861215857, 0.000918327830731869],
    [118.427167204686, 24.7440675529644, 0.000918387435376644],
  ],
  [
    [118.427743765419, 24.7435728845423, 0.000918326899409294],
    [118.427153821156, 24.7440538647057, 0.000918387435376644],
  ],
  [
    [118.427730817109, 24.7435596294421, 0.000918323174118996],
    [118.427140437624, 24.744040167418, 0.000918383710086346],
  ],
  [
    [118.427717888572, 24.7435463743306, 0.000918322242796421],
    [118.427127073859, 24.7440264610911, 0.000918382778763771],
  ],
  [
    [118.427704969912, 24.7435331011572, 0.000918320380151272],
    [118.427113719972, 24.7440127367023, 0.000918381847441196],
  ],
  [
    [118.427692061135, 24.7435198189498, 0.000918318517506123],
    [118.427100375973, 24.7439990123072, 0.000918379984796047],
  ],
  [
    [118.427679172132, 24.7435065367309, 0.000918316654860973],
    [118.427087041852, 24.7439852698503, 0.000918376259505749],
  ],
  [
    [118.427666293005, 24.7434932364503, 0.000918314792215824],
    [118.427073727505, 24.743971527382, 0.000918375328183174],
  ],
  [
    [118.427653423761, 24.7434799271356, 0.00091831386089325],
    [118.427060423034, 24.7439577668518, 0.000918373465538025],
  ],
  [
    [118.4276405644, 24.7434666087869, 0.0009183119982481],
    [118.427047128447, 24.7439439972876, 0.000918370671570301],
  ],
  [
    [118.427627714921, 24.7434532814042, 0.0009183119982481],
    [118.427033853628, 24.7439302186841, 0.000918370671570301],
  ],
  [
    [118.427614885204, 24.7434399359545, 0.000918310135602951],
    [118.427020588692, 24.7439164310467, 0.000918368808925152],
  ],
  [
    [118.427602065376, 24.7434265904986, 0.000918307341635227],
    [118.427007333639, 24.7439026343751, 0.000918367877602577],
  ],
  [
    [118.427589255431, 24.7434132360086, 0.000918305478990078],
    [118.426994088463, 24.7438888196417, 0.000918364152312279],
  ],
  [
    [118.427576455362, 24.7433998634569, 0.000918304547667503],
    [118.426980863061, 24.743875004897, 0.000918364152312279],
  ],
  [
    [118.427563665181, 24.7433864908989, 0.000918300822377205],
    [118.426967647536, 24.7438611720904, 0.00091836228966713],
  ],
  [
    [118.427550894763, 24.7433731002739, 0.00091829989105463],
    [118.426954441899, 24.7438473392775, 0.00091836042702198],
  ],
  [
    [118.427538134234, 24.7433597096428, 0.00091829989105463],
    [118.42694124614, 24.7438334884028, 0.000918358564376831],
  ],
  [
    [118.427525383581, 24.7433463009499, 0.000918297097086906],
    [118.426928070149, 24.743819628489, 0.000918357633054256],
  ],
  [
    [118.427512652696, 24.7433328832178, 0.000918296165764332],
    [118.426914904041, 24.7438057595412, 0.000918353907763958],
  ],
  [
    [118.427499931693, 24.7433194564517, 0.000918294303119183],
    [118.426901747816, 24.7437918815593, 0.000918351113796234],
  ],
  [
    [118.427487220574, 24.7433060206517, 0.000918291509151459],
    [118.42688861136, 24.7437779945383, 0.00091835018247366],
  ],
  [
    [118.427474519337, 24.7432925758176, 0.00091828964650631],
    [118.426875474895, 24.7437640894605, 0.000918349251151085],
  ],
  [
    [118.427461827982, 24.7432791219496, 0.00091828778386116],
    [118.426862368089, 24.7437501843663, 0.000918347388505936],
  ],
  [
    [118.427449156395, 24.7432656590424, 0.00091828778386116],
    [118.426849261281, 24.7437362702432, 0.000918347388505936],
  ],
  [
    [118.427436494691, 24.7432521871012, 0.000918284989893436],
    [118.426836174235, 24.7437223380533, 0.000918345525860786],
  ],
  [
    [118.42742384287, 24.7432387061261, 0.000918284058570862],
    [118.426823087187, 24.7437083968343, 0.000918342731893063],
  ],
  [
    [118.427411200931, 24.743225216117, 0.000918282195925713],
    [118.426810029793, 24.7436944465712, 0.000918342731893063],
  ],
  [
    [118.427398578755, 24.7432117080409, 0.000918279401957989],
    [118.426796972401, 24.7436804963069, 0.000918339006602764],
  ],
  [
    [118.427385966466, 24.7431981999588, 0.000918278470635414],
    [118.426783934772, 24.7436665279758, 0.000918337143957615],
  ],
  [
    [118.427373364055, 24.7431846738148, 0.000918276607990265],
    [118.426770907027, 24.7436525506107, 0.000918335281312466],
  ],
  [
    [118.427360771532, 24.7431711476646, 0.000918274745345116],
    [118.426757889158, 24.7436385551837, 0.000918333418667316],
  ],
  [
    [118.427348198771, 24.7431576034476, 0.000918274745345116],
    [118.426744891063, 24.7436245597455, 0.000918332487344742],
  ],
  [
    [118.427335635899, 24.7431440592244, 0.000918271951377392],
    [118.426731902851, 24.7436105552733, 0.000918330624699593],
  ],
  [
    [118.427323082903, 24.7431304969395, 0.000918270088732243],
    [118.426718924517, 24.7435965327393, 0.000918328762054443],
  ],
  [
    [118.42731053979, 24.7431169256206, 0.000918270088732243],
    [118.426705965956, 24.743582510194, 0.000918326899409294],
  ],
  [
    [118.427298006559, 24.7431033452677, 0.000918266363441944],
    [118.426693017273, 24.743568469587, 0.00091832596808672],
  ],
  [
    [118.427285493097, 24.7430897558758, 0.000918264500796795],
    [118.426680078472, 24.7435544199459, 0.00091832410544157],
  ],
  [
    [118.427272989522, 24.7430761664777, 0.000918262638151646],
    [118.42666714956, 24.7435403702987, 0.000918322242796421],
  ],
  [
    [118.42726050571, 24.7430625590128, 0.000918261706829071],
    [118.42665424041, 24.7435263025846, 0.000918320380151272],
  ],
  [
    [118.427248021896, 24.743048942519, 0.000918260775506496],
    [118.426641341143, 24.7435122258365, 0.000918318517506123],
  ],
  [
    [118.427235557849, 24.7430353169862, 0.000918258912861347],
    [118.426628451759, 24.7434981400545, 0.000918315723538399],
  ],
  [
    [118.427223103679, 24.7430216733917, 0.000918256118893623],
    [118.426615582144, 24.7434840452334, 0.000918314792215824],
  ],
  [
    [118.427210669283, 24.7430080297859, 0.000918254256248474],
    [118.42660271252, 24.7434699323557, 0.0009183119982481],
  ],
  [
    [118.427198234883, 24.7429943771513, 0.0009182533249259],
    [118.426589872556, 24.7434558194616, 0.000918311066925526],
  ],
  [
    [118.427185820252, 24.7429807154776, 0.000918250530958176],
    [118.426577032588, 24.7434416975386, 0.000918308272957802],
  ],
  [
    [118.427173415503, 24.74296704477, 0.000918249599635601],
    [118.426564212384, 24.7434275575489, 0.000918307341635227],
  ],
  [
    [118.427161030517, 24.7429533559956, 0.000918248668313026],
    [118.426551402068, 24.7434134175529, 0.000918307341635227],
  ],
  [
    [118.427148645534, 24.7429396672202, 0.000918245874345303],
    [118.426538601629, 24.7433992594952, 0.000918304547667503],
  ],
  [
    [118.427136280318, 24.7429259694057, 0.000918243080377579],
    [118.426525820964, 24.7433851014263, 0.000918300822377205],
  ],
  [
    [118.427123924979, 24.7429122535296, 0.00091824121773243],
    [118.426513050176, 24.7433709252957, 0.00091829989105463],
  ],
  [
    [118.427111589414, 24.7428985376422, 0.00091824121773243],
    [118.426500289272, 24.7433567401311, 0.000918298028409481],
  ],
  [
    [118.427099253841, 24.7428848036982, 0.000918240286409855],
    [118.426487548135, 24.7433425459275, 0.000918298959732056],
  ],
  [
    [118.427086938041, 24.742871069743, 0.000918238423764706],
    [118.426474816881, 24.74332834269, 0.000918294303119183],
  ],
  [
    [118.427074632118, 24.7428573177261, 0.000918237492442131],
    [118.42646209551, 24.7433141304185, 0.000918293371796608],
  ],
  [
    [118.427062345962, 24.7428435566702, 0.000918233767151833],
    [118.426449384022, 24.7432999091131, 0.000918290577828884],
  ],
  [
    [118.427050069695, 24.7428297956082, 0.000918231904506683],
    [118.426436692302, 24.7432856787687, 0.00091828964650631],
  ],
  [
    [118.427037803305, 24.7428160164845, 0.000918231904506683],
    [118.426424010465, 24.7432714393904, 0.00091828778386116],
  ],
  [
    [118.427025546803, 24.7428022373547, 0.000918228179216385],
    [118.42641134839, 24.7432571819454, 0.000918285921216011],
  ],
  [
    [118.427013300179, 24.7427884401632, 0.00091822724789381],
    [118.426398696204, 24.7432429244942, 0.000918283127248287],
  ],
  [
    [118.427001073321, 24.7427746339328, 0.000918226316571236],
    [118.426386053901, 24.743228658009, 0.000918281264603138],
  ],
  [
    [118.426988856347, 24.7427608186684, 0.000918223522603512],
    [118.426373421475, 24.7432143734622, 0.000918280333280563],
  ],
  [
    [118.426976659146, 24.7427470033929, 0.000918221659958363],
    [118.426360808823, 24.7432000889042, 0.000918278470635414],
  ],
  [
    [118.426964461937, 24.7427331700608, 0.000918219797313213],
    [118.426348206048, 24.7431857862845, 0.00091827567666769],
  ],
  [
    [118.426952284495, 24.7427193276897, 0.000918217934668064],
    [118.426335613161, 24.7431714836587, 0.000918274745345116],
  ],
  [
    [118.426940116936, 24.7427054762848, 0.00091821700334549],
    [118.426323040037, 24.7431571629662, 0.000918271951377392],
  ],
  [
    [118.426927969145, 24.7426916158409, 0.000918214209377766],
    [118.426310476796, 24.7431428332397, 0.000918271951377392],
  ],
  [
    [118.426915831237, 24.7426777463631, 0.000918212346732616],
    [118.426297923437, 24.7431284944794, 0.000918270088732243],
  ],
  [
    [118.426903703211, 24.7426638678514, 0.000918211415410042],
    [118.426285389847, 24.7431141466801, 0.000918267294764519],
  ],
  [
    [118.426891585067, 24.7426499803059, 0.000918209552764893],
    [118.42627285626, 24.7430997988798, 0.000918267294764519],
  ],
  [
    [118.426879476806, 24.7426360837266, 0.000918207690119743],
    [118.426260352321, 24.7430854330077, 0.000918264500796795],
  ],
  [
    [118.426867388313, 24.7426221781082, 0.000918206758797169],
    [118.426247848379, 24.7430710581067, 0.000918262638151646],
  ],
  [
    [118.426855309708, 24.7426082724839, 0.000918205827474594],
    [118.426235364205, 24.7430566741668, 0.000918260775506496],
  ],
  [
    [118.426843250866, 24.7425943487928, 0.000918202102184296],
    [118.426222889909, 24.7430422721653, 0.000918259844183922],
  ],
  [
    [118.42683119202, 24.7425804160729, 0.000918201170861721],
    [118.426210435386, 24.7430278701526, 0.000918257050216198],
  ],
  [
    [118.426819152943, 24.7425664743141, 0.000918199308216572],
    [118.426197990747, 24.7430134591061, 0.000918256118893623],
  ],
  [
    [118.426807133628, 24.7425525144886, 0.000918197445571423],
    [118.42618555599, 24.7429990390257, 0.000918254256248474],
  ],
  [
    [118.426795114315, 24.7425385546622, 0.000918196514248848],
    [118.426173131115, 24.7429846099114, 0.000918250530958176],
  ],
  [
    [118.42678311477, 24.7425245857968, 0.000918193720281124],
    [118.426160726004, 24.7429701627305, 0.000918250530958176],
  ],
  [
    [118.426771125108, 24.7425106078976, 0.000918191857635975],
    [118.426148330781, 24.7429557155434, 0.000918247736990452],
  ],
  [
    [118.426759145329, 24.7424966209645, 0.000918189994990826],
    [118.426135955325, 24.7429412593175, 0.000918246805667877],
  ],
  [
    [118.426747185317, 24.7424826249925, 0.000918188132345676],
    [118.426123589748, 24.7429267850299, 0.000918244011700153],
  ],
  [
    [118.426735235188, 24.7424686199867, 0.000918187201023102],
    [118.426111234058, 24.7429123107363, 0.000918243080377579],
  ],
  [
    [118.426723294941, 24.7424546059471, 0.000918185338377953],
    [118.426098888246, 24.742897818381, 0.000918242149055004],
  ],
  [
    [118.426711374462, 24.7424405828686, 0.000918182544410229],
    [118.426086562207, 24.7428833260146, 0.000918238423764706],
  ],
  [
    [118.426699463866, 24.7424265507563, 0.00091818068176508],
    [118.426074246046, 24.7428688155866, 0.000918236561119556],
  ],
  [
    [118.426687563152, 24.7424125096101, 0.000918179750442505],
    [118.426061949653, 24.7428542961198, 0.000918234698474407],
  ],
  [
    [118.426675672321, 24.7423984594302, 0.000918177887797356],
    [118.426049663148, 24.7428397766468, 0.000918232835829258],
  ],
  [
    [118.426663801257, 24.7423844002114, 0.000918176025152206],
    [118.42603738652, 24.7428252391123, 0.000918230973184109],
  ],
  [
    [118.426651940076, 24.7423703319587, 0.000918175093829632],
    [118.426025119775, 24.7428106925439, 0.00091822911053896],
  ],
  [
    [118.426640088778, 24.7423562546723, 0.000918172299861908],
    [118.426012872804, 24.7427961459645, 0.00091822724789381],
  ],
  [
    [118.426628257247, 24.7423421683469, 0.000918170437216759],
    [118.42600063571, 24.7427815813234, 0.000918224453926086],
  ],
  [
    [118.426616435599, 24.7423280729878, 0.000918169505894184],
    [118.425988418385, 24.7427670076435, 0.000918223522603512],
  ],
  [
    [118.426604623834, 24.7423139685949, 0.00091816671192646],
    [118.425976210942, 24.7427524249298, 0.000918223522603512],
  ],
  [
    [118.426592821951, 24.7422998551682, 0.000918165780603886],
    [118.425964013381, 24.7427378331823, 0.000918220728635788],
  ],
  [
    [118.42658103983, 24.7422857236749, 0.000918162986636162],
    [118.425951835595, 24.7427232414237, 0.000918217934668064],
  ],
  [
    [118.426569267597, 24.7422715921755, 0.000918162986636162],
    [118.425939667685, 24.7427086316035, 0.000918217934668064],
  ],
  [
    [118.426557505247, 24.7422574516424, 0.000918160192668438],
    [118.425927509659, 24.7426940127495, 0.00091821514070034],
  ],
  [
    [118.426545762664, 24.7422433020704, 0.000918158330023289],
    [118.425915371406, 24.7426793938844, 0.000918213278055191],
  ],
  [
    [118.426534020074, 24.7422291344419, 0.00091815646737814],
    [118.42590324303, 24.7426647569578, 0.000918212346732616],
  ],
  [
    [118.426522297256, 24.7422149668024, 0.00091815460473299],
    [118.425891134428, 24.7426501200202, 0.000918210484087467],
  ],
  [
    [118.426510584316, 24.7422007811013, 0.000918152742087841],
    [118.425879035708, 24.7426354740487, 0.000918208621442318],
  ],
  [
    [118.426498881263, 24.7421865953942, 0.000918150879442692],
    [118.425866946872, 24.7426208190435, 0.000918205827474594],
  ],
  [
    [118.426487188088, 24.7421723916255, 0.000918149016797543],
    [118.425854877803, 24.7426061549994, 0.000918203964829445],
  ],
  [
    [118.426475514685, 24.7421581878458, 0.000918149016797543],
    [118.425842818618, 24.7425914819216, 0.000918202102184296],
  ],
  [
    [118.42646385116, 24.7421439660046, 0.000918145291507244],
    [118.4258307792, 24.742576799805, 0.000918200239539146],
  ],
  [
    [118.426452187632, 24.7421297351346, 0.000918144360184669],
    [118.42581874967, 24.7425621176823, 0.000918199308216572],
  ],
  [
    [118.426440553757, 24.7421154952208, 0.00091814249753952],
    [118.425806730018, 24.7425474174981, 0.000918196514248848],
  ],
  [
    [118.426428919879, 24.7421012462783, 0.000918138772249222],
    [118.42579473014, 24.7425327173029, 0.000918194651603699],
  ],
  [
    [118.42641729589, 24.7420869973298, 0.000918138772249222],
    [118.425782740144, 24.742518008074, 0.00091819278895855],
  ],
  [
    [118.426405691662, 24.7420727303147, 0.000918136909604073],
    [118.425770760031, 24.7425032898112, 0.0009181909263134],
  ],
  [
    [118.426394087432, 24.7420584542709, 0.000918135978281498],
    [118.425758799686, 24.7424885625097, 0.000918189994990826],
  ],
  [
    [118.426382502969, 24.7420441691883, 0.000918134115636349],
    [118.425746849223, 24.7424738261744, 0.000918187201023102],
  ],
  [
    [118.426370928389, 24.7420298750719, 0.000918132252991199],
    [118.425734908649, 24.7424590898331, 0.000918185338377953],
  ],
  [
    [118.426359363692, 24.7420155719219, 0.000918129459023476],
    [118.425722987843, 24.7424443444531, 0.000918183475732803],
  ],
  [
    [118.426347818762, 24.742001259733, 0.000918128527700901],
    [118.425711076914, 24.7424295810115, 0.000918182544410229],
  ],
  [
    [118.426336273829, 24.7419869385154, 0.000918126665055752],
    [118.425699175879, 24.7424148265918, 0.000918179750442505],
  ],
  [
    [118.426324738779, 24.7419726082641, 0.000918123871088028],
    [118.425687294607, 24.7424000541055, 0.000918179750442505],
  ],
  [
    [118.426313223496, 24.741958268974, 0.000918121077120304],
    [118.425675423217, 24.7423852725855, 0.000918174162507057],
  ],
  [
    [118.426301718096, 24.7419439206502, 0.000918120145797729],
    [118.425663561715, 24.7423704910595, 0.000918174162507057],
  ],
  [
    [118.426290222584, 24.7419295723204, 0.000918120145797729],
    [118.425651719981, 24.7423557004947, 0.000918172299861908],
  ],
  [
    [118.426278736949, 24.7419152059292, 0.000918117351830006],
    [118.425639888131, 24.7423409008962, 0.000918170437216759],
  ],
  [
    [118.426267261197, 24.7419008305042, 0.000918114557862282],
    [118.425628066162, 24.742326092264, 0.000918169505894184],
  ],
  [
    [118.426255795327, 24.7418864460454, 0.000918112695217133],
    [118.425616254082, 24.7423112836258, 0.000918165780603886],
  ],
  [
    [118.426244339339, 24.741872052553, 0.000918112695217133],
    [118.42560446177, 24.7422964659489, 0.000918164849281311],
  ],
  [
    [118.426232903125, 24.7418576590496, 0.000918109901249409],
    [118.425592679341, 24.7422816392383, 0.000918162986636162],
  ],
  [
    [118.426221466902, 24.7418432474897, 0.000918108969926834],
    [118.42558091668, 24.7422668034889, 0.000918161123991013],
  ],
  [
    [118.426210050453, 24.7418288359188, 0.000918108038604259],
    [118.425569154016, 24.7422519587108, 0.000918160192668438],
  ],
  [
    [118.426198633995, 24.7418144062915, 0.00091810617595911],
    [118.425557411126, 24.7422371139218, 0.00091815646737814],
  ],
  [
    [118.42618723731, 24.7417999766532, 0.000918103381991386],
    [118.425545678118, 24.7422222600991, 0.000918153673410416],
  ],
  [
    [118.426175850503, 24.7417855289534, 0.000918101519346237],
    [118.425533964878, 24.7422073972376, 0.000918153673410416],
  ],
  [
    [118.426164473583, 24.7417710812478, 0.000918099656701088],
    [118.425522251641, 24.7421925343753, 0.000918151810765266],
  ],
  [
    [118.426153096661, 24.7417566245134, 0.000918097794055939],
    [118.425510558167, 24.7421776534464, 0.000918150879442692],
  ],
  [
    [118.426141739506, 24.7417421587403, 0.00091809406876564],
    [118.425498874586, 24.7421627815394, 0.000918149016797543],
  ],
  [
    [118.426130392233, 24.7417276839335, 0.00091809406876564],
    [118.425487210768, 24.7421478915659, 0.000918147154152393],
  ],
  [
    [118.426119054844, 24.741713200093, 0.000918093137443066],
    [118.425475546947, 24.7421329925637, 0.000918144360184669],
  ],
  [
    [118.426107727336, 24.7416987072188, 0.000918091274797916],
    [118.4254639029, 24.7421180935506, 0.000918143428862095],
  ],
  [
    [118.426096419597, 24.7416842053059, 0.000918086618185043],
    [118.425452268735, 24.7421031855038, 0.000918141566216946],
  ],
  [
    [118.426085111859, 24.7416697033922, 0.000918085686862469],
    [118.425440644459, 24.742088277451, 0.000918139703571796],
  ],
  [
    [118.426073813999, 24.7416551834169, 0.000918085686862469],
    [118.42542903995, 24.7420733603597, 0.000918137840926647],
  ],
  [
    [118.426062526027, 24.7416406634357, 0.000918082892894745],
    [118.425417435439, 24.7420584342395, 0.000918134115636349],
  ],
  [
    [118.426051247932, 24.7416261253931, 0.000918081030249596],
    [118.425405850696, 24.7420434990808, 0.000918133184313774],
  ],
  [
    [118.42603998961, 24.7416115873396, 0.000918079167604446],
    [118.425394275841, 24.7420285639161, 0.000918131321668625],
  ],
  [
    [118.426028731285, 24.7415970402574, 0.000918076373636723],
    [118.425382720754, 24.7420136197128, 0.000918129459023476],
  ],
  [
    [118.426017482843, 24.7415824841415, 0.000918076373636723],
    [118.425371165664, 24.7419986664807, 0.000918128527700901],
  ],
  [
    [118.426006244283, 24.741567918992, 0.000918073579668999],
    [118.425359630347, 24.7419837132378, 0.000918125733733177],
  ],
  [
    [118.425995025496, 24.7415533538315, 0.000918070785701275],
    [118.425348095028, 24.7419687509662, 0.000918125733733177],
  ],
  [
    [118.425983806701, 24.7415387706146, 0.0009180698543787],
    [118.425336579477, 24.7419537796559, 0.000918123871088028],
  ],
  [
    [118.425972597794, 24.7415241873918, 0.000918068923056126],
    [118.425325073814, 24.7419388083398, 0.000918119214475155],
  ],
  [
    [118.425961398769, 24.7415095951354, 0.000918067060410976],
    [118.425313587919, 24.741923827985, 0.00091811828315258],
  ],
  [
    [118.425950219512, 24.7414949938402, 0.000918065197765827],
    [118.425302102022, 24.7419088386015, 0.000918117351830006],
  ],
  [
    [118.425939040252, 24.7414803835165, 0.000918063335120678],
    [118.425290635897, 24.7418938492071, 0.000918115489184856],
  ],
  [
    [118.425927870874, 24.741465764159, 0.000918060541152954],
    [118.425279179656, 24.7418788507792, 0.000918111763894558],
  ],
  [
    [118.425916711379, 24.741451135768, 0.00091805774718523],
    [118.425267723411, 24.7418638433225, 0.000918110832571983],
  ],
  [
    [118.425905561772, 24.741436507371, 0.000918056815862656],
    [118.425256286941, 24.7418488358549, 0.000918108969926834],
  ],
  [
    [118.425894422047, 24.7414218699404, 0.000918054021894932],
    [118.425244870238, 24.7418338193488, 0.000918107107281685],
  ],
  [
    [118.425883292205, 24.7414072234761, 0.000918053090572357],
    [118.425233453537, 24.7418188028417, 0.000918105244636536],
  ],
  [
    [118.425872172245, 24.7413925679782, 0.000918052159249783],
    [118.42522204672, 24.741803777301, 0.000918102450668812],
  ],
  [
    [118.425861062168, 24.7413779034466, 0.000918048433959484],
    [118.42521065967, 24.7417887427217, 0.000918100588023663],
  ],
  [
    [118.425849961978, 24.7413632389092, 0.000918049365282059],
    [118.425199272623, 24.7417737081415, 0.000918098725378513],
  ],
  [
    [118.425838871671, 24.7413485653382, 0.000918046571314335],
    [118.425187905344, 24.7417586645227, 0.000918098725378513],
  ],
  [
    [118.425827781361, 24.7413338827384, 0.000918043777346611],
    [118.425176547953, 24.741743620898, 0.000918095931410789],
  ],
  [
    [118.425816710818, 24.7413191911001, 0.000918043777346611],
    [118.425165200445, 24.7417285682397, 0.000918095000088215],
  ],
  [
    [118.425805640273, 24.7413044904331, 0.000918040983378887],
    [118.42515386282, 24.7417135065477, 0.000918091274797916],
  ],
  [
    [118.425794589501, 24.7412897897553, 0.000918039120733738],
    [118.425142535082, 24.7416984448499, 0.000918089412152767],
  ],
  [
    [118.425783538726, 24.7412750800488, 0.000918035395443439],
    [118.425131217227, 24.7416833741185, 0.000918088480830193],
  ],
  [
    [118.425772497833, 24.7412603613087, 0.000918036326766014],
    [118.425119909255, 24.7416682943534, 0.000918086618185043],
  ],
  [
    [118.425761466823, 24.741245633535, 0.000918034464120865],
    [118.425108621056, 24.7416532145776, 0.000918084755539894],
  ],
  [
    [118.425750445695, 24.7412308967276, 0.000918030738830566],
    [118.425097332859, 24.7416381348008, 0.000918082892894745],
  ],
  [
    [118.425739434456, 24.7412161599144, 0.000918028876185417],
    [118.425086064431, 24.7416230459855, 0.000918081030249596],
  ],
  [
    [118.425728433098, 24.7412014140676, 0.000918027013540268],
    [118.425074796, 24.7416079481415, 0.000918078236281872],
  ],
  [
    [118.425717441623, 24.7411866591872, 0.000918027013540268],
    [118.425063547342, 24.7415928502868, 0.000918075442314148],
  ],
  [
    [118.425706450151, 24.7411719043059, 0.000918024219572544],
    [118.425052298682, 24.7415777434033, 0.000918074510991573],
  ],
  [
    [118.42569547844, 24.7411571313582, 0.000918023288249969],
    [118.425041069794, 24.7415626365091, 0.000918073579668999],
  ],
  [
    [118.425684506733, 24.7411423584097, 0.000918019562959671],
    [118.425029840905, 24.7415475205862, 0.000918072648346424],
  ],
  [
    [118.425673544913, 24.7411275854554, 0.000918017700314522],
    [118.425018631788, 24.7415324046526, 0.0009180698543787],
  ],
  [
    [118.42566259297, 24.7411127944397, 0.000918016768991947],
    [118.425007432554, 24.7415172796853, 0.000918067991733551],
  ],
  [
    [118.425651650915, 24.7410980034181, 0.000918013975024223],
    [118.424996233317, 24.7415021456894, 0.000918064266443253],
  ],
  [
    [118.425640718742, 24.7410832033629, 0.000918012112379074],
    [118.424985053854, 24.7414870116827, 0.000918064266443253],
  ],
  [
    [118.425629786567, 24.7410683942792, 0.000918011181056499],
    [118.424973884279, 24.7414718776702, 0.000918061472475529],
  ],
  [
    [118.425618874164, 24.7410535851846, 0.00091800931841135],
    [118.424962724586, 24.7414567346242, 0.000918059609830379],
  ],
  [
    [118.425607961759, 24.7410387670614, 0.00091800931841135],
    [118.424951564891, 24.7414415825494, 0.00091805774718523],
  ],
  [
    [118.425597059236, 24.7410239399045, 0.000918005593121052],
    [118.424940424968, 24.7414264304639, 0.000918054953217506],
  ],
  [
    [118.425586166596, 24.7410091037141, 0.000918002799153328],
    [118.424929294929, 24.7414112693448, 0.000918054021894932],
  ],
  [
    [118.425575273958, 24.7409942675229, 0.000918000936508179],
    [118.424918174777, 24.74139610822, 0.000918053090572357],
  ],
  [
    [118.425564401088, 24.7409794222931, 0.000918000005185604],
    [118.424907054628, 24.7413809470942, 0.000918051227927208],
  ],
  [
    [118.42555352822, 24.7409645770625, 0.000917998142540455],
    [118.424895954247, 24.7413657769299, 0.000918048433959484],
  ],
  [
    [118.425542665229, 24.7409497137705, 0.000917995348572731],
    [118.424884853864, 24.741350597737, 0.000918048433959484],
  ],
  [
    [118.425531812126, 24.7409348504727, 0.000917993485927582],
    [118.424873773253, 24.7413354185334, 0.000918044708669186],
  ],
  [
    [118.425520968911, 24.7409199871691, 0.000917992554605007],
    [118.424862692645, 24.7413202393289, 0.000918042846024036],
  ],
  [
    [118.425510125688, 24.740905105809, 0.000917989760637283],
    [118.424851631805, 24.7413050510858, 0.000918040983378887],
  ],
  [
    [118.425499292352, 24.7408902244432, 0.000917990691959858],
    [118.424840570963, 24.7412898538142, 0.000918039120733738],
  ],
  [
    [118.425488468899, 24.7408753340439, 0.000917986035346985],
    [118.424829529899, 24.7412746655596, 0.000918037258088589],
  ],
  [
    [118.425477655334, 24.7408604436387, 0.00091798510402441],
    [118.424818488826, 24.7412594592486, 0.000918034464120865],
  ],
  [
    [118.425466851651, 24.7408455441999, 0.000917982310056686],
    [118.424807457642, 24.7412442529318, 0.000918032601475716],
  ],
  [
    [118.425456047965, 24.7408306357326, 0.000917982310056686],
    [118.424796436346, 24.7412290466092, 0.000918030738830566],
  ],
  [
    [118.425445254167, 24.7408157272594, 0.000917979516088963],
    [118.424785424932, 24.741213831253, 0.000918029807507992],
  ],
  [
    [118.425434470251, 24.7408008097527, 0.000917976722121239],
    [118.424774423407, 24.7411986158911, 0.000918027944862843],
  ],
  [
    [118.425423686332, 24.7407858832174, 0.000917974859476089],
    [118.424763431769, 24.7411834005234, 0.000918026082217693],
  ],
  [
    [118.425412922187, 24.7407709566713, 0.000917974859476089],
    [118.424752450014, 24.7411681761221, 0.000918024219572544],
  ],
  [
    [118.425402158039, 24.7407560210967, 0.000917972065508366],
    [118.424741478141, 24.7411529426873, 0.000918020494282246],
  ],
  [
    [118.425391403773, 24.7407410764884, 0.000917970202863216],
    [118.424730506271, 24.7411377092517, 0.000918020494282246],
  ],
  [
    [118.425380649509, 24.7407261318794, 0.000917967408895493],
    [118.424719544289, 24.7411224758103, 0.000918017700314522],
  ],
  [
    [118.425369905128, 24.7407111782368, 0.000917966477572918],
    [118.424708602075, 24.7411072333304, 0.000918015837669373],
  ],
  [
    [118.425359170635, 24.7406962245884, 0.000917962752282619],
    [118.424697659863, 24.7410919908496, 0.000918013043701649],
  ],
  [
    [118.425348446024, 24.7406812619065, 0.000917962752282619],
    [118.424686727534, 24.7410767393354, 0.000918013043701649],
  ],
  [
    [118.42533772141, 24.7406662901959, 0.000917959958314896],
    [118.424675805093, 24.7410614878153, 0.000918011181056499],
  ],
  [
    [118.425327006684, 24.7406513184796, 0.000917959026992321],
    [118.42466489254, 24.7410462362895, 0.000918006524443626],
  ],
  [
    [118.42531630184, 24.7406363377298, 0.000917956233024597],
    [118.424653979984, 24.7410309757351, 0.000918006524443626],
  ],
  [
    [118.425305596994, 24.7406213479514, 0.000917953439056873],
    [118.424643087201, 24.74101571517, 0.000918003730475903],
  ],
  [
    [118.42529491192, 24.7406063581622, 0.000917954370379448],
    [118.424632194416, 24.7410004455763, 0.000918001867830753],
  ],
  [
    [118.425284216959, 24.7405913593494, 0.000917951576411724],
    [118.424621311518, 24.7409851759769, 0.000918000005185604],
  ],
  [
    [118.42527354177, 24.7405763605259, 0.000917950645089149],
    [118.424610438509, 24.7409699063717, 0.000918000005185604],
  ],
  [
    [118.425262866579, 24.7405613526738, 0.000917946919798851],
    [118.424599575382, 24.740954627733, 0.00091799721121788],
  ],
  [
    [118.425252201275, 24.7405463448159, 0.000917945988476276],
    [118.424588722143, 24.7409393490885, 0.000917995348572731],
  ],
  [
    [118.425241535969, 24.7405313279295, 0.000917945057153702],
    [118.424577868906, 24.7409240704432, 0.000917992554605007],
  ],
  [
    [118.425230880545, 24.7405163020095, 0.000917942263185978],
    [118.424567025552, 24.7409087827644, 0.000917991623282433],
  ],
  [
    [118.425220235008, 24.7405012760838, 0.000917939469218254],
    [118.424556192086, 24.7408934950798, 0.000917988829314709],
  ],
  [
    [118.425209599354, 24.7404862411245, 0.00091793667525053],
    [118.424545368502, 24.7408781983617, 0.000917987897992134],
  ],
  [
    [118.425198963697, 24.7404711971367, 0.000917935743927956],
    [118.424534554807, 24.7408629016379, 0.000917984172701836],
  ],
  [
    [118.425188328048, 24.7404561621759, 0.000917934812605381],
    [118.424523741114, 24.7408476049133, 0.000917984172701836],
  ],
  [
    [118.425177712162, 24.7404411091487, 0.000917932949960232],
    [118.424512947188, 24.7408322991502, 0.000917982310056686],
  ],
  [
    [118.425167096277, 24.7404260561208, 0.000917930155992508],
    [118.424502153266, 24.7408169933863, 0.000917979516088963],
  ],
  [
    [118.42515648039, 24.7404109940643, 0.000917927362024784],
    [118.424491359346, 24.7408016876216, 0.000917978584766388],
  ],
  [
    [118.425145874391, 24.7403959320021, 0.000917925499379635],
    [118.424480585194, 24.7407863728185, 0.000917975790798664],
  ],
  [
    [118.425135278274, 24.7403808609063, 0.00091792456805706],
    [118.424469811044, 24.7407710580146, 0.000917973928153515],
  ],
  [
    [118.425124692045, 24.7403657898048, 0.000917922705411911],
    [118.424459046782, 24.740755743205, 0.000917971134185791],
  ],
  [
    [118.425114105813, 24.7403507096748, 0.000917918980121613],
    [118.424448292403, 24.7407404193618, 0.000917970202863216],
  ],
  [
    [118.425103519583, 24.7403356295439, 0.000917918980121613],
    [118.424437547912, 24.7407250955129, 0.000917966477572918],
  ],
  [
    [118.425092943236, 24.7403205403796, 0.000917917117476463],
    [118.424426803423, 24.7407097716632, 0.000917965546250343],
  ],
  [
    [118.425082376776, 24.7403054512094, 0.000917915254831314],
    [118.424416068817, 24.7406944387801, 0.000917963683605194],
  ],
  [
    [118.425071810314, 24.7402903530108, 0.000917913392186165],
    [118.424405344098, 24.7406791058912, 0.000917961820960045],
  ],
  [
    [118.425061253734, 24.7402752457786, 0.000917911529541016],
    [118.424394619383, 24.7406637730015, 0.000917959026992321],
  ],
  [
    [118.425050707047, 24.7402601475684, 0.000917908735573292],
    [118.424383904555, 24.7406484401061, 0.000917959026992321],
  ],
  [
    [118.425040160352, 24.740245031302, 0.000917907804250717],
    [118.424373199609, 24.7406330981772, 0.000917956233024597],
  ],
  [
    [118.42502961366, 24.7402299150347, 0.000917905941605568],
    [118.424362504552, 24.7406177562426, 0.000917955301702023],
  ],
  [
    [118.42501908674, 24.7402147987568, 0.000917904078960419],
    [118.424351809492, 24.7406024052794, 0.000917953439056873],
  ],
  [
    [118.425008549932, 24.7401996734552, 0.000917903147637844],
    [118.424341124319, 24.7405870543105, 0.000917949713766575],
  ],
  [
    [118.424998032892, 24.7401845391152, 0.00091790035367012],
    [118.424330449035, 24.7405717033359, 0.000917948782444],
  ],
  [
    [118.424987505969, 24.7401694047794, 0.000917897559702396],
    [118.424319773753, 24.7405563523605, 0.000917946919798851],
  ],
  [
    [118.42497699882, 24.7401542704329, 0.000917896628379822],
    [118.424309108359, 24.7405410013794, 0.000917946919798851],
  ],
  [
    [118.424966491667, 24.7401391270578, 0.000917895697057247],
    [118.424298452847, 24.7405256413648, 0.000917941331863403],
  ],
  [
    [118.424955984511, 24.7401239746542, 0.000917891971766949],
    [118.424287797338, 24.7405102813495, 0.000917939469218254],
  ],
  [
    [118.424945487243, 24.7401088222449, 0.00091788824647665],
    [118.424277151711, 24.7404949123006, 0.000917938537895679],
  ],
  [
    [118.424934989978, 24.7400936698348, 0.000917889177799225],
    [118.424266515978, 24.7404795522738, 0.00091793667525053],
  ],
  [
    [118.424924502595, 24.7400785083912, 0.000917887315154076],
    [118.424255880242, 24.7404641832185, 0.000917934812605381],
  ],
  [
    [118.424914015215, 24.7400633469468, 0.000917884521186352],
    [118.424245254394, 24.7404488141575, 0.000917933881282806],
  ],
  [
    [118.424903537717, 24.7400481764689, 0.000917882658541203],
    [118.424234638428, 24.740433436063, 0.000917932018637657],
  ],
  [
    [118.424893070106, 24.7400330059853, 0.000917881727218628],
    [118.42422402247, 24.7404180669955, 0.000917929224669933],
  ],
  [
    [118.424882592608, 24.7400178264782, 0.000917878933250904],
    [118.424213416395, 24.7404026888945, 0.000917927362024784],
  ],
  [
    [118.424872134882, 24.7400026469603, 0.000917877070605755],
    [118.424202820207, 24.7403873107879, 0.00091792456805706],
  ],
  [
    [118.424861677154, 24.7399874584139, 0.000917874276638031],
    [118.424192224022, 24.7403719326805, 0.000917922705411911],
  ],
  [
    [118.424851219428, 24.7399722698668, 0.000917873345315456],
    [118.42418163772, 24.7403565455396, 0.000917920842766762],
  ],
  [
    [118.42484077159, 24.7399570813139, 0.000917871482670307],
    [118.42417105142, 24.7403411583979, 0.000917918980121613],
  ],
  [
    [118.424830323749, 24.7399418837325, 0.000917869620025158],
    [118.424160475008, 24.7403257712505, 0.000917918048799038],
  ],
  [
    [118.42481987591, 24.7399266861503, 0.000917866826057434],
    [118.424149908484, 24.7403103840975, 0.000917916186153889],
  ],
  [
    [118.424809437954, 24.7399114795347, 0.000917864963412285],
    [118.424139341957, 24.7402949879159, 0.000917913392186165],
  ],
  [
    [118.42479900988, 24.7398962638855, 0.00091786403208971],
    [118.424128775438, 24.7402796007613, 0.000917913392186165],
  ],
  [
    [118.424788581814, 24.7398810572634, 0.000917861238121986],
    [118.424118228687, 24.7402642045684, 0.000917908735573292],
  ],
  [
    [118.424778153746, 24.7398658416128, 0.000917860306799412],
    [118.424107681938, 24.7402488083746, 0.000917907804250717],
  ],
  [
    [118.424767735559, 24.7398506169286, 0.000917857512831688],
    [118.424097135192, 24.7402334121801, 0.000917906872928143],
  ],
  [
    [118.424757317375, 24.7398353922437, 0.000917856581509113],
    [118.424086598328, 24.7402180069522, 0.000917904078960419],
  ],
  [
    [118.424746909079, 24.7398201675531, 0.000917853787541389],
    [118.424076071352, 24.7402026017186, 0.000917902216315269],
  ],
  [
    [118.42473650078, 24.739804933834, 0.000917852856218815],
    [118.424065544384, 24.740187205512, 0.000917899422347546],
  ],
  [
    [118.424726102369, 24.7397897001091, 0.000917850993573666],
    [118.424055027298, 24.7401718002719, 0.00091790035367012],
  ],
  [
    [118.424715694069, 24.7397744573607, 0.000917850062251091],
    [118.42404451021, 24.7401563860033, 0.000917896628379822],
  ],
  [
    [118.424705305543, 24.7397592146016, 0.000917846336960793],
    [118.424034003015, 24.7401409807568, 0.000917894765734673],
  ],
  [
    [118.424694907134, 24.7397439718468, 0.000917844474315643],
    [118.424023495817, 24.7401255664818, 0.000917892903089523],
  ],
  [
    [118.424684518607, 24.7397287200584, 0.000917843542993069],
    [118.424012998512, 24.7401101612289, 0.000917890109121799],
  ],
  [
    [118.424674139968, 24.7397134682644, 0.000917840749025345],
    [118.424002501205, 24.7400947469474, 0.000917891040444374],
  ],
  [
    [118.424663751446, 24.7396982164745, 0.000917838886380196],
    [118.423992013785, 24.7400793326603, 0.000917886383831501],
  ],
  [
    [118.424653382691, 24.7396829556462, 0.000917838886380196],
    [118.423981526362, 24.7400639093446, 0.000917884521186352],
  ],
  [
    [118.424643004055, 24.7396676948221, 0.000917835161089897],
    [118.423971048833, 24.740048495051, 0.000917881727218628],
  ],
  [
    [118.4246326353, 24.7396524249646, 0.000917832367122173],
    [118.423960571301, 24.7400330717289, 0.000917880795896053],
  ],
  [
    [118.424622266548, 24.7396371551063, 0.000917830504477024],
    [118.423950103662, 24.740017657429, 0.000917879864573479],
  ],
  [
    [118.424611907683, 24.7396218852423, 0.000917829573154449],
    [118.423939645905, 24.7400022340956, 0.000917877070605755],
  ],
  [
    [118.424601548816, 24.7396066063497, 0.000917826779186726],
    [118.423929178266, 24.7399868107663, 0.000917875207960606],
  ],
  [
    [118.424591189951, 24.7395913274565, 0.000917824916541576],
    [118.4239187304, 24.7399713874265, 0.000917874276638031],
  ],
  [
    [118.424580831084, 24.7395760395347, 0.000917823985219002],
    [118.42390828253, 24.7399559550581, 0.000917871482670307],
  ],
  [
    [118.424570482104, 24.7395607516072, 0.000917822122573853],
    [118.423897834669, 24.7399405317168, 0.000917868688702583],
  ],
  [
    [118.424560133126, 24.7395454636789, 0.000917820259928703],
    [118.423887386805, 24.7399250993469, 0.000917865894734859],
  ],
  [
    [118.424549794037, 24.739530175745, 0.000917817465960979],
    [118.42387695872, 24.7399096759943, 0.000917866826057434],
  ],
  [
    [118.424539454944, 24.7395148787826, 0.00091781560331583],
    [118.423866520746, 24.739894243618, 0.000917863100767136],
  ],
  [
    [118.424529115854, 24.7394995818194, 0.000917812809348106],
    [118.42385609266, 24.7398788112361, 0.000917863100767136],
  ],
  [
    [118.424518776761, 24.7394842758276, 0.000917811878025532],
    [118.423845674462, 24.7398633788486, 0.000917859375476837],
  ],
  [
    [118.424508447556, 24.7394689698303, 0.000917810946702957],
    [118.423835256267, 24.7398479464602, 0.000917856581509113],
  ],
  [
    [118.424498118353, 24.7394536638321, 0.000917809084057808],
    [118.423824838069, 24.7398325050434, 0.000917855650186539],
  ],
  [
    [118.424487789153, 24.7394383578332, 0.000917807221412659],
    [118.423814429763, 24.7398170726487, 0.000917853787541389],
  ],
  [
    [118.424477469835, 24.7394230428009, 0.000917805358767509],
    [118.423804021461, 24.7398016402532, 0.000917850993573666],
  ],
  [
    [118.424467140635, 24.7394077277727, 0.000917801633477211],
    [118.423793613155, 24.7397861988292, 0.000917850993573666],
  ],
  [
    [118.424456831202, 24.7393924037062, 0.000917799770832062],
    [118.423783214738, 24.7397707573995, 0.000917848199605942],
  ],
  [
    [118.424446511892, 24.7393770886716, 0.000917798839509487],
    [118.423772826213, 24.7397553249921, 0.000917845405638218],
  ],
  [
    [118.424436192573, 24.7393617555807, 0.000917796976864338],
    [118.423762427801, 24.7397398835609, 0.000917844474315643],
  ],
  [
    [118.424425883148, 24.7393464315119, 0.000917794182896614],
    [118.423752039276, 24.7397244421241, 0.000917843542993069],
  ],
  [
    [118.424415573719, 24.7393310984146, 0.000917793251574039],
    [118.423741660639, 24.7397090006817, 0.000917840749025345],
  ],
  [
    [118.424405274179, 24.7393157653116, 0.00091779138892889],
    [118.423731282004, 24.7396935592386, 0.000917837023735046],
  ],
  [
    [118.424394964756, 24.7393004322128, 0.000917788594961166],
    [118.423720903372, 24.7396781177947, 0.000917836092412472],
  ],
  [
    [118.42438466522, 24.7392850991084, 0.000917786732316017],
    [118.423710534623, 24.7396626673173, 0.000917833298444748],
  ],
  [
    [118.424374365682, 24.7392697569754, 0.000917785800993443],
    [118.423700165881, 24.7396472258671, 0.000917832367122173],
  ],
  [
    [118.424364066146, 24.7392544148417, 0.000917783007025719],
    [118.423689797142, 24.739631784416, 0.000917829573154449],
  ],
  [
    [118.424353766607, 24.7392390636794, 0.000917781144380569],
    [118.423679438286, 24.7396163339316, 0.0009178277105093],
  ],
  [
    [118.424343476956, 24.7392237125115, 0.000917778350412846],
    [118.423669079437, 24.7396008924742, 0.000917826779186726],
  ],
  [
    [118.424333187307, 24.7392083613429, 0.000917778350412846],
    [118.423658720585, 24.7395854419882, 0.000917823985219002],
  ],
  [
    [118.424322897661, 24.7391930101735, 0.000917774625122547],
    [118.423648371627, 24.7395700005244, 0.000917822122573853],
  ],
  [
    [118.424312608018, 24.7391776590033, 0.000917773693799973],
    [118.423638022665, 24.7395545500321, 0.000917819328606129],
  ],
  [
    [118.424302318372, 24.7391622988047, 0.000917771831154823],
    [118.423627673712, 24.7395391085669, 0.000917819328606129],
  ],
  [
    [118.424292038613, 24.7391469386004, 0.000917769037187099],
    [118.423617334641, 24.7395236580682, 0.000917816534638405],
  ],
  [
    [118.424281758857, 24.7391315783953, 0.00091776717454195],
    [118.423606995572, 24.7395082075688, 0.00091781560331583],
  ],
  [
    [118.424271469213, 24.7391162091666, 0.000917765311896801],
    [118.423596656507, 24.7394927570686, 0.000917811878025532],
  ],
  [
    [118.424261199341, 24.7391008399274, 0.000917763449251652],
    [118.423586317449, 24.7394773155955, 0.000917810946702957],
  ],
  [
    [118.424250919587, 24.7390854706923, 0.000917761586606503],
    [118.423575988273, 24.7394618650889, 0.000917808152735233],
  ],
  [
    [118.424240639836, 24.7390701014565, 0.000917758792638779],
    [118.4235656591, 24.7394464145817, 0.000917807221412659],
  ],
  [
    [118.424230360087, 24.73905473222, 0.000917757861316204],
    [118.423555339814, 24.7394309640688, 0.000917805358767509],
  ],
  [
    [118.42422009022, 24.73903935395, 0.00091775506734848],
    [118.423545010646, 24.73941551356, 0.000917802564799786],
  ],
  [
    [118.424209820356, 24.7390239756793, 0.000917754136025906],
    [118.423534691366, 24.7394000630457, 0.000917801633477211],
  ],
  [
    [118.424199550495, 24.7390085974078, 0.000917752273380756],
    [118.423524381979, 24.7393846215535, 0.000917799770832062],
  ],
  [
    [118.424189280631, 24.7389932101078, 0.000917749479413033],
    [118.423514062704, 24.7393691710376, 0.000917796976864338],
  ],
  [
    [118.424179010769, 24.7389778228071, 0.000917748548090458],
    [118.423503753316, 24.7393537205162, 0.000917795114219189],
  ],
  [
    [118.424168740915, 24.7389624445334, 0.000917745754122734],
    [118.423493443931, 24.739338269994, 0.000917793251574039],
  ],
  [
    [118.424158471058, 24.7389470572312, 0.000917744822800159],
    [118.423483134549, 24.739322819471, 0.00091779138892889],
  ],
  [
    [118.424148211083, 24.7389316608956, 0.00091774296015501],
    [118.423472825169, 24.7393073689473, 0.000917790457606316],
  ],
  [
    [118.424137941232, 24.7389162735919, 0.000917740166187286],
    [118.423462525677, 24.739291918418, 0.000917787663638592],
  ],
  [
    [118.424127681262, 24.7389008772548, 0.000917738303542137],
    [118.423452226187, 24.739276467888, 0.000917785800993443],
  ],
  [
    [118.424117421295, 24.7388854809169, 0.000917736440896988],
    [118.423441926705, 24.739261026385, 0.000917783938348293],
  ],
  [
    [118.424107151446, 24.7388700845832, 0.000917735509574413],
    [118.423431627221, 24.7392455758535, 0.000917782075703144],
  ],
  [
    [118.424096891484, 24.7388546882439, 0.000917732715606689],
    [118.423421337624, 24.7392301253163, 0.000917780213057995],
  ],
  [
    [118.424086631519, 24.738839282876, 0.00091773085296154],
    [118.423411038144, 24.7392146747833, 0.000917777419090271],
  ],
  [
    [118.424076371557, 24.7388238775074, 0.000917728990316391],
    [118.423400748558, 24.7391992332725, 0.000917776487767696],
  ],
  [
    [118.424066111598, 24.7388084721381, 0.000917728058993816],
    [118.423390458968, 24.7391837827332, 0.000917773693799973],
  ],
  [
    [118.424055851641, 24.738793066768, 0.000917726196348667],
    [118.423380179267, 24.7391683321882, 0.000917771831154823],
  ],
  [
    [118.424045591686, 24.7387776613972, 0.000917724333703518],
    [118.423369889688, 24.7391528906752, 0.000917769037187099],
  ],
  [
    [118.424035331734, 24.7387622560257, 0.000917720608413219],
    [118.423359609992, 24.7391374401288, 0.000917768105864525],
  ],
  [
    [118.424025071779, 24.7387468416256, 0.000917719677090645],
    [118.423349330303, 24.7391219986094, 0.00091776717454195],
  ],
  [
    [118.424014821712, 24.7387314272199, 0.000917717814445496],
    [118.423339050611, 24.7391065480615, 0.000917762517929077],
  ],
  [
    [118.424004561762, 24.7387160128183, 0.000917715951800346],
    [118.423328770928, 24.7390911065407, 0.000917763449251652],
  ],
  [
    [118.423994301815, 24.738700598416, 0.000917714089155197],
    [118.423318491247, 24.7390756650191, 0.000917759723961353],
  ],
  [
    [118.42398404187, 24.738685184013, 0.000917712226510048],
    [118.423308211563, 24.7390602144689, 0.000917757861316204],
  ],
  [
    [118.423973791813, 24.7386697696043, 0.000917710363864899],
    [118.423297941772, 24.739044772941, 0.000917756929993629],
  ],
  [
    [118.423963531868, 24.738654346172, 0.000917707569897175],
    [118.423287671984, 24.7390293314124, 0.00091775506734848],
  ],
  [
    [118.423953271926, 24.738638922739, 0.000917704775929451],
    [118.423277392313, 24.7390138898878, 0.000917752273380756],
  ],
  [
    [118.423943011991, 24.738623508333, 0.000917702913284302],
    [118.42326712253, 24.7389984483577, 0.000917750410735607],
  ],
  [
    [118.423932752054, 24.7386080848984, 0.000917701981961727],
    [118.423256852749, 24.7389830068268, 0.000917749479413033],
  ],
  [
    [118.423922501999, 24.7385926524305, 0.000917699187994003],
    [118.423246592856, 24.7389675652903, 0.000917747616767883],
  ],
  [
    [118.423912242067, 24.7385772289945, 0.000917697325348854],
    [118.423236323086, 24.7389521327857, 0.000917746685445309],
  ],
  [
    [118.423901982137, 24.7385618055578, 0.000917696394026279],
    [118.423226053313, 24.7389366912526, 0.00091774296015501],
  ],
  [
    [118.423891722204, 24.7385463730925, 0.000917695462703705],
    [118.423215793432, 24.7389212587418, 0.000917742028832436],
  ],
  [
    [118.42388146228, 24.7385309496542, 0.000917692668735981],
    [118.423205523665, 24.7389058172072, 0.000917739234864712],
  ],
  [
    [118.423871202352, 24.7385155171875, 0.000917689874768257],
    [118.423195263789, 24.7388903846948, 0.000917738303542137],
  ],
  [
    [118.423860942427, 24.73850008472, 0.000917688012123108],
    [118.423185003917, 24.7388749521817, 0.000917736440896988],
  ],
  [
    [118.423850682505, 24.7384846522518, 0.000917686149477959],
    [118.423174744047, 24.7388595196679, 0.000917733646929264],
  ],
  [
    [118.423840422585, 24.7384692197828, 0.000917684286832809],
    [118.423164474294, 24.7388440871581, 0.000917729921638966],
  ],
  [
    [118.423830152782, 24.7384537873179, 0.000917684286832809],
    [118.423154214429, 24.7388286546428, 0.000917728990316391],
  ],
  [
    [118.423819892862, 24.7384383458197, 0.000917678698897362],
    [118.423143954567, 24.7388132221267, 0.000917728058993816],
  ],
  [
    [118.42380963295, 24.7384229133485, 0.000917678698897362],
    [118.423133694707, 24.7387977896099, 0.000917726196348667],
  ],
  [
    [118.42379936315, 24.7384074718537, 0.000917676836252213],
    [118.423123434855, 24.7387823661202, 0.000917724333703518],
  ],
  [
    [118.423789093358, 24.7383920393859, 0.000917674973607063],
    [118.423113184885, 24.738766933597, 0.000917721539735794],
  ],
  [
    [118.423778833448, 24.7383765978846, 0.000917673110961914],
    [118.423102925038, 24.7387515101058, 0.000917720608413219],
  ],
  [
    [118.423768563655, 24.7383611563876, 0.000917671248316765],
    [118.423092665194, 24.7387360866138, 0.000917717814445496],
  ],
  [
    [118.423758293871, 24.7383457239175, 0.000917669385671616],
    [118.423082405352, 24.7387206631211, 0.000917715951800346],
  ],
  [
    [118.423748024083, 24.738330282419, 0.000917666591703892],
    [118.423072145513, 24.7387052396277, 0.000917715020477772],
  ],
  [
    [118.423737754298, 24.7383148409197, 0.000917664729058743],
    [118.423061885676, 24.7386898161335, 0.000917712226510048],
  ],
  [
    [118.423727484516, 24.7382993994196, 0.000917662866413593],
    [118.423051635727, 24.7386743926337, 0.000917710363864899],
  ],
  [
    [118.423717204846, 24.7382839488959, 0.000917661935091019],
    [118.4230413759, 24.7386589781658, 0.000917708501219749],
  ],
  [
    [118.423706935069, 24.7382685073944, 0.000917659141123295],
    [118.423031116076, 24.7386435636972, 0.0009177066385746],
  ],
  [
    [118.423696655409, 24.738253065897, 0.000917659141123295],
    [118.423020856249, 24.7386281402001, 0.000917703844606876],
  ],
  [
    [118.423686375752, 24.7382376243988, 0.000917654484510422],
    [118.423010606316, 24.7386127257251, 0.000917701050639153],
  ],
  [
    [118.423676096092, 24.7382221738721, 0.000917653553187847],
    [118.423000346504, 24.7385973202821, 0.000917700119316578],
  ],
  [
    [118.423665816439, 24.7382067323725, 0.000917651690542698],
    [118.422990086691, 24.7385819058105, 0.000917698256671429],
  ],
  [
    [118.423655536785, 24.7381912818443, 0.000917649827897549],
    [118.422979826879, 24.7385664913382, 0.000917696394026279],
  ],
  [
    [118.423645257137, 24.7381758403432, 0.000917647033929825],
    [118.422969567076, 24.7385510858929, 0.000917693600058556],
  ],
  [
    [118.423634967603, 24.7381603898184, 0.000917644239962101],
    [118.422959307275, 24.7385356804469, 0.000917692668735981],
  ],
  [
    [118.423624678076, 24.7381449483207, 0.000917644239962101],
    [118.422949047476, 24.7385202750002, 0.000917690806090832],
  ],
  [
    [118.423614388546, 24.7381294977944, 0.000917640514671803],
    [118.42293878768, 24.7385048695527, 0.000917688943445683],
  ],
  [
    [118.423604099024, 24.7381140562951, 0.000917639583349228],
    [118.422928527887, 24.7384894641044, 0.000917686149477959],
  ],
  [
    [118.423593809499, 24.7380986057674, 0.000917638652026653],
    [118.422918268101, 24.7384740676832, 0.000917685218155384],
  ],
  [
    [118.423583510092, 24.7380831552437, 0.000917635858058929],
    [118.422908008313, 24.7384586622335, 0.000917683355510235],
  ],
  [
    [118.423573220573, 24.7380677047144, 0.00091763399541378],
    [118.422897738648, 24.7384432658157, 0.000917681492865086],
  ],
  [
    [118.423562921176, 24.7380522632171, 0.000917631201446056],
    [118.42288747887, 24.7384278693923, 0.000917678698897362],
  ],
  [
    [118.423552611891, 24.738036812696, 0.000917631201446056],
    [118.422877209209, 24.738412472973, 0.000917676836252213],
  ],
  [
    [118.423542312494, 24.7380213621694, 0.000917629338800907],
    [118.422866949441, 24.7383970855759, 0.000917675904929638],
  ],
  [
    [118.4235320131, 24.738005911642, 0.000917626544833183],
    [118.422856679791, 24.7383816981828, 0.000917673110961914],
  ],
  [
    [118.423521703828, 24.7379904701465, 0.000917623750865459],
    [118.422846410138, 24.7383663017613, 0.000917671248316765],
  ],
  [
    [118.423511394554, 24.7379750196224, 0.000917622819542885],
    [118.422836140498, 24.7383509233946, 0.000917669385671616],
  ],
  [
    [118.423501075397, 24.7379595691025, 0.000917620025575161],
    [118.422825870856, 24.7383355359993, 0.000917668454349041],
  ],
  [
    [118.423490766128, 24.737944118577, 0.000917618162930012],
    [118.422815601216, 24.7383201486033, 0.000917666591703892],
  ],
  [
    [118.423480446976, 24.7379286680555, 0.000917616300284863],
    [118.422805331583, 24.7383047702344, 0.000917661935091019],
  ],
  [
    [118.423470127833, 24.7379132265611, 0.000917614437639713],
    [118.422795061954, 24.7382893918647, 0.000917661003768444],
  ],
  [
    [118.423459808686, 24.7378977760382, 0.000917612574994564],
    [118.422784782441, 24.7382740134991, 0.000917659141123295],
  ],
  [
    [118.423449479657, 24.7378823255194, 0.000917612574994564],
    [118.422774512822, 24.7382586441557, 0.00091765820980072],
  ],
  [
    [118.423439150631, 24.7378668749998, 0.000917608849704266],
    [118.422764233315, 24.7382432657886, 0.000917656347155571],
  ],
  [
    [118.423428821612, 24.7378514335073, 0.000917606987059116],
    [118.422753953815, 24.7382278964485, 0.000917652621865273],
  ],
  [
    [118.423418492591, 24.7378359829862, 0.000917604193091393],
    [118.422743674319, 24.7382125271077, 0.000917652621865273],
  ],
  [
    [118.423408153687, 24.7378205324692, 0.000917603261768818],
    [118.422733394824, 24.7381971577662, 0.000917649827897549],
  ],
  [
    [118.423397814791, 24.7378050909792, 0.000917600467801094],
    [118.422723115338, 24.7381817974516, 0.000917647965252399],
  ],
  [
    [118.423387475892, 24.7377896404607, 0.00091759767383337],
    [118.422712825969, 24.7381664371412, 0.00091764610260725],
  ],
  [
    [118.423377127116, 24.7377741989741, 0.000917598605155945],
    [118.422702536602, 24.73815107683, 0.00091764610260725],
  ],
  [
    [118.423366788223, 24.7377587484541, 0.000917595811188221],
    [118.422692247238, 24.7381357165181, 0.000917642377316952],
  ],
  [
    [118.423356429567, 24.7377433069708, 0.000917592085897923],
    [118.422681957882, 24.7381203652332, 0.000917640514671803],
  ],
  [
    [118.423346080794, 24.7377278564542, 0.000917591154575348],
    [118.422671668528, 24.7381050139476, 0.000917638652026653],
  ],
  [
    [118.423335722143, 24.7377124149694, 0.000917588360607624],
    [118.422661379177, 24.7380896626612, 0.000917636789381504],
  ],
  [
    [118.423325363495, 24.7376969734839, 0.000917587429285049],
    [118.422651079943, 24.7380743113789, 0.000917635858058929],
  ],
  [
    [118.423314994964, 24.7376815320024, 0.0009175855666399],
    [118.422640780717, 24.7380589691236, 0.000917633064091206],
  ],
  [
    [118.423304636316, 24.7376660814875, 0.000917586497962475],
    [118.422630481494, 24.7380436268675, 0.000917632132768631],
  ],
  [
    [118.423294257906, 24.7376506400094, 0.000917581841349602],
    [118.422620182273, 24.7380282846108, 0.000917628407478333],
  ],
  [
    [118.423283889383, 24.7376351985257, 0.000917579978704453],
    [118.42260987317, 24.738012942358, 0.000917627476155758],
  ],
  [
    [118.423273510978, 24.737619757046, 0.000917578116059303],
    [118.422599573959, 24.7379976091276, 0.000917625613510609],
  ],
  [
    [118.423263132581, 24.7376043245934, 0.000917577184736729],
    [118.422589264866, 24.7379822759011, 0.00091762188822031],
  ],
  [
    [118.423252744296, 24.7375888831171, 0.000917572528123856],
    [118.422578955776, 24.737966942674, 0.000917620956897736],
  ],
  [
    [118.423242356013, 24.73757344164, 0.000917571596801281],
    [118.422568636808, 24.7379516184786, 0.000917619094252586],
  ],
  [
    [118.423231967733, 24.7375580001622, 0.000917569734156132],
    [118.422558317843, 24.7379362942825, 0.000917617231607437],
  ],
  [
    [118.423221569576, 24.7375425677162, 0.000917568802833557],
    [118.422548008765, 24.7379209700809, 0.000917614437639713],
  ],
  [
    [118.423211171416, 24.7375271262416, 0.000917565077543259],
    [118.422537679925, 24.7379056549158, 0.000917613506317139],
  ],
  [
    [118.423200763379, 24.737511693799, 0.000917564146220684],
    [118.422527360973, 24.7378903397453, 0.000917612574994564],
  ],
  [
    [118.423190355345, 24.7374962613555, 0.000917563214898109],
    [118.422517032138, 24.7378750245788, 0.000917608849704266],
  ],
  [
    [118.423179947313, 24.7374808289113, 0.000917560420930386],
    [118.422506703306, 24.7378597094115, 0.000917607918381691],
  ],
  [
    [118.423169529399, 24.7374653964712, 0.000917557626962662],
    [118.422496374481, 24.7378444032713, 0.000917605124413967],
  ],
  [
    [118.423159111488, 24.7374499640303, 0.000917555764317513],
    [118.422486045659, 24.7378290971303, 0.000917603261768818],
  ],
  [
    [118.423148693579, 24.7374345315886, 0.000917553901672363],
    [118.422475706955, 24.7378137909934, 0.000917602330446243],
  ],
  [
    [118.423138265787, 24.737419099151, 0.000917552039027214],
    [118.422465368258, 24.7377984938835, 0.000917599536478519],
  ],
  [
    [118.423127828119, 24.7374036757453, 0.000917551107704639],
    [118.422455019679, 24.7377831967776, 0.00091759767383337],
  ],
  [
    [118.423117390448, 24.737388243311, 0.000917547382414341],
    [118.422444680987, 24.7377678996662, 0.000917595811188221],
  ],
  [
    [118.423106952784, 24.7373728199037, 0.000917546451091766],
    [118.422434332418, 24.7377526115866, 0.000917593948543072],
  ],
  [
    [118.423096505239, 24.7373573965005, 0.000917543657124043],
    [118.422423973967, 24.737737323511, 0.000917593948543072],
  ],
  [
    [118.423086057695, 24.7373419730965, 0.000917543657124043],
    [118.422413625408, 24.7377220444577, 0.000917591154575348],
  ],
  [
    [118.423075610155, 24.7373265496917, 0.000917541794478893],
    [118.422403266962, 24.7377067563807, 0.000917589291930199],
  ],
  [
    [118.423065152732, 24.737311126291, 0.000917539000511169],
    [118.422392898639, 24.7376914773354, 0.0009175855666399],
  ],
  [
    [118.423054685427, 24.7372957028944, 0.000917538069188595],
    [118.422382540208, 24.7376762073124, 0.000917584635317326],
  ],
  [
    [118.423044218129, 24.7372802885247, 0.000917533412575722],
    [118.422372171895, 24.7376609372934, 0.000917581841349602],
  ],
  [
    [118.423033740944, 24.7372648651314, 0.000917531549930573],
    [118.422361803584, 24.7376456672737, 0.000917580910027027],
  ],
  [
    [118.423023263767, 24.737249450765, 0.000917529687285423],
    [118.422351425391, 24.737630397258, 0.000917579047381878],
  ],
  [
    [118.423012786592, 24.7372340363979, 0.000917529687285423],
    [118.422341047205, 24.7376151362693, 0.000917577184736729],
  ],
  [
    [118.423002299535, 24.7372186220348, 0.000917526893317699],
    [118.422330669023, 24.7375998752799, 0.00091757345944643],
  ],
  [
    [118.422991812486, 24.7372032166988, 0.00091752503067255],
    [118.422320280962, 24.7375846233222, 0.000917574390769005],
  ],
  [
    [118.422981315549, 24.7371878023389, 0.000917523168027401],
    [118.422309892905, 24.7375693713638, 0.000917572528123856],
  ],
  [
    [118.422970808735, 24.737172397011, 0.000917522236704826],
    [118.422299494965, 24.7375541194095, 0.000917567871510983],
  ],
  [
    [118.422960301918, 24.7371569826544, 0.000917521305382252],
    [118.422289097033, 24.7375388764821, 0.000917566940188408],
  ],
  [
    [118.42294979511, 24.7371415773249, 0.000917517580091953],
    [118.422278699103, 24.737523633554, 0.000917566940188408],
  ],
  [
    [118.422939268539, 24.737126181032, 0.000917515717446804],
    [118.422268301181, 24.7375083996529, 0.000917564146220684],
  ],
  [
    [118.42292875185, 24.7371107757057, 0.000917514786124229],
    [118.422257893377, 24.7374931657559, 0.000917562283575535],
  ],
  [
    [118.42291822528, 24.7370953703835, 0.00091751292347908],
    [118.42224747569, 24.7374779318628, 0.000917560420930386],
  ],
  [
    [118.422907688832, 24.7370799740931, 0.000917510129511356],
    [118.422237058011, 24.7374627069968, 0.000917558558285236],
  ],
  [
    [118.422897152386, 24.7370645778019, 0.000917508266866207],
    [118.422226640334, 24.73744748213, 0.000917555764317513],
  ],
  [
    [118.422886606059, 24.7370491815147, 0.000917506404221058],
    [118.42221622266, 24.7374322572624, 0.000917554832994938],
  ],
  [
    [118.422876059739, 24.7370337942545, 0.000917504541575909],
    [118.422205795109, 24.7374170414267, 0.000917552970349789],
  ],
  [
    [118.422865503531, 24.7370183979706, 0.000917503610253334],
    [118.422195357676, 24.7374018255949, 0.000917550176382065],
  ],
  [
    [118.422854947332, 24.7370030107137, 0.000917499884963036],
    [118.42218492025, 24.7373866187902, 0.000917548313736916],
  ],
  [
    [118.42284438125, 24.7369876234608, 0.000917498022317886],
    [118.422174482827, 24.7373714119847, 0.000917546451091766],
  ],
  [
    [118.422833805286, 24.7369722362119, 0.000917496159672737],
    [118.422164035526, 24.737356214211, 0.000917545519769192],
  ],
  [
    [118.422823229324, 24.7369568489623, 0.000917495228350163],
    [118.422153588228, 24.7373410164365, 0.000917542725801468],
  ],
  [
    [118.422812643485, 24.7369414707444, 0.000917492434382439],
    [118.422143131048, 24.737325818666, 0.000917540863156319],
  ],
  [
    [118.422802057649, 24.7369260925258, 0.000917490571737289],
    [118.422132673875, 24.7373106299225, 0.000917539000511169],
  ],
  [
    [118.422791461931, 24.7369107143112, 0.000917487777769566],
    [118.422122206825, 24.7372954502108, 0.00091753713786602],
  ],
  [
    [118.42278085633, 24.7368953361006, 0.000917486846446991],
    [118.422111739772, 24.7372802614706, 0.000917533412575722],
  ],
  [
    [118.422770250737, 24.736879966917, 0.000917486846446991],
    [118.422101272728, 24.7372650817574, 0.000917532481253147],
  ],
  [
    [118.422759645142, 24.7368645887048, 0.000917483121156693],
    [118.422090795806, 24.7372499110759, 0.000917532481253147],
  ],
  [
    [118.422749019784, 24.7368492195292, 0.000917481258511543],
    [118.422080309001, 24.7372347403985, 0.000917529687285423],
  ],
  [
    [118.422738394435, 24.7368338593806, 0.000917478464543819],
    [118.42206983209, 24.7372195787433, 0.000917526893317699],
  ],
  [
    [118.422727769082, 24.7368184902035, 0.000917477533221245],
    [118.422059335411, 24.7372044170968, 0.00091752503067255],
  ],
  [
    [118.422717123968, 24.7368031300629, 0.000917473807930946],
    [118.422048838734, 24.7371892554496, 0.000917524099349976],
  ],
  [
    [118.422706478856, 24.7367877699215, 0.000917472876608372],
    [118.422038342065, 24.7371741028294, 0.000917521305382252],
  ],
  [
    [118.422695833747, 24.7367724097794, 0.000917472876608372],
    [118.422027835514, 24.7371589502132, 0.000917520374059677],
  ],
  [
    [118.422685178761, 24.736757058669, 0.000917470082640648],
    [118.422017319086, 24.7371438066287, 0.000917517580091953],
  ],
  [
    [118.422674513888, 24.7367416985348, 0.000917467288672924],
    [118.42200680266, 24.7371286630435, 0.000917516648769379],
  ],
  [
    [118.422663839142, 24.7367263564602, 0.000917465426027775],
    [118.421996286242, 24.7371135284852, 0.000917514786124229],
  ],
  [
    [118.422653164394, 24.736711005357, 0.0009174644947052],
    [118.421985759941, 24.737098393931, 0.000917511992156506],
  ],
  [
    [118.422642479769, 24.7366956632857, 0.000917460769414902],
    [118.421975223764, 24.7370832684085, 0.000917511060833931],
  ],
  [
    [118.422631795141, 24.7366803121857, 0.000917460769414902],
    [118.421964687588, 24.7370681428852, 0.000917508266866207],
  ],
  [
    [118.422621100642, 24.7366649791453, 0.000917457044124603],
    [118.421954151421, 24.737053026389, 0.000917508266866207],
  ],
  [
    [118.422610396255, 24.736649637081, 0.000917457044124603],
    [118.421943595486, 24.7370379099014, 0.000917504541575909],
  ],
  [
    [118.422599681991, 24.7366343040486, 0.000917454250156879],
    [118.421933049444, 24.7370228024361, 0.000917501747608185],
  ],
  [
    [118.422588967729, 24.7366189710153, 0.000917451456189156],
    [118.42192249352, 24.7370076949748, 0.00091750081628561],
  ],
  [
    [118.422578243585, 24.7366036379861, 0.000917449593544006],
    [118.421911927718, 24.7369925965453, 0.000917499884963036],
  ],
  [
    [118.422567509565, 24.7365883139886, 0.000917449593544006],
    [118.421901352034, 24.7369774981197, 0.000917497090995312],
  ],
  [
    [118.422556775546, 24.7365729899903, 0.000917446799576283],
    [118.421890776358, 24.7369624087211, 0.000917495228350163],
  ],
  [
    [118.422546031646, 24.736557665996, 0.000917444005608559],
    [118.421880200684, 24.7369473193217, 0.000917493365705013],
  ],
  [
    [118.422535277869, 24.7365423510334, 0.000917442142963409],
    [118.421869615133, 24.7369322389541, 0.000917491503059864],
  ],
  [
    [118.422524514209, 24.7365270360748, 0.00091744028031826],
    [118.4218590197, 24.7369171585904, 0.000917489640414715],
  ],
  [
    [118.422513750552, 24.7365117211154, 0.000917438417673111],
    [118.421848424275, 24.7369020872538, 0.000917487777769566],
  ],
  [
    [118.422502977018, 24.7364964151878, 0.000917435623705387],
    [118.421837818967, 24.736887015921, 0.000917484983801842],
  ],
  [
    [118.422492193601, 24.7364811092641, 0.000917434692382813],
    [118.421827203782, 24.7368719536201, 0.000917484052479267],
  ],
  [
    [118.422481410188, 24.7364658033397, 0.000917431898415089],
    [118.421816588599, 24.7368568913183, 0.000917481258511543],
  ],
  [
    [118.422470616897, 24.7364505064469, 0.000917430967092514],
    [118.421805973424, 24.7368418380435, 0.000917479395866394],
  ],
  [
    [118.422459803839, 24.736435209563, 0.00091742817312479],
    [118.421795338488, 24.7368267938053, 0.000917478464543819],
  ],
  [
    [118.422449000669, 24.7364199126734, 0.000917427241802216],
    [118.421784703553, 24.7368117495662, 0.000917477533221245],
  ],
  [
    [118.422438177731, 24.7364046157926, 0.000917425379157066],
    [118.421774068622, 24.7367967053263, 0.000917475670576096],
  ],
  [
    [118.422427354802, 24.7363893279387, 0.000917422585189343],
    [118.421763423813, 24.7367816701182, 0.000917472876608372],
  ],
  [
    [118.422416521995, 24.7363740491166, 0.000917420722544193],
    [118.421752769126, 24.7367666439418, 0.000917470082640648],
  ],
  [
    [118.422405679301, 24.7363587612706, 0.000917418859899044],
    [118.421742114443, 24.7367516177646, 0.000917468219995499],
  ],
  [
    [118.422394826735, 24.7363434914842, 0.000917417928576469],
    [118.421731439997, 24.7367366006238, 0.000917467288672924],
  ],
  [
    [118.422383974167, 24.7363282126692, 0.000917415134608746],
    [118.421720775439, 24.7367215834776, 0.0009174644947052],
  ],
  [
    [118.422373101836, 24.7363129428906, 0.000917415134608746],
    [118.421710091119, 24.7367065753678, 0.000917461700737476],
  ],
  [
    [118.422362229509, 24.7362976731113, 0.000917411409318447],
    [118.421699406806, 24.7366915762849, 0.000917460769414902],
  ],
  [
    [118.422351347304, 24.7362824123637, 0.000917410477995873],
    [118.421688722496, 24.7366765772013, 0.000917458906769753],
  ],
  [
    [118.422340465097, 24.7362671425875, 0.000917407684028149],
    [118.421678018424, 24.7366615871542, 0.000917458906769753],
  ],
  [
    [118.422329563133, 24.7362518908755, 0.000917406752705574],
    [118.421667314355, 24.7366465971062, 0.000917455181479454],
  ],
  [
    [118.422318661167, 24.736236630135, 0.00091740395873785],
    [118.421656610293, 24.7366316160852, 0.000917455181479454],
  ],
  [
    [118.422307749328, 24.7362213874539, 0.000917402096092701],
    [118.421645886464, 24.7366166350729, 0.000917453318834305],
  ],
  [
    [118.422296827603, 24.7362061357491, 0.000917399302124977],
    [118.421635162643, 24.7366016630875, 0.000917448662221432],
  ],
  [
    [118.422285896, 24.7361908930759, 0.000917398370802403],
    [118.421624428945, 24.7365867001339, 0.000917447730898857],
  ],
  [
    [118.422274954515, 24.7361756504066, 0.000917395576834679],
    [118.421613695249, 24.7365717371795, 0.000917446799576283],
  ],
  [
    [118.422264013038, 24.7361604167644, 0.000917395576834679],
    [118.421602951676, 24.7365567832567, 0.000917444936931133],
  ],
  [
    [118.422253051794, 24.7361451831308, 0.00091739185154438],
    [118.42159219822, 24.7365418293379, 0.000917442142963409],
  ],
  [
    [118.422242090558, 24.7361299585241, 0.000917390920221806],
    [118.421581434888, 24.7365268844508, 0.00091744028031826],
  ],
  [
    [118.42223111944, 24.7361147339214, 0.000917389057576656],
    [118.421570671563, 24.7365119485907, 0.000917439348995686],
  ],
  [
    [118.422220138439, 24.7360995093226, 0.000917386263608933],
    [118.421559898356, 24.7364970127345, 0.000917437486350536],
  ],
  [
    [118.422209147562, 24.7360842937556, 0.000917385332286358],
    [118.421549115272, 24.7364820859099, 0.000917434692382813],
  ],
  [
    [118.422198146802, 24.7360690781924, 0.000917381606996059],
    [118.421538332196, 24.7364671681124, 0.000917432829737663],
  ],
  [
    [118.422187136165, 24.736053871661, 0.000917380675673485],
    [118.421527539237, 24.7364522503188, 0.000917430967092514],
  ],
  [
    [118.422176125531, 24.7360386651287, 0.00091737974435091],
    [118.421516736401, 24.7364373415568, 0.000917429104447365],
  ],
  [
    [118.42216510502, 24.7360234676281, 0.000917377881705761],
    [118.421505923683, 24.7364224327988, 0.000917426310479641],
  ],
  [
    [118.422154064742, 24.7360082701361, 0.000917376950383186],
    [118.421495110972, 24.7364075330677, 0.000917426310479641],
  ],
  [
    [118.422143024467, 24.7359930726433, 0.000917373225092888],
    [118.421484278499, 24.7363926423731, 0.000917423516511917],
  ],
  [
    [118.422131974315, 24.7359778841823, 0.000917369499802589],
    [118.421473446029, 24.7363777516776, 0.000917422585189343],
  ],
  [
    [118.42212091428, 24.7359626957251, 0.000917370431125164],
    [118.421462613567, 24.7363628700091, 0.000917418859899044],
  ],
  [
    [118.422109844369, 24.7359475162996, 0.00091736763715744],
    [118.421451761343, 24.736347997377, 0.000917416997253895],
  ],
  [
    [118.422098764581, 24.7359323459058, 0.000917366705834866],
    [118.421440909121, 24.7363331247441, 0.000917415134608746],
  ],
  [
    [118.422087674905, 24.7359171664881, 0.000917362049221992],
    [118.421430047022, 24.7363182611428, 0.000917414203286171],
  ],
  [
    [118.422076575357, 24.7359020051299, 0.000917362980544567],
    [118.421419175046, 24.7363034065732, 0.000917412340641022],
  ],
  [
    [118.422065475807, 24.7358868347431, 0.000917359255254269],
    [118.421408303078, 24.7362885610306, 0.000917411409318447],
  ],
  [
    [118.422054356501, 24.7358716824204, 0.000917359255254269],
    [118.421397411343, 24.7362737154966, 0.000917409546673298],
  ],
  [
    [118.422043227307, 24.7358565210739, 0.000917356461286545],
    [118.42138651961, 24.7362588699618, 0.000917406752705574],
  ],
  [
    [118.422032098126, 24.7358413777821, 0.000917354598641396],
    [118.421375618005, 24.7362440424864, 0.000917404890060425],
  ],
  [
    [118.422020949173, 24.7358262254711, 0.000917351804673672],
    [118.421364706518, 24.7362292150149, 0.000917403027415276],
  ],
  [
    [118.422009800233, 24.7358110912148, 0.000917350873351097],
    [118.421353795039, 24.7362143965704, 0.000917401164770126],
  ],
  [
    [118.421998631521, 24.7357959479394, 0.000917348079383373],
    [118.421342863792, 24.7361995781344, 0.000917399302124977],
  ],
  [
    [118.421987462817, 24.7357808136909, 0.000917347148060799],
    [118.421331932553, 24.7361847687254, 0.000917397439479828],
  ],
  [
    [118.421976274351, 24.7357656884789, 0.000917344354093075],
    [118.421320991437, 24.7361699683481, 0.000917394645512104],
  ],
  [
    [118.421965085887, 24.7357505632659, 0.000917342491447926],
    [118.421310040444, 24.7361551770024, 0.000917392782866955],
  ],
  [
    [118.421953887547, 24.7357354470846, 0.000917338766157627],
    [118.421299089454, 24.7361403856559, 0.00091739185154438],
  ],
  [
    [118.421942669445, 24.7357203399397, 0.000917338766157627],
    [118.421288118701, 24.7361256033457, 0.000917389057576656],
  ],
  [
    [118.421931451341, 24.7357052237662, 0.000917336903512478],
    [118.421277147957, 24.7361108300625, 0.000917388126254082],
  ],
  [
    [118.421920213479, 24.7356901256568, 0.000917335040867329],
    [118.42126616733, 24.7360960567832, 0.000917387194931507],
  ],
  [
    [118.421908975621, 24.7356750275466, 0.000917333178222179],
    [118.421255166946, 24.736081301568, 0.000917384400963783],
  ],
  [
    [118.421897727881, 24.7356599294402, 0.000917332246899605],
    [118.421244176449, 24.7360665463473, 0.000917382538318634],
  ],
  [
    [118.421886460378, 24.7356448403702, 0.000917329452931881],
    [118.421233166186, 24.7360517911351, 0.000917381606996059],
  ],
  [
    [118.421875192884, 24.7356297603272, 0.000917328521609306],
    [118.42122214605, 24.7360370539823, 0.000917378813028336],
  ],
  [
    [118.421863905623, 24.7356146802927, 0.000917326658964157],
    [118.421211125917, 24.7360223168287, 0.000917376950383186],
  ],
  [
    [118.421852618364, 24.7355996002573, 0.000917324796319008],
    [118.421200086023, 24.7360075887115, 0.000917375087738037],
  ],
  [
    [118.421841311344, 24.7355845292583, 0.000917322933673859],
    [118.42118904613, 24.7359928605934, 0.000917372293770313],
  ],
  [
    [118.421830004332, 24.7355694672862, 0.000917320139706135],
    [118.421177996366, 24.7359781505347, 0.000917372293770313],
  ],
  [
    [118.421818677558, 24.7355544143505, 0.000917318277060986],
    [118.42116693672, 24.7359634404799, 0.000917369499802589],
  ],
  [
    [118.421807340896, 24.7355393523908, 0.000917316414415836],
    [118.421155867196, 24.7359487394567, 0.000917368568480015],
  ],
  [
    [118.421795994363, 24.7355243084906, 0.000917313620448112],
    [118.42114478779, 24.7359340384373, 0.000917365774512291],
  ],
  [
    [118.421784647833, 24.7355092645895, 0.000917311757802963],
    [118.421133698512, 24.7359193554773, 0.000917365774512291],
  ],
  [
    [118.421773281541, 24.7354942297247, 0.000917309895157814],
    [118.421122609237, 24.7359046725166, 0.000917362980544567],
  ],
  [
    [118.421761905366, 24.7354791948638, 0.000917308963835239],
    [118.4211115002, 24.7358899985921, 0.000917360186576843],
  ],
  [
    [118.421750519315, 24.7354641690344, 0.000917306169867516],
    [118.42110039117, 24.7358753336945, 0.000917358323931694],
  ],
  [
    [118.421739113497, 24.7354491432137, 0.000917304307222366],
    [118.421089262374, 24.7358606688055, 0.000917356461286545],
  ],
  [
    [118.421727707687, 24.7354341264198, 0.000917303375899792],
    [118.42107813359, 24.7358460219712, 0.000917356461286545],
  ],
  [
    [118.421716292, 24.7354191186576, 0.000917302444577217],
    [118.421066994924, 24.7358313751407, 0.000917351804673672],
  ],
  [
    [118.421704856547, 24.7354041109039, 0.000917299650609493],
    [118.421055846381, 24.7358167373418, 0.000917350873351097],
  ],
  [
    [118.421693421101, 24.735389112177, 0.000917297787964344],
    [118.421044687961, 24.7358021085746, 0.000917349942028522],
  ],
  [
    [118.421681965888, 24.7353741134588, 0.00091729499399662],
    [118.421033519659, 24.7357874798111, 0.000917348079383373],
  ],
  [
    [118.421670510688, 24.7353591327952, 0.000917293131351471],
    [118.421022341484, 24.7357728691071, 0.000917346216738224],
  ],
  [
    [118.421659035716, 24.7353441431123, 0.000917291268706322],
    [118.421011153428, 24.7357582584069, 0.0009173434227705],
  ],
  [
    [118.421647550873, 24.7353291714889, 0.000917289406061172],
    [118.420999955494, 24.7357436567383, 0.0009173434227705],
  ],
  [
    [118.421636056147, 24.7353141998692, 0.000917287543416023],
    [118.420988747683, 24.7357290641013, 0.000917341560125351],
  ],
  [
    [118.421624541655, 24.7352992282581, 0.000917286612093449],
    [118.42097752999, 24.735714471468, 0.000917338766157627],
  ],
  [
    [118.421613027176, 24.7352842747016, 0.000917284749448299],
    [118.420966302425, 24.7356998968942, 0.000917336903512478],
  ],
  [
    [118.42160149293, 24.7352693211537, 0.00091728288680315],
    [118.420955074863, 24.7356853223195, 0.000917335040867329],
  ],
  [
    [118.421589958686, 24.7352543676048, 0.000917281024158001],
    [118.420943827539, 24.7356707567811, 0.000917333178222179],
  ],
  [
    [118.421578404687, 24.73523943212, 0.000917277298867702],
    [118.420932570337, 24.7356562002743, 0.00091733131557703],
  ],
  [
    [118.421566840805, 24.735224496639, 0.000917277298867702],
    [118.420921313144, 24.7356416527944, 0.000917328521609306],
  ],
  [
    [118.421555267041, 24.7352095611619, 0.000917275436222553],
    [118.420910036188, 24.7356271143507, 0.000917327590286732],
  ],
  [
    [118.4215436834, 24.7351946347163, 0.000917273573577404],
    [118.42089874935, 24.7356125759109, 0.000917325727641582],
  ],
  [
    [118.421532079998, 24.735179717307, 0.00091727077960968],
    [118.420887462526, 24.7355980555257, 0.000917323864996433],
  ],
  [
    [118.421520476603, 24.7351648089245, 0.000917269848287106],
    [118.420876155934, 24.735583535149, 0.000917321071028709],
  ],
  [
    [118.421508853442, 24.7351499005506, 0.000917267985641956],
    [118.420864839465, 24.7355690238039, 0.00091731920838356],
  ],
  [
    [118.421497220404, 24.7351350012082, 0.000917266122996807],
    [118.420853523003, 24.7355545214857, 0.000917320139706135],
  ],
  [
    [118.421485577488, 24.7351201108973, 0.000917263329029083],
    [118.42084218678, 24.7355400282037, 0.000917315483093262],
  ],
  [
    [118.421473914812, 24.7351052296228, 0.000917261466383934],
    [118.420830840675, 24.7355255349255, 0.000917314551770687],
  ],
  [
    [118.421462252138, 24.7350903483473, 0.000917259603738785],
    [118.420819494582, 24.735511059702, 0.000917313620448112],
  ],
  [
    [118.421450569697, 24.7350754670803, 0.000917257741093636],
    [118.420808128728, 24.7354965935147, 0.000917310826480389],
  ],
  [
    [118.421438877385, 24.7350606038727, 0.000917255878448486],
    [118.420796752991, 24.7354821273312, 0.000917309895157814],
  ],
  [
    [118.42142717519, 24.7350457406688, 0.000917254947125912],
    [118.420785367378, 24.7354676701793, 0.00091730710119009],
  ],
  [
    [118.421415453234, 24.7350308865011, 0.000917254015803337],
    [118.420773971892, 24.7354532310868, 0.000917305238544941],
  ],
  [
    [118.421403731286, 24.7350160413604, 0.000917250290513039],
    [118.420762566524, 24.7354387919979, 0.000917303375899792],
  ],
  [
    [118.421391989571, 24.735001196228, 0.000917249359190464],
    [118.420751151279, 24.7354243619407, 0.000917301513254642],
  ],
  [
    [118.421380237985, 24.734986369155, 0.000917247496545315],
    [118.420739726157, 24.735409940915, 0.000917299650609493],
  ],
  [
    [118.421368466626, 24.7349715330627, 0.000917245633900166],
    [118.420728291158, 24.7353955289208, 0.000917297787964344],
  ],
  [
    [118.421356695281, 24.734956715025, 0.000917242839932442],
    [118.420716846277, 24.7353811169305, 0.000917295925319195],
  ],
  [
    [118.421344904174, 24.7349419060235, 0.000917241908609867],
    [118.420705391524, 24.7353667229994, 0.000917294062674046],
  ],
  [
    [118.421333103185, 24.7349270970258, 0.000917239114642143],
    [118.420693926894, 24.7353523380999, 0.000917293131351471],
  ],
  [
    [118.421321292319, 24.7349122970596, 0.000917238183319569],
    [118.420682442497, 24.7353379532088, 0.000917291268706322],
  ],
  [
    [118.421309461692, 24.7348975061296, 0.000917237251996994],
    [118.420670958107, 24.7353235773446, 0.000917289406061172],
  ],
  [
    [118.421297631072, 24.7348827242265, 0.000917233526706696],
    [118.420659453956, 24.7353092105166, 0.000917288474738598],
  ],
  [
    [118.421285780686, 24.7348679423318, 0.000917231664061546],
    [118.420647939927, 24.7352948527201, 0.000917286612093449],
  ],
  [
    [118.421273920428, 24.7348531784964, 0.000917230732738972],
    [118.420636416022, 24.7352805039552, 0.000917283818125725],
  ],
  [
    [118.421262050288, 24.7348384146647, 0.000917227938771248],
    [118.42062488224, 24.7352661642217, 0.000917281024158001],
  ],
  [
    [118.421250170272, 24.7348236598646, 0.000917226076126099],
    [118.420613338575, 24.735251824492, 0.000917281024158001],
  ],
  [
    [118.421238270493, 24.7348089141006, 0.000917225144803524],
    [118.420601775148, 24.7352374937985, 0.000917278230190277],
  ],
  [
    [118.421226370723, 24.7347941773635, 0.0009172223508358],
    [118.42059021173, 24.7352231721319, 0.000917277298867702],
  ],
  [
    [118.421214451191, 24.7347794496626, 0.000917219556868076],
    [118.420578628549, 24.7352088595014, 0.000917274504899979],
  ],
  [
    [118.421202521783, 24.7347647309931, 0.000917219556868076],
    [118.420567035491, 24.7351945559025, 0.000917273573577404],
  ],
  [
    [118.421190582492, 24.7347500123274, 0.000917217694222927],
    [118.420555432557, 24.7351802613351, 0.000917271710932255],
  ],
  [
    [118.42117863333, 24.734735311721, 0.000917215831577778],
    [118.42054381974, 24.7351659667714, 0.000917268916964531],
  ],
  [
    [118.421166664401, 24.734720611123, 0.000917213037610054],
    [118.420532197046, 24.7351516812391, 0.000917267054319382],
  ],
  [
    [118.42115469548, 24.7347059195518, 0.00091721024364233],
    [118.420520554595, 24.7351374137709, 0.000917266122996807],
  ],
  [
    [118.421142706797, 24.7346912370167, 0.000917209312319756],
    [118.420508912147, 24.7351231463017, 0.000917263329029083],
  ],
  [
    [118.421130708237, 24.7346765635132, 0.000917208380997181],
    [118.420497249932, 24.7351088788409, 0.000917262397706509],
  ],
  [
    [118.421118699801, 24.7346618990411, 0.000917205587029457],
    [118.420485577845, 24.7350946294394, 0.000917261466383934],
  ],
  [
    [118.421106681483, 24.7346472345727, 0.000917204655706882],
    [118.420473895882, 24.7350803890693, 0.000917257741093636],
  ],
  [
    [118.421094643408, 24.7346325881683, 0.000917200930416584],
    [118.420462204036, 24.735066148703, 0.000917255878448486],
  ],
  [
    [118.421082605337, 24.7346179417629, 0.000917201861739159],
    [118.420450502312, 24.7350519173682, 0.000917256809771061],
  ],
  [
    [118.421070547503, 24.7346033043937, 0.000917199067771435],
    [118.420438790712, 24.7350376950648, 0.000917253084480762],
  ],
  [
    [118.421058479793, 24.7345886760559, 0.000917197205126286],
    [118.420427069235, 24.7350234817929, 0.000917252153158188],
  ],
  [
    [118.421046402206, 24.7345740567496, 0.000917196273803711],
    [118.420415327996, 24.7350092775572, 0.000917250290513039],
  ],
  [
    [118.421034314743, 24.7345594464748, 0.000917193479835987],
    [118.42040357688, 24.734995082353, 0.000917247496545315],
  ],
  [
    [118.421022207517, 24.7345448452361, 0.000917191617190838],
    [118.420391815882, 24.7349808871524, 0.000917247496545315],
  ],
  [
    [118.4210101003, 24.7345302530242, 0.000917187891900539],
    [118.420380054892, 24.7349667009787, 0.000917244702577591],
  ],
  [
    [118.420997973316, 24.7345156608206, 0.000917187891900539],
    [118.420368264255, 24.7349525238457, 0.000917241908609867],
  ],
  [
    [118.420985836455, 24.7345010776486, 0.000917186960577965],
    [118.420356473626, 24.7349383557396, 0.000917240045964718],
  ],
  [
    [118.420973689723, 24.7344865125357, 0.000917184166610241],
    [118.42034467312, 24.7349241966649, 0.000917239114642143],
  ],
  [
    [118.420961533109, 24.7344719474265, 0.000917183235287666],
    [118.420332852852, 24.7349100466263, 0.000917236320674419],
  ],
  [
    [118.420949366618, 24.7344573913488, 0.000917180441319942],
    [118.420321032591, 24.7348959056146, 0.000917236320674419],
  ],
  [
    [118.420937180365, 24.7344428443072, 0.000917180441319942],
    [118.420309192564, 24.7348817646112, 0.000917232595384121],
  ],
  [
    [118.420924994115, 24.7344282972646, 0.000917177647352219],
    [118.42029734266, 24.7348676326392, 0.000917231664061546],
  ],
  [
    [118.420912788109, 24.7344137682858, 0.000917174853384495],
    [118.420285482884, 24.7348535187265, 0.000917229801416397],
  ],
  [
    [118.420900572226, 24.7343992483386, 0.000917172990739346],
    [118.420273613226, 24.7348394048175, 0.000917229801416397],
  ],
  [
    [118.420888346461, 24.7343847283949, 0.00091717392206192],
    [118.420261733691, 24.7348252999399, 0.000917227938771248],
  ],
  [
    [118.420876100935, 24.7343702174874, 0.000917169265449047],
    [118.420249844274, 24.7348111950659, 0.000917226076126099],
  ],
  [
    [118.420863855422, 24.7343557246344, 0.000917167402803898],
    [118.420237944984, 24.7347971082512, 0.0009172223508358],
  ],
  [
    [118.420851590142, 24.7343412317898, 0.000917166471481323],
    [118.420226025928, 24.7347830214448, 0.0009172223508358],
  ],
  [
    [118.42083932487, 24.7343267479718, 0.000917165540158749],
    [118.420214097, 24.7347689526977, 0.000917219556868076],
  ],
  [
    [118.420827039831, 24.7343122641622, 0.000917160883545876],
    [118.420202168075, 24.7347548839495, 0.000917218625545502],
  ],
  [
    [118.420814744921, 24.7342977984118, 0.000917160883545876],
    [118.420190219388, 24.7347408242374, 0.000917215831577778],
  ],
  [
    [118.420802440134, 24.7342833416929, 0.000917159020900726],
    [118.420178260824, 24.7347267735568, 0.000917213037610054],
  ],
  [
    [118.42079011558, 24.7342688849822, 0.000917156226933002],
    [118.420166292383, 24.7347127319075, 0.000917212106287479],
  ],
  [
    [118.42077779104, 24.7342544463261, 0.000917155295610428],
    [118.420154304175, 24.7346986902666, 0.00091721024364233],
  ],
  [
    [118.420765446733, 24.7342400076782, 0.000917153432965279],
    [118.42014231598, 24.7346846666802, 0.000917209312319756],
  ],
  [
    [118.420753092549, 24.7342255780617, 0.000917151570320129],
    [118.420130317903, 24.7346706430975, 0.000917206518352032],
  ],
  [
    [118.420740738378, 24.7342111664998, 0.000917148776352406],
    [118.420118300069, 24.7346566375786, 0.000917206518352032],
  ],
  [
    [118.420728364441, 24.7341967549462, 0.000917147845029831],
    [118.420106272353, 24.7346426320633, 0.000917202793061733],
  ],
  [
    [118.420715970737, 24.7341823434008, 0.000917145051062107],
    [118.420094244645, 24.7346286355749, 0.000917202793061733],
  ],
  [
    [118.420703577046, 24.73416794991, 0.000917143188416958],
    [118.420082197175, 24.7346146481225, 0.000917199999094009],
  ],
  [
    [118.420691173478, 24.7341535654505, 0.000917142257094383],
    [118.420070139823, 24.7346006606736, 0.00091719813644886],
  ],
  [
    [118.420678750149, 24.7341391900271, 0.000917140394449234],
    [118.420058062714, 24.7345866912887, 0.000917196273803711],
  ],
  [
    [118.420666316938, 24.7341248146073, 0.000917139463126659],
    [118.420045985613, 24.7345727309305, 0.000917194411158562],
  ],
  [
    [118.42065387385, 24.7341104482189, 0.000917136669158936],
    [118.42003389863, 24.7345587705759, 0.000917194411158562],
  ],
  [
    [118.420641420891, 24.7340960998897, 0.000917135737836361],
    [118.420021791886, 24.7345448192573, 0.000917191617190838],
  ],
  [
    [118.42062895805, 24.7340817515641, 0.000917133875191212],
    [118.420009685149, 24.7345308769656, 0.000917190685868263],
  ],
  [
    [118.420616485332, 24.7340674122698, 0.000917132943868637],
    [118.41999755865, 24.7345169437098, 0.000917186960577965],
  ],
  [
    [118.420603992852, 24.7340530820116, 0.000917130149900913],
    [118.419985422275, 24.7345030194854, 0.000917185097932816],
  ],
  [
    [118.420591500381, 24.7340387607801, 0.000917127355933189],
    [118.419973285907, 24.7344891042878, 0.000917184166610241],
  ],
  [
    [118.420578988148, 24.7340244485846, 0.000917127355933189],
    [118.419961129777, 24.7344751981263, 0.000917182303965092],
  ],
  [
    [118.420566466038, 24.7340101454205, 0.000917124561965466],
    [118.419948953881, 24.7344612919729, 0.000917180441319942],
  ],
  [
    [118.420553934047, 24.7339958422599, 0.000917122699320316],
    [118.419936777997, 24.7344474038741, 0.000917179509997368],
  ],
  [
    [118.420541392183, 24.7339815571585, 0.000917120836675167],
    [118.419924592231, 24.7344335157789, 0.000917177647352219],
  ],
  [
    [118.420528840438, 24.7339672720607, 0.000917118974030018],
    [118.419912396589, 24.734419636715, 0.000917174853384495],
  ],
  [
    [118.420516268937, 24.7339530050267, 0.000917117111384869],
    [118.419900181185, 24.7344057666872, 0.000917174853384495],
  ],
  [
    [118.420503697439, 24.7339387379916, 0.000917116180062294],
    [118.419887955903, 24.7343919056907, 0.000917172059416771],
  ],
  [
    [118.420491106179, 24.7339244799925, 0.000917114317417145],
    [118.41987573063, 24.734378053721, 0.000917170196771622],
  ],
  [
    [118.420478505042, 24.7339102310247, 0.000917112454771996],
    [118.419863485595, 24.7343642107872, 0.000917169265449047],
  ],
  [
    [118.420465894029, 24.7338959910883, 0.000917110592126846],
    [118.419851230677, 24.7343503678571, 0.000917168334126472],
  ],
  [
    [118.420453273138, 24.7338817601833, 0.000917108729481697],
    [118.419838965888, 24.7343365429861, 0.000917165540158749],
  ],
  [
    [118.420440642372, 24.7338675383096, 0.000917105935513973],
    [118.419826691217, 24.7343227181186, 0.000917163677513599],
  ],
  [
    [118.420428001728, 24.7338533254672, 0.000917105004191399],
    [118.419814406674, 24.7343089113104, 0.00091716181486845],
  ],
  [
    [118.420415341318, 24.733839112633, 0.000917102210223675],
    [118.419802102364, 24.7342951045103, 0.000917159020900726],
  ],
  [
    [118.420402680921, 24.7338249178533, 0.0009171012789011],
    [118.419789798062, 24.7342813067369, 0.000917159020900726],
  ],
  [
    [118.420390000762, 24.7338107321096, 0.000917099416255951],
    [118.419777483883, 24.7342675179949, 0.000917157158255577],
  ],
  [
    [118.420377310722, 24.7337965463694, 0.000917097553610802],
    [118.419765149942, 24.7342537382889, 0.000917154364287853],
  ],
  [
    [118.420364610805, 24.7337823696605, 0.000917095690965652],
    [118.419752806119, 24.7342399585864, 0.000917154364287853],
  ],
  [
    [118.420351901016, 24.7337682110108, 0.000917093828320503],
    [118.419740452424, 24.734226196943, 0.000917151570320129],
  ],
  [
    [118.420339181346, 24.7337540523645, 0.000917091965675354],
    [118.419728098732, 24.7342124352986, 0.00091714970767498],
  ],
  [
    [118.420326441914, 24.7337399027543, 0.000917091034352779],
    [118.419715725284, 24.7341986917179, 0.000917147845029831],
  ],
  [
    [118.42031370249, 24.7337257621707, 0.00091708917170763],
    [118.419703341953, 24.7341849481408, 0.000917145051062107],
  ],
  [
    [118.420300943305, 24.733711630623, 0.000917088240385056],
    [118.419690938861, 24.7341712135996, 0.000917144119739532],
  ],
  [
    [118.420288184128, 24.7336975081021, 0.000917084515094757],
    [118.419678535781, 24.7341574971129, 0.000917142257094383],
  ],
  [
    [118.420275405189, 24.7336833946171, 0.000917082652449608],
    [118.41966612282, 24.7341437806298, 0.000917142257094383],
  ],
  [
    [118.420262616368, 24.7336692811356, 0.000917081721127033],
    [118.419653699981, 24.7341300731779, 0.000917138531804085],
  ],
  [
    [118.420249817676, 24.7336551857131, 0.000917079858481884],
    [118.419641257376, 24.7341163657342, 0.00091713760048151],
  ],
  [
    [118.420237009107, 24.733641099322, 0.000917078927159309],
    [118.419628804899, 24.7341026763497, 0.000917136669158936],
  ],
  [
    [118.420224180772, 24.733627012939, 0.000917076133191586],
    [118.419616352429, 24.7340889959918, 0.000917134806513786],
  ],
  [
    [118.420211352449, 24.7336129446105, 0.000917073339223862],
    [118.419603880193, 24.7340753156421, 0.000917132943868637],
  ],
  [
    [118.420198504361, 24.7335988762901, 0.000917071476578712],
    [118.419591398085, 24.7340616533515, 0.000917131081223488],
  ],
  [
    [118.42018565628, 24.7335848169964, 0.000917071476578712],
    [118.419578906095, 24.7340479910644, 0.000917129218578339],
  ],
  [
    [118.420172788443, 24.7335707757664, 0.000917068682610989],
    [118.419566404228, 24.7340343378086, 0.000917127355933189],
  ],
  [
    [118.420159910724, 24.7335567345398, 0.000917066819965839],
    [118.419553892485, 24.7340206935841, 0.00091712549328804],
  ],
  [
    [118.420147023128, 24.7335427023446, 0.000917065888643265],
    [118.419541370869, 24.7340070674187, 0.000917124561965466],
  ],
  [
    [118.420134125656, 24.7335286791806, 0.000917064025998116],
    [118.419528839366, 24.733993432229, 0.000917122699320316],
  ],
  [
    [118.420121218307, 24.7335146650479, 0.000917061232030392],
    [118.419516288106, 24.733979815103, 0.000917119905352592],
  ],
  [
    [118.420108291196, 24.7335006599511, 0.000917060300707817],
    [118.419503736855, 24.7339662070037, 0.000917118974030018],
  ],
  [
    [118.420095364094, 24.7334866638809, 0.000917059369385242],
    [118.419491165841, 24.7339526079403, 0.000917116180062294],
  ],
  [
    [118.420082417225, 24.7334726678189, 0.000917057506740093],
    [118.419478594831, 24.7339390088758, 0.000917115248739719],
  ],
  [
    [118.420069470369, 24.7334586898112, 0.000917053781449795],
    [118.419466004064, 24.733925427875, 0.000917114317417145],
  ],
  [
    [118.420056503752, 24.7334447208395, 0.00091705285012722],
    [118.419453403414, 24.7339118468777, 0.000917111523449421],
  ],
  [
    [118.420043527253, 24.7334307518712, 0.000917051918804646],
    [118.419440802778, 24.7338982839348, 0.000917111523449421],
  ],
  [
    [118.420030540882, 24.733416800962, 0.000917050056159496],
    [118.419428182375, 24.733884721, 0.000917109660804272],
  ],
  [
    [118.42001754463, 24.7334028500562, 0.000917047262191772],
    [118.419415552095, 24.7338711670965, 0.000917106866836548],
  ],
  [
    [118.420004538506, 24.7333889172095, 0.000917046330869198],
    [118.419402911938, 24.7338576222243, 0.000917105935513973],
  ],
  [
    [118.419991512615, 24.7333749843708, 0.000917043536901474],
    [118.419390261904, 24.7338440863834, 0.000917103141546249],
  ],
  [
    [118.419978486738, 24.7333610695866, 0.000917044468224049],
    [118.419377592108, 24.7338305595783, 0.0009171012789011],
  ],
  [
    [118.419965441094, 24.7333471548104, 0.000917041674256325],
    [118.419364922321, 24.7338170417998, 0.000917099416255951],
  ],
  [
    [118.419952395458, 24.7333332490609, 0.000917038880288601],
    [118.419352242656, 24.7338035330527, 0.000917098484933376],
  ],
  [
    [118.419939330061, 24.7333193523472, 0.000917037948966026],
    [118.419339543224, 24.7337900243136, 0.000917096622288227],
  ],
  [
    [118.419926254787, 24.7333054646647, 0.000917035154998302],
    [118.419326843806, 24.733776533629, 0.000917092896997929],
  ],
  [
    [118.419913169636, 24.7332915860135, 0.000917033292353153],
    [118.419314124626, 24.7337630519802, 0.000917094759643078],
  ],
  [
    [118.419900074609, 24.7332777163935, 0.000917031429708004],
    [118.419301405448, 24.7337495703303, 0.000917090103030205],
  ],
  [
    [118.419886969704, 24.7332638558048, 0.000917031429708004],
    [118.419288666509, 24.7337360977162, 0.000917090103030205],
  ],
  [
    [118.419873854924, 24.7332500042472, 0.000917029567062855],
    [118.419275917698, 24.7337226431612, 0.000917087309062481],
  ],
  [
    [118.419860720382, 24.7332361617255, 0.000917027704417706],
    [118.419263159005, 24.7337091886096, 0.000917087309062481],
  ],
  [
    [118.419847585848, 24.7332223282304, 0.000917025841772556],
    [118.419250390435, 24.7336957430893, 0.000917083583772182],
  ],
  [
    [118.419834431552, 24.7332085037711, 0.000917023979127407],
    [118.419237611988, 24.7336823066002, 0.000917083583772182],
  ],
  [
    [118.419821277259, 24.7331946793107, 0.000917021185159683],
    [118.419224823664, 24.7336688791423, 0.000917081721127033],
  ],
  [
    [118.419808103211, 24.7331808729138, 0.000917022116482258],
    [118.419212025464, 24.7336554607157, 0.000917078927159309],
  ],
  [
    [118.419794919285, 24.7331670755481, 0.000917017459869385],
    [118.419199217386, 24.7336420513203, 0.000917078927159309],
  ],
  [
    [118.419781725478, 24.7331532781859, 0.000917017459869385],
    [118.419186399431, 24.7336286509562, 0.000917076133191586],
  ],
  [
    [118.419768521799, 24.7331394988827, 0.000917014665901661],
    [118.419173571595, 24.7336152505954, 0.000917073339223862],
  ],
  [
    [118.419755308238, 24.7331257195828, 0.000917013734579086],
    [118.419160724002, 24.7336018682983, 0.000917073339223862],
  ],
  [
    [118.419742084806, 24.733111958342, 0.000917012803256512],
    [118.419147876416, 24.7335884950278, 0.000917071476578712],
  ],
  [
    [118.419728841607, 24.7330981971091, 0.000917010940611362],
    [118.419135009064, 24.7335751217654, 0.000917068682610989],
  ],
  [
    [118.419715598417, 24.7330844449029, 0.000917008146643639],
    [118.41912214172, 24.7335617575295, 0.000917067751288414],
  ],
  [
    [118.41970233547, 24.7330707107602, 0.000917008146643639],
    [118.419109254619, 24.7335484113573, 0.000917066819965839],
  ],
  [
    [118.419689072526, 24.7330569766163, 0.000917005352675915],
    [118.419096357637, 24.7335350651884, 0.00091706495732069],
  ],
  [
    [118.41967578982, 24.7330432515082, 0.000917002558708191],
    [118.419083460662, 24.7335217280463, 0.000917063094675541],
  ],
  [
    [118.419662497243, 24.7330295444591, 0.000916999764740467],
    [118.419070543925, 24.7335083999398, 0.000917061232030392],
  ],
  [
    [118.419649194784, 24.7330158374134, 0.000916999764740467],
    [118.419057617316, 24.7334950898924, 0.000917059369385242],
  ],
  [
    [118.419635892334, 24.7330021393942, 0.000916997902095318],
    [118.419044680826, 24.7334817798484, 0.000917058438062668],
  ],
  [
    [118.419622560237, 24.7329884504154, 0.000916996970772743],
    [118.419031734459, 24.7334684788356, 0.000917057506740093],
  ],
  [
    [118.419609228148, 24.7329747704632, 0.000916994176805019],
    [118.419018778214, 24.733455186854, 0.000917055644094944],
  ],
  [
    [118.419595886183, 24.7329610995421, 0.000916991382837296],
    [118.419005812088, 24.7334418948758, 0.000917053781449795],
  ],
  [
    [118.419582534341, 24.7329474376522, 0.000916991382837296],
    [118.41899283609, 24.7334286209566, 0.000917051918804646],
  ],
  [
    [118.419569162737, 24.7329337847981, 0.000916989520192146],
    [118.418979850215, 24.7334153560685, 0.000917050987482071],
  ],
  [
    [118.419555791142, 24.7329201409705, 0.000916987657546997],
    [118.418966844578, 24.7334021002162, 0.000917048193514347],
  ],
  [
    [118.419542399785, 24.7329065061787, 0.000916984863579273],
    [118.418953838944, 24.7333888443628, 0.000917045399546623],
  ],
  [
    [118.419529008436, 24.7328928804134, 0.000916985794901848],
    [118.418940823438, 24.7333756065683, 0.000917043536901474],
  ],
  [
    [118.419515597326, 24.7328792636839, 0.000916982069611549],
    [118.418927788166, 24.7333623687818, 0.000917042605578899],
  ],
  [
    [118.419502176334, 24.7328656469577, 0.000916981138288975],
    [118.418914752906, 24.7333491490496, 0.00091704074293375],
  ],
  [
    [118.41948874547, 24.7328520482904, 0.000916979275643826],
    [118.41890169788, 24.7333359293254, 0.000917038880288601],
  ],
  [
    [118.41947530473, 24.7328384586543, 0.000916978344321251],
    [118.418888642862, 24.7333227186279, 0.000917037948966026],
  ],
  [
    [118.419461854113, 24.7328248780494, 0.000916976481676102],
    [118.418875568087, 24.7333095259938, 0.000917036086320877],
  ],
  [
    [118.419448393615, 24.7328112974478, 0.000916975550353527],
    [118.418862493314, 24.7332963333586, 0.000917035154998302],
  ],
  [
    [118.419434923245, 24.7327977349051, 0.000916969962418079],
    [118.41884939878, 24.7332831497591, 0.000917034223675728],
  ],
  [
    [118.419421442998, 24.7327841813935, 0.000916969962418079],
    [118.41883629437, 24.7332699751907, 0.000917032361030579],
  ],
  [
    [118.419407942985, 24.7327706278899, 0.000916969031095505],
    [118.418823180082, 24.7332568096535, 0.000917031429708004],
  ],
  [
    [118.419394442984, 24.7327570924406, 0.000916967168450356],
    [118.418810065802, 24.7332436531429, 0.000917027704417706],
  ],
  [
    [118.419380933108, 24.7327435660224, 0.000916964374482632],
    [118.41879693176, 24.733230505668, 0.000917026773095131],
  ],
  [
    [118.419367403464, 24.7327300396121, 0.000916963443160057],
    [118.418783787842, 24.7332173672243, 0.000917023047804832],
  ],
  [
    [118.41935386395, 24.7327165312608, 0.000916961580514908],
    [118.418770634046, 24.7332042378117, 0.000917023047804832],
  ],
  [
    [118.419340324438, 24.7327030229082, 0.000916959717869759],
    [118.418757470374, 24.7331911174302, 0.000917021185159683],
  ],
  [
    [118.419326765169, 24.732689532619, 0.000916958786547184],
    [118.418744296825, 24.7331780060799, 0.000917020253837109],
  ],
  [
    [118.41931319602, 24.7326760423332, 0.000916957855224609],
    [118.418731113399, 24.7331649037608, 0.000917019322514534],
  ],
  [
    [118.419299616998, 24.7326625701063, 0.00091695599257946],
    [118.418717920091, 24.7331518014449, 0.000917017459869385],
  ],
  [
    [118.419286028095, 24.7326490978826, 0.000916954129934311],
    [118.418704707026, 24.7331387171926, 0.000917014665901661],
  ],
  [
    [118.41927242932, 24.7326356437179, 0.000916952267289162],
    [118.418691493969, 24.7331256419668, 0.000917012803256512],
  ],
  [
    [118.419258820664, 24.7326221895565, 0.000916950404644012],
    [118.418678271031, 24.7331125667444, 0.000917012803256512],
  ],
  [
    [118.419245202135, 24.732608753454, 0.000916949473321438],
    [118.41866503822, 24.7330995095809, 0.000917009077966213],
  ],
  [
    [118.419231563841, 24.7325953173593, 0.000916946679353714],
    [118.418651785643, 24.7330864524252, 0.000917008146643639],
  ],
  [
    [118.419217925559, 24.732581899319, 0.000916944816708565],
    [118.418638533078, 24.733073413324, 0.000917006283998489],
  ],
  [
    [118.419204277396, 24.7325684812819, 0.00091694388538599],
    [118.418625270632, 24.733060374226, 0.000917005352675915],
  ],
  [
    [118.419190609472, 24.7325550722805, 0.000916941091418266],
    [118.418611988424, 24.7330473441637, 0.000917003490030766],
  ],
  [
    [118.41917694156, 24.7325416813334, 0.000916939228773117],
    [118.418598706229, 24.7330343321558, 0.000917001627385616],
  ],
  [
    [118.419163253882, 24.7325282903942, 0.000916937366127968],
    [118.418585404267, 24.7330213201558, 0.000917000696063042],
  ],
  [
    [118.419149556333, 24.7325149175138, 0.000916936434805393],
    [118.418572102313, 24.7330083171823, 0.000916996970772743],
  ],
  [
    [118.419135858786, 24.7325015446322, 0.000916936434805393],
    [118.418558780602, 24.7329953322722, 0.000916997902095318],
  ],
  [
    [118.419122141479, 24.7324881807861, 0.000916932709515095],
    [118.418545458895, 24.732982347361, 0.000916995108127594],
  ],
  [
    [118.419108414299, 24.732474834999, 0.00091693177819252],
    [118.418532117425, 24.7329693714853, 0.000916994176805019],
  ],
  [
    [118.419094677238, 24.7324614892151, 0.000916929915547371],
    [118.418518766079, 24.7329564046408, 0.000916990451514721],
  ],
  [
    [118.4190809303, 24.7324481524622, 0.000916928984224796],
    [118.41850541474, 24.7329434468228, 0.000916990451514721],
  ],
  [
    [118.419067173491, 24.7324348337683, 0.000916925258934498],
    [118.41849204364, 24.7329304980404, 0.000916988588869572],
  ],
  [
    [118.4190534068, 24.7324215150775, 0.000916924327611923],
    [118.418478662663, 24.7329175582891, 0.000916985794901848],
  ],
  [
    [118.419039630232, 24.7324082054179, 0.000916923396289349],
    [118.418465271809, 24.732904627569, 0.000916984863579273],
  ],
  [
    [118.419025843793, 24.7323949138171, 0.000916921533644199],
    [118.418451880963, 24.7328917058754, 0.000916985794901848],
  ],
  [
    [118.419012037587, 24.732381622224, 0.00091691967099905],
    [118.418438470356, 24.7328787932173, 0.000916983000934124],
  ],
  [
    [118.418998231389, 24.7323683396575, 0.000916917808353901],
    [118.418425049871, 24.7328658895904, 0.000916981138288975],
  ],
  [
    [118.41898441532, 24.7323550751498, 0.000916916877031326],
    [118.418411619509, 24.7328529949945, 0.0009169802069664],
  ],
  [
    [118.418970579484, 24.73234181065, 0.000916915945708752],
    [118.418398179271, 24.7328401094298, 0.000916977412998676],
  ],
  [
    [118.418956743657, 24.7323285551766, 0.000916912220418453],
    [118.418384729156, 24.732827232896, 0.000916975550353527],
  ],
  [
    [118.418942888073, 24.7323153177665, 0.000916912220418453],
    [118.418371269164, 24.7328143653934, 0.000916973687708378],
  ],
  [
    [118.418929032492, 24.7323020803552, 0.000916910357773304],
    [118.418357799289, 24.732801497894, 0.000916972756385803],
  ],
  [
    [118.418915157149, 24.7322888519795, 0.00091690756380558],
    [118.418344319543, 24.7327886484535, 0.000916970893740654],
  ],
  [
    [118.418901271936, 24.7322756416625, 0.000916905701160431],
    [118.418330829921, 24.732775808044, 0.000916969962418079],
  ],
  [
    [118.418887386725, 24.7322624313443, 0.000916905701160431],
    [118.418317330421, 24.7327629766656, 0.000916967168450356],
  ],
  [
    [118.418873481752, 24.7322492300616, 0.000916901975870132],
    [118.418303821039, 24.7327501452905, 0.000916965305805206],
  ],
  [
    [118.418859566908, 24.7322360468377, 0.000916902907192707],
    [118.418290301785, 24.7327373319742, 0.000916965305805206],
  ],
  [
    [118.418845642183, 24.732222863617, 0.000916901044547558],
    [118.418276772655, 24.732724527689, 0.000916962511837482],
  ],
  [
    [118.418831707586, 24.7322096984552, 0.000916896387934685],
    [118.418263233642, 24.732711723407, 0.000916961580514908],
  ],
  [
    [118.418817763107, 24.7321965332966, 0.000916897319257259],
    [118.418249684758, 24.7326989371838, 0.000916960649192333],
  ],
  [
    [118.418803808751, 24.7321833771689, 0.000916896387934685],
    [118.418236125997, 24.7326861599917, 0.000916958786547184],
  ],
  [
    [118.418789844524, 24.7321702391001, 0.000916893593966961],
    [118.418222557354, 24.7326733828029, 0.000916956923902035],
  ],
  [
    [118.418775870415, 24.7321571010345, 0.000916891731321812],
    [118.418208968954, 24.7326606236773, 0.000916954129934311],
  ],
  [
    [118.418761886435, 24.7321439810277, 0.000916889868676662],
    [118.418195380557, 24.7326478645506, 0.000916955061256886],
  ],
  [
    [118.418747892572, 24.732130861024, 0.000916888937354088],
    [118.418181782288, 24.7326351234826, 0.000916950404644012],
  ],
  [
    [118.418733888839, 24.7321177590792, 0.000916886143386364],
    [118.418168174138, 24.7326223824179, 0.000916950404644012],
  ],
  [
    [118.418719865339, 24.7321046571421, 0.000916886143386364],
    [118.418154556115, 24.732609659412, 0.000916950404644012],
  ],
  [
    [118.418705841851, 24.7320915732592, 0.00091688334941864],
    [118.41814092821, 24.7325969364093, 0.000916946679353714],
  ],
  [
    [118.418691808483, 24.7320784893795, 0.000916882418096066],
    [118.418127280549, 24.7325842314699, 0.000916944816708565],
  ],
  [
    [118.418677755358, 24.7320654235631, 0.000916880555450916],
    [118.418113632891, 24.7325715265293, 0.000916942954063416],
  ],
  [
    [118.418663702236, 24.7320523577454, 0.000916877761483192],
    [118.418099975361, 24.7325588396475, 0.000916942022740841],
  ],
  [
    [118.418649639242, 24.7320393099865, 0.000916876830160618],
    [118.418086307949, 24.7325461527689, 0.000916940160095692],
  ],
  [
    [118.418635556482, 24.7320262622352, 0.000916874967515469],
    [118.41807262078, 24.7325334839536, 0.000916938297450542],
  ],
  [
    [118.418621473735, 24.7320132325382, 0.000916873104870319],
    [118.418058933614, 24.732520815137, 0.000916936434805393],
  ],
  [
    [118.418607371226, 24.7320002118767, 0.000916872173547745],
    [118.418045236576, 24.7325081643792, 0.000916936434805393],
  ],
  [
    [118.418593258836, 24.7319871912184, 0.000916870310902596],
    [118.418031519772, 24.7324955136291, 0.000916933640837669],
  ],
  [
    [118.418579146459, 24.7319741886143, 0.000916869379580021],
    [118.41801780298, 24.7324828809333, 0.000916930846869946],
  ],
  [
    [118.418565014321, 24.7319611950457, 0.000916866585612297],
    [118.418004076307, 24.7324702482408, 0.000916930846869946],
  ],
  [
    [118.418550872306, 24.731948210508, 0.000916866585612297],
    [118.417990339756, 24.7324576245792, 0.000916928052902222],
  ],
  [
    [118.418536730294, 24.731935225969, 0.000916861928999424],
    [118.417976583449, 24.7324450189809, 0.000916928052902222],
  ],
  [
    [118.418522568526, 24.7319222594932, 0.000916860997676849],
    [118.417962827145, 24.7324324133813, 0.000916926190257072],
  ],
  [
    [118.418508396881, 24.7319093020484, 0.000916860997676849],
    [118.417949060969, 24.7324198258404, 0.000916924327611923],
  ],
  [
    [118.418494215359, 24.7318963536345, 0.000916857272386551],
    [118.417935284911, 24.7324072383028, 0.000916924327611923],
  ],
  [
    [118.418480023961, 24.7318834142516, 0.000916857272386551],
    [118.417921489091, 24.7323946598007, 0.000916922464966774],
  ],
  [
    [118.418465832571, 24.7318704838951, 0.000916855409741402],
    [118.417907693284, 24.7323820993528, 0.000916920602321625],
  ],
  [
    [118.418451621414, 24.7318575535462, 0.000916853547096252],
    [118.417893887596, 24.7323695389081, 0.000916917808353901],
  ],
  [
    [118.418437400386, 24.7318446412561, 0.000916852615773678],
    [118.41788006215, 24.7323569965266, 0.000916915945708752],
  ],
  [
    [118.418423169481, 24.7318317379969, 0.000916849821805954],
    [118.417866236708, 24.7323444541439, 0.000916915014386177],
  ],
  [
    [118.4184089287, 24.7318188437686, 0.000916850753128529],
    [118.417852401388, 24.7323319207921, 0.000916914083063602],
  ],
  [
    [118.418394678041, 24.7318059585713, 0.000916847959160805],
    [118.417838556197, 24.7323194054991, 0.000916912220418453],
  ],
  [
    [118.418380417512, 24.7317930914327, 0.000916846096515656],
    [118.417824691239, 24.7323068902137, 0.000916910357773304],
  ],
  [
    [118.4183661471, 24.7317802242972, 0.000916844233870506],
    [118.417810826294, 24.7322943929826, 0.000916910357773304],
  ],
  [
    [118.418351866812, 24.7317673661926, 0.000916842371225357],
    [118.417796951467, 24.7322818957547, 0.000916905701160431],
  ],
  [
    [118.418337576647, 24.731754517119, 0.000916840508580208],
    [118.417783066768, 24.7322694165855, 0.000916904769837856],
  ],
  [
    [118.418323276606, 24.7317416770762, 0.000916838645935059],
    [118.417769162302, 24.7322569374239, 0.000916903838515282],
  ],
  [
    [118.418308956808, 24.7317288550967, 0.000916837714612484],
    [118.417755257845, 24.7322444672888, 0.000916902907192707],
  ],
  [
    [118.418294637013, 24.7317160331157, 0.000916837714612484],
    [118.417741343515, 24.7322320152125, 0.000916901044547558],
  ],
  [
    [118.418280307342, 24.7317032201657, 0.000916835851967335],
    [118.417727419303, 24.7322195631393, 0.000916899181902409],
  ],
  [
    [118.418265967799, 24.7316904252743, 0.000916833057999611],
    [118.417713475335, 24.7322071291293, 0.000916896387934685],
  ],
  [
    [118.418251618374, 24.7316776303861, 0.000916831195354462],
    [118.41769953137, 24.732194695118, 0.000916897319257259],
  ],
  [
    [118.418237259072, 24.7316648445288, 0.000916830264031887],
    [118.417685577533, 24.7321822791654, 0.00091689545661211],
  ],
  [
    [118.418222880015, 24.7316520767346, 0.000916827470064163],
    [118.417671613813, 24.732169863216, 0.000916892662644386],
  ],
  [
    [118.41820850096, 24.731639308939, 0.000916827470064163],
    [118.417657640222, 24.7321574653253, 0.000916891731321812],
  ],
  [
    [118.418194112034, 24.7316265592021, 0.000916824676096439],
    [118.417643656749, 24.7321450674377, 0.000916889868676662],
  ],
  [
    [118.41817971323, 24.7316138184962, 0.000916823744773865],
    [118.417629663404, 24.7321326876088, 0.000916889868676662],
  ],
  [
    [118.418165294661, 24.7316010777977, 0.000916821882128716],
    [118.417615660178, 24.7321203077831, 0.000916887074708939],
  ],
  [
    [118.418150876105, 24.7315883551535, 0.000916820019483566],
    [118.417601637194, 24.7321079460205, 0.000916886143386364],
  ],
  [
    [118.418136447672, 24.7315756415401, 0.000916818156838417],
    [118.417587614219, 24.7320955932844, 0.00091688334941864],
  ],
  [
    [118.418121999477, 24.7315629369621, 0.000916817225515842],
    [118.417573581361, 24.7320832405514, 0.00091688334941864],
  ],
  [
    [118.418107551286, 24.7315502323827, 0.000916815362870693],
    [118.417559538632, 24.7320709058772, 0.000916880555450916],
  ],
  [
    [118.418093093223, 24.7315375458619, 0.000916813500225544],
    [118.417545486025, 24.7320585802338, 0.000916879624128342],
  ],
  [
    [118.418078615399, 24.7315248683765, 0.000916813500225544],
    [118.417531423537, 24.7320462545935, 0.000916877761483192],
  ],
  [
    [118.418064137582, 24.7315121999175, 0.00091681070625782],
    [118.417517351177, 24.732033947012, 0.000916876830160618],
  ],
  [
    [118.418049649889, 24.7314995404893, 0.000916807912290096],
    [118.417503278824, 24.7320216484569, 0.000916874967515469],
  ],
  [
    [118.418035142435, 24.7314868900965, 0.000916806980967522],
    [118.417489186705, 24.7320093499093, 0.000916873104870319],
  ],
  [
    [118.418020634993, 24.7314742577578, 0.000916806980967522],
    [118.417475084714, 24.7319970694204, 0.000916872173547745],
  ],
  [
    [118.41800611767, 24.7314616254222, 0.000916805118322372],
    [118.417460972847, 24.7319847979625, 0.000916870310902596],
  ],
  [
    [118.417991580586, 24.7314490021219, 0.000916803255677223],
    [118.417446851102, 24.7319725355354, 0.000916869379580021],
  ],
  [
    [118.41797704351, 24.731436387848, 0.000916801393032074],
    [118.417432719475, 24.7319602731114, 0.000916868448257446],
  ],
  [
    [118.417962496562, 24.7314237916327, 0.000916799530386925],
    [118.417418587861, 24.7319480287416, 0.000916864722967148],
  ],
  [
    [118.417947929847, 24.7314111954249, 0.000916797667741776],
    [118.417404436486, 24.7319357934072, 0.000916862860321999],
  ],
  [
    [118.417933363146, 24.7313986172713, 0.000916796736419201],
    [118.417390275233, 24.7319235671037, 0.000916861928999424],
  ],
  [
    [118.417918786563, 24.7313860391207, 0.000916794873774052],
    [118.417376104104, 24.731911349831, 0.000916860066354275],
  ],
  [
    [118.417904190224, 24.7313734790333, 0.000916793011128902],
    [118.417361932983, 24.7318991415847, 0.0009168591350317],
  ],
  [
    [118.417889593887, 24.7313609189443, 0.000916792079806328],
    [118.417347742099, 24.7318869423738, 0.000916857272386551],
  ],
  [
    [118.417874987679, 24.731348376914, 0.000916790217161179],
    [118.417333541339, 24.7318747521937, 0.000916855409741402],
  ],
  [
    [118.41786036171, 24.731335843919, 0.000916787423193455],
    [118.417319340587, 24.7318625710401, 0.000916854478418827],
  ],
  [
    [118.417845735748, 24.7313233199504, 0.000916787423193455],
    [118.417305120073, 24.7318503989218, 0.000916852615773678],
  ],
  [
    [118.417831090026, 24.731310805017, 0.000916784629225731],
    [118.417290899567, 24.7318382358299, 0.000916851684451103],
  ],
  [
    [118.417816444311, 24.73129829911, 0.000916783697903156],
    [118.417276659299, 24.7318260817732, 0.000916849821805954],
  ],
  [
    [118.41780178872, 24.7312858022337, 0.000916782766580582],
    [118.417262419039, 24.731813936743, 0.000916847959160805],
  ],
  [
    [118.417787113367, 24.7312733143928, 0.000916780903935432],
    [118.417248168902, 24.7318018007437, 0.00091684702783823],
  ],
  [
    [118.417772438022, 24.7312608355782, 0.000916779041290283],
    [118.417233899009, 24.7317896828074, 0.000916845165193081],
  ],
  [
    [118.417757752801, 24.7312483657944, 0.000916776247322559],
    [118.417219629118, 24.7317775648698, 0.000916844233870506],
  ],
  [
    [118.417743057703, 24.7312359050413, 0.00091677438467741],
    [118.417205349351, 24.731765455963, 0.000916841439902782],
  ],
  [
    [118.417728342848, 24.7312234623514, 0.00091677438467741],
    [118.417191049826, 24.7317533651192, 0.000916841439902782],
  ],
  [
    [118.417713627997, 24.73121101966, 0.000916771590709686],
    [118.417176750305, 24.7317412742741, 0.000916839577257633],
  ],
  [
    [118.417698903269, 24.7311985859993, 0.000916770659387112],
    [118.417162440906, 24.7317291924598, 0.000916837714612484],
  ],
  [
    [118.417684168669, 24.7311861703973, 0.000916768796741962],
    [118.417148121636, 24.7317171287042, 0.000916836783289909],
  ],
  [
    [118.417669414308, 24.7311737638305, 0.000916766934096813],
    [118.417133792484, 24.7317050649516, 0.00091683492064476],
  ],
  [
    [118.417654659949, 24.7311613572622, 0.000916766002774239],
    [118.417119453459, 24.7316930192576, 0.000916833989322186],
  ],
  [
    [118.41763989572, 24.7311489687525, 0.000916766934096813],
    [118.417105104553, 24.7316809735666, 0.000916832126677036],
  ],
  [
    [118.417625121613, 24.7311365892736, 0.000916764140129089],
    [118.417090745775, 24.7316689459342, 0.000916831195354462],
  ],
  [
    [118.41761033763, 24.7311242188254, 0.000916761346161366],
    [118.417076377115, 24.7316569183049, 0.000916829332709312],
  ],
  [
    [118.417595533885, 24.7311118574125, 0.000916761346161366],
    [118.417061998583, 24.7316449087342, 0.000916827470064163],
  ],
  [
    [118.417580730149, 24.7310995050259, 0.000916759483516216],
    [118.417047610175, 24.7316329081943, 0.000916825607419014],
  ],
  [
    [118.417565916535, 24.73108716167, 0.000916756689548492],
    [118.417033211889, 24.7316209166852, 0.000916824676096439],
  ],
  [
    [118.417551093045, 24.7310748273449, 0.000916754826903343],
    [118.417018813606, 24.7316089251747, 0.00091682281345129],
  ],
  [
    [118.417536259679, 24.7310625020506, 0.000916753895580769],
    [118.417004395566, 24.7315969517272, 0.000916820950806141],
  ],
  [
    [118.417521416435, 24.731050185787, 0.000916752032935619],
    [118.41698996765, 24.7315849873106, 0.000916820019483566],
  ],
  [
    [118.41750656332, 24.731037887582, 0.000916752032935619],
    [118.416975539741, 24.7315730319203, 0.000916817225515842],
  ],
  [
    [118.417491700324, 24.7310255893799, 0.000916751101613045],
    [118.41696109207, 24.7315610855652, 0.000916817225515842],
  ],
  [
    [118.417476827455, 24.7310133092364, 0.000916747376322746],
    [118.416946644407, 24.7315491482365, 0.000916815362870693],
  ],
  [
    [118.417461944705, 24.7310010290958, 0.000916747376322746],
    [118.416932176983, 24.731537219943, 0.000916814431548119],
  ],
  [
    [118.417447052083, 24.7309887670137, 0.000916746445000172],
    [118.416917709567, 24.7315253006759, 0.000916813500225544],
  ],
  [
    [118.417432149585, 24.7309765139624, 0.000916743651032448],
    [118.416903232278, 24.7315133994674, 0.00091681070625782],
  ],
  [
    [118.41741723721, 24.7309642699419, 0.000916741788387299],
    [118.416888735223, 24.7315014982663, 0.00091681070625782],
  ],
  [
    [118.417402324842, 24.7309520349476, 0.000916740857064724],
    [118.416874238175, 24.7314896060915, 0.000916807912290096],
  ],
  [
    [118.417387392714, 24.7309398089885, 0.000916738994419575],
    [118.416859731251, 24.7314777229475, 0.000916805118322372],
  ],
  [
    [118.417372460598, 24.7309276010834, 0.000916737131774426],
    [118.416845204565, 24.7314658488387, 0.000916806049644947],
  ],
  [
    [118.4173575186, 24.7309153931814, 0.000916735269129276],
    [118.416830677887, 24.7314539837563, 0.000916803255677223],
  ],
  [
    [118.417342566731, 24.7309032033378, 0.000916733406484127],
    [118.416816131443, 24.7314421186813, 0.000916800461709499],
  ],
  [
    [118.417327604985, 24.7308910225249, 0.000916733406484127],
    [118.416801575126, 24.7314302716648, 0.000916800461709499],
  ],
  [
    [118.417312633362, 24.7308788507428, 0.000916730612516403],
    [118.416787018817, 24.7314184336747, 0.000916799530386925],
  ],
  [
    [118.417297661752, 24.7308666970147, 0.000916729681193829],
    [118.416772442742, 24.7314065956919, 0.000916797667741776],
  ],
  [
    [118.417282680261, 24.7308545432896, 0.000916728749871254],
    [118.41675785679, 24.7313947667399, 0.000916797667741776],
  ],
  [
    [118.417267688893, 24.7308423985951, 0.000916727818548679],
    [118.41674327085, 24.7313829558421, 0.000916793942451477],
  ],
  [
    [118.417252687653, 24.7308302719592, 0.000916725024580956],
    [118.416728665145, 24.7313711449516, 0.000916793942451477],
  ],
  [
    [118.41723768642, 24.7308181543496, 0.000916723161935806],
    [118.416714049562, 24.7313593430918, 0.000916791148483753],
  ],
  [
    [118.417222675311, 24.7308060457706, 0.000916721299290657],
    [118.416699433986, 24.7313475502584, 0.000916790217161179],
  ],
  [
    [118.417207654326, 24.7307939462224, 0.000916720367968082],
    [118.416684798645, 24.7313357574324, 0.000916789285838604],
  ],
  [
    [118.417192623463, 24.7307818557048, 0.000916719436645508],
    [118.416670153431, 24.7313239826649, 0.000916787423193455],
  ],
  [
    [118.417177582724, 24.7307697742179, 0.000916717574000359],
    [118.41665550822, 24.7313122078959, 0.000916784629225731],
  ],
  [
    [118.417162541993, 24.7307577017573, 0.000916716642677784],
    [118.416640843253, 24.7313004511899, 0.000916784629225731],
  ],
  [
    [118.41714749139, 24.7307456473552, 0.000916714780032635],
    [118.416626178288, 24.7312886944824, 0.000916782766580582],
  ],
  [
    [118.417132440789, 24.7307335929516, 0.000916712917387486],
    [118.416611493562, 24.73127694681, 0.000916781835258007],
  ],
  [
    [118.417117370433, 24.7307215566109, 0.000916711986064911],
    [118.416596808843, 24.7312652081639, 0.000916780903935432],
  ],
  [
    [118.417102300079, 24.7307095202686, 0.000916710123419762],
    [118.416582104359, 24.7312534695252, 0.000916779041290283],
  ],
  [
    [118.417087219853, 24.7306975019848, 0.000916708260774612],
    [118.416567399886, 24.7312417489406, 0.000916777178645134],
  ],
  [
    [118.417072139636, 24.7306854927273, 0.000916707329452038],
    [118.416552685532, 24.731230028359, 0.00091677438467741],
  ],
  [
    [118.417057039657, 24.7306734925048, 0.000916705466806889],
    [118.416537951417, 24.7312183168124, 0.00091677438467741],
  ],
  [
    [118.417041949565, 24.7306614922765, 0.000916704535484314],
    [118.416523217309, 24.7312066142921, 0.000916772522032261],
  ],
  [
    [118.417026839717, 24.7306495101109, 0.000916702672839165],
    [118.416508473319, 24.7311949117748, 0.000916770659387112],
  ],
  [
    [118.417011729877, 24.7306375369717, 0.000916700810194016],
    [118.416493719457, 24.731183227316, 0.000916769728064537],
  ],
  [
    [118.41699661016, 24.7306255728631, 0.000916699878871441],
    [118.416478955713, 24.7311715428601, 0.000916766934096813],
  ],
  [
    [118.416981480566, 24.7306136177852, 0.000916698016226292],
    [118.416464191977, 24.7311598674305, 0.000916767865419388],
  ],
  [
    [118.41696635098, 24.7306016717335, 0.000916696153581142],
    [118.41644940848, 24.731148201036, 0.000916764140129089],
  ],
  [
    [118.416951211518, 24.7305897347125, 0.000916695222258568],
    [118.416434624985, 24.73113653464, 0.000916763208806515],
  ],
  [
    [118.416936072063, 24.7305778067177, 0.000916693359613419],
    [118.416419821734, 24.7311248863069, 0.00091676227748394],
  ],
  [
    [118.416920912847, 24.730565887758, 0.000916691496968269],
    [118.416405018485, 24.7311132379722, 0.000916761346161366],
  ],
  [
    [118.416905763523, 24.7305539778201, 0.000916691496968269],
    [118.416390205355, 24.7311015896405, 0.000916760414838791],
  ],
  [
    [118.416890594438, 24.7305420769173, 0.000916688703000546],
    [118.416375382353, 24.7310899593673, 0.000916756689548492],
  ],
  [
    [118.416875425361, 24.7305301850408, 0.000916687771677971],
    [118.416360549469, 24.731078329097, 0.000916755758225918],
  ],
  [
    [118.416860256291, 24.7305183021904, 0.000916686840355396],
    [118.416345706708, 24.7310667078573, 0.000916754826903343],
  ],
  [
    [118.416845067455, 24.7305064193474, 0.000916684977710247],
    [118.416330863954, 24.7310550956439, 0.000916752964258194],
  ],
  [
    [118.416829878632, 24.7304945545583, 0.000916683115065098],
    [118.416316001435, 24.7310434834378, 0.000916752032935619],
  ],
  [
    [118.416814689817, 24.7304826987955, 0.000916681252419949],
    [118.416301138927, 24.7310318892858, 0.000916751101613045],
  ],
  [
    [118.416799491125, 24.7304708520633, 0.000916679389774799],
    [118.416286266533, 24.7310202861089, 0.000916749238967896],
  ],
  [
    [118.416784282551, 24.730459005334, 0.00091667752712965],
    [118.416271384267, 24.7310087009904, 0.000916747376322746],
  ],
  [
    [118.41676907399, 24.7304471766587, 0.000916676595807076],
    [118.41625649212, 24.7309971158748, 0.000916746445000172],
  ],
  [
    [118.416753855547, 24.7304353479863, 0.000916675664484501],
    [118.41624159998, 24.7309855397855, 0.000916744582355022],
  ],
  [
    [118.416738637117, 24.7304235373678, 0.000916673801839352],
    [118.416226697963, 24.7309739727269, 0.000916741788387299],
  ],
  [
    [118.416723408806, 24.7304117267522, 0.000916673801839352],
    [118.416211786064, 24.7309624056711, 0.000916741788387299],
  ],
  [
    [118.416708180501, 24.7303999251629, 0.000916671007871628],
    [118.416196864288, 24.730950847646, 0.000916739925742149],
  ],
  [
    [118.416692942321, 24.7303881326041, 0.000916669145226479],
    [118.416181932635, 24.7309392986515, 0.000916738994419575],
  ],
  [
    [118.416677694268, 24.7303763581038, 0.000916667282581329],
    [118.416167000986, 24.7309277496555, 0.000916738063097],
  ],
  [
    [118.416662446213, 24.7303645745741, 0.000916667282581329],
    [118.416152049574, 24.7309162096945, 0.000916733406484127],
  ],
  [
    [118.416647198171, 24.7303528090984, 0.000916664488613606],
    [118.416137098171, 24.7309046787599, 0.000916734337806702],
  ],
  [
    [118.416631930368, 24.7303410526577, 0.000916663557291031],
    [118.416122136885, 24.730893147828, 0.000916732475161552],
  ],
  [
    [118.416616672457, 24.7303293052389, 0.000916662625968456],
    [118.416107175607, 24.7308816259225, 0.000916731543838978],
  ],
  [
    [118.416601404664, 24.7303175578229, 0.000916659832000732],
    [118.416092204452, 24.7308701130475, 0.000916730612516403],
  ],
  [
    [118.416586126995, 24.7303058194374, 0.000916657969355583],
    [118.416077223416, 24.7308586001755, 0.000916728749871254],
  ],
  [
    [118.416570849333, 24.7302940900782, 0.000916657969355583],
    [118.416062232502, 24.730847096334, 0.000916727818548679],
  ],
  [
    [118.416555561794, 24.7302823697496, 0.000916654244065285],
    [118.416047231707, 24.7308355924954, 0.000916726887226105],
  ],
  [
    [118.416540274263, 24.7302706584473, 0.000916654244065285],
    [118.41603223092, 24.730824097683, 0.000916725024580956],
  ],
  [
    [118.41652498674, 24.7302589561711, 0.00091665331274271],
    [118.416017220255, 24.7308126119013, 0.000916723161935806],
  ],
  [
    [118.416509689336, 24.7302472538978, 0.000916651450097561],
    [118.416002199709, 24.7308011261224, 0.000916721299290657],
  ],
  [
    [118.416494382059, 24.7302355696828, 0.000916649587452412],
    [118.41598717917, 24.7307896493698, 0.000916720367968082],
  ],
  [
    [118.416479074785, 24.7302238854662, 0.000916649587452412],
    [118.415972148754, 24.7307781816478, 0.000916717574000359],
  ],
  [
    [118.416463767519, 24.7302122102759, 0.000916646793484688],
    [118.415957108457, 24.7307667139286, 0.000916718505322933],
  ],
  [
    [118.416448450371, 24.7302005350884, 0.000916647724807262],
    [118.415942068162, 24.7307552462079, 0.000916715711355209],
  ],
  [
    [118.416433123351, 24.7301888779592, 0.000916645862162113],
    [118.415927008106, 24.7307437875222, 0.000916715711355209],
  ],
  [
    [118.416417806219, 24.7301772208241, 0.000916643068194389],
    [118.415911948058, 24.7307323378627, 0.000916711986064911],
  ],
  [
    [118.416402469325, 24.7301655727239, 0.000916643999516964],
    [118.415896888012, 24.7307208882017, 0.000916711986064911],
  ],
  [
    [118.416387142324, 24.7301539336456, 0.00091664120554924],
    [118.415881818089, 24.7307094475712, 0.000916710123419762],
  ],
  [
    [118.416371805445, 24.7301423035979, 0.000916639342904091],
    [118.41586673829, 24.7306980159714, 0.000916709192097187],
  ],
  [
    [118.416356458686, 24.7301306735529, 0.000916638411581516],
    [118.415851648604, 24.7306865753466, 0.000916706398129463],
  ],
  [
    [118.416341111933, 24.7301190525342, 0.000916636548936367],
    [118.41583655893, 24.7306751527758, 0.000916705466806889],
  ],
  [
    [118.416325765189, 24.7301074405416, 0.000916633754968643],
    [118.415821459375, 24.7306637302079, 0.000916703604161739],
  ],
  [
    [118.416310408568, 24.7300958375797, 0.000916634686291218],
    [118.415806349937, 24.7306523076427, 0.000916702672839165],
  ],
  [
    [118.416295051949, 24.7300842346161, 0.000916631892323494],
    [118.415791240508, 24.7306408941038, 0.000916702672839165],
  ],
  [
    [118.416279695338, 24.7300726406787, 0.000916630029678345],
    [118.415776121201, 24.7306294895955, 0.000916698947548866],
  ],
  [
    [118.416264328851, 24.7300610557719, 0.000916628167033196],
    [118.415761001897, 24.7306180850856, 0.000916698947548866],
  ],
  [
    [118.416248962371, 24.7300494798914, 0.000916626304388046],
    [118.415745872712, 24.7306066805785, 0.000916697084903717],
  ],
  [
    [118.416233586009, 24.7300379040135, 0.000916625373065472],
    [118.415730733649, 24.730595285102, 0.000916695222258568],
  ],
  [
    [118.416218209655, 24.7300263371619, 0.000916624441742897],
    [118.415715594595, 24.7305838986518, 0.000916694290935993],
  ],
  [
    [118.416202833309, 24.7300147793365, 0.000916623510420322],
    [118.415700445658, 24.7305725122043, 0.000916692428290844],
  ],
  [
    [118.416187447081, 24.7300032215138, 0.000916621647775173],
    [118.41568528684, 24.7305611257596, 0.000916690565645695],
  ],
  [
    [118.416172060861, 24.7299916727174, 0.000916620716452599],
    [118.415670128029, 24.7305497483412, 0.00091668963432312],
  ],
  [
    [118.416156674648, 24.7299801329471, 0.000916618853807449],
    [118.415654959336, 24.7305383709255, 0.000916688703000546],
  ],
  [
    [118.416141278554, 24.7299685931796, 0.0009166169911623],
    [118.415639790651, 24.730527002536, 0.000916686840355396],
  ],
  [
    [118.416125882467, 24.7299570624383, 0.000916615128517151],
    [118.415624612085, 24.7305156341494, 0.000916685909032822],
  ],
  [
    [118.416110476504, 24.7299455407275, 0.000916614197194576],
    [118.415609433526, 24.7305042747889, 0.000916684046387672],
  ],
  [
    [118.416095080433, 24.7299340280386, 0.000916612334549427],
    [118.415594245085, 24.7304929154313, 0.000916683115065098],
  ],
  [
    [118.41607967448, 24.7299225153524, 0.000916610471904278],
    [118.415579046767, 24.7304815651042, 0.000916681252419949],
  ],
  [
    [118.41606426853, 24.7299110026646, 0.000916611403226852],
    [118.415563848452, 24.7304702147755, 0.000916678458452225],
  ],
  [
    [118.416048852708, 24.7298995080352, 0.000916607677936554],
    [118.415548640255, 24.7304588644496, 0.00091667752712965],
  ],
  [
    [118.416033436884, 24.7298880043764, 0.000916605815291405],
    [118.415533432066, 24.7304475231499, 0.000916676595807076],
  ],
  [
    [118.416018021072, 24.7298765187715, 0.000916605815291405],
    [118.415518213995, 24.730436181853, 0.000916676595807076],
  ],
  [
    [118.416002595379, 24.7298650331694, 0.00091660488396883],
    [118.415502986048, 24.7304248495866, 0.000916673801839352],
  ],
  [
    [118.415987179578, 24.7298535565892, 0.000916602090001106],
    [118.415487767982, 24.7304135082866, 0.000916672870516777],
  ],
  [
    [118.415971753895, 24.7298420800116, 0.000916602090001106],
    [118.41547253016, 24.7304021850492, 0.000916672870516777],
  ],
  [
    [118.415956318335, 24.7298306124647, 0.000916599296033382],
    [118.415457292341, 24.7303908618102, 0.000916671007871628],
  ],
  [
    [118.415940892668, 24.7298191539395, 0.000916597433388233],
    [118.415442054525, 24.7303795385697, 0.000916669145226479],
  ],
  [
    [118.415925457119, 24.7298076954171, 0.000916595570743084],
    [118.415426806827, 24.7303682153319, 0.000916666351258755],
  ],
  [
    [118.415910021577, 24.7297962459209, 0.000916595570743084],
    [118.415411549252, 24.7303569011246, 0.00091666541993618],
  ],
  [
    [118.415894586038, 24.7297847964231, 0.000916594639420509],
    [118.415396291679, 24.7303455869158, 0.00091666541993618],
  ],
  [
    [118.415879140623, 24.7297733559558, 0.00091659277677536],
    [118.415381034115, 24.7303342817332, 0.000916661694645882],
  ],
  [
    [118.41586369521, 24.7297619154868, 0.000916591845452785],
    [118.415365766663, 24.7303229675255, 0.000916661694645882],
  ],
  [
    [118.415848249805, 24.7297504840441, 0.000916589982807636],
    [118.41535048934, 24.7303116713762, 0.000916660763323307],
  ],
  [
    [118.415832804408, 24.7297390616276, 0.000916587188839912],
    [118.415335212015, 24.7303003661974, 0.000916657038033009],
  ],
  [
    [118.415817349129, 24.7297276392138, 0.000916588120162487],
    [118.415319934697, 24.7302890700449, 0.000916656106710434],
  ],
  [
    [118.415801903741, 24.7297162258218, 0.000916585326194763],
    [118.415304647497, 24.7302777738952, 0.000916656106710434],
  ],
  [
    [118.415786448473, 24.7297048124325, 0.000916584394872189],
    [118.415289350421, 24.7302664867759, 0.000916654244065285],
  ],
  [
    [118.415770993207, 24.7296933990417, 0.000916583463549614],
    [118.415274063227, 24.730255190623, 0.00091665331274271],
  ],
  [
    [118.415755537949, 24.729681994677, 0.00091658066958189],
    [118.415258756272, 24.7302439035049, 0.000916651450097561],
  ],
  [
    [118.415740072813, 24.7296705993428, 0.000916579738259315],
    [118.415243449324, 24.7302326254129, 0.000916650518774986],
  ],
  [
    [118.415724607681, 24.7296592040071, 0.000916577875614166],
    [118.415228142374, 24.7302213382917, 0.000916648656129837],
  ],
  [
    [118.415709152441, 24.7296478176931, 0.000916576944291592],
    [118.415212835432, 24.7302100601966, 0.000916647724807262],
  ],
  [
    [118.415693687319, 24.7296364313819, 0.000916576944291592],
    [118.415197518608, 24.7301987821042, 0.000916646793484688],
  ],
  [
    [118.415678212315, 24.7296250450734, 0.000916574150323868],
    [118.415182191907, 24.7301875130424, 0.000916643068194389],
  ],
  [
    [118.415662747208, 24.7296136768145, 0.000916572287678719],
    [118.415166865208, 24.7301762439789, 0.000916643999516964],
  ],
  [
    [118.4156472821, 24.7296022995263, 0.000916571356356144],
    [118.415151538513, 24.7301649749139, 0.00091664120554924],
  ],
  [
    [118.415631807114, 24.7295909312685, 0.000916570425033569],
    [118.415136201936, 24.7301537058516, 0.000916640274226666],
  ],
  [
    [118.415616332131, 24.7295795630091, 0.000916567631065845],
    [118.415120865362, 24.7301424367877, 0.000916638411581516],
  ],
  [
    [118.415600857156, 24.7295682037759, 0.000916567631065845],
    [118.41510551891, 24.7301311767543, 0.000916638411581516],
  ],
  [
    [118.415585382189, 24.7295568535689, 0.000916565768420696],
    [118.415090172462, 24.7301199167193, 0.000916636548936367],
  ],
  [
    [118.415569907219, 24.7295454943325, 0.000916564837098122],
    [118.415074826016, 24.7301086566827, 0.000916633754968643],
  ],
  [
    [118.415554422377, 24.7295341531544, 0.000916562043130398],
    [118.415059469689, 24.7300973966487, 0.000916633754968643],
  ],
  [
    [118.415538947418, 24.7295228029425, 0.000916561111807823],
    [118.415044113369, 24.730086145641, 0.000916632823646069],
  ],
  [
    [118.415523462582, 24.7295114617611, 0.000916559249162674],
    [118.415028757047, 24.7300748856039, 0.000916630961000919],
  ],
  [
    [118.415507987638, 24.7295001296016, 0.000916557386517525],
    [118.415013390848, 24.7300636345973, 0.000916628167033196],
  ],
  [
    [118.415492502807, 24.7294887884169, 0.000916555523872375],
    [118.414998024652, 24.7300523835891, 0.000916627235710621],
  ],
  [
    [118.415477017989, 24.7294774652863, 0.000916555523872375],
    [118.41498264858, 24.7300411416114, 0.000916627235710621],
  ],
  [
    [118.415461533169, 24.7294661331262, 0.000916554592549801],
    [118.414967272505, 24.7300298906043, 0.000916625373065472],
  ],
  [
    [118.415446048357, 24.7294548099924, 0.000916553661227226],
    [118.414951896437, 24.7300186486234, 0.000916622579097748],
  ],
  [
    [118.415430563547, 24.7294434868568, 0.000916552729904652],
    [118.414936510484, 24.7300073976174, 0.000916621647775173],
  ],
  [
    [118.415415078745, 24.7294321727475, 0.000916549004614353],
    [118.414921124537, 24.7299961556375, 0.000916618853807449],
  ],
  [
    [118.415399584061, 24.7294208586409, 0.000916547141969204],
    [118.414905738594, 24.7299849136561, 0.000916617922484875],
  ],
  [
    [118.415384099269, 24.7294095535561, 0.000916547141969204],
    [118.414890342773, 24.7299736807051, 0.000916616059839725],
  ],
  [
    [118.415368604591, 24.7293982394462, 0.000916546210646629],
    [118.414874946951, 24.7299624387248, 0.000916614197194576],
  ],
  [
    [118.415353119804, 24.7293869343582, 0.000916545279324055],
    [118.414859551136, 24.7299512057706, 0.000916614197194576],
  ],
  [
    [118.415337625141, 24.7293756383007, 0.000916541554033756],
    [118.414844155319, 24.729939963787, 0.000916613265872002],
  ],
  [
    [118.415322140365, 24.7293643422372, 0.000916539691388607],
    [118.414828749625, 24.7299287308339, 0.000916613265872002],
  ],
  [
    [118.415306645708, 24.7293530461764, 0.000916539691388607],
    [118.414813343934, 24.7299174978792, 0.000916609540581703],
  ],
  [
    [118.415291151053, 24.729341750114, 0.000916538760066032],
    [118.414797928362, 24.7299062649272, 0.000916609540581703],
  ],
  [
    [118.41527566629, 24.7293304630735, 0.000916536897420883],
    [118.414782512792, 24.7298950319735, 0.000916606746613979],
  ],
  [
    [118.415260171645, 24.7293191760356, 0.000916534103453159],
    [118.414767097225, 24.7298837990183, 0.000916605815291405],
  ],
  [
    [118.415244677004, 24.7293078889962, 0.000916533172130585],
    [118.414751681661, 24.7298725660614, 0.00091660488396883],
  ],
  [
    [118.41522918237, 24.7292966109829, 0.000916534103453159],
    [118.414736256215, 24.7298613331072, 0.000916603021323681],
  ],
  [
    [118.415213697622, 24.7292853329637, 0.000916531309485435],
    [118.414720830776, 24.7298501091792, 0.000916603021323681],
  ],
  [
    [118.415198202994, 24.7292740549471, 0.000916529446840286],
    [118.414705405336, 24.7298388762218, 0.000916602090001106],
  ],
  [
    [118.415182708368, 24.729262776929, 0.000916528515517712],
    [118.414689979903, 24.7298276522906, 0.000916598364710808],
  ],
  [
    [118.41516721375, 24.729251507937, 0.000916526652872562],
    [118.414674544584, 24.7298164193342, 0.000916597433388233],
  ],
  [
    [118.415151729019, 24.7292402389391, 0.000916525721549988],
    [118.414659109272, 24.729805195404, 0.000916595570743084],
  ],
  [
    [118.415136234406, 24.7292289699438, 0.000916523858904839],
    [118.414643673958, 24.7297939624444, 0.000916595570743084],
  ],
  [
    [118.415120739796, 24.729217700947, 0.000916522927582264],
    [118.414628238652, 24.729782738511, 0.000916594639420509],
  ],
  [
    [118.415105245194, 24.7292064409763, 0.00091652013361454],
    [118.414612793464, 24.7297715145803, 0.00091659277677536],
  ],
  [
    [118.415089760478, 24.7291951809997, 0.00091652013361454],
    [118.414597348274, 24.7297602816201, 0.000916589982807636],
  ],
  [
    [118.415074265881, 24.7291839210258, 0.000916518270969391],
    [118.414581903092, 24.7297490576861, 0.000916589982807636],
  ],
  [
    [118.415058781172, 24.7291726610459, 0.000916518270969391],
    [118.414566457913, 24.7297378337505, 0.000916589051485062],
  ],
  [
    [118.415043286585, 24.7291614100966, 0.000916513614356518],
    [118.414551002847, 24.7297266007897, 0.000916586257517338],
  ],
  [
    [118.415027801881, 24.7291501501135, 0.000916512683033943],
    [118.414535547788, 24.7297153768552, 0.000916585326194763],
  ],
  [
    [118.4150123073, 24.7291388991609, 0.000916511751711369],
    [118.414520102617, 24.7297041529147, 0.000916585326194763],
  ],
  [
    [118.414996822606, 24.7291276482023, 0.000916511751711369],
    [118.414504637675, 24.7296929199534, 0.000916582532227039],
  ],
  [
    [118.414981337919, 24.72911640627, 0.000916508957743645],
    [118.414489182625, 24.729681696014, 0.00091658066958189],
  ],
  [
    [118.414965843347, 24.7291051553125, 0.000916508957743645],
    [118.414473727578, 24.7296704720729, 0.000916579738259315],
  ],
  [
    [118.414950358666, 24.7290939133769, 0.00091650802642107],
    [118.414458262644, 24.7296592391067, 0.000916578806936741],
  ],
  [
    [118.414934873988, 24.7290826714397, 0.000916506163775921],
    [118.414442797718, 24.7296480151667, 0.000916576944291592],
  ],
  [
    [118.414919389308, 24.7290714204731, 0.000916504301130772],
    [118.41442733279, 24.7296367821973, 0.000916575081646442],
  ],
  [
    [118.41490390464, 24.7290601875604, 0.000916502438485622],
    [118.414411867865, 24.7296255492262, 0.000916575081646442],
  ],
  [
    [118.414888429854, 24.7290489456141, 0.000916501507163048],
    [118.414396393063, 24.7296143252856, 0.000916571356356144],
  ],
  [
    [118.414872945187, 24.7290377036704, 0.000916501507163048],
    [118.414380928143, 24.7296030923113, 0.000916570425033569],
  ],
  [
    [118.414857460528, 24.7290264707529, 0.000916498713195324],
    [118.414365453342, 24.7295918593396, 0.000916570425033569],
  ],
  [
    [118.414841985751, 24.7290152288017, 0.000916496850550175],
    [118.414349978544, 24.7295806263663, 0.00091656856238842],
  ],
  [
    [118.414826510981, 24.7290039958766, 0.0009164959192276],
    [118.414334503748, 24.7295693933914, 0.000916565768420696],
  ],
  [
    [118.414811036214, 24.72899276295, 0.000916494987905025],
    [118.414319028955, 24.7295581604149, 0.000916564837098122],
  ],
  [
    [118.414795551566, 24.728981530026, 0.000916494056582451],
    [118.414303554165, 24.7295469274368, 0.000916564837098122],
  ],
  [
    [118.414780076805, 24.7289702970961, 0.000916491262614727],
    [118.414288079378, 24.729535694457, 0.000916562043130398],
  ],
  [
    [118.414764602041, 24.7289590551368, 0.000916490331292152],
    [118.414272604593, 24.7295244614756, 0.000916562043130398],
  ],
  [
    [118.414749127286, 24.7289478222037, 0.000916490331292152],
    [118.414257129812, 24.7295132284926, 0.000916559249162674],
  ],
  [
    [118.414733652533, 24.7289365892689, 0.000916487537324429],
    [118.414241655028, 24.7295019864802, 0.000916559249162674],
  ],
  [
    [118.414718177782, 24.7289253563325, 0.000916485674679279],
    [118.414226170367, 24.7294907534982, 0.00091655645519495],
  ],
  [
    [118.414702703035, 24.7289141233946, 0.000916484743356705],
    [118.414210695594, 24.7294795205104, 0.00091655645519495],
  ],
  [
    [118.41468722829, 24.728902890455, 0.000916482880711555],
    [118.414195220823, 24.7294682875209, 0.000916553661227226],
  ],
  [
    [118.414671743664, 24.728891657518, 0.000916481949388981],
    [118.414179746055, 24.7294570545298, 0.000916551798582077],
  ],
  [
    [118.41465626892, 24.7288804155473, 0.000916479155421257],
    [118.41416427129, 24.7294458215371, 0.000916551798582077],
  ],
  [
    [118.414640794184, 24.7288691826029, 0.000916479155421257],
    [118.414148796528, 24.7294345885427, 0.000916549935936928],
  ],
  [
    [118.414625319451, 24.7288579496568, 0.000916477292776108],
    [118.414133321764, 24.729423346519, 0.000916549004614353],
  ],
  [
    [118.41460984472, 24.7288467167091, 0.000916476361453533],
    [118.414117837123, 24.7294121135256, 0.000916547141969204],
  ],
  [
    [118.414594369992, 24.7288354837598, 0.000916474498808384],
    [118.414102362369, 24.7294008805264, 0.00091654434800148],
  ],
  [
    [118.414578895267, 24.7288242508088, 0.000916473567485809],
    [118.414086887618, 24.7293896475256, 0.000916545279324055],
  ],
  [
    [118.414563420544, 24.7288130178563, 0.00091647170484066],
    [118.414071412869, 24.7293784145232, 0.000916543416678905],
  ],
  [
    [118.41454793594, 24.7288017849063, 0.000916470773518085],
    [118.414055938123, 24.7293671815191, 0.000916540622711182],
  ],
  [
    [118.414532461219, 24.7287905429227, 0.000916469842195511],
    [118.414040463381, 24.7293559485134, 0.000916540622711182],
  ],
  [
    [118.414516986505, 24.7287793099653, 0.000916467979550362],
    [118.41402498864, 24.7293447155061, 0.000916538760066032],
  ],
  [
    [118.414501511793, 24.7287680770063, 0.000916467979550362],
    [118.414009513899, 24.7293334734694, 0.000916536897420883],
  ],
  [
    [118.414486037085, 24.7287568440456, 0.000916464254260063],
    [118.41399402928, 24.7293222404631, 0.000916534103453159],
  ],
  [
    [118.414470562379, 24.7287456110833, 0.000916462391614914],
    [118.413978554548, 24.729311007451, 0.000916535034775734],
  ],
  [
    [118.414455087676, 24.7287343781194, 0.000916462391614914],
    [118.413963079819, 24.7292997744372, 0.00091653224080801],
  ],
  [
    [118.414439603092, 24.7287231451582, 0.000916461460292339],
    [118.413947605093, 24.7292885414218, 0.00091653224080801],
  ],
  [
    [118.41442412839, 24.7287119031632, 0.00091645959764719],
    [118.413932130369, 24.7292773084048, 0.000916529446840286],
  ],
  [
    [118.414408653695, 24.7287006701945, 0.000916457735002041],
    [118.413916655649, 24.7292660753862, 0.000916528515517712],
  ],
  [
    [118.414393179003, 24.7286894372241, 0.000916454941034317],
    [118.413901180926, 24.7292548333381, 0.000916527584195137],
  ],
  [
    [118.414377704314, 24.7286782042521, 0.000916455872356892],
    [118.413885706211, 24.7292436003162, 0.000916525721549988],
  ],
  [
    [118.414362229628, 24.7286669712785, 0.000916454009711742],
    [118.413870221614, 24.729232367297, 0.000916523858904839],
  ],
  [
    [118.414346754944, 24.7286557383032, 0.000916452147066593],
    [118.413854746905, 24.7292211342719, 0.000916523858904839],
  ],
  [
    [118.414331280263, 24.7286445053264, 0.000916450284421444],
    [118.413839272198, 24.7292099012451, 0.000916522927582264],
  ],
  [
    [118.414315795701, 24.7286332723522, 0.000916448421776295],
    [118.413823797494, 24.7291986682168, 0.00091652013361454],
  ],
  [
    [118.414300321021, 24.7286220303443, 0.000916448421776295],
    [118.413808322793, 24.7291874351868, 0.000916519202291965],
  ],
  [
    [118.414284846349, 24.7286107973625, 0.000916445627808571],
    [118.413792848094, 24.7291762021552, 0.000916519202291965],
  ],
  [
    [118.414269371679, 24.7285995643792, 0.000916444696485996],
    [118.413777373394, 24.7291649600942, 0.000916515477001667],
  ],
  [
    [118.414253897012, 24.7285883313942, 0.000916443765163422],
    [118.413761888817, 24.7291537270636, 0.000916513614356518],
  ],
  [
    [118.414238422348, 24.7285770984077, 0.000916442833840847],
    [118.413746414127, 24.7291424940272, 0.000916514545679092],
  ],
  [
    [118.414222947687, 24.7285658654195, 0.000916440039873123],
    [118.41373093944, 24.7291312609891, 0.000916511751711369],
  ],
  [
    [118.414207463144, 24.7285546324339, 0.000916440039873123],
    [118.413715464755, 24.7291200279494, 0.000916509889066219],
  ],
  [
    [118.414191988484, 24.7285433904147, 0.000916437245905399],
    [118.413699990073, 24.7291087949081, 0.000916508957743645],
  ],
  [
    [118.414176513831, 24.7285321574216, 0.000916436314582825],
    [118.413684515394, 24.7290975618652, 0.000916507095098495],
  ],
  [
    [118.414161039181, 24.728520924427, 0.000916436314582825],
    [118.413669040714, 24.7290863197929, 0.000916505232453346],
  ],
  [
    [118.414145564533, 24.7285096914307, 0.000916434451937675],
    [118.41365356604, 24.7290750867467, 0.000916505232453346],
  ],
  [
    [118.414130089889, 24.7284984584328, 0.000916431657969952],
    [118.413638081485, 24.7290638537031, 0.000916502438485622],
  ],
  [
    [118.414114615247, 24.7284872254332, 0.000916431657969952],
    [118.413622606817, 24.7290526206537, 0.000916502438485622],
  ],
  [
    [118.414099140608, 24.7284759924321, 0.000916429795324802],
    [118.413607132152, 24.7290413876027, 0.000916501507163048],
  ],
  [
    [118.414083656082, 24.7284647504057, 0.000916428864002228],
    [118.41359165749, 24.7290301545501, 0.000916499644517899],
  ],
  [
    [118.414068181449, 24.7284535174014, 0.000916426070034504],
    [118.41357618283, 24.7290189214958, 0.000916497781872749],
  ],
  [
    [118.414052706818, 24.7284422843954, 0.000916427001357079],
    [118.413560708169, 24.7290076794121, 0.000916496850550175],
  ],
  [
    [118.41403723219, 24.7284310513877, 0.00091642327606678],
    [118.413545233515, 24.7289964463546, 0.000916494987905025],
  ],
  [
    [118.414021757565, 24.7284198183785, 0.00091642327606678],
    [118.41352974898, 24.7289852132997, 0.000916494056582451],
  ],
  [
    [118.414006282943, 24.7284085853676, 0.000916420482099056],
    [118.413514274331, 24.728973980239, 0.000916491262614727],
  ],
  [
    [118.413990808323, 24.7283973523551, 0.000916420482099056],
    [118.413498799685, 24.7289627471766, 0.000916490331292152],
  ],
  [
    [118.413975323822, 24.7283861193453, 0.000916419550776482],
    [118.413483325043, 24.7289515141126, 0.000916489399969578],
  ],
  [
    [118.413959849203, 24.7283748773017, 0.000916415825486183],
    [118.413467850402, 24.728940281047, 0.000916487537324429],
  ],
  [
    [118.413944374592, 24.7283636442844, 0.000916413962841034],
    [118.413452375765, 24.7289290479798, 0.000916486606001854],
  ],
  [
    [118.413928899983, 24.7283524112654, 0.000916413962841034],
    [118.413436901126, 24.7289178058832, 0.000916484743356705],
  ],
  [
    [118.413913425378, 24.7283411782449, 0.00091641116887331],
    [118.413421426494, 24.7289065728127, 0.00091648381203413],
  ],
  [
    [118.413897950775, 24.7283299452227, 0.000916412100195885],
    [118.413405941981, 24.7288953397448, 0.000916481949388981],
  ],
  [
    [118.413882476174, 24.7283187121988, 0.000916410237550735],
    [118.413390467355, 24.7288841066712, 0.000916482880711555],
  ],
  [
    [118.413867001577, 24.7283074791734, 0.000916409306228161],
    [118.413374992731, 24.7288728735958, 0.000916478224098682],
  ],
  [
    [118.413851517093, 24.7282962371227, 0.000916407443583012],
    [118.413359518111, 24.7288616405189, 0.000916478224098682],
  ],
  [
    [118.413836042502, 24.7282850040941, 0.000916405580937862],
    [118.413344043493, 24.7288504074404, 0.000916477292776108],
  ],
  [
    [118.413820567912, 24.7282737710638, 0.000916404649615288],
    [118.413328568873, 24.7288391653324, 0.000916474498808384],
  ],
  [
    [118.413805093326, 24.7282625380319, 0.000916402786970139],
    [118.413313094261, 24.7288279322506, 0.000916473567485809],
  ],
  [
    [118.413789618743, 24.7282513049983, 0.000916401855647564],
    [118.413297609767, 24.7288166991714, 0.000916472636163235],
  ],
  [
    [118.413774144162, 24.7282400719632, 0.000916399993002415],
    [118.41328213516, 24.7288054660864, 0.000916470773518085],
  ],
  [
    [118.413758669584, 24.7282288389264, 0.000916397199034691],
    [118.413266660556, 24.7287942329997, 0.000916467979550362],
  ],
  [
    [118.413743195009, 24.728217605888, 0.000916395336389542],
    [118.413251185955, 24.7287829999114, 0.000916467979550362],
  ],
  [
    [118.413727710547, 24.7282063638244, 0.000916397199034691],
    [118.413235711357, 24.7287717668216, 0.000916467048227787],
  ],
  [
    [118.413712235978, 24.7281951307828, 0.000916393473744392],
    [118.413220236761, 24.7287605337301, 0.000916465185582638],
  ],
  [
    [118.413696761411, 24.7281838977395, 0.000916393473744392],
    [118.413204762164, 24.7287492916091, 0.000916465185582638],
  ],
  [
    [118.413681286847, 24.7281726646946, 0.000916392542421818],
    [118.413189287574, 24.7287380585144, 0.000916463322937489],
  ],
  [
    [118.413665812286, 24.7281614316482, 0.000916388817131519],
    [118.413173803102, 24.7287268254222, 0.00091645959764719],
  ],
  [
    [118.413650337727, 24.7281501986, 0.00091638695448637],
    [118.413158328517, 24.7287155923242, 0.000916460528969765],
  ],
  [
    [118.413634863171, 24.7281389655503, 0.000916389748454094],
    [118.413142853936, 24.7287043592246, 0.000916458666324615],
  ],
  [
    [118.41361937873, 24.7281277234754, 0.000916387885808945],
    [118.413127379357, 24.7286931261234, 0.000916456803679466],
  ],
  [
    [118.413603904179, 24.7281164904224, 0.000916384160518646],
    [118.413111904781, 24.7286818930206, 0.000916454009711742],
  ],
  [
    [118.413588429632, 24.7281052573678, 0.000916384160518646],
    [118.413096430203, 24.7286706508883, 0.000916454941034317],
  ],
  [
    [118.413572955087, 24.7280940243116, 0.000916381366550922],
    [118.413080955632, 24.7286594177822, 0.000916454009711742],
  ],
  [
    [118.413557480545, 24.7280827912538, 0.000916379503905773],
    [118.413065481064, 24.7286481846745, 0.000916452147066593],
  ],
  [
    [118.413542006006, 24.7280715581943, 0.000916377641260624],
    [118.413049996615, 24.7286369515693, 0.000916449353098869],
  ],
  [
    [118.41352653147, 24.7280603251333, 0.000916377641260624],
    [118.413034522052, 24.7286257184584, 0.00091644749045372],
  ],
  [
    [118.413511056932, 24.7280490830428, 0.000916375778615475],
    [118.413019047493, 24.7286144853459, 0.000916446559131145],
  ],
  [
    [118.413495572517, 24.7280378499827, 0.0009163748472929],
    [118.413003572936, 24.7286032522317, 0.000916446559131145],
  ],
  [
    [118.413480097989, 24.7280266169167, 0.000916373915970325],
    [118.412988098378, 24.7285920100881, 0.000916445627808571],
  ],
  [
    [118.413464623464, 24.7280153838492, 0.000916371122002602],
    [118.412972623826, 24.7285807769707, 0.000916443765163422],
  ],
  [
    [118.413449148941, 24.72800415078, 0.000916371122002602],
    [118.412957149278, 24.7285695438516, 0.000916440971195698],
  ],
  [
    [118.413433674422, 24.7279929177092, 0.000916369259357452],
    [118.412941664848, 24.7285583107351, 0.000916439108550549],
  ],
  [
    [118.413418199905, 24.7279816846368, 0.000916367396712303],
    [118.412926190305, 24.7285470776129, 0.000916438177227974],
  ],
  [
    [118.413402725391, 24.7279704515628, 0.000916364602744579],
    [118.412910715765, 24.728535844489, 0.000916437245905399],
  ],
  [
    [118.413387240991, 24.7279592094636, 0.000916364602744579],
    [118.412895241228, 24.7285246113635, 0.000916437245905399],
  ],
  [
    [118.413371766482, 24.7279479763863, 0.000916363671422005],
    [118.412879766693, 24.7285133782363, 0.00091643538326025],
  ],
  [
    [118.413356291976, 24.7279367433074, 0.000916361808776855],
    [118.412864292157, 24.7285021360798, 0.000916432589292526],
  ],
  [
    [118.413340817473, 24.7279255102269, 0.000916360877454281],
    [118.412848817628, 24.7284909029494, 0.000916430726647377],
  ],
  [
    [118.413325342973, 24.7279142771448, 0.000916360877454281],
    [118.412833343102, 24.7284796698174, 0.000916430726647377],
  ],
  [
    [118.413309868476, 24.7279030440611, 0.000916356220841408],
    [118.412817858694, 24.728468436688, 0.000916427001357079],
  ],
  [
    [118.413294393981, 24.7278918109757, 0.000916356220841408],
    [118.412802384174, 24.7284572035527, 0.000916427932679653],
  ],
  [
    [118.413278919485, 24.727880568861, 0.000916354358196259],
    [118.412786909656, 24.7284459704159, 0.000916426070034504],
  ],
  [
    [118.413263435111, 24.7278693357765, 0.000916353426873684],
    [118.412771435141, 24.7284347372774, 0.000916425138711929],
  ],
  [
    [118.413247960625, 24.7278581026863, 0.000916353426873684],
    [118.412755960624, 24.7284234951096, 0.000916424207389355],
  ],
  [
    [118.413232486142, 24.7278468695945, 0.00091635063290596],
    [118.412740486114, 24.7284122619678, 0.000916422344744205],
  ],
  [
    [118.413217011661, 24.727835636501, 0.000916349701583385],
    [118.412725011607, 24.7284010288245, 0.000916421413421631],
  ],
  [
    [118.413201537183, 24.727824403406, 0.000916347838938236],
    [118.412709527219, 24.7283897956837, 0.000916419550776482],
  ],
  [
    [118.413186062708, 24.7278131703093, 0.000916345976293087],
    [118.412694052718, 24.7283785625371, 0.000916417688131332],
  ],
  [
    [118.413170588231, 24.7278019281832, 0.000916345044970512],
    [118.41267857822, 24.728367329389, 0.000916416756808758],
  ],
  [
    [118.413155103877, 24.7277906950874, 0.000916344113647938],
    [118.412663103724, 24.7283560962392, 0.000916414894163609],
  ],
  [
    [118.41313962941, 24.7277794619859, 0.000916341319680214],
    [118.412647629231, 24.7283448630878, 0.00091641116887331],
  ],
  [
    [118.413124154946, 24.7277682288827, 0.000916340388357639],
    [118.412632154737, 24.7283336209069, 0.000916412100195885],
  ],
  [
    [118.413108680485, 24.7277569957779, 0.000916339457035065],
    [118.412616680249, 24.7283223877523, 0.000916410237550735],
  ],
  [
    [118.413093206026, 24.7277457626715, 0.000916337594389915],
    [118.412601205765, 24.728311154596, 0.000916407443583012],
  ],
  [
    [118.41307773157, 24.7277345295635, 0.000916336663067341],
    [118.412585721399, 24.7282999214422, 0.000916407443583012],
  ],
  [
    [118.413062257117, 24.7277232964538, 0.000916335731744766],
    [118.41257024692, 24.7282886882827, 0.000916406512260437],
  ],
  [
    [118.413046782663, 24.7277120543148, 0.000916333869099617],
    [118.412554772444, 24.7282774551216, 0.000916404649615288],
  ],
  [
    [118.413031298331, 24.727700821206, 0.000916332006454468],
    [118.41253929797, 24.7282662219588, 0.000916403718292713],
  ],
  [
    [118.413015823886, 24.7276895880915, 0.000916331075131893],
    [118.412523823495, 24.7282549797666, 0.000916402786970139],
  ],
  [
    [118.413000349445, 24.7276783549754, 0.000916331075131893],
    [118.412508349027, 24.7282437466006, 0.000916400924324989],
  ],
  [
    [118.412984875005, 24.7276671218577, 0.000916328281164169],
    [118.412492874562, 24.728232513433, 0.000916398130357265],
  ],
  [
    [118.412969400569, 24.7276558887383, 0.000916328281164169],
    [118.412477390215, 24.7282212802679, 0.000916397199034691],
  ],
  [
    [118.412953926136, 24.7276446556173, 0.000916325487196445],
    [118.412461915756, 24.7282100470971, 0.000916397199034691],
  ],
  [
    [118.4129384517, 24.7276334134669, 0.000916322693228722],
    [118.412446441299, 24.7281988139246, 0.000916394405066967],
  ],
  [
    [118.412922977272, 24.7276221803427, 0.000916320830583572],
    [118.412430966845, 24.7281875807505, 0.000916394405066967],
  ],
  [
    [118.412907492963, 24.727610947221, 0.000916321761906147],
    [118.41241549239, 24.728176338547, 0.000916392542421818],
  ],
  [
    [118.412892077868, 24.7275997592077, 0.000916320830583572],
    [118.412399958618, 24.7281650692832, 0.000916390679776669],
  ],
  [
    [118.412876682545, 24.7275885711845, 0.000916318967938423],
    [118.412384414951, 24.7281537729383, 0.000916389748454094],
  ],
  [
    [118.412861287224, 24.7275773831597, 0.000916316173970699],
    [118.412368871287, 24.7281424765919, 0.000916386023163795],
  ],
  [
    [118.412845891902, 24.7275661861055, 0.000916316173970699],
    [118.41235333751, 24.7281311802398, 0.000916386023163795],
  ],
  [
    [118.412830496582, 24.7275549890497, 0.00091631431132555],
    [118.412337793847, 24.7281198748623, 0.000916385091841221],
  ],
  [
    [118.41281511115, 24.7275437919881, 0.000916312448680401],
    [118.412322260071, 24.728108569479, 0.000916383229196072],
  ],
  [
    [118.41279972572, 24.727532594925, 0.000916312448680401],
    [118.412306736182, 24.7280972640901, 0.000916382297873497],
  ],
  [
    [118.412784350172, 24.7275213888283, 0.000916310586035252],
    [118.412291202407, 24.7280859496758, 0.000916381366550922],
  ],
  [
    [118.412768964739, 24.7275101737063, 0.000916307792067528],
    [118.41227567852, 24.7280746352557, 0.000916379503905773],
  ],
  [
    [118.412753589197, 24.7274989676064, 0.000916307792067528],
    [118.412260164519, 24.7280633208299, 0.000916377641260624],
  ],
  [
    [118.412738223537, 24.727487752473, 0.000916304066777229],
    [118.412244640632, 24.7280519973788, 0.000916376709938049],
  ],
  [
    [118.412722847991, 24.7274765283143, 0.000916303135454655],
    [118.412229126633, 24.728040673922, 0.000916373915970325],
  ],
  [
    [118.412707482337, 24.7274653131776, 0.00091630220413208],
    [118.412213612632, 24.7280293414358, 0.000916372984647751],
  ],
  [
    [118.412692116677, 24.7274540799838, 0.00091630220413208],
    [118.412198098633, 24.7280180089479, 0.000916371122002602],
  ],
  [
    [118.412676760908, 24.727442855812, 0.000916300341486931],
    [118.412182594522, 24.7280066764543, 0.000916370190680027],
  ],
  [
    [118.412661395253, 24.727431622615, 0.000916298478841782],
    [118.412167090409, 24.7279953349312, 0.000916370190680027],
  ],
  [
    [118.412646039485, 24.7274203894122, 0.000916298478841782],
    [118.412151586299, 24.7279839934066, 0.000916367396712303],
  ],
  [
    [118.4126306936, 24.727409147176, 0.000916295684874058],
    [118.412136092075, 24.7279726518762, 0.000916366465389729],
  ],
  [
    [118.412615337833, 24.7273979049422, 0.000916295684874058],
    [118.41212059785, 24.7279613013163, 0.000916364602744579],
  ],
  [
    [118.412599991953, 24.7273866627027, 0.000916293822228909],
    [118.412105103628, 24.7279499507549, 0.00091636274009943],
  ],
  [
    [118.412584646071, 24.7273754114339, 0.000916292890906334],
    [118.412089619289, 24.7279385911599, 0.000916361808776855],
  ],
  [
    [118.412569310076, 24.7273641601593, 0.000916289165616035],
    [118.412074125072, 24.7279272405953, 0.000916360877454281],
  ],
  [
    [118.412553974084, 24.7273529088831, 0.000916288234293461],
    [118.412058650618, 24.7279158719652, 0.000916359014809132],
  ],
  [
    [118.41253863809, 24.7273416485776, 0.000916287302970886],
    [118.412043166287, 24.7279045123653, 0.000916358083486557],
  ],
  [
    [118.412523302099, 24.7273303882704, 0.000916285440325737],
    [118.412027691839, 24.727893143732, 0.000916357152163982],
  ],
  [
    [118.41250797599, 24.7273191189297, 0.000916284509003162],
    [118.412012217388, 24.7278817660692, 0.000916354358196259],
  ],
  [
    [118.412492649885, 24.7273078495875, 0.000916283577680588],
    [118.411996742946, 24.7278703974327, 0.000916354358196259],
  ],
  [
    [118.412477323781, 24.7272965802436, 0.000916281715035439],
    [118.411981268501, 24.7278590197667, 0.000916352495551109],
  ],
  [
    [118.412462007561, 24.7272853018663, 0.000916279852390289],
    [118.411965803939, 24.7278476330672, 0.000916349701583385],
  ],
  [
    [118.412446681459, 24.7272740234915, 0.000916278921067715],
    [118.41195033938, 24.727836246366, 0.000916349701583385],
  ],
  [
    [118.412431365243, 24.7272627451109, 0.000916277058422565],
    [118.411934884708, 24.7278248596592, 0.000916348770260811],
  ],
  [
    [118.412416058911, 24.7272514576969, 0.000916275195777416],
    [118.411919430034, 24.727813463923, 0.000916345976293087],
  ],
  [
    [118.412400752581, 24.7272401702813, 0.000916274264454842],
    [118.411903975367, 24.7278020772129, 0.000916344113647938],
  ],
  [
    [118.412385446254, 24.7272288828641, 0.000916272401809692],
    [118.411888520695, 24.7277906724456, 0.000916343182325363],
  ],
  [
    [118.412370139925, 24.7272175864175, 0.000916272401809692],
    [118.411873075913, 24.7277792767005, 0.000916341319680214],
  ],
  [
    [118.412354843483, 24.7272062899652, 0.000916269607841969],
    [118.411857631131, 24.7277678719259, 0.000916339457035065],
  ],
  [
    [118.412339537155, 24.7271949844876, 0.000916268676519394],
    [118.411842186346, 24.7277564581219, 0.00091633852571249],
  ],
  [
    [118.412324250598, 24.7271836790002, 0.000916268676519394],
    [118.411826751449, 24.7277450443122, 0.000916337594389915],
  ],
  [
    [118.412308954159, 24.7271723735154, 0.000916264951229095],
    [118.41181130667, 24.727733630505, 0.000916337594389915],
  ],
  [
    [118.412293667604, 24.7271610589971, 0.000916264019906521],
    [118.411795871778, 24.727722216692, 0.000916335731744766],
  ],
  [
    [118.412278381051, 24.7271497444771, 0.000916263088583946],
    [118.411780446769, 24.7277107938457, 0.000916334800422192],
  ],
  [
    [118.4122630945, 24.7271384299556, 0.000916262157261372],
    [118.411765021762, 24.7276993709976, 0.000916331075131893],
  ],
  [
    [118.412247817832, 24.7271271064007, 0.000916261225938797],
    [118.411749596754, 24.7276879391202, 0.000916331075131893],
  ],
  [
    [118.412232541167, 24.7271157828441, 0.000916259363293648],
    [118.411734171749, 24.7276765072412, 0.000916330143809319],
  ],
  [
    [118.412217264505, 24.727104459286, 0.000916258431971073],
    [118.411718756631, 24.7276650753565, 0.000916328281164169],
  ],
  [
    [118.412201997725, 24.7270931266943, 0.000916256569325924],
    [118.411703341511, 24.7276536344423, 0.000916324555873871],
  ],
  [
    [118.412186730948, 24.7270817941011, 0.000916254706680775],
    [118.411687926394, 24.7276421935266, 0.000916325487196445],
  ],
  [
    [118.412171464169, 24.7270704524786, 0.000916252844035625],
    [118.411672511275, 24.7276307435815, 0.000916323624551296],
  ],
  [
    [118.412156197393, 24.7270591108544, 0.000916251912713051],
    [118.411657106044, 24.7276192936307, 0.000916321761906147],
  ],
  [
    [118.412140940504, 24.7270477692246, 0.000916250050067902],
    [118.411641700815, 24.7276078436782, 0.000916319899260998],
  ],
  [
    [118.412125683613, 24.7270364185654, 0.000916249118745327],
    [118.411626305473, 24.7275963937202, 0.000916319899260998],
  ],
  [
    [118.412110436609, 24.7270250679005, 0.000916248187422752],
    [118.411610910129, 24.7275849347327, 0.000916318036615849],
  ],
  [
    [118.412095179724, 24.7270137172381, 0.000916247256100178],
    [118.411595514789, 24.7275734757436, 0.000916316173970699],
  ],
  [
    [118.412079932721, 24.7270023575423, 0.000916245393455029],
    [118.411580119447, 24.7275620077251, 0.000916316173970699],
  ],
  [
    [118.412064685721, 24.7269909978449, 0.000916242599487305],
    [118.411564733991, 24.7275505397009, 0.00091631431132555],
  ],
  [
    [118.412049448607, 24.7269796381418, 0.000916242599487305],
    [118.41154933865, 24.7275390626514, 0.000916312448680401],
  ],
  [
    [118.412034211492, 24.7269682694094, 0.000916240736842155],
    [118.411533963085, 24.72752759462, 0.000916312448680401],
  ],
  [
    [118.41201897438, 24.7269569006754, 0.000916239805519581],
    [118.411518577634, 24.7275161175632, 0.000916307792067528],
  ],
  [
    [118.412003737266, 24.726945522912, 0.000916237942874432],
    [118.411503202065, 24.727504631473, 0.000916306860744953],
  ],
  [
    [118.41198851004, 24.726934145143, 0.000916236080229282],
    [118.411487826499, 24.7274931453811, 0.000916305929422379],
  ],
  [
    [118.411973282815, 24.7269227673723, 0.000916235148906708],
    [118.41147246082, 24.7274816592837, 0.000916304998099804],
  ],
  [
    [118.411958055589, 24.7269113805724, 0.000916233286261559],
    [118.411457085256, 24.7274701641608, 0.000916304066777229],
  ],
  [
    [118.41194283825, 24.7268999937667, 0.000916231423616409],
    [118.411441719578, 24.7274586690323, 0.000916303135454655],
  ],
  [
    [118.411927620914, 24.7268886069595, 0.000916230492293835],
    [118.411426363788, 24.7274471738982, 0.000916300341486931],
  ],
  [
    [118.411912403576, 24.7268772111229, 0.000916227698326111],
    [118.411410998111, 24.7274356697387, 0.000916298478841782],
  ],
  [
    [118.411897196125, 24.7268658152807, 0.000916227698326111],
    [118.411395642322, 24.7274241655736, 0.000916296616196632],
  ],
  [
    [118.411881978793, 24.726854419441, 0.000916226767003536],
    [118.411380286535, 24.7274126614069, 0.000916295684874058],
  ],
  [
    [118.411866771343, 24.7268430145679, 0.000916223973035812],
    [118.411364940631, 24.7274011482067, 0.000916293822228909],
  ],
  [
    [118.41185157378, 24.7268316096891, 0.000916223041713238],
    [118.41134959473, 24.727389635005, 0.000916293822228909],
  ],
  [
    [118.411836376215, 24.7268201957809, 0.000916221179068089],
    [118.411334248827, 24.7273781127738, 0.000916291959583759],
  ],
  [
    [118.411821178653, 24.7268087818712, 0.000916221179068089],
    [118.411318902932, 24.7273665995689, 0.00091629009693861],
  ],
  [
    [118.411805981094, 24.7267973679599, 0.000916219316422939],
    [118.411303566914, 24.7273550683027, 0.000916289165616035],
  ],
  [
    [118.411790783533, 24.7267859450192, 0.00091621745377779],
    [118.411288230904, 24.7273435460627, 0.000916287302970886],
  ],
  [
    [118.411775595859, 24.7267745220729, 0.000916215591132641],
    [118.411272894893, 24.7273320147933, 0.000916285440325737],
  ],
  [
    [118.411760408188, 24.7267630991251, 0.000916214659810066],
    [118.411257568764, 24.7273204744905, 0.000916285440325737],
  ],
  [
    [118.4117452304, 24.7267516671438, 0.000916212797164917],
    [118.411242242642, 24.7273089432139, 0.000916283577680588],
  ],
  [
    [118.411730052614, 24.7267402351609, 0.000916210934519768],
    [118.411226916518, 24.7272974029079, 0.000916280783712864],
  ],
  [
    [118.41171487483, 24.7267288031765, 0.000916210003197193],
    [118.411211600277, 24.7272858535685, 0.000916278921067715],
  ],
  [
    [118.411699697046, 24.7267173621627, 0.000916209071874619],
    [118.411196284039, 24.7272743042275, 0.00091627798974514],
  ],
  [
    [118.411684529148, 24.7267059211434, 0.000916209071874619],
    [118.411180967804, 24.7272627548849, 0.00091627798974514],
  ],
  [
    [118.411669361248, 24.7266944710946, 0.000916206277906895],
    [118.411165651572, 24.7272512055408, 0.000916276127099991],
  ],
  [
    [118.411654193351, 24.7266830210443, 0.000916203483939171],
    [118.411150345222, 24.7272396471632, 0.000916276127099991],
  ],
  [
    [118.411639035341, 24.7266715709883, 0.000916201621294022],
    [118.41113503887, 24.7272280797562, 0.000916273333132267],
  ],
  [
    [118.41162387733, 24.7266601119031, 0.000916200689971447],
    [118.411119732526, 24.7272165213754, 0.000916271470487118],
  ],
  [
    [118.411608719321, 24.7266486528162, 0.000916201621294022],
    [118.411104436065, 24.7272049539612, 0.000916269607841969],
  ],
  [
    [118.411593561315, 24.7266371937278, 0.000916197896003723],
    [118.411089139601, 24.7271933775177, 0.000916268676519394],
  ],
  [
    [118.411578413191, 24.726625725606, 0.000916196033358574],
    [118.411073843145, 24.7271818101003, 0.000916266813874245],
  ],
  [
    [118.41156326507, 24.7266142574826, 0.000916196964681149],
    [118.411058556572, 24.7271702336496, 0.00091626588255167],
  ],
  [
    [118.411548116952, 24.7266027893577, 0.000916195102035999],
    [118.411043269997, 24.7271586481694, 0.000916264019906521],
  ],
  [
    [118.411532978717, 24.7265913121993, 0.000916192308068275],
    [118.411027983425, 24.7271470626877, 0.000916263088583946],
  ],
  [
    [118.411517840484, 24.7265798350394, 0.000916192308068275],
    [118.411012696856, 24.7271354772044, 0.000916261225938797],
  ],
  [
    [118.411502702249, 24.7265683488502, 0.000916190445423126],
    [118.410997420174, 24.7271238917154, 0.000916260294616222],
  ],
  [
    [118.411487573906, 24.7265568716831, 0.000916188582777977],
    [118.41098214349, 24.7271122971971, 0.000916258431971073],
  ],
  [
    [118.411472445557, 24.7265453764589, 0.000916188582777977],
    [118.410966876689, 24.7271006936454, 0.000916258431971073],
  ],
  [
    [118.411457317215, 24.726533890261, 0.000916185788810253],
    [118.41095160001, 24.727089099124, 0.000916256569325924],
  ],
  [
    [118.411442188871, 24.7265223950337, 0.000916184857487679],
    [118.410936333215, 24.7270774955691, 0.0009162537753582],
  ],
  [
    [118.411427070414, 24.7265108998008, 0.000916183926165104],
    [118.410921076302, 24.7270658829809, 0.000916252844035625],
  ],
  [
    [118.411411951956, 24.7264993955385, 0.000916182063519955],
    [118.410905809512, 24.7270542794229, 0.000916250050067902],
  ],
  [
    [118.411396843384, 24.7264878912707, 0.000916178338229656],
    [118.410890552605, 24.7270426668315, 0.000916250050067902],
  ],
  [
    [118.411381724931, 24.7264763870053, 0.000916177406907082],
    [118.410875295696, 24.7270310452107, 0.000916248187422752],
  ],
  [
    [118.411366616361, 24.7264648737066, 0.000916178338229656],
    [118.410860048674, 24.7270194235843, 0.000916246324777603],
  ],
  [
    [118.411351517677, 24.7264533604022, 0.000916176475584507],
    [118.410844801655, 24.7270078019563, 0.000916244462132454],
  ],
  [
    [118.411336409108, 24.7264418380726, 0.000916174612939358],
    [118.410829554634, 24.726996171299, 0.000916243530809879],
  ],
  [
    [118.411321310426, 24.7264303157374, 0.000916174612939358],
    [118.410814307621, 24.7269845496679, 0.000916242599487305],
  ],
  [
    [118.411306211746, 24.7264187934006, 0.000916169956326485],
    [118.410799070485, 24.7269729099756, 0.000916240736842155],
  ],
  [
    [118.411291122953, 24.7264072710583, 0.000916170887649059],
    [118.410783833357, 24.7269612793096, 0.000916239805519581],
  ],
  [
    [118.411276024275, 24.7263957396906, 0.00091616902500391],
    [118.410768596228, 24.7269496396142, 0.000916238874197006],
  ],
  [
    [118.411260945367, 24.7263842083133, 0.000916166231036186],
    [118.410753368981, 24.7269379908854, 0.000916235148906708],
  ],
  [
    [118.411245856574, 24.7263726679107, 0.000916166231036186],
    [118.410738141741, 24.7269263511828, 0.000916234217584133],
  ],
  [
    [118.411230777667, 24.7263611275026, 0.000916165299713612],
    [118.410722914496, 24.726914693423, 0.000916233286261559],
  ],
  [
    [118.411215698764, 24.7263495870929, 0.000916162505745888],
    [118.410707687257, 24.7269030446895, 0.000916233286261559],
  ],
  [
    [118.411200619859, 24.7263380376538, 0.000916161574423313],
    [118.410692469901, 24.7268913869226, 0.00091622956097126],
  ],
  [
    [118.411185540956, 24.7263264882132, 0.000916159711778164],
    [118.410677252548, 24.7268797291541, 0.000916228629648685],
  ],
  [
    [118.411170471936, 24.7263149297393, 0.000916157849133015],
    [118.410662045078, 24.7268680623523, 0.000916227698326111],
  ],
  [
    [118.411155412807, 24.7263033802875, 0.000916157849133015],
    [118.410646837615, 24.7268564045767, 0.000916225835680962],
  ],
  [
    [118.411140343789, 24.7262918127827, 0.000916155055165291],
    [118.410631630146, 24.726844728744, 0.000916224904358387],
  ],
  [
    [118.411125284661, 24.7262802543001, 0.000916154123842716],
    [118.410616422684, 24.7268330619374, 0.000916223041713238],
  ],
  [
    [118.411110225532, 24.7262686867882, 0.000916151329874992],
    [118.410601225104, 24.7268213860975, 0.000916222110390663],
  ],
  [
    [118.411095166406, 24.7262571192747, 0.000916151329874992],
    [118.410586027524, 24.7268097012283, 0.000916221179068089],
  ],
  [
    [118.411080117162, 24.7262455427278, 0.000916149467229843],
    [118.41057082995, 24.7267980253853, 0.00091621745377779],
  ],
  [
    [118.41106506792, 24.7262339661794, 0.000916149467229843],
    [118.410555642255, 24.7267863314811, 0.000916218385100365],
  ],
  [
    [118.411050018682, 24.7262223896295, 0.000916147604584694],
    [118.410540454566, 24.7267746466031, 0.000916216522455215],
  ],
  [
    [118.411034979326, 24.7262108040463, 0.000916145741939545],
    [118.410525266877, 24.7267629526958, 0.000916214659810066],
  ],
  [
    [118.411019939973, 24.7261992184615, 0.00091614481061697],
    [118.41051007919, 24.726751258787, 0.000916212797164917],
  ],
  [
    [118.411004900623, 24.7261876328751, 0.000916142947971821],
    [118.41049490139, 24.7267395648725, 0.000916211865842342],
  ],
  [
    [118.410989871155, 24.7261760382554, 0.000916140154004097],
    [118.410479723588, 24.7267278619287, 0.000916211865842342],
  ],
  [
    [118.410974831806, 24.7261644436382, 0.000916139222681522],
    [118.41046455567, 24.7267161499516, 0.000916210934519768],
  ],
  [
    [118.410959812228, 24.7261528490115, 0.000916139222681522],
    [118.410449377874, 24.7267044470047, 0.000916208140552044],
  ],
  [
    [118.410944782764, 24.7261412453594, 0.000916138291358948],
    [118.410434209961, 24.7266927350245, 0.000916206277906895],
  ],
  [
    [118.410929763187, 24.7261296417017, 0.000916134566068649],
    [118.41041905193, 24.7266810140109, 0.000916206277906895],
  ],
  [
    [118.410914743608, 24.7261180290148, 0.000916133634746075],
    [118.410403884023, 24.7266693020275, 0.000916203483939171],
  ],
  [
    [118.410899724037, 24.7261064253541, 0.000916130840778351],
    [118.410388725998, 24.7266575810108, 0.000916200689971447],
  ],
  [
    [118.410884714343, 24.7260948036322, 0.0009161327034235],
    [118.410373577855, 24.7266458509607, 0.000916201621294022],
  ],
  [
    [118.410869704657, 24.7260831909367, 0.000916129909455776],
    [118.410358419832, 24.7266341209131, 0.000916198827326298],
  ],
  [
    [118.410854694969, 24.7260715692118, 0.000916128046810627],
    [118.410343271695, 24.72662239086, 0.000916196964681149],
  ],
  [
    [118.410839695164, 24.7260599384535, 0.000916127115488052],
    [118.410328123562, 24.7266106608052, 0.000916196964681149],
  ],
  [
    [118.410824685482, 24.7260483167256, 0.000916125252842903],
    [118.41031298531, 24.7265989217172, 0.000916194170713425],
  ],
  [
    [118.410809695566, 24.7260366859603, 0.000916124321520329],
    [118.410297837178, 24.7265871826316, 0.00091619323939085],
  ],
  [
    [118.410794695765, 24.7260250461697, 0.000916121527552605],
    [118.410282698928, 24.7265754345126, 0.000916190445423126],
  ],
  [
    [118.410779705855, 24.7260134154014, 0.000916122458875179],
    [118.410267570565, 24.7265636863882, 0.000916189514100552],
  ],
  [
    [118.410764715943, 24.7260017756037, 0.000916119664907455],
    [118.410252442205, 24.7265519382621, 0.000916189514100552],
  ],
  [
    [118.41074972603, 24.7259901267767, 0.000916117802262306],
    [118.410237313844, 24.7265401811067, 0.000916185788810253],
  ],
  [
    [118.410734746003, 24.7259784779442, 0.000916115939617157],
    [118.410222185485, 24.7265284239498, 0.000916184857487679],
  ],
  [
    [118.41071976598, 24.7259668291102, 0.000916114076972008],
    [118.410207067013, 24.7265166667873, 0.000916182063519955],
  ],
  [
    [118.410704785959, 24.7259551802746, 0.000916113145649433],
    [118.41019194854, 24.7265049005955, 0.00091618113219738],
  ],
  [
    [118.41068981582, 24.7259435224058, 0.000916111283004284],
    [118.41017683007, 24.7264931344022, 0.00091618113219738],
  ],
  [
    [118.410674845685, 24.7259318645354, 0.000916110351681709],
    [118.410161711598, 24.7264813591795, 0.000916179269552231],
  ],
  [
    [118.410659875548, 24.7259201976356, 0.000916107557713985],
    [118.410146603017, 24.7264695929791, 0.000916178338229656],
  ],
  [
    [118.410644905413, 24.7259085307344, 0.000916107557713985],
    [118.410131494431, 24.7264578087215, 0.000916175544261932],
  ],
  [
    [118.410629945166, 24.7258968638277, 0.000916104763746262],
    [118.410116395736, 24.7264460334862, 0.000916174612939358],
  ],
  [
    [118.410614984917, 24.7258851878916, 0.000916105695068836],
    [118.410101297039, 24.7264342492216, 0.000916173681616783],
  ],
  [
    [118.410600034554, 24.72587351195, 0.000916103832423687],
    [118.410086198345, 24.7264224649554, 0.000916171818971634],
  ],
  [
    [118.410585074311, 24.7258618360109, 0.000916101969778538],
    [118.41007109965, 24.7264106716599, 0.000916170887649059],
  ],
  [
    [118.41057012395, 24.7258501510385, 0.000916101038455963],
    [118.410056010842, 24.7263988783589, 0.00091616902500391],
  ],
  [
    [118.410555183476, 24.7258384660605, 0.00091609638184309],
    [118.410040922036, 24.7263870850563, 0.000916168093681335],
  ],
  [
    [118.410540233116, 24.7258267720573, 0.00091609638184309],
    [118.410025833229, 24.7263752827244, 0.000916165299713612],
  ],
  [
    [118.410525292647, 24.7258150870764, 0.000916095450520515],
    [118.410010754309, 24.726363480387, 0.000916163437068462],
  ],
  [
    [118.410510362057, 24.7258033840343, 0.000916094519197941],
    [118.409995675388, 24.7263516690203, 0.000916163437068462],
  ],
  [
    [118.410495421589, 24.7257916900225, 0.000916093587875366],
    [118.409980596473, 24.7263398666798, 0.000916161574423313],
  ],
  [
    [118.410480491004, 24.7257799869774, 0.000916092656552792],
    [118.409965527442, 24.726328055306, 0.000916159711778164],
  ],
  [
    [118.410465560422, 24.7257682839309, 0.000916088931262493],
    [118.409950448524, 24.7263162349068, 0.000916157849133015],
  ],
  [
    [118.410450639723, 24.725756571851, 0.000916087068617344],
    [118.409935389378, 24.7263044144982, 0.000916157849133015],
  ],
  [
    [118.410435709142, 24.7257448597735, 0.000916087999939919],
    [118.409920320351, 24.726292594092, 0.000916155055165291],
  ],
  [
    [118.410420798332, 24.7257331476867, 0.000916085205972195],
    [118.409905261206, 24.7262807646525, 0.000916154123842716],
  ],
  [
    [118.410405877636, 24.7257214265744, 0.00091608427464962],
    [118.409890202064, 24.7262689352115, 0.000916153192520142],
  ],
  [
    [118.410390966827, 24.7257097054567, 0.000916082412004471],
    [118.409875142925, 24.7262571057689, 0.000916150398552418],
  ],
  [
    [118.410376056021, 24.7256979843375, 0.000916081480681896],
    [118.409860093668, 24.726245267293, 0.000916150398552418],
  ],
  [
    [118.410361145214, 24.725686254189, 0.000916079618036747],
    [118.409845044414, 24.7262334288156, 0.000916148535907269],
  ],
  [
    [118.410346244293, 24.725674524035, 0.000916077755391598],
    [118.409829995163, 24.7262215903367, 0.000916146673262119],
  ],
  [
    [118.410331333491, 24.7256627938834, 0.000916076824069023],
    [118.409814955795, 24.7262097428245, 0.000916146673262119],
  ],
  [
    [118.410316442456, 24.7256510546946, 0.000916074961423874],
    [118.40979991643, 24.7261978953108, 0.000916143879294395],
  ],
  [
    [118.410301541539, 24.7256393155083, 0.000916074030101299],
    [118.409784877067, 24.7261860477955, 0.000916142016649246],
  ],
  [
    [118.410286650505, 24.7256275672887, 0.000916071236133575],
    [118.409769847587, 24.726174191247, 0.000916140154004097],
  ],
  [
    [118.410271759478, 24.7256158280954, 0.000916071236133575],
    [118.40975481811, 24.7261623346969, 0.000916140154004097],
  ],
  [
    [118.410256878329, 24.725604070841, 0.000916068442165852],
    [118.409739788632, 24.7261504691175, 0.000916137360036373],
  ],
  [
    [118.410241987303, 24.7255923226168, 0.000916067510843277],
    [118.409724759156, 24.7261386035365, 0.000916136428713799],
  ],
  [
    [118.410227116044, 24.7255805653555, 0.000916066579520702],
    [118.409709739567, 24.7261267379501, 0.000916135497391224],
  ],
  [
    [118.410212234903, 24.7255688080966, 0.000916063785552979],
    [118.409694719977, 24.7261148633344, 0.0009161327034235],
  ],
  [
    [118.410197363645, 24.7255570418044, 0.000916063785552979],
    [118.409679710274, 24.7261029887132, 0.000916131772100925],
  ],
  [
    [118.41018249239, 24.7255452755107, 0.000916060991585255],
    [118.409664700573, 24.7260911140904, 0.000916129909455776],
  ],
  [
    [118.410167621138, 24.7255335092156, 0.00091606006026268],
    [118.409649690871, 24.7260792304384, 0.000916129909455776],
  ],
  [
    [118.410152749884, 24.7255217338911, 0.000916059128940105],
    [118.409634681172, 24.7260673467848, 0.000916127115488052],
  ],
  [
    [118.410137888516, 24.7255099585612, 0.000916057266294956],
    [118.40961968136, 24.7260554631257, 0.000916127115488052],
  ],
  [
    [118.410123037036, 24.7254981832258, 0.000916055403649807],
    [118.409604681546, 24.7260435704373, 0.000916124321520329],
  ],
  [
    [118.41010817567, 24.725486398865, 0.000916054472327232],
    [118.409589681736, 24.7260316777474, 0.000916121527552605],
  ],
  [
    [118.410093324191, 24.7254746144988, 0.000916052609682083],
    [118.409574691812, 24.7260197850521, 0.000916121527552605],
  ],
  [
    [118.410078472711, 24.7254628211034, 0.000916049815714359],
    [118.409559701887, 24.7260078833274, 0.00091612059623003],
  ],
  [
    [118.410063631121, 24.7254510367302, 0.000916048884391785],
    [118.409544711964, 24.7259959816012, 0.000916117802262306],
  ],
  [
    [118.410048779642, 24.7254392343039, 0.00091604795306921],
    [118.40952972204, 24.7259840708457, 0.000916116870939732],
  ],
  [
    [118.410033938054, 24.7254274409, 0.000916047021746635],
    [118.409514742003, 24.7259721600847, 0.000916115008294582],
  ],
  [
    [118.410019106348, 24.7254156384628, 0.000916045159101486],
    [118.409499761969, 24.7259602493222, 0.000916113145649433],
  ],
  [
    [118.410004264761, 24.7254038360281, 0.000916044227778912],
    [118.409484791818, 24.7259483295264, 0.000916112214326859],
  ],
  [
    [118.409989433057, 24.7253920245601, 0.000916043296456337],
    [118.409469821669, 24.7259364097292, 0.000916109420359135],
  ],
  [
    [118.409974611239, 24.7253802130867, 0.000916041433811188],
    [118.409454851524, 24.7259244899304, 0.000916109420359135],
  ],
  [
    [118.40995977954, 24.7253684016157, 0.000916039571166039],
    [118.409439881376, 24.7259125611023, 0.00091610848903656],
  ],
  [
    [118.409944957724, 24.7253565811115, 0.000916037708520889],
    [118.409424921116, 24.7259006322687, 0.000916107557713985],
  ],
  [
    [118.409930145794, 24.7253447606019, 0.000916036777198315],
    [118.409409960859, 24.7258887034337, 0.000916104763746262],
  ],
  [
    [118.409915323984, 24.7253329400947, 0.000916034914553165],
    [118.4093950006, 24.7258767655693, 0.000916104763746262],
  ],
  [
    [118.409900512055, 24.7253211105543, 0.000916033051908016],
    [118.409380050228, 24.7258648276995, 0.000916101038455963],
  ],
  [
    [118.40988570013, 24.7253092810124, 0.000916030257940292],
    [118.409365099859, 24.7258528898281, 0.000916100107133389],
  ],
  [
    [118.409870898091, 24.725297451465, 0.000916031189262867],
    [118.409350149488, 24.7258409429275, 0.000916099175810814],
  ],
  [
    [118.409856086167, 24.7252856128923, 0.000916028395295143],
    [118.409335209005, 24.7258289960214, 0.000916098244488239],
  ],
  [
    [118.40984128413, 24.7252737743142, 0.000916027463972569],
    [118.40932026852, 24.725817040086, 0.00091609638184309],
  ],
  [
    [118.409826491979, 24.7252619357307, 0.000916024670004845],
    [118.409305328038, 24.7258050841491, 0.000916095450520515],
  ],
  [
    [118.409811699827, 24.7252500881178, 0.000916024670004845],
    [118.409290387558, 24.7257931282107, 0.000916091725230217],
  ],
  [
    [118.409796907678, 24.7252382405035, 0.00091602373868227],
    [118.409275456962, 24.7257811632391, 0.000916091725230217],
  ],
  [
    [118.409782115527, 24.7252263838599, 0.000916021876037121],
    [118.409260526368, 24.7257691982659, 0.000916090793907642],
  ],
  [
    [118.409767323379, 24.7252145272148, 0.000916020013391972],
    [118.409245605661, 24.7257572332873, 0.000916087999939919],
  ],
  [
    [118.409752541118, 24.7252026705643, 0.000916019082069397],
    [118.409230684953, 24.7257452592794, 0.000916087068617344],
  ],
  [
    [118.40973776874, 24.7251908048805, 0.000916018150746822],
    [118.409215764247, 24.72573328527, 0.000916085205972195],
  ],
  [
    [118.409722986484, 24.7251789482271, 0.000916016288101673],
    [118.409200843544, 24.7257213112591, 0.00091608427464962],
  ],
  [
    [118.409708214107, 24.7251670735126, 0.000916014425456524],
    [118.409185932724, 24.725709328215, 0.000916082412004471],
  ],
  [
    [118.409693441737, 24.7251552078244, 0.0009160116314888],
    [118.409171021907, 24.7256973451694, 0.000916080549359322],
  ],
  [
    [118.409678679249, 24.725143333103, 0.0009160116314888],
    [118.409156111093, 24.7256853621222, 0.000916079618036747],
  ],
  [
    [118.40966391676, 24.7251314493523, 0.000916010700166225],
    [118.409141210161, 24.7256733700419, 0.000916077755391598],
  ],
  [
    [118.409649154278, 24.725119574628, 0.000916007906198502],
    [118.409126309233, 24.7256613779601, 0.000916077755391598],
  ],
  [
    [118.409634391794, 24.7251076908743, 0.000916006974875927],
    [118.409111408302, 24.7256493768489, 0.000916074030101299],
  ],
  [
    [118.409619639193, 24.7250957980875, 0.000916006043553352],
    [118.409096517259, 24.7256373757323, 0.000916074030101299],
  ],
  [
    [118.409604886595, 24.7250839052992, 0.000916004180908203],
    [118.409081626219, 24.7256253746143, 0.00091607216745615],
  ],
  [
    [118.409590133999, 24.7250720125093, 0.000916002318263054],
    [118.409066735181, 24.7256133734947, 0.000916071236133575],
  ],
  [
    [118.40957539129, 24.7250601197141, 0.000916000455617905],
    [118.409051844142, 24.7256013633458, 0.000916068442165852],
  ],
  [
    [118.40956064858, 24.7250482178897, 0.00091599952429533],
    [118.409036962986, 24.7255893441637, 0.000916066579520702],
  ],
  [
    [118.409545905873, 24.7250363160637, 0.000915997661650181],
    [118.409022081836, 24.725577334008, 0.000916064716875553],
  ],
  [
    [118.409531173052, 24.7250244142323, 0.000915995799005032],
    [118.40900721057, 24.725565314819, 0.000916063785552979],
  ],
  [
    [118.40951644023, 24.7250125033717, 0.000915995799005032],
    [118.408992339302, 24.7255532866007, 0.000916063785552979],
  ],
  [
    [118.409501707406, 24.7250005834818, 0.000915993005037308],
    [118.408977468041, 24.7255412674088, 0.000916061922907829],
  ],
  [
    [118.40948697459, 24.7249886726182, 0.000915993005037308],
    [118.408962596779, 24.7255292391875, 0.000916059128940105],
  ],
  [
    [118.409472251656, 24.7249767527215, 0.000915991142392159],
    [118.408947735399, 24.725517201933, 0.000916058197617531],
  ],
  [
    [118.409457528725, 24.7249648328232, 0.000915988348424435],
    [118.408932874022, 24.725505164677, 0.000916057266294956],
  ],
  [
    [118.409442815676, 24.7249529038918, 0.00091598741710186],
    [118.408918012648, 24.7254931274196, 0.000916054472327232],
  ],
  [
    [118.40942810263, 24.7249409749589, 0.000915985554456711],
    [118.408903161161, 24.7254810901567, 0.000916054472327232],
  ],
  [
    [118.409413389587, 24.7249290460245, 0.000915983691811562],
    [118.408888309673, 24.7254690438646, 0.000916052609682083],
  ],
  [
    [118.409398676543, 24.7249171080608, 0.000915982760488987],
    [118.408873458187, 24.725456997571, 0.000916050747036934],
  ],
  [
    [118.409383973385, 24.7249051700918, 0.000915981829166412],
    [118.408858616584, 24.7254449422441, 0.00091604795306921],
  ],
  [
    [118.40936927023, 24.7248932321213, 0.000915979966521263],
    [118.408843774984, 24.7254328869158, 0.000916047021746635],
  ],
  [
    [118.409354567074, 24.7248812851216, 0.000915979035198689],
    [118.408828933387, 24.725420831586, 0.000916046090424061],
  ],
  [
    [118.409339873804, 24.7248693381164, 0.000915976241230965],
    [118.408814101677, 24.7254087762509, 0.000916044227778912],
  ],
  [
    [118.409325180537, 24.7248573911098, 0.00091597530990839],
    [118.408799269965, 24.7253967118864, 0.000916042365133762],
  ],
  [
    [118.409310487269, 24.7248454350739, 0.000915974378585815],
    [118.408784438252, 24.7253846384926, 0.000916041433811188],
  ],
  [
    [118.409295803887, 24.7248334790327, 0.000915972515940666],
    [118.408769606546, 24.7253725741251, 0.000916041433811188],
  ],
  [
    [118.409281120504, 24.7248215139621, 0.000915971584618092],
    [118.408754784723, 24.7253605007245, 0.000916037708520889],
  ],
  [
    [118.409266437128, 24.724809557918, 0.000915970653295517],
    [118.408739962898, 24.7253484182946, 0.000916038639843464],
  ],
  [
    [118.409251753747, 24.7247975838167, 0.000915967859327793],
    [118.408725150964, 24.7253363448871, 0.000916036777198315],
  ],
  [
    [118.409237080256, 24.7247856187379, 0.000915965996682644],
    [118.408710329141, 24.7253242534264, 0.000916034914553165],
  ],
  [
    [118.409222406764, 24.7247736446298, 0.000915966928005219],
    [118.408695527093, 24.7253121709843, 0.000916031189262867],
  ],
  [
    [118.409207743159, 24.7247616705164, 0.00091596320271492],
    [118.40868071516, 24.7253000795167, 0.000916032120585442],
  ],
  [
    [118.409193069668, 24.7247496873776, 0.000915961340069771],
    [118.408665913113, 24.7252879880438, 0.000916030257940292],
  ],
  [
    [118.409178415948, 24.7247377042295, 0.000915962271392345],
    [118.408651111069, 24.7252758965694, 0.000916029326617718],
  ],
  [
    [118.409163752347, 24.7247257210839, 0.000915959477424622],
    [118.408636309024, 24.7252637960657, 0.000916026532649994],
  ],
  [
    [118.409149098629, 24.7247137289051, 0.000915956683456898],
    [118.408621516866, 24.7252516955567, 0.000916024670004845],
  ],
  [
    [118.409134444917, 24.7247017457527, 0.000915955752134323],
    [118.408606724706, 24.7252395860184, 0.000916024670004845],
  ],
  [
    [118.4091197912, 24.7246897445432, 0.000915954820811749],
    [118.408591932549, 24.7252274764786, 0.000916022807359695],
  ],
  [
    [118.409105147374, 24.7246777523561, 0.000915952026844025],
    [118.40857715028, 24.7252153669334, 0.000916020013391972],
  ],
  [
    [118.409090503546, 24.7246657511398, 0.000915952026844025],
    [118.408562368008, 24.725203248359, 0.000916020013391972],
  ],
  [
    [118.409075859717, 24.7246537408942, 0.000915949232876301],
    [118.40854758574, 24.725191129783, 0.000916017219424248],
  ],
  [
    [118.409061225779, 24.7246417396711, 0.000915949232876301],
    [118.408532803474, 24.7251790112056, 0.000916017219424248],
  ],
  [
    [118.409046581951, 24.7246297203948, 0.000915945507586002],
    [118.408518031092, 24.7251668835951, 0.000916015356779099],
  ],
  [
    [118.409031957898, 24.7246177101371, 0.000915945507586002],
    [118.408503258712, 24.725154755983, 0.0009160116314888],
  ],
  [
    [118.40901732396, 24.724605690854, 0.000915945507586002],
    [118.408488496218, 24.7251426283657, 0.0009160116314888],
  ],
  [
    [118.409002699909, 24.7245936715656, 0.000915941782295704],
    [118.408473733724, 24.725130491719, 0.000916009768843651],
  ],
  [
    [118.40898807586, 24.7245816522757, 0.000915940850973129],
    [118.408458971232, 24.7251183550709, 0.000916007906198502],
  ],
  [
    [118.408973461694, 24.7245696239527, 0.000915940850973129],
    [118.408444208744, 24.7251062184213, 0.000916007906198502],
  ],
  [
    [118.408958837647, 24.7245575956321, 0.000915936194360256],
    [118.408429456137, 24.7250940727385, 0.000916006043553352],
  ],
  [
    [118.408944233366, 24.7245455582745, 0.000915936194360256],
    [118.408414703534, 24.7250819270543, 0.000916003249585629],
  ],
  [
    [118.408929619208, 24.7245335299471, 0.000915935263037682],
    [118.408399960814, 24.725069772337, 0.000916002318263054],
  ],
  [
    [118.408915014929, 24.7245214835588, 0.000915933400392532],
    [118.408385208216, 24.7250576266498, 0.00091599952429533],
  ],
  [
    [118.408900410657, 24.7245094461969, 0.000915932469069958],
    [118.408370475381, 24.7250454628978, 0.000915998592972755],
  ],
  [
    [118.408885806383, 24.7244973998057, 0.000915929675102234],
    [118.408355732669, 24.7250333081761, 0.000915997661650181],
  ],
  [
    [118.408871211996, 24.7244853534091, 0.000915929675102234],
    [118.40834099984, 24.7250211444211, 0.000915995799005032],
  ],
  [
    [118.408856617607, 24.7244732979833, 0.00091592688113451],
    [118.408326267013, 24.7250089806648, 0.000915993005037308],
  ],
  [
    [118.408842023222, 24.7244612425561, 0.000915925949811935],
    [118.408311534185, 24.7249968078791, 0.000915993005037308],
  ],
  [
    [118.408827438723, 24.7244491871236, 0.000915924087166786],
    [118.408296811244, 24.7249846350882, 0.000915992073714733],
  ],
  [
    [118.408812854223, 24.7244371226618, 0.000915921293199062],
    [118.408282088306, 24.7249724622957, 0.000915990211069584],
  ],
  [
    [118.408798269725, 24.7244250581985, 0.000915921293199062],
    [118.408267365367, 24.724960280474, 0.000915988348424435],
  ],
  [
    [118.40878368523, 24.7244129937338, 0.000915919430553913],
    [118.40825264243, 24.7249480986508, 0.00091598741710186],
  ],
  [
    [118.408769110618, 24.724400920236, 0.000915918499231339],
    [118.40823792938, 24.7249359168223, 0.000915985554456711],
  ],
  [
    [118.408754536009, 24.7243888467368, 0.000915916636586189],
    [118.408223226213, 24.7249237259607, 0.000915983691811562],
  ],
  [
    [118.408739971286, 24.7243767732322, 0.000915915705263615],
    [118.408208513165, 24.7249115351015, 0.000915981829166412],
  ],
  [
    [118.408725406562, 24.7243646906984, 0.000915913842618465],
    [118.408193810004, 24.7248993442369, 0.000915980897843838],
  ],
  [
    [118.408710841841, 24.7243526081631, 0.000915911979973316],
    [118.408179106841, 24.7248871443431, 0.000915979035198689],
  ],
  [
    [118.408696277123, 24.7243405256264, 0.000915911979973316],
    [118.408164413565, 24.724874944444, 0.000915979035198689],
  ],
  [
    [118.408681722287, 24.7243284340566, 0.000915910117328167],
    [118.408149710408, 24.7248627445472, 0.000915976241230965],
  ],
  [
    [118.408667167454, 24.7243163424854, 0.000915909186005592],
    [118.408135027018, 24.7248505356135, 0.00091597530990839],
  ],
  [
    [118.408652622507, 24.7243042509088, 0.000915907323360443],
    [118.408120333746, 24.7248383266822, 0.000915973447263241],
  ],
  [
    [118.408638067676, 24.7242921503069, 0.000915905460715294],
    [118.408105650358, 24.7248261087178, 0.000915972515940666],
  ],
  [
    [118.408623522731, 24.7242800496997, 0.00091590266674757],
    [118.408090966972, 24.7248138907519, 0.000915970653295517],
  ],
  [
    [118.408608987669, 24.7242679400593, 0.000915901735424995],
    [118.408076283589, 24.7248016727846, 0.000915967859327793],
  ],
  [
    [118.408594442725, 24.7242558304214, 0.000915898941457272],
    [118.408061610092, 24.7247894548119, 0.000915966928005219],
  ],
  [
    [118.408579907668, 24.7242437207782, 0.000915898941457272],
    [118.408046936595, 24.72477722781, 0.000915965996682644],
  ],
  [
    [118.408565382498, 24.7242316111297, 0.000915898010134697],
    [118.408032272984, 24.7247650008028, 0.00091596320271492],
  ],
  [
    [118.408550847443, 24.7242194924559, 0.000915895216166973],
    [118.408017599488, 24.7247527647702, 0.000915962271392345],
  ],
  [
    [118.408536322274, 24.7242073737767, 0.000915893353521824],
    [118.408002935879, 24.7247405287323, 0.000915961340069771],
  ],
  [
    [118.408521806988, 24.7241952460644, 0.000915892422199249],
    [118.407988282157, 24.7247282926891, 0.000915959477424622],
  ],
  [
    [118.408507281821, 24.7241831183546, 0.0009158905595541],
    [118.407973618549, 24.7247160476204, 0.000915956683456898],
  ],
  [
    [118.40849276654, 24.7241709906395, 0.0009158905595541],
    [118.407958964828, 24.7247038025465, 0.000915956683456898],
  ],
  [
    [118.408478251259, 24.7241588538951, 0.000915886834263802],
    [118.407944320994, 24.7246915574673, 0.000915954820811749],
  ],
  [
    [118.408463745863, 24.7241467171455, 0.000915886834263802],
    [118.407929667275, 24.7246793033627, 0.000915953889489174],
  ],
  [
    [118.408449240471, 24.7241345803944, 0.000915884971618652],
    [118.407915023443, 24.7246670492528, 0.00091595109552145],
  ],
  [
    [118.408434735077, 24.7241224346141, 0.000915882177650929],
    [118.407900379613, 24.7246547951414, 0.000915950164198875],
  ],
  [
    [118.408420229686, 24.7241102888324, 0.000915881246328354],
    [118.407885745667, 24.724642531997, 0.000915949232876301],
  ],
  [
    [118.408405734182, 24.7240981430453, 0.000915881246328354],
    [118.407871111723, 24.7246302688511, 0.000915944576263428],
  ],
  [
    [118.408391238677, 24.7240859882291, 0.000915879383683205],
    [118.407856477777, 24.7246179966759, 0.000915945507586002],
  ],
  [
    [118.408376753058, 24.7240738334076, 0.000915877521038055],
    [118.407841853723, 24.7246057335233, 0.000915943644940853],
  ],
  [
    [118.408362257558, 24.7240616785885, 0.000915876589715481],
    [118.407827219784, 24.7245934613452, 0.000915941782295704],
  ],
  [
    [118.408347771941, 24.7240495147363, 0.000915873795747757],
    [118.407812605611, 24.7245811801303, 0.000915940850973129],
  ],
  [
    [118.40833329621, 24.7240373508788, 0.000915872864425182],
    [118.407797981557, 24.7245688989177, 0.000915940850973129],
  ],
  [
    [118.408318810598, 24.7240251870238, 0.000915871933102608],
    [118.407783367389, 24.7245566176998, 0.000915938057005405],
  ],
  [
    [118.408304334869, 24.7240130141357, 0.000915869139134884],
    [118.407768753225, 24.7245443364805, 0.000915937125682831],
  ],
  [
    [118.408289869026, 24.7240008412424, 0.000915867276489735],
    [118.407754148944, 24.7245320462281, 0.000915934331715107],
  ],
  [
    [118.408275393303, 24.7239886683514, 0.000915867276489735],
    [118.407739534777, 24.7245197469503, 0.000915933400392532],
  ],
  [
    [118.408260927462, 24.7239764864274, 0.000915864482522011],
    [118.407724930501, 24.7245074566951, 0.000915929675102234],
  ],
  [
    [118.408246471507, 24.7239643044981, 0.000915862619876862],
    [118.407710336107, 24.7244951574068, 0.000915930606424809],
  ],
  [
    [118.408232005668, 24.7239521135435, 0.000915861688554287],
    [118.407695741717, 24.724482858117, 0.000915928743779659],
  ],
  [
    [118.408217549715, 24.7239399225835, 0.000915859825909138],
    [118.407681147325, 24.724470549798, 0.00091592688113451],
  ],
  [
    [118.408203093765, 24.7239277316222, 0.000915857963263988],
    [118.407666552937, 24.7244582414775, 0.000915925018489361],
  ],
  [
    [118.408188647701, 24.7239155406556, 0.000915857031941414],
    [118.407651968435, 24.7244459331518, 0.000915924087166786],
  ],
  [
    [118.408174201636, 24.7239033406598, 0.000915856100618839],
    [118.407637383931, 24.7244336157969, 0.000915922224521637],
  ],
  [
    [118.408159755574, 24.7238911406626, 0.00091585423797369],
    [118.407622799431, 24.7244212984405, 0.000915920361876488],
  ],
  [
    [118.408145319395, 24.7238789316323, 0.000915853306651115],
    [118.407608224817, 24.7244089810788, 0.000915919430553913],
  ],
  [
    [118.408130873334, 24.7238667226044, 0.000915850512683392],
    [118.407593650203, 24.7243966546879, 0.000915917567908764],
  ],
  [
    [118.408116437161, 24.7238545135713, 0.000915849581360817],
    [118.407579075591, 24.7243843282956, 0.000915915705263615],
  ],
  [
    [118.408102010869, 24.7238422955051, 0.000915847718715668],
    [118.407564510865, 24.724372001898, 0.00091591477394104],
  ],
  [
    [118.408087584585, 24.7238300864654, 0.000915845856070518],
    [118.407549946139, 24.7243596664712, 0.000915913842618465],
  ],
  [
    [118.408073158295, 24.7238178593685, 0.000915845856070518],
    [118.407535381415, 24.7243473310429, 0.000915912911295891],
  ],
  [
    [118.408058732012, 24.7238056412981, 0.000915843993425369],
    [118.407520826574, 24.7243349865816, 0.000915909186005592],
  ],
  [
    [118.408044315612, 24.7237934141947, 0.00091584213078022],
    [118.40750627174, 24.7243226511467, 0.000915907323360443],
  ],
  [
    [118.40802989921, 24.723781178062, 0.000915840268135071],
    [118.407491716905, 24.7243103066825, 0.000915905460715294],
  ],
  [
    [118.408015482816, 24.7237689509557, 0.000915838405489922],
    [118.407477171953, 24.7242979531853, 0.000915904529392719],
  ],
  [
    [118.408001076304, 24.7237567148164, 0.000915838405489922],
    [118.407462617119, 24.7242855996905, 0.000915903598070145],
  ],
  [
    [118.40798666979, 24.7237444696479, 0.000915836542844772],
    [118.407448082056, 24.7242732461866, 0.000915901735424995],
  ],
  [
    [118.407972273168, 24.7237322335019, 0.000915834680199623],
    [118.407433537112, 24.7242608926851, 0.000915901735424995],
  ],
  [
    [118.40795786666, 24.7237199883305, 0.000915832817554474],
    [118.407419002051, 24.7242485301505, 0.000915898941457272],
  ],
  [
    [118.407943470034, 24.7237077341262, 0.00091583002358675],
    [118.407404466993, 24.7242361676146, 0.000915898010134697],
  ],
  [
    [118.4079290833, 24.7236954889444, 0.00091583002358675],
    [118.407389941817, 24.7242237960456, 0.000915895216166973],
  ],
  [
    [118.40791468668, 24.7236832347371, 0.000915829092264175],
    [118.407375416644, 24.7242114244751, 0.000915893353521824],
  ],
  [
    [118.407900299943, 24.7236709714969, 0.000915827229619026],
    [118.407360891474, 24.7241990529032, 0.000915893353521824],
  ],
  [
    [118.407885913213, 24.7236587172831, 0.000915824435651302],
    [118.407346366303, 24.7241866723021, 0.000915891490876675],
  ],
  [
    [118.407871536365, 24.7236464540362, 0.000915822573006153],
    [118.407331851019, 24.7241742916958, 0.000915889628231525],
  ],
  [
    [118.407857159516, 24.7236341817601, 0.000915821641683578],
    [118.407317335737, 24.7241619110881, 0.000915888696908951],
  ],
  [
    [118.40784278267, 24.7236219094827, 0.000915819779038429],
    [118.407302830338, 24.7241495214473, 0.000915886834263802],
  ],
  [
    [118.407828415711, 24.7236096372, 0.00091581791639328],
    [118.407288315058, 24.7241371318089, 0.000915885902941227],
  ],
  [
    [118.40781403887, 24.7235973649197, 0.00091581791639328],
    [118.407273819549, 24.7241247421615, 0.000915884040296078],
  ],
  [
    [118.407799681796, 24.7235850836026, 0.000915816985070705],
    [118.407259314155, 24.7241123434886, 0.000915881246328354],
  ],
  [
    [118.407785314841, 24.7235728022879, 0.000915814191102982],
    [118.407244818647, 24.7240999448106, 0.000915881246328354],
  ],
  [
    [118.407770957772, 24.723560520968, 0.000915812328457832],
    [118.407230323142, 24.7240875461311, 0.00091587845236063],
  ],
  [
    [118.407756600702, 24.7235482306188, 0.000915811397135258],
    [118.407215827636, 24.7240751384223, 0.00091587845236063],
  ],
  [
    [118.407742253519, 24.7235359402645, 0.000915810465812683],
    [118.407201342017, 24.7240627307084, 0.000915874727070332],
  ],
  [
    [118.407727896451, 24.7235236408848, 0.000915807671844959],
    [118.407186856401, 24.7240503229931, 0.000915872864425182],
  ],
  [
    [118.407713559153, 24.723511341496, 0.000915806740522385],
    [118.407172370783, 24.7240379062485, 0.000915871933102608],
  ],
  [
    [118.407699211974, 24.7234990421097, 0.000915804877877235],
    [118.407157895052, 24.7240254894987, 0.000915871001780033],
  ],
  [
    [118.407684874682, 24.7234867427182, 0.000915803946554661],
    [118.407143419324, 24.7240130727475, 0.000915869139134884],
  ],
  [
    [118.407670537389, 24.7234744342974, 0.000915801152586937],
    [118.407128943595, 24.7240006469671, 0.000915868207812309],
  ],
  [
    [118.407656200098, 24.7234621258753, 0.000915800221264362],
    [118.407114477753, 24.7239882211815, 0.000915867276489735],
  ],
  [
    [118.40764187269, 24.7234498084202, 0.000915799289941788],
    [118.407100011909, 24.7239757863666, 0.000915864482522011],
  ],
  [
    [118.407627545284, 24.7234374909636, 0.000915797427296638],
    [118.407085546073, 24.7239633605782, 0.000915864482522011],
  ],
  [
    [118.407613217882, 24.7234251735057, 0.000915796495974064],
    [118.407071090115, 24.7239509167289, 0.000915862619876862],
  ],
  [
    [118.407598900362, 24.7234128470148, 0.000915794633328915],
    [118.407056634163, 24.7239384819061, 0.000915859825909138],
  ],
  [
    [118.407584582845, 24.7234005205225, 0.000915792770683765],
    [118.407042178211, 24.723926038054, 0.000915858894586563],
  ],
  [
    [118.407570265331, 24.7233881940288, 0.000915790908038616],
    [118.407027732146, 24.7239135941967, 0.000915857031941414],
  ],
  [
    [118.407555957703, 24.7233758675299, 0.000915789976716042],
    [118.407013286079, 24.7239011413102, 0.00091585423797369],
  ],
  [
    [118.407541650074, 24.7233635320018, 0.000915788114070892],
    [118.406998840015, 24.7238886884223, 0.000915853306651115],
  ],
  [
    [118.407527342444, 24.7233511874445, 0.000915786251425743],
    [118.406984403838, 24.7238762355292, 0.000915852375328541],
  ],
  [
    [118.407513044704, 24.7233388519098, 0.000915784388780594],
    [118.406969967664, 24.7238637826347, 0.000915851444005966],
  ],
  [
    [118.407498746963, 24.723326507346, 0.000915783457458019],
    [118.406955531488, 24.723851320711, 0.000915848650038242],
  ],
  [
    [118.407484449225, 24.7233141627807, 0.00091578159481287],
    [118.406941095315, 24.7238388587858, 0.000915847718715668],
  ],
  [
    [118.40747016137, 24.7233018091825, 0.000915780663490295],
    [118.406926669025, 24.7238263878277, 0.000915846787393093],
  ],
  [
    [118.407455873517, 24.7232894555829, 0.000915778800845146],
    [118.406912242738, 24.7238139168682, 0.000915844924747944],
  ],
  [
    [118.407441585668, 24.7232771019819, 0.000915774144232273],
    [118.406897826338, 24.7238014459035, 0.000915843993425369],
  ],
  [
    [118.407427297816, 24.7232647393517, 0.000915775075554848],
    [118.406883409937, 24.7237889659096, 0.000915841199457645],
  ],
  [
    [118.407413019852, 24.7232523767163, 0.000915776006877422],
    [118.406868993538, 24.7237764859143, 0.000915839336812496],
  ],
  [
    [118.40739874189, 24.7232400140795, 0.000915773212909698],
    [118.406854587026, 24.7237640059138, 0.000915838405489922],
  ],
  [
    [118.407384473811, 24.7232276424098, 0.000915770418941975],
    [118.406840170629, 24.7237515168878, 0.000915836542844772],
  ],
  [
    [118.407370205735, 24.7232152707387, 0.0009157694876194],
    [118.406825774003, 24.7237390278529, 0.000915834680199623],
  ],
  [
    [118.407355937662, 24.7232028990662, 0.000915768556296825],
    [118.406811367495, 24.7237265388204, 0.000915833748877048],
  ],
  [
    [118.407341669587, 24.7231905183645, 0.000915765762329102],
    [118.406796970871, 24.7237140407549, 0.000915831886231899],
  ],
  [
    [118.407327411399, 24.7231781376577, 0.000915764831006527],
    [118.406782574249, 24.723701542688, 0.000915830954909325],
  ],
  [
    [118.407313153213, 24.7231657569494, 0.000915762037038803],
    [118.406768187514, 24.723689044616, 0.000915829092264175],
  ],
  [
    [118.407298904911, 24.7231533672082, 0.000915761105716228],
    [118.406753790894, 24.7236765375185, 0.000915826298296452],
  ],
  [
    [118.407284656611, 24.7231409774656, 0.000915762037038803],
    [118.406739414044, 24.7236640304121, 0.000915825366973877],
  ],
  [
    [118.40727040831, 24.7231285786939, 0.000915758311748505],
    [118.406725027314, 24.723651523308, 0.000915823504328728],
  ],
  [
    [118.407256160015, 24.7231161889485, 0.00091575738042593],
    [118.406710650466, 24.723639007171, 0.000915823504328728],
  ],
  [
    [118.407241921604, 24.7231037901702, 0.000915755517780781],
    [118.406696273621, 24.7236264910326, 0.000915820710361004],
  ],
  [
    [118.407227683191, 24.7230913823627, 0.000915754586458206],
    [118.406681896775, 24.7236139658649, 0.000915819779038429],
  ],
  [
    [118.40721344478, 24.7230789745539, 0.000915750861167908],
    [118.406667529815, 24.7236014406921, 0.00091581791639328],
  ],
  [
    [118.407199216257, 24.7230665667399, 0.000915750861167908],
    [118.406653162859, 24.7235889155179, 0.000915816053748131],
  ],
  [
    [118.407184987736, 24.7230541589245, 0.000915748998522758],
    [118.406638805789, 24.7235763903386, 0.000915814191102982],
  ],
  [
    [118.407170769098, 24.7230417420761, 0.000915747135877609],
    [118.406624438834, 24.7235638561338, 0.000915815122425556],
  ],
  [
    [118.407156540579, 24.7230293252302, 0.000915746204555035],
    [118.406610081766, 24.7235513219239, 0.000915811397135258],
  ],
  [
    [118.407142321946, 24.7230169083791, 0.000915744341909885],
    [118.40659573458, 24.723538778681, 0.000915809534490108],
  ],
  [
    [118.407128113196, 24.7230044824951, 0.000915744341909885],
    [118.406581387402, 24.7235262444646, 0.000915807671844959],
  ],
  [
    [118.407113894565, 24.7229920566134, 0.000915742479264736],
    [118.406567040218, 24.7235136921911, 0.00091580580919981],
  ],
  [
    [118.407099685817, 24.7229796216988, 0.000915739685297012],
    [118.406552693041, 24.723501148944, 0.00091580580919981],
  ],
  [
    [118.407085486955, 24.7229671867791, 0.000915737822651863],
    [118.406538355747, 24.723488596664, 0.000915803946554661],
  ],
  [
    [118.407071278212, 24.7229547518618, 0.000915735960006714],
    [118.406524018456, 24.7234760443827, 0.000915801152586937],
  ],
  [
    [118.407057079356, 24.7229423169393, 0.000915734097361565],
    [118.406509681163, 24.7234634830721, 0.000915800221264362],
  ],
  [
    [118.407042890382, 24.7229298729839, 0.000915734097361565],
    [118.406495353758, 24.7234509217563, 0.000915798358619213],
  ],
  [
    [118.407028691527, 24.7229174290309, 0.000915732234716415],
    [118.406481026355, 24.7234383604392, 0.000915797427296638],
  ],
  [
    [118.407014502555, 24.7229049760449, 0.000915731303393841],
    [118.406466698955, 24.7234257991207, 0.000915795564651489],
  ],
  [
    [118.407000313586, 24.7228925230576, 0.000915729440748692],
    [118.406452381438, 24.7234132287693, 0.00091579370200634],
  ],
  [
    [118.406986134503, 24.7228800700652, 0.000915727578103542],
    [118.406438063923, 24.7234006584164, 0.000915792770683765],
  ],
  [
    [118.406971955424, 24.7228676170714, 0.000915726646780968],
    [118.406423746407, 24.7233880790344, 0.000915791839361191],
  ],
  [
    [118.406957776342, 24.7228551550484, 0.000915723852813244],
    [118.406409438779, 24.7233754996473, 0.000915790908038616],
  ],
  [
    [118.406943607148, 24.7228426930203, 0.00091572105884552],
    [118.406395131153, 24.7233629202587, 0.000915788114070892],
  ],
  [
    [118.406929437952, 24.722830221963, 0.000915721990168095],
    [118.406380823525, 24.723350331841, 0.000915786251425743],
  ],
  [
    [118.406915268759, 24.7228177509043, 0.000915720127522945],
    [118.406366525785, 24.7233377434182, 0.000915784388780594],
  ],
  [
    [118.406901099569, 24.7228052798443, 0.000915717333555222],
    [118.406352228047, 24.7233251549939, 0.000915782526135445],
  ],
  [
    [118.406886940266, 24.7227928087792, 0.000915715470910072],
    [118.406337930309, 24.7233125575405, 0.000915782526135445],
  ],
  [
    [118.406872790845, 24.7227803286812, 0.000915715470910072],
    [118.406323642457, 24.723299960082, 0.000915779732167721],
  ],
  [
    [118.406858631543, 24.7227678485855, 0.000915712676942348],
    [118.406309354608, 24.7232873626221, 0.000915778800845146],
  ],
  [
    [118.406844482124, 24.7227553594569, 0.000915711745619774],
    [118.406295066757, 24.723274756133, 0.000915776938199997],
  ],
  [
    [118.406830332707, 24.722742870327, 0.000915709882974625],
    [118.406280788794, 24.7232621496387, 0.000915775075554848],
  ],
  [
    [118.406816193177, 24.722730381192, 0.000915706157684326],
    [118.406266510833, 24.7232495431432, 0.000915773212909698],
  ],
  [
    [118.406802043762, 24.7227178830315, 0.000915708020329475],
    [118.406252232871, 24.7232369276184, 0.000915772281587124],
  ],
  [
    [118.406787914118, 24.7227053848622, 0.000915705226361752],
    [118.406237964796, 24.7232243120885, 0.000915770418941975],
  ],
  [
    [118.406773774592, 24.7226928866953, 0.000915704295039177],
    [118.406223696724, 24.7232116965572, 0.000915768556296825],
  ],
  [
    [118.406759644953, 24.7226803885232, 0.000915702432394028],
    [118.40620942865, 24.7231990719968, 0.000915767624974251],
  ],
  [
    [118.406745515313, 24.722667881322, 0.000915701501071453],
    [118.40619516058, 24.7231864474349, 0.000915765762329102],
  ],
  [
    [118.406731385676, 24.7226553741195, 0.000915699638426304],
    [118.406180902396, 24.723173822868, 0.000915765762329102],
  ],
  [
    [118.406717265921, 24.722642857884, 0.000915698707103729],
    [118.406166654094, 24.7231611892682, 0.000915762037038803],
  ],
  [
    [118.406703146169, 24.7226303416472, 0.000915694981813431],
    [118.406152395912, 24.7231485556707, 0.000915761105716228],
  ],
  [
    [118.406689036304, 24.7226178254053, 0.000915694981813431],
    [118.406138147617, 24.7231359220681, 0.000915760174393654],
  ],
  [
    [118.406674926437, 24.7226053001343, 0.000915692187845707],
    [118.40612389932, 24.7231232794363, 0.000915758311748505],
  ],
  [
    [118.406660816573, 24.7225927748618, 0.000915691256523132],
    [118.40610966091, 24.7231106367995, 0.000915756449103355],
  ],
  [
    [118.406646706712, 24.7225802495881, 0.000915689393877983],
    [118.406095422503, 24.7230979941612, 0.000915753655135632],
  ],
  [
    [118.406632606734, 24.7225677152814, 0.000915688462555408],
    [118.406081184095, 24.7230853424938, 0.000915753655135632],
  ],
  [
    [118.406618506758, 24.7225551809734, 0.000915686599910259],
    [118.406066955574, 24.7230726908213, 0.000915751792490482],
  ],
  [
    [118.406604406785, 24.722542646664, 0.000915686599910259],
    [118.406052727051, 24.7230600301196, 0.000915750861167908],
  ],
  [
    [118.406590316699, 24.7225301123495, 0.00091568473726511],
    [118.406038498531, 24.7230473694166, 0.000915748998522758],
  ],
  [
    [118.406576226612, 24.7225175690059, 0.000915681011974812],
    [118.406024270015, 24.7230347087122, 0.000915746204555035],
  ],
  [
    [118.406562146407, 24.7225050166294, 0.000915681011974812],
    [118.406010051384, 24.7230220480027, 0.00091574527323246],
  ],
  [
    [118.406548056325, 24.7224924732831, 0.000915678218007088],
    [118.405995842637, 24.7230093782603, 0.000915743410587311],
  ],
  [
    [118.406533976126, 24.7224799209039, 0.000915678218007088],
    [118.405981624009, 24.7229967085203, 0.000915742479264736],
  ],
  [
    [118.406519905809, 24.7224673594918, 0.000915675424039364],
    [118.405967415267, 24.7229840387751, 0.000915738753974438],
  ],
  [
    [118.406505825616, 24.72245480711, 0.000915673561394215],
    [118.405953206524, 24.7229713600008, 0.000915737822651863],
  ],
  [
    [118.406491755305, 24.7224422456952, 0.000915673561394215],
    [118.405939007668, 24.7229586812215, 0.000915737822651863],
  ],
  [
    [118.40647769488, 24.7224296842753, 0.000915671698749065],
    [118.405924808811, 24.7229459934129, 0.000915735960006714],
  ],
  [
    [118.406463634455, 24.7224171138263, 0.000915669836103916],
    [118.405910609956, 24.722933305603, 0.000915734097361565],
  ],
  [
    [118.406449574032, 24.722404543376, 0.000915666110813618],
    [118.405896411105, 24.7229206177917, 0.000915734097361565],
  ],
  [
    [118.406435513612, 24.7223919729243, 0.000915667042136192],
    [118.40588222214, 24.7229079299754, 0.000915731303393841],
  ],
  [
    [118.406421463074, 24.7223793934398, 0.000915663316845894],
    [118.405868043057, 24.7228952331262, 0.000915730372071266],
  ],
  [
    [118.40640741254, 24.7223668139539, 0.000915663316845894],
    [118.405853854094, 24.7228825362793, 0.000915728509426117],
  ],
  [
    [118.406393362008, 24.7223542344666, 0.000915661454200745],
    [118.405839675014, 24.7228698303996, 0.000915724784135818],
  ],
  [
    [118.406379321359, 24.7223416459465, 0.000915659591555595],
    [118.405825495936, 24.7228571245185, 0.000915724784135818],
  ],
  [
    [118.406365280712, 24.7223290574251, 0.000915658660233021],
    [118.405811326746, 24.7228444186323, 0.000915723852813244],
  ],
  [
    [118.406351240068, 24.7223164689023, 0.000915656797587872],
    [118.405797157558, 24.7228317127448, 0.000915721990168095],
  ],
  [
    [118.406337209307, 24.7223038713466, 0.000915655866265297],
    [118.405782988368, 24.7228189978281, 0.000915719196200371],
  ],
  [
    [118.406323168665, 24.7222912737933, 0.000915653072297573],
    [118.405768819182, 24.7228062829101, 0.000915717333555222],
  ],
  [
    [118.406309147794, 24.7222786762313, 0.000915650278329849],
    [118.405754659879, 24.7227935589592, 0.000915717333555222],
  ],
  [
    [118.406295117037, 24.7222660696438, 0.000915652140974998],
    [118.405740500578, 24.7227808350069, 0.000915716402232647],
  ],
  [
    [118.406281096167, 24.7222534630513, 0.000915647484362125],
    [118.405726351164, 24.7227681110496, 0.000915713608264923],
  ],
  [
    [118.406267085183, 24.7222408564537, 0.000915646553039551],
    [118.405712201749, 24.7227553780631, 0.000915710814297199],
  ],
  [
    [118.406253064315, 24.7222282408307, 0.000915644690394402],
    [118.405698052336, 24.7227426450752, 0.00091570895165205],
  ],
  [
    [118.406239053333, 24.7222156252026, 0.000915642827749252],
    [118.405683902927, 24.722729912086, 0.000915708020329475],
  ],
  [
    [118.406225052238, 24.7222030095695, 0.000915641896426678],
    [118.405669763404, 24.7227171790918, 0.000915708020329475],
  ],
  [
    [118.406211041257, 24.722190384911, 0.000915640965104103],
    [118.405655633764, 24.7227044370647, 0.000915707089006901],
  ],
  [
    [118.406197040164, 24.7221777602474, 0.000915639102458954],
    [118.405641494243, 24.72269169504, 0.000915703363716602],
  ],
  [
    [118.406183039073, 24.7221651355825, 0.000915638171136379],
    [118.405627364605, 24.7226789439824, 0.000915701501071453],
  ],
  [
    [118.406169047869, 24.7221525109125, 0.000915635377168655],
    [118.40561323497, 24.7226661929234, 0.000915700569748878],
  ],
  [
    [118.406155056663, 24.7221398772135, 0.000915633514523506],
    [118.405599115221, 24.7226534418595, 0.000915699638426304],
  ],
  [
    [118.406141065456, 24.7221272344852, 0.000915633514523506],
    [118.405584985587, 24.72264068177, 0.000915697775781155],
  ],
  [
    [118.40612708414, 24.7221146007798, 0.000915631651878357],
    [118.405570875724, 24.7226279216718, 0.000915695913136005],
  ],
  [
    [118.406113102823, 24.7221019580452, 0.000915630720555782],
    [118.40555675598, 24.7226151615759, 0.000915694981813431],
  ],
  [
    [118.406099121505, 24.7220893062815, 0.000915627926588058],
    [118.405542646119, 24.7226023924473, 0.000915692187845707],
  ],
  [
    [118.406085140193, 24.7220766635442, 0.000915626995265484],
    [118.405528536264, 24.722589632345, 0.000915691256523132],
  ],
  [
    [118.406071168764, 24.7220640117741, 0.00091562420129776],
    [118.405514436288, 24.7225768541822, 0.000915688462555408],
  ],
  [
    [118.406057207217, 24.7220513509712, 0.000915625132620335],
    [118.40550033632, 24.7225640850458, 0.000915690325200558],
  ],
  [
    [118.406043235794, 24.7220386991985, 0.000915621407330036],
    [118.405486236349, 24.7225513068802, 0.000915686599910259],
  ],
  [
    [118.406029274253, 24.7220260383929, 0.000915621407330036],
    [118.405472136378, 24.7225385196855, 0.000915685668587685],
  ],
  [
    [118.406015312711, 24.7220133685582, 0.000915617682039738],
    [118.405458046298, 24.7225257415136, 0.000915681943297386],
  ],
  [
    [118.406001361059, 24.7220007077463, 0.000915618613362312],
    [118.405443956216, 24.7225129543125, 0.000915681011974812],
  ],
  [
    [118.405987409406, 24.7219880379052, 0.000915614888072014],
    [118.405429876021, 24.7225001671064, 0.000915678218007088],
  ],
  [
    [118.405973457752, 24.721975359035, 0.000915613025426865],
    [118.405415795825, 24.7224873708711, 0.000915678218007088],
  ],
  [
    [118.405959515989, 24.7219626891876, 0.000915610231459141],
    [118.405401715632, 24.7224745746345, 0.000915676355361938],
  ],
  [
    [118.405945564341, 24.7219500103148, 0.00091561209410429],
    [118.405387645325, 24.7224617783929, 0.000915675424039364],
  ],
  [
    [118.405931632463, 24.7219373314333, 0.000915609300136566],
    [118.405373565134, 24.7224489731258, 0.000915671698749065],
  ],
  [
    [118.4059176907, 24.7219246435263, 0.000915607437491417],
    [118.405359504713, 24.7224361678501, 0.000915673561394215],
  ],
  [
    [118.405903758824, 24.7219119556143, 0.000915605574846268],
    [118.405345434411, 24.7224233625766, 0.000915671698749065],
  ],
  [
    [118.40588982695, 24.721899267701, 0.000915604643523693],
    [118.405331373992, 24.7224105482704, 0.000915668904781342],
  ],
  [
    [118.405875904959, 24.7218865707549, 0.000915601849555969],
    [118.405317313575, 24.7223977339628, 0.000915666110813618],
  ],
  [
    [118.405861982971, 24.7218738738075, 0.000915600918233395],
    [118.405303263046, 24.7223849196502, 0.000915664248168468],
  ],
  [
    [118.405848060986, 24.7218611768587, 0.000915599055588245],
    [118.405289212515, 24.7223720963085, 0.000915665179491043],
  ],
  [
    [118.405834148883, 24.7218484708772, 0.000915599055588245],
    [118.405275161987, 24.7223592729654, 0.000915662385523319],
  ],
  [
    [118.405820226899, 24.721835764898, 0.000915596261620522],
    [118.405261111462, 24.722346449621, 0.000915659591555595],
  ],
  [
    [118.405806324686, 24.7218230589101, 0.000915593467652798],
    [118.40524707082, 24.7223336172437, 0.000915657728910446],
  ],
  [
    [118.405792412588, 24.7218103438968, 0.000915592536330223],
    [118.405233030184, 24.722320793893, 0.000915656797587872],
  ],
  [
    [118.405778510376, 24.7217976288785, 0.000915593467652798],
    [118.405218999427, 24.7223079524816, 0.000915654934942722],
  ],
  [
    [118.405764608167, 24.7217849138588, 0.000915589742362499],
    [118.405204968677, 24.7222951200967, 0.000915654003620148],
  ],
  [
    [118.40575071584, 24.7217721898064, 0.00091558787971735],
    [118.405190937926, 24.7222822786827, 0.000915651209652424],
  ],
  [
    [118.405736823517, 24.7217594657526, 0.00091558787971735],
    [118.405176917058, 24.7222694282359, 0.000915651209652424],
  ],
  [
    [118.405722931196, 24.7217467416976, 0.000915586017072201],
    [118.405162896197, 24.7222565868155, 0.0009156484156847],
  ],
  [
    [118.405709038874, 24.7217340086134, 0.000915582291781902],
    [118.405148875334, 24.722243736366, 0.0009156484156847],
  ],
  [
    [118.405695156439, 24.7217212755242, 0.000915581360459328],
    [118.40513485447, 24.7222308768874, 0.000915646553039551],
  ],
  [
    [118.405681274006, 24.7217085424337, 0.000915580429136753],
    [118.405120843497, 24.7222180264316, 0.000915644690394402],
  ],
  [
    [118.40566740146, 24.7216958093383, 0.000915579497814178],
    [118.405106832523, 24.7222051669467, 0.000915640965104103],
  ],
  [
    [118.405653528913, 24.7216830672137, 0.000915577635169029],
    [118.405092831432, 24.7221922984289, 0.000915641896426678],
  ],
  [
    [118.405639656365, 24.72167031606, 0.000915574841201305],
    [118.405078830347, 24.7221794389377, 0.000915639102458954],
  ],
  [
    [118.405625783823, 24.7216575739328, 0.000915572978556156],
    [118.405064829261, 24.7221665704173, 0.000915638171136379],
  ],
  [
    [118.405611921164, 24.7216448227728, 0.000915572047233582],
    [118.405050838058, 24.7221536928641, 0.000915635377168655],
  ],
  [
    [118.405598068392, 24.7216320716079, 0.000915571115911007],
    [118.405036846862, 24.7221408243374, 0.000915633514523506],
  ],
  [
    [118.405584205734, 24.7216193114174, 0.000915569253265858],
    [118.405022855665, 24.7221279467816, 0.000915631651878357],
  ],
  [
    [118.405570352964, 24.721606551222, 0.000915568321943283],
    [118.40500886447, 24.7221150692244, 0.000915631651878357],
  ],
  [
    [118.405556500196, 24.7215937910254, 0.000915566459298134],
    [118.404994883159, 24.7221021826345, 0.000915630720555782],
  ],
  [
    [118.40554265731, 24.7215810217959, 0.00091556366533041],
    [118.404980911734, 24.7220892960396, 0.000915628857910633],
  ],
  [
    [118.405528804544, 24.7215682525688, 0.000915560871362686],
    [118.404966930428, 24.722076409447, 0.000915626995265484],
  ],
  [
    [118.405514971548, 24.721555483333, 0.000915561802685261],
    [118.404952959004, 24.7220635138216, 0.000915625132620335],
  ],
  [
    [118.405501128667, 24.7215427050719, 0.000915559940040112],
    [118.404938987584, 24.7220506181949, 0.000915623269975185],
  ],
  [
    [118.405487295676, 24.7215299358335, 0.000915557146072388],
    [118.40492502605, 24.7220377225633, 0.000915622338652611],
  ],
  [
    [118.405473462681, 24.7215171485382, 0.000915557146072388],
    [118.404911064515, 24.7220248179025, 0.000915620476007462],
  ],
  [
    [118.405459639576, 24.7215043702658, 0.000915553420782089],
    [118.404897102983, 24.7220119132405, 0.000915618613362312],
  ],
  [
    [118.40544581647, 24.7214915829643, 0.000915553420782089],
    [118.404883151338, 24.7219990085734, 0.000915615819394588],
  ],
  [
    [118.405431993366, 24.7214787956615, 0.00091555155813694],
    [118.404869199692, 24.7219860948772, 0.000915614888072014],
  ],
  [
    [118.405418170262, 24.7214659993295, 0.000915550626814365],
    [118.404855248048, 24.7219731811797, 0.000915613025426865],
  ],
  [
    [118.405404357044, 24.7214532029926, 0.000915547832846642],
    [118.404841306291, 24.7219602674773, 0.00091561209410429],
  ],
  [
    [118.405390543828, 24.7214404066545, 0.000915545970201492],
    [118.404827364533, 24.7219473447457, 0.000915610231459141],
  ],
  [
    [118.4053767405, 24.7214276103113, 0.000915544107556343],
    [118.404813422778, 24.7219344220128, 0.000915609300136566],
  ],
  [
    [118.40536293717, 24.7214148049391, 0.000915544107556343],
    [118.40479949091, 24.721921499275, 0.000915607437491417],
  ],
  [
    [118.405349133839, 24.7214019905377, 0.000915543176233768],
    [118.40478555904, 24.721908567508, 0.000915604643523693],
  ],
  [
    [118.405335340398, 24.7213891851592, 0.000915540382266045],
    [118.404771627173, 24.7218956357397, 0.000915602780878544],
  ],
  [
    [118.405321537073, 24.7213763707553, 0.00091553945094347],
    [118.404757705193, 24.7218827039665, 0.000915602780878544],
  ],
  [
    [118.405307753518, 24.7213635563427, 0.000915537588298321],
    [118.404743783212, 24.7218697631641, 0.000915600918233395],
  ],
  [
    [118.405293960078, 24.7213507329047, 0.000915535725653172],
    [118.404729861234, 24.7218568223605, 0.00091559998691082],
  ],
  [
    [118.405280176529, 24.7213379184896, 0.000915532931685448],
    [118.404715949142, 24.7218438815519, 0.000915597192943096],
  ],
  [
    [118.405266392974, 24.7213250860176, 0.000915532931685448],
    [118.40470203705, 24.7218309317141, 0.000915596261620522],
  ],
  [
    [118.40525261931, 24.7213122625684, 0.000915531069040298],
    [118.40468812496, 24.7218179818751, 0.000915594398975372],
  ],
  [
    [118.405238845645, 24.7212994300901, 0.000915529206395149],
    [118.404674222757, 24.7218050320311, 0.000915592536330223],
  ],
  [
    [118.405225071982, 24.7212865976106, 0.000915526412427425],
    [118.404660320552, 24.7217920731581, 0.000915590673685074],
  ],
  [
    [118.405211298319, 24.7212737561019, 0.000915525481104851],
    [118.404646418355, 24.7217791233114, 0.000915588811039925],
  ],
  [
    [118.405197534546, 24.7212609236161, 0.000915524549782276],
    [118.404632526036, 24.7217661554043, 0.00091558787971735],
  ],
  [
    [118.405183780651, 24.7212480730698, 0.000915522687137127],
    [118.404618633725, 24.7217531965237, 0.000915585085749626],
  ],
  [
    [118.40517001688, 24.7212352315536, 0.000915520824491978],
    [118.404604741412, 24.7217402286139, 0.000915584154427052],
  ],
  [
    [118.405156262991, 24.7212223810047, 0.000915518961846828],
    [118.404590858981, 24.7217272516714, 0.000915582291781902],
  ],
  [
    [118.405142509105, 24.7212095304545, 0.000915517099201679],
    [118.404576976558, 24.7217142837554, 0.000915581360459328],
  ],
  [
    [118.405128765105, 24.7211966798994, 0.000915514305233955],
    [118.404563094133, 24.7217013068103, 0.000915579497814178],
  ],
  [
    [118.405115021104, 24.7211838203152, 0.000915513373911381],
    [118.404549221596, 24.7216883298603, 0.000915577635169029],
  ],
  [
    [118.405101277107, 24.7211709607297, 0.000915512442588806],
    [118.404535349057, 24.7216753438812, 0.000915576703846455],
  ],
  [
    [118.405087533108, 24.7211580921151, 0.000915511511266232],
    [118.404521486404, 24.7216623578971, 0.000915573909878731],
  ],
  [
    [118.405073798999, 24.7211452325234, 0.000915508717298508],
    [118.404507613871, 24.7216493719154, 0.000915572978556156],
  ],
  [
    [118.405060074769, 24.7211323548712, 0.000915509648621082],
    [118.404493751221, 24.7216363769009, 0.000915571115911007],
  ],
  [
    [118.405046340662, 24.7211194862491, 0.000915508717298508],
    [118.404479898457, 24.7216233818815, 0.000915570184588432],
  ],
  [
    [118.405032616438, 24.7211066085942, 0.000915504992008209],
    [118.404466045696, 24.7216103868608, 0.000915569253265858],
  ],
  [
    [118.405018892217, 24.7210937309382, 0.000915504060685635],
    [118.404452192934, 24.721597382811, 0.000915566459298134],
  ],
  [
    [118.405005177882, 24.7210808532772, 0.000915502198040485],
    [118.404438340174, 24.7215843787599, 0.000915565527975559],
  ],
  [
    [118.404991463545, 24.7210679665871, 0.000915500335395336],
    [118.404424497302, 24.7215713747039, 0.00091556366533041],
  ],
  [
    [118.404977749212, 24.7210550798957, 0.000915496610105038],
    [118.404410654432, 24.7215583706466, 0.000915561802685261],
  ],
  [
    [118.404964044765, 24.7210421931994, 0.000915497541427612],
    [118.404396811561, 24.7215453575602, 0.000915559008717537],
  ],
  [
    [118.404950340317, 24.721029297474, 0.000915494747459888],
    [118.404382978573, 24.7215323354411, 0.000915559940040112],
  ],
  [
    [118.404936635872, 24.7210164017474, 0.000915491953492165],
    [118.404369145592, 24.7215193223485, 0.000915556214749813],
  ],
  [
    [118.404922941314, 24.7210035060159, 0.000915491953492165],
    [118.404355322493, 24.7215063002232, 0.000915554352104664],
  ],
  [
    [118.40490923687, 24.7209906012588, 0.00091549102216959],
    [118.404341499398, 24.7214932780966, 0.000915554352104664],
  ],
  [
    [118.404895552197, 24.7209776964933, 0.000915488228201866],
    [118.404327676301, 24.7214802469408, 0.000915552489459515],
  ],
  [
    [118.404881857643, 24.7209647917301, 0.000915486365556717],
    [118.404313853207, 24.7214672157838, 0.000915549695491791],
  ],
  [
    [118.404868172972, 24.7209518779342, 0.000915485434234142],
    [118.40430004, 24.7214541846219, 0.000915547832846642],
  ],
  [
    [118.404854498187, 24.7209389641334, 0.000915483571588993],
    [118.404286226795, 24.7214411534587, 0.000915546901524067],
  ],
  [
    [118.404840813521, 24.720926050335, 0.000915483571588993],
    [118.404272423474, 24.7214281132628, 0.000915545970201492],
  ],
  [
    [118.404827138737, 24.7209131275038, 0.000915480777621269],
    [118.404258620155, 24.7214150730656, 0.000915543176233768],
  ],
  [
    [118.404813463957, 24.7209002046714, 0.00091547891497612],
    [118.404244816835, 24.7214020238393, 0.000915542244911194],
  ],
  [
    [118.404799799063, 24.7208872818341, 0.000915477983653545],
    [118.404231023402, 24.7213889746081, 0.00091553945094347],
  ],
  [
    [118.404786134168, 24.7208743499677, 0.000915477052330971],
    [118.404217220087, 24.7213759253792, 0.00091553945094347],
  ],
  [
    [118.404772469275, 24.7208614181, 0.000915475189685822],
    [118.40420343654, 24.7213628671141, 0.000915536656975746],
  ],
  [
    [118.404758814269, 24.7208484862275, 0.000915472395718098],
    [118.404189643115, 24.721349817879, 0.000915533863008022],
  ],
  [
    [118.404745159262, 24.7208355453259, 0.000915471464395523],
    [118.404175859569, 24.7213367505835, 0.000915532931685448],
  ],
  [
    [118.404731504258, 24.720822604423, 0.000915469601750374],
    [118.40416207603, 24.7213236923144, 0.000915532000362873],
  ],
  [
    [118.404717859141, 24.7208096635152, 0.000915468670427799],
    [118.404148302373, 24.7213106250127, 0.000915529206395149],
  ],
  [
    [118.404704214026, 24.7207967226061, 0.00091546680778265],
    [118.40413452872, 24.7212975577097, 0.000915528275072575],
  ],
  [
    [118.40469056891, 24.720783772668, 0.000915464945137501],
    [118.404120755065, 24.7212844813776, 0.00091552734375],
  ],
  [
    [118.404676933676, 24.7207708136972, 0.000915463082492352],
    [118.404106991301, 24.7212714140684, 0.000915526412427425],
  ],
  [
    [118.40466329845, 24.720757863753, 0.000915461219847202],
    [118.404093227532, 24.7212583287024, 0.000915525481104851],
  ],
  [
    [118.404649663222, 24.7207449047796, 0.000915459357202053],
    [118.40407946377, 24.7212452523628, 0.000915523618459702],
  ],
  [
    [118.404636037881, 24.7207319458014, 0.000915457494556904],
    [118.40406570989, 24.7212321669906, 0.000915520824491978],
  ],
  [
    [118.404622412538, 24.7207189777941, 0.000915457494556904],
    [118.404051956013, 24.7212190816171, 0.000915519893169403],
  ],
  [
    [118.404608797082, 24.7207060097819, 0.00091545470058918],
    [118.40403820214, 24.7212059962423, 0.000915516167879105],
  ],
  [
    [118.404595171746, 24.7206930417721, 0.000915452837944031],
    [118.404024458148, 24.7211929018349, 0.00091551523655653],
  ],
  [
    [118.404581556295, 24.7206800737575, 0.000915450975298882],
    [118.40401071416, 24.7211798074261, 0.000915514305233955],
  ],
  [
    [118.404567950727, 24.7206670967101, 0.000915450975298882],
    [118.403996970171, 24.7211667039883, 0.000915511511266232],
  ],
  [
    [118.404554335279, 24.7206541196651, 0.000915449112653732],
    [118.403983236072, 24.7211536095734, 0.000915510579943657],
  ],
  [
    [118.404540739597, 24.7206411335838, 0.000915447250008583],
    [118.403969501968, 24.7211404971016, 0.000915509648621082],
  ],
  [
    [118.404527134037, 24.7206281565327, 0.000915444456040859],
    [118.403955767871, 24.7211273936564, 0.000915508717298508],
  ],
  [
    [118.404513538357, 24.7206151614211, 0.000915443524718285],
    [118.403942043657, 24.7211142811784, 0.000915506854653358],
  ],
  [
    [118.404499942683, 24.720602175336, 0.000915441662073135],
    [118.403928319445, 24.7211011686993, 0.000915504992008209],
  ],
  [
    [118.404486347008, 24.7205891802219, 0.000915440730750561],
    [118.403914595237, 24.7210880562188, 0.000915502198040485],
  ],
  [
    [118.404472761219, 24.7205761851029, 0.000915438868105412],
    [118.403900880911, 24.7210749347057, 0.00091550312936306],
  ],
  [
    [118.404459175433, 24.7205631899826, 0.000915436074137688],
    [118.403887166588, 24.7210618131913, 0.000915501266717911],
  ],
  [
    [118.40444559953, 24.7205501858297, 0.000915435142815113],
    [118.403873462151, 24.721048691672, 0.000915497541427612],
  ],
  [
    [118.404432013746, 24.7205371816791, 0.000915432348847389],
    [118.40385974783, 24.7210355611272, 0.000915495678782463],
  ],
  [
    [118.404418437849, 24.7205241775237, 0.000915431417524815],
    [118.403846053279, 24.7210224305741, 0.000915495678782463],
  ],
  [
    [118.404404871834, 24.7205111643357, 0.000915429554879665],
    [118.403832348844, 24.7210092909954, 0.000915492884814739],
  ],
  [
    [118.404391305821, 24.7204981511464, 0.000915428623557091],
    [118.403818654299, 24.7209961604397, 0.00091549102216959],
  ],
  [
    [118.404377739808, 24.720485128928, 0.000915426760911942],
    [118.403804959752, 24.7209830208548, 0.000915490090847015],
  ],
  [
    [118.404364173801, 24.7204721157361, 0.000915425829589367],
    [118.403791265205, 24.7209698722409, 0.000915488228201866],
  ],
  [
    [118.404350617677, 24.7204590935116, 0.000915424898266792],
    [118.403777580548, 24.72095673265, 0.000915487296879292],
  ],
  [
    [118.404337061552, 24.7204460622581, 0.000915423035621643],
    [118.403763895891, 24.72094358403, 0.000915484502911568],
  ],
  [
    [118.404323515318, 24.7204330400275, 0.000915421172976494],
    [118.403750221116, 24.7209304263774, 0.000915481708943844],
  ],
  [
    [118.404309969082, 24.7204200087679, 0.000915420241653919],
    [118.403736546347, 24.7209172777513, 0.000915481708943844],
  ],
  [
    [118.404296422849, 24.720406977507, 0.000915416516363621],
    [118.403722871578, 24.7209041200961, 0.000915482640266418],
  ],
  [
    [118.404282876615, 24.7203939372171, 0.000915415585041046],
    [118.403709206695, 24.7208909624362, 0.000915477052330971],
  ],
  [
    [118.404269340267, 24.7203808969223, 0.000915413722395897],
    [118.403695531928, 24.7208777957506, 0.000915476121008396],
  ],
  [
    [118.404255803922, 24.7203678566263, 0.000915411859750748],
    [118.40368187693, 24.7208646290567, 0.000915474258363247],
  ],
  [
    [118.40424227746, 24.7203548072976, 0.000915409997105598],
    [118.403668212052, 24.7208514623651, 0.000915472395718098],
  ],
  [
    [118.404228751, 24.7203417579677, 0.000915408134460449],
    [118.403654557057, 24.7208382866408, 0.000915471464395523],
  ],
  [
    [118.404215224544, 24.7203287086366, 0.0009154062718153],
    [118.403640902065, 24.7208251109153, 0.000915468670427799],
  ],
  [
    [118.40420170797, 24.7203156502728, 0.000915405340492725],
    [118.403627256959, 24.720811935185, 0.000915468670427799],
  ],
  [
    [118.404188191402, 24.7203026009356, 0.000915404409170151],
    [118.403613611852, 24.7207987504256, 0.000915467739105225],
  ],
  [
    [118.40417467483, 24.7202895335415, 0.000915403477847576],
    [118.403599966748, 24.7207855656649, 0.00091546680778265],
  ],
  [
    [118.404161158264, 24.7202764751739, 0.000915401615202427],
    [118.40358633153, 24.7207723808995, 0.000915462151169777],
  ],
  [
    [118.404147612027, 24.720263362649, 0.000915399752557278],
    [118.403572735866, 24.7207592322299, 0.000915462151169777],
  ],
  [
    [118.404134036138, 24.7202502411057, 0.000915398821234703],
    [118.403559169866, 24.7207461106318, 0.000915459357202053],
  ],
  [
    [118.404120470131, 24.7202371105297, 0.000915396958589554],
    [118.403545593983, 24.7207329800083, 0.000915457494556904],
  ],
  [
    [118.404106894248, 24.7202239889839, 0.000915396027266979],
    [118.403532027985, 24.7207198493799, 0.000915455631911755],
  ],
  [
    [118.404093328247, 24.7202108584055, 0.000915392301976681],
    [118.403518452111, 24.7207067277817, 0.00091545470058918],
  ],
  [
    [118.404079752366, 24.7201977278293, 0.000915390439331532],
    [118.403504876236, 24.7206935971544, 0.000915451906621456],
  ],
  [
    [118.404066176491, 24.7201846062797, 0.000915387645363808],
    [118.403491310247, 24.7206804665223, 0.000915450975298882],
  ],
  [
    [118.404052610499, 24.7201714756975, 0.000915388576686382],
    [118.403477734381, 24.7206673449202, 0.000915450043976307],
  ],
  [
    [118.404039034626, 24.7201583451176, 0.000915386714041233],
    [118.403464168398, 24.7206542142856, 0.000915448181331158],
  ],
  [
    [118.404025468643, 24.7201452235606, 0.000915383920073509],
    [118.403450592538, 24.7206410926811, 0.000915446318686008],
  ],
  [
    [118.404011892776, 24.7201320929782, 0.00091538205742836],
    [118.403437016677, 24.7206279620475, 0.000915445387363434],
  ],
  [
    [118.403998316911, 24.7201189623945, 0.000915381126105785],
    [118.403423450703, 24.7206148314091, 0.000915444456040859],
  ],
  [
    [118.403984750937, 24.7201058408338, 0.000915379263460636],
    [118.403409874851, 24.7206017098008, 0.00091544259339571],
  ],
  [
    [118.403971175078, 24.7200927102476, 0.000915377400815487],
    [118.403396308882, 24.7205885791599, 0.000915439799427986],
  ],
  [
    [118.403957609106, 24.7200795796566, 0.000915375538170338],
    [118.403382733033, 24.7205754485213, 0.000915438868105412],
  ],
  [
    [118.403944033257, 24.7200664580957, 0.000915373675525188],
    [118.40336915719, 24.7205623269092, 0.000915436074137688],
  ],
  [
    [118.403930457406, 24.7200533275058, 0.000915372744202614],
    [118.40335559123, 24.7205491962645, 0.000915434211492538],
  ],
  [
    [118.403916891446, 24.7200402059388, 0.000915371812880039],
    [118.403342015389, 24.7205360656221, 0.000915432348847389],
  ],
  [
    [118.403903315602, 24.7200270753463, 0.00091536995023489],
    [118.403328449438, 24.7205229440028, 0.000915431417524815],
  ],
  [
    [118.403889749644, 24.720013944749, 0.000915368087589741],
    [118.403314873602, 24.7205098133579, 0.000915429554879665],
  ],
  [
    [118.403876173809, 24.7200008231819, 0.000915366224944592],
    [118.403301297774, 24.7204966917395, 0.000915428623557091],
  ],
  [
    [118.403862597973, 24.7199876925856, 0.000915365293622017],
    [118.403287731828, 24.7204835610886, 0.000915425829589367],
  ],
  [
    [118.403849032023, 24.7199745619845, 0.000915362499654293],
    [118.403274156001, 24.7204704304399, 0.000915425829589367],
  ],
  [
    [118.403835456197, 24.7199614404136, 0.000915360637009144],
    [118.403260590064, 24.7204573088143, 0.000915423966944218],
  ],
  [
    [118.403821890253, 24.71994830981, 0.000915359705686569],
    [118.403247014243, 24.7204441781631, 0.000915421172976494],
  ],
  [
    [118.403808314428, 24.7199351792088, 0.00091535784304142],
    [118.403233438425, 24.7204310475106, 0.000915419310331345],
  ],
  [
    [118.403794738611, 24.719922057634, 0.000915355980396271],
    [118.403219872497, 24.7204179258812, 0.00091541837900877],
  ],
  [
    [118.403781172675, 24.7199089270267, 0.000915355049073696],
    [118.403206296684, 24.7204047952263, 0.000915416516363621],
  ],
  [
    [118.403767596863, 24.7198958054495, 0.000915353186428547],
    [118.403192730758, 24.7203916645666, 0.000915415585041046],
  ],
  [
    [118.403754030933, 24.7198826748396, 0.000915351323783398],
    [118.403179154955, 24.7203785429369, 0.000915412791073322],
  ],
  [
    [118.403740455123, 24.7198695442321, 0.000915350392460823],
    [118.403165579151, 24.7203654122782, 0.000915411859750748],
  ],
  [
    [118.403726879319, 24.7198564226511, 0.000915347598493099],
    [118.403152013234, 24.7203522816147, 0.000915409997105598],
  ],
  [
    [118.403713313398, 24.7198432920375, 0.000915346667170525],
    [118.403138437439, 24.7203391599813, 0.000915409997105598],
  ],
  [
    [118.403699737597, 24.7198301614262, 0.000915344804525375],
    [118.403124871527, 24.7203260293153, 0.000915408134460449],
  ],
  [
    [118.403686171685, 24.7198170398379, 0.000915344804525375],
    [118.403111295738, 24.7203129076793, 0.000915405340492725],
  ],
  [
    [118.403672595889, 24.719803909224, 0.000915342010557652],
    [118.403097719948, 24.7202997770143, 0.000915402546525002],
  ],
  [
    [118.403659020096, 24.7197907786089, 0.000915339216589928],
    [118.403084154045, 24.7202866463446, 0.000915402546525002],
  ],
  [
    [118.403645454193, 24.7197776570169, 0.000915339216589928],
    [118.403070578265, 24.7202735247048, 0.000915399752557278],
  ],
  [
    [118.403631878405, 24.7197645263992, 0.000915337353944778],
    [118.403057012367, 24.7202603940326, 0.000915398821234703],
  ],
  [
    [118.403618312504, 24.7197513957769, 0.000915335491299629],
    [118.403043436589, 24.7202472633625, 0.000915397889912128],
  ],
  [
    [118.403604736726, 24.7197382741846, 0.00091533362865448],
    [118.403029860817, 24.7202341417191, 0.000915396027266979],
  ],
  [
    [118.403591160947, 24.7197251435632, 0.000915331766009331],
    [118.403016294928, 24.720221011043, 0.000915392301976681],
  ],
  [
    [118.403577595058, 24.7197120219648, 0.000915329903364182],
    [118.403002719158, 24.7202078803692, 0.000915392301976681],
  ],
  [
    [118.403564019285, 24.719698891341, 0.000915328040719032],
    [118.402989153279, 24.7201947587185, 0.000915390439331532],
  ],
  [
    [118.403550453398, 24.7196857607123, 0.000915326178073883],
    [118.402975577514, 24.7201816280422, 0.000915389508008957],
  ],
  [
    [118.403536877634, 24.7196726391137, 0.000915325246751308],
    [118.402962001753, 24.7201684973646, 0.000915386714041233],
  ],
  [
    [118.403523301869, 24.7196595084861, 0.000915322452783585],
    [118.402948435882, 24.7201553757101, 0.000915385782718658],
  ],
  [
    [118.403509735991, 24.7196463778536, 0.00091532152146101],
    [118.402934860126, 24.72014224503, 0.000915382988750935],
  ],
  [
    [118.403496160236, 24.7196332562513, 0.000915320590138435],
    [118.402921294261, 24.720129123373, 0.00091538205742836],
  ],
  [
    [118.403482594363, 24.7196201256163, 0.000915318727493286],
    [118.402907718511, 24.7201159926904, 0.000915380194783211],
  ],
  [
    [118.40346901861, 24.7196069949836, 0.000915316864848137],
    [118.402894142764, 24.7201028620066, 0.000915380194783211],
  ],
  [
    [118.403455452746, 24.719593873374, 0.000915315002202988],
    [118.402880576907, 24.7200897403458, 0.000915377400815487],
  ],
  [
    [118.403441876999, 24.7195807427388, 0.000915314070880413],
    [118.402867001166, 24.7200766096594, 0.000915376469492912],
  ],
  [
    [118.403428301258, 24.7195676211302, 0.000915310345590115],
    [118.402853435311, 24.7200634789683, 0.000915374606847763],
  ],
  [
    [118.403414735399, 24.719554490489, 0.000915310345590115],
    [118.402839859579, 24.7200503573073, 0.000915371812880039],
  ],
  [
    [118.40340115966, 24.71954135985, 0.000915307551622391],
    [118.40282629373, 24.7200372266137, 0.000915370881557465],
  ],
  [
    [118.403387593811, 24.7195282382341, 0.000915306620299816],
    [118.402812718, 24.7200240959223, 0.000915369018912315],
  ],
  [
    [118.403374018078, 24.7195151075926, 0.000915305688977242],
    [118.402799142276, 24.7200109742575, 0.000915367156267166],
  ],
  [
    [118.403360442347, 24.7195019769499, 0.000915303826332092],
    [118.402785576436, 24.7199978435601, 0.000915365293622017],
  ],
  [
    [118.403346876507, 24.7194888553302, 0.000915301032364368],
    [118.402772000718, 24.7199847218927, 0.000915364362299442],
  ],
  [
    [118.403333300782, 24.719475724685, 0.000915300101041794],
    [118.402758434883, 24.7199715911928, 0.000915362499654293],
  ],
  [
    [118.403319734943, 24.719462594035, 0.000915299169719219],
    [118.402744859167, 24.7199584604952, 0.000915360637009144],
  ],
  [
    [118.403306159228, 24.719449472415, 0.00091529730707407],
    [118.402731283458, 24.7199453388241, 0.000915359705686569],
  ],
  [
    [118.403292583512, 24.719436341766, 0.000915296375751495],
    [118.402717717632, 24.7199322081204, 0.00091535784304142],
  ],
  [
    [118.403279017682, 24.7194232111122, 0.000915292650461197],
    [118.402704141925, 24.719919077419, 0.000915355980396271],
  ],
  [
    [118.403265441975, 24.7194100894885, 0.000915291719138622],
    [118.402690576108, 24.7199059557406, 0.000915354117751122],
  ],
  [
    [118.403251876151, 24.7193969588322, 0.000915290787816048],
    [118.402677000406, 24.7198928250367, 0.000915351323783398],
  ],
  [
    [118.403238300449, 24.719383837206, 0.000915289856493473],
    [118.402663424707, 24.7198796943315, 0.000915351323783398],
  ],
  [
    [118.403224724747, 24.7193707065507, 0.000915287062525749],
    [118.402649858899, 24.7198665726494, 0.000915350392460823],
  ],
  [
    [118.403211158932, 24.7193575758907, 0.0009152851998806],
    [118.402636283206, 24.7198534419417, 0.000915347598493099],
  ],
  [
    [118.403197583239, 24.7193444542607, 0.000915283337235451],
    [118.402622717399, 24.7198403112292, 0.00091534573584795],
  ],
  [
    [118.403184017429, 24.7193313235981, 0.000915281474590302],
    [118.402609141716, 24.7198271895468, 0.000915343873202801],
  ],
  [
    [118.403170441738, 24.7193181929378, 0.000915280543267727],
    [118.402595566032, 24.7198140588353, 0.000915342010557652],
  ],
  [
    [118.403156866054, 24.7193050713041, 0.000915278680622578],
    [118.402582000237, 24.7198009371469, 0.000915341079235077],
  ],
  [
    [118.403143300253, 24.7192919406378, 0.000915276817977428],
    [118.402568424559, 24.7197878064329, 0.000915339216589928],
  ],
  [
    [118.40312972457, 24.7192788099737, 0.000915274955332279],
    [118.402554858766, 24.7197746757142, 0.000915338285267353],
  ],
  [
    [118.403116158779, 24.7192656883327, 0.000915274024009705],
    [118.402541283097, 24.7197615540255, 0.000915336422622204],
  ],
  [
    [118.403102583102, 24.7192525576661, 0.000915272161364555],
    [118.402527707427, 24.7197484233078, 0.000915334559977055],
  ],
  [
    [118.403089007428, 24.7192394269982, 0.000915270298719406],
    [118.402514141643, 24.7197352925853, 0.000915332697331905],
  ],
  [
    [118.403075441645, 24.7192263053534, 0.000915269367396832],
    [118.402500565983, 24.7197221708928, 0.000915330834686756],
  ],
  [
    [118.403061865977, 24.7192131746831, 0.000915267504751682],
    [118.402487000204, 24.7197090401678, 0.000915330834686756],
  ],
  [
    [118.403048300199, 24.7192000530358, 0.000915266573429108],
    [118.402473424546, 24.7196959094451, 0.000915327109396458],
  ],
  [
    [118.403034724537, 24.7191869223629, 0.000915264710783958],
    [118.402459848894, 24.7196827877488, 0.000915327109396458],
  ],
  [
    [118.403021148878, 24.7191737916888, 0.000915262848138809],
    [118.402446283124, 24.7196696570201, 0.000915324315428734],
  ],
  [
    [118.403007583108, 24.7191606700377, 0.00091526098549366],
    [118.402432707478, 24.7196565353213, 0.000915322452783585],
  ],
  [
    [118.402994007455, 24.7191475393611, 0.000915259122848511],
    [118.402419141714, 24.7196434045901, 0.000915320590138435],
  ],
  [
    [118.402980441687, 24.7191344086797, 0.000915255397558212],
    [118.402405566069, 24.719630273861, 0.000915319658815861],
  ],
  [
    [118.402966866043, 24.7191212870284, 0.000915256328880787],
    [118.402391990431, 24.7196171521585, 0.000915316864848137],
  ],
  [
    [118.402953290398, 24.719108156348, 0.000915253534913063],
    [118.402378424676, 24.7196040214235, 0.000915316864848137],
  ],
  [
    [118.402939724639, 24.7190950256628, 0.000915251672267914],
    [118.40236484904, 24.7195908906906, 0.000915314070880413],
  ],
  [
    [118.402926149003, 24.7190819040077, 0.000915251672267914],
    [118.402351283294, 24.7195777689809, 0.000915313139557838],
  ],
  [
    [118.40291258325, 24.71906877332, 0.000915249809622765],
    [118.402337707664, 24.7195646382456, 0.000915311276912689],
  ],
  [
    [118.40289900762, 24.7190556516624, 0.000915247946977615],
    [118.402324132036, 24.719551507509, 0.000915310345590115],
  ],
  [
    [118.40288543199, 24.7190425209757, 0.000915247015655041],
    [118.402310566299, 24.7195383857955, 0.000915308482944965],
  ],
  [
    [118.402871866245, 24.7190293902843, 0.000915243290364742],
    [118.402296990677, 24.7195252550563, 0.000915305688977242],
  ],
  [
    [118.402858290624, 24.7190162686229, 0.000915242359042168],
    [118.402283424942, 24.7195121243125, 0.000915305688977242],
  ],
  [
    [118.402844724885, 24.719003137929, 0.000915240496397018],
    [118.40226984933, 24.7194990025987, 0.000915302895009518],
  ],
  [
    [118.402831149265, 24.7189900072373, 0.000915240496397018],
    [118.402256273717, 24.7194858718558, 0.000915302895009518],
  ],
  [
    [118.402817573652, 24.7189768855721, 0.000915237702429295],
    [118.402242707993, 24.7194727501361, 0.000915301032364368],
  ],
  [
    [118.402804007922, 24.7189637548744, 0.000915235839784145],
    [118.402229132386, 24.7194596193907, 0.000915299169719219],
  ],
  [
    [118.402790432311, 24.7189506241789, 0.000915233977138996],
    [118.402215566665, 24.7194464886406, 0.000915296375751495],
  ],
  [
    [118.40277686659, 24.7189375025065, 0.000915232114493847],
    [118.402201991067, 24.7194333669205, 0.000915295444428921],
  ],
  [
    [118.402763290985, 24.7189243718085, 0.000915232114493847],
    [118.402188415468, 24.7194202361713, 0.000915292650461197],
  ],
  [
    [118.402749715382, 24.7189112411093, 0.000915229320526123],
    [118.402174849755, 24.7194071054175, 0.000915291719138622],
  ],
  [
    [118.40273614967, 24.7188981194331, 0.000915228389203548],
    [118.402161274166, 24.7193939836936, 0.000915291719138622],
  ],
  [
    [118.402722574073, 24.7188849887314, 0.000915226526558399],
    [118.402147708459, 24.7193808529372, 0.000915288925170898],
  ],
  [
    [118.402709008367, 24.7188718670527, 0.00091522466391325],
    [118.402134132871, 24.7193677221831, 0.000915287062525749],
  ],
  [
    [118.402695432776, 24.7188587363484, 0.000915222801268101],
    [118.40212055729, 24.7193546004554, 0.0009152851998806],
  ],
  [
    [118.402681867071, 24.7188456056394, 0.000915221869945526],
    [118.402106991592, 24.7193414696953, 0.000915284268558025],
  ],
  [
    [118.402668291489, 24.7188324839605, 0.000915219075977802],
    [118.402093416017, 24.7193283479652, 0.000915282405912876],
  ],
  [
    [118.402654715907, 24.7188193532524, 0.000915218144655228],
    [118.402079850324, 24.7193152172025, 0.000915280543267727],
  ],
  [
    [118.402641150211, 24.7188062225396, 0.000915216282010078],
    [118.402066274751, 24.7193020864421, 0.000915279611945152],
  ],
  [
    [118.402627574638, 24.7187931008569, 0.000915215350687504],
    [118.402052699184, 24.7192889647081, 0.000915276817977428],
  ],
  [
    [118.402614008947, 24.7187799701416, 0.000915213488042355],
    [118.4020391335, 24.7192758339418, 0.000915274955332279],
  ],
  [
    [118.402600433376, 24.7187668394286, 0.000915213488042355],
    [118.402025557935, 24.7192627031775, 0.000915272161364555],
  ],
  [
    [118.402586857812, 24.7187537177421, 0.000915208831429482],
    [118.40201199226, 24.7192495814364, 0.000915271230041981],
  ],
  [
    [118.40257329213, 24.718740587023, 0.000915207900106907],
    [118.401998416701, 24.7192364506697, 0.000915271230041981],
  ],
  [
    [118.402559716571, 24.718727465334, 0.000915205106139183],
    [118.401984851029, 24.7192233198982, 0.000915269367396832],
  ],
  [
    [118.402546150895, 24.7187143346125, 0.000915204174816608],
    [118.401971275479, 24.7192101981568, 0.000915266573429108],
  ],
  [
    [118.402532575338, 24.7187012038931, 0.000915204174816608],
    [118.401957699928, 24.7191970673863, 0.000915264710783958],
  ],
  [
    [118.402518999788, 24.7186880822003, 0.000915201380848885],
    [118.401944134264, 24.7191839366111, 0.000915264710783958],
  ],
  [
    [118.40250543412, 24.718674951475, 0.000915199518203735],
    [118.401930558723, 24.7191708148659, 0.000915261916816235],
  ],
  [
    [118.402491858572, 24.7186618207519, 0.000915197655558586],
    [118.401916993065, 24.7191576840882, 0.00091526098549366],
  ],
  [
    [118.402478292913, 24.7186486990519, 0.000915196724236012],
    [118.401903417529, 24.7191445623405, 0.000915259122848511],
  ],
  [
    [118.402464717371, 24.7186355683263, 0.000915195792913437],
    [118.401889841993, 24.7191314315637, 0.000915257260203362],
  ],
  [
    [118.402451141831, 24.7186224375994, 0.000915192998945713],
    [118.401876276343, 24.7191183007822, 0.000915255397558212],
  ],
  [
    [118.402437576181, 24.7186093158956, 0.000915190204977989],
    [118.401862700816, 24.7191051790307, 0.000915254466235638],
  ],
  [
    [118.402424000647, 24.7185961851662, 0.000915191136300564],
    [118.401849135172, 24.7190920482467, 0.000915251672267914],
  ],
  [
    [118.402410435, 24.7185830544321, 0.000915189273655415],
    [118.401835559647, 24.7190789174649, 0.000915250740945339],
  ],
  [
    [118.402396859475, 24.7185699327281, 0.000915185548365116],
    [118.401821984129, 24.7190657957097, 0.00091524887830019],
  ],
  [
    [118.402383283949, 24.7185568019949, 0.000915184617042542],
    [118.401808418493, 24.7190526649219, 0.000915247946977615],
  ],
  [
    [118.402369718314, 24.7185436802848, 0.000915182754397392],
    [118.401794842976, 24.7190395341363, 0.000915245153009892],
  ],
  [
    [118.402356142794, 24.7185305495492, 0.000915181823074818],
    [118.40178127735, 24.7190264123739, 0.000915243290364742],
  ],
  [
    [118.402342577161, 24.7185174188088, 0.000915180891752243],
    [118.40176770184, 24.7190132815858, 0.000915244221687317],
  ],
  [
    [118.40232900165, 24.7185042970984, 0.000915179029107094],
    [118.401754126332, 24.7190001507965, 0.000915241427719593],
  ],
  [
    [118.402315426139, 24.718491166359, 0.000915177166461945],
    [118.401740560714, 24.7189870290302, 0.000915238633751869],
  ],
  [
    [118.402301860514, 24.7184780356149, 0.000915175303816795],
    [118.401726985212, 24.7189738982384, 0.000915237702429295],
  ],
  [
    [118.402288285012, 24.7184649139007, 0.000915174372494221],
    [118.4017134196, 24.7189607764697, 0.00091523677110672],
  ],
  [
    [118.402274719393, 24.7184517831541, 0.000915172509849072],
    [118.401699844103, 24.7189476456753, 0.000915233977138996],
  ],
  [
    [118.402261143893, 24.7184386524096, 0.000915170647203922],
    [118.40168626861, 24.7189345148797, 0.000915233045816422],
  ],
  [
    [118.4022475684, 24.7184255306917, 0.000915167853236198],
    [118.401672703006, 24.7189213931072, 0.000915230251848698],
  ],
  [
    [118.402234002789, 24.7184123999413, 0.000915166921913624],
    [118.401659127518, 24.718908262309, 0.000915229320526123],
  ],
  [
    [118.402220427301, 24.7183992782209, 0.000915163196623325],
    [118.401645561917, 24.7188951315062, 0.000915226526558399],
  ],
  [
    [118.402206861696, 24.718386147468, 0.000915163196623325],
    [118.401631986438, 24.7188820097334, 0.000915226526558399],
  ],
  [
    [118.402193286211, 24.7183730167172, 0.000915162265300751],
    [118.401618410959, 24.7188688789315, 0.000915223732590675],
  ],
  [
    [118.402179710731, 24.718359894993, 0.000915160402655602],
    [118.401604845366, 24.7188557481249, 0.000915222801268101],
  ],
  [
    [118.402166145135, 24.7183467642363, 0.000915158540010452],
    [118.401591269896, 24.7188426263483, 0.000915221869945526],
  ],
  [
    [118.402152569658, 24.7183336334818, 0.000915157608687878],
    [118.401577704309, 24.7188294955392, 0.000915219075977802],
  ],
  [
    [118.402139004071, 24.7183205117504, 0.000915155746042728],
    [118.401564128845, 24.7188163737601, 0.000915216282010078],
  ],
  [
    [118.402125428599, 24.7183073809934, 0.000915154814720154],
    [118.401550553379, 24.7188032429519, 0.000915215350687504],
  ],
  [
    [118.402111853131, 24.7182942502351, 0.00091515202075243],
    [118.401536987801, 24.7187901121391, 0.000915214419364929],
  ],
  [
    [118.402098287552, 24.7182811285, 0.000915149226784706],
    [118.401523412345, 24.7187769903562, 0.000915211625397205],
  ],
  [
    [118.402084712089, 24.7182679977392, 0.000915147364139557],
    [118.401509846772, 24.7187638595409, 0.000915210694074631],
  ],
  [
    [118.402071146513, 24.7182548669737, 0.000915146432816982],
    [118.401496271318, 24.7187507287276, 0.000915208831429482],
  ],
  [
    [118.402057571059, 24.7182417452382, 0.000915144570171833],
    [118.401482695871, 24.718737606941, 0.000915208831429482],
  ],
  [
    [118.402043995605, 24.7182286144737, 0.000915142707526684],
    [118.401469130307, 24.7187244761219, 0.000915206037461758],
  ],
  [
    [118.402030430041, 24.7182154927323, 0.000915140844881535],
    [118.401455554861, 24.7187113453049, 0.000915205106139183],
  ],
  [
    [118.402016854592, 24.7182023619652, 0.000915141776204109],
    [118.401441989306, 24.7186982235111, 0.000915203243494034],
  ],
  [
    [118.40200328903, 24.7181892311934, 0.000915140844881535],
    [118.401428413867, 24.7186850926916, 0.000915201380848885],
  ],
  [
    [118.401989713591, 24.7181761094517, 0.000915138050913811],
    [118.40141483843, 24.7186719618708, 0.000915198586881161],
  ],
  [
    [118.40197613815, 24.7181629786808, 0.000915135256946087],
    [118.401401272884, 24.7186588400733, 0.000915197655558586],
  ],
  [
    [118.401962572597, 24.7181498479053, 0.000915134325623512],
    [118.401387697453, 24.71864570925, 0.000915195792913437],
  ],
  [
    [118.401948997166, 24.7181367261598, 0.000915132462978363],
    [118.401374131912, 24.7186325874499, 0.000915192998945713],
  ],
  [
    [118.401935431618, 24.7181235953818, 0.000915131531655788],
    [118.401360556486, 24.7186194566242, 0.000915192998945713],
  ],
  [
    [118.401921856189, 24.7181104646059, 0.00091512780636549],
    [118.401346981064, 24.7186063257971, 0.000915192998945713],
  ],
  [
    [118.401908280767, 24.7180973428566, 0.00091512780636549],
    [118.401333415532, 24.7185932039933, 0.000915189273655415],
  ],
  [
    [118.401894715227, 24.7180842120748, 0.000915126875042915],
    [118.401319840115, 24.7185800731637, 0.00091518834233284],
  ],
  [
    [118.401881139811, 24.718071090323, 0.000915123149752617],
    [118.401306274585, 24.7185669423296, 0.000915186479687691],
  ],
  [
    [118.401867574277, 24.7180579595387, 0.000915123149752617],
    [118.401292699177, 24.7185538205253, 0.000915184617042542],
  ],
  [
    [118.401853998863, 24.7180448287566, 0.000915120355784893],
    [118.401279123769, 24.718540689692, 0.000915181823074818],
  ],
  [
    [118.401840433338, 24.7180317069976, 0.000915117561817169],
    [118.401265558247, 24.7185275588541, 0.000915181823074818],
  ],
  [
    [118.401826857929, 24.7180185762129, 0.000915118493139744],
    [118.401251982849, 24.7185144370461, 0.000915180891752243],
  ],
  [
    [118.401813282524, 24.718005445427, 0.000915117561817169],
    [118.401238417333, 24.7185013062056, 0.000915178097784519],
  ],
  [
    [118.401799717008, 24.7179923236643, 0.000915112905204296],
    [118.40122484194, 24.7184881843951, 0.000915175303816795],
  ],
  [
    [118.401786141607, 24.7179791928759, 0.000915114767849445],
    [118.401211276429, 24.7184750535522, 0.000915173441171646],
  ],
  [
    [118.401772576093, 24.7179660620828, 0.000915110111236572],
    [118.401197701038, 24.7184619227113, 0.000915173441171646],
  ],
  [
    [118.401759000703, 24.7179529403197, 0.000915108248591423],
    [118.401184125654, 24.718448800897, 0.000915172509849072],
  ],
  [
    [118.401745425311, 24.7179398095275, 0.000915107317268848],
    [118.401170560152, 24.7184356700503, 0.000915168784558773],
  ],
  [
    [118.401731859806, 24.7179266787306, 0.000915107317268848],
    [118.401156984769, 24.7184225392057, 0.000915168784558773],
  ],
  [
    [118.401718284423, 24.7179135569637, 0.000915105454623699],
    [118.401143419277, 24.7184094173843, 0.000915165990591049],
  ],
  [
    [118.401704718924, 24.7179004261644, 0.00091510359197855],
    [118.4011298439, 24.7183962865372, 0.0009151641279459],
  ],
  [
    [118.401691143547, 24.717887304395, 0.000915100798010826],
    [118.401116268526, 24.7183831556888, 0.000915163196623325],
  ],
  [
    [118.40167756817, 24.7178741735965, 0.000915098935365677],
    [118.401102703042, 24.7183700338636, 0.000915161333978176],
  ],
  [
    [118.401664002678, 24.7178610427934, 0.000915098004043102],
    [118.401089127674, 24.7183569030127, 0.000915158540010452],
  ],
  [
    [118.40165042731, 24.7178479210202, 0.000915096141397953],
    [118.401075562192, 24.7183437721572, 0.000915159471333027],
  ],
  [
    [118.401636861825, 24.7178347902146, 0.000915094278752804],
    [118.401061986833, 24.7183306503316, 0.000915155746042728],
  ],
  [
    [118.401623286459, 24.7178216594111, 0.000915093347430229],
    [118.401048411473, 24.718317519477, 0.000915153883397579],
  ],
  [
    [118.401609711099, 24.7178085376342, 0.000915090553462505],
    [118.401034846003, 24.7183043976455, 0.000915153883397579],
  ],
  [
    [118.401596145622, 24.7177954068248, 0.000915089622139931],
    [118.401021270649, 24.7182912667884, 0.000915151089429855],
  ],
  [
    [118.401582570265, 24.7177822760176, 0.000915087759494781],
    [118.401007705181, 24.7182781359266, 0.000915149226784706],
  ],
  [
    [118.401569004797, 24.7177691542335, 0.000915085896849632],
    [118.400994129837, 24.7182650140947, 0.000915146432816982],
  ],
  [
    [118.401555429446, 24.7177560234237, 0.000915084965527058],
    [118.400980554491, 24.7182518832338, 0.000915147364139557],
  ],
  [
    [118.401541854097, 24.7177428926127, 0.000915083102881908],
    [118.400966989032, 24.7182387523682, 0.000915144570171833],
  ],
  [
    [118.401528288638, 24.7177297708248, 0.000915082171559334],
    [118.400953413696, 24.7182256305326, 0.000915144570171833],
  ],
  [
    [118.401514713294, 24.7177166400113, 0.000915080308914185],
    [118.400939848243, 24.7182124996645, 0.000915141776204109],
  ],
  [
    [118.401501147841, 24.7177035182209, 0.000915077514946461],
    [118.400926272908, 24.7181993687986, 0.000915138982236385],
  ],
  [
    [118.401487572503, 24.7176903874049, 0.000915078446269035],
    [118.400912697581, 24.7181862469592, 0.000915137119591236],
  ],
  [
    [118.401473997169, 24.7176772565876, 0.000915074720978737],
    [118.400899132136, 24.7181731160874, 0.000915137119591236],
  ],
  [
    [118.401460431724, 24.7176641347934, 0.000915073789656162],
    [118.400885556814, 24.7181599942455, 0.000915137119591236],
  ],
  [
    [118.401446856395, 24.7176510039736, 0.000915071927011013],
    [118.400871991375, 24.7181468633711, 0.000915132462978363],
  ],
  [
    [118.401433290952, 24.7176378731492, 0.000915069133043289],
    [118.400858416055, 24.7181337324989, 0.000915133394300938],
  ],
  [
    [118.401419715633, 24.7176247513547, 0.00091506727039814],
    [118.400844840742, 24.7181206106532, 0.000915130600333214],
  ],
  [
    [118.401406140312, 24.7176116205311, 0.000915066339075565],
    [118.400831275311, 24.7181074797751, 0.000915129669010639],
  ],
  [
    [118.401392574878, 24.7175984897029, 0.000915064476430416],
    [118.4008177, 24.7180943488991, 0.000915125943720341],
  ],
  [
    [118.401378999567, 24.7175853679046, 0.000915064476430416],
    [118.400804134578, 24.7180812270463, 0.000915125012397766],
  ],
  [
    [118.401365434138, 24.7175722370739, 0.000915061682462692],
    [118.400790559273, 24.7180680961678, 0.000915124081075192],
  ],
  [
    [118.401351858833, 24.7175591152731, 0.000915060751140118],
    [118.40077698397, 24.7180549652881, 0.000915123149752617],
  ],
  [
    [118.401338283527, 24.7175459844432, 0.000915058888494968],
    [118.400763418557, 24.7180418434315, 0.000915120355784893],
  ],
  [
    [118.401324718107, 24.7175328536087, 0.000915057025849819],
    [118.40074984326, 24.7180287125492, 0.000915118493139744],
  ],
  [
    [118.40131114281, 24.7175197318042, 0.000915056094527245],
    [118.400736277849, 24.7180155816623, 0.000915117561817169],
  ],
  [
    [118.401297577395, 24.7175066009672, 0.000915054231882095],
    [118.400722702561, 24.7180024598054, 0.00091511569917202],
  ],
  [
    [118.4012840021, 24.7174934701323, 0.000915051437914371],
    [118.400709127273, 24.7179893289193, 0.000915113836526871],
  ],
  [
    [118.401270426812, 24.717480348324, 0.000915051437914371],
    [118.400695561874, 24.7179762070565, 0.000915112905204296],
  ],
  [
    [118.401256861406, 24.7174672174832, 0.000915048643946648],
    [118.400681986591, 24.7179630761679, 0.000915110111236572],
  ],
  [
    [118.40124328612, 24.7174540866445, 0.000915045849978924],
    [118.400668421195, 24.7179499452748, 0.000915109179913998],
  ],
  [
    [118.401229720724, 24.7174409648291, 0.0009150430560112],
    [118.400654845921, 24.7179368234115, 0.000915106385946274],
  ],
  [
    [118.401216145443, 24.7174278339879, 0.000915043987333775],
    [118.400641270647, 24.7179236925192, 0.000915104523301125],
  ],
  [
    [118.401202570165, 24.7174147031455, 0.000915041193366051],
    [118.400627705259, 24.7179105616223, 0.00091510359197855],
  ],
  [
    [118.401189004778, 24.7174015813263, 0.000915040262043476],
    [118.400614129994, 24.7178974397553, 0.000915102660655975],
  ],
  [
    [118.401175429505, 24.7173884504813, 0.000915037468075752],
    [118.400600564612, 24.7178843088558, 0.000915100798010826],
  ],
  [
    [118.401161864123, 24.7173753286596, 0.000915037468075752],
    [118.400586989349, 24.7178711779585, 0.000915098004043102],
  ],
  [
    [118.401148288857, 24.7173621978122, 0.000915036536753178],
    [118.400573414093, 24.7178580560877, 0.000915096141397953],
  ],
  [
    [118.401134713593, 24.7173490669635, 0.000915032811462879],
    [118.400559848719, 24.7178449251845, 0.000915097072720528],
  ],
  [
    [118.40112114822, 24.717335945138, 0.000915030017495155],
    [118.400546273468, 24.7178318033112, 0.000915093347430229],
  ],
  [
    [118.401107572962, 24.7173228142868, 0.000915029086172581],
    [118.4005327081, 24.7178186724055, 0.000915093347430229],
  ],
  [
    [118.40109400759, 24.7173096834309, 0.000915028154850006],
    [118.400519132851, 24.7178055415019, 0.000915090553462505],
  ],
  [
    [118.401080432342, 24.717296561605, 0.000915027223527431],
    [118.400505557609, 24.7177924196248, 0.000915090553462505],
  ],
  [
    [118.401066866976, 24.7172834307467, 0.000915025360882282],
    [118.40049199225, 24.7177792887153, 0.000915088690817356],
  ],
  [
    [118.40105329173, 24.7172702998905, 0.000915022566914558],
    [118.400478417009, 24.7177661578079, 0.000915084965527058],
  ],
  [
    [118.40103971649, 24.7172571780608, 0.000915022566914558],
    [118.400464851659, 24.7177530359238, 0.000915084965527058],
  ],
  [
    [118.401026151132, 24.7172440471987, 0.000915020704269409],
    [118.400451276425, 24.7177399050139, 0.000915082171559334],
  ],
  [
    [118.401012575898, 24.7172309253665, 0.000915017910301685],
    [118.400437711077, 24.7177267740994, 0.000915081240236759],
  ],
  [
    [118.400999010546, 24.7172177945019, 0.000915016978979111],
    [118.400424135852, 24.7177136522148, 0.000915078446269035],
  ],
  [
    [118.400985435314, 24.7172046636394, 0.000915015116333961],
    [118.400410560626, 24.7177005213011, 0.000915078446269035],
  ],
  [
    [118.400971860088, 24.7171915418035, 0.000915013253688812],
    [118.400396995286, 24.7176873903829, 0.000915076583623886],
  ],
  [
    [118.400958294745, 24.7171784109351, 0.000915012322366238],
    [118.40038342007, 24.7176742684945, 0.000915073789656162],
  ],
  [
    [118.400944719522, 24.7171652800688, 0.000915009528398514],
    [118.400369854736, 24.7176611375737, 0.000915072858333588],
  ],
  [
    [118.400931154188, 24.7171521582257, 0.000915008597075939],
    [118.400356279525, 24.7176480156829, 0.000915070995688438],
  ],
  [
    [118.40091757897, 24.717139027357, 0.00091500673443079],
    [118.400342704313, 24.7176348847629, 0.000915068201720715],
  ],
  [
    [118.400904003755, 24.7171258964869, 0.00091500673443079],
    [118.400329138988, 24.7176217538384, 0.000915068201720715],
  ],
  [
    [118.40089043843, 24.7171127746401, 0.000915003940463066],
    [118.400315563786, 24.7176086319437, 0.00091506727039814],
  ],
  [
    [118.40087686322, 24.7170996437675, 0.000915002077817917],
    [118.400301998466, 24.7175955010167, 0.000915063545107841],
  ],
  [
    [118.400863297897, 24.7170865128904, 0.000915001146495342],
    [118.400288423266, 24.7175823700917, 0.000915061682462692],
  ],
  [
    [118.400849722697, 24.7170733910431, 0.000914999283850193],
    [118.400274848072, 24.7175692481933, 0.000915060751140118],
  ],
  [
    [118.400836147496, 24.7170602601668, 0.000914997421205044],
    [118.400261282761, 24.7175561172625, 0.000915057957172394],
  ],
  [
    [118.400822582185, 24.7170471383137, 0.000914995558559895],
    [118.400247707569, 24.7175429863338, 0.000915057025849819],
  ],
  [
    [118.40080900699, 24.7170340074349, 0.000914993695914745],
    [118.400234142267, 24.7175298644283, 0.000915056094527245],
  ],
  [
    [118.400795441681, 24.7170208765514, 0.000914991833269596],
    [118.400220567081, 24.7175167334971, 0.000915054231882095],
  ],
  [
    [118.400781866495, 24.7170077546979, 0.000914989970624447],
    [118.400206991898, 24.7175036025645, 0.000915053300559521],
  ],
  [
    [118.400768291308, 24.7169946238153, 0.000914989970624447],
    [118.400193426605, 24.7174904806553, 0.000915050506591797],
  ],
  [
    [118.400754726008, 24.7169814929281, 0.000914988107979298],
    [118.400179851427, 24.7174773497203, 0.000915049575269222],
  ],
  [
    [118.400741150831, 24.7169683710708, 0.000914985314011574],
    [118.40016628614, 24.7174642278085, 0.000915047712624073],
  ],
  [
    [118.400727585536, 24.7169552401811, 0.000914983451366425],
    [118.400152710968, 24.717451096871, 0.000915045849978924],
  ],
  [
    [118.400714010361, 24.7169421092935, 0.000914981588721275],
    [118.400139135799, 24.7174379659322, 0.000915046781301498],
  ],
  [
    [118.400700435192, 24.7169289874324, 0.000914980657398701],
    [118.40012557052, 24.7174248440167, 0.000915042124688625],
  ],
  [
    [118.400686869906, 24.716915856539, 0.000914979726076126],
    [118.400111995357, 24.7174117130754, 0.000915041193366051],
  ],
  [
    [118.400673294743, 24.7169027346754, 0.000914976932108402],
    [118.40009843008, 24.7173985821295, 0.000915040262043476],
  ],
  [
    [118.400659729462, 24.7168896037794, 0.000914976932108402],
    [118.400084854926, 24.7173854602135, 0.000915037468075752],
  ],
  [
    [118.400646154301, 24.7168764728855, 0.000914975069463253],
    [118.400071279771, 24.7173723292685, 0.000915036536753178],
  ],
  [
    [118.400632579147, 24.7168633510182, 0.000914972275495529],
    [118.400057714503, 24.7173591983188, 0.000915034674108028],
  ],
  [
    [118.400619013875, 24.7168502201184, 0.000914971344172955],
    [118.400044139357, 24.7173460763991, 0.000915033742785454],
  ],
  [
    [118.400605438722, 24.7168370892208, 0.000914967618882656],
    [118.400030574095, 24.7173329454469, 0.00091503094881773],
  ],
  [
    [118.40059187346, 24.7168239673463, 0.000914968550205231],
    [118.400016998955, 24.7173198235247, 0.00091503094881773],
  ],
  [
    [118.400578298313, 24.7168108364462, 0.000914966687560081],
    [118.400003423814, 24.7173066925733, 0.000915028154850006],
  ],
  [
    [118.400564723169, 24.7167977055447, 0.000914964824914932],
    [118.39998985856, 24.7172935616174, 0.000915027223527431],
  ],
  [
    [118.400551157915, 24.7167845836665, 0.000914962962269783],
    [118.399976283429, 24.7172804396914, 0.000915025360882282],
  ],
  [
    [118.400537582777, 24.7167714527626, 0.000914962962269783],
    [118.399962718181, 24.717267308733, 0.000915022566914558],
  ],
  [
    [118.400524017525, 24.716758321854, 0.000914960168302059],
    [118.399949143052, 24.7172541777766, 0.000915021635591984],
  ],
  [
    [118.400510442396, 24.7167451999754, 0.00091495830565691],
    [118.399935567929, 24.7172410558468, 0.000915020704269409],
  ],
  [
    [118.400496867266, 24.7167320690677, 0.000914957374334335],
    [118.399922002689, 24.7172279248847, 0.00091501884162426],
  ],
  [
    [118.400483302026, 24.7167189471832, 0.000914954580366611],
    [118.399908427568, 24.7172147939245, 0.000915017910301685],
  ],
  [
    [118.400469726902, 24.716705816273, 0.000914953649044037],
    [118.399894862338, 24.7172016719877, 0.000915014185011387],
  ],
  [
    [118.400456161664, 24.7166926853582, 0.000914951786398888],
    [118.399881287223, 24.717188541025, 0.000915014185011387],
  ],
  [
    [118.40044258655, 24.7166795634733, 0.000914949923753738],
    [118.399867712111, 24.7171754100611, 0.000915012322366238],
  ],
  [
    [118.400429011434, 24.7166664325593, 0.000914948061108589],
    [118.399854146889, 24.7171622881205, 0.000915010459721088],
  ],
  [
    [118.400415446205, 24.7166533016407, 0.00091494619846344],
    [118.399840571783, 24.7171491571541, 0.000915007665753365],
  ],
  [
    [118.400401871099, 24.716640179752, 0.000914944335818291],
    [118.399827006566, 24.717136035211, 0.000915007665753365],
  ],
  [
    [118.400388305875, 24.716627048831, 0.000914944335818291],
    [118.399813431466, 24.7171229042421, 0.000915005803108215],
  ],
  [
    [118.400374730771, 24.716613917912, 0.000914940610527992],
    [118.399799856368, 24.7171097732719, 0.000915003940463066],
  ],
  [
    [118.400361155674, 24.7166007960195, 0.000914939679205418],
    [118.39978629116, 24.717096651325, 0.000915002077817917],
  ],
  [
    [118.400347590459, 24.7165876650947, 0.000914938747882843],
    [118.399772716068, 24.7170835203523, 0.000914999283850193],
  ],
  [
    [118.400334015363, 24.7165745341719, 0.000914935953915119],
    [118.399759150862, 24.7170703893751, 0.000915000215172768],
  ],
  [
    [118.400320450157, 24.7165614122724, 0.00091493409126997],
    [118.399745575779, 24.7170572674277, 0.000914996489882469],
  ],
  [
    [118.400306875068, 24.7165482813471, 0.000914931297302246],
    [118.399732000696, 24.7170441364513, 0.000914993695914745],
  ],
  [
    [118.400293309868, 24.716535159445, 0.000914931297302246],
    [118.399718435499, 24.7170310054703, 0.000914992764592171],
  ],
  [
    [118.400279734784, 24.7165220285172, 0.000914930365979671],
    [118.399704860424, 24.7170178835191, 0.000914991833269596],
  ],
  [
    [118.400266159702, 24.7165088975882, 0.000914929434657097],
    [118.399691295233, 24.7170047525356, 0.000914991833269596],
  ],
  [
    [118.400252594511, 24.7164957756824, 0.000914926640689373],
    [118.399677720164, 24.716991630582, 0.000914989039301872],
  ],
  [
    [118.400239019435, 24.7164826447508, 0.000914925709366798],
    [118.399664154978, 24.716978499596, 0.000914987176656723],
  ],
  [
    [118.400225454246, 24.7164695138147, 0.000914924778044224],
    [118.399650579912, 24.716965368612, 0.000914985314011574],
  ],
  [
    [118.40021187918, 24.7164563919084, 0.0009149219840765],
    [118.399637004852, 24.7169522466546, 0.000914984382688999],
  ],
  [
    [118.400198304113, 24.7164432609731, 0.000914921052753925],
    [118.399623439675, 24.7169391156648, 0.00091498252004385],
  ],
  [
    [118.400184738932, 24.7164301300332, 0.000914917327463627],
    [118.399609864617, 24.716925984677, 0.000914980657398701],
  ],
  [
    [118.400171163874, 24.7164170081232, 0.000914917327463627],
    [118.399596299449, 24.7169128627126, 0.000914979726076126],
  ],
  [
    [118.400157598699, 24.7164038771807, 0.000914915464818478],
    [118.399582724397, 24.7168997317223, 0.000914977863430977],
  ],
  [
    [118.400144023647, 24.7163907552682, 0.000914914533495903],
    [118.399569149347, 24.7168866007308, 0.000914974138140678],
  ],
  [
    [118.400130448594, 24.7163776243266, 0.000914912670850754],
    [118.399555584188, 24.7168734787626, 0.000914974138140678],
  ],
  [
    [118.400116883427, 24.7163644933804, 0.000914910808205605],
    [118.399542009144, 24.7168603477685, 0.000914973206818104],
  ],
  [
    [118.400103308384, 24.7163513714641, 0.000914908014237881],
    [118.399528443987, 24.71684721677, 0.00091497041285038],
  ],
  [
    [118.400089743223, 24.7163382405154, 0.000914908014237881],
    [118.399514868952, 24.7168340948013, 0.000914968550205231],
  ],
  [
    [118.400076168181, 24.7163251095688, 0.000914905220270157],
    [118.399501293917, 24.7168209638035, 0.000914967618882656],
  ],
  [
    [118.400062593147, 24.7163119876487, 0.000914903357625008],
    [118.399487728772, 24.716807841829, 0.000914965756237507],
  ],
  [
    [118.400049027994, 24.7162988566963, 0.000914901494979858],
    [118.399474153743, 24.7167947108287, 0.000914963893592358],
  ],
  [
    [118.400035452961, 24.7162857257459, 0.000914900563657284],
    [118.3994605886, 24.7167815798238, 0.000914962030947208],
  ],
  [
    [118.400021887818, 24.7162726038188, 0.000914898701012135],
    [118.399447013579, 24.7167684578488, 0.000914960168302059],
  ],
  [
    [118.400008312791, 24.7162594728659, 0.00091489776968956],
    [118.399433438559, 24.7167553268448, 0.000914959236979485],
  ],
  [
    [118.399994737767, 24.7162463419117, 0.000914895907044411],
    [118.399419873424, 24.7167421958362, 0.000914957374334335],
  ],
  [
    [118.399981172632, 24.7162332199808, 0.000914893113076687],
    [118.399406298412, 24.7167290738574, 0.000914956443011761],
  ],
  [
    [118.399967597614, 24.7162200890241, 0.000914892181754112],
    [118.399392733283, 24.7167159428463, 0.000914954580366611],
  ],
  [
    [118.399954032485, 24.7162069670907, 0.000914891250431538],
    [118.399379158274, 24.7167028118372, 0.000914951786398888],
  ],
  [
    [118.399940457472, 24.7161938361315, 0.000914887525141239],
    [118.399365583271, 24.7166896898547, 0.000914951786398888],
  ],
  [
    [118.399926882462, 24.7161807051711, 0.000914888456463814],
    [118.399352018151, 24.7166765588398, 0.000914949923753738],
  ],
  [
    [118.399913317341, 24.7161675832339, 0.00091488566249609],
    [118.399338443153, 24.7166634368548, 0.000914947129786015],
  ],
  [
    [118.399899742337, 24.7161544522709, 0.000914883799850941],
    [118.399324878038, 24.7166503058374, 0.00091494619846344],
  ],
  [
    [118.399886177219, 24.7161413213034, 0.000914882868528366],
    [118.399311303043, 24.716637174822, 0.000914944335818291],
  ],
  [
    [118.399872602224, 24.7161281993658, 0.000914881005883217],
    [118.399297728054, 24.7166240528332, 0.000914942473173141],
  ],
  [
    [118.399859027228, 24.7161150683991, 0.000914879143238068],
    [118.399284162948, 24.7166109218121, 0.000914941541850567],
  ],
  [
    [118.399845462118, 24.7161019374278, 0.000914877280592918],
    [118.399270587962, 24.716597790793, 0.000914940610527992],
  ],
  [
    [118.399831887131, 24.7160888154864, 0.000914874486625195],
    [118.399257022865, 24.7165846687971, 0.000914936885237694],
  ],
  [
    [118.399818322027, 24.7160756845126, 0.00091487355530262],
    [118.399243447884, 24.7165715377755, 0.000914935953915119],
  ],
  [
    [118.399804747047, 24.7160625625687, 0.000914872623980045],
    [118.399229872906, 24.7165584067526, 0.00091493409126997],
  ],
  [
    [118.399791172065, 24.7160494315957, 0.000914870761334896],
    [118.399216307817, 24.716545284753, 0.000914933159947395],
  ],
  [
    [118.39977760697, 24.7160363006182, 0.000914868898689747],
    [118.399202732845, 24.7165321537276, 0.000914930365979671],
  ],
  [
    [118.399764031997, 24.7160231786705, 0.000914868898689747],
    [118.399189167759, 24.7165190226977, 0.000914929434657097],
  ],
  [
    [118.399750466907, 24.7160100476904, 0.000914865173399448],
    [118.399175592795, 24.7165059006975, 0.000914927572011948],
  ],
  [
    [118.399736891937, 24.7159969167124, 0.000914863310754299],
    [118.399162017832, 24.7164927696684, 0.000914927572011948],
  ],
  [
    [118.399723316973, 24.715983794761, 0.000914862379431725],
    [118.399148452757, 24.7164796476625, 0.000914924778044224],
  ],
  [
    [118.399709751892, 24.7159706637771, 0.00091486144810915],
    [118.399134877799, 24.7164665166308, 0.000914923846721649],
  ],
  [
    [118.399696176931, 24.7159575327953, 0.000914858654141426],
    [118.399121312727, 24.7164533855946, 0.000914921052753925],
  ],
  [
    [118.399682611859, 24.7159444108369, 0.000914856791496277],
    [118.399107737778, 24.7164402635882, 0.000914920121431351],
  ],
  [
    [118.399669036903, 24.7159312798526, 0.000914855860173702],
    [118.399094162829, 24.7164271325528, 0.000914918258786201],
  ],
  [
    [118.39965546195, 24.715918148867, 0.000914853997528553],
    [118.399080597765, 24.7164140015128, 0.000914916396141052],
  ],
  [
    [118.399641896886, 24.7159050269047, 0.000914853066205978],
    [118.399067022825, 24.7164008795027, 0.000914914533495903],
  ],
  [
    [118.399628321939, 24.7158918959167, 0.000914850272238255],
    [118.399053457767, 24.7163877484602, 0.000914912670850754],
  ],
  [
    [118.399614756881, 24.7158787739519, 0.00091484934091568],
    [118.399039882829, 24.7163746174197, 0.000914912670850754],
  ],
  [
    [118.399601181939, 24.7158656429613, 0.000914846546947956],
    [118.399026307897, 24.7163614954058, 0.00091490987688303],
  ],
  [
    [118.399587607, 24.7158525119695, 0.000914846546947956],
    [118.399012742848, 24.7163483643596, 0.000914908014237881],
  ],
  [
    [118.399574041951, 24.715839390001, 0.000914844684302807],
    [118.398999167918, 24.7163352333153, 0.000914906151592731],
  ],
  [
    [118.399560467018, 24.7158262590066, 0.000914843752980232],
    [118.398985602878, 24.7163221112944, 0.000914904288947582],
  ],
  [
    [118.399546901971, 24.7158131280078, 0.000914841890335083],
    [118.398972027954, 24.7163089802476, 0.000914904288947582],
  ],
  [
    [118.399533327047, 24.7158000060387, 0.000914840959012508],
    [118.398958453036, 24.7162958582274, 0.000914900563657284],
  ],
  [
    [118.399519762006, 24.7157868750373, 0.000914838165044785],
    [118.398944888001, 24.716282727175, 0.000914900563657284],
  ],
  [
    [118.399506187084, 24.715773744038, 0.000914836302399635],
    [118.398931313086, 24.7162695961244, 0.000914898701012135],
  ],
  [
    [118.399492612168, 24.7157606220652, 0.000914834439754486],
    [118.39891774806, 24.7162564740972, 0.000914896838366985],
  ],
  [
    [118.399479047136, 24.71574749106, 0.000914833508431911],
    [118.39890417315, 24.7162433430442, 0.000914894975721836],
  ],
  [
    [118.399465472226, 24.7157343690847, 0.000914831645786762],
    [118.398890608127, 24.7162302119867, 0.000914894044399261],
  ],
  [
    [118.399451907199, 24.7157212380771, 0.000914830714464188],
    [118.398877033226, 24.716217089959, 0.000914892181754112],
  ],
  [
    [118.399438332291, 24.7157081070715, 0.000914826989173889],
    [118.398863458325, 24.7162039589022, 0.000914890319108963],
  ],
  [
    [118.39942475739, 24.7156949850924, 0.000914826989173889],
    [118.39884989331, 24.7161908278409, 0.000914888456463814],
  ],
  [
    [118.399411192371, 24.715681854081, 0.00091482512652874],
    [118.398836318418, 24.7161777058094, 0.000914886593818665],
  ],
  [
    [118.399397617472, 24.7156687230715, 0.000914823263883591],
    [118.398822753408, 24.7161645747456, 0.00091488566249609],
  ],
  [
    [118.399384052463, 24.7156556010854, 0.000914821401238441],
    [118.398809178522, 24.7161514527116, 0.000914883799850941],
  ],
  [
    [118.39937047757, 24.7156424700735, 0.000914820469915867],
    [118.398795603635, 24.7161383216485, 0.000914881937205791],
  ],
  [
    [118.399356902679, 24.7156293390604, 0.000914817675948143],
    [118.398782038634, 24.7161251905809, 0.000914880074560642],
  ],
  [
    [118.399343337678, 24.7156162170705, 0.000914817675948143],
    [118.398768463756, 24.7161120685432, 0.000914878211915493],
  ],
  [
    [118.399329762794, 24.7156030860548, 0.000914814881980419],
    [118.398754898761, 24.7160989374731, 0.000914877280592918],
  ],
  [
    [118.399316197795, 24.7155899550346, 0.000914811156690121],
    [118.398741323886, 24.716085806405, 0.000914874486625195],
  ],
  [
    [118.399302622919, 24.7155768330442, 0.000914812088012695],
    [118.398727749017, 24.7160726843635, 0.00091487355530262],
  ],
  [
    [118.399289048043, 24.7155637020248, 0.000914811156690121],
    [118.39871418403, 24.7160595532897, 0.000914872623980045],
  ],
  [
    [118.399275483057, 24.7155505800287, 0.000914808362722397],
    [118.398700609163, 24.7160464222178, 0.000914870761334896],
  ],
  [
    [118.399261908186, 24.7155374490067, 0.000914805568754673],
    [118.398687044185, 24.7160333001693, 0.000914868898689747],
  ],
  [
    [118.399248343202, 24.7155243179802, 0.000914805568754673],
    [118.398673469324, 24.7160201690949, 0.000914867036044598],
  ],
  [
    [118.39923476834, 24.7155111959836, 0.000914802774786949],
    [118.398659894466, 24.7160070380193, 0.000914866104722023],
  ],
  [
    [118.399221193478, 24.7154980649578, 0.000914802774786949],
    [118.398646329497, 24.715993915967, 0.000914864242076874],
  ],
  [
    [118.399207628502, 24.7154849339276, 0.000914799980819225],
    [118.398632754644, 24.7159807848888, 0.000914862379431725],
  ],
  [
    [118.39919405365, 24.7154718119272, 0.000914799049496651],
    [118.398619189681, 24.715967662834, 0.000914860516786575],
  ],
  [
    [118.399180488679, 24.7154586808945, 0.000914797186851501],
    [118.398605614834, 24.7159545317534, 0.000914858654141426],
  ],
  [
    [118.399166913829, 24.7154455498637, 0.000914795324206352],
    [118.398592039989, 24.7159414006715, 0.000914857722818851],
  ],
  [
    [118.399153338985, 24.7154324278595, 0.000914793461561203],
    [118.398578475035, 24.7159282786129, 0.000914854928851128],
  ],
  [
    [118.399139774023, 24.715419296823, 0.000914791598916054],
    [118.398564900196, 24.7159151475285, 0.000914853066205978],
  ],
  [
    [118.399126199181, 24.7154061657885, 0.000914789736270905],
    [118.398551335244, 24.7159020164396, 0.000914851203560829],
  ],
  [
    [118.399112634228, 24.7153930437773, 0.00091478880494833],
    [118.398537760414, 24.7158888943805, 0.00091484934091568],
  ],
  [
    [118.399099059392, 24.7153799127403, 0.000914786942303181],
    [118.398524185584, 24.7158757632923, 0.00091484934091568],
  ],
  [
    [118.399085484562, 24.7153667907298, 0.000914784148335457],
    [118.39851062064, 24.7158626321997, 0.000914846546947956],
  ],
  [
    [118.399071919615, 24.7153536596871, 0.000914783217012882],
    [118.398497045819, 24.7158495101368, 0.000914846546947956],
  ],
  [
    [118.399058344787, 24.7153405286463, 0.000914782285690308],
    [118.398483480881, 24.7158363790417, 0.000914845615625381],
  ],
  [
    [118.399044779849, 24.7153274066288, 0.000914780423045158],
    [118.398469906066, 24.7158232569763, 0.000914842821657658],
  ],
  [
    [118.399031205026, 24.7153142755855, 0.000914779491722584],
    [118.39845633125, 24.7158101258818, 0.000914840959012508],
  ],
  [
    [118.399017630207, 24.7153011445409, 0.000914778560400009],
    [118.398442766321, 24.7157969947829, 0.000914839096367359],
  ],
  [
    [118.399004065277, 24.7152880225197, 0.000914774835109711],
    [118.398429191514, 24.7157838727137, 0.000914838165044785],
  ],
  [
    [118.398990490464, 24.7152748914727, 0.000914773903787136],
    [118.39841562659, 24.7157707416123, 0.000914835371077061],
  ],
  [
    [118.398976925536, 24.7152617604211, 0.000914772972464561],
    [118.398402051786, 24.7157576105128, 0.000914835371077061],
  ],
  [
    [118.398963350732, 24.7152486383993, 0.000914770178496838],
    [118.398388476988, 24.7157444884399, 0.000914832577109337],
  ],
  [
    [118.398949775927, 24.7152355073485, 0.000914767384529114],
    [118.398374912072, 24.7157313573347, 0.000914830714464188],
  ],
  [
    [118.398936211011, 24.715222385321, 0.000914765521883965],
    [118.398361337276, 24.7157182262315, 0.000914829783141613],
  ],
  [
    [118.398922636212, 24.7152092542677, 0.00091476459056139],
    [118.39834777237, 24.7157051041516, 0.000914827920496464],
  ],
  [
    [118.398909071299, 24.7151961232098, 0.00091476459056139],
    [118.39833419758, 24.7156919730458, 0.000914826989173889],
  ],
  [
    [118.398895496509, 24.7151830011818, 0.000914762727916241],
    [118.398320622792, 24.7156788419388, 0.00091482512652874],
  ],
  [
    [118.398881921718, 24.7151698701247, 0.000914759933948517],
    [118.398307057895, 24.7156657198552, 0.000914821401238441],
  ],
  [
    [118.398868356813, 24.7151567390631, 0.000914758071303368],
    [118.398293483113, 24.7156525887456, 0.000914820469915867],
  ],
  [
    [118.398854782032, 24.7151436170313, 0.000914758071303368],
    [118.398279918221, 24.7156394666595, 0.000914819538593292],
  ],
  [
    [118.398841217132, 24.7151304859672, 0.000914755277335644],
    [118.398266343445, 24.7156263355475, 0.000914818607270718],
  ],
  [
    [118.398827642353, 24.715117354905, 0.000914755277335644],
    [118.398252768672, 24.7156132044342, 0.000914816744625568],
  ],
  [
    [118.39881406758, 24.7151042328695, 0.00091475248336792],
    [118.398239203789, 24.7156000823443, 0.000914813950657845],
  ],
  [
    [118.398800502689, 24.7150911018016, 0.000914750620722771],
    [118.398225629021, 24.7155869512284, 0.00091481301933527],
  ],
  [
    [118.398786927919, 24.7150779707357, 0.000914748758077621],
    [118.39821206414, 24.7155738201082, 0.000914810225367546],
  ],
  [
    [118.398773363037, 24.7150648486932, 0.000914746895432472],
    [118.398198489382, 24.7155606980177, 0.000914808362722397],
  ],
  [
    [118.398759788272, 24.7150517176248, 0.000914744101464748],
    [118.398184914623, 24.7155475668981, 0.000914808362722397],
  ],
  [
    [118.398746213513, 24.7150385955829, 0.000914744101464748],
    [118.39817134975, 24.7155344357741, 0.000914806500077248],
  ],
  [
    [118.398732648637, 24.7150254645088, 0.000914742238819599],
    [118.398157775, 24.7155213136799, 0.000914803706109524],
  ],
  [
    [118.39871907388, 24.7150123334366, 0.000914741307497025],
    [118.398144210133, 24.7155081825534, 0.000914803706109524],
  ],
  [
    [118.398705509013, 24.7149992113878, 0.000914739444851875],
    [118.398130635389, 24.7154950604566, 0.0009148009121418],
  ],
  [
    [118.398691934262, 24.7149860803131, 0.000914737582206726],
    [118.398117060645, 24.7154819293307, 0.000914799049496651],
  ],
  [
    [118.398678369397, 24.7149729492339, 0.000914736650884151],
    [118.398103495786, 24.7154687982005, 0.000914799049496651],
  ],
  [
    [118.398664794656, 24.7149598271846, 0.000914733856916428],
    [118.398089921051, 24.7154556760999, 0.000914796255528927],
  ],
  [
    [118.398651219913, 24.7149466961061, 0.000914732925593853],
    [118.398076356198, 24.7154425449672, 0.000914793461561203],
  ],
  [
    [118.398637655057, 24.7149335650232, 0.000914731994271278],
    [118.398062781465, 24.7154294138363, 0.000914794392883778],
  ],
  [
    [118.398624080324, 24.71492044297, 0.000914731062948704],
    [118.398049216621, 24.7154162917288, 0.000914791598916054],
  ],
  [
    [118.398610515473, 24.7149073118846, 0.000914727337658405],
    [118.398035641894, 24.7154031605954, 0.000914791598916054],
  ],
  [
    [118.398596940746, 24.714894189829, 0.000914726406335831],
    [118.398022067169, 24.7153900294608, 0.000914787873625755],
  ],
  [
    [118.398583366017, 24.7148810587442, 0.000914723612368107],
    [118.398008502334, 24.7153769073496, 0.000914786010980606],
  ],
  [
    [118.398569801175, 24.7148679276551, 0.000914723612368107],
    [118.397994927615, 24.7153637762124, 0.000914786010980606],
  ],
  [
    [118.398556226456, 24.7148548055956, 0.000914719887077808],
    [118.397981362782, 24.7153506450709, 0.000914783217012882],
  ],
  [
    [118.39854266162, 24.7148416745039, 0.000914720818400383],
    [118.397967788072, 24.715337522959, 0.000914780423045158],
  ],
  [
    [118.398529086903, 24.7148285434142, 0.000914717093110085],
    [118.397954213362, 24.7153243918181, 0.000914779491722584],
  ],
  [
    [118.398515512193, 24.714815421351, 0.00091471616178751],
    [118.397940648541, 24.7153112697006, 0.000914777629077435],
  ],
  [
    [118.398501947365, 24.7148022902555, 0.000914714299142361],
    [118.397927073836, 24.7152981385572, 0.00091477669775486],
  ],
  [
    [118.398488372657, 24.714789159162, 0.000914711505174637],
    [118.397913509017, 24.7152850074093, 0.000914774835109711],
  ],
  [
    [118.398474807838, 24.7147760370919, 0.000914711505174637],
    [118.397899934322, 24.7152718852912, 0.000914773903787136],
  ],
  [
    [118.398461233135, 24.7147629059958, 0.000914709642529488],
    [118.397886359626, 24.715258754144, 0.000914771109819412],
  ],
  [
    [118.398447658436, 24.7147497748986, 0.000914706848561764],
    [118.397872794815, 24.7152456229924, 0.000914769247174263],
  ],
  [
    [118.398434093625, 24.7147366528247, 0.000914706848561764],
    [118.397859220128, 24.7152325008706, 0.000914768315851688],
  ],
  [
    [118.398420518931, 24.7147235217249, 0.00091470405459404],
    [118.397845655324, 24.7152193697165, 0.000914765521883965],
  ],
  [
    [118.398406954127, 24.7147103996485, 0.000914702191948891],
    [118.397832080639, 24.7152062385643, 0.000914765521883965],
  ],
  [
    [118.398393379439, 24.7146972685461, 0.000914701260626316],
    [118.397818505961, 24.7151931164386, 0.000914762727916241],
  ],
  [
    [118.398379804753, 24.7146841374426, 0.000914699397981167],
    [118.397804941165, 24.7151799852807, 0.000914760865271091],
  ],
  [
    [118.398366239957, 24.7146710153624, 0.000914697535336018],
    [118.397791366489, 24.7151668541248, 0.000914760865271091],
  ],
  [
    [118.398352665278, 24.7146578842563, 0.000914695672690868],
    [118.397777801702, 24.7151537319922, 0.000914757139980793],
  ],
  [
    [118.398339100484, 24.7146447531458, 0.000914693810045719],
    [118.397764227031, 24.7151406008337, 0.000914756208658218],
  ],
  [
    [118.398325525813, 24.7146316310651, 0.000914692878723145],
    [118.397750652367, 24.7151274787018, 0.000914755277335644],
  ],
  [
    [118.398311951142, 24.7146184999552, 0.00091469194740057],
    [118.397737087585, 24.7151143475377, 0.000914753414690495],
  ],
  [
    [118.398298386357, 24.7146053688409, 0.000914690084755421],
    [118.397723512923, 24.7151012163754, 0.000914753414690495],
  ],
  [
    [118.398284811695, 24.7145922467564, 0.000914688222110271],
    [118.397709948151, 24.7150880942366, 0.000914749689400196],
  ],
  [
    [118.398271246915, 24.7145791156396, 0.000914686359465122],
    [118.397696373494, 24.7150749630718, 0.000914748758077621],
  ],
  [
    [118.398257672259, 24.7145659935526, 0.000914682634174824],
    [118.397682798841, 24.7150618319058, 0.000914746895432472],
  ],
  [
    [118.398244097602, 24.7145528624365, 0.000914682634174824],
    [118.397669234077, 24.7150487097632, 0.000914745032787323],
  ],
  [
    [118.398230532831, 24.7145397313159, 0.000914680771529675],
    [118.397655659429, 24.7150355785947, 0.000914744101464748],
  ],
  [
    [118.398216958183, 24.7145266092251, 0.000914678908884525],
    [118.397642094667, 24.7150224474218, 0.000914741307497025],
  ],
  [
    [118.398203393418, 24.7145134781021, 0.000914677977561951],
    [118.397628520029, 24.7150093252786, 0.000914738513529301],
  ],
  [
    [118.398189818772, 24.7145003469809, 0.000914677046239376],
    [118.397614945389, 24.7149961941063, 0.000914738513529301],
  ],
  [
    [118.398176244133, 24.7144872248864, 0.000914674252271652],
    [118.39760138064, 24.7149830719574, 0.000914737582206726],
  ],
  [
    [118.398162679376, 24.7144740937596, 0.000914674252271652],
    [118.397587806006, 24.7149699407826, 0.000914735719561577],
  ],
  [
    [118.398149104739, 24.7144609626347, 0.000914669595658779],
    [118.397574241259, 24.7149568096034, 0.000914734788239002],
  ],
  [
    [118.398135539992, 24.7144478405332, 0.000914668664336205],
    [118.397560666634, 24.7149436874539, 0.000914733856916428],
  ],
  [
    [118.39812196536, 24.7144347094058, 0.000914669595658779],
    [118.397547092009, 24.7149305562753, 0.000914730131626129],
  ],
  [
    [118.398108390732, 24.7144215782771, 0.000914665870368481],
    [118.39753352727, 24.7149174250924, 0.000914729200303555],
  ],
  [
    [118.398094825993, 24.7144084561718, 0.000914664007723331],
    [118.397519952654, 24.7149043029391, 0.000914727337658405],
  ],
  [
    [118.39808125137, 24.7143953250406, 0.000914664007723331],
    [118.397506387921, 24.7148911717537, 0.000914725475013256],
  ],
  [
    [118.398067686637, 24.7143822029329, 0.000914662145078182],
    [118.397492813307, 24.7148780405701, 0.000914722681045532],
  ],
  [
    [118.398054112019, 24.7143690717992, 0.000914660282433033],
    [118.3974792387, 24.714864918413, 0.000914720818400383],
  ],
  [
    [118.398040537405, 24.7143559406642, 0.000914659351110458],
    [118.397465673975, 24.7148517872238, 0.000914720818400383],
  ],
  [
    [118.39802697268, 24.7143428185527, 0.000914656557142735],
    [118.39745209937, 24.7148386560365, 0.000914718024432659],
  ],
  [
    [118.398013398072, 24.7143296874153, 0.00091465562582016],
    [118.397438534655, 24.7148255338726, 0.000914718955755234],
  ],
  [
    [118.397999833349, 24.7143165562734, 0.000914653763175011],
    [118.397424960055, 24.7148124026827, 0.00091471616178751],
  ],
  [
    [118.39798625875, 24.7143034341612, 0.000914651900529861],
    [118.397411385462, 24.7147992805194, 0.000914712436497211],
  ],
  [
    [118.39797268415, 24.71429030302, 0.000914650037884712],
    [118.397397820752, 24.7147861493239, 0.000914713367819786],
  ],
  [
    [118.397959119436, 24.7142771718744, 0.000914648175239563],
    [118.397384246161, 24.7147730181303, 0.000914708711206913],
  ],
  [
    [118.397945544845, 24.7142640497585, 0.000914646312594414],
    [118.397370681459, 24.7147598959601, 0.000914708711206913],
  ],
  [
    [118.397931980137, 24.7142509186103, 0.000914646312594414],
    [118.397357106874, 24.7147467647639, 0.000914707779884338],
  ],
  [
    [118.397918405551, 24.7142377964919, 0.00091464351862669],
    [118.397343532292, 24.7147336335665, 0.000914703123271465],
  ],
  [
    [118.397904840849, 24.7142246653413, 0.000914642587304115],
    [118.397329967599, 24.7147205113926, 0.00091470405459404],
  ],
  [
    [118.397891266266, 24.7142115341925, 0.000914640724658966],
    [118.397316393023, 24.7147073801927, 0.000914701260626316],
  ],
  [
    [118.397877691689, 24.7141984120703, 0.000914639793336391],
    [118.397302828332, 24.7146942489884, 0.000914701260626316],
  ],
  [
    [118.397864126995, 24.7141852809159, 0.000914637930691242],
    [118.397289253765, 24.7146811268138, 0.000914699397981167],
  ],
  [
    [118.397850552421, 24.7141721497634, 0.000914636068046093],
    [118.39727568908, 24.714667995607, 0.000914696604013443],
  ],
  [
    [118.397836987736, 24.7141590276343, 0.000914634205400944],
    [118.397262114518, 24.7146548734299, 0.000914697535336018],
  ],
  [
    [118.397823413167, 24.7141458964793, 0.00091463141143322],
    [118.397248539955, 24.7146417422237, 0.000914694741368294],
  ],
  [
    [118.397809838601, 24.714132765323, 0.000914630480110645],
    [118.397234975279, 24.7146286110132, 0.000914691016077995],
  ],
  [
    [118.397796273925, 24.7141196431902, 0.000914628617465496],
    [118.397221400726, 24.7146154888323, 0.000914690084755421],
  ],
  [
    [118.397782699364, 24.7141065120314, 0.000914627686142921],
    [118.397207836055, 24.7146023576193, 0.000914689153432846],
  ],
  [
    [118.39776913469, 24.7140933808682, 0.000914625823497772],
    [118.397194261504, 24.7145892264081, 0.000914687290787697],
  ],
  [
    [118.397755560139, 24.7140802587347, 0.000914623960852623],
    [118.397180686959, 24.7145761042234, 0.000914684496819973],
  ],
  [
    [118.397741985588, 24.7140671275721, 0.000914622098207474],
    [118.397167122297, 24.7145629730066, 0.000914683565497398],
  ],
  [
    [118.397728420925, 24.714054005433, 0.000914621166884899],
    [118.397153547755, 24.7145498417916, 0.000914682634174824],
  ],
  [
    [118.39771484638, 24.7140408742679, 0.000914620235562325],
    [118.397139983102, 24.7145367196001, 0.0009146798402071],
  ],
  [
    [118.39770128172, 24.7140277430985, 0.000914615578949451],
    [118.397126408565, 24.7145235883826, 0.000914678908884525],
  ],
  [
    [118.397687707183, 24.7140146209587, 0.000914615578949451],
    [118.397112834031, 24.7145104571639, 0.000914677046239376],
  ],
  [
    [118.397674132645, 24.7140014897899, 0.000914612784981728],
    [118.397099269387, 24.7144973349686, 0.000914676114916801],
  ],
  [
    [118.397660567994, 24.7139883586167, 0.000914612784981728],
    [118.397085694859, 24.7144842037474, 0.000914674252271652],
  ],
  [
    [118.397646993466, 24.7139752364732, 0.000914610922336578],
    [118.39707213022, 24.7144710815496, 0.000914671458303928],
  ],
  [
    [118.39763342882, 24.7139621052974, 0.000914609059691429],
    [118.397058555697, 24.7144579503259, 0.000914671458303928],
  ],
  [
    [118.397619854294, 24.7139489741236, 0.000914609059691429],
    [118.397044981178, 24.7144448191009, 0.00091466773301363],
  ],
  [
    [118.397606279774, 24.7139358519763, 0.000914605334401131],
    [118.397031416547, 24.7144316968993, 0.000914669595658779],
  ],
  [
    [118.397592715137, 24.7139227207968, 0.000914605334401131],
    [118.397017842033, 24.7144185656718, 0.000914665870368481],
  ],
  [
    [118.39757914062, 24.7139095896192, 0.000914603471755981],
    [118.397004277406, 24.7144054344399, 0.000914666801691055],
  ],
  [
    [118.397565575992, 24.713896467465, 0.000914599746465683],
    [118.396990702901, 24.7143923122377, 0.000914663076400757],
  ],
  [
    [118.39755200148, 24.7138833362848, 0.000914599746465683],
    [118.396977128395, 24.7143791810064, 0.000914661213755608],
  ],
  [
    [118.397538426974, 24.7138702141313, 0.000914596952497959],
    [118.396963563776, 24.7143660497708, 0.000914658419787884],
  ],
  [
    [118.397524862351, 24.7138570829455, 0.000914596952497959],
    [118.396949989279, 24.7143529275648, 0.000914658419787884],
  ],
  [
    [118.397511287848, 24.7138439517616, 0.000914594158530235],
    [118.396936424666, 24.7143397963267, 0.000914656557142735],
  ],
  [
    [118.397497723234, 24.7138308296012, 0.000914591364562511],
    [118.396922850175, 24.7143266741182, 0.000914653763175011],
  ],
  [
    [118.397484148737, 24.7138176984148, 0.000914591364562511],
    [118.396909275684, 24.7143135428806, 0.000914653763175011],
  ],
  [
    [118.397470574242, 24.7138045672271, 0.000914588570594788],
    [118.396895711079, 24.7143004116387, 0.000914650969207287],
  ],
  [
    [118.397457009637, 24.7137914450629, 0.000914587639272213],
    [118.396882136597, 24.7142872894265, 0.000914648175239563],
  ],
  [
    [118.397443435148, 24.7137783138727, 0.000914586707949638],
    [118.396868571997, 24.7142741581821, 0.000914648175239563],
  ],
  [
    [118.397429870545, 24.7137651826782, 0.000914584845304489],
    [118.396854997517, 24.7142610269395, 0.000914646312594414],
  ],
  [
    [118.397416296065, 24.7137520605133, 0.000914581120014191],
    [118.396841423044, 24.7142479047235, 0.000914645381271839],
  ],
  [
    [118.397402721584, 24.7137389293194, 0.000914580188691616],
    [118.396827858453, 24.7142347734753, 0.000914642587304115],
  ],
  [
    [118.397389156993, 24.7137258071489, 0.000914578326046467],
    [118.396814283982, 24.7142216422289, 0.000914641655981541],
  ],
  [
    [118.397375582519, 24.7137126759524, 0.000914577394723892],
    [118.3968007194, 24.7142085200061, 0.000914638862013817],
  ],
  [
    [118.39736201793, 24.7136995447516, 0.000914576463401318],
    [118.396787144934, 24.7141953887572, 0.000914639793336391],
  ],
  [
    [118.397348443464, 24.7136864225805, 0.000914572738111019],
    [118.396773570471, 24.7141822575071, 0.000914635136723518],
  ],
  [
    [118.397334868998, 24.7136732913803, 0.000914572738111019],
    [118.396760005898, 24.7141691352805, 0.000914633274078369],
  ],
  [
    [118.397321304418, 24.7136601601757, 0.00091457087546587],
    [118.396746431441, 24.7141560040279, 0.000914634205400944],
  ],
  [
    [118.397307729961, 24.7136470380008, 0.000914569012820721],
    [118.396732866873, 24.7141428817987, 0.00091463141143322],
  ],
  [
    [118.397294165386, 24.7136339067937, 0.000914568081498146],
    [118.396719292422, 24.7141297505436, 0.000914630480110645],
  ],
  [
    [118.397280590931, 24.7136207755885, 0.000914565287530422],
    [118.396705717974, 24.7141166192872, 0.000914627686142921],
  ],
  [
    [118.397267016483, 24.7136076534098, 0.000914565287530422],
    [118.396692153415, 24.7141034970543, 0.000914626754820347],
  ],
  [
    [118.397253451917, 24.713594522199, 0.000914563424885273],
    [118.396678578972, 24.7140903657954, 0.000914623029530048],
  ],
  [
    [118.39723987747, 24.71358139099, 0.000914560630917549],
    [118.396665014415, 24.7140772345322, 0.000914623029530048],
  ],
  [
    [118.397226312913, 24.7135682688044, 0.000914557836949825],
    [118.396651439981, 24.7140641122986, 0.000914622098207474],
  ],
  [
    [118.397212738473, 24.7135551375929, 0.000914557836949825],
    [118.396637865547, 24.714050981036, 0.000914617441594601],
  ],
  [
    [118.397199164038, 24.713542015408, 0.000914556905627251],
    [118.396624300999, 24.714037849769, 0.000914617441594601],
  ],
  [
    [118.397185599487, 24.7135288841909, 0.000914555042982101],
    [118.396610726574, 24.7140247275316, 0.000914617441594601],
  ],
  [
    [118.397172025055, 24.7135157529756, 0.000914554111659527],
    [118.396597162031, 24.7140115962621, 0.000914614647626877],
  ],
  [
    [118.397158460512, 24.7135026307838, 0.000914551317691803],
    [118.396583587612, 24.7139984740223, 0.000914613716304302],
  ],
  [
    [118.397144886086, 24.713489499566, 0.000914550386369228],
    [118.396570013192, 24.7139853427533, 0.000914611853659153],
  ],
  [
    [118.397131321545, 24.7134763683439, 0.000914547592401505],
    [118.396556448658, 24.7139722114801, 0.000914609991014004],
  ],
  [
    [118.397117747128, 24.7134632461514, 0.00091454666107893],
    [118.396542874247, 24.7139590892365, 0.000914605334401131],
  ],
  [
    [118.39710417271, 24.7134501149299, 0.000914544798433781],
    [118.396529309718, 24.7139459579607, 0.000914606265723705],
  ],
  [
    [118.397090608178, 24.713436983704, 0.000914542935788631],
    [118.39651573531, 24.7139328266867, 0.00091460719704628],
  ],
  [
    [118.39707703377, 24.7134238615077, 0.000914542004466057],
    [118.39650217079, 24.7139197044363, 0.000914602540433407],
  ],
  [
    [118.397063469243, 24.7134107302793, 0.000914541073143482],
    [118.396488596387, 24.7139065731598, 0.000914602540433407],
  ],
  [
    [118.39704989484, 24.7133976080806, 0.000914537347853184],
    [118.396475021987, 24.7138934418821, 0.000914599746465683],
  ],
  [
    [118.397036320437, 24.7133844768527, 0.000914537347853184],
    [118.396461457477, 24.7138803196279, 0.000914599746465683],
  ],
  [
    [118.397022755919, 24.7133713456206, 0.000914535485208035],
    [118.396447883082, 24.7138671883476, 0.000914596021175385],
  ],
  [
    [118.397009181525, 24.7133582234181, 0.000914533622562885],
    [118.396434318574, 24.7138540570631, 0.00091459508985281],
  ],
  [
    [118.396995617013, 24.7133450921834, 0.000914530828595161],
    [118.396420744189, 24.7138409348082, 0.000914593227207661],
  ],
  [
    [118.396982042621, 24.7133319609505, 0.000914530828595161],
    [118.396407169803, 24.7138278035242, 0.000914590433239937],
  ],
  [
    [118.396968468235, 24.7133188387443, 0.000914528034627438],
    [118.396393605306, 24.7138146812637, 0.000914590433239937],
  ],
  [
    [118.396954903731, 24.7133057075058, 0.000914526171982288],
    [118.396380030926, 24.7138015499772, 0.000914587639272213],
  ],
  [
    [118.396941329348, 24.7132925762692, 0.000914524309337139],
    [118.396366466432, 24.7137884186864, 0.000914587639272213],
  ],
  [
    [118.396927764853, 24.7132794540561, 0.00091452244669199],
    [118.396352892061, 24.7137752964252, 0.000914584845304489],
  ],
  [
    [118.396914190475, 24.713266322817, 0.000914521515369415],
    [118.396339317689, 24.7137621651349, 0.00091458298265934],
  ],
  [
    [118.3969006161, 24.7132531915766, 0.000914520584046841],
    [118.396325753204, 24.7137490338403, 0.000914581120014191],
  ],
  [
    [118.396887051614, 24.7132400693597, 0.000914517790079117],
    [118.396312178841, 24.7137359115753, 0.000914580188691616],
  ],
  [
    [118.396873477245, 24.7132269381168, 0.000914517790079117],
    [118.396298614361, 24.7137227802783, 0.000914579257369041],
  ],
  [
    [118.396859912765, 24.7132138158974, 0.000914515927433968],
    [118.396285040001, 24.713709648983, 0.000914575532078743],
  ],
  [
    [118.396846338401, 24.713200684652, 0.000914513133466244],
    [118.396271465647, 24.7136965267142, 0.000914576463401318],
  ],
  [
    [118.39683276404, 24.7131875534054, 0.000914513133466244],
    [118.396257901175, 24.7136833954134, 0.000914575532078743],
  ],
  [
    [118.396819199569, 24.7131744311822, 0.000914509408175945],
    [118.396244326824, 24.7136702641143, 0.000914571806788445],
  ],
  [
    [118.396805625214, 24.7131612999331, 0.000914508476853371],
    [118.396230762361, 24.7136571418388, 0.000914571806788445],
  ],
  [
    [118.396792060744, 24.7131481686796, 0.000914509408175945],
    [118.396217188015, 24.7136440105372, 0.000914569944143295],
  ],
  [
    [118.396778486398, 24.7131350464557, 0.000914504751563072],
    [118.396203613676, 24.7136308882622, 0.000914569012820721],
  ],
  [
    [118.396764912052, 24.7131219152028, 0.000914503820240498],
    [118.396190049218, 24.7136177569551, 0.000914565287530422],
  ],
  [
    [118.396751347591, 24.7131087839455, 0.000914501957595348],
    [118.396176474881, 24.7136046256498, 0.000914563424885273],
  ],
  [
    [118.396737773253, 24.7130956617179, 0.000914501957595348],
    [118.396162910433, 24.713591503368, 0.000914563424885273],
  ],
  [
    [118.396724208798, 24.7130825304582, 0.000914500094950199],
    [118.396149336101, 24.7135783720601, 0.000914560630917549],
  ],
  [
    [118.396710634466, 24.7130694082281, 0.000914496369659901],
    [118.396135761772, 24.713565240751, 0.0009145587682724],
  ],
  [
    [118.396697060134, 24.7130562769689, 0.000914495438337326],
    [118.396122197333, 24.7135521184655, 0.0009145587682724],
  ],
  [
    [118.396683495688, 24.7130431457053, 0.000914493575692177],
    [118.396108623009, 24.7135389871539, 0.000914555974304676],
  ],
  [
    [118.396669921364, 24.7130300234714, 0.000914493575692177],
    [118.396095058572, 24.713525855838, 0.000914554111659527],
  ],
  [
    [118.396656356923, 24.7130168922054, 0.000914489850401878],
    [118.396081484258, 24.7135127335517, 0.000914553180336952],
  ],
  [
    [118.396642782602, 24.7130037609412, 0.000914488919079304],
    [118.396067909943, 24.7134996022363, 0.000914550386369228],
  ],
  [
    [118.396629208288, 24.7129906387036, 0.000914487056434155],
    [118.396054345518, 24.7134864799445, 0.000914548523724079],
  ],
  [
    [118.396615643855, 24.7129775074338, 0.00091448612511158],
    [118.396040771209, 24.7134733486266, 0.000914548523724079],
  ],
  [
    [118.396602069543, 24.7129643761658, 0.000914483331143856],
    [118.396027206786, 24.7134602173044, 0.000914547592401505],
  ],
  [
    [118.39658850512, 24.7129512539213, 0.000914480537176132],
    [118.396013632486, 24.7134470950119, 0.000914544798433781],
  ],
  [
    [118.396574930813, 24.7129381226508, 0.000914481468498707],
    [118.396000058186, 24.7134339636902, 0.000914542935788631],
  ],
  [
    [118.396561356509, 24.7129249913791, 0.000914480537176132],
    [118.395986493771, 24.7134208323643, 0.000914541073143482],
  ],
  [
    [118.396547792094, 24.7129118691308, 0.000914477743208408],
    [118.39597291948, 24.7134077100679, 0.000914540141820908],
  ],
  [
    [118.396534217796, 24.7128987378565, 0.000914475880563259],
    [118.395959355071, 24.7133945787395, 0.000914538279175758],
  ],
  [
    [118.396520653387, 24.7128856156058, 0.00091447401791811],
    [118.395945780782, 24.7133814474128, 0.000914536416530609],
  ],
  [
    [118.396507079095, 24.712872484329, 0.000914473086595535],
    [118.395932206499, 24.7133683251127, 0.000914533622562885],
  ],
  [
    [118.396493504805, 24.712859353051, 0.000914471223950386],
    [118.395918642099, 24.7133551937805, 0.000914532691240311],
  ],
  [
    [118.396479940405, 24.7128462307965, 0.000914469361305237],
    [118.395905067818, 24.7133420624501, 0.000914531759917736],
  ],
  [
    [118.396466366121, 24.712833099516, 0.000914467498660088],
    [118.395891503427, 24.7133289401432, 0.000914530828595161],
  ],
  [
    [118.396452801722, 24.7128199682311, 0.000914465636014938],
    [118.395877929152, 24.7133158088103, 0.000914527103304863],
  ],
  [
    [118.396439227447, 24.7128068459759, 0.000914464704692364],
    [118.395864354884, 24.7133026865039, 0.000914526171982288],
  ],
  [
    [118.396425653172, 24.7127937146916, 0.00091446191072464],
    [118.395850790498, 24.7132895551654, 0.000914525240659714],
  ],
  [
    [118.396412088782, 24.712780583403, 0.000914460048079491],
    [118.395837216231, 24.7132764238287, 0.00091452244669199],
  ],
  [
    [118.396398514516, 24.712767461144, 0.000914460048079491],
    [118.395823651854, 24.7132633015156, 0.000914520584046841],
  ],
  [
    [118.396384950132, 24.7127543298529, 0.000914455391466618],
    [118.395810077594, 24.7132501701764, 0.000914520584046841],
  ],
  [
    [118.396371375868, 24.7127411985636, 0.000914456322789192],
    [118.395796503336, 24.7132370388359, 0.000914517790079117],
  ],
  [
    [118.396357811493, 24.7127280762978, 0.000914453528821468],
    [118.395782938968, 24.713223916519, 0.000914514996111393],
  ],
  [
    [118.396344237235, 24.7127149450059, 0.000914452597498894],
    [118.395769364716, 24.713210785176, 0.000914514996111393],
  ],
  [
    [118.396330662983, 24.7127018227407, 0.000914451666176319],
    [118.39575580035, 24.7131976538287, 0.000914514064788818],
  ],
  [
    [118.396317098613, 24.7126886914433, 0.000914448872208595],
    [118.395742226107, 24.7131845315111, 0.000914511270821095],
  ],
  [
    [118.396303524363, 24.7126755601477, 0.000914447940886021],
    [118.395728661746, 24.7131714001613, 0.00091451033949852],
  ],
  [
    [118.396289960003, 24.7126624378756, 0.000914446078240871],
    [118.395715087509, 24.7131582778411, 0.000914507545530796],
  ],
  [
    [118.396276385759, 24.7126493065775, 0.000914443284273148],
    [118.395701513271, 24.7131451464919, 0.000914505682885647],
  ],
  [
    [118.396262811517, 24.7126361752782, 0.000914442352950573],
    [118.395687948919, 24.7131320151384, 0.000914504751563072],
  ],
  [
    [118.396249247165, 24.7126230530024, 0.000914440490305424],
    [118.39567437469, 24.7131188928144, 0.000914501957595348],
  ],
  [
    [118.39623567293, 24.7126099217005, 0.000914439558982849],
    [118.395660810344, 24.7131057614584, 0.000914501957595348],
  ],
  [
    [118.39622210858, 24.7125967903943, 0.0009144376963377],
    [118.395647236118, 24.7130926301041, 0.000914501026272774],
  ],
  [
    [118.396208534353, 24.7125836681178, 0.000914436765015125],
    [118.395633661898, 24.7130795077764, 0.00091449823230505],
  ],
  [
    [118.396194960126, 24.7125705368122, 0.000914434902369976],
    [118.39562009756, 24.7130663764166, 0.000914495438337326],
  ],
  [
    [118.396181395788, 24.7125574145301, 0.000914433039724827],
    [118.395606523342, 24.7130532450586, 0.000914494507014751],
  ],
  [
    [118.396167821567, 24.7125442832219, 0.000914431177079678],
    [118.395592959014, 24.7130401227241, 0.000914492644369602],
  ],
  [
    [118.396154257232, 24.7125311519095, 0.000914429314434528],
    [118.395579384801, 24.7130269913636, 0.000914492644369602],
  ],
  [
    [118.396140683019, 24.7125180296266, 0.000914427451789379],
    [118.395565810592, 24.7130138600018, 0.000914490781724453],
  ],
  [
    [118.396127108806, 24.7125048983147, 0.000914426520466805],
    [118.395552246272, 24.7130007376635, 0.000914488919079304],
  ],
  [
    [118.39611354448, 24.7124917669985, 0.000914424657821655],
    [118.395538672068, 24.7129876062992, 0.000914487056434155],
  ],
  [
    [118.396099970276, 24.712478644712, 0.000914422795176506],
    [118.395525107754, 24.7129744839585, 0.000914485193789005],
  ],
  [
    [118.396086405954, 24.7124655133932, 0.000914421863853931],
    [118.395511533556, 24.7129613525916, 0.000914483331143856],
  ],
  [
    [118.396072831753, 24.7124523820763, 0.000914420001208782],
    [118.395497959361, 24.7129482212236, 0.000914481468498707],
  ],
  [
    [118.396059257558, 24.712439259786, 0.000914418138563633],
    [118.395484395055, 24.7129350988791, 0.000914479605853558],
  ],
  [
    [118.396045693245, 24.7124261284635, 0.000914416275918484],
    [118.395470820866, 24.7129219675085, 0.000914477743208408],
  ],
  [
    [118.396032119052, 24.7124129971428, 0.000914414413273335],
    [118.395457256562, 24.7129088361336, 0.000914476811885834],
  ],
  [
    [118.396018554748, 24.7123998748457, 0.00091441348195076],
    [118.395443682382, 24.7128957137884, 0.000914476811885834],
  ],
  [
    [118.396004980561, 24.7123867435225, 0.000914411619305611],
    [118.395430108201, 24.712882582414, 0.000914473086595535],
  ],
  [
    [118.39599140638, 24.7123736212258, 0.000914409756660461],
    [118.395416543906, 24.7128694510354, 0.000914471223950386],
  ],
  [
    [118.395977842082, 24.7123604898971, 0.000914408825337887],
    [118.395402969734, 24.7128563286864, 0.000914470292627811],
  ],
  [
    [118.395964267903, 24.7123473585701, 0.000914406031370163],
    [118.395389405445, 24.7128431973053, 0.000914468429982662],
  ],
  [
    [118.395950703614, 24.7123342362667, 0.000914404168725014],
    [118.395375831279, 24.7128300749537, 0.000914466567337513],
  ],
  [
    [118.395937129441, 24.7123211049372, 0.000914403237402439],
    [118.395362257112, 24.7128169435731, 0.000914465636014938],
  ],
  [
    [118.395923555271, 24.7123079736065, 0.00091440137475729],
    [118.395348692831, 24.7128038121882, 0.000914463773369789],
  ],
  [
    [118.39590999099, 24.7122948512993, 0.000914400443434715],
    [118.395335118674, 24.7127906898329, 0.00091446191072464],
  ],
  [
    [118.395896416825, 24.7122817199661, 0.000914396718144417],
    [118.395321554399, 24.7127775584456, 0.000914460048079491],
  ],
  [
    [118.395882852547, 24.7122685886286, 0.000914395786821842],
    [118.395307980244, 24.7127644270599, 0.000914458185434341],
  ],
  [
    [118.395869278391, 24.7122554663207, 0.000914395786821842],
    [118.395294406095, 24.7127513047008, 0.000914457254111767],
  ],
  [
    [118.395855704235, 24.7122423349836, 0.000914393924176693],
    [118.395280841828, 24.7127381733097, 0.000914455391466618],
  ],
  [
    [118.395842139969, 24.7122292126702, 0.000914392061531544],
    [118.395267267681, 24.7127250419203, 0.000914455391466618],
  ],
  [
    [118.395828565819, 24.7122160813307, 0.000914390198886395],
    [118.395253703424, 24.7127119195545, 0.000914451666176319],
  ],
  [
    [118.395815001554, 24.7122029499869, 0.000914388336241245],
    [118.395240129283, 24.7126987881625, 0.00091444980353117],
  ],
  [
    [118.395801427413, 24.7121898276727, 0.000914387404918671],
    [118.395226555145, 24.7126856567694, 0.000914448872208595],
  ],
  [
    [118.395787853271, 24.7121766963294, 0.000914384610950947],
    [118.395212990896, 24.7126725343998, 0.000914447009563446],
  ],
  [
    [118.395774289016, 24.7121635649819, 0.000914383679628372],
    [118.395199416763, 24.7126594030041, 0.000914447009563446],
  ],
  [
    [118.395760714883, 24.7121504426639, 0.000914382748305798],
    [118.39518585252, 24.712646280632, 0.000914444215595722],
  ],
  [
    [118.395747150633, 24.7121373113139, 0.000914379954338074],
    [118.395172278393, 24.7126331492338, 0.000914443284273148],
  ],
  [
    [118.395733576503, 24.7121241799656, 0.000914379023015499],
    [118.395158704269, 24.7126200178344, 0.000914439558982849],
  ],
  [
    [118.395720002379, 24.7121110576438, 0.00091437716037035],
    [118.395145140035, 24.7126068954585, 0.000914438627660275],
  ],
  [
    [118.395706438137, 24.71209792629, 0.000914375297725201],
    [118.395131565916, 24.7125937640566, 0.0009144376963377],
  ],
  [
    [118.395692864015, 24.712084794938, 0.000914374366402626],
    [118.395118001684, 24.7125806326504, 0.000914435833692551],
  ],
  [
    [118.395679299783, 24.7120716726095, 0.000914373435080051],
    [118.395104427575, 24.7125675102737, 0.000914433039724827],
  ],
  [
    [118.395665725667, 24.7120585412549, 0.000914369709789753],
    [118.395090853465, 24.712554378868, 0.000914433039724827],
  ],
  [
    [118.395652151557, 24.7120454189269, 0.000914369709789753],
    [118.395077289241, 24.7125412474581, 0.000914430245757103],
  ],
  [
    [118.395638587329, 24.7120322875668, 0.000914365984499455],
    [118.395063715141, 24.7125281250776, 0.000914429314434528],
  ],
  [
    [118.395625013222, 24.7120191562085, 0.00091436505317688],
    [118.395050150923, 24.7125149936652, 0.000914429314434528],
  ],
  [
    [118.395611449004, 24.7120060338737, 0.000914363190531731],
    [118.395036576824, 24.7125018622544, 0.000914426520466805],
  ],
  [
    [118.395597874902, 24.7119929025129, 0.000914361327886581],
    [118.395023002732, 24.7124887398703, 0.000914423726499081],
  ],
  [
    [118.395584310686, 24.7119797711478, 0.000914360396564007],
    [118.395009438523, 24.7124756084541, 0.000914422795176506],
  ],
  [
    [118.395570736593, 24.7119666488122, 0.000914358533918858],
    [118.394995864436, 24.7124624860674, 0.000914421863853931],
  ],
  [
    [118.3955571625, 24.7119535174476, 0.000914357602596283],
    [118.394982300232, 24.7124493546487, 0.000914418138563633],
  ],
  [
    [118.395543598292, 24.7119403860788, 0.000914354808628559],
    [118.394968726148, 24.7124362232316, 0.000914417207241058],
  ],
  [
    [118.395530024208, 24.7119272637395, 0.00091435294598341],
    [118.39495515207, 24.7124231008412, 0.000914416275918484],
  ],
  [
    [118.395516460006, 24.7119141323681, 0.000914352014660835],
    [118.394941587875, 24.7124099694187, 0.00091441348195076],
  ],
  [
    [118.395502885928, 24.7119010100263, 0.000914351083338261],
    [118.3949280138, 24.7123968379979, 0.000914412550628185],
  ],
  [
    [118.395489311849, 24.7118878786554, 0.000914349220693111],
    [118.394914449613, 24.7123837156008, 0.000914410687983036],
  ],
  [
    [118.395475747656, 24.7118747472803, 0.000914346426725388],
    [118.394900875543, 24.7123705841775, 0.000914409756660461],
  ],
  [
    [118.395462173586, 24.7118616249347, 0.000914346426725388],
    [118.394887311359, 24.71235745275, 0.000914408825337887],
  ],
  [
    [118.395448609398, 24.7118484935571, 0.000914344564080238],
    [118.394873737299, 24.712344330352, 0.000914406031370163],
  ],
  [
    [118.395435035331, 24.7118353621812, 0.000914342701435089],
    [118.394860163237, 24.7123311989249, 0.000914405100047588],
  ],
  [
    [118.395421461269, 24.7118222398318, 0.000914338976144791],
    [118.394846599065, 24.7123180765215, 0.000914403237402439],
  ],
  [
    [118.39540789709, 24.7118091084504, 0.000914338044822216],
    [118.39483302501, 24.7123049450919, 0.000914400443434715],
  ],
  [
    [118.395394323031, 24.7117959770708, 0.000914336182177067],
    [118.39481946084, 24.7122918136582, 0.000914400443434715],
  ],
  [
    [118.395380758861, 24.7117828547147, 0.000914336182177067],
    [118.394805886793, 24.7122786912539, 0.000914398580789566],
  ],
  [
    [118.395367184808, 24.7117697233325, 0.000914333388209343],
    [118.394792312746, 24.7122655598206, 0.000914395786821842],
  ],
  [
    [118.395353610757, 24.7117565919491, 0.000914332456886768],
    [118.394778748585, 24.7122524283831, 0.000914394855499268],
  ],
  [
    [118.395340046596, 24.7117434695892, 0.000914331525564194],
    [118.394765174547, 24.712239305975, 0.000914392992854118],
  ],
  [
    [118.395326472551, 24.7117303382033, 0.000914329662919044],
    [118.394751610391, 24.712226174535, 0.000914392061531544],
  ],
  [
    [118.395312908395, 24.7117172158409, 0.000914327800273895],
    [118.394738036356, 24.7122130430967, 0.000914390198886395],
  ],
  [
    [118.395299334356, 24.7117040844525, 0.000914325006306171],
    [118.394724462326, 24.7121999206849, 0.00091438926756382],
  ],
  [
    [118.39528576032, 24.7116909530628, 0.000914322212338448],
    [118.394710898179, 24.7121867892411, 0.000914385542273521],
  ],
  [
    [118.395272196172, 24.7116778306967, 0.000914321281015873],
    [118.394697324152, 24.712173657799, 0.000914384610950947],
  ],
  [
    [118.395258622142, 24.7116646993045, 0.000914321281015873],
    [118.394683760014, 24.7121605353805, 0.000914383679628372],
  ],
  [
    [118.395245057997, 24.711651567908, 0.000914319418370724],
    [118.394670185993, 24.7121474039359, 0.000914379954338074],
  ],
  [
    [118.395231483975, 24.7116384455411, 0.000914316624403],
    [118.394656611978, 24.7121342815178, 0.000914379954338074],
  ],
  [
    [118.395217909953, 24.7116253141451, 0.000914315693080425],
    [118.394643047845, 24.7121211500678, 0.000914379023015499],
  ],
  [
    [118.395204345817, 24.7116121827449, 0.000914313830435276],
    [118.394629473832, 24.7121080186194, 0.000914376229047775],
  ],
];
